/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.0.6.0 (NJsonSchema v10.0.23.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';
import * as moment from 'moment';
export var API_BASE_URL = new InjectionToken('API_BASE_URL');
var AccountServiceProxy = /** @class */ (function () {
    function AccountServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param body (optional)
     * @return Success
     */
    AccountServiceProxy.prototype.isTenantAvailable = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Account/IsTenantAvailable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processIsTenantAvailable(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processIsTenantAvailable(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AccountServiceProxy.prototype.processIsTenantAvailable = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = IsTenantAvailableOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    AccountServiceProxy.prototype.resolveTenantId = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Account/ResolveTenantId";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processResolveTenantId(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processResolveTenantId(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AccountServiceProxy.prototype.processResolveTenantId = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    AccountServiceProxy.prototype.register = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Account/Register";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processRegister(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processRegister(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AccountServiceProxy.prototype.processRegister = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = RegisterOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    AccountServiceProxy.prototype.sendPasswordResetCode = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Account/SendPasswordResetCode";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSendPasswordResetCode(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSendPasswordResetCode(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AccountServiceProxy.prototype.processSendPasswordResetCode = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    AccountServiceProxy.prototype.resetPassword = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Account/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processResetPassword(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processResetPassword(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AccountServiceProxy.prototype.processResetPassword = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = ResetPasswordOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    AccountServiceProxy.prototype.sendEmailActivationLink = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Account/SendEmailActivationLink";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSendEmailActivationLink(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSendEmailActivationLink(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AccountServiceProxy.prototype.processSendEmailActivationLink = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    AccountServiceProxy.prototype.activateEmail = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Account/ActivateEmail";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processActivateEmail(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processActivateEmail(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AccountServiceProxy.prototype.processActivateEmail = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    AccountServiceProxy.prototype.impersonate = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Account/Impersonate";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processImpersonate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processImpersonate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AccountServiceProxy.prototype.processImpersonate = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = ImpersonateOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    AccountServiceProxy.prototype.backToImpersonator = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Account/BackToImpersonator";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processBackToImpersonator(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processBackToImpersonator(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AccountServiceProxy.prototype.processBackToImpersonator = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = ImpersonateOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    AccountServiceProxy.prototype.switchToLinkedAccount = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Account/SwitchToLinkedAccount";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSwitchToLinkedAccount(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSwitchToLinkedAccount(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AccountServiceProxy.prototype.processSwitchToLinkedAccount = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = SwitchToLinkedAccountOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return AccountServiceProxy;
}());
export { AccountServiceProxy };
var AppConfigurationLookupServiceProxy = /** @class */ (function () {
    function AppConfigurationLookupServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param searchTerm (optional)
     * @return Success
     */
    AppConfigurationLookupServiceProxy.prototype.getDepotLocations = function (searchTerm) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/AppConfigurationLookup/GetDepotLocations?";
        if (searchTerm !== undefined)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDepotLocations(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDepotLocations(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AppConfigurationLookupServiceProxy.prototype.processGetDepotLocations = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_1 = resultData200; _i < resultData200_1.length; _i++) {
                        var item = resultData200_1[_i];
                        result200.push(NameValueOfString.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param searchTerm (optional)
     * @param resultCount (optional)
     * @return Success
     */
    AppConfigurationLookupServiceProxy.prototype.getManifestFiles = function (searchTerm, resultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/AppConfigurationLookup/GetManifestFiles?";
        if (searchTerm !== undefined)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (resultCount === null)
            throw new Error("The parameter 'resultCount' cannot be null.");
        else if (resultCount !== undefined)
            url_ += "resultCount=" + encodeURIComponent("" + resultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetManifestFiles(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetManifestFiles(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AppConfigurationLookupServiceProxy.prototype.processGetManifestFiles = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_2 = resultData200; _i < resultData200_2.length; _i++) {
                        var item = resultData200_2[_i];
                        result200.push(NameValueOfInt32.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param searchTerm (optional)
     * @return Success
     */
    AppConfigurationLookupServiceProxy.prototype.getBrands = function (searchTerm) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/AppConfigurationLookup/GetBrands?";
        if (searchTerm !== undefined)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetBrands(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetBrands(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AppConfigurationLookupServiceProxy.prototype.processGetBrands = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_3 = resultData200; _i < resultData200_3.length; _i++) {
                        var item = resultData200_3[_i];
                        result200.push(NameValueOfString.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param searchTerm (optional)
     * @param isClientVisible (optional)
     * @return Success
     */
    AppConfigurationLookupServiceProxy.prototype.getConsignmentStatuss = function (searchTerm, isClientVisible) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/AppConfigurationLookup/GetConsignmentStatuss?";
        if (searchTerm !== undefined)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (isClientVisible !== undefined)
            url_ += "isClientVisible=" + encodeURIComponent("" + isClientVisible) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetConsignmentStatuss(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetConsignmentStatuss(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AppConfigurationLookupServiceProxy.prototype.processGetConsignmentStatuss = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_4 = resultData200; _i < resultData200_4.length; _i++) {
                        var item = resultData200_4[_i];
                        result200.push(NameValueOfString.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param searchTerm (optional)
     * @return Success
     */
    AppConfigurationLookupServiceProxy.prototype.getManifestTemplates = function (searchTerm) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/AppConfigurationLookup/GetManifestTemplates?";
        if (searchTerm !== undefined)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetManifestTemplates(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetManifestTemplates(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AppConfigurationLookupServiceProxy.prototype.processGetManifestTemplates = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_5 = resultData200; _i < resultData200_5.length; _i++) {
                        var item = resultData200_5[_i];
                        result200.push(NameValueOfString.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param searchTerm (optional)
     * @param depotIds (optional)
     * @param isDriver (optional)
     * @param hasD365Entity (optional)
     * @return Success
     */
    AppConfigurationLookupServiceProxy.prototype.getCarriers = function (searchTerm, depotIds, isDriver, hasD365Entity) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/AppConfigurationLookup/GetCarriers?";
        if (searchTerm !== undefined)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (depotIds !== undefined)
            depotIds && depotIds.forEach(function (item) { url_ += "depotIds=" + encodeURIComponent("" + item) + "&"; });
        if (isDriver !== undefined)
            url_ += "isDriver=" + encodeURIComponent("" + isDriver) + "&";
        if (hasD365Entity !== undefined)
            url_ += "hasD365Entity=" + encodeURIComponent("" + hasD365Entity) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetCarriers(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetCarriers(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AppConfigurationLookupServiceProxy.prototype.processGetCarriers = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_6 = resultData200; _i < resultData200_6.length; _i++) {
                        var item = resultData200_6[_i];
                        result200.push(NameValueOfInt32.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param searchTerm (optional)
     * @param depotIds (optional)
     * @param isNexday (optional)
     * @param isDriver (optional)
     * @param hasD365Entity (optional)
     * @return Success
     */
    AppConfigurationLookupServiceProxy.prototype.getCarriersWithCodes = function (searchTerm, depotIds, isNexday, isDriver, hasD365Entity) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/AppConfigurationLookup/GetCarriersWithCodes?";
        if (searchTerm !== undefined)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (depotIds !== undefined)
            depotIds && depotIds.forEach(function (item) { url_ += "depotIds=" + encodeURIComponent("" + item) + "&"; });
        if (isNexday !== undefined)
            url_ += "isNexday=" + encodeURIComponent("" + isNexday) + "&";
        if (isDriver !== undefined)
            url_ += "isDriver=" + encodeURIComponent("" + isDriver) + "&";
        if (hasD365Entity !== undefined)
            url_ += "hasD365Entity=" + encodeURIComponent("" + hasD365Entity) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetCarriersWithCodes(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetCarriersWithCodes(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AppConfigurationLookupServiceProxy.prototype.processGetCarriersWithCodes = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_7 = resultData200; _i < resultData200_7.length; _i++) {
                        var item = resultData200_7[_i];
                        result200.push(NameValueOfString.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param searchTerm (optional)
     * @return Success
     */
    AppConfigurationLookupServiceProxy.prototype.getEventGroups = function (searchTerm) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/AppConfigurationLookup/GetEventGroups?";
        if (searchTerm !== undefined)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetEventGroups(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetEventGroups(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AppConfigurationLookupServiceProxy.prototype.processGetEventGroups = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_8 = resultData200; _i < resultData200_8.length; _i++) {
                        var item = resultData200_8[_i];
                        result200.push(NameValueOfInt32.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param searchTerm (optional)
     * @return Success
     */
    AppConfigurationLookupServiceProxy.prototype.getEventDetails = function (searchTerm) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/AppConfigurationLookup/GetEventDetails?";
        if (searchTerm !== undefined)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetEventDetails(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetEventDetails(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AppConfigurationLookupServiceProxy.prototype.processGetEventDetails = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_9 = resultData200; _i < resultData200_9.length; _i++) {
                        var item = resultData200_9[_i];
                        result200.push(NameValueOfString.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param searchTerm (optional)
     * @param exceptionType (optional)
     * @param courierCode (optional)
     * @return Success
     */
    AppConfigurationLookupServiceProxy.prototype.getEventDetailsByExceptionType = function (searchTerm, exceptionType, courierCode) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/AppConfigurationLookup/GetEventDetailsByExceptionType?";
        if (searchTerm !== undefined)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (exceptionType !== undefined)
            url_ += "exceptionType=" + encodeURIComponent("" + exceptionType) + "&";
        if (courierCode !== undefined)
            url_ += "courierCode=" + encodeURIComponent("" + courierCode) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetEventDetailsByExceptionType(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetEventDetailsByExceptionType(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AppConfigurationLookupServiceProxy.prototype.processGetEventDetailsByExceptionType = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_10 = resultData200; _i < resultData200_10.length; _i++) {
                        var item = resultData200_10[_i];
                        result200.push(NameValueOfString.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param searchTerm (optional)
     * @return Success
     */
    AppConfigurationLookupServiceProxy.prototype.getCouriers = function (searchTerm) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/AppConfigurationLookup/GetCouriers?";
        if (searchTerm !== undefined)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetCouriers(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetCouriers(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AppConfigurationLookupServiceProxy.prototype.processGetCouriers = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_11 = resultData200; _i < resultData200_11.length; _i++) {
                        var item = resultData200_11[_i];
                        result200.push(NameValueOfInt32.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param searchTerm (optional)
     * @return Success
     */
    AppConfigurationLookupServiceProxy.prototype.getTerritoryConfigurations = function (searchTerm) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/AppConfigurationLookup/GetTerritoryConfigurations?";
        if (searchTerm !== undefined)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetTerritoryConfigurations(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetTerritoryConfigurations(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AppConfigurationLookupServiceProxy.prototype.processGetTerritoryConfigurations = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_12 = resultData200; _i < resultData200_12.length; _i++) {
                        var item = resultData200_12[_i];
                        result200.push(NameValueOfInt32.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    AppConfigurationLookupServiceProxy.prototype.getManifestJobs = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/AppConfigurationLookup/GetManifestJobs";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetManifestJobs(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetManifestJobs(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AppConfigurationLookupServiceProxy.prototype.processGetManifestJobs = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_13 = resultData200; _i < resultData200_13.length; _i++) {
                        var item = resultData200_13[_i];
                        result200.push(NameValueOfString.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param searchTerm (optional)
     * @return Success
     */
    AppConfigurationLookupServiceProxy.prototype.getClientGroups = function (searchTerm) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/AppConfigurationLookup/GetClientGroups?";
        if (searchTerm !== undefined)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetClientGroups(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetClientGroups(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AppConfigurationLookupServiceProxy.prototype.processGetClientGroups = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_14 = resultData200; _i < resultData200_14.length; _i++) {
                        var item = resultData200_14[_i];
                        result200.push(NameValueOfClientGroupDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param searchTerm (optional)
     * @param hasD365Entity (optional)
     * @return Success
     */
    AppConfigurationLookupServiceProxy.prototype.getClients = function (searchTerm, hasD365Entity) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/AppConfigurationLookup/GetClients?";
        if (searchTerm !== undefined)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (hasD365Entity !== undefined)
            url_ += "hasD365Entity=" + encodeURIComponent("" + hasD365Entity) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetClients(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetClients(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AppConfigurationLookupServiceProxy.prototype.processGetClients = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_15 = resultData200; _i < resultData200_15.length; _i++) {
                        var item = resultData200_15[_i];
                        result200.push(NameValueOfInt32.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param searchTerm (optional)
     * @return Success
     */
    AppConfigurationLookupServiceProxy.prototype.getClientsWithCode = function (searchTerm) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/AppConfigurationLookup/GetClientsWithCode?";
        if (searchTerm !== undefined)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetClientsWithCode(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetClientsWithCode(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AppConfigurationLookupServiceProxy.prototype.processGetClientsWithCode = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_16 = resultData200; _i < resultData200_16.length; _i++) {
                        var item = resultData200_16[_i];
                        result200.push(NameValueOfString.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param searchTerm (optional)
     * @return Success
     */
    AppConfigurationLookupServiceProxy.prototype.getStoreWithId = function (searchTerm) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/AppConfigurationLookup/GetStoreWithId?";
        if (searchTerm !== undefined)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetStoreWithId(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetStoreWithId(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AppConfigurationLookupServiceProxy.prototype.processGetStoreWithId = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_17 = resultData200; _i < resultData200_17.length; _i++) {
                        var item = resultData200_17[_i];
                        result200.push(NameValueOfString.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param storeId (optional)
     * @return Success
     */
    AppConfigurationLookupServiceProxy.prototype.getStoreLocationWithId = function (storeId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/AppConfigurationLookup/GetStoreLocationWithId?";
        if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetStoreLocationWithId(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetStoreLocationWithId(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AppConfigurationLookupServiceProxy.prototype.processGetStoreLocationWithId = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_18 = resultData200; _i < resultData200_18.length; _i++) {
                        var item = resultData200_18[_i];
                        result200.push(NameValueOfNullableOfInt64.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param searchTerm (optional)
     * @return Success
     */
    AppConfigurationLookupServiceProxy.prototype.getMiscCostChargeTypes = function (searchTerm) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/AppConfigurationLookup/GetMiscCostChargeTypes?";
        if (searchTerm !== undefined)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetMiscCostChargeTypes(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetMiscCostChargeTypes(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AppConfigurationLookupServiceProxy.prototype.processGetMiscCostChargeTypes = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_19 = resultData200; _i < resultData200_19.length; _i++) {
                        var item = resultData200_19[_i];
                        result200.push(NameValueOfInt32.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    AppConfigurationLookupServiceProxy.prototype.getAutoCompleteData = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/AppConfigurationLookup/GetAutoCompleteData";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAutoCompleteData(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAutoCompleteData(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AppConfigurationLookupServiceProxy.prototype.processGetAutoCompleteData = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetAllAutoCompleteData.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param filter (optional)
     * @param statusFilter (optional)
     * @param descriptionFilter (optional)
     * @param removeTransactionFilter (optional)
     * @param eventGroupDescriptionFilter (optional)
     * @param courierNameFilter (optional)
     * @param exceptionConsignmentStatusIdFilter (optional)
     * @param zendeskQueryTypeFilter (optional)
     * @param consignmentDashboardCategoryFilter (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    AppConfigurationLookupServiceProxy.prototype.getAll = function (filter, statusFilter, descriptionFilter, removeTransactionFilter, eventGroupDescriptionFilter, courierNameFilter, exceptionConsignmentStatusIdFilter, zendeskQueryTypeFilter, consignmentDashboardCategoryFilter, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/AppConfigurationLookup/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (removeTransactionFilter !== undefined)
            url_ += "RemoveTransactionFilter=" + encodeURIComponent("" + removeTransactionFilter) + "&";
        if (eventGroupDescriptionFilter !== undefined)
            url_ += "EventGroupDescriptionFilter=" + encodeURIComponent("" + eventGroupDescriptionFilter) + "&";
        if (courierNameFilter !== undefined)
            url_ += "CourierNameFilter=" + encodeURIComponent("" + courierNameFilter) + "&";
        if (exceptionConsignmentStatusIdFilter !== undefined)
            url_ += "ExceptionConsignmentStatusIdFilter=" + encodeURIComponent("" + exceptionConsignmentStatusIdFilter) + "&";
        if (zendeskQueryTypeFilter !== undefined)
            url_ += "ZendeskQueryTypeFilter=" + encodeURIComponent("" + zendeskQueryTypeFilter) + "&";
        if (consignmentDashboardCategoryFilter !== undefined)
            url_ += "ConsignmentDashboardCategoryFilter=" + encodeURIComponent("" + consignmentDashboardCategoryFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AppConfigurationLookupServiceProxy.prototype.processGetAll = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PagedResultDtoOfGetEventDetailForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return AppConfigurationLookupServiceProxy;
}());
export { AppConfigurationLookupServiceProxy };
var AuditLogServiceProxy = /** @class */ (function () {
    function AuditLogServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param startDate (optional)
     * @param endDate (optional)
     * @param userName (optional)
     * @param serviceName (optional)
     * @param methodName (optional)
     * @param browserInfo (optional)
     * @param hasException (optional)
     * @param minExecutionDuration (optional)
     * @param maxExecutionDuration (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    AuditLogServiceProxy.prototype.getAuditLogs = function (startDate, endDate, userName, serviceName, methodName, browserInfo, hasException, minExecutionDuration, maxExecutionDuration, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/AuditLog/GetAuditLogs?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (userName !== undefined)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
        if (serviceName !== undefined)
            url_ += "ServiceName=" + encodeURIComponent("" + serviceName) + "&";
        if (methodName !== undefined)
            url_ += "MethodName=" + encodeURIComponent("" + methodName) + "&";
        if (browserInfo !== undefined)
            url_ += "BrowserInfo=" + encodeURIComponent("" + browserInfo) + "&";
        if (hasException !== undefined)
            url_ += "HasException=" + encodeURIComponent("" + hasException) + "&";
        if (minExecutionDuration !== undefined)
            url_ += "MinExecutionDuration=" + encodeURIComponent("" + minExecutionDuration) + "&";
        if (maxExecutionDuration !== undefined)
            url_ += "MaxExecutionDuration=" + encodeURIComponent("" + maxExecutionDuration) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAuditLogs(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAuditLogs(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AuditLogServiceProxy.prototype.processGetAuditLogs = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PagedResultDtoOfAuditLogListDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param startDate (optional)
     * @param endDate (optional)
     * @param userName (optional)
     * @param serviceName (optional)
     * @param methodName (optional)
     * @param browserInfo (optional)
     * @param hasException (optional)
     * @param minExecutionDuration (optional)
     * @param maxExecutionDuration (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    AuditLogServiceProxy.prototype.getAuditLogsToExcel = function (startDate, endDate, userName, serviceName, methodName, browserInfo, hasException, minExecutionDuration, maxExecutionDuration, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/AuditLog/GetAuditLogsToExcel?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (userName !== undefined)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
        if (serviceName !== undefined)
            url_ += "ServiceName=" + encodeURIComponent("" + serviceName) + "&";
        if (methodName !== undefined)
            url_ += "MethodName=" + encodeURIComponent("" + methodName) + "&";
        if (browserInfo !== undefined)
            url_ += "BrowserInfo=" + encodeURIComponent("" + browserInfo) + "&";
        if (hasException !== undefined)
            url_ += "HasException=" + encodeURIComponent("" + hasException) + "&";
        if (minExecutionDuration !== undefined)
            url_ += "MinExecutionDuration=" + encodeURIComponent("" + minExecutionDuration) + "&";
        if (maxExecutionDuration !== undefined)
            url_ += "MaxExecutionDuration=" + encodeURIComponent("" + maxExecutionDuration) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAuditLogsToExcel(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAuditLogsToExcel(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AuditLogServiceProxy.prototype.processGetAuditLogsToExcel = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = FileDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    AuditLogServiceProxy.prototype.getEntityHistoryObjectTypes = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityHistoryObjectTypes";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetEntityHistoryObjectTypes(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetEntityHistoryObjectTypes(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AuditLogServiceProxy.prototype.processGetEntityHistoryObjectTypes = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_20 = resultData200; _i < resultData200_20.length; _i++) {
                        var item = resultData200_20[_i];
                        result200.push(NameValueDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param startDate (optional)
     * @param endDate (optional)
     * @param userName (optional)
     * @param entityTypeFullName (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    AuditLogServiceProxy.prototype.getEntityChanges = function (startDate, endDate, userName, entityTypeFullName, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityChanges?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (userName !== undefined)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
        if (entityTypeFullName !== undefined)
            url_ += "EntityTypeFullName=" + encodeURIComponent("" + entityTypeFullName) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetEntityChanges(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetEntityChanges(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AuditLogServiceProxy.prototype.processGetEntityChanges = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PagedResultDtoOfEntityChangeListDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param entityTypeFullName (optional)
     * @param entityId (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    AuditLogServiceProxy.prototype.getEntityTypeChanges = function (entityTypeFullName, entityId, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityTypeChanges?";
        if (entityTypeFullName !== undefined)
            url_ += "EntityTypeFullName=" + encodeURIComponent("" + entityTypeFullName) + "&";
        if (entityId !== undefined)
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetEntityTypeChanges(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetEntityTypeChanges(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AuditLogServiceProxy.prototype.processGetEntityTypeChanges = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PagedResultDtoOfEntityChangeListDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param startDate (optional)
     * @param endDate (optional)
     * @param userName (optional)
     * @param entityTypeFullName (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    AuditLogServiceProxy.prototype.getEntityChangesToExcel = function (startDate, endDate, userName, entityTypeFullName, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityChangesToExcel?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (userName !== undefined)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
        if (entityTypeFullName !== undefined)
            url_ += "EntityTypeFullName=" + encodeURIComponent("" + entityTypeFullName) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetEntityChangesToExcel(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetEntityChangesToExcel(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AuditLogServiceProxy.prototype.processGetEntityChangesToExcel = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = FileDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param entityChangeId (optional)
     * @return Success
     */
    AuditLogServiceProxy.prototype.getEntityPropertyChanges = function (entityChangeId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityPropertyChanges?";
        if (entityChangeId === null)
            throw new Error("The parameter 'entityChangeId' cannot be null.");
        else if (entityChangeId !== undefined)
            url_ += "entityChangeId=" + encodeURIComponent("" + entityChangeId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetEntityPropertyChanges(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetEntityPropertyChanges(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AuditLogServiceProxy.prototype.processGetEntityPropertyChanges = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_21 = resultData200; _i < resultData200_21.length; _i++) {
                        var item = resultData200_21[_i];
                        result200.push(EntityPropertyChangeDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return AuditLogServiceProxy;
}());
export { AuditLogServiceProxy };
var BarcodeScanHistoriesServiceProxy = /** @class */ (function () {
    function BarcodeScanHistoriesServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param depotLocationFilter (optional)
     * @param typeFilter (optional)
     * @param personNameFilter (optional)
     * @param barcodeFilter (optional)
     * @param maxCreatedDateFilter (optional)
     * @param minCreatedDateFilter (optional)
     * @param maxEndDateFilter (optional)
     * @param minEndDateFilter (optional)
     * @param ownDepotFilter (optional)
     * @param barcodeScanHistoryScanTagFilter (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    BarcodeScanHistoriesServiceProxy.prototype.getAll = function (depotLocationFilter, typeFilter, personNameFilter, barcodeFilter, maxCreatedDateFilter, minCreatedDateFilter, maxEndDateFilter, minEndDateFilter, ownDepotFilter, barcodeScanHistoryScanTagFilter, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/BarcodeScanHistories/GetAll?";
        if (depotLocationFilter !== undefined)
            url_ += "DepotLocationFilter=" + encodeURIComponent("" + depotLocationFilter) + "&";
        if (typeFilter === null)
            throw new Error("The parameter 'typeFilter' cannot be null.");
        else if (typeFilter !== undefined)
            url_ += "TypeFilter=" + encodeURIComponent("" + typeFilter) + "&";
        if (personNameFilter !== undefined)
            url_ += "PersonNameFilter=" + encodeURIComponent("" + personNameFilter) + "&";
        if (barcodeFilter !== undefined)
            url_ += "BarcodeFilter=" + encodeURIComponent("" + barcodeFilter) + "&";
        if (maxCreatedDateFilter !== undefined)
            url_ += "MaxCreatedDateFilter=" + encodeURIComponent(maxCreatedDateFilter ? "" + maxCreatedDateFilter.toJSON() : "") + "&";
        if (minCreatedDateFilter !== undefined)
            url_ += "MinCreatedDateFilter=" + encodeURIComponent(minCreatedDateFilter ? "" + minCreatedDateFilter.toJSON() : "") + "&";
        if (maxEndDateFilter !== undefined)
            url_ += "MaxEndDateFilter=" + encodeURIComponent(maxEndDateFilter ? "" + maxEndDateFilter.toJSON() : "") + "&";
        if (minEndDateFilter !== undefined)
            url_ += "MinEndDateFilter=" + encodeURIComponent(minEndDateFilter ? "" + minEndDateFilter.toJSON() : "") + "&";
        if (ownDepotFilter === null)
            throw new Error("The parameter 'ownDepotFilter' cannot be null.");
        else if (ownDepotFilter !== undefined)
            url_ += "OwnDepotFilter=" + encodeURIComponent("" + ownDepotFilter) + "&";
        if (barcodeScanHistoryScanTagFilter !== undefined)
            barcodeScanHistoryScanTagFilter && barcodeScanHistoryScanTagFilter.forEach(function (item) { url_ += "BarcodeScanHistoryScanTagFilter=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    BarcodeScanHistoriesServiceProxy.prototype.processGetAll = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PagedResultDtoOfGetBarcodeScanHistoryForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    BarcodeScanHistoriesServiceProxy.prototype.getBarcodeScanHistoryForView = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/BarcodeScanHistories/GetBarcodeScanHistoryForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetBarcodeScanHistoryForView(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetBarcodeScanHistoryForView(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    BarcodeScanHistoriesServiceProxy.prototype.processGetBarcodeScanHistoryForView = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetBarcodeScanHistoryForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    BarcodeScanHistoriesServiceProxy.prototype.create = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/BarcodeScanHistories/Create";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    BarcodeScanHistoriesServiceProxy.prototype.processCreate = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetBarcodeScanHistoryForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    BarcodeScanHistoriesServiceProxy.prototype.exportToExcel = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/BarcodeScanHistories/ExportToExcel";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processExportToExcel(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processExportToExcel(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    BarcodeScanHistoriesServiceProxy.prototype.processExportToExcel = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = FileDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    BarcodeScanHistoriesServiceProxy.prototype.printLabels = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/BarcodeScanHistories/PrintLabels";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processPrintLabels(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processPrintLabels(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    BarcodeScanHistoriesServiceProxy.prototype.processPrintLabels = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = FileDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    BarcodeScanHistoriesServiceProxy.prototype.printSatoLabels = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/BarcodeScanHistories/PrintSatoLabels";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processPrintSatoLabels(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processPrintSatoLabels(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    BarcodeScanHistoriesServiceProxy.prototype.processPrintSatoLabels = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    BarcodeScanHistoriesServiceProxy.prototype.validatePrintLabel = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/BarcodeScanHistories/ValidatePrintLabel";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processValidatePrintLabel(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processValidatePrintLabel(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    BarcodeScanHistoriesServiceProxy.prototype.processValidatePrintLabel = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = BulkPackageValidationResult.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return BarcodeScanHistoriesServiceProxy;
}());
export { BarcodeScanHistoriesServiceProxy };
var BrandCustomerRegionsServiceProxy = /** @class */ (function () {
    function BrandCustomerRegionsServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param postcodeFilter (optional)
     * @param regionTypeFilter (optional)
     * @param brandNameFilter (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    BrandCustomerRegionsServiceProxy.prototype.getAll = function (postcodeFilter, regionTypeFilter, brandNameFilter, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/BrandCustomerRegions/GetAll?";
        if (postcodeFilter !== undefined)
            url_ += "PostcodeFilter=" + encodeURIComponent("" + postcodeFilter) + "&";
        if (regionTypeFilter === null)
            throw new Error("The parameter 'regionTypeFilter' cannot be null.");
        else if (regionTypeFilter !== undefined)
            url_ += "RegionTypeFilter=" + encodeURIComponent("" + regionTypeFilter) + "&";
        if (brandNameFilter !== undefined)
            url_ += "BrandNameFilter=" + encodeURIComponent("" + brandNameFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    BrandCustomerRegionsServiceProxy.prototype.processGetAll = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PagedResultDtoOfGetBrandCustomerRegionForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    BrandCustomerRegionsServiceProxy.prototype.getBrandCustomerRegionForView = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/BrandCustomerRegions/GetBrandCustomerRegionForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetBrandCustomerRegionForView(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetBrandCustomerRegionForView(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    BrandCustomerRegionsServiceProxy.prototype.processGetBrandCustomerRegionForView = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetBrandCustomerRegionForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    BrandCustomerRegionsServiceProxy.prototype.getBrandCustomerRegionForEdit = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/BrandCustomerRegions/GetBrandCustomerRegionForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetBrandCustomerRegionForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetBrandCustomerRegionForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    BrandCustomerRegionsServiceProxy.prototype.processGetBrandCustomerRegionForEdit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetBrandCustomerRegionForEditOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    BrandCustomerRegionsServiceProxy.prototype.createOrEdit = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/BrandCustomerRegions/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    BrandCustomerRegionsServiceProxy.prototype.processCreateOrEdit = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    BrandCustomerRegionsServiceProxy.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/BrandCustomerRegions/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDelete(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDelete(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    BrandCustomerRegionsServiceProxy.prototype.processDelete = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param postcodeFilter (optional)
     * @param regionTypeFilter (optional)
     * @param brandNameFilter (optional)
     * @return Success
     */
    BrandCustomerRegionsServiceProxy.prototype.getBrandCustomerRegionsToExcel = function (postcodeFilter, regionTypeFilter, brandNameFilter) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/BrandCustomerRegions/GetBrandCustomerRegionsToExcel?";
        if (postcodeFilter !== undefined)
            url_ += "PostcodeFilter=" + encodeURIComponent("" + postcodeFilter) + "&";
        if (regionTypeFilter === null)
            throw new Error("The parameter 'regionTypeFilter' cannot be null.");
        else if (regionTypeFilter !== undefined)
            url_ += "RegionTypeFilter=" + encodeURIComponent("" + regionTypeFilter) + "&";
        if (brandNameFilter !== undefined)
            url_ += "BrandNameFilter=" + encodeURIComponent("" + brandNameFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetBrandCustomerRegionsToExcel(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetBrandCustomerRegionsToExcel(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    BrandCustomerRegionsServiceProxy.prototype.processGetBrandCustomerRegionsToExcel = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = FileDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    BrandCustomerRegionsServiceProxy.prototype.importFromExcel = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/BrandCustomerRegions/ImportFromExcel";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = body;
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "multipart/form-data",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processImportFromExcel(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processImportFromExcel(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    BrandCustomerRegionsServiceProxy.prototype.processImportFromExcel = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return BrandCustomerRegionsServiceProxy;
}());
export { BrandCustomerRegionsServiceProxy };
var BrandRegionSLAsServiceProxy = /** @class */ (function () {
    function BrandRegionSLAsServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param regionTypeFilter (optional)
     * @param regionValueFilter (optional)
     * @param slaDaysFilter (optional)
     * @param brandNameFilter (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    BrandRegionSLAsServiceProxy.prototype.getAll = function (regionTypeFilter, regionValueFilter, slaDaysFilter, brandNameFilter, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/BrandRegionSLAs/GetAll?";
        if (regionTypeFilter === null)
            throw new Error("The parameter 'regionTypeFilter' cannot be null.");
        else if (regionTypeFilter !== undefined)
            url_ += "RegionTypeFilter=" + encodeURIComponent("" + regionTypeFilter) + "&";
        if (regionValueFilter === null)
            throw new Error("The parameter 'regionValueFilter' cannot be null.");
        else if (regionValueFilter !== undefined)
            url_ += "RegionValueFilter=" + encodeURIComponent("" + regionValueFilter) + "&";
        if (slaDaysFilter !== undefined)
            url_ += "slaDaysFilter=" + encodeURIComponent("" + slaDaysFilter) + "&";
        if (brandNameFilter !== undefined)
            url_ += "BrandNameFilter=" + encodeURIComponent("" + brandNameFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    BrandRegionSLAsServiceProxy.prototype.processGetAll = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PagedResultDtoOfGetBrandRegionSLAForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    BrandRegionSLAsServiceProxy.prototype.getBrandRegionSLAForView = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/BrandRegionSLAs/GetBrandRegionSLAForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetBrandRegionSLAForView(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetBrandRegionSLAForView(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    BrandRegionSLAsServiceProxy.prototype.processGetBrandRegionSLAForView = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetBrandRegionSLAForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    BrandRegionSLAsServiceProxy.prototype.getBrandRegionSLAForEdit = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/BrandRegionSLAs/GetBrandRegionSLAForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetBrandRegionSLAForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetBrandRegionSLAForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    BrandRegionSLAsServiceProxy.prototype.processGetBrandRegionSLAForEdit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetBrandRegionSLAForEditOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    BrandRegionSLAsServiceProxy.prototype.createOrEdit = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/BrandRegionSLAs/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    BrandRegionSLAsServiceProxy.prototype.processCreateOrEdit = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    BrandRegionSLAsServiceProxy.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/BrandRegionSLAs/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDelete(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDelete(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    BrandRegionSLAsServiceProxy.prototype.processDelete = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return BrandRegionSLAsServiceProxy;
}());
export { BrandRegionSLAsServiceProxy };
var BrandsServiceProxy = /** @class */ (function () {
    function BrandsServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param nameFilter (optional)
     * @param rtsCarrierCodeFilter (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    BrandsServiceProxy.prototype.getAll = function (nameFilter, rtsCarrierCodeFilter, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Brands/GetAll?";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (rtsCarrierCodeFilter !== undefined)
            url_ += "RtsCarrierCodeFilter=" + encodeURIComponent("" + rtsCarrierCodeFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    BrandsServiceProxy.prototype.processGetAll = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PagedResultDtoOfGetBrandForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    BrandsServiceProxy.prototype.getBrandForView = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Brands/GetBrandForView?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetBrandForView(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetBrandForView(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    BrandsServiceProxy.prototype.processGetBrandForView = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetBrandForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    BrandsServiceProxy.prototype.getBrandForEdit = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Brands/GetBrandForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetBrandForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetBrandForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    BrandsServiceProxy.prototype.processGetBrandForEdit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetBrandForEditOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    BrandsServiceProxy.prototype.createOrEdit = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Brands/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    BrandsServiceProxy.prototype.processCreateOrEdit = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return BrandsServiceProxy;
}());
export { BrandsServiceProxy };
var BurndownEventsServiceProxy = /** @class */ (function () {
    function BurndownEventsServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param filter (optional)
     * @param dashboardTextFilter (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    BurndownEventsServiceProxy.prototype.getAll = function (filter, dashboardTextFilter, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/BurndownEvents/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (dashboardTextFilter !== undefined)
            url_ += "DashboardTextFilter=" + encodeURIComponent("" + dashboardTextFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    BurndownEventsServiceProxy.prototype.processGetAll = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PagedResultDtoOfGetBurndownEventForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    BurndownEventsServiceProxy.prototype.getBurndownEventForEdit = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/BurndownEvents/GetBurndownEventForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetBurndownEventForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetBurndownEventForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    BurndownEventsServiceProxy.prototype.processGetBurndownEventForEdit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetBurndownEventForEditOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    BurndownEventsServiceProxy.prototype.createOrEdit = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/BurndownEvents/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    BurndownEventsServiceProxy.prototype.processCreateOrEdit = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    BurndownEventsServiceProxy.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/BurndownEvents/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDelete(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDelete(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    BurndownEventsServiceProxy.prototype.processDelete = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return BurndownEventsServiceProxy;
}());
export { BurndownEventsServiceProxy };
var CachingServiceProxy = /** @class */ (function () {
    function CachingServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @return Success
     */
    CachingServiceProxy.prototype.getAllCaches = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Caching/GetAllCaches";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAllCaches(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAllCaches(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CachingServiceProxy.prototype.processGetAllCaches = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = ListResultDtoOfCacheDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    CachingServiceProxy.prototype.clearCache = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Caching/ClearCache";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processClearCache(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processClearCache(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CachingServiceProxy.prototype.processClearCache = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    CachingServiceProxy.prototype.clearAllCaches = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Caching/ClearAllCaches";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processClearAllCaches(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processClearAllCaches(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CachingServiceProxy.prototype.processClearAllCaches = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return CachingServiceProxy;
}());
export { CachingServiceProxy };
var CarriersServiceProxy = /** @class */ (function () {
    function CarriersServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param codeFilter (optional)
     * @param isDriver (optional)
     * @param nameFilter (optional)
     * @param manifestJobFilter (optional)
     * @param courierIdFilter (optional)
     * @param d365EntityFilter (optional)
     * @param emailFilter (optional)
     * @param depotIdFilter (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    CarriersServiceProxy.prototype.getAll = function (codeFilter, isDriver, nameFilter, manifestJobFilter, courierIdFilter, d365EntityFilter, emailFilter, depotIdFilter, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Carriers/GetAll?";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (isDriver !== undefined)
            url_ += "IsDriver=" + encodeURIComponent("" + isDriver) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (manifestJobFilter !== undefined)
            url_ += "ManifestJobFilter=" + encodeURIComponent("" + manifestJobFilter) + "&";
        if (courierIdFilter !== undefined)
            courierIdFilter && courierIdFilter.forEach(function (item) { url_ += "CourierIdFilter=" + encodeURIComponent("" + item) + "&"; });
        if (d365EntityFilter !== undefined)
            url_ += "D365EntityFilter=" + encodeURIComponent("" + d365EntityFilter) + "&";
        if (emailFilter !== undefined)
            url_ += "EmailFilter=" + encodeURIComponent("" + emailFilter) + "&";
        if (depotIdFilter !== undefined)
            url_ += "DepotIdFilter=" + encodeURIComponent("" + depotIdFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CarriersServiceProxy.prototype.processGetAll = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PagedResultDtoOfGetCarrierForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    CarriersServiceProxy.prototype.getCarrierForView = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Carriers/GetCarrierForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetCarrierForView(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetCarrierForView(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CarriersServiceProxy.prototype.processGetCarrierForView = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetCarrierForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    CarriersServiceProxy.prototype.getCarrierForEdit = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Carriers/GetCarrierForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetCarrierForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetCarrierForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CarriersServiceProxy.prototype.processGetCarrierForEdit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetCarrierForEditOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    CarriersServiceProxy.prototype.createOrEdit = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Carriers/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CarriersServiceProxy.prototype.processCreateOrEdit = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    CarriersServiceProxy.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Carriers/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDelete(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDelete(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CarriersServiceProxy.prototype.processDelete = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param codeFilter (optional)
     * @param isDriver (optional)
     * @param nameFilter (optional)
     * @param manifestJobFilter (optional)
     * @param courierIdFilter (optional)
     * @param d365EntityFilter (optional)
     * @param emailFilter (optional)
     * @param depotIdFilter (optional)
     * @return Success
     */
    CarriersServiceProxy.prototype.getCarriersToExcel = function (codeFilter, isDriver, nameFilter, manifestJobFilter, courierIdFilter, d365EntityFilter, emailFilter, depotIdFilter) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Carriers/GetCarriersToExcel?";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (isDriver !== undefined)
            url_ += "IsDriver=" + encodeURIComponent("" + isDriver) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (manifestJobFilter !== undefined)
            url_ += "ManifestJobFilter=" + encodeURIComponent("" + manifestJobFilter) + "&";
        if (courierIdFilter !== undefined)
            courierIdFilter && courierIdFilter.forEach(function (item) { url_ += "CourierIdFilter=" + encodeURIComponent("" + item) + "&"; });
        if (d365EntityFilter !== undefined)
            url_ += "D365EntityFilter=" + encodeURIComponent("" + d365EntityFilter) + "&";
        if (emailFilter !== undefined)
            url_ += "EmailFilter=" + encodeURIComponent("" + emailFilter) + "&";
        if (depotIdFilter !== undefined)
            url_ += "DepotIdFilter=" + encodeURIComponent("" + depotIdFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetCarriersToExcel(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetCarriersToExcel(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CarriersServiceProxy.prototype.processGetCarriersToExcel = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = FileDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    CarriersServiceProxy.prototype.importFromExcel = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Carriers/ImportFromExcel";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = body;
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "multipart/form-data",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processImportFromExcel(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processImportFromExcel(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CarriersServiceProxy.prototype.processImportFromExcel = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return CarriersServiceProxy;
}());
export { CarriersServiceProxy };
var ChatServiceProxy = /** @class */ (function () {
    function ChatServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @return Success
     */
    ChatServiceProxy.prototype.getUserChatFriendsWithSettings = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Chat/GetUserChatFriendsWithSettings";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetUserChatFriendsWithSettings(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetUserChatFriendsWithSettings(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ChatServiceProxy.prototype.processGetUserChatFriendsWithSettings = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetUserChatFriendsWithSettingsOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param tenantId (optional)
     * @param userId (optional)
     * @param minMessageId (optional)
     * @return Success
     */
    ChatServiceProxy.prototype.getUserChatMessages = function (tenantId, userId, minMessageId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Chat/GetUserChatMessages?";
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (minMessageId !== undefined)
            url_ += "MinMessageId=" + encodeURIComponent("" + minMessageId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetUserChatMessages(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetUserChatMessages(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ChatServiceProxy.prototype.processGetUserChatMessages = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = ListResultDtoOfChatMessageDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ChatServiceProxy.prototype.markAllUnreadMessagesOfUserAsRead = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Chat/MarkAllUnreadMessagesOfUserAsRead";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processMarkAllUnreadMessagesOfUserAsRead(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processMarkAllUnreadMessagesOfUserAsRead(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ChatServiceProxy.prototype.processMarkAllUnreadMessagesOfUserAsRead = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return ChatServiceProxy;
}());
export { ChatServiceProxy };
var ClientGroupsServiceProxy = /** @class */ (function () {
    function ClientGroupsServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param filter (optional)
     * @param nameFilter (optional)
     * @param signatureRequiredFilter (optional)
     * @param brandNameFilter (optional)
     * @param depotLocationNameFilter (optional)
     * @param consignmentStatusDescriptionFilter (optional)
     * @param manifestTemplateNameFilter (optional)
     * @param cutoffAlertFilter (optional)
     * @param d365EntityFilter (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    ClientGroupsServiceProxy.prototype.getAll = function (filter, nameFilter, signatureRequiredFilter, brandNameFilter, depotLocationNameFilter, consignmentStatusDescriptionFilter, manifestTemplateNameFilter, cutoffAlertFilter, d365EntityFilter, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ClientGroups/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (signatureRequiredFilter !== undefined)
            url_ += "SignatureRequiredFilter=" + encodeURIComponent("" + signatureRequiredFilter) + "&";
        if (brandNameFilter !== undefined)
            url_ += "BrandNameFilter=" + encodeURIComponent("" + brandNameFilter) + "&";
        if (depotLocationNameFilter !== undefined)
            url_ += "DepotLocationNameFilter=" + encodeURIComponent("" + depotLocationNameFilter) + "&";
        if (consignmentStatusDescriptionFilter !== undefined)
            url_ += "ConsignmentStatusDescriptionFilter=" + encodeURIComponent("" + consignmentStatusDescriptionFilter) + "&";
        if (manifestTemplateNameFilter !== undefined)
            url_ += "ManifestTemplateNameFilter=" + encodeURIComponent("" + manifestTemplateNameFilter) + "&";
        if (cutoffAlertFilter === null)
            throw new Error("The parameter 'cutoffAlertFilter' cannot be null.");
        else if (cutoffAlertFilter !== undefined)
            url_ += "CutoffAlertFilter=" + encodeURIComponent("" + cutoffAlertFilter) + "&";
        if (d365EntityFilter !== undefined)
            url_ += "D365EntityFilter=" + encodeURIComponent("" + d365EntityFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ClientGroupsServiceProxy.prototype.processGetAll = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PagedResultDtoOfGetClientGroupForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    ClientGroupsServiceProxy.prototype.getClientGroupForView = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ClientGroups/GetClientGroupForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetClientGroupForView(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetClientGroupForView(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ClientGroupsServiceProxy.prototype.processGetClientGroupForView = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetClientGroupForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    ClientGroupsServiceProxy.prototype.getClientGroupForEdit = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ClientGroups/GetClientGroupForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetClientGroupForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetClientGroupForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ClientGroupsServiceProxy.prototype.processGetClientGroupForEdit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetClientGroupForEditOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ClientGroupsServiceProxy.prototype.createOrEdit = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ClientGroups/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ClientGroupsServiceProxy.prototype.processCreateOrEdit = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    ClientGroupsServiceProxy.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ClientGroups/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDelete(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDelete(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ClientGroupsServiceProxy.prototype.processDelete = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param filter (optional)
     * @param nameFilter (optional)
     * @param signatureRequiredFilter (optional)
     * @param brandNameFilter (optional)
     * @param depotLocationNameFilter (optional)
     * @param consignmentStatusDescriptionFilter (optional)
     * @param manifestTemplateNameFilter (optional)
     * @param cutoffAlertFilter (optional)
     * @param d365EntityFilter (optional)
     * @return Success
     */
    ClientGroupsServiceProxy.prototype.getClientGroupsToExcel = function (filter, nameFilter, signatureRequiredFilter, brandNameFilter, depotLocationNameFilter, consignmentStatusDescriptionFilter, manifestTemplateNameFilter, cutoffAlertFilter, d365EntityFilter) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ClientGroups/GetClientGroupsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (signatureRequiredFilter !== undefined)
            url_ += "SignatureRequiredFilter=" + encodeURIComponent("" + signatureRequiredFilter) + "&";
        if (brandNameFilter !== undefined)
            url_ += "BrandNameFilter=" + encodeURIComponent("" + brandNameFilter) + "&";
        if (depotLocationNameFilter !== undefined)
            url_ += "DepotLocationNameFilter=" + encodeURIComponent("" + depotLocationNameFilter) + "&";
        if (consignmentStatusDescriptionFilter !== undefined)
            url_ += "ConsignmentStatusDescriptionFilter=" + encodeURIComponent("" + consignmentStatusDescriptionFilter) + "&";
        if (manifestTemplateNameFilter !== undefined)
            url_ += "ManifestTemplateNameFilter=" + encodeURIComponent("" + manifestTemplateNameFilter) + "&";
        if (cutoffAlertFilter === null)
            throw new Error("The parameter 'cutoffAlertFilter' cannot be null.");
        else if (cutoffAlertFilter !== undefined)
            url_ += "CutoffAlertFilter=" + encodeURIComponent("" + cutoffAlertFilter) + "&";
        if (d365EntityFilter !== undefined)
            url_ += "D365EntityFilter=" + encodeURIComponent("" + d365EntityFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetClientGroupsToExcel(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetClientGroupsToExcel(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ClientGroupsServiceProxy.prototype.processGetClientGroupsToExcel = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = FileDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ClientGroupsServiceProxy.prototype.importFromExcel = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ClientGroups/ImportFromExcel";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = body;
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "multipart/form-data",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processImportFromExcel(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processImportFromExcel(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ClientGroupsServiceProxy.prototype.processImportFromExcel = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return ClientGroupsServiceProxy;
}());
export { ClientGroupsServiceProxy };
var ClientsServiceProxy = /** @class */ (function () {
    function ClientsServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param filter (optional)
     * @param nameFilter (optional)
     * @param maxLeadTimeFilter (optional)
     * @param minLeadTimeFilter (optional)
     * @param notificationEmailFilter (optional)
     * @param codeFilter (optional)
     * @param clientGroupNameFilter (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    ClientsServiceProxy.prototype.getAll = function (filter, nameFilter, maxLeadTimeFilter, minLeadTimeFilter, notificationEmailFilter, codeFilter, clientGroupNameFilter, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Clients/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (maxLeadTimeFilter !== undefined)
            url_ += "MaxLeadTimeFilter=" + encodeURIComponent("" + maxLeadTimeFilter) + "&";
        if (minLeadTimeFilter !== undefined)
            url_ += "MinLeadTimeFilter=" + encodeURIComponent("" + minLeadTimeFilter) + "&";
        if (notificationEmailFilter !== undefined)
            url_ += "NotificationEmailFilter=" + encodeURIComponent("" + notificationEmailFilter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (clientGroupNameFilter !== undefined)
            url_ += "ClientGroupNameFilter=" + encodeURIComponent("" + clientGroupNameFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ClientsServiceProxy.prototype.processGetAll = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PagedResultDtoOfGetClientForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    ClientsServiceProxy.prototype.getClientForView = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Clients/GetClientForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetClientForView(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetClientForView(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ClientsServiceProxy.prototype.processGetClientForView = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetClientForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    ClientsServiceProxy.prototype.getClientForEdit = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Clients/GetClientForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetClientForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetClientForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ClientsServiceProxy.prototype.processGetClientForEdit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetClientForEditOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ClientsServiceProxy.prototype.createOrEdit = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Clients/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ClientsServiceProxy.prototype.processCreateOrEdit = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ClientsServiceProxy.prototype.createOrEditClientPickupLocationConfig = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Clients/CreateOrEditClientPickupLocationConfig";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrEditClientPickupLocationConfig(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrEditClientPickupLocationConfig(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ClientsServiceProxy.prototype.processCreateOrEditClientPickupLocationConfig = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ClientsServiceProxy.prototype.viewPickupLocationConfigKeys = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Clients/ViewPickupLocationConfigKeys";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processViewPickupLocationConfigKeys(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processViewPickupLocationConfigKeys(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ClientsServiceProxy.prototype.processViewPickupLocationConfigKeys = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetClientPickupLocationConfigKeysForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param courierName (optional)
     * @return Success
     */
    ClientsServiceProxy.prototype.deleteClientConfig = function (locationId, courierName, clientCode) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Clients/DeleteClientConfig?";
        if (locationId === undefined || locationId === null)
            throw new Error("The parameter 'locationId' must be defined and cannot be null.");
        else
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        if (courierName !== undefined)
            url_ += "CourierName=" + encodeURIComponent("" + courierName) + "&";
        if (clientCode === undefined || clientCode === null)
            throw new Error("The parameter 'clientCode' must be defined and cannot be null.");
        else
            url_ += "ClientCode=" + encodeURIComponent("" + clientCode) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteClientConfig(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteClientConfig(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ClientsServiceProxy.prototype.processDeleteClientConfig = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    ClientsServiceProxy.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Clients/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDelete(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDelete(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ClientsServiceProxy.prototype.processDelete = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param filter (optional)
     * @param nameFilter (optional)
     * @param maxLeadTimeFilter (optional)
     * @param minLeadTimeFilter (optional)
     * @param notificationEmailFilter (optional)
     * @param codeFilter (optional)
     * @param clientGroupNameFilter (optional)
     * @return Success
     */
    ClientsServiceProxy.prototype.getClientsToExcel = function (filter, nameFilter, maxLeadTimeFilter, minLeadTimeFilter, notificationEmailFilter, codeFilter, clientGroupNameFilter) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Clients/GetClientsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (maxLeadTimeFilter !== undefined)
            url_ += "MaxLeadTimeFilter=" + encodeURIComponent("" + maxLeadTimeFilter) + "&";
        if (minLeadTimeFilter !== undefined)
            url_ += "MinLeadTimeFilter=" + encodeURIComponent("" + minLeadTimeFilter) + "&";
        if (notificationEmailFilter !== undefined)
            url_ += "NotificationEmailFilter=" + encodeURIComponent("" + notificationEmailFilter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (clientGroupNameFilter !== undefined)
            url_ += "ClientGroupNameFilter=" + encodeURIComponent("" + clientGroupNameFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetClientsToExcel(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetClientsToExcel(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ClientsServiceProxy.prototype.processGetClientsToExcel = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = FileDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param filter (optional)
     * @param nameFilter (optional)
     * @param maxLeadTimeFilter (optional)
     * @param minLeadTimeFilter (optional)
     * @param notificationEmailFilter (optional)
     * @param codeFilter (optional)
     * @param clientGroupNameFilter (optional)
     * @return Success
     */
    ClientsServiceProxy.prototype.getClientsPickupConfigsToExcel = function (filter, nameFilter, maxLeadTimeFilter, minLeadTimeFilter, notificationEmailFilter, codeFilter, clientGroupNameFilter) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Clients/GetClientsPickupConfigsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (maxLeadTimeFilter !== undefined)
            url_ += "MaxLeadTimeFilter=" + encodeURIComponent("" + maxLeadTimeFilter) + "&";
        if (minLeadTimeFilter !== undefined)
            url_ += "MinLeadTimeFilter=" + encodeURIComponent("" + minLeadTimeFilter) + "&";
        if (notificationEmailFilter !== undefined)
            url_ += "NotificationEmailFilter=" + encodeURIComponent("" + notificationEmailFilter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (clientGroupNameFilter !== undefined)
            url_ += "ClientGroupNameFilter=" + encodeURIComponent("" + clientGroupNameFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetClientsPickupConfigsToExcel(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetClientsPickupConfigsToExcel(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ClientsServiceProxy.prototype.processGetClientsPickupConfigsToExcel = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = FileDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ClientsServiceProxy.prototype.createOrUpdateClientForBrand = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Clients/CreateOrUpdateClientForBrand";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrUpdateClientForBrand(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrUpdateClientForBrand(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ClientsServiceProxy.prototype.processCreateOrUpdateClientForBrand = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetClientForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ClientsServiceProxy.prototype.createOrUpdateMarketPlaceClient = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Clients/CreateOrUpdateMarketPlaceClient";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrUpdateMarketPlaceClient(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrUpdateMarketPlaceClient(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ClientsServiceProxy.prototype.processCreateOrUpdateMarketPlaceClient = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ClientsServiceProxy.prototype.importFromExcel = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Clients/ImportFromExcel";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = body;
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "multipart/form-data",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processImportFromExcel(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processImportFromExcel(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ClientsServiceProxy.prototype.processImportFromExcel = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ClientsServiceProxy.prototype.importPickupConfigurationFromExcel = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Clients/ImportPickupConfigurationFromExcel";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = body;
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "multipart/form-data",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processImportPickupConfigurationFromExcel(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processImportPickupConfigurationFromExcel(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ClientsServiceProxy.prototype.processImportPickupConfigurationFromExcel = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return ClientsServiceProxy;
}());
export { ClientsServiceProxy };
var CommonLookupServiceProxy = /** @class */ (function () {
    function CommonLookupServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param onlyFreeItems (optional)
     * @return Success
     */
    CommonLookupServiceProxy.prototype.getEditionsForCombobox = function (onlyFreeItems) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/CommonLookup/GetEditionsForCombobox?";
        if (onlyFreeItems === null)
            throw new Error("The parameter 'onlyFreeItems' cannot be null.");
        else if (onlyFreeItems !== undefined)
            url_ += "onlyFreeItems=" + encodeURIComponent("" + onlyFreeItems) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetEditionsForCombobox(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetEditionsForCombobox(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CommonLookupServiceProxy.prototype.processGetEditionsForCombobox = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = ListResultDtoOfSubscribableEditionComboboxItemDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    CommonLookupServiceProxy.prototype.findUsers = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/CommonLookup/FindUsers";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processFindUsers(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processFindUsers(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CommonLookupServiceProxy.prototype.processFindUsers = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PagedResultDtoOfNameValueDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    CommonLookupServiceProxy.prototype.getDefaultEditionName = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/CommonLookup/GetDefaultEditionName";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDefaultEditionName(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDefaultEditionName(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CommonLookupServiceProxy.prototype.processGetDefaultEditionName = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetDefaultEditionNameOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return CommonLookupServiceProxy;
}());
export { CommonLookupServiceProxy };
var ConsignmentsServiceProxy = /** @class */ (function () {
    function ConsignmentsServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param autoCreatedBySystem (optional)
     * @param body (optional)
     * @return Success
     */
    ConsignmentsServiceProxy.prototype.create = function (autoCreatedBySystem, body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Consignments/Create?";
        if (autoCreatedBySystem === null)
            throw new Error("The parameter 'autoCreatedBySystem' cannot be null.");
        else if (autoCreatedBySystem !== undefined)
            url_ += "autoCreatedBySystem=" + encodeURIComponent("" + autoCreatedBySystem) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConsignmentsServiceProxy.prototype.processCreate = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = ConsignmentDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ConsignmentsServiceProxy.prototype.addBarcode = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Consignments/AddBarcode";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processAddBarcode(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processAddBarcode(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConsignmentsServiceProxy.prototype.processAddBarcode = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = ConsignmentDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param locationId (optional)
     * @return Success
     */
    ConsignmentsServiceProxy.prototype.getDeliveryDateExclusionForLocation = function (locationId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Consignments/GetDeliveryDateExclusionForLocation?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDeliveryDateExclusionForLocation(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDeliveryDateExclusionForLocation(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConsignmentsServiceProxy.prototype.processGetDeliveryDateExclusionForLocation = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = ListResultDtoOfDeliveryDateExclusionDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ConsignmentsServiceProxy.prototype.createDriverManifest = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Consignments/CreateDriverManifest";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateDriverManifest(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateDriverManifest(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConsignmentsServiceProxy.prototype.processCreateDriverManifest = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = FileDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ConsignmentsServiceProxy.prototype.validateBulkManifest = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Consignments/ValidateBulkManifest";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processValidateBulkManifest(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processValidateBulkManifest(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConsignmentsServiceProxy.prototype.processValidateBulkManifest = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = BulkConsignmentValidationResult.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ConsignmentsServiceProxy.prototype.validateBulkManifestByConsignmentIds = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Consignments/ValidateBulkManifestByConsignmentIds";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processValidateBulkManifestByConsignmentIds(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processValidateBulkManifestByConsignmentIds(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConsignmentsServiceProxy.prototype.processValidateBulkManifestByConsignmentIds = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = BulkConsignmentValidationResult.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ConsignmentsServiceProxy.prototype.bulkManifest = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Consignments/BulkManifest";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processBulkManifest(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processBulkManifest(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConsignmentsServiceProxy.prototype.processBulkManifest = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = FileDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ConsignmentsServiceProxy.prototype.getAll = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Consignments/GetAll";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConsignmentsServiceProxy.prototype.processGetAll = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PagedResultDtoOfGetConsignmentForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ConsignmentsServiceProxy.prototype.getCount = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Consignments/GetCount";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetCount(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetCount(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConsignmentsServiceProxy.prototype.processGetCount = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    ConsignmentsServiceProxy.prototype.getConsignmentForEdit = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Consignments/GetConsignmentForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetConsignmentForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetConsignmentForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConsignmentsServiceProxy.prototype.processGetConsignmentForEdit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetConsignmentForEditOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param consignmentNumber (optional)
     * @return Success
     */
    ConsignmentsServiceProxy.prototype.getZenDeskTicketsByConsignmentNumber = function (consignmentNumber) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Consignments/GetZenDeskTicketsByConsignmentNumber?";
        if (consignmentNumber !== undefined)
            url_ += "consignmentNumber=" + encodeURIComponent("" + consignmentNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetZenDeskTicketsByConsignmentNumber(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetZenDeskTicketsByConsignmentNumber(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConsignmentsServiceProxy.prototype.processGetZenDeskTicketsByConsignmentNumber = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_22 = resultData200; _i < resultData200_22.length; _i++) {
                        var item = resultData200_22[_i];
                        result200.push(ZenDeskTicketDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ConsignmentsServiceProxy.prototype.updateConsignmentContactDetails = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Consignments/UpdateConsignmentContactDetails";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateConsignmentContactDetails(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateConsignmentContactDetails(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConsignmentsServiceProxy.prototype.processUpdateConsignmentContactDetails = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param consignmentNumber (optional)
     * @return Success
     */
    ConsignmentsServiceProxy.prototype.getCommunications = function (consignmentNumber) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Consignments/GetCommunications?";
        if (consignmentNumber !== undefined)
            url_ += "consignmentNumber=" + encodeURIComponent("" + consignmentNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetCommunications(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetCommunications(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConsignmentsServiceProxy.prototype.processGetCommunications = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_23 = resultData200; _i < resultData200_23.length; _i++) {
                        var item = resultData200_23[_i];
                        result200.push(CommunicationListItem.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ConsignmentsServiceProxy.prototype.createPickUp = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Consignments/CreatePickUp";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreatePickUp(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreatePickUp(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConsignmentsServiceProxy.prototype.processCreatePickUp = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = CreateOrEditConsignmentDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    ConsignmentsServiceProxy.prototype.getClientInformation = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Consignments/GetClientInformation?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetClientInformation(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetClientInformation(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConsignmentsServiceProxy.prototype.processGetClientInformation = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetClientForEditOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param consignmentId (optional)
     * @param shipDate (optional)
     * @param body (optional)
     * @return Success
     */
    ConsignmentsServiceProxy.prototype.validatePickUp = function (consignmentId, shipDate, body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Consignments/ValidatePickUp?";
        if (consignmentId === null)
            throw new Error("The parameter 'consignmentId' cannot be null.");
        else if (consignmentId !== undefined)
            url_ += "consignmentId=" + encodeURIComponent("" + consignmentId) + "&";
        if (shipDate === null)
            throw new Error("The parameter 'shipDate' cannot be null.");
        else if (shipDate !== undefined)
            url_ += "shipDate=" + encodeURIComponent(shipDate ? "" + shipDate.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processValidatePickUp(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processValidatePickUp(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConsignmentsServiceProxy.prototype.processValidatePickUp = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = BulkConsignmentValidationResult.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param consignmentId (optional)
     * @return Success
     */
    ConsignmentsServiceProxy.prototype.getDeliveryDateExclusionsByConsignmentId = function (consignmentId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Consignments/GetDeliveryDateExclusionsByConsignmentId?";
        if (consignmentId === null)
            throw new Error("The parameter 'consignmentId' cannot be null.");
        else if (consignmentId !== undefined)
            url_ += "consignmentId=" + encodeURIComponent("" + consignmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDeliveryDateExclusionsByConsignmentId(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDeliveryDateExclusionsByConsignmentId(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConsignmentsServiceProxy.prototype.processGetDeliveryDateExclusionsByConsignmentId = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = ListResultDtoOfDeliveryDateExclusionDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param consignmentId (optional)
     * @return Success
     */
    ConsignmentsServiceProxy.prototype.actionOnConsignment = function (consignmentId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Consignments/ActionOnConsignment?";
        if (consignmentId === null)
            throw new Error("The parameter 'consignmentId' cannot be null.");
        else if (consignmentId !== undefined)
            url_ += "consignmentId=" + encodeURIComponent("" + consignmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processActionOnConsignment(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processActionOnConsignment(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConsignmentsServiceProxy.prototype.processActionOnConsignment = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param consignmentId (optional)
     * @return Success
     */
    ConsignmentsServiceProxy.prototype.undoActionOnConsignment = function (consignmentId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Consignments/UndoActionOnConsignment?";
        if (consignmentId === null)
            throw new Error("The parameter 'consignmentId' cannot be null.");
        else if (consignmentId !== undefined)
            url_ += "consignmentId=" + encodeURIComponent("" + consignmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUndoActionOnConsignment(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUndoActionOnConsignment(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConsignmentsServiceProxy.prototype.processUndoActionOnConsignment = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param consignmentId (optional)
     * @return Success
     */
    ConsignmentsServiceProxy.prototype.removeFromDashboard = function (consignmentId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Consignments/RemoveFromDashboard?";
        if (consignmentId === null)
            throw new Error("The parameter 'consignmentId' cannot be null.");
        else if (consignmentId !== undefined)
            url_ += "consignmentId=" + encodeURIComponent("" + consignmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processRemoveFromDashboard(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processRemoveFromDashboard(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConsignmentsServiceProxy.prototype.processRemoveFromDashboard = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param consignmentId (optional)
     * @return Success
     */
    ConsignmentsServiceProxy.prototype.undoRemoveFromDashboard = function (consignmentId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Consignments/UndoRemoveFromDashboard?";
        if (consignmentId === null)
            throw new Error("The parameter 'consignmentId' cannot be null.");
        else if (consignmentId !== undefined)
            url_ += "consignmentId=" + encodeURIComponent("" + consignmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUndoRemoveFromDashboard(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUndoRemoveFromDashboard(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConsignmentsServiceProxy.prototype.processUndoRemoveFromDashboard = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ConsignmentsServiceProxy.prototype.validateActivePickupDoesNotExistForBarcodes = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Consignments/ValidateActivePickupDoesNotExistForBarcodes";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processValidateActivePickupDoesNotExistForBarcodes(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processValidateActivePickupDoesNotExistForBarcodes(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConsignmentsServiceProxy.prototype.processValidateActivePickupDoesNotExistForBarcodes = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ConsignmentsServiceProxy.prototype.getConsignmentStatistics = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Consignments/GetConsignmentStatistics";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetConsignmentStatistics(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetConsignmentStatistics(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConsignmentsServiceProxy.prototype.processGetConsignmentStatistics = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = ConsignmentStatisticsDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    ConsignmentsServiceProxy.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Consignments/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDelete(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDelete(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConsignmentsServiceProxy.prototype.processDelete = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ConsignmentsServiceProxy.prototype.createReturnToSupplier = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Consignments/CreateReturnToSupplier";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateReturnToSupplier(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateReturnToSupplier(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConsignmentsServiceProxy.prototype.processCreateReturnToSupplier = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return ConsignmentsServiceProxy;
}());
export { ConsignmentsServiceProxy };
var ConsignmentsChangeCarrierServiceProxy = /** @class */ (function () {
    function ConsignmentsChangeCarrierServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param body (optional)
     * @return Success
     */
    ConsignmentsChangeCarrierServiceProxy.prototype.validateChangeCarrierByConsignmentIds = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConsignmentsChangeCarrier/ValidateChangeCarrierByConsignmentIds";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processValidateChangeCarrierByConsignmentIds(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processValidateChangeCarrierByConsignmentIds(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConsignmentsChangeCarrierServiceProxy.prototype.processValidateChangeCarrierByConsignmentIds = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = BulkConsignmentValidationResult.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ConsignmentsChangeCarrierServiceProxy.prototype.validateChangeCarrier = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConsignmentsChangeCarrier/ValidateChangeCarrier";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processValidateChangeCarrier(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processValidateChangeCarrier(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConsignmentsChangeCarrierServiceProxy.prototype.processValidateChangeCarrier = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = BulkConsignmentValidationResult.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param carrierId (optional)
     * @param body (optional)
     * @return Success
     */
    ConsignmentsChangeCarrierServiceProxy.prototype.bulkChangeCarrierByConsignmentIds = function (carrierId, body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConsignmentsChangeCarrier/BulkChangeCarrierByConsignmentIds?";
        if (carrierId === null)
            throw new Error("The parameter 'carrierId' cannot be null.");
        else if (carrierId !== undefined)
            url_ += "carrierId=" + encodeURIComponent("" + carrierId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processBulkChangeCarrierByConsignmentIds(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processBulkChangeCarrierByConsignmentIds(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConsignmentsChangeCarrierServiceProxy.prototype.processBulkChangeCarrierByConsignmentIds = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return ConsignmentsChangeCarrierServiceProxy;
}());
export { ConsignmentsChangeCarrierServiceProxy };
var ConsignmentsChangeStatusServiceProxy = /** @class */ (function () {
    function ConsignmentsChangeStatusServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param body (optional)
     * @return Success
     */
    ConsignmentsChangeStatusServiceProxy.prototype.validateChangeStatusByConsignmentIds = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConsignmentsChangeStatus/ValidateChangeStatusByConsignmentIds";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processValidateChangeStatusByConsignmentIds(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processValidateChangeStatusByConsignmentIds(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConsignmentsChangeStatusServiceProxy.prototype.processValidateChangeStatusByConsignmentIds = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = BulkConsignmentValidationResult.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ConsignmentsChangeStatusServiceProxy.prototype.validateChangeStatus = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConsignmentsChangeStatus/ValidateChangeStatus";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processValidateChangeStatus(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processValidateChangeStatus(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConsignmentsChangeStatusServiceProxy.prototype.processValidateChangeStatus = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = BulkConsignmentValidationResult.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ConsignmentsChangeStatusServiceProxy.prototype.changeStatusByConsignmentIds = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConsignmentsChangeStatus/ChangeStatusByConsignmentIds";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processChangeStatusByConsignmentIds(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processChangeStatusByConsignmentIds(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConsignmentsChangeStatusServiceProxy.prototype.processChangeStatusByConsignmentIds = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param comment (optional)
     * @param body (optional)
     * @return Success
     */
    ConsignmentsChangeStatusServiceProxy.prototype.cancelConsignmentsByConsignmentIds = function (comment, body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConsignmentsChangeStatus/CancelConsignmentsByConsignmentIds?";
        if (comment !== undefined)
            url_ += "comment=" + encodeURIComponent("" + comment) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCancelConsignmentsByConsignmentIds(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCancelConsignmentsByConsignmentIds(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConsignmentsChangeStatusServiceProxy.prototype.processCancelConsignmentsByConsignmentIds = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param includeDeliveryConsignments (optional)
     * @param body (optional)
     * @return Success
     */
    ConsignmentsChangeStatusServiceProxy.prototype.changeStatus = function (includeDeliveryConsignments, body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConsignmentsChangeStatus/ChangeStatus?";
        if (includeDeliveryConsignments === null)
            throw new Error("The parameter 'includeDeliveryConsignments' cannot be null.");
        else if (includeDeliveryConsignments !== undefined)
            url_ += "includeDeliveryConsignments=" + encodeURIComponent("" + includeDeliveryConsignments) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processChangeStatus(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processChangeStatus(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConsignmentsChangeStatusServiceProxy.prototype.processChangeStatus = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return ConsignmentsChangeStatusServiceProxy;
}());
export { ConsignmentsChangeStatusServiceProxy };
var ConsignmentsExportForRoutingServiceProxy = /** @class */ (function () {
    function ConsignmentsExportForRoutingServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param body (optional)
     * @return Success
     */
    ConsignmentsExportForRoutingServiceProxy.prototype.validateExportForRoutingByConsignmentIds = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConsignmentsExportForRouting/ValidateExportForRoutingByConsignmentIds";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processValidateExportForRoutingByConsignmentIds(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processValidateExportForRoutingByConsignmentIds(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConsignmentsExportForRoutingServiceProxy.prototype.processValidateExportForRoutingByConsignmentIds = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = BulkConsignmentValidationResult.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ConsignmentsExportForRoutingServiceProxy.prototype.validateExportForRouting = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConsignmentsExportForRouting/ValidateExportForRouting";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processValidateExportForRouting(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processValidateExportForRouting(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConsignmentsExportForRoutingServiceProxy.prototype.processValidateExportForRouting = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = BulkConsignmentValidationResult.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ConsignmentsExportForRoutingServiceProxy.prototype.exportForRoutingByConsignmentIds = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConsignmentsExportForRouting/ExportForRoutingByConsignmentIds";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processExportForRoutingByConsignmentIds(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processExportForRoutingByConsignmentIds(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConsignmentsExportForRoutingServiceProxy.prototype.processExportForRoutingByConsignmentIds = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ConsignmentsExportForRoutingServiceProxy.prototype.exportForRouting = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConsignmentsExportForRouting/ExportForRouting";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processExportForRouting(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processExportForRouting(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConsignmentsExportForRoutingServiceProxy.prototype.processExportForRouting = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return ConsignmentsExportForRoutingServiceProxy;
}());
export { ConsignmentsExportForRoutingServiceProxy };
var ConsignmentsExportToExcelServiceProxy = /** @class */ (function () {
    function ConsignmentsExportToExcelServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param body (optional)
     * @return Success
     */
    ConsignmentsExportToExcelServiceProxy.prototype.validateExportToExcel = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConsignmentsExportToExcel/ValidateExportToExcel";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processValidateExportToExcel(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processValidateExportToExcel(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConsignmentsExportToExcelServiceProxy.prototype.processValidateExportToExcel = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = BulkConsignmentValidationResult.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ConsignmentsExportToExcelServiceProxy.prototype.validateExportToExcelByConsignmentIds = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConsignmentsExportToExcel/ValidateExportToExcelByConsignmentIds";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processValidateExportToExcelByConsignmentIds(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processValidateExportToExcelByConsignmentIds(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConsignmentsExportToExcelServiceProxy.prototype.processValidateExportToExcelByConsignmentIds = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = BulkConsignmentValidationResult.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ConsignmentsExportToExcelServiceProxy.prototype.exportToExcel = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConsignmentsExportToExcel/ExportToExcel";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processExportToExcel(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processExportToExcel(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConsignmentsExportToExcelServiceProxy.prototype.processExportToExcel = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ConsignmentsExportToExcelServiceProxy.prototype.exportToExcelFileDto = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConsignmentsExportToExcel/ExportToExcelFileDto";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processExportToExcelFileDto(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processExportToExcelFileDto(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConsignmentsExportToExcelServiceProxy.prototype.processExportToExcelFileDto = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = FileDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ConsignmentsExportToExcelServiceProxy.prototype.exportToExcelByConsignmentIds = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConsignmentsExportToExcel/ExportToExcelByConsignmentIds";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processExportToExcelByConsignmentIds(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processExportToExcelByConsignmentIds(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConsignmentsExportToExcelServiceProxy.prototype.processExportToExcelByConsignmentIds = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ConsignmentsExportToExcelServiceProxy.prototype.exportToExcelByConsignmentIdsFileDto = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConsignmentsExportToExcel/ExportToExcelByConsignmentIdsFileDto";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processExportToExcelByConsignmentIdsFileDto(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processExportToExcelByConsignmentIdsFileDto(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConsignmentsExportToExcelServiceProxy.prototype.processExportToExcelByConsignmentIdsFileDto = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = FileDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return ConsignmentsExportToExcelServiceProxy;
}());
export { ConsignmentsExportToExcelServiceProxy };
var ConsignmentsOnForwardServiceProxy = /** @class */ (function () {
    function ConsignmentsOnForwardServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param body (optional)
     * @return Success
     */
    ConsignmentsOnForwardServiceProxy.prototype.validateOnForwardByConsignmentIds = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConsignmentsOnForward/ValidateOnForwardByConsignmentIds";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processValidateOnForwardByConsignmentIds(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processValidateOnForwardByConsignmentIds(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConsignmentsOnForwardServiceProxy.prototype.processValidateOnForwardByConsignmentIds = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = BulkConsignmentValidationResult.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ConsignmentsOnForwardServiceProxy.prototype.validateOnForward = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConsignmentsOnForward/ValidateOnForward";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processValidateOnForward(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processValidateOnForward(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConsignmentsOnForwardServiceProxy.prototype.processValidateOnForward = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = BulkConsignmentValidationResult.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ConsignmentsOnForwardServiceProxy.prototype.onForwardByConsignmentIds = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConsignmentsOnForward/OnForwardByConsignmentIds";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processOnForwardByConsignmentIds(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processOnForwardByConsignmentIds(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConsignmentsOnForwardServiceProxy.prototype.processOnForwardByConsignmentIds = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ConsignmentsOnForwardServiceProxy.prototype.onForward = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConsignmentsOnForward/OnForward";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processOnForward(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processOnForward(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConsignmentsOnForwardServiceProxy.prototype.processOnForward = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param courierId (optional)
     * @param body (optional)
     * @return Success
     */
    ConsignmentsOnForwardServiceProxy.prototype.updateLoadsForManualExport = function (courierId, body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConsignmentsOnForward/UpdateLoadsForManualExport?";
        if (courierId === null)
            throw new Error("The parameter 'courierId' cannot be null.");
        else if (courierId !== undefined)
            url_ += "courierId=" + encodeURIComponent("" + courierId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateLoadsForManualExport(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateLoadsForManualExport(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConsignmentsOnForwardServiceProxy.prototype.processUpdateLoadsForManualExport = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return ConsignmentsOnForwardServiceProxy;
}());
export { ConsignmentsOnForwardServiceProxy };
var ConsignmentsPrintLabelsServiceProxy = /** @class */ (function () {
    function ConsignmentsPrintLabelsServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param body (optional)
     * @return Success
     */
    ConsignmentsPrintLabelsServiceProxy.prototype.validatePrintLabelsByConsignmentIds = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConsignmentsPrintLabels/ValidatePrintLabelsByConsignmentIds";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processValidatePrintLabelsByConsignmentIds(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processValidatePrintLabelsByConsignmentIds(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConsignmentsPrintLabelsServiceProxy.prototype.processValidatePrintLabelsByConsignmentIds = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = BulkConsignmentValidationResult.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ConsignmentsPrintLabelsServiceProxy.prototype.validatePrintLabelsByPackageIds = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConsignmentsPrintLabels/ValidatePrintLabelsByPackageIds";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processValidatePrintLabelsByPackageIds(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processValidatePrintLabelsByPackageIds(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConsignmentsPrintLabelsServiceProxy.prototype.processValidatePrintLabelsByPackageIds = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = BulkPackageValidationResult.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ConsignmentsPrintLabelsServiceProxy.prototype.validatePrintLabels = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConsignmentsPrintLabels/ValidatePrintLabels";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processValidatePrintLabels(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processValidatePrintLabels(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConsignmentsPrintLabelsServiceProxy.prototype.processValidatePrintLabels = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = BulkConsignmentValidationResult.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    ConsignmentsPrintLabelsServiceProxy.prototype.getPrintersFullList = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConsignmentsPrintLabels/GetPrintersFullList";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetPrintersFullList(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetPrintersFullList(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConsignmentsPrintLabelsServiceProxy.prototype.processGetPrintersFullList = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_24 = resultData200; _i < resultData200_24.length; _i++) {
                        var item = resultData200_24[_i];
                        result200.push(GetPrintersForViewDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ConsignmentsPrintLabelsServiceProxy.prototype.printLabelsByConsignmentIds = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConsignmentsPrintLabels/PrintLabelsByConsignmentIds";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processPrintLabelsByConsignmentIds(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processPrintLabelsByConsignmentIds(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConsignmentsPrintLabelsServiceProxy.prototype.processPrintLabelsByConsignmentIds = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = FileDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ConsignmentsPrintLabelsServiceProxy.prototype.printLabels = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConsignmentsPrintLabels/PrintLabels";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processPrintLabels(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processPrintLabels(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConsignmentsPrintLabelsServiceProxy.prototype.processPrintLabels = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = FileDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ConsignmentsPrintLabelsServiceProxy.prototype.printLabelsOnSatoByConsignmentIds = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConsignmentsPrintLabels/PrintLabelsOnSatoByConsignmentIds";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processPrintLabelsOnSatoByConsignmentIds(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processPrintLabelsOnSatoByConsignmentIds(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConsignmentsPrintLabelsServiceProxy.prototype.processPrintLabelsOnSatoByConsignmentIds = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ConsignmentsPrintLabelsServiceProxy.prototype.printLabelsOnSatoByPackageIds = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConsignmentsPrintLabels/PrintLabelsOnSatoByPackageIds";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processPrintLabelsOnSatoByPackageIds(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processPrintLabelsOnSatoByPackageIds(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConsignmentsPrintLabelsServiceProxy.prototype.processPrintLabelsOnSatoByPackageIds = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ConsignmentsPrintLabelsServiceProxy.prototype.printLabelsByPackageIds = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConsignmentsPrintLabels/PrintLabelsByPackageIds";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processPrintLabelsByPackageIds(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processPrintLabelsByPackageIds(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConsignmentsPrintLabelsServiceProxy.prototype.processPrintLabelsByPackageIds = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = FileDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return ConsignmentsPrintLabelsServiceProxy;
}());
export { ConsignmentsPrintLabelsServiceProxy };
var ConsignmentsRescheduleServiceProxy = /** @class */ (function () {
    function ConsignmentsRescheduleServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param newShipDate (optional)
     * @param body (optional)
     * @return Success
     */
    ConsignmentsRescheduleServiceProxy.prototype.validateRedeliveryByConsignmentIds = function (newShipDate, body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConsignmentsReschedule/ValidateRedeliveryByConsignmentIds?";
        if (newShipDate === null)
            throw new Error("The parameter 'newShipDate' cannot be null.");
        else if (newShipDate !== undefined)
            url_ += "newShipDate=" + encodeURIComponent(newShipDate ? "" + newShipDate.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processValidateRedeliveryByConsignmentIds(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processValidateRedeliveryByConsignmentIds(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConsignmentsRescheduleServiceProxy.prototype.processValidateRedeliveryByConsignmentIds = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = BulkConsignmentValidationResult.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param newShipDate (optional)
     * @param body (optional)
     * @return Success
     */
    ConsignmentsRescheduleServiceProxy.prototype.validateRedelivery = function (newShipDate, body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConsignmentsReschedule/ValidateRedelivery?";
        if (newShipDate === null)
            throw new Error("The parameter 'newShipDate' cannot be null.");
        else if (newShipDate !== undefined)
            url_ += "newShipDate=" + encodeURIComponent(newShipDate ? "" + newShipDate.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processValidateRedelivery(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processValidateRedelivery(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConsignmentsRescheduleServiceProxy.prototype.processValidateRedelivery = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = BulkConsignmentValidationResult.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param newShipDate (optional)
     * @param body (optional)
     * @return Success
     */
    ConsignmentsRescheduleServiceProxy.prototype.validateODDRedeliveryByConsignmentIds = function (newShipDate, body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConsignmentsReschedule/ValidateODDRedeliveryByConsignmentIds?";
        if (newShipDate === null)
            throw new Error("The parameter 'newShipDate' cannot be null.");
        else if (newShipDate !== undefined)
            url_ += "newShipDate=" + encodeURIComponent(newShipDate ? "" + newShipDate.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processValidateODDRedeliveryByConsignmentIds(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processValidateODDRedeliveryByConsignmentIds(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConsignmentsRescheduleServiceProxy.prototype.processValidateODDRedeliveryByConsignmentIds = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = BulkConsignmentValidationResult.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param newShipDate (optional)
     * @param body (optional)
     * @return Success
     */
    ConsignmentsRescheduleServiceProxy.prototype.validateRescheduleByConsignmentIds = function (newShipDate, body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConsignmentsReschedule/ValidateRescheduleByConsignmentIds?";
        if (newShipDate === null)
            throw new Error("The parameter 'newShipDate' cannot be null.");
        else if (newShipDate !== undefined)
            url_ += "newShipDate=" + encodeURIComponent(newShipDate ? "" + newShipDate.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processValidateRescheduleByConsignmentIds(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processValidateRescheduleByConsignmentIds(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConsignmentsRescheduleServiceProxy.prototype.processValidateRescheduleByConsignmentIds = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = BulkConsignmentValidationResult.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param newShipDate (optional)
     * @param body (optional)
     * @return Success
     */
    ConsignmentsRescheduleServiceProxy.prototype.validateReschedule = function (newShipDate, body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConsignmentsReschedule/ValidateReschedule?";
        if (newShipDate === null)
            throw new Error("The parameter 'newShipDate' cannot be null.");
        else if (newShipDate !== undefined)
            url_ += "newShipDate=" + encodeURIComponent(newShipDate ? "" + newShipDate.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processValidateReschedule(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processValidateReschedule(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConsignmentsRescheduleServiceProxy.prototype.processValidateReschedule = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = BulkConsignmentValidationResult.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param deliveryType (optional)
     * @param newShipDate (optional)
     * @param carrierId (optional)
     * @param resolveZendeskTicket (optional)
     * @param comment (optional)
     * @param excludeCustomerConfirmed (optional)
     * @param body (optional)
     * @return Success
     */
    ConsignmentsRescheduleServiceProxy.prototype.bulkChangeShipDateByConsignmentIds = function (deliveryType, newShipDate, carrierId, resolveZendeskTicket, comment, excludeCustomerConfirmed, body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConsignmentsReschedule/BulkChangeShipDateByConsignmentIds?";
        if (deliveryType !== undefined)
            url_ += "deliveryType=" + encodeURIComponent("" + deliveryType) + "&";
        if (newShipDate === null)
            throw new Error("The parameter 'newShipDate' cannot be null.");
        else if (newShipDate !== undefined)
            url_ += "newShipDate=" + encodeURIComponent(newShipDate ? "" + newShipDate.toJSON() : "") + "&";
        if (carrierId !== undefined)
            url_ += "carrierId=" + encodeURIComponent("" + carrierId) + "&";
        if (resolveZendeskTicket === null)
            throw new Error("The parameter 'resolveZendeskTicket' cannot be null.");
        else if (resolveZendeskTicket !== undefined)
            url_ += "resolveZendeskTicket=" + encodeURIComponent("" + resolveZendeskTicket) + "&";
        if (comment !== undefined)
            url_ += "comment=" + encodeURIComponent("" + comment) + "&";
        if (excludeCustomerConfirmed === null)
            throw new Error("The parameter 'excludeCustomerConfirmed' cannot be null.");
        else if (excludeCustomerConfirmed !== undefined)
            url_ += "excludeCustomerConfirmed=" + encodeURIComponent("" + excludeCustomerConfirmed) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processBulkChangeShipDateByConsignmentIds(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processBulkChangeShipDateByConsignmentIds(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConsignmentsRescheduleServiceProxy.prototype.processBulkChangeShipDateByConsignmentIds = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param deliveryType (optional)
     * @param newShipDate (optional)
     * @param carrierId (optional)
     * @param resolveZendeskTicket (optional)
     * @param comment (optional)
     * @param excludeCustomerConfirmed (optional)
     * @param body (optional)
     * @return Success
     */
    ConsignmentsRescheduleServiceProxy.prototype.bulkChangeShipDate = function (deliveryType, newShipDate, carrierId, resolveZendeskTicket, comment, excludeCustomerConfirmed, body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConsignmentsReschedule/BulkChangeShipDate?";
        if (deliveryType !== undefined)
            url_ += "deliveryType=" + encodeURIComponent("" + deliveryType) + "&";
        if (newShipDate === null)
            throw new Error("The parameter 'newShipDate' cannot be null.");
        else if (newShipDate !== undefined)
            url_ += "newShipDate=" + encodeURIComponent(newShipDate ? "" + newShipDate.toJSON() : "") + "&";
        if (carrierId !== undefined)
            url_ += "carrierId=" + encodeURIComponent("" + carrierId) + "&";
        if (resolveZendeskTicket === null)
            throw new Error("The parameter 'resolveZendeskTicket' cannot be null.");
        else if (resolveZendeskTicket !== undefined)
            url_ += "resolveZendeskTicket=" + encodeURIComponent("" + resolveZendeskTicket) + "&";
        if (comment !== undefined)
            url_ += "comment=" + encodeURIComponent("" + comment) + "&";
        if (excludeCustomerConfirmed === null)
            throw new Error("The parameter 'excludeCustomerConfirmed' cannot be null.");
        else if (excludeCustomerConfirmed !== undefined)
            url_ += "excludeCustomerConfirmed=" + encodeURIComponent("" + excludeCustomerConfirmed) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processBulkChangeShipDate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processBulkChangeShipDate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConsignmentsRescheduleServiceProxy.prototype.processBulkChangeShipDate = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    ConsignmentsRescheduleServiceProxy.prototype.getConsignmentDeliveryInstructionsForEdit = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConsignmentsReschedule/GetConsignmentDeliveryInstructionsForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetConsignmentDeliveryInstructionsForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetConsignmentDeliveryInstructionsForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConsignmentsRescheduleServiceProxy.prototype.processGetConsignmentDeliveryInstructionsForEdit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetConsignmentDropcodeInstructionsForEditOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ConsignmentsRescheduleServiceProxy.prototype.rescheduleConsignment = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConsignmentsReschedule/RescheduleConsignment";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processRescheduleConsignment(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processRescheduleConsignment(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConsignmentsRescheduleServiceProxy.prototype.processRescheduleConsignment = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ConsignmentsRescheduleServiceProxy.prototype.redeliverConsignment = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConsignmentsReschedule/RedeliverConsignment";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processRedeliverConsignment(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processRedeliverConsignment(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConsignmentsRescheduleServiceProxy.prototype.processRedeliverConsignment = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ConsignmentsRescheduleServiceProxy.prototype.redirectConsignment = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConsignmentsReschedule/RedirectConsignment";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processRedirectConsignment(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processRedirectConsignment(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConsignmentsRescheduleServiceProxy.prototype.processRedirectConsignment = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ConsignmentsRescheduleServiceProxy.prototype.updateConsignmentPriority = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConsignmentsReschedule/UpdateConsignmentPriority";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateConsignmentPriority(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateConsignmentPriority(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConsignmentsRescheduleServiceProxy.prototype.processUpdateConsignmentPriority = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ConsignmentsRescheduleServiceProxy.prototype.updateConsignmentDeliveryInstructions = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConsignmentsReschedule/UpdateConsignmentDeliveryInstructions";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateConsignmentDeliveryInstructions(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateConsignmentDeliveryInstructions(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConsignmentsRescheduleServiceProxy.prototype.processUpdateConsignmentDeliveryInstructions = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return ConsignmentsRescheduleServiceProxy;
}());
export { ConsignmentsRescheduleServiceProxy };
var ConsignmentsSendCommunicationServiceProxy = /** @class */ (function () {
    function ConsignmentsSendCommunicationServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param status (optional)
     * @param body (optional)
     * @return Success
     */
    ConsignmentsSendCommunicationServiceProxy.prototype.validateSendCommunicationByConsignmentIds = function (status, body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConsignmentsSendCommunication/ValidateSendCommunicationByConsignmentIds?";
        if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processValidateSendCommunicationByConsignmentIds(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processValidateSendCommunicationByConsignmentIds(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConsignmentsSendCommunicationServiceProxy.prototype.processValidateSendCommunicationByConsignmentIds = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = BulkConsignmentValidationResult.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param status (optional)
     * @param body (optional)
     * @return Success
     */
    ConsignmentsSendCommunicationServiceProxy.prototype.validateSendCommunication = function (status, body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConsignmentsSendCommunication/ValidateSendCommunication?";
        if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processValidateSendCommunication(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processValidateSendCommunication(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConsignmentsSendCommunicationServiceProxy.prototype.processValidateSendCommunication = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = BulkConsignmentValidationResult.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param status (optional)
     * @param body (optional)
     * @return Success
     */
    ConsignmentsSendCommunicationServiceProxy.prototype.bulkSendCommunicationByConsignmentIds = function (status, body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConsignmentsSendCommunication/BulkSendCommunicationByConsignmentIds?";
        if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processBulkSendCommunicationByConsignmentIds(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processBulkSendCommunicationByConsignmentIds(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConsignmentsSendCommunicationServiceProxy.prototype.processBulkSendCommunicationByConsignmentIds = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return ConsignmentsSendCommunicationServiceProxy;
}());
export { ConsignmentsSendCommunicationServiceProxy };
var ConsignmentStatusDashboardServiceProxy = /** @class */ (function () {
    function ConsignmentStatusDashboardServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @return Success
     */
    ConsignmentStatusDashboardServiceProxy.prototype.getConsignmentsForDashboardEdByState = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConsignmentStatusDashboard/GetConsignmentsForDashboardEdByState";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetConsignmentsForDashboardEdByState(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetConsignmentsForDashboardEdByState(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConsignmentStatusDashboardServiceProxy.prototype.processGetConsignmentsForDashboardEdByState = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = ConsignmentsSummaryDashboardEdByStateOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    ConsignmentStatusDashboardServiceProxy.prototype.getConsignmentsForDashboardAllCarriers = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ConsignmentStatusDashboard/GetConsignmentsForDashboardAllCarriers";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetConsignmentsForDashboardAllCarriers(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetConsignmentsForDashboardAllCarriers(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ConsignmentStatusDashboardServiceProxy.prototype.processGetConsignmentsForDashboardAllCarriers = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = ConsignmentsSummaryDashboardAllCarriersOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return ConsignmentStatusDashboardServiceProxy;
}());
export { ConsignmentStatusDashboardServiceProxy };
var CostRegionLocationsServiceProxy = /** @class */ (function () {
    function CostRegionLocationsServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param regionFilter (optional)
     * @param suburbFilter (optional)
     * @param postcodeFilter (optional)
     * @param courierIdFilter (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    CostRegionLocationsServiceProxy.prototype.getAll = function (regionFilter, suburbFilter, postcodeFilter, courierIdFilter, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/CostRegionLocations/GetAll?";
        if (regionFilter !== undefined)
            url_ += "RegionFilter=" + encodeURIComponent("" + regionFilter) + "&";
        if (suburbFilter !== undefined)
            url_ += "SuburbFilter=" + encodeURIComponent("" + suburbFilter) + "&";
        if (postcodeFilter !== undefined)
            url_ += "PostcodeFilter=" + encodeURIComponent("" + postcodeFilter) + "&";
        if (courierIdFilter !== undefined)
            url_ += "CourierIdFilter=" + encodeURIComponent("" + courierIdFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CostRegionLocationsServiceProxy.prototype.processGetAll = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PagedResultDtoOfGetCostRegionLocationForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    CostRegionLocationsServiceProxy.prototype.getCostRegionLocationForEdit = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/CostRegionLocations/GetCostRegionLocationForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetCostRegionLocationForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetCostRegionLocationForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CostRegionLocationsServiceProxy.prototype.processGetCostRegionLocationForEdit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetCostRegionLocationForEditOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    CostRegionLocationsServiceProxy.prototype.createOrEdit = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/CostRegionLocations/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CostRegionLocationsServiceProxy.prototype.processCreateOrEdit = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    CostRegionLocationsServiceProxy.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/CostRegionLocations/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDelete(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDelete(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CostRegionLocationsServiceProxy.prototype.processDelete = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param regionFilter (optional)
     * @param suburbFilter (optional)
     * @param postcodeFilter (optional)
     * @param courierIdFilter (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    CostRegionLocationsServiceProxy.prototype.getCostRegionLocationsToExcel = function (regionFilter, suburbFilter, postcodeFilter, courierIdFilter, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/CostRegionLocations/GetCostRegionLocationsToExcel?";
        if (regionFilter !== undefined)
            url_ += "RegionFilter=" + encodeURIComponent("" + regionFilter) + "&";
        if (suburbFilter !== undefined)
            url_ += "SuburbFilter=" + encodeURIComponent("" + suburbFilter) + "&";
        if (postcodeFilter !== undefined)
            url_ += "PostcodeFilter=" + encodeURIComponent("" + postcodeFilter) + "&";
        if (courierIdFilter !== undefined)
            url_ += "CourierIdFilter=" + encodeURIComponent("" + courierIdFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetCostRegionLocationsToExcel(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetCostRegionLocationsToExcel(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CostRegionLocationsServiceProxy.prototype.processGetCostRegionLocationsToExcel = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = FileDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param filter (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    CostRegionLocationsServiceProxy.prototype.getAllCostRegionForLookupTable = function (filter, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/CostRegionLocations/GetAllCostRegionForLookupTable?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAllCostRegionForLookupTable(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAllCostRegionForLookupTable(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CostRegionLocationsServiceProxy.prototype.processGetAllCostRegionForLookupTable = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PagedResultDtoOfCostRegionLocationCostRegionLookupTableDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param filter (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    CostRegionLocationsServiceProxy.prototype.getAllLocationSettingForLookupTable = function (filter, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/CostRegionLocations/GetAllLocationSettingForLookupTable?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAllLocationSettingForLookupTable(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAllLocationSettingForLookupTable(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CostRegionLocationsServiceProxy.prototype.processGetAllLocationSettingForLookupTable = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PagedResultDtoOfCostRegionLocationLocationSettingLookupTableDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    CostRegionLocationsServiceProxy.prototype.importFromExcel = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/CostRegionLocations/ImportFromExcel";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = body;
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "multipart/form-data",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processImportFromExcel(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processImportFromExcel(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CostRegionLocationsServiceProxy.prototype.processImportFromExcel = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return CostRegionLocationsServiceProxy;
}());
export { CostRegionLocationsServiceProxy };
var CostRegionsServiceProxy = /** @class */ (function () {
    function CostRegionsServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param regionFilter (optional)
     * @param courierilter (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    CostRegionsServiceProxy.prototype.getAll = function (regionFilter, courierilter, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/CostRegions/GetAll?";
        if (regionFilter !== undefined)
            url_ += "RegionFilter=" + encodeURIComponent("" + regionFilter) + "&";
        if (courierilter !== undefined)
            url_ += "Courierilter=" + encodeURIComponent("" + courierilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CostRegionsServiceProxy.prototype.processGetAll = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PagedResultDtoOfGetCostRegionForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    CostRegionsServiceProxy.prototype.getCostRegionForEdit = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/CostRegions/GetCostRegionForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetCostRegionForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetCostRegionForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CostRegionsServiceProxy.prototype.processGetCostRegionForEdit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetCostRegionForEditOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    CostRegionsServiceProxy.prototype.createOrEdit = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/CostRegions/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CostRegionsServiceProxy.prototype.processCreateOrEdit = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    CostRegionsServiceProxy.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/CostRegions/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDelete(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDelete(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CostRegionsServiceProxy.prototype.processDelete = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param regionFilter (optional)
     * @param courierilter (optional)
     * @return Success
     */
    CostRegionsServiceProxy.prototype.getCostRegionsToExcel = function (regionFilter, courierilter) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/CostRegions/GetCostRegionsToExcel?";
        if (regionFilter !== undefined)
            url_ += "RegionFilter=" + encodeURIComponent("" + regionFilter) + "&";
        if (courierilter !== undefined)
            url_ += "Courierilter=" + encodeURIComponent("" + courierilter) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetCostRegionsToExcel(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetCostRegionsToExcel(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CostRegionsServiceProxy.prototype.processGetCostRegionsToExcel = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = FileDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    CostRegionsServiceProxy.prototype.importFromExcel = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/CostRegions/ImportFromExcel";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = body;
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "multipart/form-data",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processImportFromExcel(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processImportFromExcel(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CostRegionsServiceProxy.prototype.processImportFromExcel = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return CostRegionsServiceProxy;
}());
export { CostRegionsServiceProxy };
var CouriersServiceProxy = /** @class */ (function () {
    function CouriersServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param filter (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    CouriersServiceProxy.prototype.getAll = function (filter, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Couriers/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CouriersServiceProxy.prototype.processGetAll = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PagedResultDtoOfGetCourierForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    CouriersServiceProxy.prototype.getCourierForView = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Couriers/GetCourierForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetCourierForView(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetCourierForView(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CouriersServiceProxy.prototype.processGetCourierForView = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetCourierForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    CouriersServiceProxy.prototype.getCourierForEdit = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Couriers/GetCourierForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetCourierForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetCourierForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CouriersServiceProxy.prototype.processGetCourierForEdit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetCourierForEditOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    CouriersServiceProxy.prototype.createOrEdit = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Couriers/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CouriersServiceProxy.prototype.processCreateOrEdit = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    CouriersServiceProxy.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Couriers/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDelete(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDelete(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CouriersServiceProxy.prototype.processDelete = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return CouriersServiceProxy;
}());
export { CouriersServiceProxy };
var CrossBordersServiceProxy = /** @class */ (function () {
    function CrossBordersServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param locationFilter (optional)
     * @param destinationFilter (optional)
     * @param maxPalletisedDateFilter (optional)
     * @param minPalletisedDateFilter (optional)
     * @param ownDepotFilter (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    CrossBordersServiceProxy.prototype.getAll = function (locationFilter, destinationFilter, maxPalletisedDateFilter, minPalletisedDateFilter, ownDepotFilter, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/CrossBorders/GetAll?";
        if (locationFilter !== undefined)
            url_ += "LocationFilter=" + encodeURIComponent("" + locationFilter) + "&";
        if (destinationFilter !== undefined)
            url_ += "DestinationFilter=" + encodeURIComponent("" + destinationFilter) + "&";
        if (maxPalletisedDateFilter !== undefined)
            url_ += "MaxPalletisedDateFilter=" + encodeURIComponent(maxPalletisedDateFilter ? "" + maxPalletisedDateFilter.toJSON() : "") + "&";
        if (minPalletisedDateFilter !== undefined)
            url_ += "MinPalletisedDateFilter=" + encodeURIComponent(minPalletisedDateFilter ? "" + minPalletisedDateFilter.toJSON() : "") + "&";
        if (ownDepotFilter === null)
            throw new Error("The parameter 'ownDepotFilter' cannot be null.");
        else if (ownDepotFilter !== undefined)
            url_ += "OwnDepotFilter=" + encodeURIComponent("" + ownDepotFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CrossBordersServiceProxy.prototype.processGetAll = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PagedResultDtoOfGetCrossBorderForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    CrossBordersServiceProxy.prototype.getCrossBorderForView = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/CrossBorders/GetCrossBorderForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetCrossBorderForView(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetCrossBorderForView(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CrossBordersServiceProxy.prototype.processGetCrossBorderForView = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetCrossBorderForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    CrossBordersServiceProxy.prototype.delete = function (crossBorderIds) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/CrossBorders/Delete?";
        if (crossBorderIds === undefined || crossBorderIds === null)
            throw new Error("The parameter 'crossBorderIds' must be defined and cannot be null.");
        else
            crossBorderIds && crossBorderIds.forEach(function (item) { url_ += "CrossBorderIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDelete(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDelete(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CrossBordersServiceProxy.prototype.processDelete = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    CrossBordersServiceProxy.prototype.createLoad = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/CrossBorders/CreateLoad";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateLoad(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateLoad(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CrossBordersServiceProxy.prototype.processCreateLoad = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return CrossBordersServiceProxy;
}());
export { CrossBordersServiceProxy };
var DashboardCustomizationServiceProxy = /** @class */ (function () {
    function DashboardCustomizationServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param dashboardName (optional)
     * @param application (optional)
     * @return Success
     */
    DashboardCustomizationServiceProxy.prototype.getUserDashboard = function (dashboardName, application) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DashboardCustomization/GetUserDashboard?";
        if (dashboardName !== undefined)
            url_ += "DashboardName=" + encodeURIComponent("" + dashboardName) + "&";
        if (application !== undefined)
            url_ += "Application=" + encodeURIComponent("" + application) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetUserDashboard(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetUserDashboard(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DashboardCustomizationServiceProxy.prototype.processGetUserDashboard = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = Dashboard.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    DashboardCustomizationServiceProxy.prototype.savePage = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DashboardCustomization/SavePage";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSavePage(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSavePage(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DashboardCustomizationServiceProxy.prototype.processSavePage = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    DashboardCustomizationServiceProxy.prototype.renamePage = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DashboardCustomization/RenamePage";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processRenamePage(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processRenamePage(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DashboardCustomizationServiceProxy.prototype.processRenamePage = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    DashboardCustomizationServiceProxy.prototype.addNewPage = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DashboardCustomization/AddNewPage";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processAddNewPage(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processAddNewPage(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DashboardCustomizationServiceProxy.prototype.processAddNewPage = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = AddNewPageOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @param dashboardName (optional)
     * @param application (optional)
     * @return Success
     */
    DashboardCustomizationServiceProxy.prototype.deletePage = function (id, dashboardName, application) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DashboardCustomization/DeletePage?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (dashboardName !== undefined)
            url_ += "DashboardName=" + encodeURIComponent("" + dashboardName) + "&";
        if (application !== undefined)
            url_ += "Application=" + encodeURIComponent("" + application) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeletePage(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeletePage(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DashboardCustomizationServiceProxy.prototype.processDeletePage = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    DashboardCustomizationServiceProxy.prototype.addWidget = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DashboardCustomization/AddWidget";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processAddWidget(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processAddWidget(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DashboardCustomizationServiceProxy.prototype.processAddWidget = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = Widget.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param dashboardName (optional)
     * @param application (optional)
     * @return Success
     */
    DashboardCustomizationServiceProxy.prototype.getDashboardDefinition = function (dashboardName, application) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DashboardCustomization/GetDashboardDefinition?";
        if (dashboardName !== undefined)
            url_ += "DashboardName=" + encodeURIComponent("" + dashboardName) + "&";
        if (application !== undefined)
            url_ += "Application=" + encodeURIComponent("" + application) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDashboardDefinition(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDashboardDefinition(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DashboardCustomizationServiceProxy.prototype.processGetDashboardDefinition = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = DashboardOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param dashboardName (optional)
     * @param application (optional)
     * @return Success
     */
    DashboardCustomizationServiceProxy.prototype.getAllWidgetDefinitions = function (dashboardName, application) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DashboardCustomization/GetAllWidgetDefinitions?";
        if (dashboardName !== undefined)
            url_ += "DashboardName=" + encodeURIComponent("" + dashboardName) + "&";
        if (application !== undefined)
            url_ += "Application=" + encodeURIComponent("" + application) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAllWidgetDefinitions(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAllWidgetDefinitions(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DashboardCustomizationServiceProxy.prototype.processGetAllWidgetDefinitions = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_25 = resultData200; _i < resultData200_25.length; _i++) {
                        var item = resultData200_25[_i];
                        result200.push(WidgetOutput.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param application (optional)
     * @return Success
     */
    DashboardCustomizationServiceProxy.prototype.getSettingName = function (application) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DashboardCustomization/GetSettingName?";
        if (application !== undefined)
            url_ += "application=" + encodeURIComponent("" + application) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetSettingName(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetSettingName(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DashboardCustomizationServiceProxy.prototype.processGetSettingName = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return DashboardCustomizationServiceProxy;
}());
export { DashboardCustomizationServiceProxy };
var DeliveryDateExclusionsServiceProxy = /** @class */ (function () {
    function DeliveryDateExclusionsServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param filter (optional)
     * @param stateFilter (optional)
     * @param minDeliveryDateFilter (optional)
     * @param maxDeliveryDateFilter (optional)
     * @return Success
     */
    DeliveryDateExclusionsServiceProxy.prototype.getAll = function (filter, stateFilter, minDeliveryDateFilter, maxDeliveryDateFilter) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeliveryDateExclusions/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (stateFilter !== undefined)
            url_ += "StateFilter=" + encodeURIComponent("" + stateFilter) + "&";
        if (minDeliveryDateFilter !== undefined)
            url_ += "MinDeliveryDateFilter=" + encodeURIComponent(minDeliveryDateFilter ? "" + minDeliveryDateFilter.toJSON() : "") + "&";
        if (maxDeliveryDateFilter !== undefined)
            url_ += "MaxDeliveryDateFilter=" + encodeURIComponent(maxDeliveryDateFilter ? "" + maxDeliveryDateFilter.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeliveryDateExclusionsServiceProxy.prototype.processGetAll = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PagedResultDtoOfGetDeliveryDateExclusionForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param consignmentId (optional)
     * @return Success
     */
    DeliveryDateExclusionsServiceProxy.prototype.getFutureDeliveryDatesForConsignment = function (consignmentId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeliveryDateExclusions/GetFutureDeliveryDatesForConsignment?";
        if (consignmentId === null)
            throw new Error("The parameter 'consignmentId' cannot be null.");
        else if (consignmentId !== undefined)
            url_ += "ConsignmentId=" + encodeURIComponent("" + consignmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetFutureDeliveryDatesForConsignment(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetFutureDeliveryDatesForConsignment(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeliveryDateExclusionsServiceProxy.prototype.processGetFutureDeliveryDatesForConsignment = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_26 = resultData200; _i < resultData200_26.length; _i++) {
                        var item = resultData200_26[_i];
                        result200.push(FutureDeliveryDatesDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    DeliveryDateExclusionsServiceProxy.prototype.getDeliveryDateExclusionForEdit = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeliveryDateExclusions/GetDeliveryDateExclusionForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDeliveryDateExclusionForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDeliveryDateExclusionForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeliveryDateExclusionsServiceProxy.prototype.processGetDeliveryDateExclusionForEdit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetDeliveryDateExclusionForEditOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    DeliveryDateExclusionsServiceProxy.prototype.createOrEdit = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeliveryDateExclusions/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeliveryDateExclusionsServiceProxy.prototype.processCreateOrEdit = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    DeliveryDateExclusionsServiceProxy.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeliveryDateExclusions/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDelete(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDelete(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeliveryDateExclusionsServiceProxy.prototype.processDelete = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param filter (optional)
     * @param stateFilter (optional)
     * @param minDeliveryDateFilter (optional)
     * @param maxDeliveryDateFilter (optional)
     * @return Success
     */
    DeliveryDateExclusionsServiceProxy.prototype.getDeliveryDateExclusionsToExcel = function (filter, stateFilter, minDeliveryDateFilter, maxDeliveryDateFilter) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeliveryDateExclusions/GetDeliveryDateExclusionsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (stateFilter !== undefined)
            url_ += "StateFilter=" + encodeURIComponent("" + stateFilter) + "&";
        if (minDeliveryDateFilter !== undefined)
            url_ += "MinDeliveryDateFilter=" + encodeURIComponent(minDeliveryDateFilter ? "" + minDeliveryDateFilter.toJSON() : "") + "&";
        if (maxDeliveryDateFilter !== undefined)
            url_ += "MaxDeliveryDateFilter=" + encodeURIComponent(maxDeliveryDateFilter ? "" + maxDeliveryDateFilter.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDeliveryDateExclusionsToExcel(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDeliveryDateExclusionsToExcel(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeliveryDateExclusionsServiceProxy.prototype.processGetDeliveryDateExclusionsToExcel = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = FileDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    DeliveryDateExclusionsServiceProxy.prototype.importFromExcel = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeliveryDateExclusions/ImportFromExcel";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = body;
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "multipart/form-data",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processImportFromExcel(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processImportFromExcel(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeliveryDateExclusionsServiceProxy.prototype.processImportFromExcel = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return DeliveryDateExclusionsServiceProxy;
}());
export { DeliveryDateExclusionsServiceProxy };
var DeliveryTypeSettingsServiceProxy = /** @class */ (function () {
    function DeliveryTypeSettingsServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param filter (optional)
     * @param deliveryTypeFilter (optional)
     * @param maxLeadTimeFilter (optional)
     * @param minLeadTimeFilter (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    DeliveryTypeSettingsServiceProxy.prototype.getAll = function (filter, deliveryTypeFilter, maxLeadTimeFilter, minLeadTimeFilter, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeliveryTypeSettings/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (deliveryTypeFilter === null)
            throw new Error("The parameter 'deliveryTypeFilter' cannot be null.");
        else if (deliveryTypeFilter !== undefined)
            url_ += "DeliveryTypeFilter=" + encodeURIComponent("" + deliveryTypeFilter) + "&";
        if (maxLeadTimeFilter !== undefined)
            url_ += "MaxLeadTimeFilter=" + encodeURIComponent("" + maxLeadTimeFilter) + "&";
        if (minLeadTimeFilter !== undefined)
            url_ += "MinLeadTimeFilter=" + encodeURIComponent("" + minLeadTimeFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeliveryTypeSettingsServiceProxy.prototype.processGetAll = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PagedResultDtoOfGetDeliveryTypeSettingForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    DeliveryTypeSettingsServiceProxy.prototype.getDeliveryTypeSettingForView = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeliveryTypeSettings/GetDeliveryTypeSettingForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDeliveryTypeSettingForView(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDeliveryTypeSettingForView(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeliveryTypeSettingsServiceProxy.prototype.processGetDeliveryTypeSettingForView = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetDeliveryTypeSettingForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    DeliveryTypeSettingsServiceProxy.prototype.getDeliveryTypeSettingForEdit = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeliveryTypeSettings/GetDeliveryTypeSettingForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDeliveryTypeSettingForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDeliveryTypeSettingForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeliveryTypeSettingsServiceProxy.prototype.processGetDeliveryTypeSettingForEdit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetDeliveryTypeSettingForEditOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    DeliveryTypeSettingsServiceProxy.prototype.createOrEdit = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeliveryTypeSettings/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeliveryTypeSettingsServiceProxy.prototype.processCreateOrEdit = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    DeliveryTypeSettingsServiceProxy.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeliveryTypeSettings/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDelete(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDelete(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeliveryTypeSettingsServiceProxy.prototype.processDelete = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param filter (optional)
     * @param deliveryTypeFilter (optional)
     * @param maxLeadTimeFilter (optional)
     * @param minLeadTimeFilter (optional)
     * @return Success
     */
    DeliveryTypeSettingsServiceProxy.prototype.getDeliveryTypeSettingsToExcel = function (filter, deliveryTypeFilter, maxLeadTimeFilter, minLeadTimeFilter) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeliveryTypeSettings/GetDeliveryTypeSettingsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (deliveryTypeFilter === null)
            throw new Error("The parameter 'deliveryTypeFilter' cannot be null.");
        else if (deliveryTypeFilter !== undefined)
            url_ += "DeliveryTypeFilter=" + encodeURIComponent("" + deliveryTypeFilter) + "&";
        if (maxLeadTimeFilter !== undefined)
            url_ += "MaxLeadTimeFilter=" + encodeURIComponent("" + maxLeadTimeFilter) + "&";
        if (minLeadTimeFilter !== undefined)
            url_ += "MinLeadTimeFilter=" + encodeURIComponent("" + minLeadTimeFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDeliveryTypeSettingsToExcel(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDeliveryTypeSettingsToExcel(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeliveryTypeSettingsServiceProxy.prototype.processGetDeliveryTypeSettingsToExcel = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = FileDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return DeliveryTypeSettingsServiceProxy;
}());
export { DeliveryTypeSettingsServiceProxy };
var DemoUiComponentsServiceProxy = /** @class */ (function () {
    function DemoUiComponentsServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param date (optional)
     * @return Success
     */
    DemoUiComponentsServiceProxy.prototype.sendAndGetDate = function (date) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetDate?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSendAndGetDate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSendAndGetDate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DemoUiComponentsServiceProxy.prototype.processSendAndGetDate = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = DateToStringOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param date (optional)
     * @return Success
     */
    DemoUiComponentsServiceProxy.prototype.sendAndGetDateTime = function (date) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetDateTime?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSendAndGetDateTime(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSendAndGetDateTime(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DemoUiComponentsServiceProxy.prototype.processSendAndGetDateTime = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = DateToStringOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param startDate (optional)
     * @param endDate (optional)
     * @return Success
     */
    DemoUiComponentsServiceProxy.prototype.sendAndGetDateRange = function (startDate, endDate) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetDateRange?";
        if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSendAndGetDateRange(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSendAndGetDateRange(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DemoUiComponentsServiceProxy.prototype.processSendAndGetDateRange = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = DateToStringOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param searchTerm (optional)
     * @return Success
     */
    DemoUiComponentsServiceProxy.prototype.getCountries = function (searchTerm) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DemoUiComponents/GetCountries?";
        if (searchTerm !== undefined)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetCountries(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetCountries(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DemoUiComponentsServiceProxy.prototype.processGetCountries = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_27 = resultData200; _i < resultData200_27.length; _i++) {
                        var item = resultData200_27[_i];
                        result200.push(NameValueOfString.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    DemoUiComponentsServiceProxy.prototype.sendAndGetSelectedCountries = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetSelectedCountries";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSendAndGetSelectedCountries(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSendAndGetSelectedCountries(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DemoUiComponentsServiceProxy.prototype.processSendAndGetSelectedCountries = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_28 = resultData200; _i < resultData200_28.length; _i++) {
                        var item = resultData200_28[_i];
                        result200.push(NameValueOfString.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param input (optional)
     * @return Success
     */
    DemoUiComponentsServiceProxy.prototype.sendAndGetValue = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetValue?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSendAndGetValue(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSendAndGetValue(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DemoUiComponentsServiceProxy.prototype.processSendAndGetValue = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = StringOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return DemoUiComponentsServiceProxy;
}());
export { DemoUiComponentsServiceProxy };
var DepotLocationsServiceProxy = /** @class */ (function () {
    function DepotLocationsServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param filter (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    DepotLocationsServiceProxy.prototype.getAll = function (filter, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DepotLocations/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DepotLocationsServiceProxy.prototype.processGetAll = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PagedResultDtoOfGetDepotLocationForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    DepotLocationsServiceProxy.prototype.getDepotLocationForView = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DepotLocations/GetDepotLocationForView?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDepotLocationForView(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDepotLocationForView(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DepotLocationsServiceProxy.prototype.processGetDepotLocationForView = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetDepotLocationForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    DepotLocationsServiceProxy.prototype.getDepotLocationForEdit = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DepotLocations/GetDepotLocationForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDepotLocationForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDepotLocationForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DepotLocationsServiceProxy.prototype.processGetDepotLocationForEdit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetDepotLocationForEditOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    DepotLocationsServiceProxy.prototype.createOrEdit = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DepotLocations/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DepotLocationsServiceProxy.prototype.processCreateOrEdit = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return DepotLocationsServiceProxy;
}());
export { DepotLocationsServiceProxy };
var DepotToDepotSettingsServiceProxy = /** @class */ (function () {
    function DepotToDepotSettingsServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param depotLocationNameFilter (optional)
     * @param depotLocationName2Filter (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    DepotToDepotSettingsServiceProxy.prototype.getAll = function (depotLocationNameFilter, depotLocationName2Filter, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DepotToDepotSettings/GetAll?";
        if (depotLocationNameFilter !== undefined)
            url_ += "DepotLocationNameFilter=" + encodeURIComponent("" + depotLocationNameFilter) + "&";
        if (depotLocationName2Filter !== undefined)
            url_ += "DepotLocationName2Filter=" + encodeURIComponent("" + depotLocationName2Filter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DepotToDepotSettingsServiceProxy.prototype.processGetAll = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PagedResultDtoOfGetDepotToDepotSettingForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    DepotToDepotSettingsServiceProxy.prototype.getDepotToDepotSettingForView = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DepotToDepotSettings/GetDepotToDepotSettingForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDepotToDepotSettingForView(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDepotToDepotSettingForView(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DepotToDepotSettingsServiceProxy.prototype.processGetDepotToDepotSettingForView = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetDepotToDepotSettingForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    DepotToDepotSettingsServiceProxy.prototype.getDepotToDepotSettingForEdit = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DepotToDepotSettings/GetDepotToDepotSettingForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDepotToDepotSettingForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDepotToDepotSettingForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DepotToDepotSettingsServiceProxy.prototype.processGetDepotToDepotSettingForEdit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetDepotToDepotSettingForEditOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    DepotToDepotSettingsServiceProxy.prototype.createOrEdit = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DepotToDepotSettings/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DepotToDepotSettingsServiceProxy.prototype.processCreateOrEdit = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    DepotToDepotSettingsServiceProxy.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DepotToDepotSettings/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDelete(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDelete(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DepotToDepotSettingsServiceProxy.prototype.processDelete = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param depotLocationNameFilter (optional)
     * @param depotLocationName2Filter (optional)
     * @return Success
     */
    DepotToDepotSettingsServiceProxy.prototype.getDepotToDepotSettingsToExcel = function (depotLocationNameFilter, depotLocationName2Filter) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DepotToDepotSettings/GetDepotToDepotSettingsToExcel?";
        if (depotLocationNameFilter !== undefined)
            url_ += "DepotLocationNameFilter=" + encodeURIComponent("" + depotLocationNameFilter) + "&";
        if (depotLocationName2Filter !== undefined)
            url_ += "DepotLocationName2Filter=" + encodeURIComponent("" + depotLocationName2Filter) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDepotToDepotSettingsToExcel(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDepotToDepotSettingsToExcel(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DepotToDepotSettingsServiceProxy.prototype.processGetDepotToDepotSettingsToExcel = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = FileDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return DepotToDepotSettingsServiceProxy;
}());
export { DepotToDepotSettingsServiceProxy };
var DriverDaysWorkedServiceProxy = /** @class */ (function () {
    function DriverDaysWorkedServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param filter (optional)
     * @param driverFilter (optional)
     * @param maxPeriodDateFilter (optional)
     * @param minPeriodDateFilter (optional)
     * @param depotLocationIdFilter (optional)
     * @param ownDepotFilter (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    DriverDaysWorkedServiceProxy.prototype.getAll = function (filter, driverFilter, maxPeriodDateFilter, minPeriodDateFilter, depotLocationIdFilter, ownDepotFilter, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DriverDaysWorked/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (driverFilter !== undefined)
            url_ += "DriverFilter=" + encodeURIComponent("" + driverFilter) + "&";
        if (maxPeriodDateFilter !== undefined)
            url_ += "MaxPeriodDateFilter=" + encodeURIComponent(maxPeriodDateFilter ? "" + maxPeriodDateFilter.toJSON() : "") + "&";
        if (minPeriodDateFilter !== undefined)
            url_ += "MinPeriodDateFilter=" + encodeURIComponent(minPeriodDateFilter ? "" + minPeriodDateFilter.toJSON() : "") + "&";
        if (depotLocationIdFilter !== undefined)
            url_ += "DepotLocationIdFilter=" + encodeURIComponent("" + depotLocationIdFilter) + "&";
        if (ownDepotFilter === null)
            throw new Error("The parameter 'ownDepotFilter' cannot be null.");
        else if (ownDepotFilter !== undefined)
            url_ += "OwnDepotFilter=" + encodeURIComponent("" + ownDepotFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DriverDaysWorkedServiceProxy.prototype.processGetAll = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PagedResultDtoOfGetDriverDaysWorkedForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    DriverDaysWorkedServiceProxy.prototype.getDriverDaysWorkedForView = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DriverDaysWorked/GetDriverDaysWorkedForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDriverDaysWorkedForView(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDriverDaysWorkedForView(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DriverDaysWorkedServiceProxy.prototype.processGetDriverDaysWorkedForView = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetDriverDaysWorkedForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    DriverDaysWorkedServiceProxy.prototype.getDriverDaysWorkedForEdit = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DriverDaysWorked/GetDriverDaysWorkedForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDriverDaysWorkedForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDriverDaysWorkedForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DriverDaysWorkedServiceProxy.prototype.processGetDriverDaysWorkedForEdit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetDriverDaysWorkedForEditOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    DriverDaysWorkedServiceProxy.prototype.createOrEdit = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DriverDaysWorked/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DriverDaysWorkedServiceProxy.prototype.processCreateOrEdit = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    DriverDaysWorkedServiceProxy.prototype.bulkEdit = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DriverDaysWorked/BulkEdit";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processBulkEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processBulkEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DriverDaysWorkedServiceProxy.prototype.processBulkEdit = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    DriverDaysWorkedServiceProxy.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DriverDaysWorked/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDelete(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDelete(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DriverDaysWorkedServiceProxy.prototype.processDelete = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param filter (optional)
     * @param driverFilter (optional)
     * @param maxPeriodDateFilter (optional)
     * @param minPeriodDateFilter (optional)
     * @param depotLocationIdFilter (optional)
     * @param ownDepotFilter (optional)
     * @return Success
     */
    DriverDaysWorkedServiceProxy.prototype.getDriverDaysWorkedToExcel = function (filter, driverFilter, maxPeriodDateFilter, minPeriodDateFilter, depotLocationIdFilter, ownDepotFilter) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DriverDaysWorked/GetDriverDaysWorkedToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (driverFilter !== undefined)
            url_ += "DriverFilter=" + encodeURIComponent("" + driverFilter) + "&";
        if (maxPeriodDateFilter !== undefined)
            url_ += "MaxPeriodDateFilter=" + encodeURIComponent(maxPeriodDateFilter ? "" + maxPeriodDateFilter.toJSON() : "") + "&";
        if (minPeriodDateFilter !== undefined)
            url_ += "MinPeriodDateFilter=" + encodeURIComponent(minPeriodDateFilter ? "" + minPeriodDateFilter.toJSON() : "") + "&";
        if (depotLocationIdFilter !== undefined)
            url_ += "DepotLocationIdFilter=" + encodeURIComponent("" + depotLocationIdFilter) + "&";
        if (ownDepotFilter === null)
            throw new Error("The parameter 'ownDepotFilter' cannot be null.");
        else if (ownDepotFilter !== undefined)
            url_ += "OwnDepotFilter=" + encodeURIComponent("" + ownDepotFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDriverDaysWorkedToExcel(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDriverDaysWorkedToExcel(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DriverDaysWorkedServiceProxy.prototype.processGetDriverDaysWorkedToExcel = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = FileDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param filter (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    DriverDaysWorkedServiceProxy.prototype.getAllDepotLocationForLookupTable = function (filter, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DriverDaysWorked/GetAllDepotLocationForLookupTable?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAllDepotLocationForLookupTable(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAllDepotLocationForLookupTable(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DriverDaysWorkedServiceProxy.prototype.processGetAllDepotLocationForLookupTable = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PagedResultDtoOfDriverDaysWorkedDepotLocationLookupTableDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    DriverDaysWorkedServiceProxy.prototype.importFromExcelCurrentPeriod = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DriverDaysWorked/ImportFromExcelCurrentPeriod";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = body;
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "multipart/form-data",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processImportFromExcelCurrentPeriod(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processImportFromExcelCurrentPeriod(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DriverDaysWorkedServiceProxy.prototype.processImportFromExcelCurrentPeriod = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    DriverDaysWorkedServiceProxy.prototype.importFromExcelPreviousPeriod = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DriverDaysWorked/ImportFromExcelPreviousPeriod";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = body;
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "multipart/form-data",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processImportFromExcelPreviousPeriod(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processImportFromExcelPreviousPeriod(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DriverDaysWorkedServiceProxy.prototype.processImportFromExcelPreviousPeriod = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return DriverDaysWorkedServiceProxy;
}());
export { DriverDaysWorkedServiceProxy };
var EditionServiceProxy = /** @class */ (function () {
    function EditionServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @return Success
     */
    EditionServiceProxy.prototype.getEditions = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Edition/GetEditions";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetEditions(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetEditions(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    EditionServiceProxy.prototype.processGetEditions = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = ListResultDtoOfEditionListDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    EditionServiceProxy.prototype.getEditionForEdit = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Edition/GetEditionForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetEditionForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetEditionForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    EditionServiceProxy.prototype.processGetEditionForEdit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetEditionEditOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    EditionServiceProxy.prototype.createEdition = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Edition/CreateEdition";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateEdition(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateEdition(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    EditionServiceProxy.prototype.processCreateEdition = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    EditionServiceProxy.prototype.updateEdition = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Edition/UpdateEdition";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateEdition(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateEdition(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    EditionServiceProxy.prototype.processUpdateEdition = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    EditionServiceProxy.prototype.deleteEdition = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Edition/DeleteEdition?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteEdition(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteEdition(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    EditionServiceProxy.prototype.processDeleteEdition = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    EditionServiceProxy.prototype.moveTenantsToAnotherEdition = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Edition/MoveTenantsToAnotherEdition";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processMoveTenantsToAnotherEdition(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processMoveTenantsToAnotherEdition(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    EditionServiceProxy.prototype.processMoveTenantsToAnotherEdition = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param selectedEditionId (optional)
     * @param addAllItem (optional)
     * @param onlyFreeItems (optional)
     * @return Success
     */
    EditionServiceProxy.prototype.getEditionComboboxItems = function (selectedEditionId, addAllItem, onlyFreeItems) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Edition/GetEditionComboboxItems?";
        if (selectedEditionId !== undefined)
            url_ += "selectedEditionId=" + encodeURIComponent("" + selectedEditionId) + "&";
        if (addAllItem === null)
            throw new Error("The parameter 'addAllItem' cannot be null.");
        else if (addAllItem !== undefined)
            url_ += "addAllItem=" + encodeURIComponent("" + addAllItem) + "&";
        if (onlyFreeItems === null)
            throw new Error("The parameter 'onlyFreeItems' cannot be null.");
        else if (onlyFreeItems !== undefined)
            url_ += "onlyFreeItems=" + encodeURIComponent("" + onlyFreeItems) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetEditionComboboxItems(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetEditionComboboxItems(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    EditionServiceProxy.prototype.processGetEditionComboboxItems = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_29 = resultData200; _i < resultData200_29.length; _i++) {
                        var item = resultData200_29[_i];
                        result200.push(SubscribableEditionComboboxItemDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param editionId (optional)
     * @return Success
     */
    EditionServiceProxy.prototype.getTenantCount = function (editionId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Edition/GetTenantCount?";
        if (editionId === null)
            throw new Error("The parameter 'editionId' cannot be null.");
        else if (editionId !== undefined)
            url_ += "editionId=" + encodeURIComponent("" + editionId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetTenantCount(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetTenantCount(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    EditionServiceProxy.prototype.processGetTenantCount = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return EditionServiceProxy;
}());
export { EditionServiceProxy };
var EventDetailsServiceProxy = /** @class */ (function () {
    function EventDetailsServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param filter (optional)
     * @param statusFilter (optional)
     * @param descriptionFilter (optional)
     * @param removeTransactionFilter (optional)
     * @param eventGroupDescriptionFilter (optional)
     * @param courierNameFilter (optional)
     * @param exceptionConsignmentStatusIdFilter (optional)
     * @param zendeskQueryTypeFilter (optional)
     * @param consignmentDashboardCategoryFilter (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    EventDetailsServiceProxy.prototype.getAll = function (filter, statusFilter, descriptionFilter, removeTransactionFilter, eventGroupDescriptionFilter, courierNameFilter, exceptionConsignmentStatusIdFilter, zendeskQueryTypeFilter, consignmentDashboardCategoryFilter, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/EventDetails/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (removeTransactionFilter !== undefined)
            url_ += "RemoveTransactionFilter=" + encodeURIComponent("" + removeTransactionFilter) + "&";
        if (eventGroupDescriptionFilter !== undefined)
            url_ += "EventGroupDescriptionFilter=" + encodeURIComponent("" + eventGroupDescriptionFilter) + "&";
        if (courierNameFilter !== undefined)
            url_ += "CourierNameFilter=" + encodeURIComponent("" + courierNameFilter) + "&";
        if (exceptionConsignmentStatusIdFilter !== undefined)
            url_ += "ExceptionConsignmentStatusIdFilter=" + encodeURIComponent("" + exceptionConsignmentStatusIdFilter) + "&";
        if (zendeskQueryTypeFilter !== undefined)
            url_ += "ZendeskQueryTypeFilter=" + encodeURIComponent("" + zendeskQueryTypeFilter) + "&";
        if (consignmentDashboardCategoryFilter !== undefined)
            url_ += "ConsignmentDashboardCategoryFilter=" + encodeURIComponent("" + consignmentDashboardCategoryFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    EventDetailsServiceProxy.prototype.processGetAll = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PagedResultDtoOfGetEventDetailForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    EventDetailsServiceProxy.prototype.getEventDetailForView = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/EventDetails/GetEventDetailForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetEventDetailForView(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetEventDetailForView(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    EventDetailsServiceProxy.prototype.processGetEventDetailForView = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetEventDetailForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    EventDetailsServiceProxy.prototype.getEventDetailForEdit = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/EventDetails/GetEventDetailForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetEventDetailForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetEventDetailForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    EventDetailsServiceProxy.prototype.processGetEventDetailForEdit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetEventDetailForEditOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    EventDetailsServiceProxy.prototype.createOrEdit = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/EventDetails/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    EventDetailsServiceProxy.prototype.processCreateOrEdit = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    EventDetailsServiceProxy.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/EventDetails/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDelete(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDelete(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    EventDetailsServiceProxy.prototype.processDelete = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param filter (optional)
     * @param statusFilter (optional)
     * @param descriptionFilter (optional)
     * @param removeTransactionFilter (optional)
     * @param eventGroupDescriptionFilter (optional)
     * @param courierNameFilter (optional)
     * @param exceptionConsignmentStatusIdFilter (optional)
     * @param zendeskQueryTypeFilter (optional)
     * @param consignmentDashboardCategoryFilter (optional)
     * @return Success
     */
    EventDetailsServiceProxy.prototype.getEventDetailsToExcel = function (filter, statusFilter, descriptionFilter, removeTransactionFilter, eventGroupDescriptionFilter, courierNameFilter, exceptionConsignmentStatusIdFilter, zendeskQueryTypeFilter, consignmentDashboardCategoryFilter) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/EventDetails/GetEventDetailsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (removeTransactionFilter !== undefined)
            url_ += "RemoveTransactionFilter=" + encodeURIComponent("" + removeTransactionFilter) + "&";
        if (eventGroupDescriptionFilter !== undefined)
            url_ += "EventGroupDescriptionFilter=" + encodeURIComponent("" + eventGroupDescriptionFilter) + "&";
        if (courierNameFilter !== undefined)
            url_ += "CourierNameFilter=" + encodeURIComponent("" + courierNameFilter) + "&";
        if (exceptionConsignmentStatusIdFilter !== undefined)
            url_ += "ExceptionConsignmentStatusIdFilter=" + encodeURIComponent("" + exceptionConsignmentStatusIdFilter) + "&";
        if (zendeskQueryTypeFilter !== undefined)
            url_ += "ZendeskQueryTypeFilter=" + encodeURIComponent("" + zendeskQueryTypeFilter) + "&";
        if (consignmentDashboardCategoryFilter !== undefined)
            url_ += "ConsignmentDashboardCategoryFilter=" + encodeURIComponent("" + consignmentDashboardCategoryFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetEventDetailsToExcel(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetEventDetailsToExcel(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    EventDetailsServiceProxy.prototype.processGetEventDetailsToExcel = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = FileDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    EventDetailsServiceProxy.prototype.importFromExcel = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/EventDetails/ImportFromExcel";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = body;
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "multipart/form-data",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processImportFromExcel(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processImportFromExcel(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    EventDetailsServiceProxy.prototype.processImportFromExcel = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return EventDetailsServiceProxy;
}());
export { EventDetailsServiceProxy };
var EventGroupsServiceProxy = /** @class */ (function () {
    function EventGroupsServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param filter (optional)
     * @param isExceptionFilter (optional)
     * @param exceptionTypeFilter (optional)
     * @param resultingConsignmentStatusIdFilter (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    EventGroupsServiceProxy.prototype.getAll = function (filter, isExceptionFilter, exceptionTypeFilter, resultingConsignmentStatusIdFilter, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/EventGroups/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (isExceptionFilter !== undefined)
            url_ += "IsExceptionFilter=" + encodeURIComponent("" + isExceptionFilter) + "&";
        if (exceptionTypeFilter !== undefined)
            url_ += "ExceptionTypeFilter=" + encodeURIComponent("" + exceptionTypeFilter) + "&";
        if (resultingConsignmentStatusIdFilter !== undefined)
            url_ += "ResultingConsignmentStatusIdFilter=" + encodeURIComponent("" + resultingConsignmentStatusIdFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    EventGroupsServiceProxy.prototype.processGetAll = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PagedResultDtoOfGetEventGroupForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    EventGroupsServiceProxy.prototype.getEventGroupForView = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/EventGroups/GetEventGroupForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetEventGroupForView(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetEventGroupForView(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    EventGroupsServiceProxy.prototype.processGetEventGroupForView = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetEventGroupForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    EventGroupsServiceProxy.prototype.getEventGroupForEdit = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/EventGroups/GetEventGroupForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetEventGroupForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetEventGroupForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    EventGroupsServiceProxy.prototype.processGetEventGroupForEdit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetEventGroupForEditOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    EventGroupsServiceProxy.prototype.createOrEdit = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/EventGroups/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    EventGroupsServiceProxy.prototype.processCreateOrEdit = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    EventGroupsServiceProxy.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/EventGroups/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDelete(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDelete(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    EventGroupsServiceProxy.prototype.processDelete = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param filter (optional)
     * @param isExceptionFilter (optional)
     * @param exceptionTypeFilter (optional)
     * @param resultingConsignmentStatusIdFilter (optional)
     * @return Success
     */
    EventGroupsServiceProxy.prototype.getEventGroupsToExcel = function (filter, isExceptionFilter, exceptionTypeFilter, resultingConsignmentStatusIdFilter) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/EventGroups/GetEventGroupsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (isExceptionFilter !== undefined)
            url_ += "IsExceptionFilter=" + encodeURIComponent("" + isExceptionFilter) + "&";
        if (exceptionTypeFilter !== undefined)
            url_ += "ExceptionTypeFilter=" + encodeURIComponent("" + exceptionTypeFilter) + "&";
        if (resultingConsignmentStatusIdFilter !== undefined)
            url_ += "ResultingConsignmentStatusIdFilter=" + encodeURIComponent("" + resultingConsignmentStatusIdFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetEventGroupsToExcel(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetEventGroupsToExcel(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    EventGroupsServiceProxy.prototype.processGetEventGroupsToExcel = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = FileDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    EventGroupsServiceProxy.prototype.importFromExcel = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/EventGroups/ImportFromExcel";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = body;
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "multipart/form-data",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processImportFromExcel(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processImportFromExcel(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    EventGroupsServiceProxy.prototype.processImportFromExcel = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return EventGroupsServiceProxy;
}());
export { EventGroupsServiceProxy };
var ExternalVendorsServiceProxy = /** @class */ (function () {
    function ExternalVendorsServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param filter (optional)
     * @param nameFilter (optional)
     * @param d365EntityFilter (optional)
     * @param clientGroupNameFilter (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    ExternalVendorsServiceProxy.prototype.getAll = function (filter, nameFilter, d365EntityFilter, clientGroupNameFilter, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ExternalVendors/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (d365EntityFilter !== undefined)
            url_ += "D365EntityFilter=" + encodeURIComponent("" + d365EntityFilter) + "&";
        if (clientGroupNameFilter !== undefined)
            url_ += "ClientGroupNameFilter=" + encodeURIComponent("" + clientGroupNameFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ExternalVendorsServiceProxy.prototype.processGetAll = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PagedResultDtoOfGetExternalVendorForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    ExternalVendorsServiceProxy.prototype.getExternalVendorForView = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ExternalVendors/GetExternalVendorForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetExternalVendorForView(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetExternalVendorForView(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ExternalVendorsServiceProxy.prototype.processGetExternalVendorForView = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetExternalVendorForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    ExternalVendorsServiceProxy.prototype.getExternalVendorForEdit = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ExternalVendors/GetExternalVendorForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetExternalVendorForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetExternalVendorForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ExternalVendorsServiceProxy.prototype.processGetExternalVendorForEdit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetExternalVendorForEditOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ExternalVendorsServiceProxy.prototype.createOrEdit = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ExternalVendors/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ExternalVendorsServiceProxy.prototype.processCreateOrEdit = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    ExternalVendorsServiceProxy.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ExternalVendors/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDelete(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDelete(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ExternalVendorsServiceProxy.prototype.processDelete = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param filter (optional)
     * @param nameFilter (optional)
     * @param d365EntityFilter (optional)
     * @param clientGroupNameFilter (optional)
     * @return Success
     */
    ExternalVendorsServiceProxy.prototype.getExternalVendorsToExcel = function (filter, nameFilter, d365EntityFilter, clientGroupNameFilter) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ExternalVendors/GetExternalVendorsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (d365EntityFilter !== undefined)
            url_ += "D365EntityFilter=" + encodeURIComponent("" + d365EntityFilter) + "&";
        if (clientGroupNameFilter !== undefined)
            url_ += "ClientGroupNameFilter=" + encodeURIComponent("" + clientGroupNameFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetExternalVendorsToExcel(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetExternalVendorsToExcel(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ExternalVendorsServiceProxy.prototype.processGetExternalVendorsToExcel = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = FileDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    ExternalVendorsServiceProxy.prototype.getAllClientGroupForTableDropdown = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ExternalVendors/GetAllClientGroupForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAllClientGroupForTableDropdown(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAllClientGroupForTableDropdown(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ExternalVendorsServiceProxy.prototype.processGetAllClientGroupForTableDropdown = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_30 = resultData200; _i < resultData200_30.length; _i++) {
                        var item = resultData200_30[_i];
                        result200.push(ExternalVendorClientGroupLookupTableDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ExternalVendorsServiceProxy.prototype.importFromExcel = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ExternalVendors/ImportFromExcel";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = body;
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "multipart/form-data",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processImportFromExcel(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processImportFromExcel(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ExternalVendorsServiceProxy.prototype.processImportFromExcel = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return ExternalVendorsServiceProxy;
}());
export { ExternalVendorsServiceProxy };
var FileOperationsServiceProxy = /** @class */ (function () {
    function FileOperationsServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param permission (optional)
     * @param fileName (optional)
     * @return Success
     */
    FileOperationsServiceProxy.prototype.getFileContentByPermission = function (permission, fileName) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/FileOperations/GetFileContentByPermission?";
        if (permission !== undefined)
            url_ += "permission=" + encodeURIComponent("" + permission) + "&";
        if (fileName !== undefined)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetFileContentByPermission(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetFileContentByPermission(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    FileOperationsServiceProxy.prototype.processGetFileContentByPermission = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = FileDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return FileOperationsServiceProxy;
}());
export { FileOperationsServiceProxy };
var FinanceServiceProxy = /** @class */ (function () {
    function FinanceServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param consignmentId (optional)
     * @return Success
     */
    FinanceServiceProxy.prototype.getFinanceInfoByConsignmentId = function (consignmentId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Finance/GetFinanceInfoByConsignmentId?";
        if (consignmentId === null)
            throw new Error("The parameter 'consignmentId' cannot be null.");
        else if (consignmentId !== undefined)
            url_ += "consignmentId=" + encodeURIComponent("" + consignmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetFinanceInfoByConsignmentId(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetFinanceInfoByConsignmentId(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    FinanceServiceProxy.prototype.processGetFinanceInfoByConsignmentId = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetFinanceInfoDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    FinanceServiceProxy.prototype.updateFinanceInfo = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Finance/UpdateFinanceInfo";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateFinanceInfo(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateFinanceInfo(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    FinanceServiceProxy.prototype.processUpdateFinanceInfo = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return FinanceServiceProxy;
}());
export { FinanceServiceProxy };
var FriendshipServiceProxy = /** @class */ (function () {
    function FriendshipServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param body (optional)
     * @return Success
     */
    FriendshipServiceProxy.prototype.createFriendshipRequest = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Friendship/CreateFriendshipRequest";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateFriendshipRequest(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateFriendshipRequest(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    FriendshipServiceProxy.prototype.processCreateFriendshipRequest = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = FriendDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    FriendshipServiceProxy.prototype.createFriendshipRequestByUserName = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Friendship/CreateFriendshipRequestByUserName";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateFriendshipRequestByUserName(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateFriendshipRequestByUserName(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    FriendshipServiceProxy.prototype.processCreateFriendshipRequestByUserName = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = FriendDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    FriendshipServiceProxy.prototype.blockUser = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Friendship/BlockUser";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processBlockUser(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processBlockUser(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    FriendshipServiceProxy.prototype.processBlockUser = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    FriendshipServiceProxy.prototype.unblockUser = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Friendship/UnblockUser";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUnblockUser(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUnblockUser(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    FriendshipServiceProxy.prototype.processUnblockUser = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    FriendshipServiceProxy.prototype.acceptFriendshipRequest = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Friendship/AcceptFriendshipRequest";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processAcceptFriendshipRequest(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processAcceptFriendshipRequest(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    FriendshipServiceProxy.prototype.processAcceptFriendshipRequest = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return FriendshipServiceProxy;
}());
export { FriendshipServiceProxy };
var HostDashboardServiceProxy = /** @class */ (function () {
    function HostDashboardServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param startDate (optional)
     * @param endDate (optional)
     * @return Success
     */
    HostDashboardServiceProxy.prototype.getTopStatsData = function (startDate, endDate) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/HostDashboard/GetTopStatsData?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetTopStatsData(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetTopStatsData(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    HostDashboardServiceProxy.prototype.processGetTopStatsData = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = TopStatsData.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    HostDashboardServiceProxy.prototype.getRecentTenantsData = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/HostDashboard/GetRecentTenantsData";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetRecentTenantsData(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetRecentTenantsData(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    HostDashboardServiceProxy.prototype.processGetRecentTenantsData = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetRecentTenantsOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    HostDashboardServiceProxy.prototype.getSubscriptionExpiringTenantsData = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/HostDashboard/GetSubscriptionExpiringTenantsData";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetSubscriptionExpiringTenantsData(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetSubscriptionExpiringTenantsData(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    HostDashboardServiceProxy.prototype.processGetSubscriptionExpiringTenantsData = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetExpiringTenantsOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param startDate (optional)
     * @param endDate (optional)
     * @return Success
     */
    HostDashboardServiceProxy.prototype.getIncomeStatistics = function (incomeStatisticsDateInterval, startDate, endDate) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/HostDashboard/GetIncomeStatistics?";
        if (incomeStatisticsDateInterval === undefined || incomeStatisticsDateInterval === null)
            throw new Error("The parameter 'incomeStatisticsDateInterval' must be defined and cannot be null.");
        else
            url_ += "IncomeStatisticsDateInterval=" + encodeURIComponent("" + incomeStatisticsDateInterval) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetIncomeStatistics(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetIncomeStatistics(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    HostDashboardServiceProxy.prototype.processGetIncomeStatistics = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetIncomeStatisticsDataOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param startDate (optional)
     * @param endDate (optional)
     * @return Success
     */
    HostDashboardServiceProxy.prototype.getEditionTenantStatistics = function (startDate, endDate) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/HostDashboard/GetEditionTenantStatistics?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetEditionTenantStatistics(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetEditionTenantStatistics(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    HostDashboardServiceProxy.prototype.processGetEditionTenantStatistics = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetEditionTenantStatisticsOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return HostDashboardServiceProxy;
}());
export { HostDashboardServiceProxy };
var HostSettingsServiceProxy = /** @class */ (function () {
    function HostSettingsServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @return Success
     */
    HostSettingsServiceProxy.prototype.getAllSettings = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/HostSettings/GetAllSettings";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAllSettings(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAllSettings(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    HostSettingsServiceProxy.prototype.processGetAllSettings = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = HostSettingsEditDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    HostSettingsServiceProxy.prototype.updateAllSettings = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/HostSettings/UpdateAllSettings";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateAllSettings(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateAllSettings(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    HostSettingsServiceProxy.prototype.processUpdateAllSettings = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    HostSettingsServiceProxy.prototype.sendTestEmail = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/HostSettings/SendTestEmail";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSendTestEmail(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSendTestEmail(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    HostSettingsServiceProxy.prototype.processSendTestEmail = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return HostSettingsServiceProxy;
}());
export { HostSettingsServiceProxy };
var InstallServiceProxy = /** @class */ (function () {
    function InstallServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param body (optional)
     * @return Success
     */
    InstallServiceProxy.prototype.setup = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Install/Setup";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSetup(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSetup(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    InstallServiceProxy.prototype.processSetup = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    InstallServiceProxy.prototype.getAppSettingsJson = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Install/GetAppSettingsJson";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAppSettingsJson(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAppSettingsJson(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    InstallServiceProxy.prototype.processGetAppSettingsJson = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = AppSettingsJsonDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    InstallServiceProxy.prototype.checkDatabase = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Install/CheckDatabase";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCheckDatabase(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCheckDatabase(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    InstallServiceProxy.prototype.processCheckDatabase = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = CheckDatabaseOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return InstallServiceProxy;
}());
export { InstallServiceProxy };
var InvoiceServiceProxy = /** @class */ (function () {
    function InvoiceServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param id (optional)
     * @return Success
     */
    InvoiceServiceProxy.prototype.getInvoiceInfo = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Invoice/GetInvoiceInfo?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetInvoiceInfo(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetInvoiceInfo(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    InvoiceServiceProxy.prototype.processGetInvoiceInfo = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = InvoiceDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    InvoiceServiceProxy.prototype.createInvoice = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Invoice/CreateInvoice";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateInvoice(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateInvoice(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    InvoiceServiceProxy.prototype.processCreateInvoice = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return InvoiceServiceProxy;
}());
export { InvoiceServiceProxy };
var LanguageServiceProxy = /** @class */ (function () {
    function LanguageServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @return Success
     */
    LanguageServiceProxy.prototype.getLanguages = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Language/GetLanguages";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetLanguages(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetLanguages(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    LanguageServiceProxy.prototype.processGetLanguages = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetLanguagesOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    LanguageServiceProxy.prototype.getLanguageForEdit = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Language/GetLanguageForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetLanguageForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetLanguageForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    LanguageServiceProxy.prototype.processGetLanguageForEdit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetLanguageForEditOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    LanguageServiceProxy.prototype.createOrUpdateLanguage = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Language/CreateOrUpdateLanguage";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrUpdateLanguage(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrUpdateLanguage(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    LanguageServiceProxy.prototype.processCreateOrUpdateLanguage = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    LanguageServiceProxy.prototype.deleteLanguage = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Language/DeleteLanguage?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteLanguage(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteLanguage(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    LanguageServiceProxy.prototype.processDeleteLanguage = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    LanguageServiceProxy.prototype.setDefaultLanguage = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Language/SetDefaultLanguage";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSetDefaultLanguage(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSetDefaultLanguage(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    LanguageServiceProxy.prototype.processSetDefaultLanguage = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @param sorting (optional)
     * @param baseLanguageName (optional)
     * @param targetValueFilter (optional)
     * @param filterText (optional)
     * @return Success
     */
    LanguageServiceProxy.prototype.getLanguageTexts = function (maxResultCount, skipCount, sorting, sourceName, baseLanguageName, targetLanguageName, targetValueFilter, filterText) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Language/GetLanguageTexts?";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (sourceName === undefined || sourceName === null)
            throw new Error("The parameter 'sourceName' must be defined and cannot be null.");
        else
            url_ += "SourceName=" + encodeURIComponent("" + sourceName) + "&";
        if (baseLanguageName !== undefined)
            url_ += "BaseLanguageName=" + encodeURIComponent("" + baseLanguageName) + "&";
        if (targetLanguageName === undefined || targetLanguageName === null)
            throw new Error("The parameter 'targetLanguageName' must be defined and cannot be null.");
        else
            url_ += "TargetLanguageName=" + encodeURIComponent("" + targetLanguageName) + "&";
        if (targetValueFilter !== undefined)
            url_ += "TargetValueFilter=" + encodeURIComponent("" + targetValueFilter) + "&";
        if (filterText !== undefined)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetLanguageTexts(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetLanguageTexts(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    LanguageServiceProxy.prototype.processGetLanguageTexts = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PagedResultDtoOfLanguageTextListDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    LanguageServiceProxy.prototype.updateLanguageText = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Language/UpdateLanguageText";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateLanguageText(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateLanguageText(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    LanguageServiceProxy.prototype.processUpdateLanguageText = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return LanguageServiceProxy;
}());
export { LanguageServiceProxy };
var LoadsServiceProxy = /** @class */ (function () {
    function LoadsServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param body (optional)
     * @return Success
     */
    LoadsServiceProxy.prototype.getAll = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Loads/GetAll";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    LoadsServiceProxy.prototype.processGetAll = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PagedResultDtoOfGetLoadForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    LoadsServiceProxy.prototype.getLoadForView = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Loads/GetLoadForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetLoadForView(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetLoadForView(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    LoadsServiceProxy.prototype.processGetLoadForView = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetLoadForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    LoadsServiceProxy.prototype.getLoadForEdit = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Loads/GetLoadForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetLoadForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetLoadForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    LoadsServiceProxy.prototype.processGetLoadForEdit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetLoadForEditOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    LoadsServiceProxy.prototype.validate = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Loads/Validate";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processValidate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processValidate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    LoadsServiceProxy.prototype.processValidate = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = ValidateLoadsOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    LoadsServiceProxy.prototype.updateStatus = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Loads/UpdateStatus";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateStatus(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateStatus(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    LoadsServiceProxy.prototype.processUpdateStatus = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetLoadForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    LoadsServiceProxy.prototype.createOrEdit = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Loads/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    LoadsServiceProxy.prototype.processCreateOrEdit = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    LoadsServiceProxy.prototype.createRTSLoadManifest = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Loads/CreateRTSLoadManifest";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateRTSLoadManifest(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateRTSLoadManifest(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    LoadsServiceProxy.prototype.processCreateRTSLoadManifest = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = FileDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    LoadsServiceProxy.prototype.createRTSLoadLabel = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Loads/CreateRTSLoadLabel";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateRTSLoadLabel(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateRTSLoadLabel(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    LoadsServiceProxy.prototype.processCreateRTSLoadLabel = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = FileDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param input (optional)
     * @return Success
     */
    LoadsServiceProxy.prototype.exportToExcelRTS = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Loads/ExportToExcelRTS?";
        if (input === null)
            throw new Error("The parameter 'input' cannot be null.");
        else if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processExportToExcelRTS(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processExportToExcelRTS(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    LoadsServiceProxy.prototype.processExportToExcelRTS = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = FileDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return LoadsServiceProxy;
}());
export { LoadsServiceProxy };
var LocationDetailsServiceProxy = /** @class */ (function () {
    function LocationDetailsServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param filter (optional)
     * @param latitudeFilter (optional)
     * @param longitudeFilter (optional)
     * @param stateFilter (optional)
     * @param postalCodeFilter (optional)
     * @param businessNameFilter (optional)
     * @param addressLine1Filter (optional)
     * @param addressLine2Filter (optional)
     * @param suburbFilter (optional)
     * @param storeIdFilter (optional)
     * @param jsonDataFilter (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    LocationDetailsServiceProxy.prototype.getAll = function (filter, latitudeFilter, longitudeFilter, stateFilter, postalCodeFilter, businessNameFilter, addressLine1Filter, addressLine2Filter, suburbFilter, storeIdFilter, jsonDataFilter, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/LocationDetails/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (latitudeFilter !== undefined)
            url_ += "LatitudeFilter=" + encodeURIComponent("" + latitudeFilter) + "&";
        if (longitudeFilter !== undefined)
            url_ += "LongitudeFilter=" + encodeURIComponent("" + longitudeFilter) + "&";
        if (stateFilter !== undefined)
            url_ += "StateFilter=" + encodeURIComponent("" + stateFilter) + "&";
        if (postalCodeFilter !== undefined)
            url_ += "PostalCodeFilter=" + encodeURIComponent("" + postalCodeFilter) + "&";
        if (businessNameFilter !== undefined)
            url_ += "BusinessNameFilter=" + encodeURIComponent("" + businessNameFilter) + "&";
        if (addressLine1Filter !== undefined)
            url_ += "AddressLine1Filter=" + encodeURIComponent("" + addressLine1Filter) + "&";
        if (addressLine2Filter !== undefined)
            url_ += "AddressLine2Filter=" + encodeURIComponent("" + addressLine2Filter) + "&";
        if (suburbFilter !== undefined)
            url_ += "SuburbFilter=" + encodeURIComponent("" + suburbFilter) + "&";
        if (storeIdFilter !== undefined)
            url_ += "StoreIdFilter=" + encodeURIComponent("" + storeIdFilter) + "&";
        if (jsonDataFilter !== undefined)
            url_ += "JsonDataFilter=" + encodeURIComponent("" + jsonDataFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    LocationDetailsServiceProxy.prototype.processGetAll = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PagedResultDtoOfGetLocationDetailForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    LocationDetailsServiceProxy.prototype.getLocationDetailForView = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/LocationDetails/GetLocationDetailForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetLocationDetailForView(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetLocationDetailForView(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    LocationDetailsServiceProxy.prototype.processGetLocationDetailForView = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetLocationDetailForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    LocationDetailsServiceProxy.prototype.getLocationDetailForEdit = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/LocationDetails/GetLocationDetailForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetLocationDetailForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetLocationDetailForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    LocationDetailsServiceProxy.prototype.processGetLocationDetailForEdit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetLocationDetailForEditOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    LocationDetailsServiceProxy.prototype.createOrEdit = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/LocationDetails/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    LocationDetailsServiceProxy.prototype.processCreateOrEdit = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    LocationDetailsServiceProxy.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/LocationDetails/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDelete(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDelete(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    LocationDetailsServiceProxy.prototype.processDelete = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return LocationDetailsServiceProxy;
}());
export { LocationDetailsServiceProxy };
var LocationsServiceProxy = /** @class */ (function () {
    function LocationsServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param filter (optional)
     * @param idFilter (optional)
     * @param fullAddressFilter (optional)
     * @param hasGeocodeFilter (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    LocationsServiceProxy.prototype.getAll = function (filter, idFilter, fullAddressFilter, hasGeocodeFilter, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Locations/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (idFilter !== undefined)
            idFilter && idFilter.forEach(function (item) { url_ += "IdFilter=" + encodeURIComponent("" + item) + "&"; });
        if (fullAddressFilter !== undefined)
            url_ += "FullAddressFilter=" + encodeURIComponent("" + fullAddressFilter) + "&";
        if (hasGeocodeFilter !== undefined)
            url_ += "HasGeocodeFilter=" + encodeURIComponent("" + hasGeocodeFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    LocationsServiceProxy.prototype.processGetAll = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PagedResultDtoOfGetLocationForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    LocationsServiceProxy.prototype.getLocationForView = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Locations/GetLocationForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetLocationForView(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetLocationForView(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    LocationsServiceProxy.prototype.processGetLocationForView = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetLocationForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    LocationsServiceProxy.prototype.getLocationForEdit = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Locations/GetLocationForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetLocationForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetLocationForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    LocationsServiceProxy.prototype.processGetLocationForEdit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetLocationForEditOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param consignmentId (optional)
     * @param body (optional)
     * @return Success
     */
    LocationsServiceProxy.prototype.createOrEdit = function (consignmentId, body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Locations/CreateOrEdit?";
        if (consignmentId !== undefined)
            url_ += "consignmentId=" + encodeURIComponent("" + consignmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    LocationsServiceProxy.prototype.processCreateOrEdit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    LocationsServiceProxy.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Locations/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDelete(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDelete(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    LocationsServiceProxy.prototype.processDelete = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param filter (optional)
     * @param fullAddressFilter (optional)
     * @param hasGeocodeFilter (optional)
     * @return Success
     */
    LocationsServiceProxy.prototype.getLocationsToExcel = function (filter, fullAddressFilter, hasGeocodeFilter) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Locations/GetLocationsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (fullAddressFilter !== undefined)
            url_ += "FullAddressFilter=" + encodeURIComponent("" + fullAddressFilter) + "&";
        if (hasGeocodeFilter !== undefined)
            url_ += "HasGeocodeFilter=" + encodeURIComponent("" + hasGeocodeFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetLocationsToExcel(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetLocationsToExcel(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    LocationsServiceProxy.prototype.processGetLocationsToExcel = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = FileDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param state (optional)
     * @param hasGeocode (optional)
     * @return Success
     */
    LocationsServiceProxy.prototype.getLocationForGeocoding = function (state, hasGeocode) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Locations/GetLocationForGeocoding?";
        if (state !== undefined)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (hasGeocode === null)
            throw new Error("The parameter 'hasGeocode' cannot be null.");
        else if (hasGeocode !== undefined)
            url_ += "HasGeocode=" + encodeURIComponent("" + hasGeocode) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetLocationForGeocoding(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetLocationForGeocoding(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    LocationsServiceProxy.prototype.processGetLocationForGeocoding = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetAllLocationForGeocodeOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    LocationsServiceProxy.prototype.ignoreGeocoding = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Locations/IgnoreGeocoding?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processIgnoreGeocoding(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processIgnoreGeocoding(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    LocationsServiceProxy.prototype.processIgnoreGeocoding = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    LocationsServiceProxy.prototype.resubmitAllForGeocoding = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Locations/ResubmitAllForGeocoding";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processResubmitAllForGeocoding(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processResubmitAllForGeocoding(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    LocationsServiceProxy.prototype.processResubmitAllForGeocoding = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    LocationsServiceProxy.prototype.importFromExcel = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Locations/ImportFromExcel";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = body;
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "multipart/form-data",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processImportFromExcel(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processImportFromExcel(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    LocationsServiceProxy.prototype.processImportFromExcel = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return LocationsServiceProxy;
}());
export { LocationsServiceProxy };
var LocationSettingsServiceProxy = /** @class */ (function () {
    function LocationSettingsServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param filter (optional)
     * @param postcodeFilter (optional)
     * @param suburbFilter (optional)
     * @param maxLeadTimeFilter (optional)
     * @param minLeadTimeFilter (optional)
     * @param carrierCodeFilter (optional)
     * @param depotLocationNameFilter (optional)
     * @param territoryFilter (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    LocationSettingsServiceProxy.prototype.getAll = function (filter, postcodeFilter, suburbFilter, maxLeadTimeFilter, minLeadTimeFilter, carrierCodeFilter, depotLocationNameFilter, territoryFilter, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/LocationSettings/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (postcodeFilter !== undefined)
            url_ += "PostcodeFilter=" + encodeURIComponent("" + postcodeFilter) + "&";
        if (suburbFilter !== undefined)
            url_ += "SuburbFilter=" + encodeURIComponent("" + suburbFilter) + "&";
        if (maxLeadTimeFilter !== undefined)
            url_ += "MaxLeadTimeFilter=" + encodeURIComponent("" + maxLeadTimeFilter) + "&";
        if (minLeadTimeFilter !== undefined)
            url_ += "MinLeadTimeFilter=" + encodeURIComponent("" + minLeadTimeFilter) + "&";
        if (carrierCodeFilter !== undefined)
            url_ += "CarrierCodeFilter=" + encodeURIComponent("" + carrierCodeFilter) + "&";
        if (depotLocationNameFilter !== undefined)
            url_ += "DepotLocationNameFilter=" + encodeURIComponent("" + depotLocationNameFilter) + "&";
        if (territoryFilter !== undefined)
            territoryFilter && territoryFilter.forEach(function (item) { url_ += "TerritoryFilter=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    LocationSettingsServiceProxy.prototype.processGetAll = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PagedResultDtoOfGetLocationSettingForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    LocationSettingsServiceProxy.prototype.getLocationSettingForView = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/LocationSettings/GetLocationSettingForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetLocationSettingForView(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetLocationSettingForView(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    LocationSettingsServiceProxy.prototype.processGetLocationSettingForView = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetLocationSettingForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    LocationSettingsServiceProxy.prototype.getLocationSettingForEdit = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/LocationSettings/GetLocationSettingForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetLocationSettingForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetLocationSettingForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    LocationSettingsServiceProxy.prototype.processGetLocationSettingForEdit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetLocationSettingForEditOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    LocationSettingsServiceProxy.prototype.createOrEdit = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/LocationSettings/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    LocationSettingsServiceProxy.prototype.processCreateOrEdit = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param postcode (optional)
     * @param suburb (optional)
     * @return Success
     */
    LocationSettingsServiceProxy.prototype.getExistingLocationSetting = function (postcode, suburb) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/LocationSettings/GetExistingLocationSetting?";
        if (postcode === null)
            throw new Error("The parameter 'postcode' cannot be null.");
        else if (postcode !== undefined)
            url_ += "postcode=" + encodeURIComponent("" + postcode) + "&";
        if (suburb !== undefined)
            url_ += "suburb=" + encodeURIComponent("" + suburb) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetExistingLocationSetting(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetExistingLocationSetting(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    LocationSettingsServiceProxy.prototype.processGetExistingLocationSetting = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = LocationSetting.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    LocationSettingsServiceProxy.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/LocationSettings/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDelete(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDelete(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    LocationSettingsServiceProxy.prototype.processDelete = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param filter (optional)
     * @param postcodeFilter (optional)
     * @param suburbFilter (optional)
     * @param maxLeadTimeFilter (optional)
     * @param minLeadTimeFilter (optional)
     * @param carrierCodeFilter (optional)
     * @param depotLocationNameFilter (optional)
     * @param territoryFilter (optional)
     * @return Success
     */
    LocationSettingsServiceProxy.prototype.getLocationSettingsToExcel = function (filter, postcodeFilter, suburbFilter, maxLeadTimeFilter, minLeadTimeFilter, carrierCodeFilter, depotLocationNameFilter, territoryFilter) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/LocationSettings/GetLocationSettingsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (postcodeFilter !== undefined)
            url_ += "PostcodeFilter=" + encodeURIComponent("" + postcodeFilter) + "&";
        if (suburbFilter !== undefined)
            url_ += "SuburbFilter=" + encodeURIComponent("" + suburbFilter) + "&";
        if (maxLeadTimeFilter !== undefined)
            url_ += "MaxLeadTimeFilter=" + encodeURIComponent("" + maxLeadTimeFilter) + "&";
        if (minLeadTimeFilter !== undefined)
            url_ += "MinLeadTimeFilter=" + encodeURIComponent("" + minLeadTimeFilter) + "&";
        if (carrierCodeFilter !== undefined)
            url_ += "CarrierCodeFilter=" + encodeURIComponent("" + carrierCodeFilter) + "&";
        if (depotLocationNameFilter !== undefined)
            url_ += "DepotLocationNameFilter=" + encodeURIComponent("" + depotLocationNameFilter) + "&";
        if (territoryFilter !== undefined)
            territoryFilter && territoryFilter.forEach(function (item) { url_ += "TerritoryFilter=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetLocationSettingsToExcel(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetLocationSettingsToExcel(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    LocationSettingsServiceProxy.prototype.processGetLocationSettingsToExcel = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = FileDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    LocationSettingsServiceProxy.prototype.importFromExcel = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/LocationSettings/ImportFromExcel";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = body;
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "multipart/form-data",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processImportFromExcel(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processImportFromExcel(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    LocationSettingsServiceProxy.prototype.processImportFromExcel = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return LocationSettingsServiceProxy;
}());
export { LocationSettingsServiceProxy };
var ManifestServiceProxy = /** @class */ (function () {
    function ManifestServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param body (optional)
     * @return Success
     */
    ManifestServiceProxy.prototype.createManifestWithConsignments = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Manifest/CreateManifestWithConsignments";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateManifestWithConsignments(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateManifestWithConsignments(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ManifestServiceProxy.prototype.processCreateManifestWithConsignments = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = CreateManifestWithConsignmentsOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ManifestServiceProxy.prototype.packConsignments = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Manifest/PackConsignments";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processPackConsignments(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processPackConsignments(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ManifestServiceProxy.prototype.processPackConsignments = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = CreateManifestWithConsignmentsOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return ManifestServiceProxy;
}());
export { ManifestServiceProxy };
var ManifestFileRecordsServiceProxy = /** @class */ (function () {
    function ManifestFileRecordsServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param connoteNumberFilter (optional)
     * @param clientIdFilter (optional)
     * @param asJsonStringFilter (optional)
     * @param statusFilter (optional)
     * @param manifestFileFileNameFilter (optional)
     * @param consignmentStatusDescriptionFilter (optional)
     * @param maxUpdatedAtFilter (optional)
     * @param minUpdatedAtFilter (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    ManifestFileRecordsServiceProxy.prototype.getAll = function (connoteNumberFilter, clientIdFilter, asJsonStringFilter, statusFilter, manifestFileFileNameFilter, consignmentStatusDescriptionFilter, maxUpdatedAtFilter, minUpdatedAtFilter, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ManifestFileRecords/GetAll?";
        if (connoteNumberFilter !== undefined)
            url_ += "ConnoteNumberFilter=" + encodeURIComponent("" + connoteNumberFilter) + "&";
        if (clientIdFilter === null)
            throw new Error("The parameter 'clientIdFilter' cannot be null.");
        else if (clientIdFilter !== undefined)
            url_ += "ClientIdFilter=" + encodeURIComponent("" + clientIdFilter) + "&";
        if (asJsonStringFilter !== undefined)
            url_ += "AsJsonStringFilter=" + encodeURIComponent("" + asJsonStringFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (manifestFileFileNameFilter !== undefined)
            url_ += "ManifestFileFileNameFilter=" + encodeURIComponent("" + manifestFileFileNameFilter) + "&";
        if (consignmentStatusDescriptionFilter !== undefined)
            url_ += "ConsignmentStatusDescriptionFilter=" + encodeURIComponent("" + consignmentStatusDescriptionFilter) + "&";
        if (maxUpdatedAtFilter !== undefined)
            url_ += "MaxUpdatedAtFilter=" + encodeURIComponent(maxUpdatedAtFilter ? "" + maxUpdatedAtFilter.toJSON() : "") + "&";
        if (minUpdatedAtFilter !== undefined)
            url_ += "MinUpdatedAtFilter=" + encodeURIComponent(minUpdatedAtFilter ? "" + minUpdatedAtFilter.toJSON() : "") + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ManifestFileRecordsServiceProxy.prototype.processGetAll = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PagedResultDtoOfGetManifestFileRecordForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    ManifestFileRecordsServiceProxy.prototype.getManifestFileRecordForView = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ManifestFileRecords/GetManifestFileRecordForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetManifestFileRecordForView(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetManifestFileRecordForView(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ManifestFileRecordsServiceProxy.prototype.processGetManifestFileRecordForView = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetManifestFileRecordForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    ManifestFileRecordsServiceProxy.prototype.getManifestFileRecordForEdit = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ManifestFileRecords/GetManifestFileRecordForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetManifestFileRecordForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetManifestFileRecordForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ManifestFileRecordsServiceProxy.prototype.processGetManifestFileRecordForEdit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetManifestFileRecordForEditOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    ManifestFileRecordsServiceProxy.prototype.revalidateAll = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ManifestFileRecords/RevalidateAll";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processRevalidateAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processRevalidateAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ManifestFileRecordsServiceProxy.prototype.processRevalidateAll = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ManifestFileRecordsServiceProxy.prototype.update = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ManifestFileRecords/Update";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ManifestFileRecordsServiceProxy.prototype.processUpdate = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param connoteNumberFilter (optional)
     * @param asJsonStringFilter (optional)
     * @param statusFilter (optional)
     * @param clientIdFilter (optional)
     * @param manifestFileFileNameFilter (optional)
     * @param consignmentStatusDescriptionFilter (optional)
     * @param maxUpdatedAtFilter (optional)
     * @param minUpdatedAtFilter (optional)
     * @return Success
     */
    ManifestFileRecordsServiceProxy.prototype.getManifestFileRecordsToExcel = function (connoteNumberFilter, asJsonStringFilter, statusFilter, clientIdFilter, manifestFileFileNameFilter, consignmentStatusDescriptionFilter, maxUpdatedAtFilter, minUpdatedAtFilter) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ManifestFileRecords/GetManifestFileRecordsToExcel?";
        if (connoteNumberFilter !== undefined)
            url_ += "ConnoteNumberFilter=" + encodeURIComponent("" + connoteNumberFilter) + "&";
        if (asJsonStringFilter !== undefined)
            url_ += "AsJsonStringFilter=" + encodeURIComponent("" + asJsonStringFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (clientIdFilter === null)
            throw new Error("The parameter 'clientIdFilter' cannot be null.");
        else if (clientIdFilter !== undefined)
            url_ += "ClientIdFilter=" + encodeURIComponent("" + clientIdFilter) + "&";
        if (manifestFileFileNameFilter !== undefined)
            url_ += "ManifestFileFileNameFilter=" + encodeURIComponent("" + manifestFileFileNameFilter) + "&";
        if (consignmentStatusDescriptionFilter !== undefined)
            url_ += "ConsignmentStatusDescriptionFilter=" + encodeURIComponent("" + consignmentStatusDescriptionFilter) + "&";
        if (maxUpdatedAtFilter !== undefined)
            url_ += "MaxUpdatedAtFilter=" + encodeURIComponent(maxUpdatedAtFilter ? "" + maxUpdatedAtFilter.toJSON() : "") + "&";
        if (minUpdatedAtFilter !== undefined)
            url_ += "MinUpdatedAtFilter=" + encodeURIComponent(minUpdatedAtFilter ? "" + minUpdatedAtFilter.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetManifestFileRecordsToExcel(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetManifestFileRecordsToExcel(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ManifestFileRecordsServiceProxy.prototype.processGetManifestFileRecordsToExcel = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = FileDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param filter (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    ManifestFileRecordsServiceProxy.prototype.getAllManifestFileForLookupTable = function (filter, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ManifestFileRecords/GetAllManifestFileForLookupTable?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAllManifestFileForLookupTable(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAllManifestFileForLookupTable(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ManifestFileRecordsServiceProxy.prototype.processGetAllManifestFileForLookupTable = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PagedResultDtoOfManifestFileLookupTableDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return ManifestFileRecordsServiceProxy;
}());
export { ManifestFileRecordsServiceProxy };
var ManifestFilesServiceProxy = /** @class */ (function () {
    function ManifestFilesServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param body (optional)
     * @return Success
     */
    ManifestFilesServiceProxy.prototype.getAll = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ManifestFiles/GetAll";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ManifestFilesServiceProxy.prototype.processGetAll = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PagedResultDtoOfGetManifestFileForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param filter (optional)
     * @param fileNameFilter (optional)
     * @param maxImportedAtFilter (optional)
     * @param minImportedAtFilter (optional)
     * @param importLogFilter (optional)
     * @param clientIdFilter (optional)
     * @param clientGroupNameFilter (optional)
     * @return Success
     */
    ManifestFilesServiceProxy.prototype.getManifestFilesToExcel = function (filter, fileNameFilter, maxImportedAtFilter, minImportedAtFilter, importLogFilter, clientIdFilter, clientGroupNameFilter) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ManifestFiles/GetManifestFilesToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (fileNameFilter !== undefined)
            fileNameFilter && fileNameFilter.forEach(function (item) { url_ += "FileNameFilter=" + encodeURIComponent("" + item) + "&"; });
        if (maxImportedAtFilter !== undefined)
            url_ += "MaxImportedAtFilter=" + encodeURIComponent(maxImportedAtFilter ? "" + maxImportedAtFilter.toJSON() : "") + "&";
        if (minImportedAtFilter !== undefined)
            url_ += "MinImportedAtFilter=" + encodeURIComponent(minImportedAtFilter ? "" + minImportedAtFilter.toJSON() : "") + "&";
        if (importLogFilter !== undefined)
            url_ += "ImportLogFilter=" + encodeURIComponent("" + importLogFilter) + "&";
        if (clientIdFilter !== undefined)
            clientIdFilter && clientIdFilter.forEach(function (item) { url_ += "ClientIdFilter=" + encodeURIComponent("" + item) + "&"; });
        if (clientGroupNameFilter !== undefined)
            clientGroupNameFilter && clientGroupNameFilter.forEach(function (item) { url_ += "ClientGroupNameFilter=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetManifestFilesToExcel(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetManifestFilesToExcel(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ManifestFilesServiceProxy.prototype.processGetManifestFilesToExcel = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = FileDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param searchTerm (optional)
     * @param resultCount (optional)
     * @return Success
     */
    ManifestFilesServiceProxy.prototype.getManifestFiles = function (searchTerm, resultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ManifestFiles/GetManifestFiles?";
        if (searchTerm !== undefined)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (resultCount === null)
            throw new Error("The parameter 'resultCount' cannot be null.");
        else if (resultCount !== undefined)
            url_ += "resultCount=" + encodeURIComponent("" + resultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetManifestFiles(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetManifestFiles(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ManifestFilesServiceProxy.prototype.processGetManifestFiles = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_31 = resultData200; _i < resultData200_31.length; _i++) {
                        var item = resultData200_31[_i];
                        result200.push(NameValueOfInt32.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ManifestFilesServiceProxy.prototype.uploadManifestFiles = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ManifestFiles/UploadManifestFiles";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = body;
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "multipart/form-data",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUploadManifestFiles(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUploadManifestFiles(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ManifestFilesServiceProxy.prototype.processUploadManifestFiles = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = NameValueOfInt32.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return ManifestFilesServiceProxy;
}());
export { ManifestFilesServiceProxy };
var ManifestTemplatesServiceProxy = /** @class */ (function () {
    function ManifestTemplatesServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param filter (optional)
     * @param nameFilter (optional)
     * @param rEQColumnsInOrderFilter (optional)
     * @param lNEColumnsInOrderFilter (optional)
     * @param jsonSchemaFilter (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    ManifestTemplatesServiceProxy.prototype.getAll = function (filter, nameFilter, rEQColumnsInOrderFilter, lNEColumnsInOrderFilter, jsonSchemaFilter, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ManifestTemplates/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (rEQColumnsInOrderFilter !== undefined)
            url_ += "REQColumnsInOrderFilter=" + encodeURIComponent("" + rEQColumnsInOrderFilter) + "&";
        if (lNEColumnsInOrderFilter !== undefined)
            url_ += "LNEColumnsInOrderFilter=" + encodeURIComponent("" + lNEColumnsInOrderFilter) + "&";
        if (jsonSchemaFilter !== undefined)
            url_ += "JsonSchemaFilter=" + encodeURIComponent("" + jsonSchemaFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ManifestTemplatesServiceProxy.prototype.processGetAll = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PagedResultDtoOfGetManifestTemplateForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    ManifestTemplatesServiceProxy.prototype.getManifestTemplateForView = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ManifestTemplates/GetManifestTemplateForView?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetManifestTemplateForView(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetManifestTemplateForView(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ManifestTemplatesServiceProxy.prototype.processGetManifestTemplateForView = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetManifestTemplateForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return ManifestTemplatesServiceProxy;
}());
export { ManifestTemplatesServiceProxy };
var MidasScanServiceProxy = /** @class */ (function () {
    function MidasScanServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param body (optional)
     * @return Success
     */
    MidasScanServiceProxy.prototype.midasBarcodeScans = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/MidasScan/MidasBarcodeScans";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processMidasBarcodeScans(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processMidasBarcodeScans(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    MidasScanServiceProxy.prototype.processMidasBarcodeScans = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = CreateBarcodeHistoryDepoScansOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    MidasScanServiceProxy.prototype.getEligibleScanTypes = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/MidasScan/GetEligibleScanTypes";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetEligibleScanTypes(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetEligibleScanTypes(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    MidasScanServiceProxy.prototype.processGetEligibleScanTypes = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetEligibleScanTypesDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param batchId (optional)
     * @return Success
     */
    MidasScanServiceProxy.prototype.midasBarcodeScanEndTime = function (batchId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/MidasScan/MidasBarcodeScanEndTime?";
        if (batchId === null)
            throw new Error("The parameter 'batchId' cannot be null.");
        else if (batchId !== undefined)
            url_ += "batchId=" + encodeURIComponent("" + batchId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processMidasBarcodeScanEndTime(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processMidasBarcodeScanEndTime(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    MidasScanServiceProxy.prototype.processMidasBarcodeScanEndTime = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param packageId (optional)
     * @return Success
     */
    MidasScanServiceProxy.prototype.getShippingLabel = function (packageId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/MidasScan/GetShippingLabel?";
        if (packageId === null)
            throw new Error("The parameter 'packageId' cannot be null.");
        else if (packageId !== undefined)
            url_ += "packageId=" + encodeURIComponent("" + packageId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetShippingLabel(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetShippingLabel(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    MidasScanServiceProxy.prototype.processGetShippingLabel = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param packageId (optional)
     * @return Success
     */
    MidasScanServiceProxy.prototype.getPdfLabelFile = function (packageId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/MidasScan/GetPdfLabelFile?";
        if (packageId === null)
            throw new Error("The parameter 'packageId' cannot be null.");
        else if (packageId !== undefined)
            url_ += "packageId=" + encodeURIComponent("" + packageId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetPdfLabelFile(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetPdfLabelFile(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    MidasScanServiceProxy.prototype.processGetPdfLabelFile = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = FileDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    MidasScanServiceProxy.prototype.updateRTSProductQuantity = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/MidasScan/UpdateRTSProductQuantity";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateRTSProductQuantity(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateRTSProductQuantity(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    MidasScanServiceProxy.prototype.processUpdateRTSProductQuantity = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = UpdateBarcodeScanProductQuantityOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    MidasScanServiceProxy.prototype.createConsignmentInEden = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/MidasScan/CreateConsignmentInEden";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateConsignmentInEden(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateConsignmentInEden(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    MidasScanServiceProxy.prototype.processCreateConsignmentInEden = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = CreateBarcodeHistoryDepoScansOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return MidasScanServiceProxy;
}());
export { MidasScanServiceProxy };
var MiscChargesServiceProxy = /** @class */ (function () {
    function MiscChargesServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param filter (optional)
     * @param ownDepotFilter (optional)
     * @param maxChargeDateFilter (optional)
     * @param minChargeDateFilter (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    MiscChargesServiceProxy.prototype.getAll = function (filter, ownDepotFilter, maxChargeDateFilter, minChargeDateFilter, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/MiscCharges/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (ownDepotFilter === null)
            throw new Error("The parameter 'ownDepotFilter' cannot be null.");
        else if (ownDepotFilter !== undefined)
            url_ += "OwnDepotFilter=" + encodeURIComponent("" + ownDepotFilter) + "&";
        if (maxChargeDateFilter !== undefined)
            url_ += "MaxChargeDateFilter=" + encodeURIComponent(maxChargeDateFilter ? "" + maxChargeDateFilter.toJSON() : "") + "&";
        if (minChargeDateFilter !== undefined)
            url_ += "MinChargeDateFilter=" + encodeURIComponent(minChargeDateFilter ? "" + minChargeDateFilter.toJSON() : "") + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    MiscChargesServiceProxy.prototype.processGetAll = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PagedResultDtoOfGetMiscChargeForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    MiscChargesServiceProxy.prototype.getMiscChargeForView = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/MiscCharges/GetMiscChargeForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetMiscChargeForView(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetMiscChargeForView(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    MiscChargesServiceProxy.prototype.processGetMiscChargeForView = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetMiscChargeForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    MiscChargesServiceProxy.prototype.getMiscChargeForEdit = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/MiscCharges/GetMiscChargeForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetMiscChargeForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetMiscChargeForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    MiscChargesServiceProxy.prototype.processGetMiscChargeForEdit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetMiscChargeForEditOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    MiscChargesServiceProxy.prototype.createOrEdit = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/MiscCharges/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    MiscChargesServiceProxy.prototype.processCreateOrEdit = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    MiscChargesServiceProxy.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/MiscCharges/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDelete(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDelete(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    MiscChargesServiceProxy.prototype.processDelete = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param filter (optional)
     * @param ownDepotFilter (optional)
     * @param maxChargeDateFilter (optional)
     * @param minChargeDateFilter (optional)
     * @return Success
     */
    MiscChargesServiceProxy.prototype.getMiscChargesToExcel = function (filter, ownDepotFilter, maxChargeDateFilter, minChargeDateFilter) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/MiscCharges/GetMiscChargesToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (ownDepotFilter === null)
            throw new Error("The parameter 'ownDepotFilter' cannot be null.");
        else if (ownDepotFilter !== undefined)
            url_ += "OwnDepotFilter=" + encodeURIComponent("" + ownDepotFilter) + "&";
        if (maxChargeDateFilter !== undefined)
            url_ += "MaxChargeDateFilter=" + encodeURIComponent(maxChargeDateFilter ? "" + maxChargeDateFilter.toJSON() : "") + "&";
        if (minChargeDateFilter !== undefined)
            url_ += "MinChargeDateFilter=" + encodeURIComponent(minChargeDateFilter ? "" + minChargeDateFilter.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetMiscChargesToExcel(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetMiscChargesToExcel(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    MiscChargesServiceProxy.prototype.processGetMiscChargesToExcel = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = FileDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    MiscChargesServiceProxy.prototype.importFromExcel = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/MiscCharges/ImportFromExcel";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = body;
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "multipart/form-data",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processImportFromExcel(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processImportFromExcel(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    MiscChargesServiceProxy.prototype.processImportFromExcel = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return MiscChargesServiceProxy;
}());
export { MiscChargesServiceProxy };
var MiscCostChargeTypesServiceProxy = /** @class */ (function () {
    function MiscCostChargeTypesServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param filter (optional)
     * @param nameFilter (optional)
     * @param miscChargeTypeFilter (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    MiscCostChargeTypesServiceProxy.prototype.getAll = function (filter, nameFilter, miscChargeTypeFilter, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/MiscCostChargeTypes/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (miscChargeTypeFilter === null)
            throw new Error("The parameter 'miscChargeTypeFilter' cannot be null.");
        else if (miscChargeTypeFilter !== undefined)
            url_ += "MiscChargeTypeFilter=" + encodeURIComponent("" + miscChargeTypeFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    MiscCostChargeTypesServiceProxy.prototype.processGetAll = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PagedResultDtoOfGetMiscCostChargeTypeForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    MiscCostChargeTypesServiceProxy.prototype.getMiscCostChargeTypeForView = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/MiscCostChargeTypes/GetMiscCostChargeTypeForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetMiscCostChargeTypeForView(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetMiscCostChargeTypeForView(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    MiscCostChargeTypesServiceProxy.prototype.processGetMiscCostChargeTypeForView = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetMiscCostChargeTypeForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    MiscCostChargeTypesServiceProxy.prototype.getMiscCostChargeTypeForEdit = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/MiscCostChargeTypes/GetMiscCostChargeTypeForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetMiscCostChargeTypeForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetMiscCostChargeTypeForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    MiscCostChargeTypesServiceProxy.prototype.processGetMiscCostChargeTypeForEdit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetMiscCostChargeTypeForEditOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    MiscCostChargeTypesServiceProxy.prototype.createOrEdit = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/MiscCostChargeTypes/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    MiscCostChargeTypesServiceProxy.prototype.processCreateOrEdit = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    MiscCostChargeTypesServiceProxy.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/MiscCostChargeTypes/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDelete(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDelete(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    MiscCostChargeTypesServiceProxy.prototype.processDelete = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return MiscCostChargeTypesServiceProxy;
}());
export { MiscCostChargeTypesServiceProxy };
var NotificationServiceProxy = /** @class */ (function () {
    function NotificationServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param state (optional)
     * @param startDate (optional)
     * @param endDate (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    NotificationServiceProxy.prototype.getUserNotifications = function (state, startDate, endDate, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Notification/GetUserNotifications?";
        if (state === null)
            throw new Error("The parameter 'state' cannot be null.");
        else if (state !== undefined)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetUserNotifications(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetUserNotifications(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    NotificationServiceProxy.prototype.processGetUserNotifications = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetNotificationsOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    NotificationServiceProxy.prototype.setAllNotificationsAsRead = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Notification/SetAllNotificationsAsRead";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSetAllNotificationsAsRead(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSetAllNotificationsAsRead(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    NotificationServiceProxy.prototype.processSetAllNotificationsAsRead = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    NotificationServiceProxy.prototype.setNotificationAsRead = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Notification/SetNotificationAsRead";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSetNotificationAsRead(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSetNotificationAsRead(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    NotificationServiceProxy.prototype.processSetNotificationAsRead = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    NotificationServiceProxy.prototype.getNotificationSettings = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Notification/GetNotificationSettings";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetNotificationSettings(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetNotificationSettings(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    NotificationServiceProxy.prototype.processGetNotificationSettings = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetNotificationSettingsOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    NotificationServiceProxy.prototype.updateNotificationSettings = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Notification/UpdateNotificationSettings";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateNotificationSettings(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateNotificationSettings(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    NotificationServiceProxy.prototype.processUpdateNotificationSettings = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    NotificationServiceProxy.prototype.deleteNotification = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Notification/DeleteNotification?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteNotification(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteNotification(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    NotificationServiceProxy.prototype.processDeleteNotification = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param state (optional)
     * @param startDate (optional)
     * @param endDate (optional)
     * @return Success
     */
    NotificationServiceProxy.prototype.deleteAllUserNotifications = function (state, startDate, endDate) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Notification/DeleteAllUserNotifications?";
        if (state === null)
            throw new Error("The parameter 'state' cannot be null.");
        else if (state !== undefined)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteAllUserNotifications(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteAllUserNotifications(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    NotificationServiceProxy.prototype.processDeleteAllUserNotifications = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return NotificationServiceProxy;
}());
export { NotificationServiceProxy };
var OrdersServiceProxy = /** @class */ (function () {
    function OrdersServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param body (optional)
     * @return Success
     */
    OrdersServiceProxy.prototype.getAll = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Orders/GetAll";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrdersServiceProxy.prototype.processGetAll = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PagedResultDtoOfGetOrderForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    OrdersServiceProxy.prototype.getCount = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Orders/GetCount";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetCount(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetCount(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrdersServiceProxy.prototype.processGetCount = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param orderId (optional)
     * @param body (optional)
     * @return Success
     */
    OrdersServiceProxy.prototype.changeHeatStatus = function (orderId, body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Orders/ChangeHeatStatus?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processChangeHeatStatus(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processChangeHeatStatus(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrdersServiceProxy.prototype.processChangeHeatStatus = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param orderId (optional)
     * @return Success
     */
    OrdersServiceProxy.prototype.actionOnOrder = function (orderId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Orders/ActionOnOrder?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processActionOnOrder(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processActionOnOrder(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrdersServiceProxy.prototype.processActionOnOrder = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param orderId (optional)
     * @return Success
     */
    OrdersServiceProxy.prototype.undoActionOnOrder = function (orderId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Orders/UndoActionOnOrder?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUndoActionOnOrder(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUndoActionOnOrder(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrdersServiceProxy.prototype.processUndoActionOnOrder = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param orderId (optional)
     * @return Success
     */
    OrdersServiceProxy.prototype.removeFromDashboard = function (orderId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Orders/RemoveFromDashboard?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processRemoveFromDashboard(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processRemoveFromDashboard(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrdersServiceProxy.prototype.processRemoveFromDashboard = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param orderId (optional)
     * @return Success
     */
    OrdersServiceProxy.prototype.undoRemoveFromDashboard = function (orderId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Orders/UndoRemoveFromDashboard?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUndoRemoveFromDashboard(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUndoRemoveFromDashboard(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrdersServiceProxy.prototype.processUndoRemoveFromDashboard = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param brand (optional)
     * @param orderNumber (optional)
     * @param orderId (optional)
     * @return Success
     */
    OrdersServiceProxy.prototype.getOrderForView = function (brand, orderNumber, orderId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Orders/GetOrderForView?";
        if (brand !== undefined)
            url_ += "brand=" + encodeURIComponent("" + brand) + "&";
        if (orderNumber !== undefined)
            url_ += "orderNumber=" + encodeURIComponent("" + orderNumber) + "&";
        if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetOrderForView(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetOrderForView(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrdersServiceProxy.prototype.processGetOrderForView = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetOrderForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param brand (optional)
     * @param orderNumber (optional)
     * @return Success
     */
    OrdersServiceProxy.prototype.getConsignmentSummaryForView = function (brand, orderNumber) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Orders/GetConsignmentSummaryForView?";
        if (brand !== undefined)
            url_ += "brand=" + encodeURIComponent("" + brand) + "&";
        if (orderNumber !== undefined)
            url_ += "orderNumber=" + encodeURIComponent("" + orderNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetConsignmentSummaryForView(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetConsignmentSummaryForView(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrdersServiceProxy.prototype.processGetConsignmentSummaryForView = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_32 = resultData200; _i < resultData200_32.length; _i++) {
                        var item = resultData200_32[_i];
                        result200.push(ConsignmentSummaryDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param searchTerm (optional)
     * @param brand (optional)
     * @return Success
     */
    OrdersServiceProxy.prototype.searchCustomers = function (searchTerm, brand) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Orders/SearchCustomers?";
        if (searchTerm !== undefined)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (brand !== undefined)
            url_ += "brand=" + encodeURIComponent("" + brand) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSearchCustomers(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSearchCustomers(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrdersServiceProxy.prototype.processSearchCustomers = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_33 = resultData200; _i < resultData200_33.length; _i++) {
                        var item = resultData200_33[_i];
                        result200.push(NameValueOfInt32.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return OrdersServiceProxy;
}());
export { OrdersServiceProxy };
var OrdersDashboardServiceProxy = /** @class */ (function () {
    function OrdersDashboardServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @return Success
     */
    OrdersDashboardServiceProxy.prototype.getOrdersSummary = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrdersDashboard/GetOrdersSummary";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetOrdersSummary(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetOrdersSummary(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrdersDashboardServiceProxy.prototype.processGetOrdersSummary = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = OrdersSummaryDashboardOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return OrdersDashboardServiceProxy;
}());
export { OrdersDashboardServiceProxy };
var OrganizationUnitServiceProxy = /** @class */ (function () {
    function OrganizationUnitServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @return Success
     */
    OrganizationUnitServiceProxy.prototype.getOrganizationUnits = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetOrganizationUnits";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetOrganizationUnits(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetOrganizationUnits(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrganizationUnitServiceProxy.prototype.processGetOrganizationUnits = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = ListResultDtoOfOrganizationUnitDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    OrganizationUnitServiceProxy.prototype.getOrganizationUnitUsers = function (id, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetOrganizationUnitUsers?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetOrganizationUnitUsers(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetOrganizationUnitUsers(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrganizationUnitServiceProxy.prototype.processGetOrganizationUnitUsers = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PagedResultDtoOfOrganizationUnitUserListDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    OrganizationUnitServiceProxy.prototype.getOrganizationUnitRoles = function (id, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetOrganizationUnitRoles?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetOrganizationUnitRoles(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetOrganizationUnitRoles(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrganizationUnitServiceProxy.prototype.processGetOrganizationUnitRoles = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PagedResultDtoOfOrganizationUnitRoleListDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    OrganizationUnitServiceProxy.prototype.createOrganizationUnit = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrganizationUnit/CreateOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrganizationUnit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrganizationUnit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrganizationUnitServiceProxy.prototype.processCreateOrganizationUnit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = OrganizationUnitDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    OrganizationUnitServiceProxy.prototype.updateOrganizationUnit = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrganizationUnit/UpdateOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateOrganizationUnit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateOrganizationUnit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrganizationUnitServiceProxy.prototype.processUpdateOrganizationUnit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = OrganizationUnitDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    OrganizationUnitServiceProxy.prototype.moveOrganizationUnit = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrganizationUnit/MoveOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processMoveOrganizationUnit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processMoveOrganizationUnit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrganizationUnitServiceProxy.prototype.processMoveOrganizationUnit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = OrganizationUnitDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    OrganizationUnitServiceProxy.prototype.deleteOrganizationUnit = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrganizationUnit/DeleteOrganizationUnit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteOrganizationUnit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteOrganizationUnit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrganizationUnitServiceProxy.prototype.processDeleteOrganizationUnit = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param userId (optional)
     * @param organizationUnitId (optional)
     * @return Success
     */
    OrganizationUnitServiceProxy.prototype.removeUserFromOrganizationUnit = function (userId, organizationUnitId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrganizationUnit/RemoveUserFromOrganizationUnit?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (organizationUnitId === null)
            throw new Error("The parameter 'organizationUnitId' cannot be null.");
        else if (organizationUnitId !== undefined)
            url_ += "OrganizationUnitId=" + encodeURIComponent("" + organizationUnitId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processRemoveUserFromOrganizationUnit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processRemoveUserFromOrganizationUnit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrganizationUnitServiceProxy.prototype.processRemoveUserFromOrganizationUnit = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param roleId (optional)
     * @param organizationUnitId (optional)
     * @return Success
     */
    OrganizationUnitServiceProxy.prototype.removeRoleFromOrganizationUnit = function (roleId, organizationUnitId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrganizationUnit/RemoveRoleFromOrganizationUnit?";
        if (roleId === null)
            throw new Error("The parameter 'roleId' cannot be null.");
        else if (roleId !== undefined)
            url_ += "RoleId=" + encodeURIComponent("" + roleId) + "&";
        if (organizationUnitId === null)
            throw new Error("The parameter 'organizationUnitId' cannot be null.");
        else if (organizationUnitId !== undefined)
            url_ += "OrganizationUnitId=" + encodeURIComponent("" + organizationUnitId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processRemoveRoleFromOrganizationUnit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processRemoveRoleFromOrganizationUnit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrganizationUnitServiceProxy.prototype.processRemoveRoleFromOrganizationUnit = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    OrganizationUnitServiceProxy.prototype.addUsersToOrganizationUnit = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrganizationUnit/AddUsersToOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processAddUsersToOrganizationUnit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processAddUsersToOrganizationUnit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrganizationUnitServiceProxy.prototype.processAddUsersToOrganizationUnit = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    OrganizationUnitServiceProxy.prototype.addRolesToOrganizationUnit = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrganizationUnit/AddRolesToOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processAddRolesToOrganizationUnit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processAddRolesToOrganizationUnit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrganizationUnitServiceProxy.prototype.processAddRolesToOrganizationUnit = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    OrganizationUnitServiceProxy.prototype.findUsers = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrganizationUnit/FindUsers";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processFindUsers(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processFindUsers(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrganizationUnitServiceProxy.prototype.processFindUsers = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PagedResultDtoOfNameValueDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    OrganizationUnitServiceProxy.prototype.findRoles = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrganizationUnit/FindRoles";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processFindRoles(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processFindRoles(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrganizationUnitServiceProxy.prototype.processFindRoles = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PagedResultDtoOfNameValueDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return OrganizationUnitServiceProxy;
}());
export { OrganizationUnitServiceProxy };
var PackageEventsServiceProxy = /** @class */ (function () {
    function PackageEventsServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param userExceptionTypeDefault (optional)
     * @param body (optional)
     * @return Success
     */
    PackageEventsServiceProxy.prototype.saveEdenPackageEvents = function (userExceptionTypeDefault, body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PackageEvents/SaveEdenPackageEvents?";
        if (userExceptionTypeDefault !== undefined)
            url_ += "UserExceptionTypeDefault=" + encodeURIComponent("" + userExceptionTypeDefault) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSaveEdenPackageEvents(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSaveEdenPackageEvents(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PackageEventsServiceProxy.prototype.processSaveEdenPackageEvents = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return PackageEventsServiceProxy;
}());
export { PackageEventsServiceProxy };
var PackageHistoryServiceProxy = /** @class */ (function () {
    function PackageHistoryServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param packageIdFilter (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    PackageHistoryServiceProxy.prototype.getAll = function (packageIdFilter, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PackageHistory/GetAll?";
        if (packageIdFilter === null)
            throw new Error("The parameter 'packageIdFilter' cannot be null.");
        else if (packageIdFilter !== undefined)
            url_ += "PackageIdFilter=" + encodeURIComponent("" + packageIdFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PackageHistoryServiceProxy.prototype.processGetAll = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PagedResultDtoOfGetPackageHistoryForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return PackageHistoryServiceProxy;
}());
export { PackageHistoryServiceProxy };
var PackagesServiceProxy = /** @class */ (function () {
    function PackagesServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param filter (optional)
     * @param barcodeFilter (optional)
     * @param maxConsignmentIdFilter (optional)
     * @param minConsignmentIdFilter (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    PackagesServiceProxy.prototype.getAll = function (filter, barcodeFilter, maxConsignmentIdFilter, minConsignmentIdFilter, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Packages/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (barcodeFilter !== undefined)
            url_ += "BarcodeFilter=" + encodeURIComponent("" + barcodeFilter) + "&";
        if (maxConsignmentIdFilter !== undefined)
            url_ += "MaxConsignmentIdFilter=" + encodeURIComponent("" + maxConsignmentIdFilter) + "&";
        if (minConsignmentIdFilter !== undefined)
            url_ += "MinConsignmentIdFilter=" + encodeURIComponent("" + minConsignmentIdFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PackagesServiceProxy.prototype.processGetAll = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PagedResultDtoOfGetPackageForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    PackagesServiceProxy.prototype.getPackageForView = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Packages/GetPackageForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetPackageForView(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetPackageForView(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PackagesServiceProxy.prototype.processGetPackageForView = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetPackageForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    PackagesServiceProxy.prototype.getPackageForEdit = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Packages/GetPackageForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetPackageForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetPackageForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PackagesServiceProxy.prototype.processGetPackageForEdit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetPackageForEditOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    PackagesServiceProxy.prototype.createOrEdit = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Packages/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PackagesServiceProxy.prototype.processCreateOrEdit = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    PackagesServiceProxy.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Packages/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDelete(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDelete(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PackagesServiceProxy.prototype.processDelete = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return PackagesServiceProxy;
}());
export { PackagesServiceProxy };
var PackageStatusServiceProxy = /** @class */ (function () {
    function PackageStatusServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param barcode (optional)
     * @return Success
     */
    PackageStatusServiceProxy.prototype.getPackageStatus = function (barcode) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PackageStatus/GetPackageStatus?";
        if (barcode !== undefined)
            url_ += "barcode=" + encodeURIComponent("" + barcode) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetPackageStatus(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetPackageStatus(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PackageStatusServiceProxy.prototype.processGetPackageStatus = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PackageStatusDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return PackageStatusServiceProxy;
}());
export { PackageStatusServiceProxy };
var PackageWeightsServiceProxy = /** @class */ (function () {
    function PackageWeightsServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param filter (optional)
     * @param uomFilter (optional)
     * @param maxWeightFilter (optional)
     * @param minWeightFilter (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    PackageWeightsServiceProxy.prototype.getAll = function (filter, uomFilter, maxWeightFilter, minWeightFilter, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PackageWeights/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (uomFilter !== undefined)
            url_ += "UomFilter=" + encodeURIComponent("" + uomFilter) + "&";
        if (maxWeightFilter !== undefined)
            url_ += "MaxWeightFilter=" + encodeURIComponent("" + maxWeightFilter) + "&";
        if (minWeightFilter !== undefined)
            url_ += "MinWeightFilter=" + encodeURIComponent("" + minWeightFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PackageWeightsServiceProxy.prototype.processGetAll = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PagedResultDtoOfGetPackageWeightForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    PackageWeightsServiceProxy.prototype.getPackageWeightForView = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PackageWeights/GetPackageWeightForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetPackageWeightForView(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetPackageWeightForView(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PackageWeightsServiceProxy.prototype.processGetPackageWeightForView = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetPackageWeightForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    PackageWeightsServiceProxy.prototype.getPackageWeightForEdit = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PackageWeights/GetPackageWeightForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetPackageWeightForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetPackageWeightForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PackageWeightsServiceProxy.prototype.processGetPackageWeightForEdit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetPackageWeightForEditOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    PackageWeightsServiceProxy.prototype.createOrEdit = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PackageWeights/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PackageWeightsServiceProxy.prototype.processCreateOrEdit = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    PackageWeightsServiceProxy.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PackageWeights/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDelete(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDelete(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PackageWeightsServiceProxy.prototype.processDelete = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param filter (optional)
     * @param uomFilter (optional)
     * @param maxWeightFilter (optional)
     * @param minWeightFilter (optional)
     * @return Success
     */
    PackageWeightsServiceProxy.prototype.getPackageWeightsToExcel = function (filter, uomFilter, maxWeightFilter, minWeightFilter) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PackageWeights/GetPackageWeightsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (uomFilter !== undefined)
            url_ += "UomFilter=" + encodeURIComponent("" + uomFilter) + "&";
        if (maxWeightFilter !== undefined)
            url_ += "MaxWeightFilter=" + encodeURIComponent("" + maxWeightFilter) + "&";
        if (minWeightFilter !== undefined)
            url_ += "MinWeightFilter=" + encodeURIComponent("" + minWeightFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetPackageWeightsToExcel(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetPackageWeightsToExcel(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PackageWeightsServiceProxy.prototype.processGetPackageWeightsToExcel = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = FileDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    PackageWeightsServiceProxy.prototype.importFromExcel = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PackageWeights/ImportFromExcel";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = body;
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "multipart/form-data",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processImportFromExcel(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processImportFromExcel(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PackageWeightsServiceProxy.prototype.processImportFromExcel = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return PackageWeightsServiceProxy;
}());
export { PackageWeightsServiceProxy };
var PalletRescheduleServiceProxy = /** @class */ (function () {
    function PalletRescheduleServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param body (optional)
     * @return Success
     */
    PalletRescheduleServiceProxy.prototype.bulkChangeShipDateByPalletIds = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PalletReschedule/BulkChangeShipDateByPalletIds";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processBulkChangeShipDateByPalletIds(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processBulkChangeShipDateByPalletIds(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PalletRescheduleServiceProxy.prototype.processBulkChangeShipDateByPalletIds = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    PalletRescheduleServiceProxy.prototype.validateRescheduleByPalletIds = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PalletReschedule/ValidateRescheduleByPalletIds";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processValidateRescheduleByPalletIds(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processValidateRescheduleByPalletIds(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PalletRescheduleServiceProxy.prototype.processValidateRescheduleByPalletIds = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = BulkPalletValidationResult.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    PalletRescheduleServiceProxy.prototype.changeCarrierToDefault = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PalletReschedule/ChangeCarrierToDefault";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processChangeCarrierToDefault(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processChangeCarrierToDefault(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PalletRescheduleServiceProxy.prototype.processChangeCarrierToDefault = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return PalletRescheduleServiceProxy;
}());
export { PalletRescheduleServiceProxy };
var PalletsServiceProxy = /** @class */ (function () {
    function PalletsServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param body (optional)
     * @return Success
     */
    PalletsServiceProxy.prototype.getAll = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Pallets/GetAll";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PalletsServiceProxy.prototype.processGetAll = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PagedResultDtoOfGetPalletForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    PalletsServiceProxy.prototype.getPalletForView = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Pallets/GetPalletForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetPalletForView(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetPalletForView(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PalletsServiceProxy.prototype.processGetPalletForView = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetPalletForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param palletBarcode (optional)
     * @return Success
     */
    PalletsServiceProxy.prototype.validatePallet = function (palletBarcode) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Pallets/ValidatePallet?";
        if (palletBarcode !== undefined)
            url_ += "palletBarcode=" + encodeURIComponent("" + palletBarcode) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processValidatePallet(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processValidatePallet(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PalletsServiceProxy.prototype.processValidatePallet = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PalletValidationResult.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    PalletsServiceProxy.prototype.getPalletForEdit = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Pallets/GetPalletForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetPalletForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetPalletForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PalletsServiceProxy.prototype.processGetPalletForEdit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetPalletForEditOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    PalletsServiceProxy.prototype.exportForRoutingByPalletId = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Pallets/ExportForRoutingByPalletId";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processExportForRoutingByPalletId(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processExportForRoutingByPalletId(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PalletsServiceProxy.prototype.processExportForRoutingByPalletId = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param palletId (optional)
     * @return Success
     */
    PalletsServiceProxy.prototype.endPallet = function (palletId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Pallets/EndPallet?";
        if (palletId === null)
            throw new Error("The parameter 'palletId' cannot be null.");
        else if (palletId !== undefined)
            url_ += "palletId=" + encodeURIComponent("" + palletId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processEndPallet(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processEndPallet(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PalletsServiceProxy.prototype.processEndPallet = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param packageId (optional)
     * @param palletId (optional)
     * @return Success
     */
    PalletsServiceProxy.prototype.depalletizePackage = function (packageId, palletId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Pallets/DepalletizePackage?";
        if (packageId === null)
            throw new Error("The parameter 'packageId' cannot be null.");
        else if (packageId !== undefined)
            url_ += "packageId=" + encodeURIComponent("" + packageId) + "&";
        if (palletId === null)
            throw new Error("The parameter 'palletId' cannot be null.");
        else if (palletId !== undefined)
            url_ += "palletId=" + encodeURIComponent("" + palletId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDepalletizePackage(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDepalletizePackage(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PalletsServiceProxy.prototype.processDepalletizePackage = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    PalletsServiceProxy.prototype.createOrEdit = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Pallets/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PalletsServiceProxy.prototype.processCreateOrEdit = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    PalletsServiceProxy.prototype.createFromMidasScanner = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Pallets/CreateFromMidasScanner";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateFromMidasScanner(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateFromMidasScanner(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PalletsServiceProxy.prototype.processCreateFromMidasScanner = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetPalletForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    PalletsServiceProxy.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Pallets/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDelete(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDelete(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PalletsServiceProxy.prototype.processDelete = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    PalletsServiceProxy.prototype.getPalletsToExcel = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Pallets/GetPalletsToExcel";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetPalletsToExcel(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetPalletsToExcel(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PalletsServiceProxy.prototype.processGetPalletsToExcel = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = FileDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    PalletsServiceProxy.prototype.printPalletLabel = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Pallets/PrintPalletLabel";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processPrintPalletLabel(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processPrintPalletLabel(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PalletsServiceProxy.prototype.processPrintPalletLabel = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = FileDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    PalletsServiceProxy.prototype.printLabelsOnSatoByPalletIds = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Pallets/PrintLabelsOnSatoByPalletIds";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processPrintLabelsOnSatoByPalletIds(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processPrintLabelsOnSatoByPalletIds(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PalletsServiceProxy.prototype.processPrintLabelsOnSatoByPalletIds = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    PalletsServiceProxy.prototype.resolveZendeskTicketForPallet = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Pallets/ResolveZendeskTicketForPallet";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processResolveZendeskTicketForPallet(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processResolveZendeskTicketForPallet(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PalletsServiceProxy.prototype.processResolveZendeskTicketForPallet = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    PalletsServiceProxy.prototype.getAllNonPalletisedBarcodes = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Pallets/GetAllNonPalletisedBarcodes";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAllNonPalletisedBarcodes(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAllNonPalletisedBarcodes(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PalletsServiceProxy.prototype.processGetAllNonPalletisedBarcodes = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PagedResultDtoOfGetNonPalletisedBarcodesForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    PalletsServiceProxy.prototype.exportNonPalletisedBarcodesToExcel = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Pallets/ExportNonPalletisedBarcodesToExcel";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processExportNonPalletisedBarcodesToExcel(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processExportNonPalletisedBarcodesToExcel(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PalletsServiceProxy.prototype.processExportNonPalletisedBarcodesToExcel = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = FileDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return PalletsServiceProxy;
}());
export { PalletsServiceProxy };
var PalletStatusChangeServiceProxy = /** @class */ (function () {
    function PalletStatusChangeServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param body (optional)
     * @return Success
     */
    PalletStatusChangeServiceProxy.prototype.changeStatusByPalletIds = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PalletStatusChange/ChangeStatusByPalletIds";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processChangeStatusByPalletIds(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processChangeStatusByPalletIds(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PalletStatusChangeServiceProxy.prototype.processChangeStatusByPalletIds = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    PalletStatusChangeServiceProxy.prototype.validateChangeStatusByPalletIds = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PalletStatusChange/ValidateChangeStatusByPalletIds";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processValidateChangeStatusByPalletIds(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processValidateChangeStatusByPalletIds(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PalletStatusChangeServiceProxy.prototype.processValidateChangeStatusByPalletIds = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = BulkPalletValidationResult.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return PalletStatusChangeServiceProxy;
}());
export { PalletStatusChangeServiceProxy };
var PaymentServiceProxy = /** @class */ (function () {
    function PaymentServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param upgradeEditionId (optional)
     * @return Success
     */
    PaymentServiceProxy.prototype.getPaymentInfo = function (upgradeEditionId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Payment/GetPaymentInfo?";
        if (upgradeEditionId !== undefined)
            url_ += "UpgradeEditionId=" + encodeURIComponent("" + upgradeEditionId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetPaymentInfo(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetPaymentInfo(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PaymentServiceProxy.prototype.processGetPaymentInfo = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PaymentInfoDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    PaymentServiceProxy.prototype.createPayment = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Payment/CreatePayment";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreatePayment(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreatePayment(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PaymentServiceProxy.prototype.processCreatePayment = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    PaymentServiceProxy.prototype.cancelPayment = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Payment/CancelPayment";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCancelPayment(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCancelPayment(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PaymentServiceProxy.prototype.processCancelPayment = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    PaymentServiceProxy.prototype.getPaymentHistory = function (sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Payment/GetPaymentHistory?";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetPaymentHistory(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetPaymentHistory(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PaymentServiceProxy.prototype.processGetPaymentHistory = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PagedResultDtoOfSubscriptionPaymentListDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param recurringPaymentsEnabled (optional)
     * @return Success
     */
    PaymentServiceProxy.prototype.getActiveGateways = function (recurringPaymentsEnabled) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Payment/GetActiveGateways?";
        if (recurringPaymentsEnabled !== undefined)
            url_ += "RecurringPaymentsEnabled=" + encodeURIComponent("" + recurringPaymentsEnabled) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetActiveGateways(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetActiveGateways(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PaymentServiceProxy.prototype.processGetActiveGateways = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_34 = resultData200; _i < resultData200_34.length; _i++) {
                        var item = resultData200_34[_i];
                        result200.push(PaymentGatewayModel.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param paymentId (optional)
     * @return Success
     */
    PaymentServiceProxy.prototype.getPayment = function (paymentId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Payment/GetPayment?";
        if (paymentId === null)
            throw new Error("The parameter 'paymentId' cannot be null.");
        else if (paymentId !== undefined)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetPayment(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetPayment(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PaymentServiceProxy.prototype.processGetPayment = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = SubscriptionPaymentDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    PaymentServiceProxy.prototype.getLastCompletedPayment = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Payment/GetLastCompletedPayment";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetLastCompletedPayment(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetLastCompletedPayment(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PaymentServiceProxy.prototype.processGetLastCompletedPayment = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = SubscriptionPaymentDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param paymentId (optional)
     * @return Success
     */
    PaymentServiceProxy.prototype.buyNowSucceed = function (paymentId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Payment/BuyNowSucceed?";
        if (paymentId === null)
            throw new Error("The parameter 'paymentId' cannot be null.");
        else if (paymentId !== undefined)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processBuyNowSucceed(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processBuyNowSucceed(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PaymentServiceProxy.prototype.processBuyNowSucceed = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param paymentId (optional)
     * @return Success
     */
    PaymentServiceProxy.prototype.newRegistrationSucceed = function (paymentId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Payment/NewRegistrationSucceed?";
        if (paymentId === null)
            throw new Error("The parameter 'paymentId' cannot be null.");
        else if (paymentId !== undefined)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processNewRegistrationSucceed(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processNewRegistrationSucceed(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PaymentServiceProxy.prototype.processNewRegistrationSucceed = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param paymentId (optional)
     * @return Success
     */
    PaymentServiceProxy.prototype.upgradeSucceed = function (paymentId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Payment/UpgradeSucceed?";
        if (paymentId === null)
            throw new Error("The parameter 'paymentId' cannot be null.");
        else if (paymentId !== undefined)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpgradeSucceed(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpgradeSucceed(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PaymentServiceProxy.prototype.processUpgradeSucceed = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param paymentId (optional)
     * @return Success
     */
    PaymentServiceProxy.prototype.extendSucceed = function (paymentId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Payment/ExtendSucceed?";
        if (paymentId === null)
            throw new Error("The parameter 'paymentId' cannot be null.");
        else if (paymentId !== undefined)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processExtendSucceed(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processExtendSucceed(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PaymentServiceProxy.prototype.processExtendSucceed = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param paymentId (optional)
     * @return Success
     */
    PaymentServiceProxy.prototype.paymentFailed = function (paymentId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Payment/PaymentFailed?";
        if (paymentId === null)
            throw new Error("The parameter 'paymentId' cannot be null.");
        else if (paymentId !== undefined)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processPaymentFailed(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processPaymentFailed(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PaymentServiceProxy.prototype.processPaymentFailed = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param upgradeEditionId (optional)
     * @return Success
     */
    PaymentServiceProxy.prototype.switchBetweenFreeEditions = function (upgradeEditionId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Payment/SwitchBetweenFreeEditions?";
        if (upgradeEditionId === null)
            throw new Error("The parameter 'upgradeEditionId' cannot be null.");
        else if (upgradeEditionId !== undefined)
            url_ += "upgradeEditionId=" + encodeURIComponent("" + upgradeEditionId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSwitchBetweenFreeEditions(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSwitchBetweenFreeEditions(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PaymentServiceProxy.prototype.processSwitchBetweenFreeEditions = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param editionId (optional)
     * @return Success
     */
    PaymentServiceProxy.prototype.upgradeSubscriptionCostsLessThenMinAmount = function (editionId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Payment/UpgradeSubscriptionCostsLessThenMinAmount?";
        if (editionId === null)
            throw new Error("The parameter 'editionId' cannot be null.");
        else if (editionId !== undefined)
            url_ += "editionId=" + encodeURIComponent("" + editionId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpgradeSubscriptionCostsLessThenMinAmount(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpgradeSubscriptionCostsLessThenMinAmount(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PaymentServiceProxy.prototype.processUpgradeSubscriptionCostsLessThenMinAmount = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return PaymentServiceProxy;
}());
export { PaymentServiceProxy };
var PayPalPaymentServiceProxy = /** @class */ (function () {
    function PayPalPaymentServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param paymentId (optional)
     * @param paypalOrderId (optional)
     * @return Success
     */
    PayPalPaymentServiceProxy.prototype.confirmPayment = function (paymentId, paypalOrderId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PayPalPayment/ConfirmPayment?";
        if (paymentId === null)
            throw new Error("The parameter 'paymentId' cannot be null.");
        else if (paymentId !== undefined)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&";
        if (paypalOrderId !== undefined)
            url_ += "paypalOrderId=" + encodeURIComponent("" + paypalOrderId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processConfirmPayment(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processConfirmPayment(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PayPalPaymentServiceProxy.prototype.processConfirmPayment = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    PayPalPaymentServiceProxy.prototype.getConfiguration = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PayPalPayment/GetConfiguration";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetConfiguration(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetConfiguration(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PayPalPaymentServiceProxy.prototype.processGetConfiguration = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PayPalConfigurationDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return PayPalPaymentServiceProxy;
}());
export { PayPalPaymentServiceProxy };
var PermissionServiceProxy = /** @class */ (function () {
    function PermissionServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @return Success
     */
    PermissionServiceProxy.prototype.getAllPermissions = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Permission/GetAllPermissions";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAllPermissions(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAllPermissions(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PermissionServiceProxy.prototype.processGetAllPermissions = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = ListResultDtoOfFlatPermissionWithLevelDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return PermissionServiceProxy;
}());
export { PermissionServiceProxy };
var PrintersServiceProxy = /** @class */ (function () {
    function PrintersServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param filter (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    PrintersServiceProxy.prototype.getAll = function (filter, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Printers/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PrintersServiceProxy.prototype.processGetAll = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PagedResultDtoOfGetPrintersForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    PrintersServiceProxy.prototype.getPrintersForEdit = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Printers/GetPrintersForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetPrintersForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetPrintersForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PrintersServiceProxy.prototype.processGetPrintersForEdit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetPrintersForEditOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    PrintersServiceProxy.prototype.createOrEdit = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Printers/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PrintersServiceProxy.prototype.processCreateOrEdit = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    PrintersServiceProxy.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Printers/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDelete(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDelete(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PrintersServiceProxy.prototype.processDelete = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param filter (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    PrintersServiceProxy.prototype.getAllDepotLocationForLookupTable = function (filter, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Printers/GetAllDepotLocationForLookupTable?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAllDepotLocationForLookupTable(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAllDepotLocationForLookupTable(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PrintersServiceProxy.prototype.processGetAllDepotLocationForLookupTable = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PagedResultDtoOfPrintersDepotLocationLookupTableDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return PrintersServiceProxy;
}());
export { PrintersServiceProxy };
var ProfileServiceProxy = /** @class */ (function () {
    function ProfileServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @return Success
     */
    ProfileServiceProxy.prototype.getCurrentUserProfileForEdit = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Profile/GetCurrentUserProfileForEdit";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetCurrentUserProfileForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetCurrentUserProfileForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ProfileServiceProxy.prototype.processGetCurrentUserProfileForEdit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = CurrentUserProfileEditDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    ProfileServiceProxy.prototype.disableGoogleAuthenticator = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Profile/DisableGoogleAuthenticator";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDisableGoogleAuthenticator(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDisableGoogleAuthenticator(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ProfileServiceProxy.prototype.processDisableGoogleAuthenticator = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    ProfileServiceProxy.prototype.updateGoogleAuthenticatorKey = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Profile/UpdateGoogleAuthenticatorKey";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateGoogleAuthenticatorKey(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateGoogleAuthenticatorKey(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ProfileServiceProxy.prototype.processUpdateGoogleAuthenticatorKey = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = UpdateGoogleAuthenticatorKeyOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ProfileServiceProxy.prototype.sendVerificationSms = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Profile/SendVerificationSms";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSendVerificationSms(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSendVerificationSms(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ProfileServiceProxy.prototype.processSendVerificationSms = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ProfileServiceProxy.prototype.verifySmsCode = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Profile/VerifySmsCode";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processVerifySmsCode(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processVerifySmsCode(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ProfileServiceProxy.prototype.processVerifySmsCode = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    ProfileServiceProxy.prototype.prepareCollectedData = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Profile/PrepareCollectedData";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processPrepareCollectedData(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processPrepareCollectedData(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ProfileServiceProxy.prototype.processPrepareCollectedData = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ProfileServiceProxy.prototype.updateCurrentUserProfile = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Profile/UpdateCurrentUserProfile";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateCurrentUserProfile(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateCurrentUserProfile(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ProfileServiceProxy.prototype.processUpdateCurrentUserProfile = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ProfileServiceProxy.prototype.changePassword = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Profile/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processChangePassword(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processChangePassword(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ProfileServiceProxy.prototype.processChangePassword = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ProfileServiceProxy.prototype.updateProfilePicture = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Profile/UpdateProfilePicture";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateProfilePicture(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateProfilePicture(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ProfileServiceProxy.prototype.processUpdateProfilePicture = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    ProfileServiceProxy.prototype.getPasswordComplexitySetting = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Profile/GetPasswordComplexitySetting";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetPasswordComplexitySetting(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetPasswordComplexitySetting(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ProfileServiceProxy.prototype.processGetPasswordComplexitySetting = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetPasswordComplexitySettingOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    ProfileServiceProxy.prototype.getProfilePicture = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Profile/GetProfilePicture";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetProfilePicture(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetProfilePicture(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ProfileServiceProxy.prototype.processGetProfilePicture = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetProfilePictureOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param profilePictureId (optional)
     * @param userId (optional)
     * @param tenantId (optional)
     * @return Success
     */
    ProfileServiceProxy.prototype.getFriendProfilePictureById = function (profilePictureId, userId, tenantId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Profile/GetFriendProfilePictureById?";
        if (profilePictureId !== undefined)
            url_ += "ProfilePictureId=" + encodeURIComponent("" + profilePictureId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetFriendProfilePictureById(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetFriendProfilePictureById(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ProfileServiceProxy.prototype.processGetFriendProfilePictureById = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetProfilePictureOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param profilePictureId (optional)
     * @return Success
     */
    ProfileServiceProxy.prototype.getProfilePictureById = function (profilePictureId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Profile/GetProfilePictureById?";
        if (profilePictureId === null)
            throw new Error("The parameter 'profilePictureId' cannot be null.");
        else if (profilePictureId !== undefined)
            url_ += "profilePictureId=" + encodeURIComponent("" + profilePictureId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetProfilePictureById(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetProfilePictureById(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ProfileServiceProxy.prototype.processGetProfilePictureById = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetProfilePictureOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ProfileServiceProxy.prototype.changeLanguage = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Profile/ChangeLanguage";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processChangeLanguage(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processChangeLanguage(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ProfileServiceProxy.prototype.processChangeLanguage = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param depot (optional)
     * @return Success
     */
    ProfileServiceProxy.prototype.updateAssociatedDepot = function (depot) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Profile/UpdateAssociatedDepot?";
        if (depot !== undefined)
            url_ += "depot=" + encodeURIComponent("" + depot) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateAssociatedDepot(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateAssociatedDepot(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ProfileServiceProxy.prototype.processUpdateAssociatedDepot = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param printer (optional)
     * @param body (optional)
     * @return Success
     */
    ProfileServiceProxy.prototype.updateUserPreferredPrinter = function (printer, body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Profile/UpdateUserPreferredPrinter?";
        if (printer !== undefined)
            url_ += "printer=" + encodeURIComponent("" + printer) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateUserPreferredPrinter(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateUserPreferredPrinter(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ProfileServiceProxy.prototype.processUpdateUserPreferredPrinter = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return ProfileServiceProxy;
}());
export { ProfileServiceProxy };
var ReturnToSuppliersServiceProxy = /** @class */ (function () {
    function ReturnToSuppliersServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param body (optional)
     * @return Success
     */
    ReturnToSuppliersServiceProxy.prototype.getAll = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ReturnToSuppliers/GetAll";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ReturnToSuppliersServiceProxy.prototype.processGetAll = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PagedResultDtoOfGetReturnToSupplierForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    ReturnToSuppliersServiceProxy.prototype.getReturnToSupplierForView = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ReturnToSuppliers/GetReturnToSupplierForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetReturnToSupplierForView(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetReturnToSupplierForView(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ReturnToSuppliersServiceProxy.prototype.processGetReturnToSupplierForView = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetReturnToSupplierForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ReturnToSuppliersServiceProxy.prototype.createLoad = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ReturnToSuppliers/CreateLoad";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateLoad(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateLoad(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ReturnToSuppliersServiceProxy.prototype.processCreateLoad = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    ReturnToSuppliersServiceProxy.prototype.delete = function (rtsIds) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ReturnToSuppliers/Delete?";
        if (rtsIds === undefined || rtsIds === null)
            throw new Error("The parameter 'rtsIds' must be defined and cannot be null.");
        else
            rtsIds && rtsIds.forEach(function (item) { url_ += "RtsIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDelete(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDelete(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ReturnToSuppliersServiceProxy.prototype.processDelete = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return ReturnToSuppliersServiceProxy;
}());
export { ReturnToSuppliersServiceProxy };
var RoleServiceProxy = /** @class */ (function () {
    function RoleServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param permissions (optional)
     * @return Success
     */
    RoleServiceProxy.prototype.getRoles = function (permissions) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Role/GetRoles?";
        if (permissions !== undefined)
            permissions && permissions.forEach(function (item) { url_ += "Permissions=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetRoles(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetRoles(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RoleServiceProxy.prototype.processGetRoles = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = ListResultDtoOfRoleListDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    RoleServiceProxy.prototype.getRoleForEdit = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Role/GetRoleForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetRoleForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetRoleForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RoleServiceProxy.prototype.processGetRoleForEdit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetRoleForEditOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    RoleServiceProxy.prototype.createOrUpdateRole = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Role/CreateOrUpdateRole";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrUpdateRole(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrUpdateRole(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RoleServiceProxy.prototype.processCreateOrUpdateRole = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    RoleServiceProxy.prototype.deleteRole = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Role/DeleteRole?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteRole(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteRole(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RoleServiceProxy.prototype.processDeleteRole = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return RoleServiceProxy;
}());
export { RoleServiceProxy };
var SessionServiceProxy = /** @class */ (function () {
    function SessionServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @return Success
     */
    SessionServiceProxy.prototype.getCurrentLoginInformations = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Session/GetCurrentLoginInformations";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetCurrentLoginInformations(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetCurrentLoginInformations(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    SessionServiceProxy.prototype.processGetCurrentLoginInformations = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetCurrentLoginInformationsOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    SessionServiceProxy.prototype.updateUserSignInToken = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Session/UpdateUserSignInToken";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateUserSignInToken(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateUserSignInToken(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    SessionServiceProxy.prototype.processUpdateUserSignInToken = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = UpdateUserSignInTokenOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return SessionServiceProxy;
}());
export { SessionServiceProxy };
var StoreNumberDeliveryPostcodesServiceProxy = /** @class */ (function () {
    function StoreNumberDeliveryPostcodesServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param storeNumberFilter (optional)
     * @param deliveryPostCodeFilter (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    StoreNumberDeliveryPostcodesServiceProxy.prototype.getAll = function (storeNumberFilter, deliveryPostCodeFilter, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/StoreNumberDeliveryPostcodes/GetAll?";
        if (storeNumberFilter !== undefined)
            url_ += "StoreNumberFilter=" + encodeURIComponent("" + storeNumberFilter) + "&";
        if (deliveryPostCodeFilter !== undefined)
            url_ += "DeliveryPostCodeFilter=" + encodeURIComponent("" + deliveryPostCodeFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    StoreNumberDeliveryPostcodesServiceProxy.prototype.processGetAll = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PagedResultDtoOfGetStoreNumberDeliveryPostcodeForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    StoreNumberDeliveryPostcodesServiceProxy.prototype.getStoreNumberDeliveryPostcodeForView = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/StoreNumberDeliveryPostcodes/GetStoreNumberDeliveryPostcodeForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetStoreNumberDeliveryPostcodeForView(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetStoreNumberDeliveryPostcodeForView(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    StoreNumberDeliveryPostcodesServiceProxy.prototype.processGetStoreNumberDeliveryPostcodeForView = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetStoreNumberDeliveryPostcodeForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    StoreNumberDeliveryPostcodesServiceProxy.prototype.getStoreNumberDeliveryPostcodeForEdit = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/StoreNumberDeliveryPostcodes/GetStoreNumberDeliveryPostcodeForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetStoreNumberDeliveryPostcodeForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetStoreNumberDeliveryPostcodeForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    StoreNumberDeliveryPostcodesServiceProxy.prototype.processGetStoreNumberDeliveryPostcodeForEdit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetStoreNumberDeliveryPostcodeForEditOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    StoreNumberDeliveryPostcodesServiceProxy.prototype.createOrEdit = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/StoreNumberDeliveryPostcodes/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    StoreNumberDeliveryPostcodesServiceProxy.prototype.processCreateOrEdit = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    StoreNumberDeliveryPostcodesServiceProxy.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/StoreNumberDeliveryPostcodes/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDelete(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDelete(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    StoreNumberDeliveryPostcodesServiceProxy.prototype.processDelete = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return StoreNumberDeliveryPostcodesServiceProxy;
}());
export { StoreNumberDeliveryPostcodesServiceProxy };
var StoresServiceProxy = /** @class */ (function () {
    function StoresServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param filter (optional)
     * @param storeIdFilter (optional)
     * @param nameFilter (optional)
     * @param palletEnabledFilter (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    StoresServiceProxy.prototype.getAll = function (filter, storeIdFilter, nameFilter, palletEnabledFilter, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Stores/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (storeIdFilter !== undefined)
            url_ += "StoreIdFilter=" + encodeURIComponent("" + storeIdFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (palletEnabledFilter !== undefined)
            url_ += "PalletEnabledFilter=" + encodeURIComponent("" + palletEnabledFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    StoresServiceProxy.prototype.processGetAll = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PagedResultDtoOfGetStoreForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    StoresServiceProxy.prototype.getStoreForView = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Stores/GetStoreForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetStoreForView(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetStoreForView(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    StoresServiceProxy.prototype.processGetStoreForView = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetStoreForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    StoresServiceProxy.prototype.getStoreForEdit = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Stores/GetStoreForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetStoreForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetStoreForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    StoresServiceProxy.prototype.processGetStoreForEdit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetStoreForEditOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    StoresServiceProxy.prototype.createOrEdit = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Stores/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    StoresServiceProxy.prototype.processCreateOrEdit = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    StoresServiceProxy.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Stores/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDelete(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDelete(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    StoresServiceProxy.prototype.processDelete = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param filter (optional)
     * @param storeIdFilter (optional)
     * @param nameFilter (optional)
     * @param palletEnabledFilter (optional)
     * @return Success
     */
    StoresServiceProxy.prototype.getStoresToExcel = function (filter, storeIdFilter, nameFilter, palletEnabledFilter) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Stores/GetStoresToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (storeIdFilter !== undefined)
            url_ += "StoreIdFilter=" + encodeURIComponent("" + storeIdFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (palletEnabledFilter !== undefined)
            url_ += "PalletEnabledFilter=" + encodeURIComponent("" + palletEnabledFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetStoresToExcel(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetStoresToExcel(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    StoresServiceProxy.prototype.processGetStoresToExcel = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = FileDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    StoresServiceProxy.prototype.importFromExcel = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Stores/ImportFromExcel";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = body;
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "multipart/form-data",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processImportFromExcel(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processImportFromExcel(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    StoresServiceProxy.prototype.processImportFromExcel = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return StoresServiceProxy;
}());
export { StoresServiceProxy };
var StripePaymentServiceProxy = /** @class */ (function () {
    function StripePaymentServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @return Success
     */
    StripePaymentServiceProxy.prototype.getConfiguration = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/StripePayment/GetConfiguration";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetConfiguration(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetConfiguration(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    StripePaymentServiceProxy.prototype.processGetConfiguration = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = StripeConfigurationDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param stripeSessionId (optional)
     * @return Success
     */
    StripePaymentServiceProxy.prototype.getPayment = function (stripeSessionId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/StripePayment/GetPayment?";
        if (stripeSessionId !== undefined)
            url_ += "StripeSessionId=" + encodeURIComponent("" + stripeSessionId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetPayment(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetPayment(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    StripePaymentServiceProxy.prototype.processGetPayment = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = SubscriptionPaymentDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    StripePaymentServiceProxy.prototype.createPaymentSession = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/StripePayment/CreatePaymentSession";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreatePaymentSession(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreatePaymentSession(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    StripePaymentServiceProxy.prototype.processCreatePaymentSession = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param paymentId (optional)
     * @return Success
     */
    StripePaymentServiceProxy.prototype.getPaymentResult = function (paymentId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/StripePayment/GetPaymentResult?";
        if (paymentId === null)
            throw new Error("The parameter 'paymentId' cannot be null.");
        else if (paymentId !== undefined)
            url_ += "PaymentId=" + encodeURIComponent("" + paymentId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetPaymentResult(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetPaymentResult(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    StripePaymentServiceProxy.prototype.processGetPaymentResult = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = StripePaymentResultOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return StripePaymentServiceProxy;
}());
export { StripePaymentServiceProxy };
var SubscriptionServiceProxy = /** @class */ (function () {
    function SubscriptionServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @return Success
     */
    SubscriptionServiceProxy.prototype.disableRecurringPayments = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Subscription/DisableRecurringPayments";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDisableRecurringPayments(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDisableRecurringPayments(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    SubscriptionServiceProxy.prototype.processDisableRecurringPayments = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    SubscriptionServiceProxy.prototype.enableRecurringPayments = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Subscription/EnableRecurringPayments";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processEnableRecurringPayments(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processEnableRecurringPayments(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    SubscriptionServiceProxy.prototype.processEnableRecurringPayments = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return SubscriptionServiceProxy;
}());
export { SubscriptionServiceProxy };
var TenantServiceProxy = /** @class */ (function () {
    function TenantServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param filter (optional)
     * @param subscriptionEndDateStart (optional)
     * @param subscriptionEndDateEnd (optional)
     * @param creationDateStart (optional)
     * @param creationDateEnd (optional)
     * @param editionId (optional)
     * @param editionIdSpecified (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    TenantServiceProxy.prototype.getTenants = function (filter, subscriptionEndDateStart, subscriptionEndDateEnd, creationDateStart, creationDateEnd, editionId, editionIdSpecified, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Tenant/GetTenants?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (subscriptionEndDateStart !== undefined)
            url_ += "SubscriptionEndDateStart=" + encodeURIComponent(subscriptionEndDateStart ? "" + subscriptionEndDateStart.toJSON() : "") + "&";
        if (subscriptionEndDateEnd !== undefined)
            url_ += "SubscriptionEndDateEnd=" + encodeURIComponent(subscriptionEndDateEnd ? "" + subscriptionEndDateEnd.toJSON() : "") + "&";
        if (creationDateStart !== undefined)
            url_ += "CreationDateStart=" + encodeURIComponent(creationDateStart ? "" + creationDateStart.toJSON() : "") + "&";
        if (creationDateEnd !== undefined)
            url_ += "CreationDateEnd=" + encodeURIComponent(creationDateEnd ? "" + creationDateEnd.toJSON() : "") + "&";
        if (editionId !== undefined)
            url_ += "EditionId=" + encodeURIComponent("" + editionId) + "&";
        if (editionIdSpecified === null)
            throw new Error("The parameter 'editionIdSpecified' cannot be null.");
        else if (editionIdSpecified !== undefined)
            url_ += "EditionIdSpecified=" + encodeURIComponent("" + editionIdSpecified) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetTenants(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetTenants(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantServiceProxy.prototype.processGetTenants = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PagedResultDtoOfTenantListDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    TenantServiceProxy.prototype.createTenant = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Tenant/CreateTenant";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateTenant(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateTenant(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantServiceProxy.prototype.processCreateTenant = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    TenantServiceProxy.prototype.getTenantForEdit = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Tenant/GetTenantForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetTenantForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetTenantForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantServiceProxy.prototype.processGetTenantForEdit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = TenantEditDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    TenantServiceProxy.prototype.updateTenant = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Tenant/UpdateTenant";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateTenant(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateTenant(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantServiceProxy.prototype.processUpdateTenant = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    TenantServiceProxy.prototype.deleteTenant = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Tenant/DeleteTenant?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteTenant(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteTenant(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantServiceProxy.prototype.processDeleteTenant = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    TenantServiceProxy.prototype.getTenantFeaturesForEdit = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Tenant/GetTenantFeaturesForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetTenantFeaturesForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetTenantFeaturesForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantServiceProxy.prototype.processGetTenantFeaturesForEdit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetTenantFeaturesEditOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    TenantServiceProxy.prototype.updateTenantFeatures = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Tenant/UpdateTenantFeatures";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateTenantFeatures(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateTenantFeatures(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantServiceProxy.prototype.processUpdateTenantFeatures = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    TenantServiceProxy.prototype.resetTenantSpecificFeatures = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Tenant/ResetTenantSpecificFeatures";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processResetTenantSpecificFeatures(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processResetTenantSpecificFeatures(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantServiceProxy.prototype.processResetTenantSpecificFeatures = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    TenantServiceProxy.prototype.unlockTenantAdmin = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Tenant/UnlockTenantAdmin";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUnlockTenantAdmin(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUnlockTenantAdmin(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantServiceProxy.prototype.processUnlockTenantAdmin = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return TenantServiceProxy;
}());
export { TenantServiceProxy };
var TenantDashboardServiceProxy = /** @class */ (function () {
    function TenantDashboardServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @return Success
     */
    TenantDashboardServiceProxy.prototype.getMemberActivity = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetMemberActivity";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetMemberActivity(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetMemberActivity(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantDashboardServiceProxy.prototype.processGetMemberActivity = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetMemberActivityOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    TenantDashboardServiceProxy.prototype.getDashboardData = function (salesSummaryDatePeriod) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetDashboardData?";
        if (salesSummaryDatePeriod === undefined || salesSummaryDatePeriod === null)
            throw new Error("The parameter 'salesSummaryDatePeriod' must be defined and cannot be null.");
        else
            url_ += "SalesSummaryDatePeriod=" + encodeURIComponent("" + salesSummaryDatePeriod) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDashboardData(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDashboardData(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantDashboardServiceProxy.prototype.processGetDashboardData = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetDashboardDataOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    TenantDashboardServiceProxy.prototype.getTopStats = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetTopStats";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetTopStats(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetTopStats(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantDashboardServiceProxy.prototype.processGetTopStats = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetTopStatsOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    TenantDashboardServiceProxy.prototype.getProfitShare = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetProfitShare";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetProfitShare(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetProfitShare(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantDashboardServiceProxy.prototype.processGetProfitShare = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetProfitShareOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    TenantDashboardServiceProxy.prototype.getDailySales = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetDailySales";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDailySales(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDailySales(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantDashboardServiceProxy.prototype.processGetDailySales = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetDailySalesOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    TenantDashboardServiceProxy.prototype.getSalesSummary = function (salesSummaryDatePeriod) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetSalesSummary?";
        if (salesSummaryDatePeriod === undefined || salesSummaryDatePeriod === null)
            throw new Error("The parameter 'salesSummaryDatePeriod' must be defined and cannot be null.");
        else
            url_ += "SalesSummaryDatePeriod=" + encodeURIComponent("" + salesSummaryDatePeriod) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetSalesSummary(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetSalesSummary(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantDashboardServiceProxy.prototype.processGetSalesSummary = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetSalesSummaryOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    TenantDashboardServiceProxy.prototype.getRegionalStats = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetRegionalStats";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetRegionalStats(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetRegionalStats(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantDashboardServiceProxy.prototype.processGetRegionalStats = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetRegionalStatsOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    TenantDashboardServiceProxy.prototype.getGeneralStats = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetGeneralStats";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetGeneralStats(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetGeneralStats(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantDashboardServiceProxy.prototype.processGetGeneralStats = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetGeneralStatsOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return TenantDashboardServiceProxy;
}());
export { TenantDashboardServiceProxy };
var TenantRegistrationServiceProxy = /** @class */ (function () {
    function TenantRegistrationServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param body (optional)
     * @return Success
     */
    TenantRegistrationServiceProxy.prototype.registerTenant = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/TenantRegistration/RegisterTenant";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processRegisterTenant(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processRegisterTenant(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantRegistrationServiceProxy.prototype.processRegisterTenant = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = RegisterTenantOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    TenantRegistrationServiceProxy.prototype.getEditionsForSelect = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/TenantRegistration/GetEditionsForSelect";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetEditionsForSelect(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetEditionsForSelect(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantRegistrationServiceProxy.prototype.processGetEditionsForSelect = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = EditionsSelectOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param editionId (optional)
     * @return Success
     */
    TenantRegistrationServiceProxy.prototype.getEdition = function (editionId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/TenantRegistration/GetEdition?";
        if (editionId === null)
            throw new Error("The parameter 'editionId' cannot be null.");
        else if (editionId !== undefined)
            url_ += "editionId=" + encodeURIComponent("" + editionId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetEdition(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetEdition(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantRegistrationServiceProxy.prototype.processGetEdition = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = EditionSelectDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return TenantRegistrationServiceProxy;
}());
export { TenantRegistrationServiceProxy };
var TenantSettingsServiceProxy = /** @class */ (function () {
    function TenantSettingsServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @return Success
     */
    TenantSettingsServiceProxy.prototype.getAllSettings = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/TenantSettings/GetAllSettings";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAllSettings(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAllSettings(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantSettingsServiceProxy.prototype.processGetAllSettings = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = TenantSettingsEditDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    TenantSettingsServiceProxy.prototype.getDeliveryWindowSettings = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/TenantSettings/GetDeliveryWindowSettings";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDeliveryWindowSettings(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDeliveryWindowSettings(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantSettingsServiceProxy.prototype.processGetDeliveryWindowSettings = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = DeliveryWindowSettingEditDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    TenantSettingsServiceProxy.prototype.updateAllSettings = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/TenantSettings/UpdateAllSettings";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateAllSettings(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateAllSettings(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantSettingsServiceProxy.prototype.processUpdateAllSettings = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    TenantSettingsServiceProxy.prototype.clearLogo = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/TenantSettings/ClearLogo";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processClearLogo(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processClearLogo(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantSettingsServiceProxy.prototype.processClearLogo = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    TenantSettingsServiceProxy.prototype.clearCustomCss = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/TenantSettings/ClearCustomCss";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processClearCustomCss(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processClearCustomCss(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantSettingsServiceProxy.prototype.processClearCustomCss = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    TenantSettingsServiceProxy.prototype.sendTestEmail = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/TenantSettings/SendTestEmail";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSendTestEmail(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSendTestEmail(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantSettingsServiceProxy.prototype.processSendTestEmail = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return TenantSettingsServiceProxy;
}());
export { TenantSettingsServiceProxy };
var TerritoryConfigurationsServiceProxy = /** @class */ (function () {
    function TerritoryConfigurationsServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param filter (optional)
     * @param servicedByEDFilter (optional)
     * @param routedByFilter (optional)
     * @param showETAFilter (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    TerritoryConfigurationsServiceProxy.prototype.getAll = function (filter, servicedByEDFilter, routedByFilter, showETAFilter, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/TerritoryConfigurations/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (servicedByEDFilter !== undefined)
            url_ += "ServicedByEDFilter=" + encodeURIComponent("" + servicedByEDFilter) + "&";
        if (routedByFilter !== undefined)
            url_ += "RoutedByFilter=" + encodeURIComponent("" + routedByFilter) + "&";
        if (showETAFilter !== undefined)
            url_ += "ShowETAFilter=" + encodeURIComponent("" + showETAFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TerritoryConfigurationsServiceProxy.prototype.processGetAll = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PagedResultDtoOfGetTerritoryConfigurationForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    TerritoryConfigurationsServiceProxy.prototype.getTerritoryConfigurationForView = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/TerritoryConfigurations/GetTerritoryConfigurationForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetTerritoryConfigurationForView(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetTerritoryConfigurationForView(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TerritoryConfigurationsServiceProxy.prototype.processGetTerritoryConfigurationForView = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetTerritoryConfigurationForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    TerritoryConfigurationsServiceProxy.prototype.getTerritoryConfigurationForEdit = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/TerritoryConfigurations/GetTerritoryConfigurationForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetTerritoryConfigurationForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetTerritoryConfigurationForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TerritoryConfigurationsServiceProxy.prototype.processGetTerritoryConfigurationForEdit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetTerritoryConfigurationForEditOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    TerritoryConfigurationsServiceProxy.prototype.createOrEdit = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/TerritoryConfigurations/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TerritoryConfigurationsServiceProxy.prototype.processCreateOrEdit = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    TerritoryConfigurationsServiceProxy.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/TerritoryConfigurations/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDelete(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDelete(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TerritoryConfigurationsServiceProxy.prototype.processDelete = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param filter (optional)
     * @param territoryFilter (optional)
     * @param routedByFilter (optional)
     * @param servicedByEDFilter (optional)
     * @param showETAFilter (optional)
     * @return Success
     */
    TerritoryConfigurationsServiceProxy.prototype.getTerritoryConfigurationsToExcel = function (filter, territoryFilter, routedByFilter, servicedByEDFilter, showETAFilter) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/TerritoryConfigurations/GetTerritoryConfigurationsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (territoryFilter !== undefined)
            url_ += "TerritoryFilter=" + encodeURIComponent("" + territoryFilter) + "&";
        if (routedByFilter !== undefined)
            url_ += "RoutedByFilter=" + encodeURIComponent("" + routedByFilter) + "&";
        if (servicedByEDFilter !== undefined)
            url_ += "ServicedByEDFilter=" + encodeURIComponent("" + servicedByEDFilter) + "&";
        if (showETAFilter !== undefined)
            url_ += "ShowETAFilter=" + encodeURIComponent("" + showETAFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetTerritoryConfigurationsToExcel(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetTerritoryConfigurationsToExcel(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TerritoryConfigurationsServiceProxy.prototype.processGetTerritoryConfigurationsToExcel = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = FileDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    TerritoryConfigurationsServiceProxy.prototype.importFromExcel = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/TerritoryConfigurations/ImportFromExcel";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = body;
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "multipart/form-data",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processImportFromExcel(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processImportFromExcel(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TerritoryConfigurationsServiceProxy.prototype.processImportFromExcel = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return TerritoryConfigurationsServiceProxy;
}());
export { TerritoryConfigurationsServiceProxy };
var TimingServiceProxy = /** @class */ (function () {
    function TimingServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @return Success
     */
    TimingServiceProxy.prototype.getTimezones = function (defaultTimezoneScope) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Timing/GetTimezones?";
        if (defaultTimezoneScope === undefined || defaultTimezoneScope === null)
            throw new Error("The parameter 'defaultTimezoneScope' must be defined and cannot be null.");
        else
            url_ += "DefaultTimezoneScope=" + encodeURIComponent("" + defaultTimezoneScope) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetTimezones(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetTimezones(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TimingServiceProxy.prototype.processGetTimezones = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = ListResultDtoOfNameValueDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param selectedTimezoneId (optional)
     * @return Success
     */
    TimingServiceProxy.prototype.getTimezoneComboboxItems = function (selectedTimezoneId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Timing/GetTimezoneComboboxItems?";
        if (selectedTimezoneId !== undefined)
            url_ += "SelectedTimezoneId=" + encodeURIComponent("" + selectedTimezoneId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetTimezoneComboboxItems(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetTimezoneComboboxItems(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TimingServiceProxy.prototype.processGetTimezoneComboboxItems = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_35 = resultData200; _i < resultData200_35.length; _i++) {
                        var item = resultData200_35[_i];
                        result200.push(ComboboxItemDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return TimingServiceProxy;
}());
export { TimingServiceProxy };
var TokenAuthServiceProxy = /** @class */ (function () {
    function TokenAuthServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param body (optional)
     * @return Success
     */
    TokenAuthServiceProxy.prototype.authenticate = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/TokenAuth/Authenticate";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processAuthenticate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processAuthenticate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TokenAuthServiceProxy.prototype.processAuthenticate = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = AuthenticateResultModel.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param refreshToken (optional)
     * @return Success
     */
    TokenAuthServiceProxy.prototype.refreshToken = function (refreshToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/TokenAuth/RefreshToken?";
        if (refreshToken !== undefined)
            url_ += "refreshToken=" + encodeURIComponent("" + refreshToken) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processRefreshToken(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processRefreshToken(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TokenAuthServiceProxy.prototype.processRefreshToken = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = RefreshTokenResult.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    TokenAuthServiceProxy.prototype.logOut = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/TokenAuth/LogOut";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processLogOut(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processLogOut(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TokenAuthServiceProxy.prototype.processLogOut = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    TokenAuthServiceProxy.prototype.sendTwoFactorAuthCode = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/TokenAuth/SendTwoFactorAuthCode";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSendTwoFactorAuthCode(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSendTwoFactorAuthCode(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TokenAuthServiceProxy.prototype.processSendTwoFactorAuthCode = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param impersonationToken (optional)
     * @return Success
     */
    TokenAuthServiceProxy.prototype.impersonatedAuthenticate = function (impersonationToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/TokenAuth/ImpersonatedAuthenticate?";
        if (impersonationToken !== undefined)
            url_ += "impersonationToken=" + encodeURIComponent("" + impersonationToken) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processImpersonatedAuthenticate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processImpersonatedAuthenticate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TokenAuthServiceProxy.prototype.processImpersonatedAuthenticate = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = ImpersonatedAuthenticateResultModel.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param switchAccountToken (optional)
     * @return Success
     */
    TokenAuthServiceProxy.prototype.linkedAccountAuthenticate = function (switchAccountToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/TokenAuth/LinkedAccountAuthenticate?";
        if (switchAccountToken !== undefined)
            url_ += "switchAccountToken=" + encodeURIComponent("" + switchAccountToken) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processLinkedAccountAuthenticate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processLinkedAccountAuthenticate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TokenAuthServiceProxy.prototype.processLinkedAccountAuthenticate = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = SwitchedAccountAuthenticateResultModel.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    TokenAuthServiceProxy.prototype.getExternalAuthenticationProviders = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/TokenAuth/GetExternalAuthenticationProviders";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetExternalAuthenticationProviders(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetExternalAuthenticationProviders(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TokenAuthServiceProxy.prototype.processGetExternalAuthenticationProviders = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_36 = resultData200; _i < resultData200_36.length; _i++) {
                        var item = resultData200_36[_i];
                        result200.push(ExternalLoginProviderInfoModel.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    TokenAuthServiceProxy.prototype.externalAuthenticate = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/TokenAuth/ExternalAuthenticate";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processExternalAuthenticate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processExternalAuthenticate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TokenAuthServiceProxy.prototype.processExternalAuthenticate = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = ExternalAuthenticateResultModel.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param message (optional)
     * @param severity (optional)
     * @return Success
     */
    TokenAuthServiceProxy.prototype.testNotification = function (message, severity) {
        var _this = this;
        var url_ = this.baseUrl + "/api/TokenAuth/TestNotification?";
        if (message !== undefined)
            url_ += "message=" + encodeURIComponent("" + message) + "&";
        if (severity !== undefined)
            url_ += "severity=" + encodeURIComponent("" + severity) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processTestNotification(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processTestNotification(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TokenAuthServiceProxy.prototype.processTestNotification = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return TokenAuthServiceProxy;
}());
export { TokenAuthServiceProxy };
var UiCustomizationSettingsServiceProxy = /** @class */ (function () {
    function UiCustomizationSettingsServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @return Success
     */
    UiCustomizationSettingsServiceProxy.prototype.getUiManagementSettings = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/GetUiManagementSettings";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetUiManagementSettings(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetUiManagementSettings(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    UiCustomizationSettingsServiceProxy.prototype.processGetUiManagementSettings = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_37 = resultData200; _i < resultData200_37.length; _i++) {
                        var item = resultData200_37[_i];
                        result200.push(ThemeSettingsDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param themeName (optional)
     * @return Success
     */
    UiCustomizationSettingsServiceProxy.prototype.changeThemeWithDefaultValues = function (themeName) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/ChangeThemeWithDefaultValues?";
        if (themeName !== undefined)
            url_ += "themeName=" + encodeURIComponent("" + themeName) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processChangeThemeWithDefaultValues(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processChangeThemeWithDefaultValues(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    UiCustomizationSettingsServiceProxy.prototype.processChangeThemeWithDefaultValues = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    UiCustomizationSettingsServiceProxy.prototype.updateUiManagementSettings = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/UpdateUiManagementSettings";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateUiManagementSettings(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateUiManagementSettings(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    UiCustomizationSettingsServiceProxy.prototype.processUpdateUiManagementSettings = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    UiCustomizationSettingsServiceProxy.prototype.updateDefaultUiManagementSettings = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/UpdateDefaultUiManagementSettings";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateDefaultUiManagementSettings(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateDefaultUiManagementSettings(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    UiCustomizationSettingsServiceProxy.prototype.processUpdateDefaultUiManagementSettings = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    UiCustomizationSettingsServiceProxy.prototype.useSystemDefaultSettings = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/UseSystemDefaultSettings";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUseSystemDefaultSettings(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUseSystemDefaultSettings(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    UiCustomizationSettingsServiceProxy.prototype.processUseSystemDefaultSettings = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return UiCustomizationSettingsServiceProxy;
}());
export { UiCustomizationSettingsServiceProxy };
var UserServiceProxy = /** @class */ (function () {
    function UserServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param filter (optional)
     * @param permissions (optional)
     * @param role (optional)
     * @param onlyLockedUsers (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    UserServiceProxy.prototype.getUsers = function (filter, permissions, role, onlyLockedUsers, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/User/GetUsers?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (permissions !== undefined)
            permissions && permissions.forEach(function (item) { url_ += "Permissions=" + encodeURIComponent("" + item) + "&"; });
        if (role !== undefined)
            url_ += "Role=" + encodeURIComponent("" + role) + "&";
        if (onlyLockedUsers === null)
            throw new Error("The parameter 'onlyLockedUsers' cannot be null.");
        else if (onlyLockedUsers !== undefined)
            url_ += "OnlyLockedUsers=" + encodeURIComponent("" + onlyLockedUsers) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetUsers(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetUsers(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    UserServiceProxy.prototype.processGetUsers = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PagedResultDtoOfUserListDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param filter (optional)
     * @param permissions (optional)
     * @param role (optional)
     * @param onlyLockedUsers (optional)
     * @param sorting (optional)
     * @return Success
     */
    UserServiceProxy.prototype.getUsersToExcel = function (filter, permissions, role, onlyLockedUsers, sorting) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/User/GetUsersToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (permissions !== undefined)
            permissions && permissions.forEach(function (item) { url_ += "Permissions=" + encodeURIComponent("" + item) + "&"; });
        if (role !== undefined)
            url_ += "Role=" + encodeURIComponent("" + role) + "&";
        if (onlyLockedUsers === null)
            throw new Error("The parameter 'onlyLockedUsers' cannot be null.");
        else if (onlyLockedUsers !== undefined)
            url_ += "OnlyLockedUsers=" + encodeURIComponent("" + onlyLockedUsers) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetUsersToExcel(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetUsersToExcel(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    UserServiceProxy.prototype.processGetUsersToExcel = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = FileDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    UserServiceProxy.prototype.getUserForEdit = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/User/GetUserForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetUserForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetUserForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    UserServiceProxy.prototype.processGetUserForEdit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetUserForEditOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    UserServiceProxy.prototype.getUserPermissionsForEdit = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/User/GetUserPermissionsForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetUserPermissionsForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetUserPermissionsForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    UserServiceProxy.prototype.processGetUserPermissionsForEdit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetUserPermissionsForEditOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    UserServiceProxy.prototype.resetUserSpecificPermissions = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/User/ResetUserSpecificPermissions";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processResetUserSpecificPermissions(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processResetUserSpecificPermissions(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    UserServiceProxy.prototype.processResetUserSpecificPermissions = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    UserServiceProxy.prototype.updateUserPermissions = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/User/UpdateUserPermissions";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateUserPermissions(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateUserPermissions(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    UserServiceProxy.prototype.processUpdateUserPermissions = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    UserServiceProxy.prototype.createOrUpdateUser = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/User/CreateOrUpdateUser";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrUpdateUser(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrUpdateUser(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    UserServiceProxy.prototype.processCreateOrUpdateUser = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    UserServiceProxy.prototype.deleteUser = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/User/DeleteUser?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteUser(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteUser(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    UserServiceProxy.prototype.processDeleteUser = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    UserServiceProxy.prototype.unlockUser = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/User/UnlockUser";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUnlockUser(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUnlockUser(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    UserServiceProxy.prototype.processUnlockUser = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return UserServiceProxy;
}());
export { UserServiceProxy };
var UserLinkServiceProxy = /** @class */ (function () {
    function UserLinkServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param body (optional)
     * @return Success
     */
    UserLinkServiceProxy.prototype.linkToUser = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/UserLink/LinkToUser";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processLinkToUser(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processLinkToUser(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    UserLinkServiceProxy.prototype.processLinkToUser = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @param sorting (optional)
     * @return Success
     */
    UserLinkServiceProxy.prototype.getLinkedUsers = function (maxResultCount, skipCount, sorting) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/UserLink/GetLinkedUsers?";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetLinkedUsers(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetLinkedUsers(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    UserLinkServiceProxy.prototype.processGetLinkedUsers = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PagedResultDtoOfLinkedUserDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    UserLinkServiceProxy.prototype.getRecentlyUsedLinkedUsers = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/UserLink/GetRecentlyUsedLinkedUsers";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetRecentlyUsedLinkedUsers(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetRecentlyUsedLinkedUsers(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    UserLinkServiceProxy.prototype.processGetRecentlyUsedLinkedUsers = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = ListResultDtoOfLinkedUserDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    UserLinkServiceProxy.prototype.unlinkUser = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/UserLink/UnlinkUser";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUnlinkUser(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUnlinkUser(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    UserLinkServiceProxy.prototype.processUnlinkUser = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return UserLinkServiceProxy;
}());
export { UserLinkServiceProxy };
var UserLoginServiceProxy = /** @class */ (function () {
    function UserLoginServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @return Success
     */
    UserLoginServiceProxy.prototype.getRecentUserLoginAttempts = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/UserLogin/GetRecentUserLoginAttempts";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetRecentUserLoginAttempts(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetRecentUserLoginAttempts(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    UserLoginServiceProxy.prototype.processGetRecentUserLoginAttempts = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = ListResultDtoOfUserLoginAttemptDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return UserLoginServiceProxy;
}());
export { UserLoginServiceProxy };
var WebhookEventServiceProxy = /** @class */ (function () {
    function WebhookEventServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param id (optional)
     * @return Success
     */
    WebhookEventServiceProxy.prototype.get = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/WebhookEvent/Get?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGet(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGet(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    WebhookEventServiceProxy.prototype.processGet = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = WebhookEvent.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return WebhookEventServiceProxy;
}());
export { WebhookEventServiceProxy };
var WebhookSendAttemptServiceProxy = /** @class */ (function () {
    function WebhookSendAttemptServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param subscriptionId (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    WebhookSendAttemptServiceProxy.prototype.getAllSendAttempts = function (subscriptionId, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/WebhookSendAttempt/GetAllSendAttempts?";
        if (subscriptionId !== undefined)
            url_ += "SubscriptionId=" + encodeURIComponent("" + subscriptionId) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAllSendAttempts(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAllSendAttempts(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    WebhookSendAttemptServiceProxy.prototype.processGetAllSendAttempts = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PagedResultDtoOfGetAllSendAttemptsOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    WebhookSendAttemptServiceProxy.prototype.getAllSendAttemptsOfWebhookEvent = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/WebhookSendAttempt/GetAllSendAttemptsOfWebhookEvent?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAllSendAttemptsOfWebhookEvent(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAllSendAttemptsOfWebhookEvent(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    WebhookSendAttemptServiceProxy.prototype.processGetAllSendAttemptsOfWebhookEvent = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = ListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param sendAttemptId (optional)
     * @return Success
     */
    WebhookSendAttemptServiceProxy.prototype.resend = function (sendAttemptId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/WebhookSendAttempt/Resend?";
        if (sendAttemptId !== undefined)
            url_ += "sendAttemptId=" + encodeURIComponent("" + sendAttemptId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processResend(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processResend(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    WebhookSendAttemptServiceProxy.prototype.processResend = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return WebhookSendAttemptServiceProxy;
}());
export { WebhookSendAttemptServiceProxy };
var WebhookSubscriptionServiceProxy = /** @class */ (function () {
    function WebhookSubscriptionServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @return Success
     */
    WebhookSubscriptionServiceProxy.prototype.publishTestWebhook = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/WebhookSubscription/PublishTestWebhook";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processPublishTestWebhook(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processPublishTestWebhook(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    WebhookSubscriptionServiceProxy.prototype.processPublishTestWebhook = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    WebhookSubscriptionServiceProxy.prototype.getAllSubscriptions = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/WebhookSubscription/GetAllSubscriptions";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAllSubscriptions(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAllSubscriptions(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    WebhookSubscriptionServiceProxy.prototype.processGetAllSubscriptions = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = ListResultDtoOfGetAllSubscriptionsOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param subscriptionId (optional)
     * @return Success
     */
    WebhookSubscriptionServiceProxy.prototype.getSubscription = function (subscriptionId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/WebhookSubscription/GetSubscription?";
        if (subscriptionId !== undefined)
            url_ += "subscriptionId=" + encodeURIComponent("" + subscriptionId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetSubscription(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetSubscription(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    WebhookSubscriptionServiceProxy.prototype.processGetSubscription = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = WebhookSubscription.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    WebhookSubscriptionServiceProxy.prototype.addSubscription = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/WebhookSubscription/AddSubscription";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processAddSubscription(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processAddSubscription(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    WebhookSubscriptionServiceProxy.prototype.processAddSubscription = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    WebhookSubscriptionServiceProxy.prototype.updateSubscription = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/WebhookSubscription/UpdateSubscription";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateSubscription(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateSubscription(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    WebhookSubscriptionServiceProxy.prototype.processUpdateSubscription = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    WebhookSubscriptionServiceProxy.prototype.activateWebhookSubscription = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/WebhookSubscription/ActivateWebhookSubscription";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processActivateWebhookSubscription(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processActivateWebhookSubscription(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    WebhookSubscriptionServiceProxy.prototype.processActivateWebhookSubscription = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param webhookName (optional)
     * @return Success
     */
    WebhookSubscriptionServiceProxy.prototype.isSubscribed = function (webhookName) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/WebhookSubscription/IsSubscribed?";
        if (webhookName !== undefined)
            url_ += "webhookName=" + encodeURIComponent("" + webhookName) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processIsSubscribed(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processIsSubscribed(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    WebhookSubscriptionServiceProxy.prototype.processIsSubscribed = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param webhookName (optional)
     * @return Success
     */
    WebhookSubscriptionServiceProxy.prototype.getAllSubscriptionsIfFeaturesGranted = function (webhookName) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/WebhookSubscription/GetAllSubscriptionsIfFeaturesGranted?";
        if (webhookName !== undefined)
            url_ += "webhookName=" + encodeURIComponent("" + webhookName) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAllSubscriptionsIfFeaturesGranted(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAllSubscriptionsIfFeaturesGranted(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    WebhookSubscriptionServiceProxy.prototype.processGetAllSubscriptionsIfFeaturesGranted = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = ListResultDtoOfGetAllSubscriptionsOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    WebhookSubscriptionServiceProxy.prototype.getAllAvailableWebhooks = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/WebhookSubscription/GetAllAvailableWebhooks";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAllAvailableWebhooks(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAllAvailableWebhooks(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    WebhookSubscriptionServiceProxy.prototype.processGetAllAvailableWebhooks = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = ListResultDtoOfGetAllAvailableWebhooksOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return WebhookSubscriptionServiceProxy;
}());
export { WebhookSubscriptionServiceProxy };
var WebLogServiceProxy = /** @class */ (function () {
    function WebLogServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @return Success
     */
    WebLogServiceProxy.prototype.getLatestWebLogs = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/WebLog/GetLatestWebLogs";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetLatestWebLogs(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetLatestWebLogs(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    WebLogServiceProxy.prototype.processGetLatestWebLogs = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetLatestWebLogsOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    WebLogServiceProxy.prototype.downloadWebLogs = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/WebLog/DownloadWebLogs";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDownloadWebLogs(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDownloadWebLogs(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    WebLogServiceProxy.prototype.processDownloadWebLogs = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = FileDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return WebLogServiceProxy;
}());
export { WebLogServiceProxy };
var ZenDeskFieldsServiceProxy = /** @class */ (function () {
    function ZenDeskFieldsServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param descriptionFilter (optional)
     * @param nameFilter (optional)
     * @param zenDeskIdFilter (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    ZenDeskFieldsServiceProxy.prototype.getAll = function (descriptionFilter, nameFilter, zenDeskIdFilter, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ZenDeskFields/GetAll?";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (zenDeskIdFilter !== undefined)
            url_ += "ZenDeskIdFilter=" + encodeURIComponent("" + zenDeskIdFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ZenDeskFieldsServiceProxy.prototype.processGetAll = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PagedResultDtoOfGetZenDeskFieldForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    ZenDeskFieldsServiceProxy.prototype.getZenDeskFieldForView = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ZenDeskFields/GetZenDeskFieldForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetZenDeskFieldForView(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetZenDeskFieldForView(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ZenDeskFieldsServiceProxy.prototype.processGetZenDeskFieldForView = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetZenDeskFieldForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    ZenDeskFieldsServiceProxy.prototype.getZenDeskFieldForEdit = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ZenDeskFields/GetZenDeskFieldForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetZenDeskFieldForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetZenDeskFieldForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ZenDeskFieldsServiceProxy.prototype.processGetZenDeskFieldForEdit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetZenDeskFieldForEditOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ZenDeskFieldsServiceProxy.prototype.createOrEdit = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ZenDeskFields/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ZenDeskFieldsServiceProxy.prototype.processCreateOrEdit = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    ZenDeskFieldsServiceProxy.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ZenDeskFields/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDelete(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDelete(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ZenDeskFieldsServiceProxy.prototype.processDelete = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param descriptionFilter (optional)
     * @param nameFilter (optional)
     * @param zenDeskIdFilter (optional)
     * @return Success
     */
    ZenDeskFieldsServiceProxy.prototype.getZenDeskFieldsToExcel = function (descriptionFilter, nameFilter, zenDeskIdFilter) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ZenDeskFields/GetZenDeskFieldsToExcel?";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (zenDeskIdFilter !== undefined)
            url_ += "ZenDeskIdFilter=" + encodeURIComponent("" + zenDeskIdFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetZenDeskFieldsToExcel(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetZenDeskFieldsToExcel(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ZenDeskFieldsServiceProxy.prototype.processGetZenDeskFieldsToExcel = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = FileDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ZenDeskFieldsServiceProxy.prototype.importFromExcel = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ZenDeskFields/ImportFromExcel";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = body;
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "multipart/form-data",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processImportFromExcel(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processImportFromExcel(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ZenDeskFieldsServiceProxy.prototype.processImportFromExcel = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return ZenDeskFieldsServiceProxy;
}());
export { ZenDeskFieldsServiceProxy };
var IsTenantAvailableInput = /** @class */ (function () {
    function IsTenantAvailableInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    IsTenantAvailableInput.prototype.init = function (data) {
        if (data) {
            this.tenancyName = data["tenancyName"];
        }
    };
    IsTenantAvailableInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new IsTenantAvailableInput();
        result.init(data);
        return result;
    };
    IsTenantAvailableInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        return data;
    };
    return IsTenantAvailableInput;
}());
export { IsTenantAvailableInput };
export var TenantAvailabilityState;
(function (TenantAvailabilityState) {
    TenantAvailabilityState[TenantAvailabilityState["Available"] = 1] = "Available";
    TenantAvailabilityState[TenantAvailabilityState["InActive"] = 2] = "InActive";
    TenantAvailabilityState[TenantAvailabilityState["NotFound"] = 3] = "NotFound";
})(TenantAvailabilityState || (TenantAvailabilityState = {}));
var IsTenantAvailableOutput = /** @class */ (function () {
    function IsTenantAvailableOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    IsTenantAvailableOutput.prototype.init = function (data) {
        if (data) {
            this.state = data["state"];
            this.tenantId = data["tenantId"];
            this.serverRootAddress = data["serverRootAddress"];
        }
    };
    IsTenantAvailableOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new IsTenantAvailableOutput();
        result.init(data);
        return result;
    };
    IsTenantAvailableOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["tenantId"] = this.tenantId;
        data["serverRootAddress"] = this.serverRootAddress;
        return data;
    };
    return IsTenantAvailableOutput;
}());
export { IsTenantAvailableOutput };
var ResolveTenantIdInput = /** @class */ (function () {
    function ResolveTenantIdInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ResolveTenantIdInput.prototype.init = function (data) {
        if (data) {
            this.c = data["c"];
        }
    };
    ResolveTenantIdInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ResolveTenantIdInput();
        result.init(data);
        return result;
    };
    ResolveTenantIdInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["c"] = this.c;
        return data;
    };
    return ResolveTenantIdInput;
}());
export { ResolveTenantIdInput };
var RegisterInput = /** @class */ (function () {
    function RegisterInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RegisterInput.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.surname = data["surname"];
            this.userName = data["userName"];
            this.emailAddress = data["emailAddress"];
            this.password = data["password"];
            this.captchaResponse = data["captchaResponse"];
        }
    };
    RegisterInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RegisterInput();
        result.init(data);
        return result;
    };
    RegisterInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["password"] = this.password;
        data["captchaResponse"] = this.captchaResponse;
        return data;
    };
    return RegisterInput;
}());
export { RegisterInput };
var RegisterOutput = /** @class */ (function () {
    function RegisterOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RegisterOutput.prototype.init = function (data) {
        if (data) {
            this.canLogin = data["canLogin"];
        }
    };
    RegisterOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RegisterOutput();
        result.init(data);
        return result;
    };
    RegisterOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["canLogin"] = this.canLogin;
        return data;
    };
    return RegisterOutput;
}());
export { RegisterOutput };
var SendPasswordResetCodeInput = /** @class */ (function () {
    function SendPasswordResetCodeInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SendPasswordResetCodeInput.prototype.init = function (data) {
        if (data) {
            this.emailAddress = data["emailAddress"];
        }
    };
    SendPasswordResetCodeInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SendPasswordResetCodeInput();
        result.init(data);
        return result;
    };
    SendPasswordResetCodeInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data;
    };
    return SendPasswordResetCodeInput;
}());
export { SendPasswordResetCodeInput };
var ResetPasswordInput = /** @class */ (function () {
    function ResetPasswordInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ResetPasswordInput.prototype.init = function (data) {
        if (data) {
            this.userId = data["userId"];
            this.resetCode = data["resetCode"];
            this.password = data["password"];
            this.returnUrl = data["returnUrl"];
            this.singleSignIn = data["singleSignIn"];
            this.c = data["c"];
        }
    };
    ResetPasswordInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ResetPasswordInput();
        result.init(data);
        return result;
    };
    ResetPasswordInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["resetCode"] = this.resetCode;
        data["password"] = this.password;
        data["returnUrl"] = this.returnUrl;
        data["singleSignIn"] = this.singleSignIn;
        data["c"] = this.c;
        return data;
    };
    return ResetPasswordInput;
}());
export { ResetPasswordInput };
var ResetPasswordOutput = /** @class */ (function () {
    function ResetPasswordOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ResetPasswordOutput.prototype.init = function (data) {
        if (data) {
            this.canLogin = data["canLogin"];
            this.userName = data["userName"];
        }
    };
    ResetPasswordOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ResetPasswordOutput();
        result.init(data);
        return result;
    };
    ResetPasswordOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["canLogin"] = this.canLogin;
        data["userName"] = this.userName;
        return data;
    };
    return ResetPasswordOutput;
}());
export { ResetPasswordOutput };
var SendEmailActivationLinkInput = /** @class */ (function () {
    function SendEmailActivationLinkInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SendEmailActivationLinkInput.prototype.init = function (data) {
        if (data) {
            this.emailAddress = data["emailAddress"];
        }
    };
    SendEmailActivationLinkInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SendEmailActivationLinkInput();
        result.init(data);
        return result;
    };
    SendEmailActivationLinkInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data;
    };
    return SendEmailActivationLinkInput;
}());
export { SendEmailActivationLinkInput };
var ActivateEmailInput = /** @class */ (function () {
    function ActivateEmailInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ActivateEmailInput.prototype.init = function (data) {
        if (data) {
            this.userId = data["userId"];
            this.confirmationCode = data["confirmationCode"];
            this.c = data["c"];
        }
    };
    ActivateEmailInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ActivateEmailInput();
        result.init(data);
        return result;
    };
    ActivateEmailInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["confirmationCode"] = this.confirmationCode;
        data["c"] = this.c;
        return data;
    };
    return ActivateEmailInput;
}());
export { ActivateEmailInput };
var ImpersonateInput = /** @class */ (function () {
    function ImpersonateInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ImpersonateInput.prototype.init = function (data) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
        }
    };
    ImpersonateInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ImpersonateInput();
        result.init(data);
        return result;
    };
    ImpersonateInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        return data;
    };
    return ImpersonateInput;
}());
export { ImpersonateInput };
var ImpersonateOutput = /** @class */ (function () {
    function ImpersonateOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ImpersonateOutput.prototype.init = function (data) {
        if (data) {
            this.impersonationToken = data["impersonationToken"];
            this.tenancyName = data["tenancyName"];
        }
    };
    ImpersonateOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ImpersonateOutput();
        result.init(data);
        return result;
    };
    ImpersonateOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["impersonationToken"] = this.impersonationToken;
        data["tenancyName"] = this.tenancyName;
        return data;
    };
    return ImpersonateOutput;
}());
export { ImpersonateOutput };
var SwitchToLinkedAccountInput = /** @class */ (function () {
    function SwitchToLinkedAccountInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SwitchToLinkedAccountInput.prototype.init = function (data) {
        if (data) {
            this.targetTenantId = data["targetTenantId"];
            this.targetUserId = data["targetUserId"];
        }
    };
    SwitchToLinkedAccountInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SwitchToLinkedAccountInput();
        result.init(data);
        return result;
    };
    SwitchToLinkedAccountInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["targetTenantId"] = this.targetTenantId;
        data["targetUserId"] = this.targetUserId;
        return data;
    };
    return SwitchToLinkedAccountInput;
}());
export { SwitchToLinkedAccountInput };
var SwitchToLinkedAccountOutput = /** @class */ (function () {
    function SwitchToLinkedAccountOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SwitchToLinkedAccountOutput.prototype.init = function (data) {
        if (data) {
            this.switchAccountToken = data["switchAccountToken"];
            this.tenancyName = data["tenancyName"];
        }
    };
    SwitchToLinkedAccountOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SwitchToLinkedAccountOutput();
        result.init(data);
        return result;
    };
    SwitchToLinkedAccountOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["switchAccountToken"] = this.switchAccountToken;
        data["tenancyName"] = this.tenancyName;
        return data;
    };
    return SwitchToLinkedAccountOutput;
}());
export { SwitchToLinkedAccountOutput };
var NameValueOfString = /** @class */ (function () {
    function NameValueOfString(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    NameValueOfString.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.value = data["value"];
        }
    };
    NameValueOfString.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new NameValueOfString();
        result.init(data);
        return result;
    };
    NameValueOfString.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    };
    return NameValueOfString;
}());
export { NameValueOfString };
var NameValueOfInt32 = /** @class */ (function () {
    function NameValueOfInt32(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    NameValueOfInt32.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.value = data["value"];
        }
    };
    NameValueOfInt32.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new NameValueOfInt32();
        result.init(data);
        return result;
    };
    NameValueOfInt32.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    };
    return NameValueOfInt32;
}());
export { NameValueOfInt32 };
export var CutoffAlert;
(function (CutoffAlert) {
    CutoffAlert[CutoffAlert["None"] = 0] = "None";
    CutoffAlert[CutoffAlert["Always"] = 1] = "Always";
    CutoffAlert[CutoffAlert["IfFileRecievedEarlierToday"] = 2] = "IfFileRecievedEarlierToday";
})(CutoffAlert || (CutoffAlert = {}));
export var DayOfWeek;
(function (DayOfWeek) {
    DayOfWeek[DayOfWeek["Sunday"] = 0] = "Sunday";
    DayOfWeek[DayOfWeek["Monday"] = 1] = "Monday";
    DayOfWeek[DayOfWeek["Tuesday"] = 2] = "Tuesday";
    DayOfWeek[DayOfWeek["Wednesday"] = 3] = "Wednesday";
    DayOfWeek[DayOfWeek["Thursday"] = 4] = "Thursday";
    DayOfWeek[DayOfWeek["Friday"] = 5] = "Friday";
    DayOfWeek[DayOfWeek["Saturday"] = 6] = "Saturday";
})(DayOfWeek || (DayOfWeek = {}));
var Hours = /** @class */ (function () {
    function Hours(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Hours.prototype.init = function (data) {
        if (data) {
            this.start = data["start"];
            this.end = data["end"];
        }
    };
    Hours.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Hours();
        result.init(data);
        return result;
    };
    Hours.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["start"] = this.start;
        data["end"] = this.end;
        return data;
    };
    return Hours;
}());
export { Hours };
var BusinessHour = /** @class */ (function () {
    function BusinessHour(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BusinessHour.prototype.init = function (data) {
        if (data) {
            this.weekday = data["weekday"];
            this.hours = data["hours"] ? Hours.fromJS(data["hours"]) : undefined;
            this.open = data["open"];
        }
    };
    BusinessHour.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BusinessHour();
        result.init(data);
        return result;
    };
    BusinessHour.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["weekday"] = this.weekday;
        data["hours"] = this.hours ? this.hours.toJSON() : undefined;
        data["open"] = this.open;
        return data;
    };
    return BusinessHour;
}());
export { BusinessHour };
var BusinessDetail = /** @class */ (function () {
    function BusinessDetail(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BusinessDetail.prototype.init = function (data) {
        if (data) {
            if (Array.isArray(data["businessHours"])) {
                this.businessHours = [];
                for (var _i = 0, _a = data["businessHours"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.businessHours.push(BusinessHour.fromJS(item));
                }
            }
        }
    };
    BusinessDetail.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BusinessDetail();
        result.init(data);
        return result;
    };
    BusinessDetail.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.businessHours)) {
            data["businessHours"] = [];
            for (var _i = 0, _a = this.businessHours; _i < _a.length; _i++) {
                var item = _a[_i];
                data["businessHours"].push(item.toJSON());
            }
        }
        return data;
    };
    return BusinessDetail;
}());
export { BusinessDetail };
var LocationDetailDto = /** @class */ (function () {
    function LocationDetailDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    LocationDetailDto.prototype.init = function (data) {
        if (data) {
            this.latitude = data["latitude"];
            this.longitude = data["longitude"];
            this.state = data["state"];
            this.postalCode = data["postalCode"];
            this.businessName = data["businessName"];
            this.addressLine1 = data["addressLine1"];
            this.addressLine2 = data["addressLine2"];
            this.suburb = data["suburb"];
            this.storeId = data["storeId"];
            this.businessDetails = data["businessDetails"] ? BusinessDetail.fromJS(data["businessDetails"]) : undefined;
            this.deliveryTimeFrom = data["deliveryTimeFrom"];
            this.deliveryTimeTo = data["deliveryTimeTo"];
            this.isBusiness = data["isBusiness"];
            this.id = data["id"];
        }
    };
    LocationDetailDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new LocationDetailDto();
        result.init(data);
        return result;
    };
    LocationDetailDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["state"] = this.state;
        data["postalCode"] = this.postalCode;
        data["businessName"] = this.businessName;
        data["addressLine1"] = this.addressLine1;
        data["addressLine2"] = this.addressLine2;
        data["suburb"] = this.suburb;
        data["storeId"] = this.storeId;
        data["businessDetails"] = this.businessDetails ? this.businessDetails.toJSON() : undefined;
        data["deliveryTimeFrom"] = this.deliveryTimeFrom;
        data["deliveryTimeTo"] = this.deliveryTimeTo;
        data["isBusiness"] = this.isBusiness;
        data["id"] = this.id;
        return data;
    };
    return LocationDetailDto;
}());
export { LocationDetailDto };
var LocationDto = /** @class */ (function () {
    function LocationDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    LocationDto.prototype.init = function (data) {
        if (data) {
            this.fullAddress = data["fullAddress"];
            this.hasGeocode = data["hasGeocode"];
            this.ignoredAt = data["ignoredAt"] ? moment(data["ignoredAt"].toString()) : undefined;
            this.locationDetail = data["locationDetail"] ? LocationDetailDto.fromJS(data["locationDetail"]) : undefined;
            this.id = data["id"];
        }
    };
    LocationDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new LocationDto();
        result.init(data);
        return result;
    };
    LocationDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["fullAddress"] = this.fullAddress;
        data["hasGeocode"] = this.hasGeocode;
        data["ignoredAt"] = this.ignoredAt ? this.ignoredAt.toISOString() : undefined;
        data["locationDetail"] = this.locationDetail ? this.locationDetail.toJSON() : undefined;
        data["id"] = this.id;
        return data;
    };
    return LocationDto;
}());
export { LocationDto };
export var ClientGroupType;
(function (ClientGroupType) {
    ClientGroupType[ClientGroupType["None"] = 0] = "None";
    ClientGroupType[ClientGroupType["MarketPlace"] = 1] = "MarketPlace";
    ClientGroupType[ClientGroupType["NBD"] = 2] = "NBD";
    ClientGroupType[ClientGroupType["D2D"] = 3] = "D2D";
    ClientGroupType[ClientGroupType["NoData"] = 4] = "NoData";
})(ClientGroupType || (ClientGroupType = {}));
var ClientGroupDto = /** @class */ (function () {
    function ClientGroupDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ClientGroupDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.cutoffTime = data["cutoffTime"];
            this.signatureRequired = data["signatureRequired"];
            this.brandId = data["brandId"];
            this.depotLocationId = data["depotLocationId"];
            this.consignmentStatusId = data["consignmentStatusId"];
            this.manifestTemplateId = data["manifestTemplateId"];
            this.cutoffAlert = data["cutoffAlert"];
            this.locationId = data["locationId"];
            this.location = data["location"] ? LocationDto.fromJS(data["location"]) : undefined;
            this.d365Entity = data["d365Entity"];
            this.type = data["type"];
            this.id = data["id"];
        }
    };
    ClientGroupDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ClientGroupDto();
        result.init(data);
        return result;
    };
    ClientGroupDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["cutoffTime"] = this.cutoffTime;
        data["signatureRequired"] = this.signatureRequired;
        data["brandId"] = this.brandId;
        data["depotLocationId"] = this.depotLocationId;
        data["consignmentStatusId"] = this.consignmentStatusId;
        data["manifestTemplateId"] = this.manifestTemplateId;
        data["cutoffAlert"] = this.cutoffAlert;
        data["locationId"] = this.locationId;
        data["location"] = this.location ? this.location.toJSON() : undefined;
        data["d365Entity"] = this.d365Entity;
        data["type"] = this.type;
        data["id"] = this.id;
        return data;
    };
    return ClientGroupDto;
}());
export { ClientGroupDto };
var NameValueOfClientGroupDto = /** @class */ (function () {
    function NameValueOfClientGroupDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    NameValueOfClientGroupDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.value = data["value"] ? ClientGroupDto.fromJS(data["value"]) : undefined;
        }
    };
    NameValueOfClientGroupDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new NameValueOfClientGroupDto();
        result.init(data);
        return result;
    };
    NameValueOfClientGroupDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value ? this.value.toJSON() : undefined;
        return data;
    };
    return NameValueOfClientGroupDto;
}());
export { NameValueOfClientGroupDto };
var NameValueOfNullableOfInt64 = /** @class */ (function () {
    function NameValueOfNullableOfInt64(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    NameValueOfNullableOfInt64.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.value = data["value"];
        }
    };
    NameValueOfNullableOfInt64.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new NameValueOfNullableOfInt64();
        result.init(data);
        return result;
    };
    NameValueOfNullableOfInt64.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    };
    return NameValueOfNullableOfInt64;
}());
export { NameValueOfNullableOfInt64 };
var GetAllAutoCompleteData = /** @class */ (function () {
    function GetAllAutoCompleteData(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetAllAutoCompleteData.prototype.init = function (data) {
        if (data) {
            if (Array.isArray(data["depotLocations"])) {
                this.depotLocations = [];
                for (var _i = 0, _a = data["depotLocations"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.depotLocations.push(NameValueOfString.fromJS(item));
                }
            }
            if (Array.isArray(data["brands"])) {
                this.brands = [];
                for (var _b = 0, _c = data["brands"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.brands.push(NameValueOfString.fromJS(item));
                }
            }
            if (Array.isArray(data["consignmentStatuss"])) {
                this.consignmentStatuss = [];
                for (var _d = 0, _e = data["consignmentStatuss"]; _d < _e.length; _d++) {
                    var item = _e[_d];
                    this.consignmentStatuss.push(NameValueOfString.fromJS(item));
                }
            }
            if (Array.isArray(data["manifestTemplates"])) {
                this.manifestTemplates = [];
                for (var _f = 0, _g = data["manifestTemplates"]; _f < _g.length; _f++) {
                    var item = _g[_f];
                    this.manifestTemplates.push(NameValueOfString.fromJS(item));
                }
            }
            if (Array.isArray(data["manifestJobs"])) {
                this.manifestJobs = [];
                for (var _h = 0, _j = data["manifestJobs"]; _h < _j.length; _h++) {
                    var item = _j[_h];
                    this.manifestJobs.push(NameValueOfString.fromJS(item));
                }
            }
            if (Array.isArray(data["carriers"])) {
                this.carriers = [];
                for (var _k = 0, _l = data["carriers"]; _k < _l.length; _k++) {
                    var item = _l[_k];
                    this.carriers.push(NameValueOfInt32.fromJS(item));
                }
            }
            if (Array.isArray(data["couriers"])) {
                this.couriers = [];
                for (var _m = 0, _o = data["couriers"]; _m < _o.length; _m++) {
                    var item = _o[_m];
                    this.couriers.push(NameValueOfInt32.fromJS(item));
                }
            }
            if (Array.isArray(data["clientGroups"])) {
                this.clientGroups = [];
                for (var _p = 0, _q = data["clientGroups"]; _p < _q.length; _p++) {
                    var item = _q[_p];
                    this.clientGroups.push(NameValueOfClientGroupDto.fromJS(item));
                }
            }
            if (Array.isArray(data["eventGroups"])) {
                this.eventGroups = [];
                for (var _r = 0, _s = data["eventGroups"]; _r < _s.length; _r++) {
                    var item = _s[_r];
                    this.eventGroups.push(NameValueOfInt32.fromJS(item));
                }
            }
            if (Array.isArray(data["eventDetails"])) {
                this.eventDetails = [];
                for (var _t = 0, _u = data["eventDetails"]; _t < _u.length; _t++) {
                    var item = _u[_t];
                    this.eventDetails.push(NameValueOfString.fromJS(item));
                }
            }
            if (Array.isArray(data["clients"])) {
                this.clients = [];
                for (var _v = 0, _w = data["clients"]; _v < _w.length; _v++) {
                    var item = _w[_v];
                    this.clients.push(NameValueOfInt32.fromJS(item));
                }
            }
            if (Array.isArray(data["clientsWithCode"])) {
                this.clientsWithCode = [];
                for (var _x = 0, _y = data["clientsWithCode"]; _x < _y.length; _x++) {
                    var item = _y[_x];
                    this.clientsWithCode.push(NameValueOfString.fromJS(item));
                }
            }
            if (Array.isArray(data["clientVisibleConsignmentStatuss"])) {
                this.clientVisibleConsignmentStatuss = [];
                for (var _z = 0, _0 = data["clientVisibleConsignmentStatuss"]; _z < _0.length; _z++) {
                    var item = _0[_z];
                    this.clientVisibleConsignmentStatuss.push(NameValueOfString.fromJS(item));
                }
            }
            if (Array.isArray(data["eventDetailZendeskTickets"])) {
                this.eventDetailZendeskTickets = [];
                for (var _1 = 0, _2 = data["eventDetailZendeskTickets"]; _1 < _2.length; _1++) {
                    var item = _2[_1];
                    this.eventDetailZendeskTickets.push(NameValueOfString.fromJS(item));
                }
            }
        }
    };
    GetAllAutoCompleteData.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetAllAutoCompleteData();
        result.init(data);
        return result;
    };
    GetAllAutoCompleteData.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.depotLocations)) {
            data["depotLocations"] = [];
            for (var _i = 0, _a = this.depotLocations; _i < _a.length; _i++) {
                var item = _a[_i];
                data["depotLocations"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.brands)) {
            data["brands"] = [];
            for (var _b = 0, _c = this.brands; _b < _c.length; _b++) {
                var item = _c[_b];
                data["brands"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.consignmentStatuss)) {
            data["consignmentStatuss"] = [];
            for (var _d = 0, _e = this.consignmentStatuss; _d < _e.length; _d++) {
                var item = _e[_d];
                data["consignmentStatuss"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.manifestTemplates)) {
            data["manifestTemplates"] = [];
            for (var _f = 0, _g = this.manifestTemplates; _f < _g.length; _f++) {
                var item = _g[_f];
                data["manifestTemplates"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.manifestJobs)) {
            data["manifestJobs"] = [];
            for (var _h = 0, _j = this.manifestJobs; _h < _j.length; _h++) {
                var item = _j[_h];
                data["manifestJobs"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.carriers)) {
            data["carriers"] = [];
            for (var _k = 0, _l = this.carriers; _k < _l.length; _k++) {
                var item = _l[_k];
                data["carriers"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.couriers)) {
            data["couriers"] = [];
            for (var _m = 0, _o = this.couriers; _m < _o.length; _m++) {
                var item = _o[_m];
                data["couriers"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.clientGroups)) {
            data["clientGroups"] = [];
            for (var _p = 0, _q = this.clientGroups; _p < _q.length; _p++) {
                var item = _q[_p];
                data["clientGroups"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.eventGroups)) {
            data["eventGroups"] = [];
            for (var _r = 0, _s = this.eventGroups; _r < _s.length; _r++) {
                var item = _s[_r];
                data["eventGroups"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.eventDetails)) {
            data["eventDetails"] = [];
            for (var _t = 0, _u = this.eventDetails; _t < _u.length; _t++) {
                var item = _u[_t];
                data["eventDetails"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.clients)) {
            data["clients"] = [];
            for (var _v = 0, _w = this.clients; _v < _w.length; _v++) {
                var item = _w[_v];
                data["clients"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.clientsWithCode)) {
            data["clientsWithCode"] = [];
            for (var _x = 0, _y = this.clientsWithCode; _x < _y.length; _x++) {
                var item = _y[_x];
                data["clientsWithCode"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.clientVisibleConsignmentStatuss)) {
            data["clientVisibleConsignmentStatuss"] = [];
            for (var _z = 0, _0 = this.clientVisibleConsignmentStatuss; _z < _0.length; _z++) {
                var item = _0[_z];
                data["clientVisibleConsignmentStatuss"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.eventDetailZendeskTickets)) {
            data["eventDetailZendeskTickets"] = [];
            for (var _1 = 0, _2 = this.eventDetailZendeskTickets; _1 < _2.length; _1++) {
                var item = _2[_1];
                data["eventDetailZendeskTickets"].push(item.toJSON());
            }
        }
        return data;
    };
    return GetAllAutoCompleteData;
}());
export { GetAllAutoCompleteData };
export var RemoveTransaction;
(function (RemoveTransaction) {
    RemoveTransaction[RemoveTransaction["None"] = 0] = "None";
    RemoveTransaction[RemoveTransaction["Cost"] = 1] = "Cost";
    RemoveTransaction[RemoveTransaction["Charge"] = 2] = "Charge";
})(RemoveTransaction || (RemoveTransaction = {}));
export var ConsignmentDashboardCategory;
(function (ConsignmentDashboardCategory) {
    ConsignmentDashboardCategory[ConsignmentDashboardCategory["NotApplicable"] = 0] = "NotApplicable";
    ConsignmentDashboardCategory[ConsignmentDashboardCategory["NotReceivedInDepot"] = 1] = "NotReceivedInDepot";
    ConsignmentDashboardCategory[ConsignmentDashboardCategory["ReceivedInDepot"] = 2] = "ReceivedInDepot";
    ConsignmentDashboardCategory[ConsignmentDashboardCategory["WithCarrier"] = 3] = "WithCarrier";
    ConsignmentDashboardCategory[ConsignmentDashboardCategory["WithDriver"] = 4] = "WithDriver";
    ConsignmentDashboardCategory[ConsignmentDashboardCategory["ProblemStatus"] = 5] = "ProblemStatus";
    ConsignmentDashboardCategory[ConsignmentDashboardCategory["DeliveryAttempt"] = 6] = "DeliveryAttempt";
    ConsignmentDashboardCategory[ConsignmentDashboardCategory["Delivered"] = 7] = "Delivered";
})(ConsignmentDashboardCategory || (ConsignmentDashboardCategory = {}));
var EventDetailDto = /** @class */ (function () {
    function EventDetailDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EventDetailDto.prototype.init = function (data) {
        if (data) {
            this.status = data["status"];
            this.description = data["description"];
            this.removeTransaction = data["removeTransaction"];
            this.eventGroupId = data["eventGroupId"];
            this.courierId = data["courierId"];
            this.exceptionConsignmentStatusId = data["exceptionConsignmentStatusId"];
            this.zendeskQueryType = data["zendeskQueryType"];
            this.consignmentDashboardCategory = data["consignmentDashboardCategory"];
            this.id = data["id"];
        }
    };
    EventDetailDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new EventDetailDto();
        result.init(data);
        return result;
    };
    EventDetailDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["description"] = this.description;
        data["removeTransaction"] = this.removeTransaction;
        data["eventGroupId"] = this.eventGroupId;
        data["courierId"] = this.courierId;
        data["exceptionConsignmentStatusId"] = this.exceptionConsignmentStatusId;
        data["zendeskQueryType"] = this.zendeskQueryType;
        data["consignmentDashboardCategory"] = this.consignmentDashboardCategory;
        data["id"] = this.id;
        return data;
    };
    return EventDetailDto;
}());
export { EventDetailDto };
var GetEventDetailForViewDto = /** @class */ (function () {
    function GetEventDetailForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetEventDetailForViewDto.prototype.init = function (data) {
        if (data) {
            this.eventDetail = data["eventDetail"] ? EventDetailDto.fromJS(data["eventDetail"]) : undefined;
            this.eventGroupDescription = data["eventGroupDescription"];
            this.courierName = data["courierName"];
            this.exceptionConsignmentStatus = data["exceptionConsignmentStatus"];
        }
    };
    GetEventDetailForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetEventDetailForViewDto();
        result.init(data);
        return result;
    };
    GetEventDetailForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["eventDetail"] = this.eventDetail ? this.eventDetail.toJSON() : undefined;
        data["eventGroupDescription"] = this.eventGroupDescription;
        data["courierName"] = this.courierName;
        data["exceptionConsignmentStatus"] = this.exceptionConsignmentStatus;
        return data;
    };
    return GetEventDetailForViewDto;
}());
export { GetEventDetailForViewDto };
var PagedResultDtoOfGetEventDetailForViewDto = /** @class */ (function () {
    function PagedResultDtoOfGetEventDetailForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfGetEventDetailForViewDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(GetEventDetailForViewDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfGetEventDetailForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfGetEventDetailForViewDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfGetEventDetailForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfGetEventDetailForViewDto;
}());
export { PagedResultDtoOfGetEventDetailForViewDto };
var AuditLogListDto = /** @class */ (function () {
    function AuditLogListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AuditLogListDto.prototype.init = function (data) {
        if (data) {
            this.userId = data["userId"];
            this.userName = data["userName"];
            this.impersonatorTenantId = data["impersonatorTenantId"];
            this.impersonatorUserId = data["impersonatorUserId"];
            this.serviceName = data["serviceName"];
            this.methodName = data["methodName"];
            this.parameters = data["parameters"];
            this.executionTime = data["executionTime"] ? moment(data["executionTime"].toString()) : undefined;
            this.executionDuration = data["executionDuration"];
            this.clientIpAddress = data["clientIpAddress"];
            this.clientName = data["clientName"];
            this.browserInfo = data["browserInfo"];
            this.exception = data["exception"];
            this.customData = data["customData"];
            this.id = data["id"];
        }
    };
    AuditLogListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AuditLogListDto();
        result.init(data);
        return result;
    };
    AuditLogListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["impersonatorTenantId"] = this.impersonatorTenantId;
        data["impersonatorUserId"] = this.impersonatorUserId;
        data["serviceName"] = this.serviceName;
        data["methodName"] = this.methodName;
        data["parameters"] = this.parameters;
        data["executionTime"] = this.executionTime ? this.executionTime.toISOString() : undefined;
        data["executionDuration"] = this.executionDuration;
        data["clientIpAddress"] = this.clientIpAddress;
        data["clientName"] = this.clientName;
        data["browserInfo"] = this.browserInfo;
        data["exception"] = this.exception;
        data["customData"] = this.customData;
        data["id"] = this.id;
        return data;
    };
    return AuditLogListDto;
}());
export { AuditLogListDto };
var PagedResultDtoOfAuditLogListDto = /** @class */ (function () {
    function PagedResultDtoOfAuditLogListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfAuditLogListDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(AuditLogListDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfAuditLogListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfAuditLogListDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfAuditLogListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfAuditLogListDto;
}());
export { PagedResultDtoOfAuditLogListDto };
var FileDto = /** @class */ (function () {
    function FileDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FileDto.prototype.init = function (data) {
        if (data) {
            this.fileName = data["fileName"];
            this.fileType = data["fileType"];
            this.fileToken = data["fileToken"];
        }
    };
    FileDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FileDto();
        result.init(data);
        return result;
    };
    FileDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["fileToken"] = this.fileToken;
        return data;
    };
    return FileDto;
}());
export { FileDto };
var NameValueDto = /** @class */ (function () {
    function NameValueDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    NameValueDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.value = data["value"];
        }
    };
    NameValueDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new NameValueDto();
        result.init(data);
        return result;
    };
    NameValueDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    };
    return NameValueDto;
}());
export { NameValueDto };
export var EntityChangeType;
(function (EntityChangeType) {
    EntityChangeType[EntityChangeType["Created"] = 0] = "Created";
    EntityChangeType[EntityChangeType["Updated"] = 1] = "Updated";
    EntityChangeType[EntityChangeType["Deleted"] = 2] = "Deleted";
})(EntityChangeType || (EntityChangeType = {}));
var EntityPropertyChangeDto = /** @class */ (function () {
    function EntityPropertyChangeDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EntityPropertyChangeDto.prototype.init = function (data) {
        if (data) {
            this.entityChangeId = data["entityChangeId"];
            this.newValue = data["newValue"];
            this.originalValue = data["originalValue"];
            this.propertyName = data["propertyName"];
            this.propertyTypeFullName = data["propertyTypeFullName"];
            this.tenantId = data["tenantId"];
            this.id = data["id"];
        }
    };
    EntityPropertyChangeDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new EntityPropertyChangeDto();
        result.init(data);
        return result;
    };
    EntityPropertyChangeDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["entityChangeId"] = this.entityChangeId;
        data["newValue"] = this.newValue;
        data["originalValue"] = this.originalValue;
        data["propertyName"] = this.propertyName;
        data["propertyTypeFullName"] = this.propertyTypeFullName;
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        return data;
    };
    return EntityPropertyChangeDto;
}());
export { EntityPropertyChangeDto };
var EntityChangeListDto = /** @class */ (function () {
    function EntityChangeListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EntityChangeListDto.prototype.init = function (data) {
        if (data) {
            this.userId = data["userId"];
            this.userName = data["userName"];
            this.changeTime = data["changeTime"] ? moment(data["changeTime"].toString()) : undefined;
            this.entityTypeFullName = data["entityTypeFullName"];
            this.changeType = data["changeType"];
            this.changeTypeName = data["changeTypeName"];
            this.entityChangeSetId = data["entityChangeSetId"];
            if (Array.isArray(data["propertyChanges"])) {
                this.propertyChanges = [];
                for (var _i = 0, _a = data["propertyChanges"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.propertyChanges.push(EntityPropertyChangeDto.fromJS(item));
                }
            }
            this.reason = data["reason"];
            this.id = data["id"];
        }
    };
    EntityChangeListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new EntityChangeListDto();
        result.init(data);
        return result;
    };
    EntityChangeListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["changeTime"] = this.changeTime ? this.changeTime.toISOString() : undefined;
        data["entityTypeFullName"] = this.entityTypeFullName;
        data["changeType"] = this.changeType;
        data["changeTypeName"] = this.changeTypeName;
        data["entityChangeSetId"] = this.entityChangeSetId;
        if (Array.isArray(this.propertyChanges)) {
            data["propertyChanges"] = [];
            for (var _i = 0, _a = this.propertyChanges; _i < _a.length; _i++) {
                var item = _a[_i];
                data["propertyChanges"].push(item.toJSON());
            }
        }
        data["reason"] = this.reason;
        data["id"] = this.id;
        return data;
    };
    return EntityChangeListDto;
}());
export { EntityChangeListDto };
var PagedResultDtoOfEntityChangeListDto = /** @class */ (function () {
    function PagedResultDtoOfEntityChangeListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfEntityChangeListDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(EntityChangeListDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfEntityChangeListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfEntityChangeListDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfEntityChangeListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfEntityChangeListDto;
}());
export { PagedResultDtoOfEntityChangeListDto };
export var BarcodeScanType;
(function (BarcodeScanType) {
    BarcodeScanType[BarcodeScanType["CrossDock"] = 0] = "CrossDock";
    BarcodeScanType[BarcodeScanType["ProblemPallet"] = 1] = "ProblemPallet";
    BarcodeScanType[BarcodeScanType["FloorScan"] = 2] = "FloorScan";
    BarcodeScanType[BarcodeScanType["DriverReturn"] = 3] = "DriverReturn";
    BarcodeScanType[BarcodeScanType["XBorder"] = 4] = "XBorder";
    BarcodeScanType[BarcodeScanType["RegionalReturn"] = 5] = "RegionalReturn";
    BarcodeScanType[BarcodeScanType["RTS"] = 6] = "RTS";
    BarcodeScanType[BarcodeScanType["Sort"] = 7] = "Sort";
    BarcodeScanType[BarcodeScanType["RTSProduct"] = 8] = "RTSProduct";
})(BarcodeScanType || (BarcodeScanType = {}));
var DepotLocationDto = /** @class */ (function () {
    function DepotLocationDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DepotLocationDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.cutoffTime = data["cutoffTime"];
            this.address1 = data["address1"];
            this.address2 = data["address2"];
            this.suburb = data["suburb"];
            this.state = data["state"];
            this.postcode = data["postcode"];
            this.depotStoreNumber = data["depotStoreNumber"];
            if (Array.isArray(data["validDepotLocationScanTags"])) {
                this.validDepotLocationScanTags = [];
                for (var _i = 0, _a = data["validDepotLocationScanTags"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.validDepotLocationScanTags.push(item);
                }
            }
            this.id = data["id"];
        }
    };
    DepotLocationDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DepotLocationDto();
        result.init(data);
        return result;
    };
    DepotLocationDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["cutoffTime"] = this.cutoffTime;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["suburb"] = this.suburb;
        data["state"] = this.state;
        data["postcode"] = this.postcode;
        data["depotStoreNumber"] = this.depotStoreNumber;
        if (Array.isArray(this.validDepotLocationScanTags)) {
            data["validDepotLocationScanTags"] = [];
            for (var _i = 0, _a = this.validDepotLocationScanTags; _i < _a.length; _i++) {
                var item = _a[_i];
                data["validDepotLocationScanTags"].push(item);
            }
        }
        data["id"] = this.id;
        return data;
    };
    return DepotLocationDto;
}());
export { DepotLocationDto };
var BarcodeScanPackageProductDto = /** @class */ (function () {
    function BarcodeScanPackageProductDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BarcodeScanPackageProductDto.prototype.init = function (data) {
        if (data) {
            this.connote = data["connote"];
            this.boxBarcode = data["boxBarcode"];
            this.productBarcode = data["productBarcode"];
            this.quantity = data["quantity"];
        }
    };
    BarcodeScanPackageProductDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BarcodeScanPackageProductDto();
        result.init(data);
        return result;
    };
    BarcodeScanPackageProductDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["connote"] = this.connote;
        data["boxBarcode"] = this.boxBarcode;
        data["productBarcode"] = this.productBarcode;
        data["quantity"] = this.quantity;
        return data;
    };
    return BarcodeScanPackageProductDto;
}());
export { BarcodeScanPackageProductDto };
var BarcodeScanPackageDto = /** @class */ (function () {
    function BarcodeScanPackageDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BarcodeScanPackageDto.prototype.init = function (data) {
        if (data) {
            this.barcodeScanHistoryId = data["barcodeScanHistoryId"];
            this.packageId = data["packageId"];
            this.barcode = data["barcode"];
            this.isValid = data["isValid"];
            if (Array.isArray(data["barcodeScanPackageProducts"])) {
                this.barcodeScanPackageProducts = [];
                for (var _i = 0, _a = data["barcodeScanPackageProducts"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.barcodeScanPackageProducts.push(BarcodeScanPackageProductDto.fromJS(item));
                }
            }
        }
    };
    BarcodeScanPackageDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BarcodeScanPackageDto();
        result.init(data);
        return result;
    };
    BarcodeScanPackageDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["barcodeScanHistoryId"] = this.barcodeScanHistoryId;
        data["packageId"] = this.packageId;
        data["barcode"] = this.barcode;
        data["isValid"] = this.isValid;
        if (Array.isArray(this.barcodeScanPackageProducts)) {
            data["barcodeScanPackageProducts"] = [];
            for (var _i = 0, _a = this.barcodeScanPackageProducts; _i < _a.length; _i++) {
                var item = _a[_i];
                data["barcodeScanPackageProducts"].push(item.toJSON());
            }
        }
        return data;
    };
    return BarcodeScanPackageDto;
}());
export { BarcodeScanPackageDto };
var BarcodeScanHistoryDto = /** @class */ (function () {
    function BarcodeScanHistoryDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BarcodeScanHistoryDto.prototype.init = function (data) {
        if (data) {
            this.type = data["type"];
            this.barcodesNoData = data["barcodesNoData"];
            this.depotLocationId = data["depotLocationId"];
            this.depotLocation = data["depotLocation"] ? DepotLocationDto.fromJS(data["depotLocation"]) : undefined;
            if (Array.isArray(data["barcodeScanPackages"])) {
                this.barcodeScanPackages = [];
                for (var _i = 0, _a = data["barcodeScanPackages"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.barcodeScanPackages.push(BarcodeScanPackageDto.fromJS(item));
                }
            }
            this.endTime = data["endTime"] ? moment(data["endTime"].toString()) : undefined;
            if (Array.isArray(data["barcodeScanHistoryScanTags"])) {
                this.barcodeScanHistoryScanTags = [];
                for (var _b = 0, _c = data["barcodeScanHistoryScanTags"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.barcodeScanHistoryScanTags.push(item);
                }
            }
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    };
    BarcodeScanHistoryDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BarcodeScanHistoryDto();
        result.init(data);
        return result;
    };
    BarcodeScanHistoryDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["barcodesNoData"] = this.barcodesNoData;
        data["depotLocationId"] = this.depotLocationId;
        data["depotLocation"] = this.depotLocation ? this.depotLocation.toJSON() : undefined;
        if (Array.isArray(this.barcodeScanPackages)) {
            data["barcodeScanPackages"] = [];
            for (var _i = 0, _a = this.barcodeScanPackages; _i < _a.length; _i++) {
                var item = _a[_i];
                data["barcodeScanPackages"].push(item.toJSON());
            }
        }
        data["endTime"] = this.endTime ? this.endTime.toISOString() : undefined;
        if (Array.isArray(this.barcodeScanHistoryScanTags)) {
            data["barcodeScanHistoryScanTags"] = [];
            for (var _b = 0, _c = this.barcodeScanHistoryScanTags; _b < _c.length; _b++) {
                var item = _c[_b];
                data["barcodeScanHistoryScanTags"].push(item);
            }
        }
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    return BarcodeScanHistoryDto;
}());
export { BarcodeScanHistoryDto };
var GetBarcodeScanHistoryForViewDto = /** @class */ (function () {
    function GetBarcodeScanHistoryForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetBarcodeScanHistoryForViewDto.prototype.init = function (data) {
        if (data) {
            this.barcodeScanHistory = data["barcodeScanHistory"] ? BarcodeScanHistoryDto.fromJS(data["barcodeScanHistory"]) : undefined;
            this.depotLocationName = data["depotLocationName"];
            this.personName = data["personName"];
            this.validBarcodeCount = data["validBarcodeCount"];
            this.inValidBarcodeCounts = data["inValidBarcodeCounts"];
            this.rtsProductCount = data["rtsProductCount"];
        }
    };
    GetBarcodeScanHistoryForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetBarcodeScanHistoryForViewDto();
        result.init(data);
        return result;
    };
    GetBarcodeScanHistoryForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["barcodeScanHistory"] = this.barcodeScanHistory ? this.barcodeScanHistory.toJSON() : undefined;
        data["depotLocationName"] = this.depotLocationName;
        data["personName"] = this.personName;
        data["validBarcodeCount"] = this.validBarcodeCount;
        data["inValidBarcodeCounts"] = this.inValidBarcodeCounts;
        data["rtsProductCount"] = this.rtsProductCount;
        return data;
    };
    return GetBarcodeScanHistoryForViewDto;
}());
export { GetBarcodeScanHistoryForViewDto };
var PagedResultDtoOfGetBarcodeScanHistoryForViewDto = /** @class */ (function () {
    function PagedResultDtoOfGetBarcodeScanHistoryForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfGetBarcodeScanHistoryForViewDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(GetBarcodeScanHistoryForViewDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfGetBarcodeScanHistoryForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfGetBarcodeScanHistoryForViewDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfGetBarcodeScanHistoryForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfGetBarcodeScanHistoryForViewDto;
}());
export { PagedResultDtoOfGetBarcodeScanHistoryForViewDto };
var CreateBarcodeScanHistoryDto = /** @class */ (function () {
    function CreateBarcodeScanHistoryDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.barcodes = [];
        }
    }
    CreateBarcodeScanHistoryDto.prototype.init = function (data) {
        if (data) {
            this.scanType = data["scanType"];
            if (Array.isArray(data["barcodes"])) {
                this.barcodes = [];
                for (var _i = 0, _a = data["barcodes"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.barcodes.push(item);
                }
            }
            if (Array.isArray(data["barcodeScanHistoryScanTags"])) {
                this.barcodeScanHistoryScanTags = [];
                for (var _b = 0, _c = data["barcodeScanHistoryScanTags"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.barcodeScanHistoryScanTags.push(item);
                }
            }
        }
    };
    CreateBarcodeScanHistoryDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateBarcodeScanHistoryDto();
        result.init(data);
        return result;
    };
    CreateBarcodeScanHistoryDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["scanType"] = this.scanType;
        if (Array.isArray(this.barcodes)) {
            data["barcodes"] = [];
            for (var _i = 0, _a = this.barcodes; _i < _a.length; _i++) {
                var item = _a[_i];
                data["barcodes"].push(item);
            }
        }
        if (Array.isArray(this.barcodeScanHistoryScanTags)) {
            data["barcodeScanHistoryScanTags"] = [];
            for (var _b = 0, _c = this.barcodeScanHistoryScanTags; _b < _c.length; _b++) {
                var item = _c[_b];
                data["barcodeScanHistoryScanTags"].push(item);
            }
        }
        return data;
    };
    return CreateBarcodeScanHistoryDto;
}());
export { CreateBarcodeScanHistoryDto };
export var LabelType;
(function (LabelType) {
    LabelType[LabelType["Pdf"] = 0] = "Pdf";
    LabelType[LabelType["Zebra"] = 1] = "Zebra";
    LabelType[LabelType["Sato"] = 2] = "Sato";
})(LabelType || (LabelType = {}));
var BarcodePrintLabelInput = /** @class */ (function () {
    function BarcodePrintLabelInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BarcodePrintLabelInput.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.labelType = data["labelType"];
        }
    };
    BarcodePrintLabelInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BarcodePrintLabelInput();
        result.init(data);
        return result;
    };
    BarcodePrintLabelInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["labelType"] = this.labelType;
        return data;
    };
    return BarcodePrintLabelInput;
}());
export { BarcodePrintLabelInput };
var BulkPackageValidationResult = /** @class */ (function () {
    function BulkPackageValidationResult(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BulkPackageValidationResult.prototype.init = function (data) {
        if (data) {
            if (Array.isArray(data["validPackageIds"])) {
                this.validPackageIds = [];
                for (var _i = 0, _a = data["validPackageIds"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.validPackageIds.push(item);
                }
            }
            if (Array.isArray(data["errors"])) {
                this.errors = [];
                for (var _b = 0, _c = data["errors"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.errors.push(item);
                }
            }
            if (Array.isArray(data["warnings"])) {
                this.warnings = [];
                for (var _d = 0, _e = data["warnings"]; _d < _e.length; _d++) {
                    var item = _e[_d];
                    this.warnings.push(item);
                }
            }
        }
    };
    BulkPackageValidationResult.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BulkPackageValidationResult();
        result.init(data);
        return result;
    };
    BulkPackageValidationResult.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.validPackageIds)) {
            data["validPackageIds"] = [];
            for (var _i = 0, _a = this.validPackageIds; _i < _a.length; _i++) {
                var item = _a[_i];
                data["validPackageIds"].push(item);
            }
        }
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (var _b = 0, _c = this.errors; _b < _c.length; _b++) {
                var item = _c[_b];
                data["errors"].push(item);
            }
        }
        if (Array.isArray(this.warnings)) {
            data["warnings"] = [];
            for (var _d = 0, _e = this.warnings; _d < _e.length; _d++) {
                var item = _e[_d];
                data["warnings"].push(item);
            }
        }
        return data;
    };
    return BulkPackageValidationResult;
}());
export { BulkPackageValidationResult };
export var RegionType;
(function (RegionType) {
    RegionType[RegionType["Unknown"] = 0] = "Unknown";
    RegionType[RegionType["Metro"] = 1] = "Metro";
    RegionType[RegionType["Regional"] = 2] = "Regional";
    RegionType[RegionType["Country"] = 3] = "Country";
})(RegionType || (RegionType = {}));
var BrandCustomerRegionDto = /** @class */ (function () {
    function BrandCustomerRegionDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BrandCustomerRegionDto.prototype.init = function (data) {
        if (data) {
            this.postCode = data["postCode"];
            this.suburb = data["suburb"];
            this.state = data["state"];
            this.regionType = data["regionType"];
            this.brandId = data["brandId"];
            this.id = data["id"];
        }
    };
    BrandCustomerRegionDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BrandCustomerRegionDto();
        result.init(data);
        return result;
    };
    BrandCustomerRegionDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["postCode"] = this.postCode;
        data["suburb"] = this.suburb;
        data["state"] = this.state;
        data["regionType"] = this.regionType;
        data["brandId"] = this.brandId;
        data["id"] = this.id;
        return data;
    };
    return BrandCustomerRegionDto;
}());
export { BrandCustomerRegionDto };
var GetBrandCustomerRegionForViewDto = /** @class */ (function () {
    function GetBrandCustomerRegionForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetBrandCustomerRegionForViewDto.prototype.init = function (data) {
        if (data) {
            this.brandCustomerRegion = data["brandCustomerRegion"] ? BrandCustomerRegionDto.fromJS(data["brandCustomerRegion"]) : undefined;
            this.brandName = data["brandName"];
        }
    };
    GetBrandCustomerRegionForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetBrandCustomerRegionForViewDto();
        result.init(data);
        return result;
    };
    GetBrandCustomerRegionForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["brandCustomerRegion"] = this.brandCustomerRegion ? this.brandCustomerRegion.toJSON() : undefined;
        data["brandName"] = this.brandName;
        return data;
    };
    return GetBrandCustomerRegionForViewDto;
}());
export { GetBrandCustomerRegionForViewDto };
var PagedResultDtoOfGetBrandCustomerRegionForViewDto = /** @class */ (function () {
    function PagedResultDtoOfGetBrandCustomerRegionForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfGetBrandCustomerRegionForViewDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(GetBrandCustomerRegionForViewDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfGetBrandCustomerRegionForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfGetBrandCustomerRegionForViewDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfGetBrandCustomerRegionForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfGetBrandCustomerRegionForViewDto;
}());
export { PagedResultDtoOfGetBrandCustomerRegionForViewDto };
var CreateOrEditBrandCustomerRegionDto = /** @class */ (function () {
    function CreateOrEditBrandCustomerRegionDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateOrEditBrandCustomerRegionDto.prototype.init = function (data) {
        if (data) {
            this.postCode = data["postCode"];
            this.regionType = data["regionType"];
            this.brandId = data["brandId"];
            this.id = data["id"];
        }
    };
    CreateOrEditBrandCustomerRegionDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrEditBrandCustomerRegionDto();
        result.init(data);
        return result;
    };
    CreateOrEditBrandCustomerRegionDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["postCode"] = this.postCode;
        data["regionType"] = this.regionType;
        data["brandId"] = this.brandId;
        data["id"] = this.id;
        return data;
    };
    return CreateOrEditBrandCustomerRegionDto;
}());
export { CreateOrEditBrandCustomerRegionDto };
var GetBrandCustomerRegionForEditOutput = /** @class */ (function () {
    function GetBrandCustomerRegionForEditOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetBrandCustomerRegionForEditOutput.prototype.init = function (data) {
        if (data) {
            this.brandCustomerRegion = data["brandCustomerRegion"] ? CreateOrEditBrandCustomerRegionDto.fromJS(data["brandCustomerRegion"]) : undefined;
            this.brandName = data["brandName"];
        }
    };
    GetBrandCustomerRegionForEditOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetBrandCustomerRegionForEditOutput();
        result.init(data);
        return result;
    };
    GetBrandCustomerRegionForEditOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["brandCustomerRegion"] = this.brandCustomerRegion ? this.brandCustomerRegion.toJSON() : undefined;
        data["brandName"] = this.brandName;
        return data;
    };
    return GetBrandCustomerRegionForEditOutput;
}());
export { GetBrandCustomerRegionForEditOutput };
export var RegionValue;
(function (RegionValue) {
    RegionValue[RegionValue["Unknown"] = 0] = "Unknown";
    RegionValue[RegionValue["SameState"] = 1] = "SameState";
    RegionValue[RegionValue["CrossBorder"] = 2] = "CrossBorder";
    RegionValue[RegionValue["Connections"] = 3] = "Connections";
    RegionValue[RegionValue["Adelaide"] = 4] = "Adelaide";
    RegionValue[RegionValue["Melbourne"] = 5] = "Melbourne";
    RegionValue[RegionValue["Sydney"] = 6] = "Sydney";
    RegionValue[RegionValue["Brisbane"] = 7] = "Brisbane";
    RegionValue[RegionValue["Perth"] = 8] = "Perth";
    RegionValue[RegionValue["ACT"] = 9] = "ACT";
    RegionValue[RegionValue["SA"] = 10] = "SA";
    RegionValue[RegionValue["VIC"] = 11] = "VIC";
    RegionValue[RegionValue["NSW"] = 12] = "NSW";
    RegionValue[RegionValue["TAS"] = 13] = "TAS";
    RegionValue[RegionValue["QLD"] = 14] = "QLD";
    RegionValue[RegionValue["WA"] = 15] = "WA";
    RegionValue[RegionValue["NT"] = 16] = "NT";
})(RegionValue || (RegionValue = {}));
var BrandRegionSLADto = /** @class */ (function () {
    function BrandRegionSLADto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BrandRegionSLADto.prototype.init = function (data) {
        if (data) {
            this.regionType = data["regionType"];
            this.regionValue = data["regionValue"];
            this.slaDays = data["slaDays"];
            this.eventCutOffDate = data["eventCutOffDate"] ? moment(data["eventCutOffDate"].toString()) : undefined;
            this.daysBeforeSLADateAtRisk = data["daysBeforeSLADateAtRisk"];
            this.brandId = data["brandId"];
            this.id = data["id"];
        }
    };
    BrandRegionSLADto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BrandRegionSLADto();
        result.init(data);
        return result;
    };
    BrandRegionSLADto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["regionType"] = this.regionType;
        data["regionValue"] = this.regionValue;
        data["slaDays"] = this.slaDays;
        data["eventCutOffDate"] = this.eventCutOffDate ? this.eventCutOffDate.toISOString() : undefined;
        data["daysBeforeSLADateAtRisk"] = this.daysBeforeSLADateAtRisk;
        data["brandId"] = this.brandId;
        data["id"] = this.id;
        return data;
    };
    return BrandRegionSLADto;
}());
export { BrandRegionSLADto };
var GetBrandRegionSLAForViewDto = /** @class */ (function () {
    function GetBrandRegionSLAForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetBrandRegionSLAForViewDto.prototype.init = function (data) {
        if (data) {
            this.brandRegionSLA = data["brandRegionSLA"] ? BrandRegionSLADto.fromJS(data["brandRegionSLA"]) : undefined;
            this.brandName = data["brandName"];
        }
    };
    GetBrandRegionSLAForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetBrandRegionSLAForViewDto();
        result.init(data);
        return result;
    };
    GetBrandRegionSLAForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["brandRegionSLA"] = this.brandRegionSLA ? this.brandRegionSLA.toJSON() : undefined;
        data["brandName"] = this.brandName;
        return data;
    };
    return GetBrandRegionSLAForViewDto;
}());
export { GetBrandRegionSLAForViewDto };
var PagedResultDtoOfGetBrandRegionSLAForViewDto = /** @class */ (function () {
    function PagedResultDtoOfGetBrandRegionSLAForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfGetBrandRegionSLAForViewDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(GetBrandRegionSLAForViewDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfGetBrandRegionSLAForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfGetBrandRegionSLAForViewDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfGetBrandRegionSLAForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfGetBrandRegionSLAForViewDto;
}());
export { PagedResultDtoOfGetBrandRegionSLAForViewDto };
var CreateOrEditBrandRegionSLADto = /** @class */ (function () {
    function CreateOrEditBrandRegionSLADto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateOrEditBrandRegionSLADto.prototype.init = function (data) {
        if (data) {
            this.regionType = data["regionType"];
            this.regionValue = data["regionValue"];
            this.slaDays = data["slaDays"];
            this.eventCutOffDate = data["eventCutOffDate"] ? moment(data["eventCutOffDate"].toString()) : undefined;
            this.daysBeforeSLADateAtRisk = data["daysBeforeSLADateAtRisk"];
            this.brandId = data["brandId"];
            this.id = data["id"];
        }
    };
    CreateOrEditBrandRegionSLADto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrEditBrandRegionSLADto();
        result.init(data);
        return result;
    };
    CreateOrEditBrandRegionSLADto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["regionType"] = this.regionType;
        data["regionValue"] = this.regionValue;
        data["slaDays"] = this.slaDays;
        data["eventCutOffDate"] = this.eventCutOffDate ? this.eventCutOffDate.toISOString() : undefined;
        data["daysBeforeSLADateAtRisk"] = this.daysBeforeSLADateAtRisk;
        data["brandId"] = this.brandId;
        data["id"] = this.id;
        return data;
    };
    return CreateOrEditBrandRegionSLADto;
}());
export { CreateOrEditBrandRegionSLADto };
var GetBrandRegionSLAForEditOutput = /** @class */ (function () {
    function GetBrandRegionSLAForEditOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetBrandRegionSLAForEditOutput.prototype.init = function (data) {
        if (data) {
            this.brandRegionSLA = data["brandRegionSLA"] ? CreateOrEditBrandRegionSLADto.fromJS(data["brandRegionSLA"]) : undefined;
            this.brandName = data["brandName"];
        }
    };
    GetBrandRegionSLAForEditOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetBrandRegionSLAForEditOutput();
        result.init(data);
        return result;
    };
    GetBrandRegionSLAForEditOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["brandRegionSLA"] = this.brandRegionSLA ? this.brandRegionSLA.toJSON() : undefined;
        data["brandName"] = this.brandName;
        return data;
    };
    return GetBrandRegionSLAForEditOutput;
}());
export { GetBrandRegionSLAForEditOutput };
var BrandDto = /** @class */ (function () {
    function BrandDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BrandDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.rtsCarrierCode = data["rtsCarrierCode"];
            this.id = data["id"];
        }
    };
    BrandDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BrandDto();
        result.init(data);
        return result;
    };
    BrandDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["rtsCarrierCode"] = this.rtsCarrierCode;
        data["id"] = this.id;
        return data;
    };
    return BrandDto;
}());
export { BrandDto };
var GetBrandForViewDto = /** @class */ (function () {
    function GetBrandForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetBrandForViewDto.prototype.init = function (data) {
        if (data) {
            this.brand = data["brand"] ? BrandDto.fromJS(data["brand"]) : undefined;
        }
    };
    GetBrandForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetBrandForViewDto();
        result.init(data);
        return result;
    };
    GetBrandForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["brand"] = this.brand ? this.brand.toJSON() : undefined;
        return data;
    };
    return GetBrandForViewDto;
}());
export { GetBrandForViewDto };
var PagedResultDtoOfGetBrandForViewDto = /** @class */ (function () {
    function PagedResultDtoOfGetBrandForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfGetBrandForViewDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(GetBrandForViewDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfGetBrandForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfGetBrandForViewDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfGetBrandForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfGetBrandForViewDto;
}());
export { PagedResultDtoOfGetBrandForViewDto };
var CreateOrEditBrandDto = /** @class */ (function () {
    function CreateOrEditBrandDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateOrEditBrandDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.rtsCarrierCode = data["rtsCarrierCode"];
            this.id = data["id"];
        }
    };
    CreateOrEditBrandDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrEditBrandDto();
        result.init(data);
        return result;
    };
    CreateOrEditBrandDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["rtsCarrierCode"] = this.rtsCarrierCode;
        data["id"] = this.id;
        return data;
    };
    return CreateOrEditBrandDto;
}());
export { CreateOrEditBrandDto };
var GetBrandForEditOutput = /** @class */ (function () {
    function GetBrandForEditOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetBrandForEditOutput.prototype.init = function (data) {
        if (data) {
            this.brand = data["brand"] ? CreateOrEditBrandDto.fromJS(data["brand"]) : undefined;
        }
    };
    GetBrandForEditOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetBrandForEditOutput();
        result.init(data);
        return result;
    };
    GetBrandForEditOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["brand"] = this.brand ? this.brand.toJSON() : undefined;
        return data;
    };
    return GetBrandForEditOutput;
}());
export { GetBrandForEditOutput };
var BurndownEventDto = /** @class */ (function () {
    function BurndownEventDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BurndownEventDto.prototype.init = function (data) {
        if (data) {
            this.burndownStartDate = data["burndownStartDate"] ? moment(data["burndownStartDate"].toString()) : undefined;
            this.burndownEndDate = data["burndownEndDate"] ? moment(data["burndownEndDate"].toString()) : undefined;
            this.dashboardText = data["dashboardText"];
            this.id = data["id"];
        }
    };
    BurndownEventDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BurndownEventDto();
        result.init(data);
        return result;
    };
    BurndownEventDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["burndownStartDate"] = this.burndownStartDate ? this.burndownStartDate.toISOString() : undefined;
        data["burndownEndDate"] = this.burndownEndDate ? this.burndownEndDate.toISOString() : undefined;
        data["dashboardText"] = this.dashboardText;
        data["id"] = this.id;
        return data;
    };
    return BurndownEventDto;
}());
export { BurndownEventDto };
var GetBurndownEventForViewDto = /** @class */ (function () {
    function GetBurndownEventForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetBurndownEventForViewDto.prototype.init = function (data) {
        if (data) {
            this.burndownEvent = data["burndownEvent"] ? BurndownEventDto.fromJS(data["burndownEvent"]) : undefined;
        }
    };
    GetBurndownEventForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetBurndownEventForViewDto();
        result.init(data);
        return result;
    };
    GetBurndownEventForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["burndownEvent"] = this.burndownEvent ? this.burndownEvent.toJSON() : undefined;
        return data;
    };
    return GetBurndownEventForViewDto;
}());
export { GetBurndownEventForViewDto };
var PagedResultDtoOfGetBurndownEventForViewDto = /** @class */ (function () {
    function PagedResultDtoOfGetBurndownEventForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfGetBurndownEventForViewDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(GetBurndownEventForViewDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfGetBurndownEventForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfGetBurndownEventForViewDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfGetBurndownEventForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfGetBurndownEventForViewDto;
}());
export { PagedResultDtoOfGetBurndownEventForViewDto };
var CreateOrEditBurndownEventDto = /** @class */ (function () {
    function CreateOrEditBurndownEventDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateOrEditBurndownEventDto.prototype.init = function (data) {
        if (data) {
            this.burndownStartDate = data["burndownStartDate"] ? moment(data["burndownStartDate"].toString()) : undefined;
            this.burndownEndDate = data["burndownEndDate"] ? moment(data["burndownEndDate"].toString()) : undefined;
            this.dashboardText = data["dashboardText"];
            this.id = data["id"];
        }
    };
    CreateOrEditBurndownEventDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrEditBurndownEventDto();
        result.init(data);
        return result;
    };
    CreateOrEditBurndownEventDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["burndownStartDate"] = this.burndownStartDate ? this.burndownStartDate.toISOString() : undefined;
        data["burndownEndDate"] = this.burndownEndDate ? this.burndownEndDate.toISOString() : undefined;
        data["dashboardText"] = this.dashboardText;
        data["id"] = this.id;
        return data;
    };
    return CreateOrEditBurndownEventDto;
}());
export { CreateOrEditBurndownEventDto };
var GetBurndownEventForEditOutput = /** @class */ (function () {
    function GetBurndownEventForEditOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetBurndownEventForEditOutput.prototype.init = function (data) {
        if (data) {
            this.burndownEvent = data["burndownEvent"] ? CreateOrEditBurndownEventDto.fromJS(data["burndownEvent"]) : undefined;
        }
    };
    GetBurndownEventForEditOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetBurndownEventForEditOutput();
        result.init(data);
        return result;
    };
    GetBurndownEventForEditOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["burndownEvent"] = this.burndownEvent ? this.burndownEvent.toJSON() : undefined;
        return data;
    };
    return GetBurndownEventForEditOutput;
}());
export { GetBurndownEventForEditOutput };
var CacheDto = /** @class */ (function () {
    function CacheDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CacheDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
        }
    };
    CacheDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CacheDto();
        result.init(data);
        return result;
    };
    CacheDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    };
    return CacheDto;
}());
export { CacheDto };
var ListResultDtoOfCacheDto = /** @class */ (function () {
    function ListResultDtoOfCacheDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ListResultDtoOfCacheDto.prototype.init = function (data) {
        if (data) {
            if (Array.isArray(data["items"])) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(CacheDto.fromJS(item));
                }
            }
        }
    };
    ListResultDtoOfCacheDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ListResultDtoOfCacheDto();
        result.init(data);
        return result;
    };
    ListResultDtoOfCacheDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return ListResultDtoOfCacheDto;
}());
export { ListResultDtoOfCacheDto };
var EntityDtoOfString = /** @class */ (function () {
    function EntityDtoOfString(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EntityDtoOfString.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
        }
    };
    EntityDtoOfString.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new EntityDtoOfString();
        result.init(data);
        return result;
    };
    EntityDtoOfString.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    };
    return EntityDtoOfString;
}());
export { EntityDtoOfString };
var CarrierDto = /** @class */ (function () {
    function CarrierDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CarrierDto.prototype.init = function (data) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.isDriver = data["isDriver"];
            this.manifestJob = data["manifestJob"];
            this.depotLocationId = data["depotLocationId"];
            this.d365Entity = data["d365Entity"];
            this.email = data["email"];
            this.id = data["id"];
        }
    };
    CarrierDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CarrierDto();
        result.init(data);
        return result;
    };
    CarrierDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["isDriver"] = this.isDriver;
        data["manifestJob"] = this.manifestJob;
        data["depotLocationId"] = this.depotLocationId;
        data["d365Entity"] = this.d365Entity;
        data["email"] = this.email;
        data["id"] = this.id;
        return data;
    };
    return CarrierDto;
}());
export { CarrierDto };
var GetCarrierForViewDto = /** @class */ (function () {
    function GetCarrierForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetCarrierForViewDto.prototype.init = function (data) {
        if (data) {
            this.carrier = data["carrier"] ? CarrierDto.fromJS(data["carrier"]) : undefined;
            this.depotLocationName = data["depotLocationName"];
            this.courierName = data["courierName"];
            this.courierCode = data["courierCode"];
        }
    };
    GetCarrierForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetCarrierForViewDto();
        result.init(data);
        return result;
    };
    GetCarrierForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["carrier"] = this.carrier ? this.carrier.toJSON() : undefined;
        data["depotLocationName"] = this.depotLocationName;
        data["courierName"] = this.courierName;
        data["courierCode"] = this.courierCode;
        return data;
    };
    return GetCarrierForViewDto;
}());
export { GetCarrierForViewDto };
var PagedResultDtoOfGetCarrierForViewDto = /** @class */ (function () {
    function PagedResultDtoOfGetCarrierForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfGetCarrierForViewDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(GetCarrierForViewDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfGetCarrierForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfGetCarrierForViewDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfGetCarrierForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfGetCarrierForViewDto;
}());
export { PagedResultDtoOfGetCarrierForViewDto };
var CreateOrEditCarrierDto = /** @class */ (function () {
    function CreateOrEditCarrierDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateOrEditCarrierDto.prototype.init = function (data) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.isDriver = data["isDriver"];
            this.manifestJob = data["manifestJob"];
            this.courierId = data["courierId"];
            this.d365Entity = data["d365Entity"];
            this.depotLocationId = data["depotLocationId"];
            this.email = data["email"];
            this.id = data["id"];
        }
    };
    CreateOrEditCarrierDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrEditCarrierDto();
        result.init(data);
        return result;
    };
    CreateOrEditCarrierDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["isDriver"] = this.isDriver;
        data["manifestJob"] = this.manifestJob;
        data["courierId"] = this.courierId;
        data["d365Entity"] = this.d365Entity;
        data["depotLocationId"] = this.depotLocationId;
        data["email"] = this.email;
        data["id"] = this.id;
        return data;
    };
    return CreateOrEditCarrierDto;
}());
export { CreateOrEditCarrierDto };
var CourierDto = /** @class */ (function () {
    function CourierDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CourierDto.prototype.init = function (data) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.id = data["id"];
        }
    };
    CourierDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CourierDto();
        result.init(data);
        return result;
    };
    CourierDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    };
    return CourierDto;
}());
export { CourierDto };
var GetCarrierForEditOutput = /** @class */ (function () {
    function GetCarrierForEditOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetCarrierForEditOutput.prototype.init = function (data) {
        if (data) {
            this.carrier = data["carrier"] ? CreateOrEditCarrierDto.fromJS(data["carrier"]) : undefined;
            this.courier = data["courier"] ? CourierDto.fromJS(data["courier"]) : undefined;
            this.depotLocationName = data["depotLocationName"];
        }
    };
    GetCarrierForEditOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetCarrierForEditOutput();
        result.init(data);
        return result;
    };
    GetCarrierForEditOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["carrier"] = this.carrier ? this.carrier.toJSON() : undefined;
        data["courier"] = this.courier ? this.courier.toJSON() : undefined;
        data["depotLocationName"] = this.depotLocationName;
        return data;
    };
    return GetCarrierForEditOutput;
}());
export { GetCarrierForEditOutput };
export var FriendshipState;
(function (FriendshipState) {
    FriendshipState[FriendshipState["Accepted"] = 1] = "Accepted";
    FriendshipState[FriendshipState["Blocked"] = 2] = "Blocked";
})(FriendshipState || (FriendshipState = {}));
var FriendDto = /** @class */ (function () {
    function FriendDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FriendDto.prototype.init = function (data) {
        if (data) {
            this.friendUserId = data["friendUserId"];
            this.friendTenantId = data["friendTenantId"];
            this.friendUserName = data["friendUserName"];
            this.friendTenancyName = data["friendTenancyName"];
            this.friendProfilePictureId = data["friendProfilePictureId"];
            this.unreadMessageCount = data["unreadMessageCount"];
            this.isOnline = data["isOnline"];
            this.state = data["state"];
        }
    };
    FriendDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FriendDto();
        result.init(data);
        return result;
    };
    FriendDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["friendUserId"] = this.friendUserId;
        data["friendTenantId"] = this.friendTenantId;
        data["friendUserName"] = this.friendUserName;
        data["friendTenancyName"] = this.friendTenancyName;
        data["friendProfilePictureId"] = this.friendProfilePictureId;
        data["unreadMessageCount"] = this.unreadMessageCount;
        data["isOnline"] = this.isOnline;
        data["state"] = this.state;
        return data;
    };
    return FriendDto;
}());
export { FriendDto };
var GetUserChatFriendsWithSettingsOutput = /** @class */ (function () {
    function GetUserChatFriendsWithSettingsOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetUserChatFriendsWithSettingsOutput.prototype.init = function (data) {
        if (data) {
            this.serverTime = data["serverTime"] ? moment(data["serverTime"].toString()) : undefined;
            if (Array.isArray(data["friends"])) {
                this.friends = [];
                for (var _i = 0, _a = data["friends"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.friends.push(FriendDto.fromJS(item));
                }
            }
        }
    };
    GetUserChatFriendsWithSettingsOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetUserChatFriendsWithSettingsOutput();
        result.init(data);
        return result;
    };
    GetUserChatFriendsWithSettingsOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["serverTime"] = this.serverTime ? this.serverTime.toISOString() : undefined;
        if (Array.isArray(this.friends)) {
            data["friends"] = [];
            for (var _i = 0, _a = this.friends; _i < _a.length; _i++) {
                var item = _a[_i];
                data["friends"].push(item.toJSON());
            }
        }
        return data;
    };
    return GetUserChatFriendsWithSettingsOutput;
}());
export { GetUserChatFriendsWithSettingsOutput };
export var ChatSide;
(function (ChatSide) {
    ChatSide[ChatSide["Sender"] = 1] = "Sender";
    ChatSide[ChatSide["Receiver"] = 2] = "Receiver";
})(ChatSide || (ChatSide = {}));
export var ChatMessageReadState;
(function (ChatMessageReadState) {
    ChatMessageReadState[ChatMessageReadState["Unread"] = 1] = "Unread";
    ChatMessageReadState[ChatMessageReadState["Read"] = 2] = "Read";
})(ChatMessageReadState || (ChatMessageReadState = {}));
var ChatMessageDto = /** @class */ (function () {
    function ChatMessageDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ChatMessageDto.prototype.init = function (data) {
        if (data) {
            this.userId = data["userId"];
            this.tenantId = data["tenantId"];
            this.targetUserId = data["targetUserId"];
            this.targetTenantId = data["targetTenantId"];
            this.side = data["side"];
            this.readState = data["readState"];
            this.receiverReadState = data["receiverReadState"];
            this.message = data["message"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.sharedMessageId = data["sharedMessageId"];
            this.id = data["id"];
        }
    };
    ChatMessageDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ChatMessageDto();
        result.init(data);
        return result;
    };
    ChatMessageDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["targetUserId"] = this.targetUserId;
        data["targetTenantId"] = this.targetTenantId;
        data["side"] = this.side;
        data["readState"] = this.readState;
        data["receiverReadState"] = this.receiverReadState;
        data["message"] = this.message;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["sharedMessageId"] = this.sharedMessageId;
        data["id"] = this.id;
        return data;
    };
    return ChatMessageDto;
}());
export { ChatMessageDto };
var ListResultDtoOfChatMessageDto = /** @class */ (function () {
    function ListResultDtoOfChatMessageDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ListResultDtoOfChatMessageDto.prototype.init = function (data) {
        if (data) {
            if (Array.isArray(data["items"])) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(ChatMessageDto.fromJS(item));
                }
            }
        }
    };
    ListResultDtoOfChatMessageDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ListResultDtoOfChatMessageDto();
        result.init(data);
        return result;
    };
    ListResultDtoOfChatMessageDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return ListResultDtoOfChatMessageDto;
}());
export { ListResultDtoOfChatMessageDto };
var MarkAllUnreadMessagesOfUserAsReadInput = /** @class */ (function () {
    function MarkAllUnreadMessagesOfUserAsReadInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MarkAllUnreadMessagesOfUserAsReadInput.prototype.init = function (data) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
        }
    };
    MarkAllUnreadMessagesOfUserAsReadInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new MarkAllUnreadMessagesOfUserAsReadInput();
        result.init(data);
        return result;
    };
    MarkAllUnreadMessagesOfUserAsReadInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        return data;
    };
    return MarkAllUnreadMessagesOfUserAsReadInput;
}());
export { MarkAllUnreadMessagesOfUserAsReadInput };
var ManifestTemplateDto = /** @class */ (function () {
    function ManifestTemplateDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ManifestTemplateDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.reqColumnsInOrder = data["reqColumnsInOrder"];
            this.lneColumnsInOrder = data["lneColumnsInOrder"];
            this.jsonSchema = data["jsonSchema"];
            this.id = data["id"];
        }
    };
    ManifestTemplateDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ManifestTemplateDto();
        result.init(data);
        return result;
    };
    ManifestTemplateDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["reqColumnsInOrder"] = this.reqColumnsInOrder;
        data["lneColumnsInOrder"] = this.lneColumnsInOrder;
        data["jsonSchema"] = this.jsonSchema;
        data["id"] = this.id;
        return data;
    };
    return ManifestTemplateDto;
}());
export { ManifestTemplateDto };
var GetClientGroupForViewDto = /** @class */ (function () {
    function GetClientGroupForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetClientGroupForViewDto.prototype.init = function (data) {
        if (data) {
            this.clientGroup = data["clientGroup"] ? ClientGroupDto.fromJS(data["clientGroup"]) : undefined;
            this.brandName = data["brandName"];
            this.depotLocationName = data["depotLocationName"];
            this.consignmentStatusDescription = data["consignmentStatusDescription"];
            this.manifestTemplateName = data["manifestTemplateName"];
            this.cutoffAlertName = data["cutoffAlertName"];
            this.manifestTemplate = data["manifestTemplate"] ? ManifestTemplateDto.fromJS(data["manifestTemplate"]) : undefined;
        }
    };
    GetClientGroupForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetClientGroupForViewDto();
        result.init(data);
        return result;
    };
    GetClientGroupForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["clientGroup"] = this.clientGroup ? this.clientGroup.toJSON() : undefined;
        data["brandName"] = this.brandName;
        data["depotLocationName"] = this.depotLocationName;
        data["consignmentStatusDescription"] = this.consignmentStatusDescription;
        data["manifestTemplateName"] = this.manifestTemplateName;
        data["cutoffAlertName"] = this.cutoffAlertName;
        data["manifestTemplate"] = this.manifestTemplate ? this.manifestTemplate.toJSON() : undefined;
        return data;
    };
    return GetClientGroupForViewDto;
}());
export { GetClientGroupForViewDto };
var PagedResultDtoOfGetClientGroupForViewDto = /** @class */ (function () {
    function PagedResultDtoOfGetClientGroupForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfGetClientGroupForViewDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(GetClientGroupForViewDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfGetClientGroupForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfGetClientGroupForViewDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfGetClientGroupForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfGetClientGroupForViewDto;
}());
export { PagedResultDtoOfGetClientGroupForViewDto };
var CreateOrEditLocationDetailDto = /** @class */ (function () {
    function CreateOrEditLocationDetailDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateOrEditLocationDetailDto.prototype.init = function (data) {
        if (data) {
            this.latitude = data["latitude"];
            this.longitude = data["longitude"];
            this.state = data["state"];
            this.isBusiness = data["isBusiness"];
            this.postalCode = data["postalCode"];
            this.businessName = data["businessName"];
            this.addressLine1 = data["addressLine1"];
            this.addressLine2 = data["addressLine2"];
            this.suburb = data["suburb"];
            this.storeId = data["storeId"];
            this.jsonData = data["jsonData"];
            this.deliveryTimeFrom = data["deliveryTimeFrom"];
            this.deliveryTimeTo = data["deliveryTimeTo"];
            this.businessDetails = data["businessDetails"] ? BusinessDetail.fromJS(data["businessDetails"]) : undefined;
            this.id = data["id"];
        }
    };
    CreateOrEditLocationDetailDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrEditLocationDetailDto();
        result.init(data);
        return result;
    };
    CreateOrEditLocationDetailDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["state"] = this.state;
        data["isBusiness"] = this.isBusiness;
        data["postalCode"] = this.postalCode;
        data["businessName"] = this.businessName;
        data["addressLine1"] = this.addressLine1;
        data["addressLine2"] = this.addressLine2;
        data["suburb"] = this.suburb;
        data["storeId"] = this.storeId;
        data["jsonData"] = this.jsonData;
        data["deliveryTimeFrom"] = this.deliveryTimeFrom;
        data["deliveryTimeTo"] = this.deliveryTimeTo;
        data["businessDetails"] = this.businessDetails ? this.businessDetails.toJSON() : undefined;
        data["id"] = this.id;
        return data;
    };
    return CreateOrEditLocationDetailDto;
}());
export { CreateOrEditLocationDetailDto };
var CreateOrEditLocationDto = /** @class */ (function () {
    function CreateOrEditLocationDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateOrEditLocationDto.prototype.init = function (data) {
        if (data) {
            this.fullAddress = data["fullAddress"];
            this.hasGeocode = data["hasGeocode"];
            this.ignoredAt = data["ignoredAt"] ? moment(data["ignoredAt"].toString()) : undefined;
            this.locationDetailId = data["locationDetailId"];
            this.locationDetail = data["locationDetail"] ? CreateOrEditLocationDetailDto.fromJS(data["locationDetail"]) : undefined;
            this.id = data["id"];
        }
    };
    CreateOrEditLocationDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrEditLocationDto();
        result.init(data);
        return result;
    };
    CreateOrEditLocationDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["fullAddress"] = this.fullAddress;
        data["hasGeocode"] = this.hasGeocode;
        data["ignoredAt"] = this.ignoredAt ? this.ignoredAt.toISOString() : undefined;
        data["locationDetailId"] = this.locationDetailId;
        data["locationDetail"] = this.locationDetail ? this.locationDetail.toJSON() : undefined;
        data["id"] = this.id;
        return data;
    };
    return CreateOrEditLocationDto;
}());
export { CreateOrEditLocationDto };
var CreateOrEditClientGroupDto = /** @class */ (function () {
    function CreateOrEditClientGroupDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateOrEditClientGroupDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.cutoffTime = data["cutoffTime"];
            this.signatureRequired = data["signatureRequired"];
            this.brandId = data["brandId"];
            this.depotLocationId = data["depotLocationId"];
            this.consignmentStatusId = data["consignmentStatusId"];
            this.manifestTemplateId = data["manifestTemplateId"];
            this.d365Entity = data["d365Entity"];
            this.cutoffAlert = data["cutoffAlert"];
            this.locationId = data["locationId"];
            this.location = data["location"] ? CreateOrEditLocationDto.fromJS(data["location"]) : undefined;
            this.type = data["type"];
            this.id = data["id"];
        }
    };
    CreateOrEditClientGroupDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrEditClientGroupDto();
        result.init(data);
        return result;
    };
    CreateOrEditClientGroupDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["cutoffTime"] = this.cutoffTime;
        data["signatureRequired"] = this.signatureRequired;
        data["brandId"] = this.brandId;
        data["depotLocationId"] = this.depotLocationId;
        data["consignmentStatusId"] = this.consignmentStatusId;
        data["manifestTemplateId"] = this.manifestTemplateId;
        data["d365Entity"] = this.d365Entity;
        data["cutoffAlert"] = this.cutoffAlert;
        data["locationId"] = this.locationId;
        data["location"] = this.location ? this.location.toJSON() : undefined;
        data["type"] = this.type;
        data["id"] = this.id;
        return data;
    };
    return CreateOrEditClientGroupDto;
}());
export { CreateOrEditClientGroupDto };
var GetClientGroupForEditOutput = /** @class */ (function () {
    function GetClientGroupForEditOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetClientGroupForEditOutput.prototype.init = function (data) {
        if (data) {
            this.clientGroup = data["clientGroup"] ? CreateOrEditClientGroupDto.fromJS(data["clientGroup"]) : undefined;
            this.brandName = data["brandName"];
            this.depotLocationName = data["depotLocationName"];
            this.consignmentStatusDescription = data["consignmentStatusDescription"];
            this.manifestTemplateName = data["manifestTemplateName"];
            this.cutoffAlertName = data["cutoffAlertName"];
        }
    };
    GetClientGroupForEditOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetClientGroupForEditOutput();
        result.init(data);
        return result;
    };
    GetClientGroupForEditOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["clientGroup"] = this.clientGroup ? this.clientGroup.toJSON() : undefined;
        data["brandName"] = this.brandName;
        data["depotLocationName"] = this.depotLocationName;
        data["consignmentStatusDescription"] = this.consignmentStatusDescription;
        data["manifestTemplateName"] = this.manifestTemplateName;
        data["cutoffAlertName"] = this.cutoffAlertName;
        return data;
    };
    return GetClientGroupForEditOutput;
}());
export { GetClientGroupForEditOutput };
var AramexSecretDto = /** @class */ (function () {
    function AramexSecretDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AramexSecretDto.prototype.init = function (data) {
        if (data) {
            this.clientId = data["clientId"];
            this.secret = data["secret"];
        }
    };
    AramexSecretDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AramexSecretDto();
        result.init(data);
        return result;
    };
    AramexSecretDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["secret"] = this.secret;
        return data;
    };
    return AramexSecretDto;
}());
export { AramexSecretDto };
var AramexConfigDto = /** @class */ (function () {
    function AramexConfigDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AramexConfigDto.prototype.init = function (data) {
        if (data) {
            this.isResellerAccount = data["isResellerAccount"];
            this.resellerAccount = data["resellerAccount"];
            this.parentAccount = data["parentAccount"];
            this.childAccountRef = data["childAccountRef"];
            this.childSecret = data["childSecret"] ? AramexSecretDto.fromJS(data["childSecret"]) : undefined;
            this.emailSent = data["emailSent"];
        }
    };
    AramexConfigDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AramexConfigDto();
        result.init(data);
        return result;
    };
    AramexConfigDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["isResellerAccount"] = this.isResellerAccount;
        data["resellerAccount"] = this.resellerAccount;
        data["parentAccount"] = this.parentAccount;
        data["childAccountRef"] = this.childAccountRef;
        data["childSecret"] = this.childSecret ? this.childSecret.toJSON() : undefined;
        data["emailSent"] = this.emailSent;
        return data;
    };
    return AramexConfigDto;
}());
export { AramexConfigDto };
var ClientPickupLocationConfigDto = /** @class */ (function () {
    function ClientPickupLocationConfigDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ClientPickupLocationConfigDto.prototype.init = function (data) {
        if (data) {
            this.locationId = data["locationId"];
            this.clientCode = data["clientCode"];
            this.aramexConfig = data["aramexConfig"] ? AramexConfigDto.fromJS(data["aramexConfig"]) : undefined;
        }
    };
    ClientPickupLocationConfigDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ClientPickupLocationConfigDto();
        result.init(data);
        return result;
    };
    ClientPickupLocationConfigDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        data["clientCode"] = this.clientCode;
        data["aramexConfig"] = this.aramexConfig ? this.aramexConfig.toJSON() : undefined;
        return data;
    };
    return ClientPickupLocationConfigDto;
}());
export { ClientPickupLocationConfigDto };
var ClientDto = /** @class */ (function () {
    function ClientDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ClientDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.leadTime = data["leadTime"];
            this.notificationEmail = data["notificationEmail"];
            this.code = data["code"];
            this.clientGroupId = data["clientGroupId"];
            this.clientGroup = data["clientGroup"] ? ClientGroupDto.fromJS(data["clientGroup"]) : undefined;
            this.locationId = data["locationId"];
            this.location = data["location"] ? LocationDto.fromJS(data["location"]) : undefined;
            this.auto3PLExport = data["auto3PLExport"];
            this.rosterLogicEnabled = data["rosterLogicEnabled"];
            this.vpsPickupRosterLogicEnabled = data["vpsPickupRosterLogicEnabled"];
            this.vpsPickupRoster = data["vpsPickupRoster"] ? BusinessDetail.fromJS(data["vpsPickupRoster"]) : undefined;
            if (Array.isArray(data["pickupLocationsConfig"])) {
                this.pickupLocationsConfig = [];
                for (var _i = 0, _a = data["pickupLocationsConfig"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.pickupLocationsConfig.push(ClientPickupLocationConfigDto.fromJS(item));
                }
            }
            this.id = data["id"];
        }
    };
    ClientDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ClientDto();
        result.init(data);
        return result;
    };
    ClientDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["leadTime"] = this.leadTime;
        data["notificationEmail"] = this.notificationEmail;
        data["code"] = this.code;
        data["clientGroupId"] = this.clientGroupId;
        data["clientGroup"] = this.clientGroup ? this.clientGroup.toJSON() : undefined;
        data["locationId"] = this.locationId;
        data["location"] = this.location ? this.location.toJSON() : undefined;
        data["auto3PLExport"] = this.auto3PLExport;
        data["rosterLogicEnabled"] = this.rosterLogicEnabled;
        data["vpsPickupRosterLogicEnabled"] = this.vpsPickupRosterLogicEnabled;
        data["vpsPickupRoster"] = this.vpsPickupRoster ? this.vpsPickupRoster.toJSON() : undefined;
        if (Array.isArray(this.pickupLocationsConfig)) {
            data["pickupLocationsConfig"] = [];
            for (var _i = 0, _a = this.pickupLocationsConfig; _i < _a.length; _i++) {
                var item = _a[_i];
                data["pickupLocationsConfig"].push(item.toJSON());
            }
        }
        data["id"] = this.id;
        return data;
    };
    return ClientDto;
}());
export { ClientDto };
var GetClientForViewDto = /** @class */ (function () {
    function GetClientForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetClientForViewDto.prototype.init = function (data) {
        if (data) {
            this.client = data["client"] ? ClientDto.fromJS(data["client"]) : undefined;
            this.clientGroupName = data["clientGroupName"];
        }
    };
    GetClientForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetClientForViewDto();
        result.init(data);
        return result;
    };
    GetClientForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["client"] = this.client ? this.client.toJSON() : undefined;
        data["clientGroupName"] = this.clientGroupName;
        return data;
    };
    return GetClientForViewDto;
}());
export { GetClientForViewDto };
var PagedResultDtoOfGetClientForViewDto = /** @class */ (function () {
    function PagedResultDtoOfGetClientForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfGetClientForViewDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(GetClientForViewDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfGetClientForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfGetClientForViewDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfGetClientForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfGetClientForViewDto;
}());
export { PagedResultDtoOfGetClientForViewDto };
var CreateOrEditClientDto = /** @class */ (function () {
    function CreateOrEditClientDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateOrEditClientDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.leadTime = data["leadTime"];
            this.notificationEmail = data["notificationEmail"];
            this.code = data["code"];
            this.state = data["state"];
            this.clientGroupId = data["clientGroupId"];
            this.locationId = data["locationId"];
            this.location = data["location"] ? CreateOrEditLocationDto.fromJS(data["location"]) : undefined;
            this.auto3PLExport = data["auto3PLExport"];
            this.rosterLogicEnabled = data["rosterLogicEnabled"];
            this.vpsPickupRosterLogicEnabled = data["vpsPickupRosterLogicEnabled"];
            this.vpsPickupRoster = data["vpsPickupRoster"] ? BusinessDetail.fromJS(data["vpsPickupRoster"]) : undefined;
            if (Array.isArray(data["pickupLocationsConfig"])) {
                this.pickupLocationsConfig = [];
                for (var _i = 0, _a = data["pickupLocationsConfig"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.pickupLocationsConfig.push(ClientPickupLocationConfigDto.fromJS(item));
                }
            }
            this.id = data["id"];
        }
    };
    CreateOrEditClientDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrEditClientDto();
        result.init(data);
        return result;
    };
    CreateOrEditClientDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["leadTime"] = this.leadTime;
        data["notificationEmail"] = this.notificationEmail;
        data["code"] = this.code;
        data["state"] = this.state;
        data["clientGroupId"] = this.clientGroupId;
        data["locationId"] = this.locationId;
        data["location"] = this.location ? this.location.toJSON() : undefined;
        data["auto3PLExport"] = this.auto3PLExport;
        data["rosterLogicEnabled"] = this.rosterLogicEnabled;
        data["vpsPickupRosterLogicEnabled"] = this.vpsPickupRosterLogicEnabled;
        data["vpsPickupRoster"] = this.vpsPickupRoster ? this.vpsPickupRoster.toJSON() : undefined;
        if (Array.isArray(this.pickupLocationsConfig)) {
            data["pickupLocationsConfig"] = [];
            for (var _i = 0, _a = this.pickupLocationsConfig; _i < _a.length; _i++) {
                var item = _a[_i];
                data["pickupLocationsConfig"].push(item.toJSON());
            }
        }
        data["id"] = this.id;
        return data;
    };
    return CreateOrEditClientDto;
}());
export { CreateOrEditClientDto };
var GetClientForEditOutput = /** @class */ (function () {
    function GetClientForEditOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetClientForEditOutput.prototype.init = function (data) {
        if (data) {
            this.client = data["client"] ? CreateOrEditClientDto.fromJS(data["client"]) : undefined;
            this.clientGroupName = data["clientGroupName"];
        }
    };
    GetClientForEditOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetClientForEditOutput();
        result.init(data);
        return result;
    };
    GetClientForEditOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["client"] = this.client ? this.client.toJSON() : undefined;
        data["clientGroupName"] = this.clientGroupName;
        return data;
    };
    return GetClientForEditOutput;
}());
export { GetClientForEditOutput };
var GetClientPickupLocationConfigKeysDto = /** @class */ (function () {
    function GetClientPickupLocationConfigKeysDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetClientPickupLocationConfigKeysDto.prototype.init = function (data) {
        if (data) {
            this.locationId = data["locationId"];
            this.courierName = data["courierName"];
            this.clientCode = data["clientCode"];
        }
    };
    GetClientPickupLocationConfigKeysDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetClientPickupLocationConfigKeysDto();
        result.init(data);
        return result;
    };
    GetClientPickupLocationConfigKeysDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        data["courierName"] = this.courierName;
        data["clientCode"] = this.clientCode;
        return data;
    };
    return GetClientPickupLocationConfigKeysDto;
}());
export { GetClientPickupLocationConfigKeysDto };
var GetClientPickupLocationConfigKeysForViewDto = /** @class */ (function () {
    function GetClientPickupLocationConfigKeysForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetClientPickupLocationConfigKeysForViewDto.prototype.init = function (data) {
        if (data) {
            this.keyName = data["keyName"];
            this.secret = data["secret"] ? AramexSecretDto.fromJS(data["secret"]) : undefined;
            this.parentAccount = data["parentAccount"];
            this.resellerAccount = data["resellerAccount"];
        }
    };
    GetClientPickupLocationConfigKeysForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetClientPickupLocationConfigKeysForViewDto();
        result.init(data);
        return result;
    };
    GetClientPickupLocationConfigKeysForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["keyName"] = this.keyName;
        data["secret"] = this.secret ? this.secret.toJSON() : undefined;
        data["parentAccount"] = this.parentAccount;
        data["resellerAccount"] = this.resellerAccount;
        return data;
    };
    return GetClientPickupLocationConfigKeysForViewDto;
}());
export { GetClientPickupLocationConfigKeysForViewDto };
var CreateOrEditClientForBrandDto = /** @class */ (function () {
    function CreateOrEditClientForBrandDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateOrEditClientForBrandDto.prototype.init = function (data) {
        if (data) {
            this.brand = data["brand"];
            this.clientGroupType = data["clientGroupType"];
            this.name = data["name"];
            this.storeNumber = data["storeNumber"];
            this.state = data["state"];
            this.postalCode = data["postalCode"];
            this.addressLine1 = data["addressLine1"];
            this.addressLine2 = data["addressLine2"];
            this.suburb = data["suburb"];
        }
    };
    CreateOrEditClientForBrandDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrEditClientForBrandDto();
        result.init(data);
        return result;
    };
    CreateOrEditClientForBrandDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["brand"] = this.brand;
        data["clientGroupType"] = this.clientGroupType;
        data["name"] = this.name;
        data["storeNumber"] = this.storeNumber;
        data["state"] = this.state;
        data["postalCode"] = this.postalCode;
        data["addressLine1"] = this.addressLine1;
        data["addressLine2"] = this.addressLine2;
        data["suburb"] = this.suburb;
        return data;
    };
    return CreateOrEditClientForBrandDto;
}());
export { CreateOrEditClientForBrandDto };
var MarketPlaceCreateOrEditClientDto = /** @class */ (function () {
    function MarketPlaceCreateOrEditClientDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MarketPlaceCreateOrEditClientDto.prototype.init = function (data) {
        if (data) {
            this.leadTime = data["leadTime"];
            this.clientGroupType = data["clientGroupType"];
            if (Array.isArray(data["additionalPickupLocations"])) {
                this.additionalPickupLocations = [];
                for (var _i = 0, _a = data["additionalPickupLocations"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.additionalPickupLocations.push(CreateOrEditLocationDto.fromJS(item));
                }
            }
            this.brand = data["brand"];
            this.storeNumber = data["storeNumber"];
            this.name = data["name"];
            this.notificationEmail = data["notificationEmail"];
            this.code = data["code"];
            this.state = data["state"];
            this.clientGroupId = data["clientGroupId"];
            this.locationId = data["locationId"];
            this.location = data["location"] ? CreateOrEditLocationDto.fromJS(data["location"]) : undefined;
            this.auto3PLExport = data["auto3PLExport"];
            this.rosterLogicEnabled = data["rosterLogicEnabled"];
            this.vpsPickupRosterLogicEnabled = data["vpsPickupRosterLogicEnabled"];
            this.vpsPickupRoster = data["vpsPickupRoster"] ? BusinessDetail.fromJS(data["vpsPickupRoster"]) : undefined;
            if (Array.isArray(data["pickupLocationsConfig"])) {
                this.pickupLocationsConfig = [];
                for (var _b = 0, _c = data["pickupLocationsConfig"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.pickupLocationsConfig.push(ClientPickupLocationConfigDto.fromJS(item));
                }
            }
            this.id = data["id"];
        }
    };
    MarketPlaceCreateOrEditClientDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new MarketPlaceCreateOrEditClientDto();
        result.init(data);
        return result;
    };
    MarketPlaceCreateOrEditClientDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["leadTime"] = this.leadTime;
        data["clientGroupType"] = this.clientGroupType;
        if (Array.isArray(this.additionalPickupLocations)) {
            data["additionalPickupLocations"] = [];
            for (var _i = 0, _a = this.additionalPickupLocations; _i < _a.length; _i++) {
                var item = _a[_i];
                data["additionalPickupLocations"].push(item.toJSON());
            }
        }
        data["brand"] = this.brand;
        data["storeNumber"] = this.storeNumber;
        data["name"] = this.name;
        data["notificationEmail"] = this.notificationEmail;
        data["code"] = this.code;
        data["state"] = this.state;
        data["clientGroupId"] = this.clientGroupId;
        data["locationId"] = this.locationId;
        data["location"] = this.location ? this.location.toJSON() : undefined;
        data["auto3PLExport"] = this.auto3PLExport;
        data["rosterLogicEnabled"] = this.rosterLogicEnabled;
        data["vpsPickupRosterLogicEnabled"] = this.vpsPickupRosterLogicEnabled;
        data["vpsPickupRoster"] = this.vpsPickupRoster ? this.vpsPickupRoster.toJSON() : undefined;
        if (Array.isArray(this.pickupLocationsConfig)) {
            data["pickupLocationsConfig"] = [];
            for (var _b = 0, _c = this.pickupLocationsConfig; _b < _c.length; _b++) {
                var item = _c[_b];
                data["pickupLocationsConfig"].push(item.toJSON());
            }
        }
        data["id"] = this.id;
        return data;
    };
    return MarketPlaceCreateOrEditClientDto;
}());
export { MarketPlaceCreateOrEditClientDto };
var SubscribableEditionComboboxItemDto = /** @class */ (function () {
    function SubscribableEditionComboboxItemDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SubscribableEditionComboboxItemDto.prototype.init = function (data) {
        if (data) {
            this.isFree = data["isFree"];
            this.value = data["value"];
            this.displayText = data["displayText"];
            this.isSelected = data["isSelected"];
        }
    };
    SubscribableEditionComboboxItemDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SubscribableEditionComboboxItemDto();
        result.init(data);
        return result;
    };
    SubscribableEditionComboboxItemDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["isFree"] = this.isFree;
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        data["isSelected"] = this.isSelected;
        return data;
    };
    return SubscribableEditionComboboxItemDto;
}());
export { SubscribableEditionComboboxItemDto };
var ListResultDtoOfSubscribableEditionComboboxItemDto = /** @class */ (function () {
    function ListResultDtoOfSubscribableEditionComboboxItemDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ListResultDtoOfSubscribableEditionComboboxItemDto.prototype.init = function (data) {
        if (data) {
            if (Array.isArray(data["items"])) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(SubscribableEditionComboboxItemDto.fromJS(item));
                }
            }
        }
    };
    ListResultDtoOfSubscribableEditionComboboxItemDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ListResultDtoOfSubscribableEditionComboboxItemDto();
        result.init(data);
        return result;
    };
    ListResultDtoOfSubscribableEditionComboboxItemDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return ListResultDtoOfSubscribableEditionComboboxItemDto;
}());
export { ListResultDtoOfSubscribableEditionComboboxItemDto };
var FindUsersInput = /** @class */ (function () {
    function FindUsersInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FindUsersInput.prototype.init = function (data) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.maxResultCount = data["maxResultCount"];
            this.skipCount = data["skipCount"];
            this.filter = data["filter"];
        }
    };
    FindUsersInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FindUsersInput();
        result.init(data);
        return result;
    };
    FindUsersInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["filter"] = this.filter;
        return data;
    };
    return FindUsersInput;
}());
export { FindUsersInput };
var PagedResultDtoOfNameValueDto = /** @class */ (function () {
    function PagedResultDtoOfNameValueDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfNameValueDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(NameValueDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfNameValueDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfNameValueDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfNameValueDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfNameValueDto;
}());
export { PagedResultDtoOfNameValueDto };
var GetDefaultEditionNameOutput = /** @class */ (function () {
    function GetDefaultEditionNameOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetDefaultEditionNameOutput.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
        }
    };
    GetDefaultEditionNameOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetDefaultEditionNameOutput();
        result.init(data);
        return result;
    };
    GetDefaultEditionNameOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    };
    return GetDefaultEditionNameOutput;
}());
export { GetDefaultEditionNameOutput };
export var Origin;
(function (Origin) {
    Origin[Origin["New"] = 0] = "New";
    Origin[Origin["PreAllocated"] = 1] = "PreAllocated";
})(Origin || (Origin = {}));
export var PriorityType;
(function (PriorityType) {
    PriorityType[PriorityType["None"] = 0] = "None";
    PriorityType[PriorityType["CustomerConfirmed"] = 20] = "CustomerConfirmed";
    PriorityType[PriorityType["CustomerConfirmedPAD"] = 21] = "CustomerConfirmedPAD";
    PriorityType[PriorityType["CustomerConfirmedNBD"] = 22] = "CustomerConfirmedNBD";
    PriorityType[PriorityType["Gift"] = 500] = "Gift";
    PriorityType[PriorityType["IsClickAndCollect"] = 1000] = "IsClickAndCollect";
    PriorityType[PriorityType["IsBusiness"] = 1700] = "IsBusiness";
    PriorityType[PriorityType["VPS"] = 2500] = "VPS";
    PriorityType[PriorityType["Corporate"] = 3000] = "Corporate";
    PriorityType[PriorityType["Shortys"] = 4000] = "Shortys";
    PriorityType[PriorityType["AutoManifested"] = 5000] = "AutoManifested";
    PriorityType[PriorityType["SaturdayRoster"] = 6000] = "SaturdayRoster";
})(PriorityType || (PriorityType = {}));
export var DeliveryType;
(function (DeliveryType) {
    DeliveryType[DeliveryType["Unknown"] = 0] = "Unknown";
    DeliveryType[DeliveryType["Delivery"] = 1] = "Delivery";
    DeliveryType[DeliveryType["Pickup"] = 2] = "Pickup";
    DeliveryType[DeliveryType["Redelivery"] = 4] = "Redelivery";
    DeliveryType[DeliveryType["Redirection"] = 5] = "Redirection";
    DeliveryType[DeliveryType["CollectNDeliver"] = 7] = "CollectNDeliver";
    DeliveryType[DeliveryType["Collect"] = 8] = "Collect";
    DeliveryType[DeliveryType["ReturnToSupplier"] = 9] = "ReturnToSupplier";
    DeliveryType[DeliveryType["Return"] = 11] = "Return";
})(DeliveryType || (DeliveryType = {}));
export var PackageType;
(function (PackageType) {
    PackageType[PackageType["Pallet"] = 0] = "Pallet";
    PackageType[PackageType["Box"] = 1] = "Box";
})(PackageType || (PackageType = {}));
var CreateOrEditPackageDto = /** @class */ (function () {
    function CreateOrEditPackageDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateOrEditPackageDto.prototype.init = function (data) {
        if (data) {
            this.barcode = data["barcode"];
            this.description = data["description"];
            this.status = data["status"];
            this.consignmentId = data["consignmentId"];
            this.weight = data["weight"];
            this.received = data["received"] ? moment(data["received"].toString()) : undefined;
            this.labelNo = data["labelNo"];
            this.items = data["items"];
            this.packageType = data["packageType"];
            this.id = data["id"];
        }
    };
    CreateOrEditPackageDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrEditPackageDto();
        result.init(data);
        return result;
    };
    CreateOrEditPackageDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["barcode"] = this.barcode;
        data["description"] = this.description;
        data["status"] = this.status;
        data["consignmentId"] = this.consignmentId;
        data["weight"] = this.weight;
        data["received"] = this.received ? this.received.toISOString() : undefined;
        data["labelNo"] = this.labelNo;
        data["items"] = this.items;
        data["packageType"] = this.packageType;
        data["id"] = this.id;
        return data;
    };
    return CreateOrEditPackageDto;
}());
export { CreateOrEditPackageDto };
var CreateConsignmentDto = /** @class */ (function () {
    function CreateConsignmentDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.location = new CreateOrEditLocationDto();
            this.packages = [];
        }
    }
    CreateConsignmentDto.prototype.init = function (data) {
        if (data) {
            this.firstName = data["firstName"];
            this.lastName = data["lastName"];
            this.mobileNumber = data["mobileNumber"];
            this.consignmentNumber = data["consignmentNumber"];
            this.originalConsignmentNumber = data["originalConsignmentNumber"];
            this.origin = data["origin"];
            this.preferredShipDate = data["preferredShipDate"] ? moment(data["preferredShipDate"].toString()) : undefined;
            this.shipDate = data["shipDate"] ? moment(data["shipDate"].toString()) : undefined;
            this.clientId = data["clientId"];
            this.clientName = data["clientName"];
            this.carrierCode = data["carrierCode"];
            this.clientGroupId = data["clientGroupId"];
            this.exitHub = data["exitHub"];
            this.deliveryHub = data["deliveryHub"];
            this.deliveryWith = data["deliveryWith"];
            this.brand = data["brand"];
            this.dropCode = data["dropCode"];
            this.orderNumber = data["orderNumber"];
            this.deliveryInstructions = data["deliveryInstructions"];
            this.giftFlag = data["giftFlag"];
            this.status = data["status"];
            this.priority = data["priority"];
            this.giftMessage = data["giftMessage"];
            this.type = data["type"];
            this.locationId = data["locationId"];
            this.location = data["location"] ? CreateOrEditLocationDto.fromJS(data["location"]) : new CreateOrEditLocationDto();
            if (Array.isArray(data["packages"])) {
                this.packages = [];
                for (var _i = 0, _a = data["packages"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.packages.push(CreateOrEditPackageDto.fromJS(item));
                }
            }
        }
    };
    CreateConsignmentDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateConsignmentDto();
        result.init(data);
        return result;
    };
    CreateConsignmentDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["mobileNumber"] = this.mobileNumber;
        data["consignmentNumber"] = this.consignmentNumber;
        data["originalConsignmentNumber"] = this.originalConsignmentNumber;
        data["origin"] = this.origin;
        data["preferredShipDate"] = this.preferredShipDate ? this.preferredShipDate.toISOString() : undefined;
        data["shipDate"] = this.shipDate ? this.shipDate.toISOString() : undefined;
        data["clientId"] = this.clientId;
        data["clientName"] = this.clientName;
        data["carrierCode"] = this.carrierCode;
        data["clientGroupId"] = this.clientGroupId;
        data["exitHub"] = this.exitHub;
        data["deliveryHub"] = this.deliveryHub;
        data["deliveryWith"] = this.deliveryWith;
        data["brand"] = this.brand;
        data["dropCode"] = this.dropCode;
        data["orderNumber"] = this.orderNumber;
        data["deliveryInstructions"] = this.deliveryInstructions;
        data["giftFlag"] = this.giftFlag;
        data["status"] = this.status;
        data["priority"] = this.priority;
        data["giftMessage"] = this.giftMessage;
        data["type"] = this.type;
        data["locationId"] = this.locationId;
        data["location"] = this.location ? this.location.toJSON() : undefined;
        if (Array.isArray(this.packages)) {
            data["packages"] = [];
            for (var _i = 0, _a = this.packages; _i < _a.length; _i++) {
                var item = _a[_i];
                data["packages"].push(item.toJSON());
            }
        }
        return data;
    };
    return CreateConsignmentDto;
}());
export { CreateConsignmentDto };
export var DropCode;
(function (DropCode) {
    DropCode[DropCode["None"] = 0] = "None";
    DropCode[DropCode["LeaveAsInstructed"] = 1] = "LeaveAsInstructed";
    DropCode[DropCode["ArrangeDelivery"] = 2] = "ArrangeDelivery";
    DropCode[DropCode["SignatureRequired"] = 3] = "SignatureRequired";
})(DropCode || (DropCode = {}));
export var ConsignmentFlags;
(function (ConsignmentFlags) {
    ConsignmentFlags[ConsignmentFlags["None"] = 0] = "None";
    ConsignmentFlags[ConsignmentFlags["AutoManifested"] = 1] = "AutoManifested";
    ConsignmentFlags[ConsignmentFlags["SaturdayRostered"] = 2] = "SaturdayRostered";
    ConsignmentFlags[ConsignmentFlags["RecipientIdCheckRequired"] = 3] = "RecipientIdCheckRequired";
})(ConsignmentFlags || (ConsignmentFlags = {}));
export var HeatStatus;
(function (HeatStatus) {
    HeatStatus[HeatStatus["None"] = 0] = "None";
    HeatStatus[HeatStatus["HeatHeld"] = 1] = "HeatHeld";
    HeatStatus[HeatStatus["HeatReleased"] = 2] = "HeatReleased";
})(HeatStatus || (HeatStatus = {}));
var ConsignmentDto = /** @class */ (function () {
    function ConsignmentDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ConsignmentDto.prototype.init = function (data) {
        if (data) {
            this.consignmentNumber = data["consignmentNumber"];
            this.shipDate = data["shipDate"] ? moment(data["shipDate"].toString()) : undefined;
            this.firstName = data["firstName"];
            this.lastName = data["lastName"];
            this.carrierCode = data["carrierCode"];
            this.deliveryWith = data["deliveryWith"];
            this.type = data["type"];
            this.status = data["status"];
            this.locationId = data["locationId"];
            this.territory = data["territory"];
            this.destination = data["destination"];
            this.packagesCount = data["packagesCount"];
            if (Array.isArray(data["barcodes"])) {
                this.barcodes = [];
                for (var _i = 0, _a = data["barcodes"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.barcodes.push(item);
                }
            }
            this.exitHub = data["exitHub"];
            this.deliveryHub = data["deliveryHub"];
            this.podIdentifierInFred = data["podIdentifierInFred"];
            this.isLocationGeocoded = data["isLocationGeocoded"];
            this.packagesWeight = data["packagesWeight"];
            this.orderNumber = data["orderNumber"];
            this.preferredShipDate = data["preferredShipDate"] ? moment(data["preferredShipDate"].toString()) : undefined;
            this.actionTakenAt = data["actionTakenAt"] ? moment(data["actionTakenAt"].toString()) : undefined;
            this.removedFromDashboardAt = data["removedFromDashboardAt"] ? moment(data["removedFromDashboardAt"].toString()) : undefined;
            this.priority = data["priority"];
            this.isClickAndCollect = data["isClickAndCollect"];
            this.dropCode = data["dropCode"];
            this.brand = data["brand"];
            this.takeActionAllowed = data["takeActionAllowed"];
            this.storeNumber = data["storeNumber"];
            this.isCrossBorder = data["isCrossBorder"];
            this.regionType = data["regionType"];
            this.regionValue = data["regionValue"];
            this.slaDate = data["slaDate"] ? moment(data["slaDate"].toString()) : undefined;
            this.isBusinessAddress = data["isBusinessAddress"];
            this.giftFlag = data["giftFlag"];
            this.rescheduledCount = data["rescheduledCount"];
            this.flags = data["flags"];
            this.heatStatus = data["heatStatus"];
            this.id = data["id"];
        }
    };
    ConsignmentDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ConsignmentDto();
        result.init(data);
        return result;
    };
    ConsignmentDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["consignmentNumber"] = this.consignmentNumber;
        data["shipDate"] = this.shipDate ? this.shipDate.toISOString() : undefined;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["carrierCode"] = this.carrierCode;
        data["deliveryWith"] = this.deliveryWith;
        data["type"] = this.type;
        data["status"] = this.status;
        data["locationId"] = this.locationId;
        data["territory"] = this.territory;
        data["destination"] = this.destination;
        data["packagesCount"] = this.packagesCount;
        if (Array.isArray(this.barcodes)) {
            data["barcodes"] = [];
            for (var _i = 0, _a = this.barcodes; _i < _a.length; _i++) {
                var item = _a[_i];
                data["barcodes"].push(item);
            }
        }
        data["exitHub"] = this.exitHub;
        data["deliveryHub"] = this.deliveryHub;
        data["podIdentifierInFred"] = this.podIdentifierInFred;
        data["isLocationGeocoded"] = this.isLocationGeocoded;
        data["packagesWeight"] = this.packagesWeight;
        data["orderNumber"] = this.orderNumber;
        data["preferredShipDate"] = this.preferredShipDate ? this.preferredShipDate.toISOString() : undefined;
        data["actionTakenAt"] = this.actionTakenAt ? this.actionTakenAt.toISOString() : undefined;
        data["removedFromDashboardAt"] = this.removedFromDashboardAt ? this.removedFromDashboardAt.toISOString() : undefined;
        data["priority"] = this.priority;
        data["isClickAndCollect"] = this.isClickAndCollect;
        data["dropCode"] = this.dropCode;
        data["brand"] = this.brand;
        data["takeActionAllowed"] = this.takeActionAllowed;
        data["storeNumber"] = this.storeNumber;
        data["isCrossBorder"] = this.isCrossBorder;
        data["regionType"] = this.regionType;
        data["regionValue"] = this.regionValue;
        data["slaDate"] = this.slaDate ? this.slaDate.toISOString() : undefined;
        data["isBusinessAddress"] = this.isBusinessAddress;
        data["giftFlag"] = this.giftFlag;
        data["rescheduledCount"] = this.rescheduledCount;
        data["flags"] = this.flags;
        data["heatStatus"] = this.heatStatus;
        data["id"] = this.id;
        return data;
    };
    return ConsignmentDto;
}());
export { ConsignmentDto };
var AddBarcodeDto = /** @class */ (function () {
    function AddBarcodeDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AddBarcodeDto.prototype.init = function (data) {
        if (data) {
            this.barcode = data["barcode"];
            this.description = data["description"];
            this.consignmentId = data["consignmentId"];
            this.weight = data["weight"];
        }
    };
    AddBarcodeDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AddBarcodeDto();
        result.init(data);
        return result;
    };
    AddBarcodeDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["barcode"] = this.barcode;
        data["description"] = this.description;
        data["consignmentId"] = this.consignmentId;
        data["weight"] = this.weight;
        return data;
    };
    return AddBarcodeDto;
}());
export { AddBarcodeDto };
var DeliveryDateExclusionDto = /** @class */ (function () {
    function DeliveryDateExclusionDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DeliveryDateExclusionDto.prototype.init = function (data) {
        if (data) {
            this.deliveryDate = data["deliveryDate"] ? moment(data["deliveryDate"].toString()) : undefined;
            this.title = data["title"];
            this.type = data["type"];
            this.state = data["state"];
            this.territory = data["territory"];
            this.id = data["id"];
        }
    };
    DeliveryDateExclusionDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DeliveryDateExclusionDto();
        result.init(data);
        return result;
    };
    DeliveryDateExclusionDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["deliveryDate"] = this.deliveryDate ? this.deliveryDate.toISOString() : undefined;
        data["title"] = this.title;
        data["type"] = this.type;
        data["state"] = this.state;
        data["territory"] = this.territory;
        data["id"] = this.id;
        return data;
    };
    return DeliveryDateExclusionDto;
}());
export { DeliveryDateExclusionDto };
var ListResultDtoOfDeliveryDateExclusionDto = /** @class */ (function () {
    function ListResultDtoOfDeliveryDateExclusionDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ListResultDtoOfDeliveryDateExclusionDto.prototype.init = function (data) {
        if (data) {
            if (Array.isArray(data["items"])) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(DeliveryDateExclusionDto.fromJS(item));
                }
            }
        }
    };
    ListResultDtoOfDeliveryDateExclusionDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ListResultDtoOfDeliveryDateExclusionDto();
        result.init(data);
        return result;
    };
    ListResultDtoOfDeliveryDateExclusionDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return ListResultDtoOfDeliveryDateExclusionDto;
}());
export { ListResultDtoOfDeliveryDateExclusionDto };
var CreateDriverManifestInput = /** @class */ (function () {
    function CreateDriverManifestInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateDriverManifestInput.prototype.init = function (data) {
        if (data) {
            this.shipDate = data["shipDate"] ? moment(data["shipDate"].toString()) : undefined;
            if (Array.isArray(data["depotLocationIds"])) {
                this.depotLocationIds = [];
                for (var _i = 0, _a = data["depotLocationIds"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.depotLocationIds.push(item);
                }
            }
            if (Array.isArray(data["carrierCodes"])) {
                this.carrierCodes = [];
                for (var _b = 0, _c = data["carrierCodes"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.carrierCodes.push(item);
                }
            }
            this.emailDrivers = data["emailDrivers"];
            if (Array.isArray(data["emailAddresses"])) {
                this.emailAddresses = [];
                for (var _d = 0, _e = data["emailAddresses"]; _d < _e.length; _d++) {
                    var item = _e[_d];
                    this.emailAddresses.push(item);
                }
            }
            this.exportToCarrier = data["exportToCarrier"];
        }
    };
    CreateDriverManifestInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateDriverManifestInput();
        result.init(data);
        return result;
    };
    CreateDriverManifestInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["shipDate"] = this.shipDate ? this.shipDate.toISOString() : undefined;
        if (Array.isArray(this.depotLocationIds)) {
            data["depotLocationIds"] = [];
            for (var _i = 0, _a = this.depotLocationIds; _i < _a.length; _i++) {
                var item = _a[_i];
                data["depotLocationIds"].push(item);
            }
        }
        if (Array.isArray(this.carrierCodes)) {
            data["carrierCodes"] = [];
            for (var _b = 0, _c = this.carrierCodes; _b < _c.length; _b++) {
                var item = _c[_b];
                data["carrierCodes"].push(item);
            }
        }
        data["emailDrivers"] = this.emailDrivers;
        if (Array.isArray(this.emailAddresses)) {
            data["emailAddresses"] = [];
            for (var _d = 0, _e = this.emailAddresses; _d < _e.length; _d++) {
                var item = _e[_d];
                data["emailAddresses"].push(item);
            }
        }
        data["exportToCarrier"] = this.exportToCarrier;
        return data;
    };
    return CreateDriverManifestInput;
}());
export { CreateDriverManifestInput };
var GetAllConsignmentsInput = /** @class */ (function () {
    function GetAllConsignmentsInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetAllConsignmentsInput.prototype.init = function (data) {
        if (data) {
            if (Array.isArray(data["consignmentNumbersFilter"])) {
                this.consignmentNumbersFilter = [];
                for (var _i = 0, _a = data["consignmentNumbersFilter"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.consignmentNumbersFilter.push(item);
                }
            }
            if (Array.isArray(data["consignmentIdsFilter"])) {
                this.consignmentIdsFilter = [];
                for (var _b = 0, _c = data["consignmentIdsFilter"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.consignmentIdsFilter.push(item);
                }
            }
            if (Array.isArray(data["barcodesFilter"])) {
                this.barcodesFilter = [];
                for (var _d = 0, _e = data["barcodesFilter"]; _d < _e.length; _d++) {
                    var item = _e[_d];
                    this.barcodesFilter.push(item);
                }
            }
            this.maxShipDateFilter = data["maxShipDateFilter"] ? moment(data["maxShipDateFilter"].toString()) : undefined;
            this.minShipDateFilter = data["minShipDateFilter"] ? moment(data["minShipDateFilter"].toString()) : undefined;
            this.customerNameFilter = data["customerNameFilter"];
            this.statusFilter = data["statusFilter"];
            if (Array.isArray(data["orderNumberFilter"])) {
                this.orderNumberFilter = [];
                for (var _f = 0, _g = data["orderNumberFilter"]; _f < _g.length; _f++) {
                    var item = _g[_f];
                    this.orderNumberFilter.push(item);
                }
            }
            if (Array.isArray(data["deliveryWithFilter"])) {
                this.deliveryWithFilter = [];
                for (var _h = 0, _j = data["deliveryWithFilter"]; _h < _j.length; _h++) {
                    var item = _j[_h];
                    this.deliveryWithFilter.push(item);
                }
            }
            if (Array.isArray(data["externalVendorOrderNumbersFilter"])) {
                this.externalVendorOrderNumbersFilter = [];
                for (var _k = 0, _l = data["externalVendorOrderNumbersFilter"]; _k < _l.length; _k++) {
                    var item = _l[_k];
                    this.externalVendorOrderNumbersFilter.push(item);
                }
            }
            if (Array.isArray(data["clientFileNameFilter"])) {
                this.clientFileNameFilter = [];
                for (var _m = 0, _o = data["clientFileNameFilter"]; _m < _o.length; _m++) {
                    var item = _o[_m];
                    this.clientFileNameFilter.push(item);
                }
            }
            this.maxOrderDateFilter = data["maxOrderDateFilter"] ? moment(data["maxOrderDateFilter"].toString()) : undefined;
            this.minOrderDateFilter = data["minOrderDateFilter"] ? moment(data["minOrderDateFilter"].toString()) : undefined;
            this.maxPreferredShipDateFilter = data["maxPreferredShipDateFilter"] ? moment(data["maxPreferredShipDateFilter"].toString()) : undefined;
            this.minPreferredShipDateFilter = data["minPreferredShipDateFilter"] ? moment(data["minPreferredShipDateFilter"].toString()) : undefined;
            this.maxCreatedDateFilter = data["maxCreatedDateFilter"] ? moment(data["maxCreatedDateFilter"].toString()) : undefined;
            this.minCreatedDateFilter = data["minCreatedDateFilter"] ? moment(data["minCreatedDateFilter"].toString()) : undefined;
            this.maxSlaDateFilter = data["maxSlaDateFilter"] ? moment(data["maxSlaDateFilter"].toString()) : undefined;
            this.minSlaDateFilter = data["minSlaDateFilter"] ? moment(data["minSlaDateFilter"].toString()) : undefined;
            this.minRescheduledCountFilter = data["minRescheduledCountFilter"];
            this.maxRescheduledCountFilter = data["maxRescheduledCountFilter"];
            if (Array.isArray(data["carrierCodeFilter"])) {
                this.carrierCodeFilter = [];
                for (var _p = 0, _q = data["carrierCodeFilter"]; _p < _q.length; _p++) {
                    var item = _q[_p];
                    this.carrierCodeFilter.push(item);
                }
            }
            if (Array.isArray(data["typeFilter"])) {
                this.typeFilter = [];
                for (var _r = 0, _s = data["typeFilter"]; _r < _s.length; _r++) {
                    var item = _s[_r];
                    this.typeFilter.push(item);
                }
            }
            if (Array.isArray(data["consignmentStatusFilter"])) {
                this.consignmentStatusFilter = [];
                for (var _t = 0, _u = data["consignmentStatusFilter"]; _t < _u.length; _t++) {
                    var item = _u[_t];
                    this.consignmentStatusFilter.push(item);
                }
            }
            if (Array.isArray(data["brandFilter"])) {
                this.brandFilter = [];
                for (var _v = 0, _w = data["brandFilter"]; _v < _w.length; _v++) {
                    var item = _w[_v];
                    this.brandFilter.push(item);
                }
            }
            if (Array.isArray(data["exitHubFilter"])) {
                this.exitHubFilter = [];
                for (var _x = 0, _y = data["exitHubFilter"]; _x < _y.length; _x++) {
                    var item = _y[_x];
                    this.exitHubFilter.push(item);
                }
            }
            if (Array.isArray(data["deliveryHubFilter"])) {
                this.deliveryHubFilter = [];
                for (var _z = 0, _0 = data["deliveryHubFilter"]; _z < _0.length; _z++) {
                    var item = _0[_z];
                    this.deliveryHubFilter.push(item);
                }
            }
            if (Array.isArray(data["clientIdFilter"])) {
                this.clientIdFilter = [];
                for (var _1 = 0, _2 = data["clientIdFilter"]; _1 < _2.length; _1++) {
                    var item = _2[_1];
                    this.clientIdFilter.push(item);
                }
            }
            if (Array.isArray(data["clientGroupFilter"])) {
                this.clientGroupFilter = [];
                for (var _3 = 0, _4 = data["clientGroupFilter"]; _3 < _4.length; _3++) {
                    var item = _4[_3];
                    this.clientGroupFilter.push(item);
                }
            }
            if (Array.isArray(data["packageStatusFilter"])) {
                this.packageStatusFilter = [];
                for (var _5 = 0, _6 = data["packageStatusFilter"]; _5 < _6.length; _5++) {
                    var item = _6[_5];
                    this.packageStatusFilter.push(item);
                }
            }
            if (Array.isArray(data["territoryFilter"])) {
                this.territoryFilter = [];
                for (var _7 = 0, _8 = data["territoryFilter"]; _7 < _8.length; _7++) {
                    var item = _8[_7];
                    this.territoryFilter.push(item);
                }
            }
            if (Array.isArray(data["loadIdFilter"])) {
                this.loadIdFilter = [];
                for (var _9 = 0, _10 = data["loadIdFilter"]; _9 < _10.length; _9++) {
                    var item = _10[_9];
                    this.loadIdFilter.push(item);
                }
            }
            if (Array.isArray(data["palletIdFilter"])) {
                this.palletIdFilter = [];
                for (var _11 = 0, _12 = data["palletIdFilter"]; _11 < _12.length; _11++) {
                    var item = _12[_11];
                    this.palletIdFilter.push(item);
                }
            }
            this.actionedFilter = data["actionedFilter"];
            this.removedFromDashboardFilter = data["removedFromDashboardFilter"];
            if (Array.isArray(data["batchIdFilter"])) {
                this.batchIdFilter = [];
                for (var _13 = 0, _14 = data["batchIdFilter"]; _13 < _14.length; _13++) {
                    var item = _14[_13];
                    this.batchIdFilter.push(item);
                }
            }
            this.dashboardViewFilter = data["dashboardViewFilter"];
            if (Array.isArray(data["xBorderIdFilter"])) {
                this.xBorderIdFilter = [];
                for (var _15 = 0, _16 = data["xBorderIdFilter"]; _15 < _16.length; _15++) {
                    var item = _16[_15];
                    this.xBorderIdFilter.push(item);
                }
            }
            if (Array.isArray(data["returnToSupplierIdFilter"])) {
                this.returnToSupplierIdFilter = [];
                for (var _17 = 0, _18 = data["returnToSupplierIdFilter"]; _17 < _18.length; _17++) {
                    var item = _18[_17];
                    this.returnToSupplierIdFilter.push(item);
                }
            }
            if (Array.isArray(data["priorityFilter"])) {
                this.priorityFilter = [];
                for (var _19 = 0, _20 = data["priorityFilter"]; _19 < _20.length; _19++) {
                    var item = _20[_19];
                    this.priorityFilter.push(item);
                }
            }
            if (Array.isArray(data["regionTypeFilter"])) {
                this.regionTypeFilter = [];
                for (var _21 = 0, _22 = data["regionTypeFilter"]; _21 < _22.length; _21++) {
                    var item = _22[_21];
                    this.regionTypeFilter.push(item);
                }
            }
            if (Array.isArray(data["regionValueFilter"])) {
                this.regionValueFilter = [];
                for (var _23 = 0, _24 = data["regionValueFilter"]; _23 < _24.length; _23++) {
                    var item = _24[_23];
                    this.regionValueFilter.push(item);
                }
            }
            if (Array.isArray(data["heatStatusFilter"])) {
                this.heatStatusFilter = [];
                for (var _25 = 0, _26 = data["heatStatusFilter"]; _25 < _26.length; _25++) {
                    var item = _26[_25];
                    this.heatStatusFilter.push(item);
                }
            }
            this.xFilter = data["xFilter"];
            this.yFilter = data["yFilter"];
            this.zFilter = data["zFilter"];
            if (Array.isArray(data["zendeskQueryType"])) {
                this.zendeskQueryType = [];
                for (var _27 = 0, _28 = data["zendeskQueryType"]; _27 < _28.length; _27++) {
                    var item = _28[_27];
                    this.zendeskQueryType.push(item);
                }
            }
            if (Array.isArray(data["destinationPostcodeFilter"])) {
                this.destinationPostcodeFilter = [];
                for (var _29 = 0, _30 = data["destinationPostcodeFilter"]; _29 < _30.length; _29++) {
                    var item = _30[_29];
                    this.destinationPostcodeFilter.push(item);
                }
            }
            this.selectedRangeLabel = data["selectedRangeLabel"];
            this.selectedDateFilter = data["selectedDateFilter"];
            this.selectedTimeRange = data["selectedTimeRange"];
            if (Array.isArray(data["palletConnoteFilter"])) {
                this.palletConnoteFilter = [];
                for (var _31 = 0, _32 = data["palletConnoteFilter"]; _31 < _32.length; _31++) {
                    var item = _32[_31];
                    this.palletConnoteFilter.push(item);
                }
            }
            this.isPalletised = data["isPalletised"];
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    };
    GetAllConsignmentsInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetAllConsignmentsInput();
        result.init(data);
        return result;
    };
    GetAllConsignmentsInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.consignmentNumbersFilter)) {
            data["consignmentNumbersFilter"] = [];
            for (var _i = 0, _a = this.consignmentNumbersFilter; _i < _a.length; _i++) {
                var item = _a[_i];
                data["consignmentNumbersFilter"].push(item);
            }
        }
        if (Array.isArray(this.consignmentIdsFilter)) {
            data["consignmentIdsFilter"] = [];
            for (var _b = 0, _c = this.consignmentIdsFilter; _b < _c.length; _b++) {
                var item = _c[_b];
                data["consignmentIdsFilter"].push(item);
            }
        }
        if (Array.isArray(this.barcodesFilter)) {
            data["barcodesFilter"] = [];
            for (var _d = 0, _e = this.barcodesFilter; _d < _e.length; _d++) {
                var item = _e[_d];
                data["barcodesFilter"].push(item);
            }
        }
        data["maxShipDateFilter"] = this.maxShipDateFilter ? this.maxShipDateFilter.toISOString() : undefined;
        data["minShipDateFilter"] = this.minShipDateFilter ? this.minShipDateFilter.toISOString() : undefined;
        data["customerNameFilter"] = this.customerNameFilter;
        data["statusFilter"] = this.statusFilter;
        if (Array.isArray(this.orderNumberFilter)) {
            data["orderNumberFilter"] = [];
            for (var _f = 0, _g = this.orderNumberFilter; _f < _g.length; _f++) {
                var item = _g[_f];
                data["orderNumberFilter"].push(item);
            }
        }
        if (Array.isArray(this.deliveryWithFilter)) {
            data["deliveryWithFilter"] = [];
            for (var _h = 0, _j = this.deliveryWithFilter; _h < _j.length; _h++) {
                var item = _j[_h];
                data["deliveryWithFilter"].push(item);
            }
        }
        if (Array.isArray(this.externalVendorOrderNumbersFilter)) {
            data["externalVendorOrderNumbersFilter"] = [];
            for (var _k = 0, _l = this.externalVendorOrderNumbersFilter; _k < _l.length; _k++) {
                var item = _l[_k];
                data["externalVendorOrderNumbersFilter"].push(item);
            }
        }
        if (Array.isArray(this.clientFileNameFilter)) {
            data["clientFileNameFilter"] = [];
            for (var _m = 0, _o = this.clientFileNameFilter; _m < _o.length; _m++) {
                var item = _o[_m];
                data["clientFileNameFilter"].push(item);
            }
        }
        data["maxOrderDateFilter"] = this.maxOrderDateFilter ? this.maxOrderDateFilter.toISOString() : undefined;
        data["minOrderDateFilter"] = this.minOrderDateFilter ? this.minOrderDateFilter.toISOString() : undefined;
        data["maxPreferredShipDateFilter"] = this.maxPreferredShipDateFilter ? this.maxPreferredShipDateFilter.toISOString() : undefined;
        data["minPreferredShipDateFilter"] = this.minPreferredShipDateFilter ? this.minPreferredShipDateFilter.toISOString() : undefined;
        data["maxCreatedDateFilter"] = this.maxCreatedDateFilter ? this.maxCreatedDateFilter.toISOString() : undefined;
        data["minCreatedDateFilter"] = this.minCreatedDateFilter ? this.minCreatedDateFilter.toISOString() : undefined;
        data["maxSlaDateFilter"] = this.maxSlaDateFilter ? this.maxSlaDateFilter.toISOString() : undefined;
        data["minSlaDateFilter"] = this.minSlaDateFilter ? this.minSlaDateFilter.toISOString() : undefined;
        data["minRescheduledCountFilter"] = this.minRescheduledCountFilter;
        data["maxRescheduledCountFilter"] = this.maxRescheduledCountFilter;
        if (Array.isArray(this.carrierCodeFilter)) {
            data["carrierCodeFilter"] = [];
            for (var _p = 0, _q = this.carrierCodeFilter; _p < _q.length; _p++) {
                var item = _q[_p];
                data["carrierCodeFilter"].push(item);
            }
        }
        if (Array.isArray(this.typeFilter)) {
            data["typeFilter"] = [];
            for (var _r = 0, _s = this.typeFilter; _r < _s.length; _r++) {
                var item = _s[_r];
                data["typeFilter"].push(item);
            }
        }
        if (Array.isArray(this.consignmentStatusFilter)) {
            data["consignmentStatusFilter"] = [];
            for (var _t = 0, _u = this.consignmentStatusFilter; _t < _u.length; _t++) {
                var item = _u[_t];
                data["consignmentStatusFilter"].push(item);
            }
        }
        if (Array.isArray(this.brandFilter)) {
            data["brandFilter"] = [];
            for (var _v = 0, _w = this.brandFilter; _v < _w.length; _v++) {
                var item = _w[_v];
                data["brandFilter"].push(item);
            }
        }
        if (Array.isArray(this.exitHubFilter)) {
            data["exitHubFilter"] = [];
            for (var _x = 0, _y = this.exitHubFilter; _x < _y.length; _x++) {
                var item = _y[_x];
                data["exitHubFilter"].push(item);
            }
        }
        if (Array.isArray(this.deliveryHubFilter)) {
            data["deliveryHubFilter"] = [];
            for (var _z = 0, _0 = this.deliveryHubFilter; _z < _0.length; _z++) {
                var item = _0[_z];
                data["deliveryHubFilter"].push(item);
            }
        }
        if (Array.isArray(this.clientIdFilter)) {
            data["clientIdFilter"] = [];
            for (var _1 = 0, _2 = this.clientIdFilter; _1 < _2.length; _1++) {
                var item = _2[_1];
                data["clientIdFilter"].push(item);
            }
        }
        if (Array.isArray(this.clientGroupFilter)) {
            data["clientGroupFilter"] = [];
            for (var _3 = 0, _4 = this.clientGroupFilter; _3 < _4.length; _3++) {
                var item = _4[_3];
                data["clientGroupFilter"].push(item);
            }
        }
        if (Array.isArray(this.packageStatusFilter)) {
            data["packageStatusFilter"] = [];
            for (var _5 = 0, _6 = this.packageStatusFilter; _5 < _6.length; _5++) {
                var item = _6[_5];
                data["packageStatusFilter"].push(item);
            }
        }
        if (Array.isArray(this.territoryFilter)) {
            data["territoryFilter"] = [];
            for (var _7 = 0, _8 = this.territoryFilter; _7 < _8.length; _7++) {
                var item = _8[_7];
                data["territoryFilter"].push(item);
            }
        }
        if (Array.isArray(this.loadIdFilter)) {
            data["loadIdFilter"] = [];
            for (var _9 = 0, _10 = this.loadIdFilter; _9 < _10.length; _9++) {
                var item = _10[_9];
                data["loadIdFilter"].push(item);
            }
        }
        if (Array.isArray(this.palletIdFilter)) {
            data["palletIdFilter"] = [];
            for (var _11 = 0, _12 = this.palletIdFilter; _11 < _12.length; _11++) {
                var item = _12[_11];
                data["palletIdFilter"].push(item);
            }
        }
        data["actionedFilter"] = this.actionedFilter;
        data["removedFromDashboardFilter"] = this.removedFromDashboardFilter;
        if (Array.isArray(this.batchIdFilter)) {
            data["batchIdFilter"] = [];
            for (var _13 = 0, _14 = this.batchIdFilter; _13 < _14.length; _13++) {
                var item = _14[_13];
                data["batchIdFilter"].push(item);
            }
        }
        data["dashboardViewFilter"] = this.dashboardViewFilter;
        if (Array.isArray(this.xBorderIdFilter)) {
            data["xBorderIdFilter"] = [];
            for (var _15 = 0, _16 = this.xBorderIdFilter; _15 < _16.length; _15++) {
                var item = _16[_15];
                data["xBorderIdFilter"].push(item);
            }
        }
        if (Array.isArray(this.returnToSupplierIdFilter)) {
            data["returnToSupplierIdFilter"] = [];
            for (var _17 = 0, _18 = this.returnToSupplierIdFilter; _17 < _18.length; _17++) {
                var item = _18[_17];
                data["returnToSupplierIdFilter"].push(item);
            }
        }
        if (Array.isArray(this.priorityFilter)) {
            data["priorityFilter"] = [];
            for (var _19 = 0, _20 = this.priorityFilter; _19 < _20.length; _19++) {
                var item = _20[_19];
                data["priorityFilter"].push(item);
            }
        }
        if (Array.isArray(this.regionTypeFilter)) {
            data["regionTypeFilter"] = [];
            for (var _21 = 0, _22 = this.regionTypeFilter; _21 < _22.length; _21++) {
                var item = _22[_21];
                data["regionTypeFilter"].push(item);
            }
        }
        if (Array.isArray(this.regionValueFilter)) {
            data["regionValueFilter"] = [];
            for (var _23 = 0, _24 = this.regionValueFilter; _23 < _24.length; _23++) {
                var item = _24[_23];
                data["regionValueFilter"].push(item);
            }
        }
        if (Array.isArray(this.heatStatusFilter)) {
            data["heatStatusFilter"] = [];
            for (var _25 = 0, _26 = this.heatStatusFilter; _25 < _26.length; _25++) {
                var item = _26[_25];
                data["heatStatusFilter"].push(item);
            }
        }
        data["xFilter"] = this.xFilter;
        data["yFilter"] = this.yFilter;
        data["zFilter"] = this.zFilter;
        if (Array.isArray(this.zendeskQueryType)) {
            data["zendeskQueryType"] = [];
            for (var _27 = 0, _28 = this.zendeskQueryType; _27 < _28.length; _27++) {
                var item = _28[_27];
                data["zendeskQueryType"].push(item);
            }
        }
        if (Array.isArray(this.destinationPostcodeFilter)) {
            data["destinationPostcodeFilter"] = [];
            for (var _29 = 0, _30 = this.destinationPostcodeFilter; _29 < _30.length; _29++) {
                var item = _30[_29];
                data["destinationPostcodeFilter"].push(item);
            }
        }
        data["selectedRangeLabel"] = this.selectedRangeLabel;
        data["selectedDateFilter"] = this.selectedDateFilter;
        data["selectedTimeRange"] = this.selectedTimeRange;
        if (Array.isArray(this.palletConnoteFilter)) {
            data["palletConnoteFilter"] = [];
            for (var _31 = 0, _32 = this.palletConnoteFilter; _31 < _32.length; _31++) {
                var item = _32[_31];
                data["palletConnoteFilter"].push(item);
            }
        }
        data["isPalletised"] = this.isPalletised;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    };
    return GetAllConsignmentsInput;
}());
export { GetAllConsignmentsInput };
var BulkConsignmentValidationResult = /** @class */ (function () {
    function BulkConsignmentValidationResult(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BulkConsignmentValidationResult.prototype.init = function (data) {
        if (data) {
            if (Array.isArray(data["validConsignmentIds"])) {
                this.validConsignmentIds = [];
                for (var _i = 0, _a = data["validConsignmentIds"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.validConsignmentIds.push(item);
                }
            }
            if (Array.isArray(data["errors"])) {
                this.errors = [];
                for (var _b = 0, _c = data["errors"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.errors.push(item);
                }
            }
            if (Array.isArray(data["warnings"])) {
                this.warnings = [];
                for (var _d = 0, _e = data["warnings"]; _d < _e.length; _d++) {
                    var item = _e[_d];
                    this.warnings.push(item);
                }
            }
            if (Array.isArray(data["warningCodes"])) {
                this.warningCodes = [];
                for (var _f = 0, _g = data["warningCodes"]; _f < _g.length; _f++) {
                    var item = _g[_f];
                    this.warningCodes.push(item);
                }
            }
        }
    };
    BulkConsignmentValidationResult.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BulkConsignmentValidationResult();
        result.init(data);
        return result;
    };
    BulkConsignmentValidationResult.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.validConsignmentIds)) {
            data["validConsignmentIds"] = [];
            for (var _i = 0, _a = this.validConsignmentIds; _i < _a.length; _i++) {
                var item = _a[_i];
                data["validConsignmentIds"].push(item);
            }
        }
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (var _b = 0, _c = this.errors; _b < _c.length; _b++) {
                var item = _c[_b];
                data["errors"].push(item);
            }
        }
        if (Array.isArray(this.warnings)) {
            data["warnings"] = [];
            for (var _d = 0, _e = this.warnings; _d < _e.length; _d++) {
                var item = _e[_d];
                data["warnings"].push(item);
            }
        }
        if (Array.isArray(this.warningCodes)) {
            data["warningCodes"] = [];
            for (var _f = 0, _g = this.warningCodes; _f < _g.length; _f++) {
                var item = _g[_f];
                data["warningCodes"].push(item);
            }
        }
        return data;
    };
    return BulkConsignmentValidationResult;
}());
export { BulkConsignmentValidationResult };
var CreateBulkManifestInput = /** @class */ (function () {
    function CreateBulkManifestInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateBulkManifestInput.prototype.init = function (data) {
        if (data) {
            this.carrierCode = data["carrierCode"];
            if (Array.isArray(data["emailAddresses"])) {
                this.emailAddresses = [];
                for (var _i = 0, _a = data["emailAddresses"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.emailAddresses.push(item);
                }
            }
            if (Array.isArray(data["consignmentNumbers"])) {
                this.consignmentNumbers = [];
                for (var _b = 0, _c = data["consignmentNumbers"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.consignmentNumbers.push(item);
                }
            }
            if (Array.isArray(data["consignmentIds"])) {
                this.consignmentIds = [];
                for (var _d = 0, _e = data["consignmentIds"]; _d < _e.length; _d++) {
                    var item = _e[_d];
                    this.consignmentIds.push(item);
                }
            }
        }
    };
    CreateBulkManifestInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateBulkManifestInput();
        result.init(data);
        return result;
    };
    CreateBulkManifestInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["carrierCode"] = this.carrierCode;
        if (Array.isArray(this.emailAddresses)) {
            data["emailAddresses"] = [];
            for (var _i = 0, _a = this.emailAddresses; _i < _a.length; _i++) {
                var item = _a[_i];
                data["emailAddresses"].push(item);
            }
        }
        if (Array.isArray(this.consignmentNumbers)) {
            data["consignmentNumbers"] = [];
            for (var _b = 0, _c = this.consignmentNumbers; _b < _c.length; _b++) {
                var item = _c[_b];
                data["consignmentNumbers"].push(item);
            }
        }
        if (Array.isArray(this.consignmentIds)) {
            data["consignmentIds"] = [];
            for (var _d = 0, _e = this.consignmentIds; _d < _e.length; _d++) {
                var item = _e[_d];
                data["consignmentIds"].push(item);
            }
        }
        return data;
    };
    return CreateBulkManifestInput;
}());
export { CreateBulkManifestInput };
export var RoutedBy;
(function (RoutedBy) {
    RoutedBy[RoutedBy["None"] = 0] = "None";
    RoutedBy[RoutedBy["RoutePlanner"] = 1] = "RoutePlanner";
    RoutedBy[RoutedBy["MileVision"] = 2] = "MileVision";
    RoutedBy[RoutedBy["Fareye"] = 3] = "Fareye";
})(RoutedBy || (RoutedBy = {}));
var GetConsignmentForViewDto = /** @class */ (function () {
    function GetConsignmentForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetConsignmentForViewDto.prototype.init = function (data) {
        if (data) {
            this.consignment = data["consignment"] ? ConsignmentDto.fromJS(data["consignment"]) : undefined;
            this.clientGroupName = data["clientGroupName"];
            this.statusDescription = data["statusDescription"];
            this.clientGroupId = data["clientGroupId"];
            this.pickupAllowed = data["pickupAllowed"];
            this.routedBy = data["routedBy"];
            this.territory = data["territory"];
            this.orderDate = data["orderDate"] ? moment(data["orderDate"].toString()) : undefined;
            this.clientName = data["clientName"];
            this.postCode = data["postCode"];
            this.manifestFileName = data["manifestFileName"];
            this.clickAndCollectOrder = data["clickAndCollectOrder"];
            this.giftOrder = data["giftOrder"];
            this.courierCode = data["courierCode"];
            this.customerType = data["customerType"];
            this.externalVendorName = data["externalVendorName"];
            this.externalVendorOrderNumber = data["externalVendorOrderNumber"];
        }
    };
    GetConsignmentForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetConsignmentForViewDto();
        result.init(data);
        return result;
    };
    GetConsignmentForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["consignment"] = this.consignment ? this.consignment.toJSON() : undefined;
        data["clientGroupName"] = this.clientGroupName;
        data["statusDescription"] = this.statusDescription;
        data["clientGroupId"] = this.clientGroupId;
        data["pickupAllowed"] = this.pickupAllowed;
        data["routedBy"] = this.routedBy;
        data["territory"] = this.territory;
        data["orderDate"] = this.orderDate ? this.orderDate.toISOString() : undefined;
        data["clientName"] = this.clientName;
        data["postCode"] = this.postCode;
        data["manifestFileName"] = this.manifestFileName;
        data["clickAndCollectOrder"] = this.clickAndCollectOrder;
        data["giftOrder"] = this.giftOrder;
        data["courierCode"] = this.courierCode;
        data["customerType"] = this.customerType;
        data["externalVendorName"] = this.externalVendorName;
        data["externalVendorOrderNumber"] = this.externalVendorOrderNumber;
        return data;
    };
    return GetConsignmentForViewDto;
}());
export { GetConsignmentForViewDto };
var PagedResultDtoOfGetConsignmentForViewDto = /** @class */ (function () {
    function PagedResultDtoOfGetConsignmentForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfGetConsignmentForViewDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(GetConsignmentForViewDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfGetConsignmentForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfGetConsignmentForViewDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfGetConsignmentForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfGetConsignmentForViewDto;
}());
export { PagedResultDtoOfGetConsignmentForViewDto };
var PackageItemsDto = /** @class */ (function () {
    function PackageItemsDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PackageItemsDto.prototype.init = function (data) {
        if (data) {
            this.lineNumber = data["lineNumber"];
            this.itemCode = data["itemCode"];
            this.itemDesc = data["itemDesc"];
            this.quantity = data["quantity"];
            this.packType = data["packType"];
        }
    };
    PackageItemsDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PackageItemsDto();
        result.init(data);
        return result;
    };
    PackageItemsDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["lineNumber"] = this.lineNumber;
        data["itemCode"] = this.itemCode;
        data["itemDesc"] = this.itemDesc;
        data["quantity"] = this.quantity;
        data["packType"] = this.packType;
        return data;
    };
    return PackageItemsDto;
}());
export { PackageItemsDto };
var PackageDto = /** @class */ (function () {
    function PackageDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PackageDto.prototype.init = function (data) {
        if (data) {
            this.consignmentId = data["consignmentId"];
            this.barcode = data["barcode"];
            this.labelNo = data["labelNo"];
            this.description = data["description"];
            this.status = data["status"];
            this.weight = data["weight"];
            this.itemDlvCodes = data["itemDlvCodes"];
            this.codes = data["codes"];
            this.received = data["received"] ? moment(data["received"].toString()) : undefined;
            this.exceptionedAt = data["exceptionedAt"] ? moment(data["exceptionedAt"].toString()) : undefined;
            if (Array.isArray(data["packageItems"])) {
                this.packageItems = [];
                for (var _i = 0, _a = data["packageItems"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.packageItems.push(PackageItemsDto.fromJS(item));
                }
            }
            this.id = data["id"];
        }
    };
    PackageDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PackageDto();
        result.init(data);
        return result;
    };
    PackageDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["consignmentId"] = this.consignmentId;
        data["barcode"] = this.barcode;
        data["labelNo"] = this.labelNo;
        data["description"] = this.description;
        data["status"] = this.status;
        data["weight"] = this.weight;
        data["itemDlvCodes"] = this.itemDlvCodes;
        data["codes"] = this.codes;
        data["received"] = this.received ? this.received.toISOString() : undefined;
        data["exceptionedAt"] = this.exceptionedAt ? this.exceptionedAt.toISOString() : undefined;
        if (Array.isArray(this.packageItems)) {
            data["packageItems"] = [];
            for (var _i = 0, _a = this.packageItems; _i < _a.length; _i++) {
                var item = _a[_i];
                data["packageItems"].push(item.toJSON());
            }
        }
        data["id"] = this.id;
        return data;
    };
    return PackageDto;
}());
export { PackageDto };
var CreateOrEditConsignmentDto = /** @class */ (function () {
    function CreateOrEditConsignmentDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateOrEditConsignmentDto.prototype.init = function (data) {
        if (data) {
            this.consignmentNumber = data["consignmentNumber"];
            this.shipDate = data["shipDate"] ? moment(data["shipDate"].toString()) : undefined;
            this.brand = data["brand"];
            this.firstName = data["firstName"];
            this.lastName = data["lastName"];
            this.homeNumber = data["homeNumber"];
            this.workNumber = data["workNumber"];
            this.mobileNumber = data["mobileNumber"];
            this.carrierCode = data["carrierCode"];
            this.type = data["type"];
            this.status = data["status"];
            this.exitHub = data["exitHub"];
            this.podIdentifierInFred = data["podIdentifierInFred"];
            this.originalConsignmentNumber = data["originalConsignmentNumber"];
            this.orderNumber = data["orderNumber"];
            this.clientId = data["clientId"];
            this.clientFileName = data["clientFileName"];
            this.orderDate = data["orderDate"] ? moment(data["orderDate"].toString()) : undefined;
            this.deliveryInstructions = data["deliveryInstructions"];
            this.deliveryWith = data["deliveryWith"];
            this.dropCode = data["dropCode"];
            this.deliveryEta = data["deliveryEta"];
            this.giftFlag = data["giftFlag"];
            this.giftMessage = data["giftMessage"];
            this.priority = data["priority"];
            this.isClickAndCollect = data["isClickAndCollect"];
            this.preferredShipDate = data["preferredShipDate"] ? moment(data["preferredShipDate"].toString()) : undefined;
            this.rescheduledCount = data["rescheduledCount"];
            this.slaDate = data["slaDate"] ? moment(data["slaDate"].toString()) : undefined;
            this.locationId = data["locationId"];
            this.flags = data["flags"];
            this.storeNumber = data["storeNumber"];
            this.location = data["location"] ? CreateOrEditLocationDto.fromJS(data["location"]) : undefined;
            if (Array.isArray(data["packages"])) {
                this.packages = [];
                for (var _i = 0, _a = data["packages"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.packages.push(PackageDto.fromJS(item));
                }
            }
            this.id = data["id"];
        }
    };
    CreateOrEditConsignmentDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrEditConsignmentDto();
        result.init(data);
        return result;
    };
    CreateOrEditConsignmentDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["consignmentNumber"] = this.consignmentNumber;
        data["shipDate"] = this.shipDate ? this.shipDate.toISOString() : undefined;
        data["brand"] = this.brand;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["homeNumber"] = this.homeNumber;
        data["workNumber"] = this.workNumber;
        data["mobileNumber"] = this.mobileNumber;
        data["carrierCode"] = this.carrierCode;
        data["type"] = this.type;
        data["status"] = this.status;
        data["exitHub"] = this.exitHub;
        data["podIdentifierInFred"] = this.podIdentifierInFred;
        data["originalConsignmentNumber"] = this.originalConsignmentNumber;
        data["orderNumber"] = this.orderNumber;
        data["clientId"] = this.clientId;
        data["clientFileName"] = this.clientFileName;
        data["orderDate"] = this.orderDate ? this.orderDate.toISOString() : undefined;
        data["deliveryInstructions"] = this.deliveryInstructions;
        data["deliveryWith"] = this.deliveryWith;
        data["dropCode"] = this.dropCode;
        data["deliveryEta"] = this.deliveryEta;
        data["giftFlag"] = this.giftFlag;
        data["giftMessage"] = this.giftMessage;
        data["priority"] = this.priority;
        data["isClickAndCollect"] = this.isClickAndCollect;
        data["preferredShipDate"] = this.preferredShipDate ? this.preferredShipDate.toISOString() : undefined;
        data["rescheduledCount"] = this.rescheduledCount;
        data["slaDate"] = this.slaDate ? this.slaDate.toISOString() : undefined;
        data["locationId"] = this.locationId;
        data["flags"] = this.flags;
        data["storeNumber"] = this.storeNumber;
        data["location"] = this.location ? this.location.toJSON() : undefined;
        if (Array.isArray(this.packages)) {
            data["packages"] = [];
            for (var _i = 0, _a = this.packages; _i < _a.length; _i++) {
                var item = _a[_i];
                data["packages"].push(item.toJSON());
            }
        }
        data["id"] = this.id;
        return data;
    };
    return CreateOrEditConsignmentDto;
}());
export { CreateOrEditConsignmentDto };
var TerritoryConfigurationDto = /** @class */ (function () {
    function TerritoryConfigurationDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TerritoryConfigurationDto.prototype.init = function (data) {
        if (data) {
            this.territory = data["territory"];
            this.routedBy = data["routedBy"];
            this.servicedByED = data["servicedByED"];
            this.state = data["state"];
            this.showETA = data["showETA"];
            this.id = data["id"];
        }
    };
    TerritoryConfigurationDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TerritoryConfigurationDto();
        result.init(data);
        return result;
    };
    TerritoryConfigurationDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["territory"] = this.territory;
        data["routedBy"] = this.routedBy;
        data["servicedByED"] = this.servicedByED;
        data["state"] = this.state;
        data["showETA"] = this.showETA;
        data["id"] = this.id;
        return data;
    };
    return TerritoryConfigurationDto;
}());
export { TerritoryConfigurationDto };
var RelatedConsignmentOutput = /** @class */ (function () {
    function RelatedConsignmentOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RelatedConsignmentOutput.prototype.init = function (data) {
        if (data) {
            this.consignmentNumber = data["consignmentNumber"];
            this.type = data["type"];
            this.status = data["status"];
            this.consignmentDetails = data["consignmentDetails"];
            this.id = data["id"];
        }
    };
    RelatedConsignmentOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RelatedConsignmentOutput();
        result.init(data);
        return result;
    };
    RelatedConsignmentOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["consignmentNumber"] = this.consignmentNumber;
        data["type"] = this.type;
        data["status"] = this.status;
        data["consignmentDetails"] = this.consignmentDetails;
        data["id"] = this.id;
        return data;
    };
    return RelatedConsignmentOutput;
}());
export { RelatedConsignmentOutput };
export var CreaterBy;
(function (CreaterBy) {
    CreaterBy[CreaterBy["Eden"] = 0] = "Eden";
    CreaterBy[CreaterBy["External"] = 1] = "External";
})(CreaterBy || (CreaterBy = {}));
var ZendeskRequestDto = /** @class */ (function () {
    function ZendeskRequestDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ZendeskRequestDto.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.consignmentNumber = data["consignmentNumber"];
            this.url = data["url"];
            this.via = data["via"];
            this.brandName = data["brandName"];
            this.type = data["type"];
            this.subject = data["subject"];
            this.description = data["description"];
            this.priority = data["priority"];
            this.status = data["status"];
            this.requesterName = data["requesterName"];
            this.requesterEmail = data["requesterEmail"];
            this.submitterName = data["submitterName"];
            this.submitterEmail = data["submitterEmail"];
            this.assigneeName = data["assigneeName"];
            this.assigneeEmail = data["assigneeEmail"];
            this.dueAt = data["dueAt"];
            this.createdDate = data["createdDate"] ? moment(data["createdDate"].toString()) : undefined;
            this.updatedDate = data["updatedDate"] ? moment(data["updatedDate"].toString()) : undefined;
            this.nexusCase = data["nexusCase"];
            this.orderNumber = data["orderNumber"];
            this.nexusIssue_type = data["nexusIssue_type"];
            this.nexusQueryNumber = data["nexusQueryNumber"];
            this.contactName = data["contactName"];
            this.contactPhone = data["contactPhone"];
        }
    };
    ZendeskRequestDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ZendeskRequestDto();
        result.init(data);
        return result;
    };
    ZendeskRequestDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["consignmentNumber"] = this.consignmentNumber;
        data["url"] = this.url;
        data["via"] = this.via;
        data["brandName"] = this.brandName;
        data["type"] = this.type;
        data["subject"] = this.subject;
        data["description"] = this.description;
        data["priority"] = this.priority;
        data["status"] = this.status;
        data["requesterName"] = this.requesterName;
        data["requesterEmail"] = this.requesterEmail;
        data["submitterName"] = this.submitterName;
        data["submitterEmail"] = this.submitterEmail;
        data["assigneeName"] = this.assigneeName;
        data["assigneeEmail"] = this.assigneeEmail;
        data["dueAt"] = this.dueAt;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : undefined;
        data["nexusCase"] = this.nexusCase;
        data["orderNumber"] = this.orderNumber;
        data["nexusIssue_type"] = this.nexusIssue_type;
        data["nexusQueryNumber"] = this.nexusQueryNumber;
        data["contactName"] = this.contactName;
        data["contactPhone"] = this.contactPhone;
        return data;
    };
    return ZendeskRequestDto;
}());
export { ZendeskRequestDto };
var ZendeskCommentDto = /** @class */ (function () {
    function ZendeskCommentDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ZendeskCommentDto.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.author_id = data["author_id"];
            this.type = data["type"];
            this.body = data["body"];
            this.created_at = data["created_at"] ? moment(data["created_at"].toString()) : undefined;
        }
    };
    ZendeskCommentDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ZendeskCommentDto();
        result.init(data);
        return result;
    };
    ZendeskCommentDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["author_id"] = this.author_id;
        data["type"] = this.type;
        data["body"] = this.body;
        data["created_at"] = this.created_at ? this.created_at.toISOString() : undefined;
        return data;
    };
    return ZendeskCommentDto;
}());
export { ZendeskCommentDto };
var ZendeskUserDto = /** @class */ (function () {
    function ZendeskUserDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ZendeskUserDto.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.email = data["email"];
        }
    };
    ZendeskUserDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ZendeskUserDto();
        result.init(data);
        return result;
    };
    ZendeskUserDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["email"] = this.email;
        return data;
    };
    return ZendeskUserDto;
}());
export { ZendeskUserDto };
var ZendeskCommentsDto = /** @class */ (function () {
    function ZendeskCommentsDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ZendeskCommentsDto.prototype.init = function (data) {
        if (data) {
            if (Array.isArray(data["comments"])) {
                this.comments = [];
                for (var _i = 0, _a = data["comments"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.comments.push(ZendeskCommentDto.fromJS(item));
                }
            }
            if (Array.isArray(data["users"])) {
                this.users = [];
                for (var _b = 0, _c = data["users"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.users.push(ZendeskUserDto.fromJS(item));
                }
            }
        }
    };
    ZendeskCommentsDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ZendeskCommentsDto();
        result.init(data);
        return result;
    };
    ZendeskCommentsDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.comments)) {
            data["comments"] = [];
            for (var _i = 0, _a = this.comments; _i < _a.length; _i++) {
                var item = _a[_i];
                data["comments"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (var _b = 0, _c = this.users; _b < _c.length; _b++) {
                var item = _c[_b];
                data["users"].push(item.toJSON());
            }
        }
        return data;
    };
    return ZendeskCommentsDto;
}());
export { ZendeskCommentsDto };
var ZenDeskTicketDto = /** @class */ (function () {
    function ZenDeskTicketDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ZenDeskTicketDto.prototype.init = function (data) {
        if (data) {
            this.ticketId = data["ticketId"];
            this.url = data["url"];
            this.status = data["status"];
            this.createrBy = data["createrBy"];
            this.zenDeskCreatedTime = data["zenDeskCreatedTime"] ? moment(data["zenDeskCreatedTime"].toString()) : undefined;
            this.zenDeskUpdatedTime = data["zenDeskUpdatedTime"] ? moment(data["zenDeskUpdatedTime"].toString()) : undefined;
            this.consignmentNumber = data["consignmentNumber"];
            this.ticketDetails = data["ticketDetails"] ? ZendeskRequestDto.fromJS(data["ticketDetails"]) : undefined;
            this.ticketComments = data["ticketComments"] ? ZendeskCommentsDto.fromJS(data["ticketComments"]) : undefined;
            this.id = data["id"];
        }
    };
    ZenDeskTicketDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ZenDeskTicketDto();
        result.init(data);
        return result;
    };
    ZenDeskTicketDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["ticketId"] = this.ticketId;
        data["url"] = this.url;
        data["status"] = this.status;
        data["createrBy"] = this.createrBy;
        data["zenDeskCreatedTime"] = this.zenDeskCreatedTime ? this.zenDeskCreatedTime.toISOString() : undefined;
        data["zenDeskUpdatedTime"] = this.zenDeskUpdatedTime ? this.zenDeskUpdatedTime.toISOString() : undefined;
        data["consignmentNumber"] = this.consignmentNumber;
        data["ticketDetails"] = this.ticketDetails ? this.ticketDetails.toJSON() : undefined;
        data["ticketComments"] = this.ticketComments ? this.ticketComments.toJSON() : undefined;
        data["id"] = this.id;
        return data;
    };
    return ZenDeskTicketDto;
}());
export { ZenDeskTicketDto };
var GetConsignmentForEditOutput = /** @class */ (function () {
    function GetConsignmentForEditOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetConsignmentForEditOutput.prototype.init = function (data) {
        if (data) {
            this.consignment = data["consignment"] ? CreateOrEditConsignmentDto.fromJS(data["consignment"]) : undefined;
            this.territoryConfiguration = data["territoryConfiguration"] ? TerritoryConfigurationDto.fromJS(data["territoryConfiguration"]) : undefined;
            this.interState = data["interState"];
            this.exitHubName = data["exitHubName"];
            this.deliveryHubName = data["deliveryHubName"];
            this.exitHubCutOffTime = data["exitHubCutOffTime"];
            this.statusDescription = data["statusDescription"];
            this.isConnoteStatusClosed = data["isConnoteStatusClosed"];
            if (Array.isArray(data["relatedConsignments"])) {
                this.relatedConsignments = [];
                for (var _i = 0, _a = data["relatedConsignments"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.relatedConsignments.push(RelatedConsignmentOutput.fromJS(item));
                }
            }
            if (Array.isArray(data["zenDeskTickets"])) {
                this.zenDeskTickets = [];
                for (var _b = 0, _c = data["zenDeskTickets"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.zenDeskTickets.push(ZenDeskTicketDto.fromJS(item));
                }
            }
            this.client = data["client"] ? ClientDto.fromJS(data["client"]) : undefined;
            this.clientGroupName = data["clientGroupName"];
            this.pickupAllowed = data["pickupAllowed"];
            this.deliveryWindow = data["deliveryWindow"];
            this.isConnoteStatusCancelled = data["isConnoteStatusCancelled"];
            this.externalVendorName = data["externalVendorName"];
            this.externalVendorOrderNumber = data["externalVendorOrderNumber"];
            this.palletId = data["palletId"];
            this.palletConnote = data["palletConnote"];
        }
    };
    GetConsignmentForEditOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetConsignmentForEditOutput();
        result.init(data);
        return result;
    };
    GetConsignmentForEditOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["consignment"] = this.consignment ? this.consignment.toJSON() : undefined;
        data["territoryConfiguration"] = this.territoryConfiguration ? this.territoryConfiguration.toJSON() : undefined;
        data["interState"] = this.interState;
        data["exitHubName"] = this.exitHubName;
        data["deliveryHubName"] = this.deliveryHubName;
        data["exitHubCutOffTime"] = this.exitHubCutOffTime;
        data["statusDescription"] = this.statusDescription;
        data["isConnoteStatusClosed"] = this.isConnoteStatusClosed;
        if (Array.isArray(this.relatedConsignments)) {
            data["relatedConsignments"] = [];
            for (var _i = 0, _a = this.relatedConsignments; _i < _a.length; _i++) {
                var item = _a[_i];
                data["relatedConsignments"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.zenDeskTickets)) {
            data["zenDeskTickets"] = [];
            for (var _b = 0, _c = this.zenDeskTickets; _b < _c.length; _b++) {
                var item = _c[_b];
                data["zenDeskTickets"].push(item.toJSON());
            }
        }
        data["client"] = this.client ? this.client.toJSON() : undefined;
        data["clientGroupName"] = this.clientGroupName;
        data["pickupAllowed"] = this.pickupAllowed;
        data["deliveryWindow"] = this.deliveryWindow;
        data["isConnoteStatusCancelled"] = this.isConnoteStatusCancelled;
        data["externalVendorName"] = this.externalVendorName;
        data["externalVendorOrderNumber"] = this.externalVendorOrderNumber;
        data["palletId"] = this.palletId;
        data["palletConnote"] = this.palletConnote;
        return data;
    };
    return GetConsignmentForEditOutput;
}());
export { GetConsignmentForEditOutput };
var EditConsignmentContactDetailsDto = /** @class */ (function () {
    function EditConsignmentContactDetailsDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EditConsignmentContactDetailsDto.prototype.init = function (data) {
        if (data) {
            this.firstName = data["firstName"];
            this.lastName = data["lastName"];
            this.homeNumber = data["homeNumber"];
            this.workNumber = data["workNumber"];
            this.mobileNumber = data["mobileNumber"];
            this.id = data["id"];
        }
    };
    EditConsignmentContactDetailsDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new EditConsignmentContactDetailsDto();
        result.init(data);
        return result;
    };
    EditConsignmentContactDetailsDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["homeNumber"] = this.homeNumber;
        data["workNumber"] = this.workNumber;
        data["mobileNumber"] = this.mobileNumber;
        data["id"] = this.id;
        return data;
    };
    return EditConsignmentContactDetailsDto;
}());
export { EditConsignmentContactDetailsDto };
export var CommunicationListItemChannelType;
(function (CommunicationListItemChannelType) {
    CommunicationListItemChannelType[CommunicationListItemChannelType["SMS"] = 0] = "SMS";
    CommunicationListItemChannelType[CommunicationListItemChannelType["Email"] = 1] = "Email";
})(CommunicationListItemChannelType || (CommunicationListItemChannelType = {}));
export var CommunicationListItemRecipients;
(function (CommunicationListItemRecipients) {
    CommunicationListItemRecipients[CommunicationListItemRecipients["None"] = 0] = "None";
    CommunicationListItemRecipients[CommunicationListItemRecipients["Pilot"] = 1] = "Pilot";
    CommunicationListItemRecipients[CommunicationListItemRecipients["Gift_recipient_only"] = 2] = "Gift_recipient_only";
    CommunicationListItemRecipients[CommunicationListItemRecipients["All_ex__gift_recipients"] = 3] = "All_ex__gift_recipients";
    CommunicationListItemRecipients[CommunicationListItemRecipients["All"] = 4] = "All";
})(CommunicationListItemRecipients || (CommunicationListItemRecipients = {}));
var CommunicationListItem = /** @class */ (function () {
    function CommunicationListItem(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CommunicationListItem.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.channelType = data["channelType"];
            this.recipients = data["recipients"];
            this.communicationSentDateTimeUtc = data["communicationSentDateTimeUtc"] ? moment(data["communicationSentDateTimeUtc"].toString()) : undefined;
            this.shortUrl = data["shortUrl"];
            this.etaWindow = data["etaWindow"];
            this.requiresResch = data["requiresResch"];
            this.requiresRebook = data["requiresRebook"];
            this.recipient1Email = data["recipient1Email"];
            this.recipient1Mobile = data["recipient1Mobile"];
            this.recipient2Email = data["recipient2Email"];
            this.recipient2Mobile = data["recipient2Mobile"];
        }
    };
    CommunicationListItem.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CommunicationListItem();
        result.init(data);
        return result;
    };
    CommunicationListItem.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["channelType"] = this.channelType;
        data["recipients"] = this.recipients;
        data["communicationSentDateTimeUtc"] = this.communicationSentDateTimeUtc ? this.communicationSentDateTimeUtc.toISOString() : undefined;
        data["shortUrl"] = this.shortUrl;
        data["etaWindow"] = this.etaWindow;
        data["requiresResch"] = this.requiresResch;
        data["requiresRebook"] = this.requiresRebook;
        data["recipient1Email"] = this.recipient1Email;
        data["recipient1Mobile"] = this.recipient1Mobile;
        data["recipient2Email"] = this.recipient2Email;
        data["recipient2Mobile"] = this.recipient2Mobile;
        return data;
    };
    return CommunicationListItem;
}());
export { CommunicationListItem };
var PickupConsignmentDto = /** @class */ (function () {
    function PickupConsignmentDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.packageIds = [];
        }
    }
    PickupConsignmentDto.prototype.init = function (data) {
        if (data) {
            this.consignmentNumber = data["consignmentNumber"];
            this.shipDate = data["shipDate"] ? moment(data["shipDate"].toString()) : undefined;
            this.comment = data["comment"];
            this.priority = data["priority"];
            if (Array.isArray(data["packageIds"])) {
                this.packageIds = [];
                for (var _i = 0, _a = data["packageIds"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.packageIds.push(item);
                }
            }
            this.id = data["id"];
        }
    };
    PickupConsignmentDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PickupConsignmentDto();
        result.init(data);
        return result;
    };
    PickupConsignmentDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["consignmentNumber"] = this.consignmentNumber;
        data["shipDate"] = this.shipDate ? this.shipDate.toISOString() : undefined;
        data["comment"] = this.comment;
        data["priority"] = this.priority;
        if (Array.isArray(this.packageIds)) {
            data["packageIds"] = [];
            for (var _i = 0, _a = this.packageIds; _i < _a.length; _i++) {
                var item = _a[_i];
                data["packageIds"].push(item);
            }
        }
        data["id"] = this.id;
        return data;
    };
    return PickupConsignmentDto;
}());
export { PickupConsignmentDto };
var ValidateActivePickupDoesNotExistForBarcodesDto = /** @class */ (function () {
    function ValidateActivePickupDoesNotExistForBarcodesDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.packageBarcodes = [];
        }
    }
    ValidateActivePickupDoesNotExistForBarcodesDto.prototype.init = function (data) {
        if (data) {
            this.consignmentNumber = data["consignmentNumber"];
            if (Array.isArray(data["packageBarcodes"])) {
                this.packageBarcodes = [];
                for (var _i = 0, _a = data["packageBarcodes"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.packageBarcodes.push(item);
                }
            }
            this.id = data["id"];
        }
    };
    ValidateActivePickupDoesNotExistForBarcodesDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ValidateActivePickupDoesNotExistForBarcodesDto();
        result.init(data);
        return result;
    };
    ValidateActivePickupDoesNotExistForBarcodesDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["consignmentNumber"] = this.consignmentNumber;
        if (Array.isArray(this.packageBarcodes)) {
            data["packageBarcodes"] = [];
            for (var _i = 0, _a = this.packageBarcodes; _i < _a.length; _i++) {
                var item = _a[_i];
                data["packageBarcodes"].push(item);
            }
        }
        data["id"] = this.id;
        return data;
    };
    return ValidateActivePickupDoesNotExistForBarcodesDto;
}());
export { ValidateActivePickupDoesNotExistForBarcodesDto };
var ConsignmentStatisticsDto = /** @class */ (function () {
    function ConsignmentStatisticsDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ConsignmentStatisticsDto.prototype.init = function (data) {
        if (data) {
            this.consignmentCount = data["consignmentCount"];
            this.packageCount = data["packageCount"];
            this.totalWeight = data["totalWeight"];
        }
    };
    ConsignmentStatisticsDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ConsignmentStatisticsDto();
        result.init(data);
        return result;
    };
    ConsignmentStatisticsDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["consignmentCount"] = this.consignmentCount;
        data["packageCount"] = this.packageCount;
        data["totalWeight"] = this.totalWeight;
        return data;
    };
    return ConsignmentStatisticsDto;
}());
export { ConsignmentStatisticsDto };
var CreateReturnToSupplierInput = /** @class */ (function () {
    function CreateReturnToSupplierInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateReturnToSupplierInput.prototype.init = function (data) {
        if (data) {
            this.consignmentId = data["consignmentId"];
            this.shipDate = data["shipDate"] ? moment(data["shipDate"].toString()) : undefined;
            this.carrierId = data["carrierId"];
            this.locationId = data["locationId"];
            this.location = data["location"] ? CreateOrEditLocationDto.fromJS(data["location"]) : undefined;
        }
    };
    CreateReturnToSupplierInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateReturnToSupplierInput();
        result.init(data);
        return result;
    };
    CreateReturnToSupplierInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["consignmentId"] = this.consignmentId;
        data["shipDate"] = this.shipDate ? this.shipDate.toISOString() : undefined;
        data["carrierId"] = this.carrierId;
        data["locationId"] = this.locationId;
        data["location"] = this.location ? this.location.toJSON() : undefined;
        return data;
    };
    return CreateReturnToSupplierInput;
}());
export { CreateReturnToSupplierInput };
export var ChangeStatusType;
(function (ChangeStatusType) {
    ChangeStatusType[ChangeStatusType["None"] = 0] = "None";
    ChangeStatusType[ChangeStatusType["Cancel"] = 1] = "Cancel";
    ChangeStatusType[ChangeStatusType["Confirm"] = 2] = "Confirm";
    ChangeStatusType[ChangeStatusType["LAIComplete"] = 3] = "LAIComplete";
    ChangeStatusType[ChangeStatusType["SignComplete"] = 4] = "SignComplete";
    ChangeStatusType[ChangeStatusType["PickUpComplete"] = 5] = "PickUpComplete";
    ChangeStatusType[ChangeStatusType["WithDriver"] = 6] = "WithDriver";
    ChangeStatusType[ChangeStatusType["WithCarrier"] = 7] = "WithCarrier";
})(ChangeStatusType || (ChangeStatusType = {}));
var ChangeStatusByConsignmentNumbersDto = /** @class */ (function () {
    function ChangeStatusByConsignmentNumbersDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ChangeStatusByConsignmentNumbersDto.prototype.init = function (data) {
        if (data) {
            if (Array.isArray(data["consignmentIds"])) {
                this.consignmentIds = [];
                for (var _i = 0, _a = data["consignmentIds"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.consignmentIds.push(item);
                }
            }
            this.changeStatusType = data["changeStatusType"];
            this.comment = data["comment"];
            this.deliveryDate = data["deliveryDate"] ? moment(data["deliveryDate"].toString()) : undefined;
            this.setShipDateAsDeliveryDate = data["setShipDateAsDeliveryDate"];
        }
    };
    ChangeStatusByConsignmentNumbersDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ChangeStatusByConsignmentNumbersDto();
        result.init(data);
        return result;
    };
    ChangeStatusByConsignmentNumbersDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.consignmentIds)) {
            data["consignmentIds"] = [];
            for (var _i = 0, _a = this.consignmentIds; _i < _a.length; _i++) {
                var item = _a[_i];
                data["consignmentIds"].push(item);
            }
        }
        data["changeStatusType"] = this.changeStatusType;
        data["comment"] = this.comment;
        data["deliveryDate"] = this.deliveryDate ? this.deliveryDate.toISOString() : undefined;
        data["setShipDateAsDeliveryDate"] = this.setShipDateAsDeliveryDate;
        return data;
    };
    return ChangeStatusByConsignmentNumbersDto;
}());
export { ChangeStatusByConsignmentNumbersDto };
var ChangeStatusDto = /** @class */ (function () {
    function ChangeStatusDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ChangeStatusDto.prototype.init = function (data) {
        if (data) {
            this.input = data["input"] ? GetAllConsignmentsInput.fromJS(data["input"]) : undefined;
            this.changeStatusType = data["changeStatusType"];
            this.comment = data["comment"];
            this.deliveryDate = data["deliveryDate"] ? moment(data["deliveryDate"].toString()) : undefined;
            this.setShipDateAsDeliveryDate = data["setShipDateAsDeliveryDate"];
        }
    };
    ChangeStatusDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ChangeStatusDto();
        result.init(data);
        return result;
    };
    ChangeStatusDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["input"] = this.input ? this.input.toJSON() : undefined;
        data["changeStatusType"] = this.changeStatusType;
        data["comment"] = this.comment;
        data["deliveryDate"] = this.deliveryDate ? this.deliveryDate.toISOString() : undefined;
        data["setShipDateAsDeliveryDate"] = this.setShipDateAsDeliveryDate;
        return data;
    };
    return ChangeStatusDto;
}());
export { ChangeStatusDto };
var LocationDetail = /** @class */ (function () {
    function LocationDetail(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    LocationDetail.prototype.init = function (data) {
        if (data) {
            this.latitude = data["latitude"];
            this.isBusiness = data["isBusiness"];
            this.longitude = data["longitude"];
            this.state = data["state"];
            this.mileZeroLocationId = data["mileZeroLocationId"];
            this.postalCode = data["postalCode"];
            this.businessName = data["businessName"];
            this.addressLine1 = data["addressLine1"];
            this.addressLine2 = data["addressLine2"];
            this.suburb = data["suburb"];
            if (Array.isArray(data["locations"])) {
                this.locations = [];
                for (var _i = 0, _a = data["locations"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.locations.push(Location.fromJS(item));
                }
            }
            this.storeId = data["storeId"];
            this.jsonData = data["jsonData"];
            this.deliveryTimeFrom = data["deliveryTimeFrom"];
            this.deliveryTimeTo = data["deliveryTimeTo"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    };
    LocationDetail.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new LocationDetail();
        result.init(data);
        return result;
    };
    LocationDetail.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["latitude"] = this.latitude;
        data["isBusiness"] = this.isBusiness;
        data["longitude"] = this.longitude;
        data["state"] = this.state;
        data["mileZeroLocationId"] = this.mileZeroLocationId;
        data["postalCode"] = this.postalCode;
        data["businessName"] = this.businessName;
        data["addressLine1"] = this.addressLine1;
        data["addressLine2"] = this.addressLine2;
        data["suburb"] = this.suburb;
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (var _i = 0, _a = this.locations; _i < _a.length; _i++) {
                var item = _a[_i];
                data["locations"].push(item.toJSON());
            }
        }
        data["storeId"] = this.storeId;
        data["jsonData"] = this.jsonData;
        data["deliveryTimeFrom"] = this.deliveryTimeFrom;
        data["deliveryTimeTo"] = this.deliveryTimeTo;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    return LocationDetail;
}());
export { LocationDetail };
export var PalletStatus;
(function (PalletStatus) {
    PalletStatus[PalletStatus["PendingExport"] = 1] = "PendingExport";
    PalletStatus[PalletStatus["Exported"] = 2] = "Exported";
    PalletStatus[PalletStatus["FailedExport"] = 3] = "FailedExport";
    PalletStatus[PalletStatus["WithDriver"] = 4] = "WithDriver";
    PalletStatus[PalletStatus["SignComplete"] = 5] = "SignComplete";
    PalletStatus[PalletStatus["LAIComplete"] = 6] = "LAIComplete";
    PalletStatus[PalletStatus["FailedDelivery"] = 7] = "FailedDelivery";
})(PalletStatus || (PalletStatus = {}));
var PalletPackage = /** @class */ (function () {
    function PalletPackage(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PalletPackage.prototype.init = function (data) {
        if (data) {
            this.palletId = data["palletId"];
            this.pallet = data["pallet"] ? Pallet.fromJS(data["pallet"]) : undefined;
            this.packageId = data["packageId"];
            this.package = data["package"] ? Package.fromJS(data["package"]) : undefined;
            this.id = data["id"];
        }
    };
    PalletPackage.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PalletPackage();
        result.init(data);
        return result;
    };
    PalletPackage.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["palletId"] = this.palletId;
        data["pallet"] = this.pallet ? this.pallet.toJSON() : undefined;
        data["packageId"] = this.packageId;
        data["package"] = this.package ? this.package.toJSON() : undefined;
        data["id"] = this.id;
        return data;
    };
    return PalletPackage;
}());
export { PalletPackage };
var Pallet = /** @class */ (function () {
    function Pallet(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Pallet.prototype.init = function (data) {
        if (data) {
            this.consignmentNumber = data["consignmentNumber"];
            this.barcode = data["barcode"];
            this.shipdate = data["shipdate"] ? moment(data["shipdate"].toString()) : undefined;
            this.from = data["from"];
            this.weight = data["weight"];
            this.carrier = data["carrier"];
            this.docket = data["docket"];
            this.deliveryInstruction = data["deliveryInstruction"];
            this.storeId = data["storeId"];
            this.locationId = data["locationId"];
            this.location = data["location"] ? Location.fromJS(data["location"]) : undefined;
            this.status = data["status"];
            this.isActive = data["isActive"];
            this.mappedLocations = data["mappedLocations"];
            this.podIdentifierInFred = data["podIdentifierInFred"];
            this.dropCode = data["dropCode"];
            if (Array.isArray(data["palletPackages"])) {
                this.palletPackages = [];
                for (var _i = 0, _a = data["palletPackages"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.palletPackages.push(PalletPackage.fromJS(item));
                }
            }
            this.rescheduledCount = data["rescheduledCount"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    };
    Pallet.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Pallet();
        result.init(data);
        return result;
    };
    Pallet.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["consignmentNumber"] = this.consignmentNumber;
        data["barcode"] = this.barcode;
        data["shipdate"] = this.shipdate ? this.shipdate.toISOString() : undefined;
        data["from"] = this.from;
        data["weight"] = this.weight;
        data["carrier"] = this.carrier;
        data["docket"] = this.docket;
        data["deliveryInstruction"] = this.deliveryInstruction;
        data["storeId"] = this.storeId;
        data["locationId"] = this.locationId;
        data["location"] = this.location ? this.location.toJSON() : undefined;
        data["status"] = this.status;
        data["isActive"] = this.isActive;
        data["mappedLocations"] = this.mappedLocations;
        data["podIdentifierInFred"] = this.podIdentifierInFred;
        data["dropCode"] = this.dropCode;
        if (Array.isArray(this.palletPackages)) {
            data["palletPackages"] = [];
            for (var _i = 0, _a = this.palletPackages; _i < _a.length; _i++) {
                var item = _a[_i];
                data["palletPackages"].push(item.toJSON());
            }
        }
        data["rescheduledCount"] = this.rescheduledCount;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    return Pallet;
}());
export { Pallet };
var Location = /** @class */ (function () {
    function Location(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Location.prototype.init = function (data) {
        if (data) {
            this.fullAddress = data["fullAddress"];
            this.hasGeocode = data["hasGeocode"];
            this.ignoredAt = data["ignoredAt"] ? moment(data["ignoredAt"].toString()) : undefined;
            this.locationDetailId = data["locationDetailId"];
            this.locationDetail = data["locationDetail"] ? LocationDetail.fromJS(data["locationDetail"]) : undefined;
            if (Array.isArray(data["consignments"])) {
                this.consignments = [];
                for (var _i = 0, _a = data["consignments"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.consignments.push(Consignment.fromJS(item));
                }
            }
            if (Array.isArray(data["pallets"])) {
                this.pallets = [];
                for (var _b = 0, _c = data["pallets"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.pallets.push(Pallet.fromJS(item));
                }
            }
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    };
    Location.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Location();
        result.init(data);
        return result;
    };
    Location.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["fullAddress"] = this.fullAddress;
        data["hasGeocode"] = this.hasGeocode;
        data["ignoredAt"] = this.ignoredAt ? this.ignoredAt.toISOString() : undefined;
        data["locationDetailId"] = this.locationDetailId;
        data["locationDetail"] = this.locationDetail ? this.locationDetail.toJSON() : undefined;
        if (Array.isArray(this.consignments)) {
            data["consignments"] = [];
            for (var _i = 0, _a = this.consignments; _i < _a.length; _i++) {
                var item = _a[_i];
                data["consignments"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.pallets)) {
            data["pallets"] = [];
            for (var _b = 0, _c = this.pallets; _b < _c.length; _b++) {
                var item = _c[_b];
                data["pallets"].push(item.toJSON());
            }
        }
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    return Location;
}());
export { Location };
export var FredStatus;
(function (FredStatus) {
    FredStatus[FredStatus["ReadyToSend"] = 0] = "ReadyToSend";
    FredStatus[FredStatus["Sent"] = 1] = "Sent";
    FredStatus[FredStatus["Processing"] = 2] = "Processing";
    FredStatus[FredStatus["Failed"] = 3] = "Failed";
})(FredStatus || (FredStatus = {}));
var Consignment = /** @class */ (function () {
    function Consignment(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Consignment.prototype.init = function (data) {
        if (data) {
            this.consignmentNumber = data["consignmentNumber"];
            this.originalConsignmentNumber = data["originalConsignmentNumber"];
            this.isBusinessAddress = data["isBusinessAddress"];
            this.shipDate = data["shipDate"] ? moment(data["shipDate"].toString()) : undefined;
            this.brand = data["brand"];
            this.title = data["title"];
            this.firstName = data["firstName"];
            this.lastName = data["lastName"];
            this.homeNumber = data["homeNumber"];
            this.workNumber = data["workNumber"];
            this.mobileNumber = data["mobileNumber"];
            this.emailAddress = data["emailAddress"];
            this.carrierCode = data["carrierCode"];
            this.type = data["type"];
            this.status = data["status"];
            this.exitHub = data["exitHub"];
            this.deliveryHub = data["deliveryHub"];
            this.podName = data["podName"];
            this.podIdentifierInFred = data["podIdentifierInFred"];
            this.orderNumber = data["orderNumber"];
            this.clientId = data["clientId"];
            this.clientName = data["clientName"];
            this.clientFileName = data["clientFileName"];
            this.clientGroupId = data["clientGroupId"];
            this.preferredShipDate = data["preferredShipDate"] ? moment(data["preferredShipDate"].toString()) : undefined;
            this.actionTakenAt = data["actionTakenAt"] ? moment(data["actionTakenAt"].toString()) : undefined;
            this.removedFromDashboardAt = data["removedFromDashboardAt"] ? moment(data["removedFromDashboardAt"].toString()) : undefined;
            this.locationId = data["locationId"];
            this.location = data["location"] ? Location.fromJS(data["location"]) : undefined;
            if (Array.isArray(data["packages"])) {
                this.packages = [];
                for (var _i = 0, _a = data["packages"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.packages.push(Package.fromJS(item));
                }
            }
            this.dropCode = data["dropCode"];
            this.deliveryInstructions = data["deliveryInstructions"];
            this.deliveryWith = data["deliveryWith"];
            this.deliveryEta = data["deliveryEta"];
            this.giftFlag = data["giftFlag"];
            this.giftMessage = data["giftMessage"];
            this.consignmentDetails = data["consignmentDetails"];
            this.sourceSystem = data["sourceSystem"];
            this.priority = data["priority"];
            this.storeNumber = data["storeNumber"];
            this.isCrossBorder = data["isCrossBorder"];
            this.regionType = data["regionType"];
            this.regionValue = data["regionValue"];
            this.slaDate = data["slaDate"] ? moment(data["slaDate"].toString()) : undefined;
            this.brandRegionSLAId = data["brandRegionSLAId"];
            this.isClickAndCollect = data["isClickAndCollect"];
            this.fredStatus = data["fredStatus"];
            this.rescheduledCount = data["rescheduledCount"];
            this.customerId = data["customerId"];
            this.carrierShipmentId = data["carrierShipmentId"];
            this.flags = data["flags"];
            this.externalVendorName = data["externalVendorName"];
            this.externalVendorOrderNumber = data["externalVendorOrderNumber"];
            this.heatStatus = data["heatStatus"];
            this.trackingInfo = data["trackingInfo"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    };
    Consignment.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Consignment();
        result.init(data);
        return result;
    };
    Consignment.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["consignmentNumber"] = this.consignmentNumber;
        data["originalConsignmentNumber"] = this.originalConsignmentNumber;
        data["isBusinessAddress"] = this.isBusinessAddress;
        data["shipDate"] = this.shipDate ? this.shipDate.toISOString() : undefined;
        data["brand"] = this.brand;
        data["title"] = this.title;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["homeNumber"] = this.homeNumber;
        data["workNumber"] = this.workNumber;
        data["mobileNumber"] = this.mobileNumber;
        data["emailAddress"] = this.emailAddress;
        data["carrierCode"] = this.carrierCode;
        data["type"] = this.type;
        data["status"] = this.status;
        data["exitHub"] = this.exitHub;
        data["deliveryHub"] = this.deliveryHub;
        data["podName"] = this.podName;
        data["podIdentifierInFred"] = this.podIdentifierInFred;
        data["orderNumber"] = this.orderNumber;
        data["clientId"] = this.clientId;
        data["clientName"] = this.clientName;
        data["clientFileName"] = this.clientFileName;
        data["clientGroupId"] = this.clientGroupId;
        data["preferredShipDate"] = this.preferredShipDate ? this.preferredShipDate.toISOString() : undefined;
        data["actionTakenAt"] = this.actionTakenAt ? this.actionTakenAt.toISOString() : undefined;
        data["removedFromDashboardAt"] = this.removedFromDashboardAt ? this.removedFromDashboardAt.toISOString() : undefined;
        data["locationId"] = this.locationId;
        data["location"] = this.location ? this.location.toJSON() : undefined;
        if (Array.isArray(this.packages)) {
            data["packages"] = [];
            for (var _i = 0, _a = this.packages; _i < _a.length; _i++) {
                var item = _a[_i];
                data["packages"].push(item.toJSON());
            }
        }
        data["dropCode"] = this.dropCode;
        data["deliveryInstructions"] = this.deliveryInstructions;
        data["deliveryWith"] = this.deliveryWith;
        data["deliveryEta"] = this.deliveryEta;
        data["giftFlag"] = this.giftFlag;
        data["giftMessage"] = this.giftMessage;
        data["consignmentDetails"] = this.consignmentDetails;
        data["sourceSystem"] = this.sourceSystem;
        data["priority"] = this.priority;
        data["storeNumber"] = this.storeNumber;
        data["isCrossBorder"] = this.isCrossBorder;
        data["regionType"] = this.regionType;
        data["regionValue"] = this.regionValue;
        data["slaDate"] = this.slaDate ? this.slaDate.toISOString() : undefined;
        data["brandRegionSLAId"] = this.brandRegionSLAId;
        data["isClickAndCollect"] = this.isClickAndCollect;
        data["fredStatus"] = this.fredStatus;
        data["rescheduledCount"] = this.rescheduledCount;
        data["customerId"] = this.customerId;
        data["carrierShipmentId"] = this.carrierShipmentId;
        data["flags"] = this.flags;
        data["externalVendorName"] = this.externalVendorName;
        data["externalVendorOrderNumber"] = this.externalVendorOrderNumber;
        data["heatStatus"] = this.heatStatus;
        data["trackingInfo"] = this.trackingInfo;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    return Consignment;
}());
export { Consignment };
var PackageEventTag = /** @class */ (function () {
    function PackageEventTag(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PackageEventTag.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.packageEventId = data["packageEventId"];
            this.packageEvent = data["packageEvent"] ? PackageEvent.fromJS(data["packageEvent"]) : undefined;
            this.id = data["id"];
        }
    };
    PackageEventTag.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PackageEventTag();
        result.init(data);
        return result;
    };
    PackageEventTag.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["packageEventId"] = this.packageEventId;
        data["packageEvent"] = this.packageEvent ? this.packageEvent.toJSON() : undefined;
        data["id"] = this.id;
        return data;
    };
    return PackageEventTag;
}());
export { PackageEventTag };
var PackageEvent = /** @class */ (function () {
    function PackageEvent(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PackageEvent.prototype.init = function (data) {
        if (data) {
            this.source = data["source"];
            this.signMessage = data["signMessage"];
            this.eventName = data["eventName"];
            this.eventStatus = data["eventStatus"];
            this.eventDescription = data["eventDescription"];
            this.subStatus = data["subStatus"];
            this.routeId = data["routeId"];
            this.routeName = data["routeName"];
            this.plannedTime = data["plannedTime"] ? moment(data["plannedTime"].toString()) : undefined;
            this.driverCode = data["driverCode"];
            this.statusTime = data["statusTime"] ? moment(data["statusTime"].toString()) : undefined;
            this.exception = data["exception"];
            this.packageId = data["packageId"];
            this.package = data["package"] ? Package.fromJS(data["package"]) : undefined;
            this.stopNumber = data["stopNumber"];
            this.comments = data["comments"];
            this.eventLocation = data["eventLocation"];
            this.loadId = data["loadId"];
            if (Array.isArray(data["packageEventTags"])) {
                this.packageEventTags = [];
                for (var _i = 0, _a = data["packageEventTags"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.packageEventTags.push(PackageEventTag.fromJS(item));
                }
            }
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    };
    PackageEvent.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PackageEvent();
        result.init(data);
        return result;
    };
    PackageEvent.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["source"] = this.source;
        data["signMessage"] = this.signMessage;
        data["eventName"] = this.eventName;
        data["eventStatus"] = this.eventStatus;
        data["eventDescription"] = this.eventDescription;
        data["subStatus"] = this.subStatus;
        data["routeId"] = this.routeId;
        data["routeName"] = this.routeName;
        data["plannedTime"] = this.plannedTime ? this.plannedTime.toISOString() : undefined;
        data["driverCode"] = this.driverCode;
        data["statusTime"] = this.statusTime ? this.statusTime.toISOString() : undefined;
        data["exception"] = this.exception;
        data["packageId"] = this.packageId;
        data["package"] = this.package ? this.package.toJSON() : undefined;
        data["stopNumber"] = this.stopNumber;
        data["comments"] = this.comments;
        data["eventLocation"] = this.eventLocation;
        data["loadId"] = this.loadId;
        if (Array.isArray(this.packageEventTags)) {
            data["packageEventTags"] = [];
            for (var _i = 0, _a = this.packageEventTags; _i < _a.length; _i++) {
                var item = _a[_i];
                data["packageEventTags"].push(item.toJSON());
            }
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    return PackageEvent;
}());
export { PackageEvent };
export var LoadStatus;
(function (LoadStatus) {
    LoadStatus[LoadStatus["Unknown"] = 0] = "Unknown";
    LoadStatus[LoadStatus["PendingDepart"] = 1] = "PendingDepart";
    LoadStatus[LoadStatus["Departed"] = 2] = "Departed";
    LoadStatus[LoadStatus["Arrived"] = 3] = "Arrived";
    LoadStatus[LoadStatus["SortInProgress"] = 4] = "SortInProgress";
    LoadStatus[LoadStatus["SortComplete"] = 5] = "SortComplete";
    LoadStatus[LoadStatus["Exported"] = 6] = "Exported";
    LoadStatus[LoadStatus["FailedExport"] = 7] = "FailedExport";
    LoadStatus[LoadStatus["PendingArrival"] = 8] = "PendingArrival";
    LoadStatus[LoadStatus["FailedDepart"] = 9] = "FailedDepart";
})(LoadStatus || (LoadStatus = {}));
export var LoadType;
(function (LoadType) {
    LoadType[LoadType["None"] = 0] = "None";
    LoadType[LoadType["Local"] = 1] = "Local";
    LoadType[LoadType["Xborder"] = 2] = "Xborder";
    LoadType[LoadType["Manifest"] = 3] = "Manifest";
    LoadType[LoadType["RTS"] = 4] = "RTS";
})(LoadType || (LoadType = {}));
export var FileRecordStatus;
(function (FileRecordStatus) {
    FileRecordStatus[FileRecordStatus["Created"] = 0] = "Created";
    FileRecordStatus[FileRecordStatus["FailedValidation"] = 1] = "FailedValidation";
    FileRecordStatus[FileRecordStatus["PassedValidation"] = 2] = "PassedValidation";
    FileRecordStatus[FileRecordStatus["Processing"] = 3] = "Processing";
    FileRecordStatus[FileRecordStatus["Sent"] = 4] = "Sent";
    FileRecordStatus[FileRecordStatus["Failed"] = 20] = "Failed";
})(FileRecordStatus || (FileRecordStatus = {}));
var ConsignmentStatus = /** @class */ (function () {
    function ConsignmentStatus(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ConsignmentStatus.prototype.init = function (data) {
        if (data) {
            this.description = data["description"];
            this.clientVisible = data["clientVisible"];
            this.isConnoteStatusClosed = data["isConnoteStatusClosed"];
            this.isConnoteStatusCancelled = data["isConnoteStatusCancelled"];
            this.id = data["id"];
        }
    };
    ConsignmentStatus.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ConsignmentStatus();
        result.init(data);
        return result;
    };
    ConsignmentStatus.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["clientVisible"] = this.clientVisible;
        data["isConnoteStatusClosed"] = this.isConnoteStatusClosed;
        data["isConnoteStatusCancelled"] = this.isConnoteStatusCancelled;
        data["id"] = this.id;
        return data;
    };
    return ConsignmentStatus;
}());
export { ConsignmentStatus };
var Brand = /** @class */ (function () {
    function Brand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Brand.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.rtsCarrierCode = data["rtsCarrierCode"];
            this.id = data["id"];
        }
    };
    Brand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Brand();
        result.init(data);
        return result;
    };
    Brand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["rtsCarrierCode"] = this.rtsCarrierCode;
        data["id"] = this.id;
        return data;
    };
    return Brand;
}());
export { Brand };
var DepotLocationScanTag = /** @class */ (function () {
    function DepotLocationScanTag(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DepotLocationScanTag.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.depotLocationId = data["depotLocationId"];
            this.depotLocation = data["depotLocation"] ? DepotLocation.fromJS(data["depotLocation"]) : undefined;
            this.id = data["id"];
        }
    };
    DepotLocationScanTag.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DepotLocationScanTag();
        result.init(data);
        return result;
    };
    DepotLocationScanTag.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["depotLocationId"] = this.depotLocationId;
        data["depotLocation"] = this.depotLocation ? this.depotLocation.toJSON() : undefined;
        data["id"] = this.id;
        return data;
    };
    return DepotLocationScanTag;
}());
export { DepotLocationScanTag };
var DepotLocation = /** @class */ (function () {
    function DepotLocation(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DepotLocation.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.cutoffTime = data["cutoffTime"];
            this.address1 = data["address1"];
            this.address2 = data["address2"];
            this.suburb = data["suburb"];
            this.state = data["state"];
            this.postcode = data["postcode"];
            this.depotStoreNumber = data["depotStoreNumber"];
            if (Array.isArray(data["validDepotLocationScanTags"])) {
                this.validDepotLocationScanTags = [];
                for (var _i = 0, _a = data["validDepotLocationScanTags"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.validDepotLocationScanTags.push(DepotLocationScanTag.fromJS(item));
                }
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    };
    DepotLocation.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DepotLocation();
        result.init(data);
        return result;
    };
    DepotLocation.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["cutoffTime"] = this.cutoffTime;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["suburb"] = this.suburb;
        data["state"] = this.state;
        data["postcode"] = this.postcode;
        data["depotStoreNumber"] = this.depotStoreNumber;
        if (Array.isArray(this.validDepotLocationScanTags)) {
            data["validDepotLocationScanTags"] = [];
            for (var _i = 0, _a = this.validDepotLocationScanTags; _i < _a.length; _i++) {
                var item = _a[_i];
                data["validDepotLocationScanTags"].push(item.toJSON());
            }
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    return DepotLocation;
}());
export { DepotLocation };
var ManifestTemplate = /** @class */ (function () {
    function ManifestTemplate(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ManifestTemplate.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.reqColumnsInOrder = data["reqColumnsInOrder"];
            this.lneColumnsInOrder = data["lneColumnsInOrder"];
            this.jsonSchema = data["jsonSchema"];
            this.sampleFile = data["sampleFile"];
            this.id = data["id"];
        }
    };
    ManifestTemplate.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ManifestTemplate();
        result.init(data);
        return result;
    };
    ManifestTemplate.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["reqColumnsInOrder"] = this.reqColumnsInOrder;
        data["lneColumnsInOrder"] = this.lneColumnsInOrder;
        data["jsonSchema"] = this.jsonSchema;
        data["sampleFile"] = this.sampleFile;
        data["id"] = this.id;
        return data;
    };
    return ManifestTemplate;
}());
export { ManifestTemplate };
var ClientGroup = /** @class */ (function () {
    function ClientGroup(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ClientGroup.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.cutoffTime = data["cutoffTime"];
            this.signatureRequired = data["signatureRequired"];
            this.brandId = data["brandId"];
            this.brand = data["brand"] ? Brand.fromJS(data["brand"]) : undefined;
            this.depotLocationId = data["depotLocationId"];
            this.depotLocation = data["depotLocation"] ? DepotLocation.fromJS(data["depotLocation"]) : undefined;
            this.consignmentStatusId = data["consignmentStatusId"];
            this.consignmentStatus = data["consignmentStatus"] ? ConsignmentStatus.fromJS(data["consignmentStatus"]) : undefined;
            this.manifestTemplateId = data["manifestTemplateId"];
            this.manifestTemplate = data["manifestTemplate"] ? ManifestTemplate.fromJS(data["manifestTemplate"]) : undefined;
            this.cutoffAlert = data["cutoffAlert"];
            this.locationId = data["locationId"];
            this.location = data["location"] ? Location.fromJS(data["location"]) : undefined;
            this.d365Entity = data["d365Entity"];
            this.type = data["type"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    };
    ClientGroup.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ClientGroup();
        result.init(data);
        return result;
    };
    ClientGroup.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["cutoffTime"] = this.cutoffTime;
        data["signatureRequired"] = this.signatureRequired;
        data["brandId"] = this.brandId;
        data["brand"] = this.brand ? this.brand.toJSON() : undefined;
        data["depotLocationId"] = this.depotLocationId;
        data["depotLocation"] = this.depotLocation ? this.depotLocation.toJSON() : undefined;
        data["consignmentStatusId"] = this.consignmentStatusId;
        data["consignmentStatus"] = this.consignmentStatus ? this.consignmentStatus.toJSON() : undefined;
        data["manifestTemplateId"] = this.manifestTemplateId;
        data["manifestTemplate"] = this.manifestTemplate ? this.manifestTemplate.toJSON() : undefined;
        data["cutoffAlert"] = this.cutoffAlert;
        data["locationId"] = this.locationId;
        data["location"] = this.location ? this.location.toJSON() : undefined;
        data["d365Entity"] = this.d365Entity;
        data["type"] = this.type;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    return ClientGroup;
}());
export { ClientGroup };
var LoadClient = /** @class */ (function () {
    function LoadClient(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    LoadClient.prototype.init = function (data) {
        if (data) {
            this.loadId = data["loadId"];
            this.load = data["load"] ? Load.fromJS(data["load"]) : undefined;
            this.clientId = data["clientId"];
            this.client = data["client"] ? Client.fromJS(data["client"]) : undefined;
        }
    };
    LoadClient.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new LoadClient();
        result.init(data);
        return result;
    };
    LoadClient.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["loadId"] = this.loadId;
        data["load"] = this.load ? this.load.toJSON() : undefined;
        data["clientId"] = this.clientId;
        data["client"] = this.client ? this.client.toJSON() : undefined;
        return data;
    };
    return LoadClient;
}());
export { LoadClient };
var ManifestFileClient = /** @class */ (function () {
    function ManifestFileClient(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ManifestFileClient.prototype.init = function (data) {
        if (data) {
            this.manifestFileId = data["manifestFileId"];
            this.manifestFile = data["manifestFile"] ? ManifestFile.fromJS(data["manifestFile"]) : undefined;
            this.clientId = data["clientId"];
            this.client = data["client"] ? Client.fromJS(data["client"]) : undefined;
        }
    };
    ManifestFileClient.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ManifestFileClient();
        result.init(data);
        return result;
    };
    ManifestFileClient.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["manifestFileId"] = this.manifestFileId;
        data["manifestFile"] = this.manifestFile ? this.manifestFile.toJSON() : undefined;
        data["clientId"] = this.clientId;
        data["client"] = this.client ? this.client.toJSON() : undefined;
        return data;
    };
    return ManifestFileClient;
}());
export { ManifestFileClient };
var Client = /** @class */ (function () {
    function Client(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Client.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.leadTime = data["leadTime"];
            this.notificationEmail = data["notificationEmail"];
            this.code = data["code"];
            this.clientGroupId = data["clientGroupId"];
            this.clientGroup = data["clientGroup"] ? ClientGroup.fromJS(data["clientGroup"]) : undefined;
            this.locationId = data["locationId"];
            this.location = data["location"] ? Location.fromJS(data["location"]) : undefined;
            this.state = data["state"];
            if (Array.isArray(data["loadClients"])) {
                this.loadClients = [];
                for (var _i = 0, _a = data["loadClients"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.loadClients.push(LoadClient.fromJS(item));
                }
            }
            if (Array.isArray(data["manifestFileClients"])) {
                this.manifestFileClients = [];
                for (var _b = 0, _c = data["manifestFileClients"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.manifestFileClients.push(ManifestFileClient.fromJS(item));
                }
            }
            this.auto3PLExport = data["auto3PLExport"];
            this.rosterLogicEnabled = data["rosterLogicEnabled"];
            this.vpsPickupRosterLogicEnabled = data["vpsPickupRosterLogicEnabled"];
            this.vpsPickupRoster = data["vpsPickupRoster"];
            this.pickupLocationConfig = data["pickupLocationConfig"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    };
    Client.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Client();
        result.init(data);
        return result;
    };
    Client.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["leadTime"] = this.leadTime;
        data["notificationEmail"] = this.notificationEmail;
        data["code"] = this.code;
        data["clientGroupId"] = this.clientGroupId;
        data["clientGroup"] = this.clientGroup ? this.clientGroup.toJSON() : undefined;
        data["locationId"] = this.locationId;
        data["location"] = this.location ? this.location.toJSON() : undefined;
        data["state"] = this.state;
        if (Array.isArray(this.loadClients)) {
            data["loadClients"] = [];
            for (var _i = 0, _a = this.loadClients; _i < _a.length; _i++) {
                var item = _a[_i];
                data["loadClients"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.manifestFileClients)) {
            data["manifestFileClients"] = [];
            for (var _b = 0, _c = this.manifestFileClients; _b < _c.length; _b++) {
                var item = _c[_b];
                data["manifestFileClients"].push(item.toJSON());
            }
        }
        data["auto3PLExport"] = this.auto3PLExport;
        data["rosterLogicEnabled"] = this.rosterLogicEnabled;
        data["vpsPickupRosterLogicEnabled"] = this.vpsPickupRosterLogicEnabled;
        data["vpsPickupRoster"] = this.vpsPickupRoster;
        data["pickupLocationConfig"] = this.pickupLocationConfig;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    return Client;
}());
export { Client };
var ManifestFileRecord = /** @class */ (function () {
    function ManifestFileRecord(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ManifestFileRecord.prototype.init = function (data) {
        if (data) {
            this.connoteNumber = data["connoteNumber"];
            this.asJsonString = data["asJsonString"];
            this.status = data["status"];
            this.manifestFileId = data["manifestFileId"];
            this.manifestFile = data["manifestFile"] ? ManifestFile.fromJS(data["manifestFile"]) : undefined;
            this.consignmentStatusId = data["consignmentStatusId"];
            this.consignmentStatus = data["consignmentStatus"] ? ConsignmentStatus.fromJS(data["consignmentStatus"]) : undefined;
            this.clientId = data["clientId"];
            this.client = data["client"] ? Client.fromJS(data["client"]) : undefined;
            this.packageCount = data["packageCount"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    };
    ManifestFileRecord.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ManifestFileRecord();
        result.init(data);
        return result;
    };
    ManifestFileRecord.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["connoteNumber"] = this.connoteNumber;
        data["asJsonString"] = this.asJsonString;
        data["status"] = this.status;
        data["manifestFileId"] = this.manifestFileId;
        data["manifestFile"] = this.manifestFile ? this.manifestFile.toJSON() : undefined;
        data["consignmentStatusId"] = this.consignmentStatusId;
        data["consignmentStatus"] = this.consignmentStatus ? this.consignmentStatus.toJSON() : undefined;
        data["clientId"] = this.clientId;
        data["client"] = this.client ? this.client.toJSON() : undefined;
        data["packageCount"] = this.packageCount;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    return ManifestFileRecord;
}());
export { ManifestFileRecord };
var ManifestFile = /** @class */ (function () {
    function ManifestFile(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ManifestFile.prototype.init = function (data) {
        if (data) {
            this.fileName = data["fileName"];
            this.importedAt = data["importedAt"] ? moment(data["importedAt"].toString()) : undefined;
            this.importLog = data["importLog"];
            if (Array.isArray(data["manifestFileRecords"])) {
                this.manifestFileRecords = [];
                for (var _i = 0, _a = data["manifestFileRecords"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.manifestFileRecords.push(ManifestFileRecord.fromJS(item));
                }
            }
            if (Array.isArray(data["manifestFileClients"])) {
                this.manifestFileClients = [];
                for (var _b = 0, _c = data["manifestFileClients"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.manifestFileClients.push(ManifestFileClient.fromJS(item));
                }
            }
            this.isPickingUpdate = data["isPickingUpdate"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    };
    ManifestFile.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ManifestFile();
        result.init(data);
        return result;
    };
    ManifestFile.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["importedAt"] = this.importedAt ? this.importedAt.toISOString() : undefined;
        data["importLog"] = this.importLog;
        if (Array.isArray(this.manifestFileRecords)) {
            data["manifestFileRecords"] = [];
            for (var _i = 0, _a = this.manifestFileRecords; _i < _a.length; _i++) {
                var item = _a[_i];
                data["manifestFileRecords"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.manifestFileClients)) {
            data["manifestFileClients"] = [];
            for (var _b = 0, _c = this.manifestFileClients; _b < _c.length; _b++) {
                var item = _c[_b];
                data["manifestFileClients"].push(item.toJSON());
            }
        }
        data["isPickingUpdate"] = this.isPickingUpdate;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    return ManifestFile;
}());
export { ManifestFile };
var Load = /** @class */ (function () {
    function Load(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Load.prototype.init = function (data) {
        if (data) {
            this.weight = data["weight"];
            this.docket = data["docket"];
            this.storeId = data["storeId"];
            this.eta = data["eta"] ? moment(data["eta"].toString()) : undefined;
            this.status = data["status"];
            this.type = data["type"];
            this.carrier = data["carrier"];
            this.deliveryCarrier = data["deliveryCarrier"];
            this.manifestFileId = data["manifestFileId"];
            this.manifestFile = data["manifestFile"] ? ManifestFile.fromJS(data["manifestFile"]) : undefined;
            this.exportedDetails = data["exportedDetails"];
            this.exportedAt = data["exportedAt"] ? moment(data["exportedAt"].toString()) : undefined;
            this.isAutoExported = data["isAutoExported"];
            this.from = data["from"];
            this.to = data["to"];
            if (Array.isArray(data["loadPackages"])) {
                this.loadPackages = [];
                for (var _i = 0, _a = data["loadPackages"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.loadPackages.push(LoadPackage.fromJS(item));
                }
            }
            if (Array.isArray(data["loadClients"])) {
                this.loadClients = [];
                for (var _b = 0, _c = data["loadClients"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.loadClients.push(LoadClient.fromJS(item));
                }
            }
            this.departedTime = data["departedTime"] ? moment(data["departedTime"].toString()) : undefined;
            this.palletCount = data["palletCount"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    };
    Load.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Load();
        result.init(data);
        return result;
    };
    Load.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["weight"] = this.weight;
        data["docket"] = this.docket;
        data["storeId"] = this.storeId;
        data["eta"] = this.eta ? this.eta.toISOString() : undefined;
        data["status"] = this.status;
        data["type"] = this.type;
        data["carrier"] = this.carrier;
        data["deliveryCarrier"] = this.deliveryCarrier;
        data["manifestFileId"] = this.manifestFileId;
        data["manifestFile"] = this.manifestFile ? this.manifestFile.toJSON() : undefined;
        data["exportedDetails"] = this.exportedDetails;
        data["exportedAt"] = this.exportedAt ? this.exportedAt.toISOString() : undefined;
        data["isAutoExported"] = this.isAutoExported;
        data["from"] = this.from;
        data["to"] = this.to;
        if (Array.isArray(this.loadPackages)) {
            data["loadPackages"] = [];
            for (var _i = 0, _a = this.loadPackages; _i < _a.length; _i++) {
                var item = _a[_i];
                data["loadPackages"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.loadClients)) {
            data["loadClients"] = [];
            for (var _b = 0, _c = this.loadClients; _b < _c.length; _b++) {
                var item = _c[_b];
                data["loadClients"].push(item.toJSON());
            }
        }
        data["departedTime"] = this.departedTime ? this.departedTime.toISOString() : undefined;
        data["palletCount"] = this.palletCount;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    return Load;
}());
export { Load };
var LoadPackageProduct = /** @class */ (function () {
    function LoadPackageProduct(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    LoadPackageProduct.prototype.init = function (data) {
        if (data) {
            this.loadPackageId = data["loadPackageId"];
            this.loadPackage = data["loadPackage"] ? LoadPackage.fromJS(data["loadPackage"]) : undefined;
            this.productBarcode = data["productBarcode"];
            this.isValidBarcode = data["isValidBarcode"];
            this.quantity = data["quantity"];
            this.id = data["id"];
        }
    };
    LoadPackageProduct.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new LoadPackageProduct();
        result.init(data);
        return result;
    };
    LoadPackageProduct.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["loadPackageId"] = this.loadPackageId;
        data["loadPackage"] = this.loadPackage ? this.loadPackage.toJSON() : undefined;
        data["productBarcode"] = this.productBarcode;
        data["isValidBarcode"] = this.isValidBarcode;
        data["quantity"] = this.quantity;
        data["id"] = this.id;
        return data;
    };
    return LoadPackageProduct;
}());
export { LoadPackageProduct };
var LoadPackage = /** @class */ (function () {
    function LoadPackage(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    LoadPackage.prototype.init = function (data) {
        if (data) {
            this.loadId = data["loadId"];
            this.load = data["load"] ? Load.fromJS(data["load"]) : undefined;
            this.packageId = data["packageId"];
            this.package = data["package"] ? Package.fromJS(data["package"]) : undefined;
            if (Array.isArray(data["loadPackageProducts"])) {
                this.loadPackageProducts = [];
                for (var _i = 0, _a = data["loadPackageProducts"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.loadPackageProducts.push(LoadPackageProduct.fromJS(item));
                }
            }
            this.id = data["id"];
        }
    };
    LoadPackage.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new LoadPackage();
        result.init(data);
        return result;
    };
    LoadPackage.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["loadId"] = this.loadId;
        data["load"] = this.load ? this.load.toJSON() : undefined;
        data["packageId"] = this.packageId;
        data["package"] = this.package ? this.package.toJSON() : undefined;
        if (Array.isArray(this.loadPackageProducts)) {
            data["loadPackageProducts"] = [];
            for (var _i = 0, _a = this.loadPackageProducts; _i < _a.length; _i++) {
                var item = _a[_i];
                data["loadPackageProducts"].push(item.toJSON());
            }
        }
        data["id"] = this.id;
        return data;
    };
    return LoadPackage;
}());
export { LoadPackage };
var BarcodeScanHistoryScanTag = /** @class */ (function () {
    function BarcodeScanHistoryScanTag(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BarcodeScanHistoryScanTag.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.barcodeScanHistoryId = data["barcodeScanHistoryId"];
            this.barcodeScanHistory = data["barcodeScanHistory"] ? BarcodeScanHistory.fromJS(data["barcodeScanHistory"]) : undefined;
            this.id = data["id"];
        }
    };
    BarcodeScanHistoryScanTag.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BarcodeScanHistoryScanTag();
        result.init(data);
        return result;
    };
    BarcodeScanHistoryScanTag.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["barcodeScanHistoryId"] = this.barcodeScanHistoryId;
        data["barcodeScanHistory"] = this.barcodeScanHistory ? this.barcodeScanHistory.toJSON() : undefined;
        data["id"] = this.id;
        return data;
    };
    return BarcodeScanHistoryScanTag;
}());
export { BarcodeScanHistoryScanTag };
var BarcodeScanHistory = /** @class */ (function () {
    function BarcodeScanHistory(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BarcodeScanHistory.prototype.init = function (data) {
        if (data) {
            this.type = data["type"];
            this.barcodesNoData = data["barcodesNoData"];
            this.depotLocationId = data["depotLocationId"];
            this.depotLocation = data["depotLocation"] ? DepotLocation.fromJS(data["depotLocation"]) : undefined;
            if (Array.isArray(data["barcodeScanPackages"])) {
                this.barcodeScanPackages = [];
                for (var _i = 0, _a = data["barcodeScanPackages"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.barcodeScanPackages.push(BarcodeScanPackage.fromJS(item));
                }
            }
            this.endTime = data["endTime"] ? moment(data["endTime"].toString()) : undefined;
            if (Array.isArray(data["barcodeScanHistoryScanTags"])) {
                this.barcodeScanHistoryScanTags = [];
                for (var _b = 0, _c = data["barcodeScanHistoryScanTags"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.barcodeScanHistoryScanTags.push(BarcodeScanHistoryScanTag.fromJS(item));
                }
            }
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    };
    BarcodeScanHistory.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BarcodeScanHistory();
        result.init(data);
        return result;
    };
    BarcodeScanHistory.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["barcodesNoData"] = this.barcodesNoData;
        data["depotLocationId"] = this.depotLocationId;
        data["depotLocation"] = this.depotLocation ? this.depotLocation.toJSON() : undefined;
        if (Array.isArray(this.barcodeScanPackages)) {
            data["barcodeScanPackages"] = [];
            for (var _i = 0, _a = this.barcodeScanPackages; _i < _a.length; _i++) {
                var item = _a[_i];
                data["barcodeScanPackages"].push(item.toJSON());
            }
        }
        data["endTime"] = this.endTime ? this.endTime.toISOString() : undefined;
        if (Array.isArray(this.barcodeScanHistoryScanTags)) {
            data["barcodeScanHistoryScanTags"] = [];
            for (var _b = 0, _c = this.barcodeScanHistoryScanTags; _b < _c.length; _b++) {
                var item = _c[_b];
                data["barcodeScanHistoryScanTags"].push(item.toJSON());
            }
        }
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    return BarcodeScanHistory;
}());
export { BarcodeScanHistory };
var BarcodeScanPackageProduct = /** @class */ (function () {
    function BarcodeScanPackageProduct(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BarcodeScanPackageProduct.prototype.init = function (data) {
        if (data) {
            this.barcodeScanPackageId = data["barcodeScanPackageId"];
            this.barcodeScanPackage = data["barcodeScanPackage"] ? BarcodeScanPackage.fromJS(data["barcodeScanPackage"]) : undefined;
            this.productBarcode = data["productBarcode"];
            this.quantity = data["quantity"];
            this.id = data["id"];
        }
    };
    BarcodeScanPackageProduct.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BarcodeScanPackageProduct();
        result.init(data);
        return result;
    };
    BarcodeScanPackageProduct.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["barcodeScanPackageId"] = this.barcodeScanPackageId;
        data["barcodeScanPackage"] = this.barcodeScanPackage ? this.barcodeScanPackage.toJSON() : undefined;
        data["productBarcode"] = this.productBarcode;
        data["quantity"] = this.quantity;
        data["id"] = this.id;
        return data;
    };
    return BarcodeScanPackageProduct;
}());
export { BarcodeScanPackageProduct };
var BarcodeScanPackage = /** @class */ (function () {
    function BarcodeScanPackage(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BarcodeScanPackage.prototype.init = function (data) {
        if (data) {
            this.barcodeScanHistoryId = data["barcodeScanHistoryId"];
            this.barcodeScanHistory = data["barcodeScanHistory"] ? BarcodeScanHistory.fromJS(data["barcodeScanHistory"]) : undefined;
            this.packageId = data["packageId"];
            this.package = data["package"] ? Package.fromJS(data["package"]) : undefined;
            if (Array.isArray(data["barcodeScanPackageProducts"])) {
                this.barcodeScanPackageProducts = [];
                for (var _i = 0, _a = data["barcodeScanPackageProducts"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.barcodeScanPackageProducts.push(BarcodeScanPackageProduct.fromJS(item));
                }
            }
            this.isValid = data["isValid"];
            this.order = data["order"];
            this.id = data["id"];
        }
    };
    BarcodeScanPackage.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BarcodeScanPackage();
        result.init(data);
        return result;
    };
    BarcodeScanPackage.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["barcodeScanHistoryId"] = this.barcodeScanHistoryId;
        data["barcodeScanHistory"] = this.barcodeScanHistory ? this.barcodeScanHistory.toJSON() : undefined;
        data["packageId"] = this.packageId;
        data["package"] = this.package ? this.package.toJSON() : undefined;
        if (Array.isArray(this.barcodeScanPackageProducts)) {
            data["barcodeScanPackageProducts"] = [];
            for (var _i = 0, _a = this.barcodeScanPackageProducts; _i < _a.length; _i++) {
                var item = _a[_i];
                data["barcodeScanPackageProducts"].push(item.toJSON());
            }
        }
        data["isValid"] = this.isValid;
        data["order"] = this.order;
        data["id"] = this.id;
        return data;
    };
    return BarcodeScanPackage;
}());
export { BarcodeScanPackage };
var CrossBorder = /** @class */ (function () {
    function CrossBorder(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CrossBorder.prototype.init = function (data) {
        if (data) {
            this.location = data["location"];
            this.destination = data["destination"];
            this.palletisedDate = data["palletisedDate"] ? moment(data["palletisedDate"].toString()) : undefined;
            if (Array.isArray(data["crossBorderPackages"])) {
                this.crossBorderPackages = [];
                for (var _i = 0, _a = data["crossBorderPackages"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.crossBorderPackages.push(CrossBorderPackage.fromJS(item));
                }
            }
            this.id = data["id"];
        }
    };
    CrossBorder.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CrossBorder();
        result.init(data);
        return result;
    };
    CrossBorder.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["location"] = this.location;
        data["destination"] = this.destination;
        data["palletisedDate"] = this.palletisedDate ? this.palletisedDate.toISOString() : undefined;
        if (Array.isArray(this.crossBorderPackages)) {
            data["crossBorderPackages"] = [];
            for (var _i = 0, _a = this.crossBorderPackages; _i < _a.length; _i++) {
                var item = _a[_i];
                data["crossBorderPackages"].push(item.toJSON());
            }
        }
        data["id"] = this.id;
        return data;
    };
    return CrossBorder;
}());
export { CrossBorder };
var CrossBorderPackage = /** @class */ (function () {
    function CrossBorderPackage(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CrossBorderPackage.prototype.init = function (data) {
        if (data) {
            this.crossBorderId = data["crossBorderId"];
            this.crossBorder = data["crossBorder"] ? CrossBorder.fromJS(data["crossBorder"]) : undefined;
            this.packageId = data["packageId"];
            this.package = data["package"] ? Package.fromJS(data["package"]) : undefined;
            this.id = data["id"];
        }
    };
    CrossBorderPackage.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CrossBorderPackage();
        result.init(data);
        return result;
    };
    CrossBorderPackage.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["crossBorderId"] = this.crossBorderId;
        data["crossBorder"] = this.crossBorder ? this.crossBorder.toJSON() : undefined;
        data["packageId"] = this.packageId;
        data["package"] = this.package ? this.package.toJSON() : undefined;
        data["id"] = this.id;
        return data;
    };
    return CrossBorderPackage;
}());
export { CrossBorderPackage };
var ReturnToSupplier = /** @class */ (function () {
    function ReturnToSupplier(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ReturnToSupplier.prototype.init = function (data) {
        if (data) {
            this.receivingLocation = data["receivingLocation"];
            this.palletisedDate = data["palletisedDate"] ? moment(data["palletisedDate"].toString()) : undefined;
            this.clientCode = data["clientCode"];
            this.clientGroupId = data["clientGroupId"];
            if (Array.isArray(data["returnToSupplierPackages"])) {
                this.returnToSupplierPackages = [];
                for (var _i = 0, _a = data["returnToSupplierPackages"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.returnToSupplierPackages.push(ReturnToSupplierPackage.fromJS(item));
                }
            }
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    };
    ReturnToSupplier.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ReturnToSupplier();
        result.init(data);
        return result;
    };
    ReturnToSupplier.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["receivingLocation"] = this.receivingLocation;
        data["palletisedDate"] = this.palletisedDate ? this.palletisedDate.toISOString() : undefined;
        data["clientCode"] = this.clientCode;
        data["clientGroupId"] = this.clientGroupId;
        if (Array.isArray(this.returnToSupplierPackages)) {
            data["returnToSupplierPackages"] = [];
            for (var _i = 0, _a = this.returnToSupplierPackages; _i < _a.length; _i++) {
                var item = _a[_i];
                data["returnToSupplierPackages"].push(item.toJSON());
            }
        }
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    return ReturnToSupplier;
}());
export { ReturnToSupplier };
var ReturnToSupplierPackageProduct = /** @class */ (function () {
    function ReturnToSupplierPackageProduct(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ReturnToSupplierPackageProduct.prototype.init = function (data) {
        if (data) {
            this.returnToSupplierPackageId = data["returnToSupplierPackageId"];
            this.returnToSupplierPackage = data["returnToSupplierPackage"] ? ReturnToSupplierPackage.fromJS(data["returnToSupplierPackage"]) : undefined;
            this.productBarcode = data["productBarcode"];
            this.quantity = data["quantity"];
            this.id = data["id"];
        }
    };
    ReturnToSupplierPackageProduct.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ReturnToSupplierPackageProduct();
        result.init(data);
        return result;
    };
    ReturnToSupplierPackageProduct.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["returnToSupplierPackageId"] = this.returnToSupplierPackageId;
        data["returnToSupplierPackage"] = this.returnToSupplierPackage ? this.returnToSupplierPackage.toJSON() : undefined;
        data["productBarcode"] = this.productBarcode;
        data["quantity"] = this.quantity;
        data["id"] = this.id;
        return data;
    };
    return ReturnToSupplierPackageProduct;
}());
export { ReturnToSupplierPackageProduct };
var ReturnToSupplierPackage = /** @class */ (function () {
    function ReturnToSupplierPackage(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ReturnToSupplierPackage.prototype.init = function (data) {
        if (data) {
            this.returnToSupplierId = data["returnToSupplierId"];
            this.returnToSupplier = data["returnToSupplier"] ? ReturnToSupplier.fromJS(data["returnToSupplier"]) : undefined;
            this.packageId = data["packageId"];
            this.package = data["package"] ? Package.fromJS(data["package"]) : undefined;
            if (Array.isArray(data["returnToSupplierPackageProducts"])) {
                this.returnToSupplierPackageProducts = [];
                for (var _i = 0, _a = data["returnToSupplierPackageProducts"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.returnToSupplierPackageProducts.push(ReturnToSupplierPackageProduct.fromJS(item));
                }
            }
            this.id = data["id"];
        }
    };
    ReturnToSupplierPackage.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ReturnToSupplierPackage();
        result.init(data);
        return result;
    };
    ReturnToSupplierPackage.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["returnToSupplierId"] = this.returnToSupplierId;
        data["returnToSupplier"] = this.returnToSupplier ? this.returnToSupplier.toJSON() : undefined;
        data["packageId"] = this.packageId;
        data["package"] = this.package ? this.package.toJSON() : undefined;
        if (Array.isArray(this.returnToSupplierPackageProducts)) {
            data["returnToSupplierPackageProducts"] = [];
            for (var _i = 0, _a = this.returnToSupplierPackageProducts; _i < _a.length; _i++) {
                var item = _a[_i];
                data["returnToSupplierPackageProducts"].push(item.toJSON());
            }
        }
        data["id"] = this.id;
        return data;
    };
    return ReturnToSupplierPackage;
}());
export { ReturnToSupplierPackage };
var Package = /** @class */ (function () {
    function Package(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Package.prototype.init = function (data) {
        if (data) {
            this.barcode = data["barcode"];
            this.description = data["description"];
            this.status = data["status"];
            this.consignmentId = data["consignmentId"];
            this.consignment = data["consignment"] ? Consignment.fromJS(data["consignment"]) : undefined;
            if (Array.isArray(data["packageEvents"])) {
                this.packageEvents = [];
                for (var _i = 0, _a = data["packageEvents"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.packageEvents.push(PackageEvent.fromJS(item));
                }
            }
            this.weight = data["weight"];
            this.received = data["received"] ? moment(data["received"].toString()) : undefined;
            this.exceptionedAt = data["exceptionedAt"] ? moment(data["exceptionedAt"].toString()) : undefined;
            this.labelNo = data["labelNo"];
            this.chargeSequenceNumber = data["chargeSequenceNumber"];
            this.costSequenceNumber = data["costSequenceNumber"];
            this.d365GroupId = data["d365GroupId"];
            this.enrichedChargeFor365At = data["enrichedChargeFor365At"] ? moment(data["enrichedChargeFor365At"].toString()) : undefined;
            this.enrichedCostFor365At = data["enrichedCostFor365At"] ? moment(data["enrichedCostFor365At"].toString()) : undefined;
            this.items = data["items"];
            this.vabChargeTransactionKey = data["vabChargeTransactionKey"];
            this.vabCostTransactionKey = data["vabCostTransactionKey"];
            this.payDriver = data["payDriver"];
            this.chargeClient = data["chargeClient"];
            if (Array.isArray(data["loadPackages"])) {
                this.loadPackages = [];
                for (var _b = 0, _c = data["loadPackages"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.loadPackages.push(LoadPackage.fromJS(item));
                }
            }
            if (Array.isArray(data["palletPackages"])) {
                this.palletPackages = [];
                for (var _d = 0, _e = data["palletPackages"]; _d < _e.length; _d++) {
                    var item = _e[_d];
                    this.palletPackages.push(PalletPackage.fromJS(item));
                }
            }
            if (Array.isArray(data["barcodeScanPackages"])) {
                this.barcodeScanPackages = [];
                for (var _f = 0, _g = data["barcodeScanPackages"]; _f < _g.length; _f++) {
                    var item = _g[_f];
                    this.barcodeScanPackages.push(BarcodeScanPackage.fromJS(item));
                }
            }
            if (Array.isArray(data["crossBorderPackages"])) {
                this.crossBorderPackages = [];
                for (var _h = 0, _j = data["crossBorderPackages"]; _h < _j.length; _h++) {
                    var item = _j[_h];
                    this.crossBorderPackages.push(CrossBorderPackage.fromJS(item));
                }
            }
            if (Array.isArray(data["returnToSupplierPackages"])) {
                this.returnToSupplierPackages = [];
                for (var _k = 0, _l = data["returnToSupplierPackages"]; _k < _l.length; _k++) {
                    var item = _l[_k];
                    this.returnToSupplierPackages.push(ReturnToSupplierPackage.fromJS(item));
                }
            }
            this.carrierItemId = data["carrierItemId"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    };
    Package.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Package();
        result.init(data);
        return result;
    };
    Package.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["barcode"] = this.barcode;
        data["description"] = this.description;
        data["status"] = this.status;
        data["consignmentId"] = this.consignmentId;
        data["consignment"] = this.consignment ? this.consignment.toJSON() : undefined;
        if (Array.isArray(this.packageEvents)) {
            data["packageEvents"] = [];
            for (var _i = 0, _a = this.packageEvents; _i < _a.length; _i++) {
                var item = _a[_i];
                data["packageEvents"].push(item.toJSON());
            }
        }
        data["weight"] = this.weight;
        data["received"] = this.received ? this.received.toISOString() : undefined;
        data["exceptionedAt"] = this.exceptionedAt ? this.exceptionedAt.toISOString() : undefined;
        data["labelNo"] = this.labelNo;
        data["chargeSequenceNumber"] = this.chargeSequenceNumber;
        data["costSequenceNumber"] = this.costSequenceNumber;
        data["d365GroupId"] = this.d365GroupId;
        data["enrichedChargeFor365At"] = this.enrichedChargeFor365At ? this.enrichedChargeFor365At.toISOString() : undefined;
        data["enrichedCostFor365At"] = this.enrichedCostFor365At ? this.enrichedCostFor365At.toISOString() : undefined;
        data["items"] = this.items;
        data["vabChargeTransactionKey"] = this.vabChargeTransactionKey;
        data["vabCostTransactionKey"] = this.vabCostTransactionKey;
        data["payDriver"] = this.payDriver;
        data["chargeClient"] = this.chargeClient;
        if (Array.isArray(this.loadPackages)) {
            data["loadPackages"] = [];
            for (var _b = 0, _c = this.loadPackages; _b < _c.length; _b++) {
                var item = _c[_b];
                data["loadPackages"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.palletPackages)) {
            data["palletPackages"] = [];
            for (var _d = 0, _e = this.palletPackages; _d < _e.length; _d++) {
                var item = _e[_d];
                data["palletPackages"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.barcodeScanPackages)) {
            data["barcodeScanPackages"] = [];
            for (var _f = 0, _g = this.barcodeScanPackages; _f < _g.length; _f++) {
                var item = _g[_f];
                data["barcodeScanPackages"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.crossBorderPackages)) {
            data["crossBorderPackages"] = [];
            for (var _h = 0, _j = this.crossBorderPackages; _h < _j.length; _h++) {
                var item = _j[_h];
                data["crossBorderPackages"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.returnToSupplierPackages)) {
            data["returnToSupplierPackages"] = [];
            for (var _k = 0, _l = this.returnToSupplierPackages; _k < _l.length; _k++) {
                var item = _l[_k];
                data["returnToSupplierPackages"].push(item.toJSON());
            }
        }
        data["carrierItemId"] = this.carrierItemId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    return Package;
}());
export { Package };
var PrintLabelsByPackageIdsInput = /** @class */ (function () {
    function PrintLabelsByPackageIdsInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PrintLabelsByPackageIdsInput.prototype.init = function (data) {
        if (data) {
            if (Array.isArray(data["packageIds"])) {
                this.packageIds = [];
                for (var _i = 0, _a = data["packageIds"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.packageIds.push(item);
                }
            }
            this.labelType = data["labelType"];
        }
    };
    PrintLabelsByPackageIdsInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PrintLabelsByPackageIdsInput();
        result.init(data);
        return result;
    };
    PrintLabelsByPackageIdsInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.packageIds)) {
            data["packageIds"] = [];
            for (var _i = 0, _a = this.packageIds; _i < _a.length; _i++) {
                var item = _a[_i];
                data["packageIds"].push(item);
            }
        }
        data["labelType"] = this.labelType;
        return data;
    };
    return PrintLabelsByPackageIdsInput;
}());
export { PrintLabelsByPackageIdsInput };
export var PrinterType;
(function (PrinterType) {
    PrinterType[PrinterType["Unknown"] = 0] = "Unknown";
    PrinterType[PrinterType["Sato"] = 1] = "Sato";
    PrinterType[PrinterType["Zebra"] = 2] = "Zebra";
})(PrinterType || (PrinterType = {}));
var PrintersDto = /** @class */ (function () {
    function PrintersDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PrintersDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.ip = data["ip"];
            this.printerType = data["printerType"];
            this.depotLocationId = data["depotLocationId"];
            this.id = data["id"];
        }
    };
    PrintersDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PrintersDto();
        result.init(data);
        return result;
    };
    PrintersDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["ip"] = this.ip;
        data["printerType"] = this.printerType;
        data["depotLocationId"] = this.depotLocationId;
        data["id"] = this.id;
        return data;
    };
    return PrintersDto;
}());
export { PrintersDto };
var GetPrintersForViewDto = /** @class */ (function () {
    function GetPrintersForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetPrintersForViewDto.prototype.init = function (data) {
        if (data) {
            this.printer = data["printer"] ? PrintersDto.fromJS(data["printer"]) : undefined;
        }
    };
    GetPrintersForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetPrintersForViewDto();
        result.init(data);
        return result;
    };
    GetPrintersForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["printer"] = this.printer ? this.printer.toJSON() : undefined;
        return data;
    };
    return GetPrintersForViewDto;
}());
export { GetPrintersForViewDto };
var PrintLabelsByConsignmentIdsInput = /** @class */ (function () {
    function PrintLabelsByConsignmentIdsInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PrintLabelsByConsignmentIdsInput.prototype.init = function (data) {
        if (data) {
            if (Array.isArray(data["consignmentIds"])) {
                this.consignmentIds = [];
                for (var _i = 0, _a = data["consignmentIds"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.consignmentIds.push(item);
                }
            }
            this.labelType = data["labelType"];
        }
    };
    PrintLabelsByConsignmentIdsInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PrintLabelsByConsignmentIdsInput();
        result.init(data);
        return result;
    };
    PrintLabelsByConsignmentIdsInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.consignmentIds)) {
            data["consignmentIds"] = [];
            for (var _i = 0, _a = this.consignmentIds; _i < _a.length; _i++) {
                var item = _a[_i];
                data["consignmentIds"].push(item);
            }
        }
        data["labelType"] = this.labelType;
        return data;
    };
    return PrintLabelsByConsignmentIdsInput;
}());
export { PrintLabelsByConsignmentIdsInput };
var PrintLabelsInput = /** @class */ (function () {
    function PrintLabelsInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PrintLabelsInput.prototype.init = function (data) {
        if (data) {
            this.searchInput = data["searchInput"] ? GetAllConsignmentsInput.fromJS(data["searchInput"]) : undefined;
            this.labelType = data["labelType"];
        }
    };
    PrintLabelsInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PrintLabelsInput();
        result.init(data);
        return result;
    };
    PrintLabelsInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["searchInput"] = this.searchInput ? this.searchInput.toJSON() : undefined;
        data["labelType"] = this.labelType;
        return data;
    };
    return PrintLabelsInput;
}());
export { PrintLabelsInput };
var EditConsignmentDropcodeInstructionsDto = /** @class */ (function () {
    function EditConsignmentDropcodeInstructionsDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EditConsignmentDropcodeInstructionsDto.prototype.init = function (data) {
        if (data) {
            this.dropCode = data["dropCode"];
            this.deliveryInstructions = data["deliveryInstructions"];
            this.id = data["id"];
        }
    };
    EditConsignmentDropcodeInstructionsDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new EditConsignmentDropcodeInstructionsDto();
        result.init(data);
        return result;
    };
    EditConsignmentDropcodeInstructionsDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["dropCode"] = this.dropCode;
        data["deliveryInstructions"] = this.deliveryInstructions;
        data["id"] = this.id;
        return data;
    };
    return EditConsignmentDropcodeInstructionsDto;
}());
export { EditConsignmentDropcodeInstructionsDto };
var GetConsignmentDropcodeInstructionsForEditOutput = /** @class */ (function () {
    function GetConsignmentDropcodeInstructionsForEditOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetConsignmentDropcodeInstructionsForEditOutput.prototype.init = function (data) {
        if (data) {
            this.consignmentInstructions = data["consignmentInstructions"] ? EditConsignmentDropcodeInstructionsDto.fromJS(data["consignmentInstructions"]) : undefined;
        }
    };
    GetConsignmentDropcodeInstructionsForEditOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetConsignmentDropcodeInstructionsForEditOutput();
        result.init(data);
        return result;
    };
    GetConsignmentDropcodeInstructionsForEditOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["consignmentInstructions"] = this.consignmentInstructions ? this.consignmentInstructions.toJSON() : undefined;
        return data;
    };
    return GetConsignmentDropcodeInstructionsForEditOutput;
}());
export { GetConsignmentDropcodeInstructionsForEditOutput };
export var OnDemandDeliveryType;
(function (OnDemandDeliveryType) {
    OnDemandDeliveryType[OnDemandDeliveryType["Unknown"] = 0] = "Unknown";
    OnDemandDeliveryType[OnDemandDeliveryType["Asap"] = 1] = "Asap";
    OnDemandDeliveryType[OnDemandDeliveryType["Scheduled"] = 2] = "Scheduled";
})(OnDemandDeliveryType || (OnDemandDeliveryType = {}));
var RescheduleConsignmentDto = /** @class */ (function () {
    function RescheduleConsignmentDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RescheduleConsignmentDto.prototype.init = function (data) {
        if (data) {
            this.shipDate = data["shipDate"] ? moment(data["shipDate"].toString()) : undefined;
            this.resolveZendeskTicket = data["resolveZendeskTicket"];
            this.comment = data["comment"];
            this.locationId = data["locationId"];
            this.priority = data["priority"];
            this.oddType = data["oddType"];
            this.id = data["id"];
        }
    };
    RescheduleConsignmentDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RescheduleConsignmentDto();
        result.init(data);
        return result;
    };
    RescheduleConsignmentDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["shipDate"] = this.shipDate ? this.shipDate.toISOString() : undefined;
        data["resolveZendeskTicket"] = this.resolveZendeskTicket;
        data["comment"] = this.comment;
        data["locationId"] = this.locationId;
        data["priority"] = this.priority;
        data["oddType"] = this.oddType;
        data["id"] = this.id;
        return data;
    };
    return RescheduleConsignmentDto;
}());
export { RescheduleConsignmentDto };
var SLAStatusOutput = /** @class */ (function () {
    function SLAStatusOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SLAStatusOutput.prototype.init = function (data) {
        if (data) {
            this.atRisk = data["atRisk"];
            this.breached = data["breached"];
            this.total = data["total"];
        }
    };
    SLAStatusOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SLAStatusOutput();
        result.init(data);
        return result;
    };
    SLAStatusOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["atRisk"] = this.atRisk;
        data["breached"] = this.breached;
        data["total"] = this.total;
        return data;
    };
    return SLAStatusOutput;
}());
export { SLAStatusOutput };
var ConsignmentsSummaryDataEdByState = /** @class */ (function () {
    function ConsignmentsSummaryDataEdByState(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ConsignmentsSummaryDataEdByState.prototype.init = function (data) {
        if (data) {
            this.state = data["state"];
            this.notReceivedInDepot = data["notReceivedInDepot"] ? SLAStatusOutput.fromJS(data["notReceivedInDepot"]) : undefined;
            this.receivedInDepot = data["receivedInDepot"] ? SLAStatusOutput.fromJS(data["receivedInDepot"]) : undefined;
            this.withDriver = data["withDriver"] ? SLAStatusOutput.fromJS(data["withDriver"]) : undefined;
            this.problemStatus = data["problemStatus"];
            this.oneDeliveryAttempt = data["oneDeliveryAttempt"];
            this.multipleDeliveryAttempt = data["multipleDeliveryAttempt"];
            this.deliveredWithinSLA = data["deliveredWithinSLA"];
            this.deliveredOutsideSLA = data["deliveredOutsideSLA"];
            this.actioned = data["actioned"];
        }
    };
    ConsignmentsSummaryDataEdByState.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ConsignmentsSummaryDataEdByState();
        result.init(data);
        return result;
    };
    ConsignmentsSummaryDataEdByState.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["notReceivedInDepot"] = this.notReceivedInDepot ? this.notReceivedInDepot.toJSON() : undefined;
        data["receivedInDepot"] = this.receivedInDepot ? this.receivedInDepot.toJSON() : undefined;
        data["withDriver"] = this.withDriver ? this.withDriver.toJSON() : undefined;
        data["problemStatus"] = this.problemStatus;
        data["oneDeliveryAttempt"] = this.oneDeliveryAttempt;
        data["multipleDeliveryAttempt"] = this.multipleDeliveryAttempt;
        data["deliveredWithinSLA"] = this.deliveredWithinSLA;
        data["deliveredOutsideSLA"] = this.deliveredOutsideSLA;
        data["actioned"] = this.actioned;
        return data;
    };
    return ConsignmentsSummaryDataEdByState;
}());
export { ConsignmentsSummaryDataEdByState };
var ConsignmentsSummaryDashboardEdByStateOutput = /** @class */ (function () {
    function ConsignmentsSummaryDashboardEdByStateOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ConsignmentsSummaryDashboardEdByStateOutput.prototype.init = function (data) {
        if (data) {
            this.mainTitle = data["mainTitle"];
            if (Array.isArray(data["consignmentsSummaryDataEdByStates"])) {
                this.consignmentsSummaryDataEdByStates = [];
                for (var _i = 0, _a = data["consignmentsSummaryDataEdByStates"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.consignmentsSummaryDataEdByStates.push(ConsignmentsSummaryDataEdByState.fromJS(item));
                }
            }
        }
    };
    ConsignmentsSummaryDashboardEdByStateOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ConsignmentsSummaryDashboardEdByStateOutput();
        result.init(data);
        return result;
    };
    ConsignmentsSummaryDashboardEdByStateOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["mainTitle"] = this.mainTitle;
        if (Array.isArray(this.consignmentsSummaryDataEdByStates)) {
            data["consignmentsSummaryDataEdByStates"] = [];
            for (var _i = 0, _a = this.consignmentsSummaryDataEdByStates; _i < _a.length; _i++) {
                var item = _a[_i];
                data["consignmentsSummaryDataEdByStates"].push(item.toJSON());
            }
        }
        return data;
    };
    return ConsignmentsSummaryDashboardEdByStateOutput;
}());
export { ConsignmentsSummaryDashboardEdByStateOutput };
var ConsignmentsSummaryDataAllCarriers = /** @class */ (function () {
    function ConsignmentsSummaryDataAllCarriers(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ConsignmentsSummaryDataAllCarriers.prototype.init = function (data) {
        if (data) {
            this.courierName = data["courierName"];
            this.courierCode = data["courierCode"];
            this.notReceivedInDepot = data["notReceivedInDepot"] ? SLAStatusOutput.fromJS(data["notReceivedInDepot"]) : undefined;
            this.receivedInDepot = data["receivedInDepot"] ? SLAStatusOutput.fromJS(data["receivedInDepot"]) : undefined;
            this.withDriver = data["withDriver"] ? SLAStatusOutput.fromJS(data["withDriver"]) : undefined;
            this.problemStatus = data["problemStatus"];
            this.deliveredWithinSLA = data["deliveredWithinSLA"];
            this.deliveredOutsideSLA = data["deliveredOutsideSLA"];
            this.actioned = data["actioned"];
        }
    };
    ConsignmentsSummaryDataAllCarriers.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ConsignmentsSummaryDataAllCarriers();
        result.init(data);
        return result;
    };
    ConsignmentsSummaryDataAllCarriers.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["courierName"] = this.courierName;
        data["courierCode"] = this.courierCode;
        data["notReceivedInDepot"] = this.notReceivedInDepot ? this.notReceivedInDepot.toJSON() : undefined;
        data["receivedInDepot"] = this.receivedInDepot ? this.receivedInDepot.toJSON() : undefined;
        data["withDriver"] = this.withDriver ? this.withDriver.toJSON() : undefined;
        data["problemStatus"] = this.problemStatus;
        data["deliveredWithinSLA"] = this.deliveredWithinSLA;
        data["deliveredOutsideSLA"] = this.deliveredOutsideSLA;
        data["actioned"] = this.actioned;
        return data;
    };
    return ConsignmentsSummaryDataAllCarriers;
}());
export { ConsignmentsSummaryDataAllCarriers };
var ConsignmentsSummaryDashboardAllCarriersOutput = /** @class */ (function () {
    function ConsignmentsSummaryDashboardAllCarriersOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ConsignmentsSummaryDashboardAllCarriersOutput.prototype.init = function (data) {
        if (data) {
            this.mainTitle = data["mainTitle"];
            if (Array.isArray(data["consignmentsSummaryDataAllCarriers"])) {
                this.consignmentsSummaryDataAllCarriers = [];
                for (var _i = 0, _a = data["consignmentsSummaryDataAllCarriers"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.consignmentsSummaryDataAllCarriers.push(ConsignmentsSummaryDataAllCarriers.fromJS(item));
                }
            }
        }
    };
    ConsignmentsSummaryDashboardAllCarriersOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ConsignmentsSummaryDashboardAllCarriersOutput();
        result.init(data);
        return result;
    };
    ConsignmentsSummaryDashboardAllCarriersOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["mainTitle"] = this.mainTitle;
        if (Array.isArray(this.consignmentsSummaryDataAllCarriers)) {
            data["consignmentsSummaryDataAllCarriers"] = [];
            for (var _i = 0, _a = this.consignmentsSummaryDataAllCarriers; _i < _a.length; _i++) {
                var item = _a[_i];
                data["consignmentsSummaryDataAllCarriers"].push(item.toJSON());
            }
        }
        return data;
    };
    return ConsignmentsSummaryDashboardAllCarriersOutput;
}());
export { ConsignmentsSummaryDashboardAllCarriersOutput };
var CostRegionLocationDto = /** @class */ (function () {
    function CostRegionLocationDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CostRegionLocationDto.prototype.init = function (data) {
        if (data) {
            this.costRegionId = data["costRegionId"];
            this.locationSettingId = data["locationSettingId"];
            this.id = data["id"];
        }
    };
    CostRegionLocationDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CostRegionLocationDto();
        result.init(data);
        return result;
    };
    CostRegionLocationDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["costRegionId"] = this.costRegionId;
        data["locationSettingId"] = this.locationSettingId;
        data["id"] = this.id;
        return data;
    };
    return CostRegionLocationDto;
}());
export { CostRegionLocationDto };
var GetCostRegionLocationForViewDto = /** @class */ (function () {
    function GetCostRegionLocationForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetCostRegionLocationForViewDto.prototype.init = function (data) {
        if (data) {
            this.costRegionLocation = data["costRegionLocation"] ? CostRegionLocationDto.fromJS(data["costRegionLocation"]) : undefined;
            this.regionName = data["regionName"];
            this.locationSuburb = data["locationSuburb"];
            this.locationPostcode = data["locationPostcode"];
            this.regionCourierName = data["regionCourierName"];
        }
    };
    GetCostRegionLocationForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetCostRegionLocationForViewDto();
        result.init(data);
        return result;
    };
    GetCostRegionLocationForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["costRegionLocation"] = this.costRegionLocation ? this.costRegionLocation.toJSON() : undefined;
        data["regionName"] = this.regionName;
        data["locationSuburb"] = this.locationSuburb;
        data["locationPostcode"] = this.locationPostcode;
        data["regionCourierName"] = this.regionCourierName;
        return data;
    };
    return GetCostRegionLocationForViewDto;
}());
export { GetCostRegionLocationForViewDto };
var PagedResultDtoOfGetCostRegionLocationForViewDto = /** @class */ (function () {
    function PagedResultDtoOfGetCostRegionLocationForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfGetCostRegionLocationForViewDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(GetCostRegionLocationForViewDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfGetCostRegionLocationForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfGetCostRegionLocationForViewDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfGetCostRegionLocationForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfGetCostRegionLocationForViewDto;
}());
export { PagedResultDtoOfGetCostRegionLocationForViewDto };
var CreateOrEditCostRegionLocationDto = /** @class */ (function () {
    function CreateOrEditCostRegionLocationDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateOrEditCostRegionLocationDto.prototype.init = function (data) {
        if (data) {
            this.costRegionId = data["costRegionId"];
            this.locationSettingId = data["locationSettingId"];
            this.id = data["id"];
        }
    };
    CreateOrEditCostRegionLocationDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrEditCostRegionLocationDto();
        result.init(data);
        return result;
    };
    CreateOrEditCostRegionLocationDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["costRegionId"] = this.costRegionId;
        data["locationSettingId"] = this.locationSettingId;
        data["id"] = this.id;
        return data;
    };
    return CreateOrEditCostRegionLocationDto;
}());
export { CreateOrEditCostRegionLocationDto };
var GetCostRegionLocationForEditOutput = /** @class */ (function () {
    function GetCostRegionLocationForEditOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetCostRegionLocationForEditOutput.prototype.init = function (data) {
        if (data) {
            this.costRegionLocation = data["costRegionLocation"] ? CreateOrEditCostRegionLocationDto.fromJS(data["costRegionLocation"]) : undefined;
            this.regionName = data["regionName"];
            this.locationSuburb = data["locationSuburb"];
            this.locationPostcode = data["locationPostcode"];
            this.regionCourierName = data["regionCourierName"];
        }
    };
    GetCostRegionLocationForEditOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetCostRegionLocationForEditOutput();
        result.init(data);
        return result;
    };
    GetCostRegionLocationForEditOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["costRegionLocation"] = this.costRegionLocation ? this.costRegionLocation.toJSON() : undefined;
        data["regionName"] = this.regionName;
        data["locationSuburb"] = this.locationSuburb;
        data["locationPostcode"] = this.locationPostcode;
        data["regionCourierName"] = this.regionCourierName;
        return data;
    };
    return GetCostRegionLocationForEditOutput;
}());
export { GetCostRegionLocationForEditOutput };
var CostRegionLocationCostRegionLookupTableDto = /** @class */ (function () {
    function CostRegionLocationCostRegionLookupTableDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CostRegionLocationCostRegionLookupTableDto.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    };
    CostRegionLocationCostRegionLookupTableDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CostRegionLocationCostRegionLookupTableDto();
        result.init(data);
        return result;
    };
    CostRegionLocationCostRegionLookupTableDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    };
    return CostRegionLocationCostRegionLookupTableDto;
}());
export { CostRegionLocationCostRegionLookupTableDto };
var PagedResultDtoOfCostRegionLocationCostRegionLookupTableDto = /** @class */ (function () {
    function PagedResultDtoOfCostRegionLocationCostRegionLookupTableDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfCostRegionLocationCostRegionLookupTableDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(CostRegionLocationCostRegionLookupTableDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfCostRegionLocationCostRegionLookupTableDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfCostRegionLocationCostRegionLookupTableDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfCostRegionLocationCostRegionLookupTableDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfCostRegionLocationCostRegionLookupTableDto;
}());
export { PagedResultDtoOfCostRegionLocationCostRegionLookupTableDto };
var CostRegionLocationLocationSettingLookupTableDto = /** @class */ (function () {
    function CostRegionLocationLocationSettingLookupTableDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CostRegionLocationLocationSettingLookupTableDto.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    };
    CostRegionLocationLocationSettingLookupTableDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CostRegionLocationLocationSettingLookupTableDto();
        result.init(data);
        return result;
    };
    CostRegionLocationLocationSettingLookupTableDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    };
    return CostRegionLocationLocationSettingLookupTableDto;
}());
export { CostRegionLocationLocationSettingLookupTableDto };
var PagedResultDtoOfCostRegionLocationLocationSettingLookupTableDto = /** @class */ (function () {
    function PagedResultDtoOfCostRegionLocationLocationSettingLookupTableDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfCostRegionLocationLocationSettingLookupTableDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(CostRegionLocationLocationSettingLookupTableDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfCostRegionLocationLocationSettingLookupTableDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfCostRegionLocationLocationSettingLookupTableDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfCostRegionLocationLocationSettingLookupTableDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfCostRegionLocationLocationSettingLookupTableDto;
}());
export { PagedResultDtoOfCostRegionLocationLocationSettingLookupTableDto };
var CostRegionDto = /** @class */ (function () {
    function CostRegionDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CostRegionDto.prototype.init = function (data) {
        if (data) {
            this.region = data["region"];
            this.courierId = data["courierId"];
            this.id = data["id"];
        }
    };
    CostRegionDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CostRegionDto();
        result.init(data);
        return result;
    };
    CostRegionDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["region"] = this.region;
        data["courierId"] = this.courierId;
        data["id"] = this.id;
        return data;
    };
    return CostRegionDto;
}());
export { CostRegionDto };
var GetCostRegionForViewDto = /** @class */ (function () {
    function GetCostRegionForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetCostRegionForViewDto.prototype.init = function (data) {
        if (data) {
            this.costRegion = data["costRegion"] ? CostRegionDto.fromJS(data["costRegion"]) : undefined;
            this.courierName = data["courierName"];
        }
    };
    GetCostRegionForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetCostRegionForViewDto();
        result.init(data);
        return result;
    };
    GetCostRegionForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["costRegion"] = this.costRegion ? this.costRegion.toJSON() : undefined;
        data["courierName"] = this.courierName;
        return data;
    };
    return GetCostRegionForViewDto;
}());
export { GetCostRegionForViewDto };
var PagedResultDtoOfGetCostRegionForViewDto = /** @class */ (function () {
    function PagedResultDtoOfGetCostRegionForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfGetCostRegionForViewDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(GetCostRegionForViewDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfGetCostRegionForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfGetCostRegionForViewDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfGetCostRegionForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfGetCostRegionForViewDto;
}());
export { PagedResultDtoOfGetCostRegionForViewDto };
var CreateOrEditCostRegionDto = /** @class */ (function () {
    function CreateOrEditCostRegionDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateOrEditCostRegionDto.prototype.init = function (data) {
        if (data) {
            this.region = data["region"];
            this.courierId = data["courierId"];
            this.id = data["id"];
        }
    };
    CreateOrEditCostRegionDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrEditCostRegionDto();
        result.init(data);
        return result;
    };
    CreateOrEditCostRegionDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["region"] = this.region;
        data["courierId"] = this.courierId;
        data["id"] = this.id;
        return data;
    };
    return CreateOrEditCostRegionDto;
}());
export { CreateOrEditCostRegionDto };
var GetCostRegionForEditOutput = /** @class */ (function () {
    function GetCostRegionForEditOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetCostRegionForEditOutput.prototype.init = function (data) {
        if (data) {
            this.costRegion = data["costRegion"] ? CreateOrEditCostRegionDto.fromJS(data["costRegion"]) : undefined;
            this.courierName = data["courierName"];
            this.courierCode = data["courierCode"];
        }
    };
    GetCostRegionForEditOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetCostRegionForEditOutput();
        result.init(data);
        return result;
    };
    GetCostRegionForEditOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["costRegion"] = this.costRegion ? this.costRegion.toJSON() : undefined;
        data["courierName"] = this.courierName;
        data["courierCode"] = this.courierCode;
        return data;
    };
    return GetCostRegionForEditOutput;
}());
export { GetCostRegionForEditOutput };
var GetCourierForViewDto = /** @class */ (function () {
    function GetCourierForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetCourierForViewDto.prototype.init = function (data) {
        if (data) {
            this.courier = data["courier"] ? CourierDto.fromJS(data["courier"]) : undefined;
        }
    };
    GetCourierForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetCourierForViewDto();
        result.init(data);
        return result;
    };
    GetCourierForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["courier"] = this.courier ? this.courier.toJSON() : undefined;
        return data;
    };
    return GetCourierForViewDto;
}());
export { GetCourierForViewDto };
var PagedResultDtoOfGetCourierForViewDto = /** @class */ (function () {
    function PagedResultDtoOfGetCourierForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfGetCourierForViewDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(GetCourierForViewDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfGetCourierForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfGetCourierForViewDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfGetCourierForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfGetCourierForViewDto;
}());
export { PagedResultDtoOfGetCourierForViewDto };
var CreateOrEditCourierDto = /** @class */ (function () {
    function CreateOrEditCourierDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateOrEditCourierDto.prototype.init = function (data) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.id = data["id"];
        }
    };
    CreateOrEditCourierDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrEditCourierDto();
        result.init(data);
        return result;
    };
    CreateOrEditCourierDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    };
    return CreateOrEditCourierDto;
}());
export { CreateOrEditCourierDto };
var GetCourierForEditOutput = /** @class */ (function () {
    function GetCourierForEditOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetCourierForEditOutput.prototype.init = function (data) {
        if (data) {
            this.courier = data["courier"] ? CreateOrEditCourierDto.fromJS(data["courier"]) : undefined;
        }
    };
    GetCourierForEditOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetCourierForEditOutput();
        result.init(data);
        return result;
    };
    GetCourierForEditOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["courier"] = this.courier ? this.courier.toJSON() : undefined;
        return data;
    };
    return GetCourierForEditOutput;
}());
export { GetCourierForEditOutput };
var CrossBorderPackageDto = /** @class */ (function () {
    function CrossBorderPackageDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CrossBorderPackageDto.prototype.init = function (data) {
        if (data) {
            this.crossBorderId = data["crossBorderId"];
            this.crossBorder = data["crossBorder"] ? CrossBorderDto.fromJS(data["crossBorder"]) : undefined;
            this.packageId = data["packageId"];
            this.package = data["package"] ? PackageDto.fromJS(data["package"]) : undefined;
            this.barcode = data["barcode"];
        }
    };
    CrossBorderPackageDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CrossBorderPackageDto();
        result.init(data);
        return result;
    };
    CrossBorderPackageDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["crossBorderId"] = this.crossBorderId;
        data["crossBorder"] = this.crossBorder ? this.crossBorder.toJSON() : undefined;
        data["packageId"] = this.packageId;
        data["package"] = this.package ? this.package.toJSON() : undefined;
        data["barcode"] = this.barcode;
        return data;
    };
    return CrossBorderPackageDto;
}());
export { CrossBorderPackageDto };
var CrossBorderDto = /** @class */ (function () {
    function CrossBorderDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CrossBorderDto.prototype.init = function (data) {
        if (data) {
            this.location = data["location"];
            this.destination = data["destination"];
            this.palletisedDate = data["palletisedDate"] ? moment(data["palletisedDate"].toString()) : undefined;
            if (Array.isArray(data["crossBorderPackages"])) {
                this.crossBorderPackages = [];
                for (var _i = 0, _a = data["crossBorderPackages"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.crossBorderPackages.push(CrossBorderPackageDto.fromJS(item));
                }
            }
            this.id = data["id"];
        }
    };
    CrossBorderDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CrossBorderDto();
        result.init(data);
        return result;
    };
    CrossBorderDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["location"] = this.location;
        data["destination"] = this.destination;
        data["palletisedDate"] = this.palletisedDate ? this.palletisedDate.toISOString() : undefined;
        if (Array.isArray(this.crossBorderPackages)) {
            data["crossBorderPackages"] = [];
            for (var _i = 0, _a = this.crossBorderPackages; _i < _a.length; _i++) {
                var item = _a[_i];
                data["crossBorderPackages"].push(item.toJSON());
            }
        }
        data["id"] = this.id;
        return data;
    };
    return CrossBorderDto;
}());
export { CrossBorderDto };
var GetCrossBorderForViewDto = /** @class */ (function () {
    function GetCrossBorderForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetCrossBorderForViewDto.prototype.init = function (data) {
        if (data) {
            this.crossBorder = data["crossBorder"] ? CrossBorderDto.fromJS(data["crossBorder"]) : undefined;
            this.packageCount = data["packageCount"];
        }
    };
    GetCrossBorderForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetCrossBorderForViewDto();
        result.init(data);
        return result;
    };
    GetCrossBorderForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["crossBorder"] = this.crossBorder ? this.crossBorder.toJSON() : undefined;
        data["packageCount"] = this.packageCount;
        return data;
    };
    return GetCrossBorderForViewDto;
}());
export { GetCrossBorderForViewDto };
var PagedResultDtoOfGetCrossBorderForViewDto = /** @class */ (function () {
    function PagedResultDtoOfGetCrossBorderForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfGetCrossBorderForViewDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(GetCrossBorderForViewDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfGetCrossBorderForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfGetCrossBorderForViewDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfGetCrossBorderForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfGetCrossBorderForViewDto;
}());
export { PagedResultDtoOfGetCrossBorderForViewDto };
var CrossBorderCreateLoadInput = /** @class */ (function () {
    function CrossBorderCreateLoadInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.crossBorderIds = [];
        }
    }
    CrossBorderCreateLoadInput.prototype.init = function (data) {
        if (data) {
            if (Array.isArray(data["crossBorderIds"])) {
                this.crossBorderIds = [];
                for (var _i = 0, _a = data["crossBorderIds"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.crossBorderIds.push(item);
                }
            }
            this.toDepot = data["toDepot"];
            this.docket = data["docket"];
            this.carrier = data["carrier"];
            this.palletCount = data["palletCount"];
        }
    };
    CrossBorderCreateLoadInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CrossBorderCreateLoadInput();
        result.init(data);
        return result;
    };
    CrossBorderCreateLoadInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.crossBorderIds)) {
            data["crossBorderIds"] = [];
            for (var _i = 0, _a = this.crossBorderIds; _i < _a.length; _i++) {
                var item = _a[_i];
                data["crossBorderIds"].push(item);
            }
        }
        data["toDepot"] = this.toDepot;
        data["docket"] = this.docket;
        data["carrier"] = this.carrier;
        data["palletCount"] = this.palletCount;
        return data;
    };
    return CrossBorderCreateLoadInput;
}());
export { CrossBorderCreateLoadInput };
var Widget = /** @class */ (function () {
    function Widget(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Widget.prototype.init = function (data) {
        if (data) {
            this.widgetId = data["widgetId"];
            this.height = data["height"];
            this.width = data["width"];
            this.positionX = data["positionX"];
            this.positionY = data["positionY"];
            this.settings = data["settings"];
        }
    };
    Widget.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Widget();
        result.init(data);
        return result;
    };
    Widget.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["widgetId"] = this.widgetId;
        data["height"] = this.height;
        data["width"] = this.width;
        data["positionX"] = this.positionX;
        data["positionY"] = this.positionY;
        data["settings"] = this.settings;
        return data;
    };
    return Widget;
}());
export { Widget };
var Page = /** @class */ (function () {
    function Page(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Page.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            if (Array.isArray(data["widgets"])) {
                this.widgets = [];
                for (var _i = 0, _a = data["widgets"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.widgets.push(Widget.fromJS(item));
                }
            }
        }
    };
    Page.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Page();
        result.init(data);
        return result;
    };
    Page.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.widgets)) {
            data["widgets"] = [];
            for (var _i = 0, _a = this.widgets; _i < _a.length; _i++) {
                var item = _a[_i];
                data["widgets"].push(item.toJSON());
            }
        }
        return data;
    };
    return Page;
}());
export { Page };
var Dashboard = /** @class */ (function () {
    function Dashboard(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Dashboard.prototype.init = function (data) {
        if (data) {
            this.dashboardName = data["dashboardName"];
            if (Array.isArray(data["pages"])) {
                this.pages = [];
                for (var _i = 0, _a = data["pages"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.pages.push(Page.fromJS(item));
                }
            }
        }
    };
    Dashboard.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Dashboard();
        result.init(data);
        return result;
    };
    Dashboard.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["dashboardName"] = this.dashboardName;
        if (Array.isArray(this.pages)) {
            data["pages"] = [];
            for (var _i = 0, _a = this.pages; _i < _a.length; _i++) {
                var item = _a[_i];
                data["pages"].push(item.toJSON());
            }
        }
        return data;
    };
    return Dashboard;
}());
export { Dashboard };
var SavePageInput = /** @class */ (function () {
    function SavePageInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SavePageInput.prototype.init = function (data) {
        if (data) {
            this.dashboardName = data["dashboardName"];
            this.application = data["application"];
            if (Array.isArray(data["pages"])) {
                this.pages = [];
                for (var _i = 0, _a = data["pages"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.pages.push(Page.fromJS(item));
                }
            }
        }
    };
    SavePageInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SavePageInput();
        result.init(data);
        return result;
    };
    SavePageInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["dashboardName"] = this.dashboardName;
        data["application"] = this.application;
        if (Array.isArray(this.pages)) {
            data["pages"] = [];
            for (var _i = 0, _a = this.pages; _i < _a.length; _i++) {
                var item = _a[_i];
                data["pages"].push(item.toJSON());
            }
        }
        return data;
    };
    return SavePageInput;
}());
export { SavePageInput };
var RenamePageInput = /** @class */ (function () {
    function RenamePageInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RenamePageInput.prototype.init = function (data) {
        if (data) {
            this.dashboardName = data["dashboardName"];
            this.id = data["id"];
            this.name = data["name"];
            this.application = data["application"];
        }
    };
    RenamePageInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RenamePageInput();
        result.init(data);
        return result;
    };
    RenamePageInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["dashboardName"] = this.dashboardName;
        data["id"] = this.id;
        data["name"] = this.name;
        data["application"] = this.application;
        return data;
    };
    return RenamePageInput;
}());
export { RenamePageInput };
var AddNewPageInput = /** @class */ (function () {
    function AddNewPageInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AddNewPageInput.prototype.init = function (data) {
        if (data) {
            this.dashboardName = data["dashboardName"];
            this.name = data["name"];
            this.application = data["application"];
        }
    };
    AddNewPageInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AddNewPageInput();
        result.init(data);
        return result;
    };
    AddNewPageInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["dashboardName"] = this.dashboardName;
        data["name"] = this.name;
        data["application"] = this.application;
        return data;
    };
    return AddNewPageInput;
}());
export { AddNewPageInput };
var AddNewPageOutput = /** @class */ (function () {
    function AddNewPageOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AddNewPageOutput.prototype.init = function (data) {
        if (data) {
            this.pageId = data["pageId"];
        }
    };
    AddNewPageOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AddNewPageOutput();
        result.init(data);
        return result;
    };
    AddNewPageOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["pageId"] = this.pageId;
        return data;
    };
    return AddNewPageOutput;
}());
export { AddNewPageOutput };
var AddWidgetInput = /** @class */ (function () {
    function AddWidgetInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AddWidgetInput.prototype.init = function (data) {
        if (data) {
            this.widgetId = data["widgetId"];
            this.pageId = data["pageId"];
            this.dashboardName = data["dashboardName"];
            this.width = data["width"];
            this.height = data["height"];
            this.application = data["application"];
            this.settings = data["settings"];
        }
    };
    AddWidgetInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AddWidgetInput();
        result.init(data);
        return result;
    };
    AddWidgetInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["widgetId"] = this.widgetId;
        data["pageId"] = this.pageId;
        data["dashboardName"] = this.dashboardName;
        data["width"] = this.width;
        data["height"] = this.height;
        data["application"] = this.application;
        data["settings"] = this.settings;
        return data;
    };
    return AddWidgetInput;
}());
export { AddWidgetInput };
var WidgetFilterOutput = /** @class */ (function () {
    function WidgetFilterOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    WidgetFilterOutput.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
        }
    };
    WidgetFilterOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new WidgetFilterOutput();
        result.init(data);
        return result;
    };
    WidgetFilterOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    };
    return WidgetFilterOutput;
}());
export { WidgetFilterOutput };
var WidgetOutput = /** @class */ (function () {
    function WidgetOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    WidgetOutput.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.description = data["description"];
            if (Array.isArray(data["filters"])) {
                this.filters = [];
                for (var _i = 0, _a = data["filters"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.filters.push(WidgetFilterOutput.fromJS(item));
                }
            }
        }
    };
    WidgetOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new WidgetOutput();
        result.init(data);
        return result;
    };
    WidgetOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (var _i = 0, _a = this.filters; _i < _a.length; _i++) {
                var item = _a[_i];
                data["filters"].push(item.toJSON());
            }
        }
        return data;
    };
    return WidgetOutput;
}());
export { WidgetOutput };
var DashboardOutput = /** @class */ (function () {
    function DashboardOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DashboardOutput.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            if (Array.isArray(data["widgets"])) {
                this.widgets = [];
                for (var _i = 0, _a = data["widgets"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.widgets.push(WidgetOutput.fromJS(item));
                }
            }
        }
    };
    DashboardOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DashboardOutput();
        result.init(data);
        return result;
    };
    DashboardOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.widgets)) {
            data["widgets"] = [];
            for (var _i = 0, _a = this.widgets; _i < _a.length; _i++) {
                var item = _a[_i];
                data["widgets"].push(item.toJSON());
            }
        }
        return data;
    };
    return DashboardOutput;
}());
export { DashboardOutput };
var GetDeliveryDateExclusionForViewDto = /** @class */ (function () {
    function GetDeliveryDateExclusionForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetDeliveryDateExclusionForViewDto.prototype.init = function (data) {
        if (data) {
            this.deliveryDateExclusion = data["deliveryDateExclusion"] ? DeliveryDateExclusionDto.fromJS(data["deliveryDateExclusion"]) : undefined;
            this.territory = data["territory"];
            this.state = data["state"];
        }
    };
    GetDeliveryDateExclusionForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetDeliveryDateExclusionForViewDto();
        result.init(data);
        return result;
    };
    GetDeliveryDateExclusionForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["deliveryDateExclusion"] = this.deliveryDateExclusion ? this.deliveryDateExclusion.toJSON() : undefined;
        data["territory"] = this.territory;
        data["state"] = this.state;
        return data;
    };
    return GetDeliveryDateExclusionForViewDto;
}());
export { GetDeliveryDateExclusionForViewDto };
var PagedResultDtoOfGetDeliveryDateExclusionForViewDto = /** @class */ (function () {
    function PagedResultDtoOfGetDeliveryDateExclusionForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfGetDeliveryDateExclusionForViewDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(GetDeliveryDateExclusionForViewDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfGetDeliveryDateExclusionForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfGetDeliveryDateExclusionForViewDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfGetDeliveryDateExclusionForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfGetDeliveryDateExclusionForViewDto;
}());
export { PagedResultDtoOfGetDeliveryDateExclusionForViewDto };
var FutureDeliveryDatesDto = /** @class */ (function () {
    function FutureDeliveryDatesDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FutureDeliveryDatesDto.prototype.init = function (data) {
        if (data) {
            this.deliveryDate = data["deliveryDate"] ? moment(data["deliveryDate"].toString()) : undefined;
            this.day = data["day"];
        }
    };
    FutureDeliveryDatesDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FutureDeliveryDatesDto();
        result.init(data);
        return result;
    };
    FutureDeliveryDatesDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["deliveryDate"] = this.deliveryDate ? this.deliveryDate.toISOString() : undefined;
        data["day"] = this.day;
        return data;
    };
    return FutureDeliveryDatesDto;
}());
export { FutureDeliveryDatesDto };
var CreateOrEditDeliveryDateExclusionDto = /** @class */ (function () {
    function CreateOrEditDeliveryDateExclusionDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateOrEditDeliveryDateExclusionDto.prototype.init = function (data) {
        if (data) {
            this.deliveryDate = data["deliveryDate"] ? moment(data["deliveryDate"].toString()) : undefined;
            this.title = data["title"];
            this.type = data["type"];
            this.territoryConfigurationId = data["territoryConfigurationId"];
            this.id = data["id"];
        }
    };
    CreateOrEditDeliveryDateExclusionDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrEditDeliveryDateExclusionDto();
        result.init(data);
        return result;
    };
    CreateOrEditDeliveryDateExclusionDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["deliveryDate"] = this.deliveryDate ? this.deliveryDate.toISOString() : undefined;
        data["title"] = this.title;
        data["type"] = this.type;
        data["territoryConfigurationId"] = this.territoryConfigurationId;
        data["id"] = this.id;
        return data;
    };
    return CreateOrEditDeliveryDateExclusionDto;
}());
export { CreateOrEditDeliveryDateExclusionDto };
var GetDeliveryDateExclusionForEditOutput = /** @class */ (function () {
    function GetDeliveryDateExclusionForEditOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetDeliveryDateExclusionForEditOutput.prototype.init = function (data) {
        if (data) {
            this.deliveryDateExclusion = data["deliveryDateExclusion"] ? CreateOrEditDeliveryDateExclusionDto.fromJS(data["deliveryDateExclusion"]) : undefined;
            this.territory = data["territory"];
            this.state = data["state"];
        }
    };
    GetDeliveryDateExclusionForEditOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetDeliveryDateExclusionForEditOutput();
        result.init(data);
        return result;
    };
    GetDeliveryDateExclusionForEditOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["deliveryDateExclusion"] = this.deliveryDateExclusion ? this.deliveryDateExclusion.toJSON() : undefined;
        data["territory"] = this.territory;
        data["state"] = this.state;
        return data;
    };
    return GetDeliveryDateExclusionForEditOutput;
}());
export { GetDeliveryDateExclusionForEditOutput };
var DeliveryTypeSettingDto = /** @class */ (function () {
    function DeliveryTypeSettingDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DeliveryTypeSettingDto.prototype.init = function (data) {
        if (data) {
            this.deliveryType = data["deliveryType"];
            this.leadTime = data["leadTime"];
            this.id = data["id"];
        }
    };
    DeliveryTypeSettingDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DeliveryTypeSettingDto();
        result.init(data);
        return result;
    };
    DeliveryTypeSettingDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["deliveryType"] = this.deliveryType;
        data["leadTime"] = this.leadTime;
        data["id"] = this.id;
        return data;
    };
    return DeliveryTypeSettingDto;
}());
export { DeliveryTypeSettingDto };
var GetDeliveryTypeSettingForViewDto = /** @class */ (function () {
    function GetDeliveryTypeSettingForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetDeliveryTypeSettingForViewDto.prototype.init = function (data) {
        if (data) {
            this.deliveryTypeSetting = data["deliveryTypeSetting"] ? DeliveryTypeSettingDto.fromJS(data["deliveryTypeSetting"]) : undefined;
        }
    };
    GetDeliveryTypeSettingForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetDeliveryTypeSettingForViewDto();
        result.init(data);
        return result;
    };
    GetDeliveryTypeSettingForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["deliveryTypeSetting"] = this.deliveryTypeSetting ? this.deliveryTypeSetting.toJSON() : undefined;
        return data;
    };
    return GetDeliveryTypeSettingForViewDto;
}());
export { GetDeliveryTypeSettingForViewDto };
var PagedResultDtoOfGetDeliveryTypeSettingForViewDto = /** @class */ (function () {
    function PagedResultDtoOfGetDeliveryTypeSettingForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfGetDeliveryTypeSettingForViewDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(GetDeliveryTypeSettingForViewDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfGetDeliveryTypeSettingForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfGetDeliveryTypeSettingForViewDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfGetDeliveryTypeSettingForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfGetDeliveryTypeSettingForViewDto;
}());
export { PagedResultDtoOfGetDeliveryTypeSettingForViewDto };
var CreateOrEditDeliveryTypeSettingDto = /** @class */ (function () {
    function CreateOrEditDeliveryTypeSettingDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateOrEditDeliveryTypeSettingDto.prototype.init = function (data) {
        if (data) {
            this.deliveryType = data["deliveryType"];
            this.leadTime = data["leadTime"];
            this.id = data["id"];
        }
    };
    CreateOrEditDeliveryTypeSettingDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrEditDeliveryTypeSettingDto();
        result.init(data);
        return result;
    };
    CreateOrEditDeliveryTypeSettingDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["deliveryType"] = this.deliveryType;
        data["leadTime"] = this.leadTime;
        data["id"] = this.id;
        return data;
    };
    return CreateOrEditDeliveryTypeSettingDto;
}());
export { CreateOrEditDeliveryTypeSettingDto };
var GetDeliveryTypeSettingForEditOutput = /** @class */ (function () {
    function GetDeliveryTypeSettingForEditOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetDeliveryTypeSettingForEditOutput.prototype.init = function (data) {
        if (data) {
            this.deliveryTypeSetting = data["deliveryTypeSetting"] ? CreateOrEditDeliveryTypeSettingDto.fromJS(data["deliveryTypeSetting"]) : undefined;
        }
    };
    GetDeliveryTypeSettingForEditOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetDeliveryTypeSettingForEditOutput();
        result.init(data);
        return result;
    };
    GetDeliveryTypeSettingForEditOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["deliveryTypeSetting"] = this.deliveryTypeSetting ? this.deliveryTypeSetting.toJSON() : undefined;
        return data;
    };
    return GetDeliveryTypeSettingForEditOutput;
}());
export { GetDeliveryTypeSettingForEditOutput };
var DateToStringOutput = /** @class */ (function () {
    function DateToStringOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DateToStringOutput.prototype.init = function (data) {
        if (data) {
            this.dateString = data["dateString"];
        }
    };
    DateToStringOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DateToStringOutput();
        result.init(data);
        return result;
    };
    DateToStringOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["dateString"] = this.dateString;
        return data;
    };
    return DateToStringOutput;
}());
export { DateToStringOutput };
var StringOutput = /** @class */ (function () {
    function StringOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    StringOutput.prototype.init = function (data) {
        if (data) {
            this.output = data["output"];
        }
    };
    StringOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new StringOutput();
        result.init(data);
        return result;
    };
    StringOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["output"] = this.output;
        return data;
    };
    return StringOutput;
}());
export { StringOutput };
var GetDepotLocationForViewDto = /** @class */ (function () {
    function GetDepotLocationForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetDepotLocationForViewDto.prototype.init = function (data) {
        if (data) {
            this.depotLocation = data["depotLocation"] ? DepotLocationDto.fromJS(data["depotLocation"]) : undefined;
        }
    };
    GetDepotLocationForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetDepotLocationForViewDto();
        result.init(data);
        return result;
    };
    GetDepotLocationForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["depotLocation"] = this.depotLocation ? this.depotLocation.toJSON() : undefined;
        return data;
    };
    return GetDepotLocationForViewDto;
}());
export { GetDepotLocationForViewDto };
var PagedResultDtoOfGetDepotLocationForViewDto = /** @class */ (function () {
    function PagedResultDtoOfGetDepotLocationForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfGetDepotLocationForViewDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(GetDepotLocationForViewDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfGetDepotLocationForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfGetDepotLocationForViewDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfGetDepotLocationForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfGetDepotLocationForViewDto;
}());
export { PagedResultDtoOfGetDepotLocationForViewDto };
var CreateOrEditDepotLocationDto = /** @class */ (function () {
    function CreateOrEditDepotLocationDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateOrEditDepotLocationDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.cutoffTime = data["cutoffTime"];
            this.address1 = data["address1"];
            this.address2 = data["address2"];
            this.suburb = data["suburb"];
            this.state = data["state"];
            this.postcode = data["postcode"];
            this.depotStoreNumber = data["depotStoreNumber"];
            if (Array.isArray(data["validDepotLocationScanTags"])) {
                this.validDepotLocationScanTags = [];
                for (var _i = 0, _a = data["validDepotLocationScanTags"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.validDepotLocationScanTags.push(item);
                }
            }
            this.id = data["id"];
        }
    };
    CreateOrEditDepotLocationDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrEditDepotLocationDto();
        result.init(data);
        return result;
    };
    CreateOrEditDepotLocationDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["cutoffTime"] = this.cutoffTime;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["suburb"] = this.suburb;
        data["state"] = this.state;
        data["postcode"] = this.postcode;
        data["depotStoreNumber"] = this.depotStoreNumber;
        if (Array.isArray(this.validDepotLocationScanTags)) {
            data["validDepotLocationScanTags"] = [];
            for (var _i = 0, _a = this.validDepotLocationScanTags; _i < _a.length; _i++) {
                var item = _a[_i];
                data["validDepotLocationScanTags"].push(item);
            }
        }
        data["id"] = this.id;
        return data;
    };
    return CreateOrEditDepotLocationDto;
}());
export { CreateOrEditDepotLocationDto };
var GetDepotLocationForEditOutput = /** @class */ (function () {
    function GetDepotLocationForEditOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetDepotLocationForEditOutput.prototype.init = function (data) {
        if (data) {
            this.depotLocation = data["depotLocation"] ? CreateOrEditDepotLocationDto.fromJS(data["depotLocation"]) : undefined;
        }
    };
    GetDepotLocationForEditOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetDepotLocationForEditOutput();
        result.init(data);
        return result;
    };
    GetDepotLocationForEditOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["depotLocation"] = this.depotLocation ? this.depotLocation.toJSON() : undefined;
        return data;
    };
    return GetDepotLocationForEditOutput;
}());
export { GetDepotLocationForEditOutput };
var DepotToDepotSettingDto = /** @class */ (function () {
    function DepotToDepotSettingDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DepotToDepotSettingDto.prototype.init = function (data) {
        if (data) {
            this.leadTime = data["leadTime"];
            this.fromDepotLocationId = data["fromDepotLocationId"];
            this.toDepotLocationId = data["toDepotLocationId"];
            this.id = data["id"];
        }
    };
    DepotToDepotSettingDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DepotToDepotSettingDto();
        result.init(data);
        return result;
    };
    DepotToDepotSettingDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["leadTime"] = this.leadTime;
        data["fromDepotLocationId"] = this.fromDepotLocationId;
        data["toDepotLocationId"] = this.toDepotLocationId;
        data["id"] = this.id;
        return data;
    };
    return DepotToDepotSettingDto;
}());
export { DepotToDepotSettingDto };
var GetDepotToDepotSettingForViewDto = /** @class */ (function () {
    function GetDepotToDepotSettingForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetDepotToDepotSettingForViewDto.prototype.init = function (data) {
        if (data) {
            this.depotToDepotSetting = data["depotToDepotSetting"] ? DepotToDepotSettingDto.fromJS(data["depotToDepotSetting"]) : undefined;
            this.depotLocationName = data["depotLocationName"];
            this.depotLocationName2 = data["depotLocationName2"];
        }
    };
    GetDepotToDepotSettingForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetDepotToDepotSettingForViewDto();
        result.init(data);
        return result;
    };
    GetDepotToDepotSettingForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["depotToDepotSetting"] = this.depotToDepotSetting ? this.depotToDepotSetting.toJSON() : undefined;
        data["depotLocationName"] = this.depotLocationName;
        data["depotLocationName2"] = this.depotLocationName2;
        return data;
    };
    return GetDepotToDepotSettingForViewDto;
}());
export { GetDepotToDepotSettingForViewDto };
var PagedResultDtoOfGetDepotToDepotSettingForViewDto = /** @class */ (function () {
    function PagedResultDtoOfGetDepotToDepotSettingForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfGetDepotToDepotSettingForViewDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(GetDepotToDepotSettingForViewDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfGetDepotToDepotSettingForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfGetDepotToDepotSettingForViewDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfGetDepotToDepotSettingForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfGetDepotToDepotSettingForViewDto;
}());
export { PagedResultDtoOfGetDepotToDepotSettingForViewDto };
var CreateOrEditDepotToDepotSettingDto = /** @class */ (function () {
    function CreateOrEditDepotToDepotSettingDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateOrEditDepotToDepotSettingDto.prototype.init = function (data) {
        if (data) {
            this.leadTime = data["leadTime"];
            this.fromDepotLocationId = data["fromDepotLocationId"];
            this.toDepotLocationId = data["toDepotLocationId"];
            this.id = data["id"];
        }
    };
    CreateOrEditDepotToDepotSettingDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrEditDepotToDepotSettingDto();
        result.init(data);
        return result;
    };
    CreateOrEditDepotToDepotSettingDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["leadTime"] = this.leadTime;
        data["fromDepotLocationId"] = this.fromDepotLocationId;
        data["toDepotLocationId"] = this.toDepotLocationId;
        data["id"] = this.id;
        return data;
    };
    return CreateOrEditDepotToDepotSettingDto;
}());
export { CreateOrEditDepotToDepotSettingDto };
var GetDepotToDepotSettingForEditOutput = /** @class */ (function () {
    function GetDepotToDepotSettingForEditOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetDepotToDepotSettingForEditOutput.prototype.init = function (data) {
        if (data) {
            this.depotToDepotSetting = data["depotToDepotSetting"] ? CreateOrEditDepotToDepotSettingDto.fromJS(data["depotToDepotSetting"]) : undefined;
            this.depotLocationName = data["depotLocationName"];
            this.depotLocationName2 = data["depotLocationName2"];
        }
    };
    GetDepotToDepotSettingForEditOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetDepotToDepotSettingForEditOutput();
        result.init(data);
        return result;
    };
    GetDepotToDepotSettingForEditOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["depotToDepotSetting"] = this.depotToDepotSetting ? this.depotToDepotSetting.toJSON() : undefined;
        data["depotLocationName"] = this.depotLocationName;
        data["depotLocationName2"] = this.depotLocationName2;
        return data;
    };
    return GetDepotToDepotSettingForEditOutput;
}());
export { GetDepotToDepotSettingForEditOutput };
var DriverDaysWorkedDto = /** @class */ (function () {
    function DriverDaysWorkedDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DriverDaysWorkedDto.prototype.init = function (data) {
        if (data) {
            this.carrierCode = data["carrierCode"];
            this.leaseDays = data["leaseDays"];
            this.topUpDays = data["topUpDays"];
            this.hours = data["hours"];
            this.depotLocationId = data["depotLocationId"];
            this.id = data["id"];
        }
    };
    DriverDaysWorkedDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DriverDaysWorkedDto();
        result.init(data);
        return result;
    };
    DriverDaysWorkedDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["carrierCode"] = this.carrierCode;
        data["leaseDays"] = this.leaseDays;
        data["topUpDays"] = this.topUpDays;
        data["hours"] = this.hours;
        data["depotLocationId"] = this.depotLocationId;
        data["id"] = this.id;
        return data;
    };
    return DriverDaysWorkedDto;
}());
export { DriverDaysWorkedDto };
var GetDriverDaysWorkedForViewDto = /** @class */ (function () {
    function GetDriverDaysWorkedForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetDriverDaysWorkedForViewDto.prototype.init = function (data) {
        if (data) {
            this.driverDaysWorked = data["driverDaysWorked"] ? DriverDaysWorkedDto.fromJS(data["driverDaysWorked"]) : undefined;
            this.depotLocationName = data["depotLocationName"];
        }
    };
    GetDriverDaysWorkedForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetDriverDaysWorkedForViewDto();
        result.init(data);
        return result;
    };
    GetDriverDaysWorkedForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["driverDaysWorked"] = this.driverDaysWorked ? this.driverDaysWorked.toJSON() : undefined;
        data["depotLocationName"] = this.depotLocationName;
        return data;
    };
    return GetDriverDaysWorkedForViewDto;
}());
export { GetDriverDaysWorkedForViewDto };
var PagedResultDtoOfGetDriverDaysWorkedForViewDto = /** @class */ (function () {
    function PagedResultDtoOfGetDriverDaysWorkedForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfGetDriverDaysWorkedForViewDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(GetDriverDaysWorkedForViewDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfGetDriverDaysWorkedForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfGetDriverDaysWorkedForViewDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfGetDriverDaysWorkedForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfGetDriverDaysWorkedForViewDto;
}());
export { PagedResultDtoOfGetDriverDaysWorkedForViewDto };
var CreateOrEditDriverDaysWorkedDto = /** @class */ (function () {
    function CreateOrEditDriverDaysWorkedDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateOrEditDriverDaysWorkedDto.prototype.init = function (data) {
        if (data) {
            this.carrierId = data["carrierId"];
            this.carrierName = data["carrierName"];
            this.leaseDays = data["leaseDays"];
            this.topUpDays = data["topUpDays"];
            this.hours = data["hours"];
            this.chargePeriodStartDate = data["chargePeriodStartDate"] ? moment(data["chargePeriodStartDate"].toString()) : undefined;
            this.depotLocationId = data["depotLocationId"];
            this.id = data["id"];
        }
    };
    CreateOrEditDriverDaysWorkedDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrEditDriverDaysWorkedDto();
        result.init(data);
        return result;
    };
    CreateOrEditDriverDaysWorkedDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["carrierId"] = this.carrierId;
        data["carrierName"] = this.carrierName;
        data["leaseDays"] = this.leaseDays;
        data["topUpDays"] = this.topUpDays;
        data["hours"] = this.hours;
        data["chargePeriodStartDate"] = this.chargePeriodStartDate ? this.chargePeriodStartDate.toISOString() : undefined;
        data["depotLocationId"] = this.depotLocationId;
        data["id"] = this.id;
        return data;
    };
    return CreateOrEditDriverDaysWorkedDto;
}());
export { CreateOrEditDriverDaysWorkedDto };
var GetDriverDaysWorkedForEditOutput = /** @class */ (function () {
    function GetDriverDaysWorkedForEditOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetDriverDaysWorkedForEditOutput.prototype.init = function (data) {
        if (data) {
            this.driverDaysWorked = data["driverDaysWorked"] ? CreateOrEditDriverDaysWorkedDto.fromJS(data["driverDaysWorked"]) : undefined;
            this.depotLocationName = data["depotLocationName"];
        }
    };
    GetDriverDaysWorkedForEditOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetDriverDaysWorkedForEditOutput();
        result.init(data);
        return result;
    };
    GetDriverDaysWorkedForEditOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["driverDaysWorked"] = this.driverDaysWorked ? this.driverDaysWorked.toJSON() : undefined;
        data["depotLocationName"] = this.depotLocationName;
        return data;
    };
    return GetDriverDaysWorkedForEditOutput;
}());
export { GetDriverDaysWorkedForEditOutput };
var BulkEditDriverDaysWorkedDto = /** @class */ (function () {
    function BulkEditDriverDaysWorkedDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BulkEditDriverDaysWorkedDto.prototype.init = function (data) {
        if (data) {
            if (Array.isArray(data["ids"])) {
                this.ids = [];
                for (var _i = 0, _a = data["ids"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.ids.push(item);
                }
            }
            this.leaseDays = data["leaseDays"];
            this.topUpDays = data["topUpDays"];
            this.hours = data["hours"];
            this.chargePeriodStartDate = data["chargePeriodStartDate"] ? moment(data["chargePeriodStartDate"].toString()) : undefined;
        }
    };
    BulkEditDriverDaysWorkedDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BulkEditDriverDaysWorkedDto();
        result.init(data);
        return result;
    };
    BulkEditDriverDaysWorkedDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (var _i = 0, _a = this.ids; _i < _a.length; _i++) {
                var item = _a[_i];
                data["ids"].push(item);
            }
        }
        data["leaseDays"] = this.leaseDays;
        data["topUpDays"] = this.topUpDays;
        data["hours"] = this.hours;
        data["chargePeriodStartDate"] = this.chargePeriodStartDate ? this.chargePeriodStartDate.toISOString() : undefined;
        return data;
    };
    return BulkEditDriverDaysWorkedDto;
}());
export { BulkEditDriverDaysWorkedDto };
var DriverDaysWorkedDepotLocationLookupTableDto = /** @class */ (function () {
    function DriverDaysWorkedDepotLocationLookupTableDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DriverDaysWorkedDepotLocationLookupTableDto.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    };
    DriverDaysWorkedDepotLocationLookupTableDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DriverDaysWorkedDepotLocationLookupTableDto();
        result.init(data);
        return result;
    };
    DriverDaysWorkedDepotLocationLookupTableDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    };
    return DriverDaysWorkedDepotLocationLookupTableDto;
}());
export { DriverDaysWorkedDepotLocationLookupTableDto };
var PagedResultDtoOfDriverDaysWorkedDepotLocationLookupTableDto = /** @class */ (function () {
    function PagedResultDtoOfDriverDaysWorkedDepotLocationLookupTableDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfDriverDaysWorkedDepotLocationLookupTableDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(DriverDaysWorkedDepotLocationLookupTableDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfDriverDaysWorkedDepotLocationLookupTableDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfDriverDaysWorkedDepotLocationLookupTableDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfDriverDaysWorkedDepotLocationLookupTableDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfDriverDaysWorkedDepotLocationLookupTableDto;
}());
export { PagedResultDtoOfDriverDaysWorkedDepotLocationLookupTableDto };
var EditionListDto = /** @class */ (function () {
    function EditionListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EditionListDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.dailyPrice = data["dailyPrice"];
            this.weeklyPrice = data["weeklyPrice"];
            this.monthlyPrice = data["monthlyPrice"];
            this.annualPrice = data["annualPrice"];
            this.waitingDayAfterExpire = data["waitingDayAfterExpire"];
            this.trialDayCount = data["trialDayCount"];
            this.expiringEditionDisplayName = data["expiringEditionDisplayName"];
            this.id = data["id"];
        }
    };
    EditionListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new EditionListDto();
        result.init(data);
        return result;
    };
    EditionListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["dailyPrice"] = this.dailyPrice;
        data["weeklyPrice"] = this.weeklyPrice;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["waitingDayAfterExpire"] = this.waitingDayAfterExpire;
        data["trialDayCount"] = this.trialDayCount;
        data["expiringEditionDisplayName"] = this.expiringEditionDisplayName;
        data["id"] = this.id;
        return data;
    };
    return EditionListDto;
}());
export { EditionListDto };
var ListResultDtoOfEditionListDto = /** @class */ (function () {
    function ListResultDtoOfEditionListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ListResultDtoOfEditionListDto.prototype.init = function (data) {
        if (data) {
            if (Array.isArray(data["items"])) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(EditionListDto.fromJS(item));
                }
            }
        }
    };
    ListResultDtoOfEditionListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ListResultDtoOfEditionListDto();
        result.init(data);
        return result;
    };
    ListResultDtoOfEditionListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return ListResultDtoOfEditionListDto;
}());
export { ListResultDtoOfEditionListDto };
var EditionEditDto = /** @class */ (function () {
    function EditionEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EditionEditDto.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
            this.expiringEditionId = data["expiringEditionId"];
        }
    };
    EditionEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new EditionEditDto();
        result.init(data);
        return result;
    };
    EditionEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["expiringEditionId"] = this.expiringEditionId;
        return data;
    };
    return EditionEditDto;
}());
export { EditionEditDto };
var IValueValidator = /** @class */ (function () {
    function IValueValidator(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    IValueValidator.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            if (data["attributes"]) {
                this.attributes = {};
                for (var key in data["attributes"]) {
                    if (data["attributes"].hasOwnProperty(key))
                        this.attributes[key] = data["attributes"][key];
                }
            }
        }
    };
    IValueValidator.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new IValueValidator();
        result.init(data);
        return result;
    };
    IValueValidator.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.attributes) {
            data["attributes"] = {};
            for (var key in this.attributes) {
                if (this.attributes.hasOwnProperty(key))
                    data["attributes"][key] = this.attributes[key];
            }
        }
        return data;
    };
    return IValueValidator;
}());
export { IValueValidator };
var LocalizableComboboxItemDto = /** @class */ (function () {
    function LocalizableComboboxItemDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    LocalizableComboboxItemDto.prototype.init = function (data) {
        if (data) {
            this.value = data["value"];
            this.displayText = data["displayText"];
        }
    };
    LocalizableComboboxItemDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new LocalizableComboboxItemDto();
        result.init(data);
        return result;
    };
    LocalizableComboboxItemDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        return data;
    };
    return LocalizableComboboxItemDto;
}());
export { LocalizableComboboxItemDto };
var LocalizableComboboxItemSourceDto = /** @class */ (function () {
    function LocalizableComboboxItemSourceDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    LocalizableComboboxItemSourceDto.prototype.init = function (data) {
        if (data) {
            if (Array.isArray(data["items"])) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(LocalizableComboboxItemDto.fromJS(item));
                }
            }
        }
    };
    LocalizableComboboxItemSourceDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new LocalizableComboboxItemSourceDto();
        result.init(data);
        return result;
    };
    LocalizableComboboxItemSourceDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return LocalizableComboboxItemSourceDto;
}());
export { LocalizableComboboxItemSourceDto };
var FeatureInputTypeDto = /** @class */ (function () {
    function FeatureInputTypeDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FeatureInputTypeDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            if (data["attributes"]) {
                this.attributes = {};
                for (var key in data["attributes"]) {
                    if (data["attributes"].hasOwnProperty(key))
                        this.attributes[key] = data["attributes"][key];
                }
            }
            this.validator = data["validator"] ? IValueValidator.fromJS(data["validator"]) : undefined;
            this.itemSource = data["itemSource"] ? LocalizableComboboxItemSourceDto.fromJS(data["itemSource"]) : undefined;
        }
    };
    FeatureInputTypeDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FeatureInputTypeDto();
        result.init(data);
        return result;
    };
    FeatureInputTypeDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.attributes) {
            data["attributes"] = {};
            for (var key in this.attributes) {
                if (this.attributes.hasOwnProperty(key))
                    data["attributes"][key] = this.attributes[key];
            }
        }
        data["validator"] = this.validator ? this.validator.toJSON() : undefined;
        data["itemSource"] = this.itemSource ? this.itemSource.toJSON() : undefined;
        return data;
    };
    return FeatureInputTypeDto;
}());
export { FeatureInputTypeDto };
var FlatFeatureDto = /** @class */ (function () {
    function FlatFeatureDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FlatFeatureDto.prototype.init = function (data) {
        if (data) {
            this.parentName = data["parentName"];
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.description = data["description"];
            this.defaultValue = data["defaultValue"];
            this.inputType = data["inputType"] ? FeatureInputTypeDto.fromJS(data["inputType"]) : undefined;
        }
    };
    FlatFeatureDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FlatFeatureDto();
        result.init(data);
        return result;
    };
    FlatFeatureDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["defaultValue"] = this.defaultValue;
        data["inputType"] = this.inputType ? this.inputType.toJSON() : undefined;
        return data;
    };
    return FlatFeatureDto;
}());
export { FlatFeatureDto };
var GetEditionEditOutput = /** @class */ (function () {
    function GetEditionEditOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetEditionEditOutput.prototype.init = function (data) {
        if (data) {
            this.edition = data["edition"] ? EditionEditDto.fromJS(data["edition"]) : undefined;
            if (Array.isArray(data["featureValues"])) {
                this.featureValues = [];
                for (var _i = 0, _a = data["featureValues"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.featureValues.push(NameValueDto.fromJS(item));
                }
            }
            if (Array.isArray(data["features"])) {
                this.features = [];
                for (var _b = 0, _c = data["features"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.features.push(FlatFeatureDto.fromJS(item));
                }
            }
        }
    };
    GetEditionEditOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetEditionEditOutput();
        result.init(data);
        return result;
    };
    GetEditionEditOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : undefined;
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (var _i = 0, _a = this.featureValues; _i < _a.length; _i++) {
                var item = _a[_i];
                data["featureValues"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.features)) {
            data["features"] = [];
            for (var _b = 0, _c = this.features; _b < _c.length; _b++) {
                var item = _c[_b];
                data["features"].push(item.toJSON());
            }
        }
        return data;
    };
    return GetEditionEditOutput;
}());
export { GetEditionEditOutput };
var EditionCreateDto = /** @class */ (function () {
    function EditionCreateDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EditionCreateDto.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
            this.dailyPrice = data["dailyPrice"];
            this.weeklyPrice = data["weeklyPrice"];
            this.monthlyPrice = data["monthlyPrice"];
            this.annualPrice = data["annualPrice"];
            this.trialDayCount = data["trialDayCount"];
            this.waitingDayAfterExpire = data["waitingDayAfterExpire"];
            this.expiringEditionId = data["expiringEditionId"];
        }
    };
    EditionCreateDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new EditionCreateDto();
        result.init(data);
        return result;
    };
    EditionCreateDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["dailyPrice"] = this.dailyPrice;
        data["weeklyPrice"] = this.weeklyPrice;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["trialDayCount"] = this.trialDayCount;
        data["waitingDayAfterExpire"] = this.waitingDayAfterExpire;
        data["expiringEditionId"] = this.expiringEditionId;
        return data;
    };
    return EditionCreateDto;
}());
export { EditionCreateDto };
var CreateEditionDto = /** @class */ (function () {
    function CreateEditionDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.edition = new EditionCreateDto();
            this.featureValues = [];
        }
    }
    CreateEditionDto.prototype.init = function (data) {
        if (data) {
            this.edition = data["edition"] ? EditionCreateDto.fromJS(data["edition"]) : new EditionCreateDto();
            if (Array.isArray(data["featureValues"])) {
                this.featureValues = [];
                for (var _i = 0, _a = data["featureValues"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.featureValues.push(NameValueDto.fromJS(item));
                }
            }
        }
    };
    CreateEditionDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateEditionDto();
        result.init(data);
        return result;
    };
    CreateEditionDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : undefined;
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (var _i = 0, _a = this.featureValues; _i < _a.length; _i++) {
                var item = _a[_i];
                data["featureValues"].push(item.toJSON());
            }
        }
        return data;
    };
    return CreateEditionDto;
}());
export { CreateEditionDto };
var UpdateEditionDto = /** @class */ (function () {
    function UpdateEditionDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.edition = new EditionEditDto();
            this.featureValues = [];
        }
    }
    UpdateEditionDto.prototype.init = function (data) {
        if (data) {
            this.edition = data["edition"] ? EditionEditDto.fromJS(data["edition"]) : new EditionEditDto();
            if (Array.isArray(data["featureValues"])) {
                this.featureValues = [];
                for (var _i = 0, _a = data["featureValues"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.featureValues.push(NameValueDto.fromJS(item));
                }
            }
        }
    };
    UpdateEditionDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateEditionDto();
        result.init(data);
        return result;
    };
    UpdateEditionDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : undefined;
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (var _i = 0, _a = this.featureValues; _i < _a.length; _i++) {
                var item = _a[_i];
                data["featureValues"].push(item.toJSON());
            }
        }
        return data;
    };
    return UpdateEditionDto;
}());
export { UpdateEditionDto };
var MoveTenantsToAnotherEditionDto = /** @class */ (function () {
    function MoveTenantsToAnotherEditionDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MoveTenantsToAnotherEditionDto.prototype.init = function (data) {
        if (data) {
            this.sourceEditionId = data["sourceEditionId"];
            this.targetEditionId = data["targetEditionId"];
        }
    };
    MoveTenantsToAnotherEditionDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new MoveTenantsToAnotherEditionDto();
        result.init(data);
        return result;
    };
    MoveTenantsToAnotherEditionDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["sourceEditionId"] = this.sourceEditionId;
        data["targetEditionId"] = this.targetEditionId;
        return data;
    };
    return MoveTenantsToAnotherEditionDto;
}());
export { MoveTenantsToAnotherEditionDto };
var CreateOrEditEventDetailDto = /** @class */ (function () {
    function CreateOrEditEventDetailDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateOrEditEventDetailDto.prototype.init = function (data) {
        if (data) {
            this.status = data["status"];
            this.description = data["description"];
            this.removeTransaction = data["removeTransaction"];
            this.eventGroupId = data["eventGroupId"];
            this.courierId = data["courierId"];
            this.exceptionConsignmentStatusId = data["exceptionConsignmentStatusId"];
            this.zendeskQueryType = data["zendeskQueryType"];
            this.consignmentDashboardCategory = data["consignmentDashboardCategory"];
            this.id = data["id"];
        }
    };
    CreateOrEditEventDetailDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrEditEventDetailDto();
        result.init(data);
        return result;
    };
    CreateOrEditEventDetailDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["description"] = this.description;
        data["removeTransaction"] = this.removeTransaction;
        data["eventGroupId"] = this.eventGroupId;
        data["courierId"] = this.courierId;
        data["exceptionConsignmentStatusId"] = this.exceptionConsignmentStatusId;
        data["zendeskQueryType"] = this.zendeskQueryType;
        data["consignmentDashboardCategory"] = this.consignmentDashboardCategory;
        data["id"] = this.id;
        return data;
    };
    return CreateOrEditEventDetailDto;
}());
export { CreateOrEditEventDetailDto };
var ConsignmentStatusDto = /** @class */ (function () {
    function ConsignmentStatusDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ConsignmentStatusDto.prototype.init = function (data) {
        if (data) {
            this.description = data["description"];
            this.clientVisible = data["clientVisible"];
            this.id = data["id"];
        }
    };
    ConsignmentStatusDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ConsignmentStatusDto();
        result.init(data);
        return result;
    };
    ConsignmentStatusDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["clientVisible"] = this.clientVisible;
        data["id"] = this.id;
        return data;
    };
    return ConsignmentStatusDto;
}());
export { ConsignmentStatusDto };
var GetEventDetailForEditOutput = /** @class */ (function () {
    function GetEventDetailForEditOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetEventDetailForEditOutput.prototype.init = function (data) {
        if (data) {
            this.eventDetail = data["eventDetail"] ? CreateOrEditEventDetailDto.fromJS(data["eventDetail"]) : undefined;
            this.eventGroupDescription = data["eventGroupDescription"];
            this.removeTransaction = data["removeTransaction"];
            this.courierName = data["courierName"];
            this.consignmentStatus = data["consignmentStatus"] ? ConsignmentStatusDto.fromJS(data["consignmentStatus"]) : undefined;
        }
    };
    GetEventDetailForEditOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetEventDetailForEditOutput();
        result.init(data);
        return result;
    };
    GetEventDetailForEditOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["eventDetail"] = this.eventDetail ? this.eventDetail.toJSON() : undefined;
        data["eventGroupDescription"] = this.eventGroupDescription;
        data["removeTransaction"] = this.removeTransaction;
        data["courierName"] = this.courierName;
        data["consignmentStatus"] = this.consignmentStatus ? this.consignmentStatus.toJSON() : undefined;
        return data;
    };
    return GetEventDetailForEditOutput;
}());
export { GetEventDetailForEditOutput };
export var ExceptionType;
(function (ExceptionType) {
    ExceptionType[ExceptionType["None"] = 0] = "None";
    ExceptionType[ExceptionType["CustomerCare"] = 1] = "CustomerCare";
    ExceptionType[ExceptionType["Depot"] = 2] = "Depot";
    ExceptionType[ExceptionType["Driver"] = 4] = "Driver";
})(ExceptionType || (ExceptionType = {}));
var EventGroupDto = /** @class */ (function () {
    function EventGroupDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EventGroupDto.prototype.init = function (data) {
        if (data) {
            this.description = data["description"];
            this.isException = data["isException"];
            this.exceptionType = data["exceptionType"];
            this.resultingConsignmentStatusId = data["resultingConsignmentStatusId"];
            this.id = data["id"];
        }
    };
    EventGroupDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new EventGroupDto();
        result.init(data);
        return result;
    };
    EventGroupDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["isException"] = this.isException;
        data["exceptionType"] = this.exceptionType;
        data["resultingConsignmentStatusId"] = this.resultingConsignmentStatusId;
        data["id"] = this.id;
        return data;
    };
    return EventGroupDto;
}());
export { EventGroupDto };
var GetEventGroupForViewDto = /** @class */ (function () {
    function GetEventGroupForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetEventGroupForViewDto.prototype.init = function (data) {
        if (data) {
            this.eventGroup = data["eventGroup"] ? EventGroupDto.fromJS(data["eventGroup"]) : undefined;
            this.resultingConsignmentStatus = data["resultingConsignmentStatus"];
        }
    };
    GetEventGroupForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetEventGroupForViewDto();
        result.init(data);
        return result;
    };
    GetEventGroupForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["eventGroup"] = this.eventGroup ? this.eventGroup.toJSON() : undefined;
        data["resultingConsignmentStatus"] = this.resultingConsignmentStatus;
        return data;
    };
    return GetEventGroupForViewDto;
}());
export { GetEventGroupForViewDto };
var PagedResultDtoOfGetEventGroupForViewDto = /** @class */ (function () {
    function PagedResultDtoOfGetEventGroupForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfGetEventGroupForViewDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(GetEventGroupForViewDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfGetEventGroupForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfGetEventGroupForViewDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfGetEventGroupForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfGetEventGroupForViewDto;
}());
export { PagedResultDtoOfGetEventGroupForViewDto };
var CreateOrEditEventGroupDto = /** @class */ (function () {
    function CreateOrEditEventGroupDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateOrEditEventGroupDto.prototype.init = function (data) {
        if (data) {
            this.description = data["description"];
            this.isException = data["isException"];
            this.exceptionType = data["exceptionType"];
            this.resultingConsignmentStatusId = data["resultingConsignmentStatusId"];
            this.id = data["id"];
        }
    };
    CreateOrEditEventGroupDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrEditEventGroupDto();
        result.init(data);
        return result;
    };
    CreateOrEditEventGroupDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["isException"] = this.isException;
        data["exceptionType"] = this.exceptionType;
        data["resultingConsignmentStatusId"] = this.resultingConsignmentStatusId;
        data["id"] = this.id;
        return data;
    };
    return CreateOrEditEventGroupDto;
}());
export { CreateOrEditEventGroupDto };
var GetEventGroupForEditOutput = /** @class */ (function () {
    function GetEventGroupForEditOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetEventGroupForEditOutput.prototype.init = function (data) {
        if (data) {
            this.eventGroup = data["eventGroup"] ? CreateOrEditEventGroupDto.fromJS(data["eventGroup"]) : undefined;
            this.consignmentStatus = data["consignmentStatus"] ? ConsignmentStatusDto.fromJS(data["consignmentStatus"]) : undefined;
        }
    };
    GetEventGroupForEditOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetEventGroupForEditOutput();
        result.init(data);
        return result;
    };
    GetEventGroupForEditOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["eventGroup"] = this.eventGroup ? this.eventGroup.toJSON() : undefined;
        data["consignmentStatus"] = this.consignmentStatus ? this.consignmentStatus.toJSON() : undefined;
        return data;
    };
    return GetEventGroupForEditOutput;
}());
export { GetEventGroupForEditOutput };
var ExternalVendorDto = /** @class */ (function () {
    function ExternalVendorDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ExternalVendorDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.d365Entity = data["d365Entity"];
            this.clientGroupId = data["clientGroupId"];
            this.id = data["id"];
        }
    };
    ExternalVendorDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ExternalVendorDto();
        result.init(data);
        return result;
    };
    ExternalVendorDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["d365Entity"] = this.d365Entity;
        data["clientGroupId"] = this.clientGroupId;
        data["id"] = this.id;
        return data;
    };
    return ExternalVendorDto;
}());
export { ExternalVendorDto };
var GetExternalVendorForViewDto = /** @class */ (function () {
    function GetExternalVendorForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetExternalVendorForViewDto.prototype.init = function (data) {
        if (data) {
            this.externalVendor = data["externalVendor"] ? ExternalVendorDto.fromJS(data["externalVendor"]) : undefined;
            this.clientGroupName = data["clientGroupName"];
        }
    };
    GetExternalVendorForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetExternalVendorForViewDto();
        result.init(data);
        return result;
    };
    GetExternalVendorForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["externalVendor"] = this.externalVendor ? this.externalVendor.toJSON() : undefined;
        data["clientGroupName"] = this.clientGroupName;
        return data;
    };
    return GetExternalVendorForViewDto;
}());
export { GetExternalVendorForViewDto };
var PagedResultDtoOfGetExternalVendorForViewDto = /** @class */ (function () {
    function PagedResultDtoOfGetExternalVendorForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfGetExternalVendorForViewDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(GetExternalVendorForViewDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfGetExternalVendorForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfGetExternalVendorForViewDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfGetExternalVendorForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfGetExternalVendorForViewDto;
}());
export { PagedResultDtoOfGetExternalVendorForViewDto };
var CreateOrEditExternalVendorDto = /** @class */ (function () {
    function CreateOrEditExternalVendorDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateOrEditExternalVendorDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.d365Entity = data["d365Entity"];
            this.clientGroupId = data["clientGroupId"];
            this.id = data["id"];
        }
    };
    CreateOrEditExternalVendorDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrEditExternalVendorDto();
        result.init(data);
        return result;
    };
    CreateOrEditExternalVendorDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["d365Entity"] = this.d365Entity;
        data["clientGroupId"] = this.clientGroupId;
        data["id"] = this.id;
        return data;
    };
    return CreateOrEditExternalVendorDto;
}());
export { CreateOrEditExternalVendorDto };
var GetExternalVendorForEditOutput = /** @class */ (function () {
    function GetExternalVendorForEditOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetExternalVendorForEditOutput.prototype.init = function (data) {
        if (data) {
            this.externalVendor = data["externalVendor"] ? CreateOrEditExternalVendorDto.fromJS(data["externalVendor"]) : undefined;
            this.clientGroupName = data["clientGroupName"];
        }
    };
    GetExternalVendorForEditOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetExternalVendorForEditOutput();
        result.init(data);
        return result;
    };
    GetExternalVendorForEditOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["externalVendor"] = this.externalVendor ? this.externalVendor.toJSON() : undefined;
        data["clientGroupName"] = this.clientGroupName;
        return data;
    };
    return GetExternalVendorForEditOutput;
}());
export { GetExternalVendorForEditOutput };
var ExternalVendorClientGroupLookupTableDto = /** @class */ (function () {
    function ExternalVendorClientGroupLookupTableDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ExternalVendorClientGroupLookupTableDto.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    };
    ExternalVendorClientGroupLookupTableDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ExternalVendorClientGroupLookupTableDto();
        result.init(data);
        return result;
    };
    ExternalVendorClientGroupLookupTableDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    };
    return ExternalVendorClientGroupLookupTableDto;
}());
export { ExternalVendorClientGroupLookupTableDto };
var PackageFinanceInfo = /** @class */ (function () {
    function PackageFinanceInfo(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PackageFinanceInfo.prototype.init = function (data) {
        if (data) {
            this.barcode = data["barcode"];
            this.chargeClient = data["chargeClient"];
            this.payDriver = data["payDriver"];
            this.isChargeInvoiced = data["isChargeInvoiced"];
            this.isCostInvoiced = data["isCostInvoiced"];
        }
    };
    PackageFinanceInfo.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PackageFinanceInfo();
        result.init(data);
        return result;
    };
    PackageFinanceInfo.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["barcode"] = this.barcode;
        data["chargeClient"] = this.chargeClient;
        data["payDriver"] = this.payDriver;
        data["isChargeInvoiced"] = this.isChargeInvoiced;
        data["isCostInvoiced"] = this.isCostInvoiced;
        return data;
    };
    return PackageFinanceInfo;
}());
export { PackageFinanceInfo };
var GetFinanceInfoDto = /** @class */ (function () {
    function GetFinanceInfoDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetFinanceInfoDto.prototype.init = function (data) {
        if (data) {
            if (Array.isArray(data["packageFinanceInfos"])) {
                this.packageFinanceInfos = [];
                for (var _i = 0, _a = data["packageFinanceInfos"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.packageFinanceInfos.push(PackageFinanceInfo.fromJS(item));
                }
            }
            this.systemUnavailable = data["systemUnavailable"];
        }
    };
    GetFinanceInfoDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetFinanceInfoDto();
        result.init(data);
        return result;
    };
    GetFinanceInfoDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.packageFinanceInfos)) {
            data["packageFinanceInfos"] = [];
            for (var _i = 0, _a = this.packageFinanceInfos; _i < _a.length; _i++) {
                var item = _a[_i];
                data["packageFinanceInfos"].push(item.toJSON());
            }
        }
        data["systemUnavailable"] = this.systemUnavailable;
        return data;
    };
    return GetFinanceInfoDto;
}());
export { GetFinanceInfoDto };
var UpdateFinanceInfoDto = /** @class */ (function () {
    function UpdateFinanceInfoDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateFinanceInfoDto.prototype.init = function (data) {
        if (data) {
            this.packageId = data["packageId"];
            this.chargeClient = data["chargeClient"];
            this.payDriver = data["payDriver"];
        }
    };
    UpdateFinanceInfoDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateFinanceInfoDto();
        result.init(data);
        return result;
    };
    UpdateFinanceInfoDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["packageId"] = this.packageId;
        data["chargeClient"] = this.chargeClient;
        data["payDriver"] = this.payDriver;
        return data;
    };
    return UpdateFinanceInfoDto;
}());
export { UpdateFinanceInfoDto };
var CreateFriendshipRequestInput = /** @class */ (function () {
    function CreateFriendshipRequestInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateFriendshipRequestInput.prototype.init = function (data) {
        if (data) {
            this.userId = data["userId"];
            this.tenantId = data["tenantId"];
        }
    };
    CreateFriendshipRequestInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateFriendshipRequestInput();
        result.init(data);
        return result;
    };
    CreateFriendshipRequestInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data;
    };
    return CreateFriendshipRequestInput;
}());
export { CreateFriendshipRequestInput };
var CreateFriendshipRequestByUserNameInput = /** @class */ (function () {
    function CreateFriendshipRequestByUserNameInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateFriendshipRequestByUserNameInput.prototype.init = function (data) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.userName = data["userName"];
        }
    };
    CreateFriendshipRequestByUserNameInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateFriendshipRequestByUserNameInput();
        result.init(data);
        return result;
    };
    CreateFriendshipRequestByUserNameInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["userName"] = this.userName;
        return data;
    };
    return CreateFriendshipRequestByUserNameInput;
}());
export { CreateFriendshipRequestByUserNameInput };
var BlockUserInput = /** @class */ (function () {
    function BlockUserInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BlockUserInput.prototype.init = function (data) {
        if (data) {
            this.userId = data["userId"];
            this.tenantId = data["tenantId"];
        }
    };
    BlockUserInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BlockUserInput();
        result.init(data);
        return result;
    };
    BlockUserInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data;
    };
    return BlockUserInput;
}());
export { BlockUserInput };
var UnblockUserInput = /** @class */ (function () {
    function UnblockUserInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UnblockUserInput.prototype.init = function (data) {
        if (data) {
            this.userId = data["userId"];
            this.tenantId = data["tenantId"];
        }
    };
    UnblockUserInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UnblockUserInput();
        result.init(data);
        return result;
    };
    UnblockUserInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data;
    };
    return UnblockUserInput;
}());
export { UnblockUserInput };
var AcceptFriendshipRequestInput = /** @class */ (function () {
    function AcceptFriendshipRequestInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AcceptFriendshipRequestInput.prototype.init = function (data) {
        if (data) {
            this.userId = data["userId"];
            this.tenantId = data["tenantId"];
        }
    };
    AcceptFriendshipRequestInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AcceptFriendshipRequestInput();
        result.init(data);
        return result;
    };
    AcceptFriendshipRequestInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data;
    };
    return AcceptFriendshipRequestInput;
}());
export { AcceptFriendshipRequestInput };
var TopStatsData = /** @class */ (function () {
    function TopStatsData(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TopStatsData.prototype.init = function (data) {
        if (data) {
            this.newTenantsCount = data["newTenantsCount"];
            this.newSubscriptionAmount = data["newSubscriptionAmount"];
            this.dashboardPlaceholder1 = data["dashboardPlaceholder1"];
            this.dashboardPlaceholder2 = data["dashboardPlaceholder2"];
        }
    };
    TopStatsData.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TopStatsData();
        result.init(data);
        return result;
    };
    TopStatsData.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["newTenantsCount"] = this.newTenantsCount;
        data["newSubscriptionAmount"] = this.newSubscriptionAmount;
        data["dashboardPlaceholder1"] = this.dashboardPlaceholder1;
        data["dashboardPlaceholder2"] = this.dashboardPlaceholder2;
        return data;
    };
    return TopStatsData;
}());
export { TopStatsData };
var GetRecentTenantsOutput = /** @class */ (function () {
    function GetRecentTenantsOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetRecentTenantsOutput.prototype.init = function (data) {
        if (data) {
            this.recentTenantsDayCount = data["recentTenantsDayCount"];
            this.maxRecentTenantsShownCount = data["maxRecentTenantsShownCount"];
            this.tenantCreationStartDate = data["tenantCreationStartDate"] ? moment(data["tenantCreationStartDate"].toString()) : undefined;
        }
    };
    GetRecentTenantsOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetRecentTenantsOutput();
        result.init(data);
        return result;
    };
    GetRecentTenantsOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["recentTenantsDayCount"] = this.recentTenantsDayCount;
        data["maxRecentTenantsShownCount"] = this.maxRecentTenantsShownCount;
        data["tenantCreationStartDate"] = this.tenantCreationStartDate ? this.tenantCreationStartDate.toISOString() : undefined;
        return data;
    };
    return GetRecentTenantsOutput;
}());
export { GetRecentTenantsOutput };
var ExpiringTenant = /** @class */ (function () {
    function ExpiringTenant(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ExpiringTenant.prototype.init = function (data) {
        if (data) {
            this.tenantName = data["tenantName"];
            this.remainingDayCount = data["remainingDayCount"];
        }
    };
    ExpiringTenant.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ExpiringTenant();
        result.init(data);
        return result;
    };
    ExpiringTenant.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenantName"] = this.tenantName;
        data["remainingDayCount"] = this.remainingDayCount;
        return data;
    };
    return ExpiringTenant;
}());
export { ExpiringTenant };
var GetExpiringTenantsOutput = /** @class */ (function () {
    function GetExpiringTenantsOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetExpiringTenantsOutput.prototype.init = function (data) {
        if (data) {
            if (Array.isArray(data["expiringTenants"])) {
                this.expiringTenants = [];
                for (var _i = 0, _a = data["expiringTenants"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.expiringTenants.push(ExpiringTenant.fromJS(item));
                }
            }
            this.subscriptionEndAlertDayCount = data["subscriptionEndAlertDayCount"];
            this.maxExpiringTenantsShownCount = data["maxExpiringTenantsShownCount"];
            this.subscriptionEndDateStart = data["subscriptionEndDateStart"] ? moment(data["subscriptionEndDateStart"].toString()) : undefined;
            this.subscriptionEndDateEnd = data["subscriptionEndDateEnd"] ? moment(data["subscriptionEndDateEnd"].toString()) : undefined;
        }
    };
    GetExpiringTenantsOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetExpiringTenantsOutput();
        result.init(data);
        return result;
    };
    GetExpiringTenantsOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.expiringTenants)) {
            data["expiringTenants"] = [];
            for (var _i = 0, _a = this.expiringTenants; _i < _a.length; _i++) {
                var item = _a[_i];
                data["expiringTenants"].push(item.toJSON());
            }
        }
        data["subscriptionEndAlertDayCount"] = this.subscriptionEndAlertDayCount;
        data["maxExpiringTenantsShownCount"] = this.maxExpiringTenantsShownCount;
        data["subscriptionEndDateStart"] = this.subscriptionEndDateStart ? this.subscriptionEndDateStart.toISOString() : undefined;
        data["subscriptionEndDateEnd"] = this.subscriptionEndDateEnd ? this.subscriptionEndDateEnd.toISOString() : undefined;
        return data;
    };
    return GetExpiringTenantsOutput;
}());
export { GetExpiringTenantsOutput };
export var ChartDateInterval;
(function (ChartDateInterval) {
    ChartDateInterval[ChartDateInterval["Daily"] = 1] = "Daily";
    ChartDateInterval[ChartDateInterval["Weekly"] = 2] = "Weekly";
    ChartDateInterval[ChartDateInterval["Monthly"] = 3] = "Monthly";
})(ChartDateInterval || (ChartDateInterval = {}));
var IncomeStastistic = /** @class */ (function () {
    function IncomeStastistic(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    IncomeStastistic.prototype.init = function (data) {
        if (data) {
            this.label = data["label"];
            this.date = data["date"] ? moment(data["date"].toString()) : undefined;
            this.amount = data["amount"];
        }
    };
    IncomeStastistic.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new IncomeStastistic();
        result.init(data);
        return result;
    };
    IncomeStastistic.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["date"] = this.date ? this.date.toISOString() : undefined;
        data["amount"] = this.amount;
        return data;
    };
    return IncomeStastistic;
}());
export { IncomeStastistic };
var GetIncomeStatisticsDataOutput = /** @class */ (function () {
    function GetIncomeStatisticsDataOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetIncomeStatisticsDataOutput.prototype.init = function (data) {
        if (data) {
            if (Array.isArray(data["incomeStatistics"])) {
                this.incomeStatistics = [];
                for (var _i = 0, _a = data["incomeStatistics"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.incomeStatistics.push(IncomeStastistic.fromJS(item));
                }
            }
        }
    };
    GetIncomeStatisticsDataOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetIncomeStatisticsDataOutput();
        result.init(data);
        return result;
    };
    GetIncomeStatisticsDataOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.incomeStatistics)) {
            data["incomeStatistics"] = [];
            for (var _i = 0, _a = this.incomeStatistics; _i < _a.length; _i++) {
                var item = _a[_i];
                data["incomeStatistics"].push(item.toJSON());
            }
        }
        return data;
    };
    return GetIncomeStatisticsDataOutput;
}());
export { GetIncomeStatisticsDataOutput };
var TenantEdition = /** @class */ (function () {
    function TenantEdition(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TenantEdition.prototype.init = function (data) {
        if (data) {
            this.label = data["label"];
            this.value = data["value"];
        }
    };
    TenantEdition.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TenantEdition();
        result.init(data);
        return result;
    };
    TenantEdition.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["value"] = this.value;
        return data;
    };
    return TenantEdition;
}());
export { TenantEdition };
var GetEditionTenantStatisticsOutput = /** @class */ (function () {
    function GetEditionTenantStatisticsOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetEditionTenantStatisticsOutput.prototype.init = function (data) {
        if (data) {
            if (Array.isArray(data["editionStatistics"])) {
                this.editionStatistics = [];
                for (var _i = 0, _a = data["editionStatistics"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.editionStatistics.push(TenantEdition.fromJS(item));
                }
            }
        }
    };
    GetEditionTenantStatisticsOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetEditionTenantStatisticsOutput();
        result.init(data);
        return result;
    };
    GetEditionTenantStatisticsOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.editionStatistics)) {
            data["editionStatistics"] = [];
            for (var _i = 0, _a = this.editionStatistics; _i < _a.length; _i++) {
                var item = _a[_i];
                data["editionStatistics"].push(item.toJSON());
            }
        }
        return data;
    };
    return GetEditionTenantStatisticsOutput;
}());
export { GetEditionTenantStatisticsOutput };
var GeneralSettingsEditDto = /** @class */ (function () {
    function GeneralSettingsEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GeneralSettingsEditDto.prototype.init = function (data) {
        if (data) {
            this.timezone = data["timezone"];
            this.timezoneForComparison = data["timezoneForComparison"];
        }
    };
    GeneralSettingsEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GeneralSettingsEditDto();
        result.init(data);
        return result;
    };
    GeneralSettingsEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["timezone"] = this.timezone;
        data["timezoneForComparison"] = this.timezoneForComparison;
        return data;
    };
    return GeneralSettingsEditDto;
}());
export { GeneralSettingsEditDto };
var SessionTimeOutSettingsEditDto = /** @class */ (function () {
    function SessionTimeOutSettingsEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SessionTimeOutSettingsEditDto.prototype.init = function (data) {
        if (data) {
            this.isEnabled = data["isEnabled"];
            this.timeOutSecond = data["timeOutSecond"];
            this.showTimeOutNotificationSecond = data["showTimeOutNotificationSecond"];
            this.showLockScreenWhenTimedOut = data["showLockScreenWhenTimedOut"];
        }
    };
    SessionTimeOutSettingsEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SessionTimeOutSettingsEditDto();
        result.init(data);
        return result;
    };
    SessionTimeOutSettingsEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["isEnabled"] = this.isEnabled;
        data["timeOutSecond"] = this.timeOutSecond;
        data["showTimeOutNotificationSecond"] = this.showTimeOutNotificationSecond;
        data["showLockScreenWhenTimedOut"] = this.showLockScreenWhenTimedOut;
        return data;
    };
    return SessionTimeOutSettingsEditDto;
}());
export { SessionTimeOutSettingsEditDto };
var HostUserManagementSettingsEditDto = /** @class */ (function () {
    function HostUserManagementSettingsEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    HostUserManagementSettingsEditDto.prototype.init = function (data) {
        if (data) {
            this.isEmailConfirmationRequiredForLogin = data["isEmailConfirmationRequiredForLogin"];
            this.smsVerificationEnabled = data["smsVerificationEnabled"];
            this.isCookieConsentEnabled = data["isCookieConsentEnabled"];
            this.isQuickThemeSelectEnabled = data["isQuickThemeSelectEnabled"];
            this.isChatEnabled = data["isChatEnabled"];
            this.useCaptchaOnLogin = data["useCaptchaOnLogin"];
            this.sessionTimeOutSettings = data["sessionTimeOutSettings"] ? SessionTimeOutSettingsEditDto.fromJS(data["sessionTimeOutSettings"]) : undefined;
        }
    };
    HostUserManagementSettingsEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new HostUserManagementSettingsEditDto();
        result.init(data);
        return result;
    };
    HostUserManagementSettingsEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["isEmailConfirmationRequiredForLogin"] = this.isEmailConfirmationRequiredForLogin;
        data["smsVerificationEnabled"] = this.smsVerificationEnabled;
        data["isCookieConsentEnabled"] = this.isCookieConsentEnabled;
        data["isQuickThemeSelectEnabled"] = this.isQuickThemeSelectEnabled;
        data["isChatEnabled"] = this.isChatEnabled;
        data["useCaptchaOnLogin"] = this.useCaptchaOnLogin;
        data["sessionTimeOutSettings"] = this.sessionTimeOutSettings ? this.sessionTimeOutSettings.toJSON() : undefined;
        return data;
    };
    return HostUserManagementSettingsEditDto;
}());
export { HostUserManagementSettingsEditDto };
var EmailSettingsEditDto = /** @class */ (function () {
    function EmailSettingsEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EmailSettingsEditDto.prototype.init = function (data) {
        if (data) {
            this.defaultFromAddress = data["defaultFromAddress"];
            this.defaultFromDisplayName = data["defaultFromDisplayName"];
            this.smtpHost = data["smtpHost"];
            this.smtpPort = data["smtpPort"];
            this.smtpUserName = data["smtpUserName"];
            this.smtpPassword = data["smtpPassword"];
            this.smtpDomain = data["smtpDomain"];
            this.smtpEnableSsl = data["smtpEnableSsl"];
            this.smtpUseDefaultCredentials = data["smtpUseDefaultCredentials"];
        }
    };
    EmailSettingsEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new EmailSettingsEditDto();
        result.init(data);
        return result;
    };
    EmailSettingsEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["defaultFromAddress"] = this.defaultFromAddress;
        data["defaultFromDisplayName"] = this.defaultFromDisplayName;
        data["smtpHost"] = this.smtpHost;
        data["smtpPort"] = this.smtpPort;
        data["smtpUserName"] = this.smtpUserName;
        data["smtpPassword"] = this.smtpPassword;
        data["smtpDomain"] = this.smtpDomain;
        data["smtpEnableSsl"] = this.smtpEnableSsl;
        data["smtpUseDefaultCredentials"] = this.smtpUseDefaultCredentials;
        return data;
    };
    return EmailSettingsEditDto;
}());
export { EmailSettingsEditDto };
var TenantManagementSettingsEditDto = /** @class */ (function () {
    function TenantManagementSettingsEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TenantManagementSettingsEditDto.prototype.init = function (data) {
        if (data) {
            this.allowSelfRegistration = data["allowSelfRegistration"];
            this.isNewRegisteredTenantActiveByDefault = data["isNewRegisteredTenantActiveByDefault"];
            this.useCaptchaOnRegistration = data["useCaptchaOnRegistration"];
            this.defaultEditionId = data["defaultEditionId"];
        }
    };
    TenantManagementSettingsEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TenantManagementSettingsEditDto();
        result.init(data);
        return result;
    };
    TenantManagementSettingsEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["allowSelfRegistration"] = this.allowSelfRegistration;
        data["isNewRegisteredTenantActiveByDefault"] = this.isNewRegisteredTenantActiveByDefault;
        data["useCaptchaOnRegistration"] = this.useCaptchaOnRegistration;
        data["defaultEditionId"] = this.defaultEditionId;
        return data;
    };
    return TenantManagementSettingsEditDto;
}());
export { TenantManagementSettingsEditDto };
var PasswordComplexitySetting = /** @class */ (function () {
    function PasswordComplexitySetting(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PasswordComplexitySetting.prototype.init = function (data) {
        if (data) {
            this.requireDigit = data["requireDigit"];
            this.requireLowercase = data["requireLowercase"];
            this.requireNonAlphanumeric = data["requireNonAlphanumeric"];
            this.requireUppercase = data["requireUppercase"];
            this.requiredLength = data["requiredLength"];
        }
    };
    PasswordComplexitySetting.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PasswordComplexitySetting();
        result.init(data);
        return result;
    };
    PasswordComplexitySetting.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["requireDigit"] = this.requireDigit;
        data["requireLowercase"] = this.requireLowercase;
        data["requireNonAlphanumeric"] = this.requireNonAlphanumeric;
        data["requireUppercase"] = this.requireUppercase;
        data["requiredLength"] = this.requiredLength;
        return data;
    };
    return PasswordComplexitySetting;
}());
export { PasswordComplexitySetting };
var UserLockOutSettingsEditDto = /** @class */ (function () {
    function UserLockOutSettingsEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UserLockOutSettingsEditDto.prototype.init = function (data) {
        if (data) {
            this.isEnabled = data["isEnabled"];
            this.maxFailedAccessAttemptsBeforeLockout = data["maxFailedAccessAttemptsBeforeLockout"];
            this.defaultAccountLockoutSeconds = data["defaultAccountLockoutSeconds"];
        }
    };
    UserLockOutSettingsEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UserLockOutSettingsEditDto();
        result.init(data);
        return result;
    };
    UserLockOutSettingsEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["isEnabled"] = this.isEnabled;
        data["maxFailedAccessAttemptsBeforeLockout"] = this.maxFailedAccessAttemptsBeforeLockout;
        data["defaultAccountLockoutSeconds"] = this.defaultAccountLockoutSeconds;
        return data;
    };
    return UserLockOutSettingsEditDto;
}());
export { UserLockOutSettingsEditDto };
var TwoFactorLoginSettingsEditDto = /** @class */ (function () {
    function TwoFactorLoginSettingsEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TwoFactorLoginSettingsEditDto.prototype.init = function (data) {
        if (data) {
            this.isEnabledForApplication = data["isEnabledForApplication"];
            this.isEnabled = data["isEnabled"];
            this.isEmailProviderEnabled = data["isEmailProviderEnabled"];
            this.isSmsProviderEnabled = data["isSmsProviderEnabled"];
            this.isRememberBrowserEnabled = data["isRememberBrowserEnabled"];
            this.isGoogleAuthenticatorEnabled = data["isGoogleAuthenticatorEnabled"];
        }
    };
    TwoFactorLoginSettingsEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TwoFactorLoginSettingsEditDto();
        result.init(data);
        return result;
    };
    TwoFactorLoginSettingsEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["isEnabledForApplication"] = this.isEnabledForApplication;
        data["isEnabled"] = this.isEnabled;
        data["isEmailProviderEnabled"] = this.isEmailProviderEnabled;
        data["isSmsProviderEnabled"] = this.isSmsProviderEnabled;
        data["isRememberBrowserEnabled"] = this.isRememberBrowserEnabled;
        data["isGoogleAuthenticatorEnabled"] = this.isGoogleAuthenticatorEnabled;
        return data;
    };
    return TwoFactorLoginSettingsEditDto;
}());
export { TwoFactorLoginSettingsEditDto };
var SecuritySettingsEditDto = /** @class */ (function () {
    function SecuritySettingsEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SecuritySettingsEditDto.prototype.init = function (data) {
        if (data) {
            this.allowOneConcurrentLoginPerUser = data["allowOneConcurrentLoginPerUser"];
            this.useDefaultPasswordComplexitySettings = data["useDefaultPasswordComplexitySettings"];
            this.passwordComplexity = data["passwordComplexity"] ? PasswordComplexitySetting.fromJS(data["passwordComplexity"]) : undefined;
            this.defaultPasswordComplexity = data["defaultPasswordComplexity"] ? PasswordComplexitySetting.fromJS(data["defaultPasswordComplexity"]) : undefined;
            this.userLockOut = data["userLockOut"] ? UserLockOutSettingsEditDto.fromJS(data["userLockOut"]) : undefined;
            this.twoFactorLogin = data["twoFactorLogin"] ? TwoFactorLoginSettingsEditDto.fromJS(data["twoFactorLogin"]) : undefined;
        }
    };
    SecuritySettingsEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SecuritySettingsEditDto();
        result.init(data);
        return result;
    };
    SecuritySettingsEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["allowOneConcurrentLoginPerUser"] = this.allowOneConcurrentLoginPerUser;
        data["useDefaultPasswordComplexitySettings"] = this.useDefaultPasswordComplexitySettings;
        data["passwordComplexity"] = this.passwordComplexity ? this.passwordComplexity.toJSON() : undefined;
        data["defaultPasswordComplexity"] = this.defaultPasswordComplexity ? this.defaultPasswordComplexity.toJSON() : undefined;
        data["userLockOut"] = this.userLockOut ? this.userLockOut.toJSON() : undefined;
        data["twoFactorLogin"] = this.twoFactorLogin ? this.twoFactorLogin.toJSON() : undefined;
        return data;
    };
    return SecuritySettingsEditDto;
}());
export { SecuritySettingsEditDto };
var HostBillingSettingsEditDto = /** @class */ (function () {
    function HostBillingSettingsEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    HostBillingSettingsEditDto.prototype.init = function (data) {
        if (data) {
            this.legalName = data["legalName"];
            this.address = data["address"];
        }
    };
    HostBillingSettingsEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new HostBillingSettingsEditDto();
        result.init(data);
        return result;
    };
    HostBillingSettingsEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["legalName"] = this.legalName;
        data["address"] = this.address;
        return data;
    };
    return HostBillingSettingsEditDto;
}());
export { HostBillingSettingsEditDto };
var OtherSettingsEditDto = /** @class */ (function () {
    function OtherSettingsEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OtherSettingsEditDto.prototype.init = function (data) {
        if (data) {
            this.isQuickThemeSelectEnabled = data["isQuickThemeSelectEnabled"];
        }
    };
    OtherSettingsEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OtherSettingsEditDto();
        result.init(data);
        return result;
    };
    OtherSettingsEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["isQuickThemeSelectEnabled"] = this.isQuickThemeSelectEnabled;
        return data;
    };
    return OtherSettingsEditDto;
}());
export { OtherSettingsEditDto };
export var AllowedCharacters;
(function (AllowedCharacters) {
    AllowedCharacters[AllowedCharacters["Numeric"] = 0] = "Numeric";
    AllowedCharacters[AllowedCharacters["Alphanumeric"] = 1] = "Alphanumeric";
})(AllowedCharacters || (AllowedCharacters = {}));
var ConnoteNumberSettingsEditDto = /** @class */ (function () {
    function ConnoteNumberSettingsEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ConnoteNumberSettingsEditDto.prototype.init = function (data) {
        if (data) {
            this.addBrandPrefix = data["addBrandPrefix"];
            this.suffixSeparator = data["suffixSeparator"];
            this.length = data["length"];
            this.allowedCharacters = data["allowedCharacters"];
        }
    };
    ConnoteNumberSettingsEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ConnoteNumberSettingsEditDto();
        result.init(data);
        return result;
    };
    ConnoteNumberSettingsEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["addBrandPrefix"] = this.addBrandPrefix;
        data["suffixSeparator"] = this.suffixSeparator;
        data["length"] = this.length;
        data["allowedCharacters"] = this.allowedCharacters;
        return data;
    };
    return ConnoteNumberSettingsEditDto;
}());
export { ConnoteNumberSettingsEditDto };
var HostSettingsEditDto = /** @class */ (function () {
    function HostSettingsEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.general = new GeneralSettingsEditDto();
            this.userManagement = new HostUserManagementSettingsEditDto();
            this.email = new EmailSettingsEditDto();
            this.tenantManagement = new TenantManagementSettingsEditDto();
            this.security = new SecuritySettingsEditDto();
        }
    }
    HostSettingsEditDto.prototype.init = function (data) {
        if (data) {
            this.general = data["general"] ? GeneralSettingsEditDto.fromJS(data["general"]) : new GeneralSettingsEditDto();
            this.userManagement = data["userManagement"] ? HostUserManagementSettingsEditDto.fromJS(data["userManagement"]) : new HostUserManagementSettingsEditDto();
            this.email = data["email"] ? EmailSettingsEditDto.fromJS(data["email"]) : new EmailSettingsEditDto();
            this.tenantManagement = data["tenantManagement"] ? TenantManagementSettingsEditDto.fromJS(data["tenantManagement"]) : new TenantManagementSettingsEditDto();
            this.security = data["security"] ? SecuritySettingsEditDto.fromJS(data["security"]) : new SecuritySettingsEditDto();
            this.billing = data["billing"] ? HostBillingSettingsEditDto.fromJS(data["billing"]) : undefined;
            this.otherSettings = data["otherSettings"] ? OtherSettingsEditDto.fromJS(data["otherSettings"]) : undefined;
            this.connoteNumberSettings = data["connoteNumberSettings"] ? ConnoteNumberSettingsEditDto.fromJS(data["connoteNumberSettings"]) : undefined;
        }
    };
    HostSettingsEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new HostSettingsEditDto();
        result.init(data);
        return result;
    };
    HostSettingsEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["general"] = this.general ? this.general.toJSON() : undefined;
        data["userManagement"] = this.userManagement ? this.userManagement.toJSON() : undefined;
        data["email"] = this.email ? this.email.toJSON() : undefined;
        data["tenantManagement"] = this.tenantManagement ? this.tenantManagement.toJSON() : undefined;
        data["security"] = this.security ? this.security.toJSON() : undefined;
        data["billing"] = this.billing ? this.billing.toJSON() : undefined;
        data["otherSettings"] = this.otherSettings ? this.otherSettings.toJSON() : undefined;
        data["connoteNumberSettings"] = this.connoteNumberSettings ? this.connoteNumberSettings.toJSON() : undefined;
        return data;
    };
    return HostSettingsEditDto;
}());
export { HostSettingsEditDto };
var SendTestEmailInput = /** @class */ (function () {
    function SendTestEmailInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SendTestEmailInput.prototype.init = function (data) {
        if (data) {
            this.emailAddress = data["emailAddress"];
        }
    };
    SendTestEmailInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SendTestEmailInput();
        result.init(data);
        return result;
    };
    SendTestEmailInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data;
    };
    return SendTestEmailInput;
}());
export { SendTestEmailInput };
var InstallDto = /** @class */ (function () {
    function InstallDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    InstallDto.prototype.init = function (data) {
        if (data) {
            this.connectionString = data["connectionString"];
            this.adminPassword = data["adminPassword"];
            this.webSiteUrl = data["webSiteUrl"];
            this.serverUrl = data["serverUrl"];
            this.defaultLanguage = data["defaultLanguage"];
            this.smtpSettings = data["smtpSettings"] ? EmailSettingsEditDto.fromJS(data["smtpSettings"]) : undefined;
            this.billInfo = data["billInfo"] ? HostBillingSettingsEditDto.fromJS(data["billInfo"]) : undefined;
        }
    };
    InstallDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new InstallDto();
        result.init(data);
        return result;
    };
    InstallDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["connectionString"] = this.connectionString;
        data["adminPassword"] = this.adminPassword;
        data["webSiteUrl"] = this.webSiteUrl;
        data["serverUrl"] = this.serverUrl;
        data["defaultLanguage"] = this.defaultLanguage;
        data["smtpSettings"] = this.smtpSettings ? this.smtpSettings.toJSON() : undefined;
        data["billInfo"] = this.billInfo ? this.billInfo.toJSON() : undefined;
        return data;
    };
    return InstallDto;
}());
export { InstallDto };
var NameValue = /** @class */ (function () {
    function NameValue(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    NameValue.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.value = data["value"];
        }
    };
    NameValue.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new NameValue();
        result.init(data);
        return result;
    };
    NameValue.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    };
    return NameValue;
}());
export { NameValue };
var AppSettingsJsonDto = /** @class */ (function () {
    function AppSettingsJsonDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AppSettingsJsonDto.prototype.init = function (data) {
        if (data) {
            this.webSiteUrl = data["webSiteUrl"];
            this.serverSiteUrl = data["serverSiteUrl"];
            if (Array.isArray(data["languages"])) {
                this.languages = [];
                for (var _i = 0, _a = data["languages"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.languages.push(NameValue.fromJS(item));
                }
            }
            this.fredPodBlobImageSasUrl = data["fredPodBlobImageSasUrl"];
        }
    };
    AppSettingsJsonDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AppSettingsJsonDto();
        result.init(data);
        return result;
    };
    AppSettingsJsonDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["webSiteUrl"] = this.webSiteUrl;
        data["serverSiteUrl"] = this.serverSiteUrl;
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (var _i = 0, _a = this.languages; _i < _a.length; _i++) {
                var item = _a[_i];
                data["languages"].push(item.toJSON());
            }
        }
        data["fredPodBlobImageSasUrl"] = this.fredPodBlobImageSasUrl;
        return data;
    };
    return AppSettingsJsonDto;
}());
export { AppSettingsJsonDto };
var CheckDatabaseOutput = /** @class */ (function () {
    function CheckDatabaseOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CheckDatabaseOutput.prototype.init = function (data) {
        if (data) {
            this.isDatabaseExist = data["isDatabaseExist"];
        }
    };
    CheckDatabaseOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CheckDatabaseOutput();
        result.init(data);
        return result;
    };
    CheckDatabaseOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["isDatabaseExist"] = this.isDatabaseExist;
        return data;
    };
    return CheckDatabaseOutput;
}());
export { CheckDatabaseOutput };
var InvoiceDto = /** @class */ (function () {
    function InvoiceDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    InvoiceDto.prototype.init = function (data) {
        if (data) {
            this.amount = data["amount"];
            this.editionDisplayName = data["editionDisplayName"];
            this.invoiceNo = data["invoiceNo"];
            this.invoiceDate = data["invoiceDate"] ? moment(data["invoiceDate"].toString()) : undefined;
            this.tenantLegalName = data["tenantLegalName"];
            if (Array.isArray(data["tenantAddress"])) {
                this.tenantAddress = [];
                for (var _i = 0, _a = data["tenantAddress"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.tenantAddress.push(item);
                }
            }
            this.tenantTaxNo = data["tenantTaxNo"];
            this.hostLegalName = data["hostLegalName"];
            if (Array.isArray(data["hostAddress"])) {
                this.hostAddress = [];
                for (var _b = 0, _c = data["hostAddress"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.hostAddress.push(item);
                }
            }
        }
    };
    InvoiceDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new InvoiceDto();
        result.init(data);
        return result;
    };
    InvoiceDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["editionDisplayName"] = this.editionDisplayName;
        data["invoiceNo"] = this.invoiceNo;
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : undefined;
        data["tenantLegalName"] = this.tenantLegalName;
        if (Array.isArray(this.tenantAddress)) {
            data["tenantAddress"] = [];
            for (var _i = 0, _a = this.tenantAddress; _i < _a.length; _i++) {
                var item = _a[_i];
                data["tenantAddress"].push(item);
            }
        }
        data["tenantTaxNo"] = this.tenantTaxNo;
        data["hostLegalName"] = this.hostLegalName;
        if (Array.isArray(this.hostAddress)) {
            data["hostAddress"] = [];
            for (var _b = 0, _c = this.hostAddress; _b < _c.length; _b++) {
                var item = _c[_b];
                data["hostAddress"].push(item);
            }
        }
        return data;
    };
    return InvoiceDto;
}());
export { InvoiceDto };
var CreateInvoiceDto = /** @class */ (function () {
    function CreateInvoiceDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateInvoiceDto.prototype.init = function (data) {
        if (data) {
            this.subscriptionPaymentId = data["subscriptionPaymentId"];
        }
    };
    CreateInvoiceDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateInvoiceDto();
        result.init(data);
        return result;
    };
    CreateInvoiceDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionPaymentId"] = this.subscriptionPaymentId;
        return data;
    };
    return CreateInvoiceDto;
}());
export { CreateInvoiceDto };
var ApplicationLanguageListDto = /** @class */ (function () {
    function ApplicationLanguageListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ApplicationLanguageListDto.prototype.init = function (data) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.icon = data["icon"];
            this.isDisabled = data["isDisabled"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    };
    ApplicationLanguageListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ApplicationLanguageListDto();
        result.init(data);
        return result;
    };
    ApplicationLanguageListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["icon"] = this.icon;
        data["isDisabled"] = this.isDisabled;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    return ApplicationLanguageListDto;
}());
export { ApplicationLanguageListDto };
var GetLanguagesOutput = /** @class */ (function () {
    function GetLanguagesOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetLanguagesOutput.prototype.init = function (data) {
        if (data) {
            this.defaultLanguageName = data["defaultLanguageName"];
            if (Array.isArray(data["items"])) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(ApplicationLanguageListDto.fromJS(item));
                }
            }
        }
    };
    GetLanguagesOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetLanguagesOutput();
        result.init(data);
        return result;
    };
    GetLanguagesOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["defaultLanguageName"] = this.defaultLanguageName;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return GetLanguagesOutput;
}());
export { GetLanguagesOutput };
var ApplicationLanguageEditDto = /** @class */ (function () {
    function ApplicationLanguageEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ApplicationLanguageEditDto.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.icon = data["icon"];
            this.isEnabled = data["isEnabled"];
        }
    };
    ApplicationLanguageEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ApplicationLanguageEditDto();
        result.init(data);
        return result;
    };
    ApplicationLanguageEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["icon"] = this.icon;
        data["isEnabled"] = this.isEnabled;
        return data;
    };
    return ApplicationLanguageEditDto;
}());
export { ApplicationLanguageEditDto };
var ComboboxItemDto = /** @class */ (function () {
    function ComboboxItemDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ComboboxItemDto.prototype.init = function (data) {
        if (data) {
            this.value = data["value"];
            this.displayText = data["displayText"];
            this.isSelected = data["isSelected"];
        }
    };
    ComboboxItemDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ComboboxItemDto();
        result.init(data);
        return result;
    };
    ComboboxItemDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        data["isSelected"] = this.isSelected;
        return data;
    };
    return ComboboxItemDto;
}());
export { ComboboxItemDto };
var GetLanguageForEditOutput = /** @class */ (function () {
    function GetLanguageForEditOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetLanguageForEditOutput.prototype.init = function (data) {
        if (data) {
            this.language = data["language"] ? ApplicationLanguageEditDto.fromJS(data["language"]) : undefined;
            if (Array.isArray(data["languageNames"])) {
                this.languageNames = [];
                for (var _i = 0, _a = data["languageNames"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.languageNames.push(ComboboxItemDto.fromJS(item));
                }
            }
            if (Array.isArray(data["flags"])) {
                this.flags = [];
                for (var _b = 0, _c = data["flags"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.flags.push(ComboboxItemDto.fromJS(item));
                }
            }
        }
    };
    GetLanguageForEditOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetLanguageForEditOutput();
        result.init(data);
        return result;
    };
    GetLanguageForEditOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language ? this.language.toJSON() : undefined;
        if (Array.isArray(this.languageNames)) {
            data["languageNames"] = [];
            for (var _i = 0, _a = this.languageNames; _i < _a.length; _i++) {
                var item = _a[_i];
                data["languageNames"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.flags)) {
            data["flags"] = [];
            for (var _b = 0, _c = this.flags; _b < _c.length; _b++) {
                var item = _c[_b];
                data["flags"].push(item.toJSON());
            }
        }
        return data;
    };
    return GetLanguageForEditOutput;
}());
export { GetLanguageForEditOutput };
var CreateOrUpdateLanguageInput = /** @class */ (function () {
    function CreateOrUpdateLanguageInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.language = new ApplicationLanguageEditDto();
        }
    }
    CreateOrUpdateLanguageInput.prototype.init = function (data) {
        if (data) {
            this.language = data["language"] ? ApplicationLanguageEditDto.fromJS(data["language"]) : new ApplicationLanguageEditDto();
        }
    };
    CreateOrUpdateLanguageInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrUpdateLanguageInput();
        result.init(data);
        return result;
    };
    CreateOrUpdateLanguageInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language ? this.language.toJSON() : undefined;
        return data;
    };
    return CreateOrUpdateLanguageInput;
}());
export { CreateOrUpdateLanguageInput };
var SetDefaultLanguageInput = /** @class */ (function () {
    function SetDefaultLanguageInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SetDefaultLanguageInput.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
        }
    };
    SetDefaultLanguageInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SetDefaultLanguageInput();
        result.init(data);
        return result;
    };
    SetDefaultLanguageInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    };
    return SetDefaultLanguageInput;
}());
export { SetDefaultLanguageInput };
var LanguageTextListDto = /** @class */ (function () {
    function LanguageTextListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    LanguageTextListDto.prototype.init = function (data) {
        if (data) {
            this.key = data["key"];
            this.baseValue = data["baseValue"];
            this.targetValue = data["targetValue"];
        }
    };
    LanguageTextListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new LanguageTextListDto();
        result.init(data);
        return result;
    };
    LanguageTextListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["baseValue"] = this.baseValue;
        data["targetValue"] = this.targetValue;
        return data;
    };
    return LanguageTextListDto;
}());
export { LanguageTextListDto };
var PagedResultDtoOfLanguageTextListDto = /** @class */ (function () {
    function PagedResultDtoOfLanguageTextListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfLanguageTextListDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(LanguageTextListDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfLanguageTextListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfLanguageTextListDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfLanguageTextListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfLanguageTextListDto;
}());
export { PagedResultDtoOfLanguageTextListDto };
var UpdateLanguageTextInput = /** @class */ (function () {
    function UpdateLanguageTextInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateLanguageTextInput.prototype.init = function (data) {
        if (data) {
            this.languageName = data["languageName"];
            this.sourceName = data["sourceName"];
            this.key = data["key"];
            this.value = data["value"];
        }
    };
    UpdateLanguageTextInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateLanguageTextInput();
        result.init(data);
        return result;
    };
    UpdateLanguageTextInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        data["sourceName"] = this.sourceName;
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    };
    return UpdateLanguageTextInput;
}());
export { UpdateLanguageTextInput };
var GetAllLoadsInput = /** @class */ (function () {
    function GetAllLoadsInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetAllLoadsInput.prototype.init = function (data) {
        if (data) {
            if (Array.isArray(data["idFilter"])) {
                this.idFilter = [];
                for (var _i = 0, _a = data["idFilter"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.idFilter.push(item);
                }
            }
            this.filenameFilter = data["filenameFilter"];
            this.maxWeightFilter = data["maxWeightFilter"];
            this.minWeightFilter = data["minWeightFilter"];
            this.docketFilter = data["docketFilter"];
            this.maxETAFilter = data["maxETAFilter"] ? moment(data["maxETAFilter"].toString()) : undefined;
            this.minETAFilter = data["minETAFilter"] ? moment(data["minETAFilter"].toString()) : undefined;
            if (Array.isArray(data["statusFilter"])) {
                this.statusFilter = [];
                for (var _b = 0, _c = data["statusFilter"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.statusFilter.push(item);
                }
            }
            this.fromFilter = data["fromFilter"];
            this.toDepotFilter = data["toDepotFilter"];
            this.toStoreFilter = data["toStoreFilter"];
            this.ownDepotFilter = data["ownDepotFilter"];
            this.clientCodeFilter = data["clientCodeFilter"];
            this.lineHaulCarrierFilter = data["lineHaulCarrierFilter"];
            this.deliveryCarrierFilter = data["deliveryCarrierFilter"];
            if (Array.isArray(data["typeFilter"])) {
                this.typeFilter = [];
                for (var _d = 0, _e = data["typeFilter"]; _d < _e.length; _d++) {
                    var item = _e[_d];
                    this.typeFilter.push(item);
                }
            }
            if (Array.isArray(data["barcodeFilter"])) {
                this.barcodeFilter = [];
                for (var _f = 0, _g = data["barcodeFilter"]; _f < _g.length; _f++) {
                    var item = _g[_f];
                    this.barcodeFilter.push(item);
                }
            }
            this.maxDepartedTimeFilter = data["maxDepartedTimeFilter"] ? moment(data["maxDepartedTimeFilter"].toString()) : undefined;
            this.minDepartedTimeFilter = data["minDepartedTimeFilter"] ? moment(data["minDepartedTimeFilter"].toString()) : undefined;
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    };
    GetAllLoadsInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetAllLoadsInput();
        result.init(data);
        return result;
    };
    GetAllLoadsInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.idFilter)) {
            data["idFilter"] = [];
            for (var _i = 0, _a = this.idFilter; _i < _a.length; _i++) {
                var item = _a[_i];
                data["idFilter"].push(item);
            }
        }
        data["filenameFilter"] = this.filenameFilter;
        data["maxWeightFilter"] = this.maxWeightFilter;
        data["minWeightFilter"] = this.minWeightFilter;
        data["docketFilter"] = this.docketFilter;
        data["maxETAFilter"] = this.maxETAFilter ? this.maxETAFilter.toISOString() : undefined;
        data["minETAFilter"] = this.minETAFilter ? this.minETAFilter.toISOString() : undefined;
        if (Array.isArray(this.statusFilter)) {
            data["statusFilter"] = [];
            for (var _b = 0, _c = this.statusFilter; _b < _c.length; _b++) {
                var item = _c[_b];
                data["statusFilter"].push(item);
            }
        }
        data["fromFilter"] = this.fromFilter;
        data["toDepotFilter"] = this.toDepotFilter;
        data["toStoreFilter"] = this.toStoreFilter;
        data["ownDepotFilter"] = this.ownDepotFilter;
        data["clientCodeFilter"] = this.clientCodeFilter;
        data["lineHaulCarrierFilter"] = this.lineHaulCarrierFilter;
        data["deliveryCarrierFilter"] = this.deliveryCarrierFilter;
        if (Array.isArray(this.typeFilter)) {
            data["typeFilter"] = [];
            for (var _d = 0, _e = this.typeFilter; _d < _e.length; _d++) {
                var item = _e[_d];
                data["typeFilter"].push(item);
            }
        }
        if (Array.isArray(this.barcodeFilter)) {
            data["barcodeFilter"] = [];
            for (var _f = 0, _g = this.barcodeFilter; _f < _g.length; _f++) {
                var item = _g[_f];
                data["barcodeFilter"].push(item);
            }
        }
        data["maxDepartedTimeFilter"] = this.maxDepartedTimeFilter ? this.maxDepartedTimeFilter.toISOString() : undefined;
        data["minDepartedTimeFilter"] = this.minDepartedTimeFilter ? this.minDepartedTimeFilter.toISOString() : undefined;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    };
    return GetAllLoadsInput;
}());
export { GetAllLoadsInput };
var ExportedDetailDto = /** @class */ (function () {
    function ExportedDetailDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ExportedDetailDto.prototype.init = function (data) {
        if (data) {
            this.carrier = data["carrier"];
            this.job = data["job"];
            this.status = data["status"];
            this.file = data["file"];
            this.at = data["at"] ? moment(data["at"].toString()) : undefined;
        }
    };
    ExportedDetailDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ExportedDetailDto();
        result.init(data);
        return result;
    };
    ExportedDetailDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["carrier"] = this.carrier;
        data["job"] = this.job;
        data["status"] = this.status;
        data["file"] = this.file;
        data["at"] = this.at ? this.at.toISOString() : undefined;
        return data;
    };
    return ExportedDetailDto;
}());
export { ExportedDetailDto };
var ExportedDetailsDto = /** @class */ (function () {
    function ExportedDetailsDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ExportedDetailsDto.prototype.init = function (data) {
        if (data) {
            if (Array.isArray(data["exportedDetail"])) {
                this.exportedDetail = [];
                for (var _i = 0, _a = data["exportedDetail"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.exportedDetail.push(ExportedDetailDto.fromJS(item));
                }
            }
        }
    };
    ExportedDetailsDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ExportedDetailsDto();
        result.init(data);
        return result;
    };
    ExportedDetailsDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.exportedDetail)) {
            data["exportedDetail"] = [];
            for (var _i = 0, _a = this.exportedDetail; _i < _a.length; _i++) {
                var item = _a[_i];
                data["exportedDetail"].push(item.toJSON());
            }
        }
        return data;
    };
    return ExportedDetailsDto;
}());
export { ExportedDetailsDto };
var LoadPackageDto = /** @class */ (function () {
    function LoadPackageDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    LoadPackageDto.prototype.init = function (data) {
        if (data) {
            this.loadId = data["loadId"];
            this.load = data["load"] ? LoadDto.fromJS(data["load"]) : undefined;
            this.packageId = data["packageId"];
            this.package = data["package"] ? PackageDto.fromJS(data["package"]) : undefined;
            this.barcode = data["barcode"];
            this.consingmentStatus = data["consingmentStatus"];
            this.consignmentNumber = data["consignmentNumber"];
        }
    };
    LoadPackageDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new LoadPackageDto();
        result.init(data);
        return result;
    };
    LoadPackageDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["loadId"] = this.loadId;
        data["load"] = this.load ? this.load.toJSON() : undefined;
        data["packageId"] = this.packageId;
        data["package"] = this.package ? this.package.toJSON() : undefined;
        data["barcode"] = this.barcode;
        data["consingmentStatus"] = this.consingmentStatus;
        data["consignmentNumber"] = this.consignmentNumber;
        return data;
    };
    return LoadPackageDto;
}());
export { LoadPackageDto };
var LoadDto = /** @class */ (function () {
    function LoadDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    LoadDto.prototype.init = function (data) {
        if (data) {
            this.weight = data["weight"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.docket = data["docket"];
            this.eta = data["eta"] ? moment(data["eta"].toString()) : undefined;
            this.status = data["status"];
            this.type = data["type"];
            this.carrier = data["carrier"];
            this.deliveryCarrier = data["deliveryCarrier"];
            if (Array.isArray(data["clientCodes"])) {
                this.clientCodes = [];
                for (var _i = 0, _a = data["clientCodes"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.clientCodes.push(item);
                }
            }
            this.from = data["from"];
            this.to = data["to"];
            this.manifestFileId = data["manifestFileId"];
            this.exportedDetails = data["exportedDetails"] ? ExportedDetailsDto.fromJS(data["exportedDetails"]) : undefined;
            this.exportedAt = data["exportedAt"] ? moment(data["exportedAt"].toString()) : undefined;
            if (Array.isArray(data["loadPackages"])) {
                this.loadPackages = [];
                for (var _b = 0, _c = data["loadPackages"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.loadPackages.push(LoadPackageDto.fromJS(item));
                }
            }
            this.isAutoExported = data["isAutoExported"];
            this.departedTime = data["departedTime"] ? moment(data["departedTime"].toString()) : undefined;
            this.palletCount = data["palletCount"];
            this.storeId = data["storeId"];
            this.storeName = data["storeName"];
            this.id = data["id"];
        }
    };
    LoadDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new LoadDto();
        result.init(data);
        return result;
    };
    LoadDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["weight"] = this.weight;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["docket"] = this.docket;
        data["eta"] = this.eta ? this.eta.toISOString() : undefined;
        data["status"] = this.status;
        data["type"] = this.type;
        data["carrier"] = this.carrier;
        data["deliveryCarrier"] = this.deliveryCarrier;
        if (Array.isArray(this.clientCodes)) {
            data["clientCodes"] = [];
            for (var _i = 0, _a = this.clientCodes; _i < _a.length; _i++) {
                var item = _a[_i];
                data["clientCodes"].push(item);
            }
        }
        data["from"] = this.from;
        data["to"] = this.to;
        data["manifestFileId"] = this.manifestFileId;
        data["exportedDetails"] = this.exportedDetails ? this.exportedDetails.toJSON() : undefined;
        data["exportedAt"] = this.exportedAt ? this.exportedAt.toISOString() : undefined;
        if (Array.isArray(this.loadPackages)) {
            data["loadPackages"] = [];
            for (var _b = 0, _c = this.loadPackages; _b < _c.length; _b++) {
                var item = _c[_b];
                data["loadPackages"].push(item.toJSON());
            }
        }
        data["isAutoExported"] = this.isAutoExported;
        data["departedTime"] = this.departedTime ? this.departedTime.toISOString() : undefined;
        data["palletCount"] = this.palletCount;
        data["storeId"] = this.storeId;
        data["storeName"] = this.storeName;
        data["id"] = this.id;
        return data;
    };
    return LoadDto;
}());
export { LoadDto };
var GetLoadForViewDto = /** @class */ (function () {
    function GetLoadForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetLoadForViewDto.prototype.init = function (data) {
        if (data) {
            this.load = data["load"] ? LoadDto.fromJS(data["load"]) : undefined;
            this.manifestFileName = data["manifestFileName"];
            this.userName = data["userName"];
            this.packageCount = data["packageCount"];
            this.consignmentCount = data["consignmentCount"];
        }
    };
    GetLoadForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetLoadForViewDto();
        result.init(data);
        return result;
    };
    GetLoadForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["load"] = this.load ? this.load.toJSON() : undefined;
        data["manifestFileName"] = this.manifestFileName;
        data["userName"] = this.userName;
        data["packageCount"] = this.packageCount;
        data["consignmentCount"] = this.consignmentCount;
        return data;
    };
    return GetLoadForViewDto;
}());
export { GetLoadForViewDto };
var PagedResultDtoOfGetLoadForViewDto = /** @class */ (function () {
    function PagedResultDtoOfGetLoadForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfGetLoadForViewDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(GetLoadForViewDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfGetLoadForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfGetLoadForViewDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfGetLoadForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfGetLoadForViewDto;
}());
export { PagedResultDtoOfGetLoadForViewDto };
export var LoadDestinationOption;
(function (LoadDestinationOption) {
    LoadDestinationOption[LoadDestinationOption["Unknown"] = 0] = "Unknown";
    LoadDestinationOption[LoadDestinationOption["Depot"] = 1] = "Depot";
    LoadDestinationOption[LoadDestinationOption["Store"] = 2] = "Store";
    LoadDestinationOption[LoadDestinationOption["Client"] = 3] = "Client";
})(LoadDestinationOption || (LoadDestinationOption = {}));
var CreateOrEditLoadDto = /** @class */ (function () {
    function CreateOrEditLoadDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateOrEditLoadDto.prototype.init = function (data) {
        if (data) {
            this.docket = data["docket"];
            this.eta = data["eta"] ? moment(data["eta"].toString()) : undefined;
            this.carrier = data["carrier"];
            if (Array.isArray(data["clientCodes"])) {
                this.clientCodes = [];
                for (var _i = 0, _a = data["clientCodes"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.clientCodes.push(item);
                }
            }
            this.manifestFileId = data["manifestFileId"];
            this.from = data["from"];
            this.type = data["type"];
            this.loadDestinationOption = data["loadDestinationOption"];
            this.to = data["to"];
            this.isAutoExported = data["isAutoExported"];
            this.palletCount = data["palletCount"];
            this.status = data["status"];
            this.storeId = data["storeId"];
            this.id = data["id"];
        }
    };
    CreateOrEditLoadDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrEditLoadDto();
        result.init(data);
        return result;
    };
    CreateOrEditLoadDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["docket"] = this.docket;
        data["eta"] = this.eta ? this.eta.toISOString() : undefined;
        data["carrier"] = this.carrier;
        if (Array.isArray(this.clientCodes)) {
            data["clientCodes"] = [];
            for (var _i = 0, _a = this.clientCodes; _i < _a.length; _i++) {
                var item = _a[_i];
                data["clientCodes"].push(item);
            }
        }
        data["manifestFileId"] = this.manifestFileId;
        data["from"] = this.from;
        data["type"] = this.type;
        data["loadDestinationOption"] = this.loadDestinationOption;
        data["to"] = this.to;
        data["isAutoExported"] = this.isAutoExported;
        data["palletCount"] = this.palletCount;
        data["status"] = this.status;
        data["storeId"] = this.storeId;
        data["id"] = this.id;
        return data;
    };
    return CreateOrEditLoadDto;
}());
export { CreateOrEditLoadDto };
var GetLoadForEditOutput = /** @class */ (function () {
    function GetLoadForEditOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetLoadForEditOutput.prototype.init = function (data) {
        if (data) {
            this.load = data["load"] ? CreateOrEditLoadDto.fromJS(data["load"]) : undefined;
            this.toDepotName = data["toDepotName"];
            this.toClientName = data["toClientName"];
            this.toStoreId = data["toStoreId"];
            this.toStoreName = data["toStoreName"];
        }
    };
    GetLoadForEditOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetLoadForEditOutput();
        result.init(data);
        return result;
    };
    GetLoadForEditOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["load"] = this.load ? this.load.toJSON() : undefined;
        data["toDepotName"] = this.toDepotName;
        data["toClientName"] = this.toClientName;
        data["toStoreId"] = this.toStoreId;
        data["toStoreName"] = this.toStoreName;
        return data;
    };
    return GetLoadForEditOutput;
}());
export { GetLoadForEditOutput };
var ValidateLoadsInputDto = /** @class */ (function () {
    function ValidateLoadsInputDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ValidateLoadsInputDto.prototype.init = function (data) {
        if (data) {
            if (Array.isArray(data["missingEventStatus"])) {
                this.missingEventStatus = [];
                for (var _i = 0, _a = data["missingEventStatus"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.missingEventStatus.push(item);
                }
            }
            if (Array.isArray(data["loadIds"])) {
                this.loadIds = [];
                for (var _b = 0, _c = data["loadIds"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.loadIds.push(item);
                }
            }
        }
    };
    ValidateLoadsInputDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ValidateLoadsInputDto();
        result.init(data);
        return result;
    };
    ValidateLoadsInputDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.missingEventStatus)) {
            data["missingEventStatus"] = [];
            for (var _i = 0, _a = this.missingEventStatus; _i < _a.length; _i++) {
                var item = _a[_i];
                data["missingEventStatus"].push(item);
            }
        }
        if (Array.isArray(this.loadIds)) {
            data["loadIds"] = [];
            for (var _b = 0, _c = this.loadIds; _b < _c.length; _b++) {
                var item = _c[_b];
                data["loadIds"].push(item);
            }
        }
        return data;
    };
    return ValidateLoadsInputDto;
}());
export { ValidateLoadsInputDto };
var MissingBarcodeForViewDto = /** @class */ (function () {
    function MissingBarcodeForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MissingBarcodeForViewDto.prototype.init = function (data) {
        if (data) {
            this.barcode = data["barcode"];
            this.consignmentNumber = data["consignmentNumber"];
            this.totalPackages = data["totalPackages"];
            this.sequenceNumber = data["sequenceNumber"];
            this.suburb = data["suburb"];
            this.lastName = data["lastName"];
            this.firstName = data["firstName"];
            this.territory = data["territory"];
            this.clientCode = data["clientCode"];
        }
    };
    MissingBarcodeForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new MissingBarcodeForViewDto();
        result.init(data);
        return result;
    };
    MissingBarcodeForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["barcode"] = this.barcode;
        data["consignmentNumber"] = this.consignmentNumber;
        data["totalPackages"] = this.totalPackages;
        data["sequenceNumber"] = this.sequenceNumber;
        data["suburb"] = this.suburb;
        data["lastName"] = this.lastName;
        data["firstName"] = this.firstName;
        data["territory"] = this.territory;
        data["clientCode"] = this.clientCode;
        return data;
    };
    return MissingBarcodeForViewDto;
}());
export { MissingBarcodeForViewDto };
var ValidateLoadsOutput = /** @class */ (function () {
    function ValidateLoadsOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ValidateLoadsOutput.prototype.init = function (data) {
        if (data) {
            if (Array.isArray(data["missingBarcodes"])) {
                this.missingBarcodes = [];
                for (var _i = 0, _a = data["missingBarcodes"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.missingBarcodes.push(MissingBarcodeForViewDto.fromJS(item));
                }
            }
        }
    };
    ValidateLoadsOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ValidateLoadsOutput();
        result.init(data);
        return result;
    };
    ValidateLoadsOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.missingBarcodes)) {
            data["missingBarcodes"] = [];
            for (var _i = 0, _a = this.missingBarcodes; _i < _a.length; _i++) {
                var item = _a[_i];
                data["missingBarcodes"].push(item.toJSON());
            }
        }
        return data;
    };
    return ValidateLoadsOutput;
}());
export { ValidateLoadsOutput };
export var LoadAction;
(function (LoadAction) {
    LoadAction[LoadAction["Unknown"] = 0] = "Unknown";
    LoadAction[LoadAction["Unsort"] = 1] = "Unsort";
})(LoadAction || (LoadAction = {}));
var UpdateLoadStatusDto = /** @class */ (function () {
    function UpdateLoadStatusDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateLoadStatusDto.prototype.init = function (data) {
        if (data) {
            this.status = data["status"];
            this.action = data["action"];
            this.id = data["id"];
        }
    };
    UpdateLoadStatusDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateLoadStatusDto();
        result.init(data);
        return result;
    };
    UpdateLoadStatusDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["action"] = this.action;
        data["id"] = this.id;
        return data;
    };
    return UpdateLoadStatusDto;
}());
export { UpdateLoadStatusDto };
var GetLocationDetailForViewDto = /** @class */ (function () {
    function GetLocationDetailForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetLocationDetailForViewDto.prototype.init = function (data) {
        if (data) {
            this.locationDetail = data["locationDetail"] ? LocationDetailDto.fromJS(data["locationDetail"]) : undefined;
        }
    };
    GetLocationDetailForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetLocationDetailForViewDto();
        result.init(data);
        return result;
    };
    GetLocationDetailForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["locationDetail"] = this.locationDetail ? this.locationDetail.toJSON() : undefined;
        return data;
    };
    return GetLocationDetailForViewDto;
}());
export { GetLocationDetailForViewDto };
var PagedResultDtoOfGetLocationDetailForViewDto = /** @class */ (function () {
    function PagedResultDtoOfGetLocationDetailForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfGetLocationDetailForViewDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(GetLocationDetailForViewDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfGetLocationDetailForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfGetLocationDetailForViewDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfGetLocationDetailForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfGetLocationDetailForViewDto;
}());
export { PagedResultDtoOfGetLocationDetailForViewDto };
var GetLocationDetailForEditOutput = /** @class */ (function () {
    function GetLocationDetailForEditOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetLocationDetailForEditOutput.prototype.init = function (data) {
        if (data) {
            this.locationDetail = data["locationDetail"] ? CreateOrEditLocationDetailDto.fromJS(data["locationDetail"]) : undefined;
        }
    };
    GetLocationDetailForEditOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetLocationDetailForEditOutput();
        result.init(data);
        return result;
    };
    GetLocationDetailForEditOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["locationDetail"] = this.locationDetail ? this.locationDetail.toJSON() : undefined;
        return data;
    };
    return GetLocationDetailForEditOutput;
}());
export { GetLocationDetailForEditOutput };
var GetLocationForViewDto = /** @class */ (function () {
    function GetLocationForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetLocationForViewDto.prototype.init = function (data) {
        if (data) {
            this.location = data["location"] ? LocationDto.fromJS(data["location"]) : undefined;
        }
    };
    GetLocationForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetLocationForViewDto();
        result.init(data);
        return result;
    };
    GetLocationForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["location"] = this.location ? this.location.toJSON() : undefined;
        return data;
    };
    return GetLocationForViewDto;
}());
export { GetLocationForViewDto };
var PagedResultDtoOfGetLocationForViewDto = /** @class */ (function () {
    function PagedResultDtoOfGetLocationForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfGetLocationForViewDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(GetLocationForViewDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfGetLocationForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfGetLocationForViewDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfGetLocationForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfGetLocationForViewDto;
}());
export { PagedResultDtoOfGetLocationForViewDto };
var GetLocationForEditOutput = /** @class */ (function () {
    function GetLocationForEditOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetLocationForEditOutput.prototype.init = function (data) {
        if (data) {
            this.location = data["location"] ? CreateOrEditLocationDto.fromJS(data["location"]) : undefined;
        }
    };
    GetLocationForEditOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetLocationForEditOutput();
        result.init(data);
        return result;
    };
    GetLocationForEditOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["location"] = this.location ? this.location.toJSON() : undefined;
        return data;
    };
    return GetLocationForEditOutput;
}());
export { GetLocationForEditOutput };
var GetAllLocationForGeocodeOutput = /** @class */ (function () {
    function GetAllLocationForGeocodeOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetAllLocationForGeocodeOutput.prototype.init = function (data) {
        if (data) {
            if (Array.isArray(data["consignments"])) {
                this.consignments = [];
                for (var _i = 0, _a = data["consignments"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.consignments.push(ConsignmentDto.fromJS(item));
                }
            }
            this.state = data["state"];
        }
    };
    GetAllLocationForGeocodeOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetAllLocationForGeocodeOutput();
        result.init(data);
        return result;
    };
    GetAllLocationForGeocodeOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.consignments)) {
            data["consignments"] = [];
            for (var _i = 0, _a = this.consignments; _i < _a.length; _i++) {
                var item = _a[_i];
                data["consignments"].push(item.toJSON());
            }
        }
        data["state"] = this.state;
        return data;
    };
    return GetAllLocationForGeocodeOutput;
}());
export { GetAllLocationForGeocodeOutput };
var LocationSettingDto = /** @class */ (function () {
    function LocationSettingDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    LocationSettingDto.prototype.init = function (data) {
        if (data) {
            this.postcode = data["postcode"];
            this.suburb = data["suburb"];
            this.leadTime = data["leadTime"];
            this.carrierId = data["carrierId"];
            this.depotLocationId = data["depotLocationId"];
            this.territoryConfigurationId = data["territoryConfigurationId"];
            this.id = data["id"];
        }
    };
    LocationSettingDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new LocationSettingDto();
        result.init(data);
        return result;
    };
    LocationSettingDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["postcode"] = this.postcode;
        data["suburb"] = this.suburb;
        data["leadTime"] = this.leadTime;
        data["carrierId"] = this.carrierId;
        data["depotLocationId"] = this.depotLocationId;
        data["territoryConfigurationId"] = this.territoryConfigurationId;
        data["id"] = this.id;
        return data;
    };
    return LocationSettingDto;
}());
export { LocationSettingDto };
var GetLocationSettingForViewDto = /** @class */ (function () {
    function GetLocationSettingForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetLocationSettingForViewDto.prototype.init = function (data) {
        if (data) {
            this.locationSetting = data["locationSetting"] ? LocationSettingDto.fromJS(data["locationSetting"]) : undefined;
            this.carrierName = data["carrierName"];
            this.carrierCode = data["carrierCode"];
            this.depotLocationName = data["depotLocationName"];
            this.territory = data["territory"];
        }
    };
    GetLocationSettingForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetLocationSettingForViewDto();
        result.init(data);
        return result;
    };
    GetLocationSettingForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["locationSetting"] = this.locationSetting ? this.locationSetting.toJSON() : undefined;
        data["carrierName"] = this.carrierName;
        data["carrierCode"] = this.carrierCode;
        data["depotLocationName"] = this.depotLocationName;
        data["territory"] = this.territory;
        return data;
    };
    return GetLocationSettingForViewDto;
}());
export { GetLocationSettingForViewDto };
var PagedResultDtoOfGetLocationSettingForViewDto = /** @class */ (function () {
    function PagedResultDtoOfGetLocationSettingForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfGetLocationSettingForViewDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(GetLocationSettingForViewDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfGetLocationSettingForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfGetLocationSettingForViewDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfGetLocationSettingForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfGetLocationSettingForViewDto;
}());
export { PagedResultDtoOfGetLocationSettingForViewDto };
var CreateOrEditLocationSettingDto = /** @class */ (function () {
    function CreateOrEditLocationSettingDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateOrEditLocationSettingDto.prototype.init = function (data) {
        if (data) {
            this.postcode = data["postcode"];
            this.suburb = data["suburb"];
            this.leadTime = data["leadTime"];
            this.carrierId = data["carrierId"];
            this.depotLocationId = data["depotLocationId"];
            this.territoryConfigurationId = data["territoryConfigurationId"];
            this.id = data["id"];
        }
    };
    CreateOrEditLocationSettingDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrEditLocationSettingDto();
        result.init(data);
        return result;
    };
    CreateOrEditLocationSettingDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["postcode"] = this.postcode;
        data["suburb"] = this.suburb;
        data["leadTime"] = this.leadTime;
        data["carrierId"] = this.carrierId;
        data["depotLocationId"] = this.depotLocationId;
        data["territoryConfigurationId"] = this.territoryConfigurationId;
        data["id"] = this.id;
        return data;
    };
    return CreateOrEditLocationSettingDto;
}());
export { CreateOrEditLocationSettingDto };
var GetLocationSettingForEditOutput = /** @class */ (function () {
    function GetLocationSettingForEditOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetLocationSettingForEditOutput.prototype.init = function (data) {
        if (data) {
            this.locationSetting = data["locationSetting"] ? CreateOrEditLocationSettingDto.fromJS(data["locationSetting"]) : undefined;
            this.carrierName = data["carrierName"];
            this.depotLocationName = data["depotLocationName"];
            this.territory = data["territory"];
        }
    };
    GetLocationSettingForEditOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetLocationSettingForEditOutput();
        result.init(data);
        return result;
    };
    GetLocationSettingForEditOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["locationSetting"] = this.locationSetting ? this.locationSetting.toJSON() : undefined;
        data["carrierName"] = this.carrierName;
        data["depotLocationName"] = this.depotLocationName;
        data["territory"] = this.territory;
        return data;
    };
    return GetLocationSettingForEditOutput;
}());
export { GetLocationSettingForEditOutput };
var Courier = /** @class */ (function () {
    function Courier(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Courier.prototype.init = function (data) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            if (Array.isArray(data["carriers"])) {
                this.carriers = [];
                for (var _i = 0, _a = data["carriers"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.carriers.push(Carrier.fromJS(item));
                }
            }
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    };
    Courier.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Courier();
        result.init(data);
        return result;
    };
    Courier.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        if (Array.isArray(this.carriers)) {
            data["carriers"] = [];
            for (var _i = 0, _a = this.carriers; _i < _a.length; _i++) {
                var item = _a[_i];
                data["carriers"].push(item.toJSON());
            }
        }
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    return Courier;
}());
export { Courier };
var Carrier = /** @class */ (function () {
    function Carrier(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Carrier.prototype.init = function (data) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.isDriver = data["isDriver"];
            this.manifestJob = data["manifestJob"];
            this.courierId = data["courierId"];
            this.courier = data["courier"] ? Courier.fromJS(data["courier"]) : undefined;
            this.depotLocationId = data["depotLocationId"];
            this.depotLocation = data["depotLocation"] ? DepotLocation.fromJS(data["depotLocation"]) : undefined;
            this.d365Entity = data["d365Entity"];
            this.email = data["email"];
            this.details = data["details"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    };
    Carrier.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Carrier();
        result.init(data);
        return result;
    };
    Carrier.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["isDriver"] = this.isDriver;
        data["manifestJob"] = this.manifestJob;
        data["courierId"] = this.courierId;
        data["courier"] = this.courier ? this.courier.toJSON() : undefined;
        data["depotLocationId"] = this.depotLocationId;
        data["depotLocation"] = this.depotLocation ? this.depotLocation.toJSON() : undefined;
        data["d365Entity"] = this.d365Entity;
        data["email"] = this.email;
        data["details"] = this.details;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    return Carrier;
}());
export { Carrier };
var TerritoryConfiguration = /** @class */ (function () {
    function TerritoryConfiguration(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TerritoryConfiguration.prototype.init = function (data) {
        if (data) {
            this.territory = data["territory"];
            this.routedBy = data["routedBy"];
            this.servicedByED = data["servicedByED"];
            this.state = data["state"];
            this.createdAtUtc = data["createdAtUtc"] ? moment(data["createdAtUtc"].toString()) : undefined;
            this.lastModifiedAtUtc = data["lastModifiedAtUtc"] ? moment(data["lastModifiedAtUtc"].toString()) : undefined;
            this.showETA = data["showETA"];
            this.id = data["id"];
        }
    };
    TerritoryConfiguration.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TerritoryConfiguration();
        result.init(data);
        return result;
    };
    TerritoryConfiguration.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["territory"] = this.territory;
        data["routedBy"] = this.routedBy;
        data["servicedByED"] = this.servicedByED;
        data["state"] = this.state;
        data["createdAtUtc"] = this.createdAtUtc ? this.createdAtUtc.toISOString() : undefined;
        data["lastModifiedAtUtc"] = this.lastModifiedAtUtc ? this.lastModifiedAtUtc.toISOString() : undefined;
        data["showETA"] = this.showETA;
        data["id"] = this.id;
        return data;
    };
    return TerritoryConfiguration;
}());
export { TerritoryConfiguration };
var LocationSetting = /** @class */ (function () {
    function LocationSetting(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    LocationSetting.prototype.init = function (data) {
        if (data) {
            this.postcode = data["postcode"];
            this.suburb = data["suburb"];
            this.leadTime = data["leadTime"];
            this.carrierId = data["carrierId"];
            this.carrier = data["carrier"] ? Carrier.fromJS(data["carrier"]) : undefined;
            this.depotLocationId = data["depotLocationId"];
            this.depotLocation = data["depotLocation"] ? DepotLocation.fromJS(data["depotLocation"]) : undefined;
            this.territoryConfigurationId = data["territoryConfigurationId"];
            this.territoryConfiguration = data["territoryConfiguration"] ? TerritoryConfiguration.fromJS(data["territoryConfiguration"]) : undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    };
    LocationSetting.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new LocationSetting();
        result.init(data);
        return result;
    };
    LocationSetting.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["postcode"] = this.postcode;
        data["suburb"] = this.suburb;
        data["leadTime"] = this.leadTime;
        data["carrierId"] = this.carrierId;
        data["carrier"] = this.carrier ? this.carrier.toJSON() : undefined;
        data["depotLocationId"] = this.depotLocationId;
        data["depotLocation"] = this.depotLocation ? this.depotLocation.toJSON() : undefined;
        data["territoryConfigurationId"] = this.territoryConfigurationId;
        data["territoryConfiguration"] = this.territoryConfiguration ? this.territoryConfiguration.toJSON() : undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    return LocationSetting;
}());
export { LocationSetting };
var ManifestPackageDto = /** @class */ (function () {
    function ManifestPackageDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ManifestPackageDto.prototype.init = function (data) {
        if (data) {
            this.lineNumber = data["lineNumber"];
            this.productCode = data["productCode"];
            this.productDescription = data["productDescription"];
            this.productQuantity = data["productQuantity"];
            this.packageType = data["packageType"];
            this.packageBarcodeNumber = data["packageBarcodeNumber"];
            this.packageWeight = data["packageWeight"];
        }
    };
    ManifestPackageDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ManifestPackageDto();
        result.init(data);
        return result;
    };
    ManifestPackageDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["lineNumber"] = this.lineNumber;
        data["productCode"] = this.productCode;
        data["productDescription"] = this.productDescription;
        data["productQuantity"] = this.productQuantity;
        data["packageType"] = this.packageType;
        data["packageBarcodeNumber"] = this.packageBarcodeNumber;
        data["packageWeight"] = this.packageWeight;
        return data;
    };
    return ManifestPackageDto;
}());
export { ManifestPackageDto };
var ManifestShipmentDto = /** @class */ (function () {
    function ManifestShipmentDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ManifestShipmentDto.prototype.init = function (data) {
        if (data) {
            this.deliveryOrPickup = data["deliveryOrPickup"];
            this.slaDate = data["slaDate"] ? moment(data["slaDate"].toString()) : undefined;
            this.name = data["name"];
            this.givenNames = data["givenNames"];
            this.familyName = data["familyName"];
            this.businessName = data["businessName"];
            this.addressLine1 = data["addressLine1"];
            this.addressLine2 = data["addressLine2"];
            this.suburb = data["suburb"];
            this.state = data["state"];
            this.postcode = data["postcode"];
            this.customerNumber = data["customerNumber"];
            this.preAllocatedConnoteNumber = data["preAllocatedConnoteNumber"];
            this.customerOrderNumber = data["customerOrderNumber"];
            this.businessPhone = data["businessPhone"];
            this.mobilePhone = data["mobilePhone"];
            this.deliveryInstructionsLine1 = data["deliveryInstructionsLine1"];
            this.deliveryInstructionsLine2 = data["deliveryInstructionsLine2"];
            this.pickupGivenNames = data["pickupGivenNames"];
            this.pickupFamilyName = data["pickupFamilyName"];
            this.pickupBusinessName = data["pickupBusinessName"];
            this.pickupAddressLine1 = data["pickupAddressLine1"];
            this.pickupAddressLine2 = data["pickupAddressLine2"];
            this.pickupInstructionsLine1 = data["pickupInstructionsLine1"];
            this.pickupSuburb = data["pickupSuburb"];
            this.pickupState = data["pickupState"];
            this.pickupPostcode = data["pickupPostcode"];
            this.pickupBusinessPhone = data["pickupBusinessPhone"];
            this.pickupCustomerNumber = data["pickupCustomerNumber"];
            this.optionalDeliveryDate = data["optionalDeliveryDate"];
            this.businessAddressFlag = data["businessAddressFlag"];
            this.giftFlag = data["giftFlag"];
            this.dropCode = data["dropCode"];
            this.trackingInfo = data["trackingInfo"];
            if (Array.isArray(data["packages"])) {
                this.packages = [];
                for (var _i = 0, _a = data["packages"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.packages.push(ManifestPackageDto.fromJS(item));
                }
            }
        }
    };
    ManifestShipmentDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ManifestShipmentDto();
        result.init(data);
        return result;
    };
    ManifestShipmentDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["deliveryOrPickup"] = this.deliveryOrPickup;
        data["slaDate"] = this.slaDate ? this.slaDate.toISOString() : undefined;
        data["name"] = this.name;
        data["givenNames"] = this.givenNames;
        data["familyName"] = this.familyName;
        data["businessName"] = this.businessName;
        data["addressLine1"] = this.addressLine1;
        data["addressLine2"] = this.addressLine2;
        data["suburb"] = this.suburb;
        data["state"] = this.state;
        data["postcode"] = this.postcode;
        data["customerNumber"] = this.customerNumber;
        data["preAllocatedConnoteNumber"] = this.preAllocatedConnoteNumber;
        data["customerOrderNumber"] = this.customerOrderNumber;
        data["businessPhone"] = this.businessPhone;
        data["mobilePhone"] = this.mobilePhone;
        data["deliveryInstructionsLine1"] = this.deliveryInstructionsLine1;
        data["deliveryInstructionsLine2"] = this.deliveryInstructionsLine2;
        data["pickupGivenNames"] = this.pickupGivenNames;
        data["pickupFamilyName"] = this.pickupFamilyName;
        data["pickupBusinessName"] = this.pickupBusinessName;
        data["pickupAddressLine1"] = this.pickupAddressLine1;
        data["pickupAddressLine2"] = this.pickupAddressLine2;
        data["pickupInstructionsLine1"] = this.pickupInstructionsLine1;
        data["pickupSuburb"] = this.pickupSuburb;
        data["pickupState"] = this.pickupState;
        data["pickupPostcode"] = this.pickupPostcode;
        data["pickupBusinessPhone"] = this.pickupBusinessPhone;
        data["pickupCustomerNumber"] = this.pickupCustomerNumber;
        data["optionalDeliveryDate"] = this.optionalDeliveryDate;
        data["businessAddressFlag"] = this.businessAddressFlag;
        data["giftFlag"] = this.giftFlag;
        data["dropCode"] = this.dropCode;
        data["trackingInfo"] = this.trackingInfo;
        if (Array.isArray(this.packages)) {
            data["packages"] = [];
            for (var _i = 0, _a = this.packages; _i < _a.length; _i++) {
                var item = _a[_i];
                data["packages"].push(item.toJSON());
            }
        }
        return data;
    };
    return ManifestShipmentDto;
}());
export { ManifestShipmentDto };
var CreateManifestWithConsignmentsInput = /** @class */ (function () {
    function CreateManifestWithConsignmentsInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateManifestWithConsignmentsInput.prototype.init = function (data) {
        if (data) {
            this.identifier = data["identifier"];
            this.clientCode = data["clientCode"];
            if (Array.isArray(data["shipments"])) {
                this.shipments = [];
                for (var _i = 0, _a = data["shipments"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.shipments.push(ManifestShipmentDto.fromJS(item));
                }
            }
        }
    };
    CreateManifestWithConsignmentsInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateManifestWithConsignmentsInput();
        result.init(data);
        return result;
    };
    CreateManifestWithConsignmentsInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["clientCode"] = this.clientCode;
        if (Array.isArray(this.shipments)) {
            data["shipments"] = [];
            for (var _i = 0, _a = this.shipments; _i < _a.length; _i++) {
                var item = _a[_i];
                data["shipments"].push(item.toJSON());
            }
        }
        return data;
    };
    return CreateManifestWithConsignmentsInput;
}());
export { CreateManifestWithConsignmentsInput };
var CreatedConsignmentsDto = /** @class */ (function () {
    function CreatedConsignmentsDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreatedConsignmentsDto.prototype.init = function (data) {
        if (data) {
            this.consignmentNumber = data["consignmentNumber"];
            if (Array.isArray(data["newBarcodes"])) {
                this.newBarcodes = [];
                for (var _i = 0, _a = data["newBarcodes"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.newBarcodes.push(item);
                }
            }
            if (Array.isArray(data["errors"])) {
                this.errors = [];
                for (var _b = 0, _c = data["errors"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.errors.push(item);
                }
            }
        }
    };
    CreatedConsignmentsDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreatedConsignmentsDto();
        result.init(data);
        return result;
    };
    CreatedConsignmentsDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["consignmentNumber"] = this.consignmentNumber;
        if (Array.isArray(this.newBarcodes)) {
            data["newBarcodes"] = [];
            for (var _i = 0, _a = this.newBarcodes; _i < _a.length; _i++) {
                var item = _a[_i];
                data["newBarcodes"].push(item);
            }
        }
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (var _b = 0, _c = this.errors; _b < _c.length; _b++) {
                var item = _c[_b];
                data["errors"].push(item);
            }
        }
        return data;
    };
    return CreatedConsignmentsDto;
}());
export { CreatedConsignmentsDto };
var CreateManifestWithConsignmentsOutput = /** @class */ (function () {
    function CreateManifestWithConsignmentsOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateManifestWithConsignmentsOutput.prototype.init = function (data) {
        if (data) {
            this.manifestIdentifier = data["manifestIdentifier"];
            this.manifestFileId = data["manifestFileId"];
            if (Array.isArray(data["createdConsignments"])) {
                this.createdConsignments = [];
                for (var _i = 0, _a = data["createdConsignments"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.createdConsignments.push(CreatedConsignmentsDto.fromJS(item));
                }
            }
        }
    };
    CreateManifestWithConsignmentsOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateManifestWithConsignmentsOutput();
        result.init(data);
        return result;
    };
    CreateManifestWithConsignmentsOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["manifestIdentifier"] = this.manifestIdentifier;
        data["manifestFileId"] = this.manifestFileId;
        if (Array.isArray(this.createdConsignments)) {
            data["createdConsignments"] = [];
            for (var _i = 0, _a = this.createdConsignments; _i < _a.length; _i++) {
                var item = _a[_i];
                data["createdConsignments"].push(item.toJSON());
            }
        }
        return data;
    };
    return CreateManifestWithConsignmentsOutput;
}());
export { CreateManifestWithConsignmentsOutput };
export var Severity;
(function (Severity) {
    Severity[Severity["Info"] = 0] = "Info";
    Severity[Severity["Warning"] = 1] = "Warning";
    Severity[Severity["Error"] = 2] = "Error";
})(Severity || (Severity = {}));
var ImportLog = /** @class */ (function () {
    function ImportLog(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ImportLog.prototype.init = function (data) {
        if (data) {
            this.severity = data["severity"];
            this.message = data["message"];
        }
    };
    ImportLog.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ImportLog();
        result.init(data);
        return result;
    };
    ImportLog.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["severity"] = this.severity;
        data["message"] = this.message;
        return data;
    };
    return ImportLog;
}());
export { ImportLog };
var ManifestFileDto = /** @class */ (function () {
    function ManifestFileDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ManifestFileDto.prototype.init = function (data) {
        if (data) {
            this.fileName = data["fileName"];
            this.importedAt = data["importedAt"] ? moment(data["importedAt"].toString()) : undefined;
            this.isSuccess = data["isSuccess"];
            if (Array.isArray(data["importLog"])) {
                this.importLog = [];
                for (var _i = 0, _a = data["importLog"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.importLog.push(ImportLog.fromJS(item));
                }
            }
            this.warningCount = data["warningCount"];
            this.infoCount = data["infoCount"];
            this.errorCount = data["errorCount"];
            if (Array.isArray(data["clients"])) {
                this.clients = [];
                for (var _b = 0, _c = data["clients"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.clients.push(item);
                }
            }
            this.id = data["id"];
        }
    };
    ManifestFileDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ManifestFileDto();
        result.init(data);
        return result;
    };
    ManifestFileDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["importedAt"] = this.importedAt ? this.importedAt.toISOString() : undefined;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.importLog)) {
            data["importLog"] = [];
            for (var _i = 0, _a = this.importLog; _i < _a.length; _i++) {
                var item = _a[_i];
                data["importLog"].push(item.toJSON());
            }
        }
        data["warningCount"] = this.warningCount;
        data["infoCount"] = this.infoCount;
        data["errorCount"] = this.errorCount;
        if (Array.isArray(this.clients)) {
            data["clients"] = [];
            for (var _b = 0, _c = this.clients; _b < _c.length; _b++) {
                var item = _c[_b];
                data["clients"].push(item);
            }
        }
        data["id"] = this.id;
        return data;
    };
    return ManifestFileDto;
}());
export { ManifestFileDto };
var ManifestFileRecordDto = /** @class */ (function () {
    function ManifestFileRecordDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ManifestFileRecordDto.prototype.init = function (data) {
        if (data) {
            this.connoteNumber = data["connoteNumber"];
            this.status = data["status"];
            this.manifestFileId = data["manifestFileId"];
            this.consignmentStatusId = data["consignmentStatusId"];
            this.asJsonString = data["asJsonString"];
            this.manifestFile = data["manifestFile"] ? ManifestFileDto.fromJS(data["manifestFile"]) : undefined;
            this.consignmentStatus = data["consignmentStatus"] ? ConsignmentStatusDto.fromJS(data["consignmentStatus"]) : undefined;
            this.clientId = data["clientId"];
            this.client = data["client"] ? ClientDto.fromJS(data["client"]) : undefined;
            this.id = data["id"];
        }
    };
    ManifestFileRecordDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ManifestFileRecordDto();
        result.init(data);
        return result;
    };
    ManifestFileRecordDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["connoteNumber"] = this.connoteNumber;
        data["status"] = this.status;
        data["manifestFileId"] = this.manifestFileId;
        data["consignmentStatusId"] = this.consignmentStatusId;
        data["asJsonString"] = this.asJsonString;
        data["manifestFile"] = this.manifestFile ? this.manifestFile.toJSON() : undefined;
        data["consignmentStatus"] = this.consignmentStatus ? this.consignmentStatus.toJSON() : undefined;
        data["clientId"] = this.clientId;
        data["client"] = this.client ? this.client.toJSON() : undefined;
        data["id"] = this.id;
        return data;
    };
    return ManifestFileRecordDto;
}());
export { ManifestFileRecordDto };
var GetManifestFileRecordForViewDto = /** @class */ (function () {
    function GetManifestFileRecordForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetManifestFileRecordForViewDto.prototype.init = function (data) {
        if (data) {
            this.manifestFileRecord = data["manifestFileRecord"] ? ManifestFileRecordDto.fromJS(data["manifestFileRecord"]) : undefined;
            this.clientName = data["clientName"];
        }
    };
    GetManifestFileRecordForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetManifestFileRecordForViewDto();
        result.init(data);
        return result;
    };
    GetManifestFileRecordForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["manifestFileRecord"] = this.manifestFileRecord ? this.manifestFileRecord.toJSON() : undefined;
        data["clientName"] = this.clientName;
        return data;
    };
    return GetManifestFileRecordForViewDto;
}());
export { GetManifestFileRecordForViewDto };
var PagedResultDtoOfGetManifestFileRecordForViewDto = /** @class */ (function () {
    function PagedResultDtoOfGetManifestFileRecordForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfGetManifestFileRecordForViewDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(GetManifestFileRecordForViewDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfGetManifestFileRecordForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfGetManifestFileRecordForViewDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfGetManifestFileRecordForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfGetManifestFileRecordForViewDto;
}());
export { PagedResultDtoOfGetManifestFileRecordForViewDto };
var CreateOrEditManifestFileRecordDto = /** @class */ (function () {
    function CreateOrEditManifestFileRecordDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateOrEditManifestFileRecordDto.prototype.init = function (data) {
        if (data) {
            this.asJsonString = data["asJsonString"];
            this.id = data["id"];
        }
    };
    CreateOrEditManifestFileRecordDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrEditManifestFileRecordDto();
        result.init(data);
        return result;
    };
    CreateOrEditManifestFileRecordDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["asJsonString"] = this.asJsonString;
        data["id"] = this.id;
        return data;
    };
    return CreateOrEditManifestFileRecordDto;
}());
export { CreateOrEditManifestFileRecordDto };
var GetManifestFileRecordForEditOutput = /** @class */ (function () {
    function GetManifestFileRecordForEditOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetManifestFileRecordForEditOutput.prototype.init = function (data) {
        if (data) {
            this.manifestFileRecord = data["manifestFileRecord"] ? CreateOrEditManifestFileRecordDto.fromJS(data["manifestFileRecord"]) : undefined;
            this.status = data["status"];
            this.fileName = data["fileName"];
            this.consignmentStatusDescription = data["consignmentStatusDescription"];
            this.jsonSchema = data["jsonSchema"];
        }
    };
    GetManifestFileRecordForEditOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetManifestFileRecordForEditOutput();
        result.init(data);
        return result;
    };
    GetManifestFileRecordForEditOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["manifestFileRecord"] = this.manifestFileRecord ? this.manifestFileRecord.toJSON() : undefined;
        data["status"] = this.status;
        data["fileName"] = this.fileName;
        data["consignmentStatusDescription"] = this.consignmentStatusDescription;
        data["jsonSchema"] = this.jsonSchema;
        return data;
    };
    return GetManifestFileRecordForEditOutput;
}());
export { GetManifestFileRecordForEditOutput };
var ManifestFileLookupTableDto = /** @class */ (function () {
    function ManifestFileLookupTableDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ManifestFileLookupTableDto.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    };
    ManifestFileLookupTableDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ManifestFileLookupTableDto();
        result.init(data);
        return result;
    };
    ManifestFileLookupTableDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    };
    return ManifestFileLookupTableDto;
}());
export { ManifestFileLookupTableDto };
var PagedResultDtoOfManifestFileLookupTableDto = /** @class */ (function () {
    function PagedResultDtoOfManifestFileLookupTableDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfManifestFileLookupTableDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(ManifestFileLookupTableDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfManifestFileLookupTableDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfManifestFileLookupTableDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfManifestFileLookupTableDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfManifestFileLookupTableDto;
}());
export { PagedResultDtoOfManifestFileLookupTableDto };
var GetAllManifestFilesInput = /** @class */ (function () {
    function GetAllManifestFilesInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetAllManifestFilesInput.prototype.init = function (data) {
        if (data) {
            this.filter = data["filter"];
            if (Array.isArray(data["fileNameFilter"])) {
                this.fileNameFilter = [];
                for (var _i = 0, _a = data["fileNameFilter"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.fileNameFilter.push(item);
                }
            }
            this.maxImportedAtFilter = data["maxImportedAtFilter"] ? moment(data["maxImportedAtFilter"].toString()) : undefined;
            this.minImportedAtFilter = data["minImportedAtFilter"] ? moment(data["minImportedAtFilter"].toString()) : undefined;
            this.importLogFilter = data["importLogFilter"];
            if (Array.isArray(data["clientIdFilter"])) {
                this.clientIdFilter = [];
                for (var _b = 0, _c = data["clientIdFilter"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.clientIdFilter.push(item);
                }
            }
            if (Array.isArray(data["clientGroupNameFilter"])) {
                this.clientGroupNameFilter = [];
                for (var _d = 0, _e = data["clientGroupNameFilter"]; _d < _e.length; _d++) {
                    var item = _e[_d];
                    this.clientGroupNameFilter.push(item);
                }
            }
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    };
    GetAllManifestFilesInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetAllManifestFilesInput();
        result.init(data);
        return result;
    };
    GetAllManifestFilesInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        if (Array.isArray(this.fileNameFilter)) {
            data["fileNameFilter"] = [];
            for (var _i = 0, _a = this.fileNameFilter; _i < _a.length; _i++) {
                var item = _a[_i];
                data["fileNameFilter"].push(item);
            }
        }
        data["maxImportedAtFilter"] = this.maxImportedAtFilter ? this.maxImportedAtFilter.toISOString() : undefined;
        data["minImportedAtFilter"] = this.minImportedAtFilter ? this.minImportedAtFilter.toISOString() : undefined;
        data["importLogFilter"] = this.importLogFilter;
        if (Array.isArray(this.clientIdFilter)) {
            data["clientIdFilter"] = [];
            for (var _b = 0, _c = this.clientIdFilter; _b < _c.length; _b++) {
                var item = _c[_b];
                data["clientIdFilter"].push(item);
            }
        }
        if (Array.isArray(this.clientGroupNameFilter)) {
            data["clientGroupNameFilter"] = [];
            for (var _d = 0, _e = this.clientGroupNameFilter; _d < _e.length; _d++) {
                var item = _e[_d];
                data["clientGroupNameFilter"].push(item);
            }
        }
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    };
    return GetAllManifestFilesInput;
}());
export { GetAllManifestFilesInput };
var GetManifestFileForViewDto = /** @class */ (function () {
    function GetManifestFileForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetManifestFileForViewDto.prototype.init = function (data) {
        if (data) {
            this.manifestFile = data["manifestFile"] ? ManifestFileDto.fromJS(data["manifestFile"]) : undefined;
            this.imported = data["imported"];
            this.errors = data["errors"];
            this.packageCount = data["packageCount"];
        }
    };
    GetManifestFileForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetManifestFileForViewDto();
        result.init(data);
        return result;
    };
    GetManifestFileForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["manifestFile"] = this.manifestFile ? this.manifestFile.toJSON() : undefined;
        data["imported"] = this.imported;
        data["errors"] = this.errors;
        data["packageCount"] = this.packageCount;
        return data;
    };
    return GetManifestFileForViewDto;
}());
export { GetManifestFileForViewDto };
var PagedResultDtoOfGetManifestFileForViewDto = /** @class */ (function () {
    function PagedResultDtoOfGetManifestFileForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfGetManifestFileForViewDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(GetManifestFileForViewDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfGetManifestFileForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfGetManifestFileForViewDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfGetManifestFileForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfGetManifestFileForViewDto;
}());
export { PagedResultDtoOfGetManifestFileForViewDto };
var GetManifestTemplateForViewDto = /** @class */ (function () {
    function GetManifestTemplateForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetManifestTemplateForViewDto.prototype.init = function (data) {
        if (data) {
            this.manifestTemplate = data["manifestTemplate"] ? ManifestTemplateDto.fromJS(data["manifestTemplate"]) : undefined;
        }
    };
    GetManifestTemplateForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetManifestTemplateForViewDto();
        result.init(data);
        return result;
    };
    GetManifestTemplateForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["manifestTemplate"] = this.manifestTemplate ? this.manifestTemplate.toJSON() : undefined;
        return data;
    };
    return GetManifestTemplateForViewDto;
}());
export { GetManifestTemplateForViewDto };
var PagedResultDtoOfGetManifestTemplateForViewDto = /** @class */ (function () {
    function PagedResultDtoOfGetManifestTemplateForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfGetManifestTemplateForViewDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(GetManifestTemplateForViewDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfGetManifestTemplateForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfGetManifestTemplateForViewDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfGetManifestTemplateForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfGetManifestTemplateForViewDto;
}());
export { PagedResultDtoOfGetManifestTemplateForViewDto };
var CreateBarcodeHistoryDepoScansInput = /** @class */ (function () {
    function CreateBarcodeHistoryDepoScansInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateBarcodeHistoryDepoScansInput.prototype.init = function (data) {
        if (data) {
            this.scanType = data["scanType"];
            this.barcode = data["barcode"];
            this.depot = data["depot"];
            this.productBarcode = data["productBarcode"];
            this.palletBarcode = data["palletBarcode"];
            this.orderNumber = data["orderNumber"];
            this.id = data["id"];
        }
    };
    CreateBarcodeHistoryDepoScansInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateBarcodeHistoryDepoScansInput();
        result.init(data);
        return result;
    };
    CreateBarcodeHistoryDepoScansInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["scanType"] = this.scanType;
        data["barcode"] = this.barcode;
        data["depot"] = this.depot;
        data["productBarcode"] = this.productBarcode;
        data["palletBarcode"] = this.palletBarcode;
        data["orderNumber"] = this.orderNumber;
        data["id"] = this.id;
        return data;
    };
    return CreateBarcodeHistoryDepoScansInput;
}());
export { CreateBarcodeHistoryDepoScansInput };
var CreateBarcodeHistoryDepoScansOutput = /** @class */ (function () {
    function CreateBarcodeHistoryDepoScansOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateBarcodeHistoryDepoScansOutput.prototype.init = function (data) {
        if (data) {
            this.connoteType = data["connoteType"];
            this.connoteStatus = data["connoteStatus"];
            this.valid = data["valid"];
            this.shipdate = data["shipdate"] ? moment(data["shipdate"].toString()) : undefined;
            this.carrierCode = data["carrierCode"];
            this.connoteNumber = data["connoteNumber"];
            this.crossBorder = data["crossBorder"];
            this.deliveryState = data["deliveryState"];
            this.consignmentId = data["consignmentId"];
            this.loadStatus = data["loadStatus"];
            this.loadId = data["loadId"];
            this.packageId = data["packageId"];
            this.canReschedule = data["canReschedule"];
            this.priority = data["priority"];
            if (Array.isArray(data["barcodeScanPackageProducts"])) {
                this.barcodeScanPackageProducts = [];
                for (var _i = 0, _a = data["barcodeScanPackageProducts"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.barcodeScanPackageProducts.push(BarcodeScanPackageProductDto.fromJS(item));
                }
            }
            this.palletId = data["palletId"];
            this.palletBarcode = data["palletBarcode"];
            this.palletConsignmentNumber = data["palletConsignmentNumber"];
            this.locationFullAddress = data["locationFullAddress"];
            this.id = data["id"];
        }
    };
    CreateBarcodeHistoryDepoScansOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateBarcodeHistoryDepoScansOutput();
        result.init(data);
        return result;
    };
    CreateBarcodeHistoryDepoScansOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["connoteType"] = this.connoteType;
        data["connoteStatus"] = this.connoteStatus;
        data["valid"] = this.valid;
        data["shipdate"] = this.shipdate ? this.shipdate.toISOString() : undefined;
        data["carrierCode"] = this.carrierCode;
        data["connoteNumber"] = this.connoteNumber;
        data["crossBorder"] = this.crossBorder;
        data["deliveryState"] = this.deliveryState;
        data["consignmentId"] = this.consignmentId;
        data["loadStatus"] = this.loadStatus;
        data["loadId"] = this.loadId;
        data["packageId"] = this.packageId;
        data["canReschedule"] = this.canReschedule;
        data["priority"] = this.priority;
        if (Array.isArray(this.barcodeScanPackageProducts)) {
            data["barcodeScanPackageProducts"] = [];
            for (var _i = 0, _a = this.barcodeScanPackageProducts; _i < _a.length; _i++) {
                var item = _a[_i];
                data["barcodeScanPackageProducts"].push(item.toJSON());
            }
        }
        data["palletId"] = this.palletId;
        data["palletBarcode"] = this.palletBarcode;
        data["palletConsignmentNumber"] = this.palletConsignmentNumber;
        data["locationFullAddress"] = this.locationFullAddress;
        data["id"] = this.id;
        return data;
    };
    return CreateBarcodeHistoryDepoScansOutput;
}());
export { CreateBarcodeHistoryDepoScansOutput };
var GetEligibleScanTypesDto = /** @class */ (function () {
    function GetEligibleScanTypesDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetEligibleScanTypesDto.prototype.init = function (data) {
        if (data) {
            if (Array.isArray(data["scanTypes"])) {
                this.scanTypes = [];
                for (var _i = 0, _a = data["scanTypes"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.scanTypes.push(item);
                }
            }
        }
    };
    GetEligibleScanTypesDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetEligibleScanTypesDto();
        result.init(data);
        return result;
    };
    GetEligibleScanTypesDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.scanTypes)) {
            data["scanTypes"] = [];
            for (var _i = 0, _a = this.scanTypes; _i < _a.length; _i++) {
                var item = _a[_i];
                data["scanTypes"].push(item);
            }
        }
        return data;
    };
    return GetEligibleScanTypesDto;
}());
export { GetEligibleScanTypesDto };
var UpdateBarcodeScanProductQuantityDto = /** @class */ (function () {
    function UpdateBarcodeScanProductQuantityDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateBarcodeScanProductQuantityDto.prototype.init = function (data) {
        if (data) {
            this.barcode = data["barcode"];
            this.depot = data["depot"];
            this.quantity = data["quantity"];
            this.productBarcode = data["productBarcode"];
            this.id = data["id"];
        }
    };
    UpdateBarcodeScanProductQuantityDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateBarcodeScanProductQuantityDto();
        result.init(data);
        return result;
    };
    UpdateBarcodeScanProductQuantityDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["barcode"] = this.barcode;
        data["depot"] = this.depot;
        data["quantity"] = this.quantity;
        data["productBarcode"] = this.productBarcode;
        data["id"] = this.id;
        return data;
    };
    return UpdateBarcodeScanProductQuantityDto;
}());
export { UpdateBarcodeScanProductQuantityDto };
var UpdateBarcodeScanProductQuantityOutput = /** @class */ (function () {
    function UpdateBarcodeScanProductQuantityOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateBarcodeScanProductQuantityOutput.prototype.init = function (data) {
        if (data) {
            if (Array.isArray(data["barcodeScanPackageProducts"])) {
                this.barcodeScanPackageProducts = [];
                for (var _i = 0, _a = data["barcodeScanPackageProducts"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.barcodeScanPackageProducts.push(BarcodeScanPackageProductDto.fromJS(item));
                }
            }
            this.id = data["id"];
        }
    };
    UpdateBarcodeScanProductQuantityOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateBarcodeScanProductQuantityOutput();
        result.init(data);
        return result;
    };
    UpdateBarcodeScanProductQuantityOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.barcodeScanPackageProducts)) {
            data["barcodeScanPackageProducts"] = [];
            for (var _i = 0, _a = this.barcodeScanPackageProducts; _i < _a.length; _i++) {
                var item = _a[_i];
                data["barcodeScanPackageProducts"].push(item.toJSON());
            }
        }
        data["id"] = this.id;
        return data;
    };
    return UpdateBarcodeScanProductQuantityOutput;
}());
export { UpdateBarcodeScanProductQuantityOutput };
var MiscChargeDto = /** @class */ (function () {
    function MiscChargeDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MiscChargeDto.prototype.init = function (data) {
        if (data) {
            this.chargeDate = data["chargeDate"] ? moment(data["chargeDate"].toString()) : undefined;
            this.amount = data["amount"];
            this.notes = data["notes"];
            this.sentToFinanceTransactionsAt = data["sentToFinanceTransactionsAt"] ? moment(data["sentToFinanceTransactionsAt"].toString()) : undefined;
            this.clientId = data["clientId"];
            this.carrierId = data["carrierId"];
            this.miscCostChargeTypeId = data["miscCostChargeTypeId"];
            this.id = data["id"];
        }
    };
    MiscChargeDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new MiscChargeDto();
        result.init(data);
        return result;
    };
    MiscChargeDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["chargeDate"] = this.chargeDate ? this.chargeDate.toISOString() : undefined;
        data["amount"] = this.amount;
        data["notes"] = this.notes;
        data["sentToFinanceTransactionsAt"] = this.sentToFinanceTransactionsAt ? this.sentToFinanceTransactionsAt.toISOString() : undefined;
        data["clientId"] = this.clientId;
        data["carrierId"] = this.carrierId;
        data["miscCostChargeTypeId"] = this.miscCostChargeTypeId;
        data["id"] = this.id;
        return data;
    };
    return MiscChargeDto;
}());
export { MiscChargeDto };
var GetMiscChargeForViewDto = /** @class */ (function () {
    function GetMiscChargeForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetMiscChargeForViewDto.prototype.init = function (data) {
        if (data) {
            this.miscCharge = data["miscCharge"] ? MiscChargeDto.fromJS(data["miscCharge"]) : undefined;
            this.depotCode = data["depotCode"];
            this.clientName = data["clientName"];
            this.clientGroupD365Entity = data["clientGroupD365Entity"];
            this.carrierName = data["carrierName"];
            this.carrierD365Entity = data["carrierD365Entity"];
            this.miscCostChargeTypeName = data["miscCostChargeTypeName"];
            this.miscCostChargeTypeMiscChargeType = data["miscCostChargeTypeMiscChargeType"];
        }
    };
    GetMiscChargeForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetMiscChargeForViewDto();
        result.init(data);
        return result;
    };
    GetMiscChargeForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["miscCharge"] = this.miscCharge ? this.miscCharge.toJSON() : undefined;
        data["depotCode"] = this.depotCode;
        data["clientName"] = this.clientName;
        data["clientGroupD365Entity"] = this.clientGroupD365Entity;
        data["carrierName"] = this.carrierName;
        data["carrierD365Entity"] = this.carrierD365Entity;
        data["miscCostChargeTypeName"] = this.miscCostChargeTypeName;
        data["miscCostChargeTypeMiscChargeType"] = this.miscCostChargeTypeMiscChargeType;
        return data;
    };
    return GetMiscChargeForViewDto;
}());
export { GetMiscChargeForViewDto };
var PagedResultDtoOfGetMiscChargeForViewDto = /** @class */ (function () {
    function PagedResultDtoOfGetMiscChargeForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfGetMiscChargeForViewDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(GetMiscChargeForViewDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfGetMiscChargeForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfGetMiscChargeForViewDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfGetMiscChargeForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfGetMiscChargeForViewDto;
}());
export { PagedResultDtoOfGetMiscChargeForViewDto };
var CreateOrEditMiscChargeDto = /** @class */ (function () {
    function CreateOrEditMiscChargeDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateOrEditMiscChargeDto.prototype.init = function (data) {
        if (data) {
            this.chargeDate = data["chargeDate"] ? moment(data["chargeDate"].toString()) : undefined;
            this.miscCostChargeTypeId = data["miscCostChargeTypeId"];
            this.amount = data["amount"];
            this.notes = data["notes"];
            this.depotLocationId = data["depotLocationId"];
            this.clientId = data["clientId"];
            this.carrierId = data["carrierId"];
            this.id = data["id"];
        }
    };
    CreateOrEditMiscChargeDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrEditMiscChargeDto();
        result.init(data);
        return result;
    };
    CreateOrEditMiscChargeDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["chargeDate"] = this.chargeDate ? this.chargeDate.toISOString() : undefined;
        data["miscCostChargeTypeId"] = this.miscCostChargeTypeId;
        data["amount"] = this.amount;
        data["notes"] = this.notes;
        data["depotLocationId"] = this.depotLocationId;
        data["clientId"] = this.clientId;
        data["carrierId"] = this.carrierId;
        data["id"] = this.id;
        return data;
    };
    return CreateOrEditMiscChargeDto;
}());
export { CreateOrEditMiscChargeDto };
var GetMiscChargeForEditOutput = /** @class */ (function () {
    function GetMiscChargeForEditOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetMiscChargeForEditOutput.prototype.init = function (data) {
        if (data) {
            this.miscCharge = data["miscCharge"] ? CreateOrEditMiscChargeDto.fromJS(data["miscCharge"]) : undefined;
            this.depotCode = data["depotCode"];
            this.clientName = data["clientName"];
            this.carrierName = data["carrierName"];
            this.miscCostChargeTypeName = data["miscCostChargeTypeName"];
        }
    };
    GetMiscChargeForEditOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetMiscChargeForEditOutput();
        result.init(data);
        return result;
    };
    GetMiscChargeForEditOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["miscCharge"] = this.miscCharge ? this.miscCharge.toJSON() : undefined;
        data["depotCode"] = this.depotCode;
        data["clientName"] = this.clientName;
        data["carrierName"] = this.carrierName;
        data["miscCostChargeTypeName"] = this.miscCostChargeTypeName;
        return data;
    };
    return GetMiscChargeForEditOutput;
}());
export { GetMiscChargeForEditOutput };
export var MiscChargeType;
(function (MiscChargeType) {
    MiscChargeType[MiscChargeType["None"] = 0] = "None";
    MiscChargeType[MiscChargeType["ChargeDriver"] = 1] = "ChargeDriver";
    MiscChargeType[MiscChargeType["PayDriver"] = 2] = "PayDriver";
})(MiscChargeType || (MiscChargeType = {}));
var MiscCostChargeTypeDto = /** @class */ (function () {
    function MiscCostChargeTypeDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MiscCostChargeTypeDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.miscChargeType = data["miscChargeType"];
            this.id = data["id"];
        }
    };
    MiscCostChargeTypeDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new MiscCostChargeTypeDto();
        result.init(data);
        return result;
    };
    MiscCostChargeTypeDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["miscChargeType"] = this.miscChargeType;
        data["id"] = this.id;
        return data;
    };
    return MiscCostChargeTypeDto;
}());
export { MiscCostChargeTypeDto };
var GetMiscCostChargeTypeForViewDto = /** @class */ (function () {
    function GetMiscCostChargeTypeForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetMiscCostChargeTypeForViewDto.prototype.init = function (data) {
        if (data) {
            this.miscCostChargeType = data["miscCostChargeType"] ? MiscCostChargeTypeDto.fromJS(data["miscCostChargeType"]) : undefined;
        }
    };
    GetMiscCostChargeTypeForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetMiscCostChargeTypeForViewDto();
        result.init(data);
        return result;
    };
    GetMiscCostChargeTypeForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["miscCostChargeType"] = this.miscCostChargeType ? this.miscCostChargeType.toJSON() : undefined;
        return data;
    };
    return GetMiscCostChargeTypeForViewDto;
}());
export { GetMiscCostChargeTypeForViewDto };
var PagedResultDtoOfGetMiscCostChargeTypeForViewDto = /** @class */ (function () {
    function PagedResultDtoOfGetMiscCostChargeTypeForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfGetMiscCostChargeTypeForViewDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(GetMiscCostChargeTypeForViewDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfGetMiscCostChargeTypeForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfGetMiscCostChargeTypeForViewDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfGetMiscCostChargeTypeForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfGetMiscCostChargeTypeForViewDto;
}());
export { PagedResultDtoOfGetMiscCostChargeTypeForViewDto };
var CreateOrEditMiscCostChargeTypeDto = /** @class */ (function () {
    function CreateOrEditMiscCostChargeTypeDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateOrEditMiscCostChargeTypeDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.miscChargeType = data["miscChargeType"];
            this.id = data["id"];
        }
    };
    CreateOrEditMiscCostChargeTypeDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrEditMiscCostChargeTypeDto();
        result.init(data);
        return result;
    };
    CreateOrEditMiscCostChargeTypeDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["miscChargeType"] = this.miscChargeType;
        data["id"] = this.id;
        return data;
    };
    return CreateOrEditMiscCostChargeTypeDto;
}());
export { CreateOrEditMiscCostChargeTypeDto };
var GetMiscCostChargeTypeForEditOutput = /** @class */ (function () {
    function GetMiscCostChargeTypeForEditOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetMiscCostChargeTypeForEditOutput.prototype.init = function (data) {
        if (data) {
            this.miscCostChargeType = data["miscCostChargeType"] ? CreateOrEditMiscCostChargeTypeDto.fromJS(data["miscCostChargeType"]) : undefined;
        }
    };
    GetMiscCostChargeTypeForEditOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetMiscCostChargeTypeForEditOutput();
        result.init(data);
        return result;
    };
    GetMiscCostChargeTypeForEditOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["miscCostChargeType"] = this.miscCostChargeType ? this.miscCostChargeType.toJSON() : undefined;
        return data;
    };
    return GetMiscCostChargeTypeForEditOutput;
}());
export { GetMiscCostChargeTypeForEditOutput };
export var UserNotificationState;
(function (UserNotificationState) {
    UserNotificationState[UserNotificationState["Unread"] = 0] = "Unread";
    UserNotificationState[UserNotificationState["Read"] = 1] = "Read";
})(UserNotificationState || (UserNotificationState = {}));
var NotificationData = /** @class */ (function () {
    function NotificationData(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    NotificationData.prototype.init = function (data) {
        if (data) {
            this.type = data["type"];
            if (data["properties"]) {
                this.properties = {};
                for (var key in data["properties"]) {
                    if (data["properties"].hasOwnProperty(key))
                        this.properties[key] = data["properties"][key];
                }
            }
        }
    };
    NotificationData.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new NotificationData();
        result.init(data);
        return result;
    };
    NotificationData.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        if (this.properties) {
            data["properties"] = {};
            for (var key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    data["properties"][key] = this.properties[key];
            }
        }
        return data;
    };
    return NotificationData;
}());
export { NotificationData };
export var MemberTypes;
(function (MemberTypes) {
    MemberTypes[MemberTypes["Constructor"] = 1] = "Constructor";
    MemberTypes[MemberTypes["Event"] = 2] = "Event";
    MemberTypes[MemberTypes["Field"] = 4] = "Field";
    MemberTypes[MemberTypes["Method"] = 8] = "Method";
    MemberTypes[MemberTypes["Property"] = 16] = "Property";
    MemberTypes[MemberTypes["TypeInfo"] = 32] = "TypeInfo";
    MemberTypes[MemberTypes["Custom"] = 64] = "Custom";
    MemberTypes[MemberTypes["NestedType"] = 128] = "NestedType";
    MemberTypes[MemberTypes["All"] = 191] = "All";
})(MemberTypes || (MemberTypes = {}));
export var MethodAttributes;
(function (MethodAttributes) {
    MethodAttributes[MethodAttributes["ReuseSlot"] = 0] = "ReuseSlot";
    MethodAttributes[MethodAttributes["PrivateScope"] = 0] = "PrivateScope";
    MethodAttributes[MethodAttributes["Private"] = 1] = "Private";
    MethodAttributes[MethodAttributes["FamANDAssem"] = 2] = "FamANDAssem";
    MethodAttributes[MethodAttributes["Assembly"] = 3] = "Assembly";
    MethodAttributes[MethodAttributes["Family"] = 4] = "Family";
    MethodAttributes[MethodAttributes["FamORAssem"] = 5] = "FamORAssem";
    MethodAttributes[MethodAttributes["Public"] = 6] = "Public";
    MethodAttributes[MethodAttributes["MemberAccessMask"] = 7] = "MemberAccessMask";
    MethodAttributes[MethodAttributes["UnmanagedExport"] = 8] = "UnmanagedExport";
    MethodAttributes[MethodAttributes["Static"] = 16] = "Static";
    MethodAttributes[MethodAttributes["Final"] = 32] = "Final";
    MethodAttributes[MethodAttributes["Virtual"] = 64] = "Virtual";
    MethodAttributes[MethodAttributes["HideBySig"] = 128] = "HideBySig";
    MethodAttributes[MethodAttributes["NewSlot"] = 256] = "NewSlot";
    MethodAttributes[MethodAttributes["VtableLayoutMask"] = 256] = "VtableLayoutMask";
    MethodAttributes[MethodAttributes["CheckAccessOnOverride"] = 512] = "CheckAccessOnOverride";
    MethodAttributes[MethodAttributes["Abstract"] = 1024] = "Abstract";
    MethodAttributes[MethodAttributes["SpecialName"] = 2048] = "SpecialName";
    MethodAttributes[MethodAttributes["RTSpecialName"] = 4096] = "RTSpecialName";
    MethodAttributes[MethodAttributes["PinvokeImpl"] = 8192] = "PinvokeImpl";
    MethodAttributes[MethodAttributes["HasSecurity"] = 16384] = "HasSecurity";
    MethodAttributes[MethodAttributes["RequireSecObject"] = 32768] = "RequireSecObject";
    MethodAttributes[MethodAttributes["ReservedMask"] = 53248] = "ReservedMask";
})(MethodAttributes || (MethodAttributes = {}));
export var MethodImplAttributes;
(function (MethodImplAttributes) {
    MethodImplAttributes[MethodImplAttributes["IL"] = 0] = "IL";
    MethodImplAttributes[MethodImplAttributes["Managed"] = 0] = "Managed";
    MethodImplAttributes[MethodImplAttributes["Native"] = 1] = "Native";
    MethodImplAttributes[MethodImplAttributes["OPTIL"] = 2] = "OPTIL";
    MethodImplAttributes[MethodImplAttributes["Runtime"] = 3] = "Runtime";
    MethodImplAttributes[MethodImplAttributes["CodeTypeMask"] = 3] = "CodeTypeMask";
    MethodImplAttributes[MethodImplAttributes["Unmanaged"] = 4] = "Unmanaged";
    MethodImplAttributes[MethodImplAttributes["ManagedMask"] = 4] = "ManagedMask";
    MethodImplAttributes[MethodImplAttributes["NoInlining"] = 8] = "NoInlining";
    MethodImplAttributes[MethodImplAttributes["ForwardRef"] = 16] = "ForwardRef";
    MethodImplAttributes[MethodImplAttributes["Synchronized"] = 32] = "Synchronized";
    MethodImplAttributes[MethodImplAttributes["NoOptimization"] = 64] = "NoOptimization";
    MethodImplAttributes[MethodImplAttributes["PreserveSig"] = 128] = "PreserveSig";
    MethodImplAttributes[MethodImplAttributes["AggressiveInlining"] = 256] = "AggressiveInlining";
    MethodImplAttributes[MethodImplAttributes["AggressiveOptimization"] = 512] = "AggressiveOptimization";
    MethodImplAttributes[MethodImplAttributes["InternalCall"] = 4096] = "InternalCall";
    MethodImplAttributes[MethodImplAttributes["MaxMethodImplVal"] = 65535] = "MaxMethodImplVal";
})(MethodImplAttributes || (MethodImplAttributes = {}));
export var CallingConventions;
(function (CallingConventions) {
    CallingConventions[CallingConventions["Standard"] = 1] = "Standard";
    CallingConventions[CallingConventions["VarArgs"] = 2] = "VarArgs";
    CallingConventions[CallingConventions["Any"] = 3] = "Any";
    CallingConventions[CallingConventions["HasThis"] = 32] = "HasThis";
    CallingConventions[CallingConventions["ExplicitThis"] = 64] = "ExplicitThis";
})(CallingConventions || (CallingConventions = {}));
var IntPtr = /** @class */ (function () {
    function IntPtr(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    IntPtr.prototype.init = function (data) {
    };
    IntPtr.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new IntPtr();
        result.init(data);
        return result;
    };
    IntPtr.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        return data;
    };
    return IntPtr;
}());
export { IntPtr };
var RuntimeMethodHandle = /** @class */ (function () {
    function RuntimeMethodHandle(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RuntimeMethodHandle.prototype.init = function (data) {
        if (data) {
            this.value = data["value"] ? IntPtr.fromJS(data["value"]) : undefined;
        }
    };
    RuntimeMethodHandle.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RuntimeMethodHandle();
        result.init(data);
        return result;
    };
    RuntimeMethodHandle.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : undefined;
        return data;
    };
    return RuntimeMethodHandle;
}());
export { RuntimeMethodHandle };
var ModuleHandle = /** @class */ (function () {
    function ModuleHandle(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ModuleHandle.prototype.init = function (data) {
        if (data) {
            this.mdStreamVersion = data["mdStreamVersion"];
        }
    };
    ModuleHandle.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ModuleHandle();
        result.init(data);
        return result;
    };
    ModuleHandle.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["mdStreamVersion"] = this.mdStreamVersion;
        return data;
    };
    return ModuleHandle;
}());
export { ModuleHandle };
var CustomAttributeTypedArgument = /** @class */ (function () {
    function CustomAttributeTypedArgument(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CustomAttributeTypedArgument.prototype.init = function (data) {
        if (data) {
            this.argumentType = data["argumentType"] ? Type.fromJS(data["argumentType"]) : undefined;
            this.value = data["value"];
        }
    };
    CustomAttributeTypedArgument.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CustomAttributeTypedArgument();
        result.init(data);
        return result;
    };
    CustomAttributeTypedArgument.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["argumentType"] = this.argumentType ? this.argumentType.toJSON() : undefined;
        data["value"] = this.value;
        return data;
    };
    return CustomAttributeTypedArgument;
}());
export { CustomAttributeTypedArgument };
var MemberInfo = /** @class */ (function () {
    function MemberInfo(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MemberInfo.prototype.init = function (data) {
        if (data) {
            this.memberType = data["memberType"];
            this.declaringType = data["declaringType"] ? Type.fromJS(data["declaringType"]) : undefined;
            this.reflectedType = data["reflectedType"] ? Type.fromJS(data["reflectedType"]) : undefined;
            this.name = data["name"];
            this.module = data["module"] ? Module.fromJS(data["module"]) : undefined;
            if (Array.isArray(data["customAttributes"])) {
                this.customAttributes = [];
                for (var _i = 0, _a = data["customAttributes"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.customAttributes.push(CustomAttributeData.fromJS(item));
                }
            }
            this.isCollectible = data["isCollectible"];
            this.metadataToken = data["metadataToken"];
        }
    };
    MemberInfo.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new MemberInfo();
        result.init(data);
        return result;
    };
    MemberInfo.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["memberType"] = this.memberType;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : undefined;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : undefined;
        data["name"] = this.name;
        data["module"] = this.module ? this.module.toJSON() : undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (var _i = 0, _a = this.customAttributes; _i < _a.length; _i++) {
                var item = _a[_i];
                data["customAttributes"].push(item.toJSON());
            }
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        return data;
    };
    return MemberInfo;
}());
export { MemberInfo };
var CustomAttributeNamedArgument = /** @class */ (function () {
    function CustomAttributeNamedArgument(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CustomAttributeNamedArgument.prototype.init = function (data) {
        if (data) {
            this.memberInfo = data["memberInfo"] ? MemberInfo.fromJS(data["memberInfo"]) : undefined;
            this.typedValue = data["typedValue"] ? CustomAttributeTypedArgument.fromJS(data["typedValue"]) : undefined;
            this.memberName = data["memberName"];
            this.isField = data["isField"];
        }
    };
    CustomAttributeNamedArgument.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CustomAttributeNamedArgument();
        result.init(data);
        return result;
    };
    CustomAttributeNamedArgument.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["memberInfo"] = this.memberInfo ? this.memberInfo.toJSON() : undefined;
        data["typedValue"] = this.typedValue ? this.typedValue.toJSON() : undefined;
        data["memberName"] = this.memberName;
        data["isField"] = this.isField;
        return data;
    };
    return CustomAttributeNamedArgument;
}());
export { CustomAttributeNamedArgument };
var CustomAttributeData = /** @class */ (function () {
    function CustomAttributeData(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CustomAttributeData.prototype.init = function (data) {
        if (data) {
            this.attributeType = data["attributeType"] ? Type.fromJS(data["attributeType"]) : undefined;
            this.constructor_ = data["constructor"] ? ConstructorInfo.fromJS(data["constructor"]) : undefined;
            if (Array.isArray(data["constructorArguments"])) {
                this.constructorArguments = [];
                for (var _i = 0, _a = data["constructorArguments"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.constructorArguments.push(CustomAttributeTypedArgument.fromJS(item));
                }
            }
            if (Array.isArray(data["namedArguments"])) {
                this.namedArguments = [];
                for (var _b = 0, _c = data["namedArguments"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.namedArguments.push(CustomAttributeNamedArgument.fromJS(item));
                }
            }
        }
    };
    CustomAttributeData.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CustomAttributeData();
        result.init(data);
        return result;
    };
    CustomAttributeData.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["attributeType"] = this.attributeType ? this.attributeType.toJSON() : undefined;
        data["constructor"] = this.constructor_ ? this.constructor_.toJSON() : undefined;
        if (Array.isArray(this.constructorArguments)) {
            data["constructorArguments"] = [];
            for (var _i = 0, _a = this.constructorArguments; _i < _a.length; _i++) {
                var item = _a[_i];
                data["constructorArguments"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.namedArguments)) {
            data["namedArguments"] = [];
            for (var _b = 0, _c = this.namedArguments; _b < _c.length; _b++) {
                var item = _c[_b];
                data["namedArguments"].push(item.toJSON());
            }
        }
        return data;
    };
    return CustomAttributeData;
}());
export { CustomAttributeData };
var Module = /** @class */ (function () {
    function Module(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Module.prototype.init = function (data) {
        if (data) {
            this.assembly = data["assembly"] ? Assembly.fromJS(data["assembly"]) : undefined;
            this.fullyQualifiedName = data["fullyQualifiedName"];
            this.name = data["name"];
            this.mdStreamVersion = data["mdStreamVersion"];
            this.moduleVersionId = data["moduleVersionId"];
            this.scopeName = data["scopeName"];
            this.moduleHandle = data["moduleHandle"] ? ModuleHandle.fromJS(data["moduleHandle"]) : undefined;
            if (Array.isArray(data["customAttributes"])) {
                this.customAttributes = [];
                for (var _i = 0, _a = data["customAttributes"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.customAttributes.push(CustomAttributeData.fromJS(item));
                }
            }
            this.metadataToken = data["metadataToken"];
        }
    };
    Module.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Module();
        result.init(data);
        return result;
    };
    Module.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["assembly"] = this.assembly ? this.assembly.toJSON() : undefined;
        data["fullyQualifiedName"] = this.fullyQualifiedName;
        data["name"] = this.name;
        data["mdStreamVersion"] = this.mdStreamVersion;
        data["moduleVersionId"] = this.moduleVersionId;
        data["scopeName"] = this.scopeName;
        data["moduleHandle"] = this.moduleHandle ? this.moduleHandle.toJSON() : undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (var _i = 0, _a = this.customAttributes; _i < _a.length; _i++) {
                var item = _a[_i];
                data["customAttributes"].push(item.toJSON());
            }
        }
        data["metadataToken"] = this.metadataToken;
        return data;
    };
    return Module;
}());
export { Module };
var ConstructorInfo = /** @class */ (function () {
    function ConstructorInfo(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ConstructorInfo.prototype.init = function (data) {
        if (data) {
            this.memberType = data["memberType"];
            this.attributes = data["attributes"];
            this.methodImplementationFlags = data["methodImplementationFlags"];
            this.callingConvention = data["callingConvention"];
            this.isAbstract = data["isAbstract"];
            this.isConstructor = data["isConstructor"];
            this.isFinal = data["isFinal"];
            this.isHideBySig = data["isHideBySig"];
            this.isSpecialName = data["isSpecialName"];
            this.isStatic = data["isStatic"];
            this.isVirtual = data["isVirtual"];
            this.isAssembly = data["isAssembly"];
            this.isFamily = data["isFamily"];
            this.isFamilyAndAssembly = data["isFamilyAndAssembly"];
            this.isFamilyOrAssembly = data["isFamilyOrAssembly"];
            this.isPrivate = data["isPrivate"];
            this.isPublic = data["isPublic"];
            this.isConstructedGenericMethod = data["isConstructedGenericMethod"];
            this.isGenericMethod = data["isGenericMethod"];
            this.isGenericMethodDefinition = data["isGenericMethodDefinition"];
            this.containsGenericParameters = data["containsGenericParameters"];
            this.methodHandle = data["methodHandle"] ? RuntimeMethodHandle.fromJS(data["methodHandle"]) : undefined;
            this.isSecurityCritical = data["isSecurityCritical"];
            this.isSecuritySafeCritical = data["isSecuritySafeCritical"];
            this.isSecurityTransparent = data["isSecurityTransparent"];
            this.name = data["name"];
            this.declaringType = data["declaringType"] ? Type.fromJS(data["declaringType"]) : undefined;
            this.reflectedType = data["reflectedType"] ? Type.fromJS(data["reflectedType"]) : undefined;
            this.module = data["module"] ? Module.fromJS(data["module"]) : undefined;
            if (Array.isArray(data["customAttributes"])) {
                this.customAttributes = [];
                for (var _i = 0, _a = data["customAttributes"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.customAttributes.push(CustomAttributeData.fromJS(item));
                }
            }
            this.isCollectible = data["isCollectible"];
            this.metadataToken = data["metadataToken"];
        }
    };
    ConstructorInfo.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ConstructorInfo();
        result.init(data);
        return result;
    };
    ConstructorInfo.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["memberType"] = this.memberType;
        data["attributes"] = this.attributes;
        data["methodImplementationFlags"] = this.methodImplementationFlags;
        data["callingConvention"] = this.callingConvention;
        data["isAbstract"] = this.isAbstract;
        data["isConstructor"] = this.isConstructor;
        data["isFinal"] = this.isFinal;
        data["isHideBySig"] = this.isHideBySig;
        data["isSpecialName"] = this.isSpecialName;
        data["isStatic"] = this.isStatic;
        data["isVirtual"] = this.isVirtual;
        data["isAssembly"] = this.isAssembly;
        data["isFamily"] = this.isFamily;
        data["isFamilyAndAssembly"] = this.isFamilyAndAssembly;
        data["isFamilyOrAssembly"] = this.isFamilyOrAssembly;
        data["isPrivate"] = this.isPrivate;
        data["isPublic"] = this.isPublic;
        data["isConstructedGenericMethod"] = this.isConstructedGenericMethod;
        data["isGenericMethod"] = this.isGenericMethod;
        data["isGenericMethodDefinition"] = this.isGenericMethodDefinition;
        data["containsGenericParameters"] = this.containsGenericParameters;
        data["methodHandle"] = this.methodHandle ? this.methodHandle.toJSON() : undefined;
        data["isSecurityCritical"] = this.isSecurityCritical;
        data["isSecuritySafeCritical"] = this.isSecuritySafeCritical;
        data["isSecurityTransparent"] = this.isSecurityTransparent;
        data["name"] = this.name;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : undefined;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : undefined;
        data["module"] = this.module ? this.module.toJSON() : undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (var _i = 0, _a = this.customAttributes; _i < _a.length; _i++) {
                var item = _a[_i];
                data["customAttributes"].push(item.toJSON());
            }
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        return data;
    };
    return ConstructorInfo;
}());
export { ConstructorInfo };
export var EventAttributes;
(function (EventAttributes) {
    EventAttributes[EventAttributes["None"] = 0] = "None";
    EventAttributes[EventAttributes["SpecialName"] = 512] = "SpecialName";
    EventAttributes[EventAttributes["RTSpecialName"] = 1024] = "RTSpecialName";
    EventAttributes[EventAttributes["ReservedMask"] = 1024] = "ReservedMask";
})(EventAttributes || (EventAttributes = {}));
export var ParameterAttributes;
(function (ParameterAttributes) {
    ParameterAttributes[ParameterAttributes["None"] = 0] = "None";
    ParameterAttributes[ParameterAttributes["In"] = 1] = "In";
    ParameterAttributes[ParameterAttributes["Out"] = 2] = "Out";
    ParameterAttributes[ParameterAttributes["Lcid"] = 4] = "Lcid";
    ParameterAttributes[ParameterAttributes["Retval"] = 8] = "Retval";
    ParameterAttributes[ParameterAttributes["Optional"] = 16] = "Optional";
    ParameterAttributes[ParameterAttributes["HasDefault"] = 4096] = "HasDefault";
    ParameterAttributes[ParameterAttributes["HasFieldMarshal"] = 8192] = "HasFieldMarshal";
    ParameterAttributes[ParameterAttributes["Reserved3"] = 16384] = "Reserved3";
    ParameterAttributes[ParameterAttributes["Reserved4"] = 32768] = "Reserved4";
    ParameterAttributes[ParameterAttributes["ReservedMask"] = 61440] = "ReservedMask";
})(ParameterAttributes || (ParameterAttributes = {}));
var ParameterInfo = /** @class */ (function () {
    function ParameterInfo(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ParameterInfo.prototype.init = function (data) {
        if (data) {
            this.attributes = data["attributes"];
            this.member = data["member"] ? MemberInfo.fromJS(data["member"]) : undefined;
            this.name = data["name"];
            this.parameterType = data["parameterType"] ? Type.fromJS(data["parameterType"]) : undefined;
            this.position = data["position"];
            this.isIn = data["isIn"];
            this.isLcid = data["isLcid"];
            this.isOptional = data["isOptional"];
            this.isOut = data["isOut"];
            this.isRetval = data["isRetval"];
            this.defaultValue = data["defaultValue"];
            this.rawDefaultValue = data["rawDefaultValue"];
            this.hasDefaultValue = data["hasDefaultValue"];
            if (Array.isArray(data["customAttributes"])) {
                this.customAttributes = [];
                for (var _i = 0, _a = data["customAttributes"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.customAttributes.push(CustomAttributeData.fromJS(item));
                }
            }
            this.metadataToken = data["metadataToken"];
        }
    };
    ParameterInfo.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ParameterInfo();
        result.init(data);
        return result;
    };
    ParameterInfo.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["attributes"] = this.attributes;
        data["member"] = this.member ? this.member.toJSON() : undefined;
        data["name"] = this.name;
        data["parameterType"] = this.parameterType ? this.parameterType.toJSON() : undefined;
        data["position"] = this.position;
        data["isIn"] = this.isIn;
        data["isLcid"] = this.isLcid;
        data["isOptional"] = this.isOptional;
        data["isOut"] = this.isOut;
        data["isRetval"] = this.isRetval;
        data["defaultValue"] = this.defaultValue;
        data["rawDefaultValue"] = this.rawDefaultValue;
        data["hasDefaultValue"] = this.hasDefaultValue;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (var _i = 0, _a = this.customAttributes; _i < _a.length; _i++) {
                var item = _a[_i];
                data["customAttributes"].push(item.toJSON());
            }
        }
        data["metadataToken"] = this.metadataToken;
        return data;
    };
    return ParameterInfo;
}());
export { ParameterInfo };
var ICustomAttributeProvider = /** @class */ (function () {
    function ICustomAttributeProvider(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ICustomAttributeProvider.prototype.init = function (data) {
    };
    ICustomAttributeProvider.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ICustomAttributeProvider();
        result.init(data);
        return result;
    };
    ICustomAttributeProvider.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        return data;
    };
    return ICustomAttributeProvider;
}());
export { ICustomAttributeProvider };
var MethodInfo = /** @class */ (function () {
    function MethodInfo(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MethodInfo.prototype.init = function (data) {
        if (data) {
            this.memberType = data["memberType"];
            this.returnParameter = data["returnParameter"] ? ParameterInfo.fromJS(data["returnParameter"]) : undefined;
            this.returnType = data["returnType"] ? Type.fromJS(data["returnType"]) : undefined;
            this.returnTypeCustomAttributes = data["returnTypeCustomAttributes"] ? ICustomAttributeProvider.fromJS(data["returnTypeCustomAttributes"]) : undefined;
            this.attributes = data["attributes"];
            this.methodImplementationFlags = data["methodImplementationFlags"];
            this.callingConvention = data["callingConvention"];
            this.isAbstract = data["isAbstract"];
            this.isConstructor = data["isConstructor"];
            this.isFinal = data["isFinal"];
            this.isHideBySig = data["isHideBySig"];
            this.isSpecialName = data["isSpecialName"];
            this.isStatic = data["isStatic"];
            this.isVirtual = data["isVirtual"];
            this.isAssembly = data["isAssembly"];
            this.isFamily = data["isFamily"];
            this.isFamilyAndAssembly = data["isFamilyAndAssembly"];
            this.isFamilyOrAssembly = data["isFamilyOrAssembly"];
            this.isPrivate = data["isPrivate"];
            this.isPublic = data["isPublic"];
            this.isConstructedGenericMethod = data["isConstructedGenericMethod"];
            this.isGenericMethod = data["isGenericMethod"];
            this.isGenericMethodDefinition = data["isGenericMethodDefinition"];
            this.containsGenericParameters = data["containsGenericParameters"];
            this.methodHandle = data["methodHandle"] ? RuntimeMethodHandle.fromJS(data["methodHandle"]) : undefined;
            this.isSecurityCritical = data["isSecurityCritical"];
            this.isSecuritySafeCritical = data["isSecuritySafeCritical"];
            this.isSecurityTransparent = data["isSecurityTransparent"];
            this.name = data["name"];
            this.declaringType = data["declaringType"] ? Type.fromJS(data["declaringType"]) : undefined;
            this.reflectedType = data["reflectedType"] ? Type.fromJS(data["reflectedType"]) : undefined;
            this.module = data["module"] ? Module.fromJS(data["module"]) : undefined;
            if (Array.isArray(data["customAttributes"])) {
                this.customAttributes = [];
                for (var _i = 0, _a = data["customAttributes"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.customAttributes.push(CustomAttributeData.fromJS(item));
                }
            }
            this.isCollectible = data["isCollectible"];
            this.metadataToken = data["metadataToken"];
        }
    };
    MethodInfo.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new MethodInfo();
        result.init(data);
        return result;
    };
    MethodInfo.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["memberType"] = this.memberType;
        data["returnParameter"] = this.returnParameter ? this.returnParameter.toJSON() : undefined;
        data["returnType"] = this.returnType ? this.returnType.toJSON() : undefined;
        data["returnTypeCustomAttributes"] = this.returnTypeCustomAttributes ? this.returnTypeCustomAttributes.toJSON() : undefined;
        data["attributes"] = this.attributes;
        data["methodImplementationFlags"] = this.methodImplementationFlags;
        data["callingConvention"] = this.callingConvention;
        data["isAbstract"] = this.isAbstract;
        data["isConstructor"] = this.isConstructor;
        data["isFinal"] = this.isFinal;
        data["isHideBySig"] = this.isHideBySig;
        data["isSpecialName"] = this.isSpecialName;
        data["isStatic"] = this.isStatic;
        data["isVirtual"] = this.isVirtual;
        data["isAssembly"] = this.isAssembly;
        data["isFamily"] = this.isFamily;
        data["isFamilyAndAssembly"] = this.isFamilyAndAssembly;
        data["isFamilyOrAssembly"] = this.isFamilyOrAssembly;
        data["isPrivate"] = this.isPrivate;
        data["isPublic"] = this.isPublic;
        data["isConstructedGenericMethod"] = this.isConstructedGenericMethod;
        data["isGenericMethod"] = this.isGenericMethod;
        data["isGenericMethodDefinition"] = this.isGenericMethodDefinition;
        data["containsGenericParameters"] = this.containsGenericParameters;
        data["methodHandle"] = this.methodHandle ? this.methodHandle.toJSON() : undefined;
        data["isSecurityCritical"] = this.isSecurityCritical;
        data["isSecuritySafeCritical"] = this.isSecuritySafeCritical;
        data["isSecurityTransparent"] = this.isSecurityTransparent;
        data["name"] = this.name;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : undefined;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : undefined;
        data["module"] = this.module ? this.module.toJSON() : undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (var _i = 0, _a = this.customAttributes; _i < _a.length; _i++) {
                var item = _a[_i];
                data["customAttributes"].push(item.toJSON());
            }
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        return data;
    };
    return MethodInfo;
}());
export { MethodInfo };
var EventInfo = /** @class */ (function () {
    function EventInfo(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EventInfo.prototype.init = function (data) {
        if (data) {
            this.memberType = data["memberType"];
            this.attributes = data["attributes"];
            this.isSpecialName = data["isSpecialName"];
            this.addMethod = data["addMethod"] ? MethodInfo.fromJS(data["addMethod"]) : undefined;
            this.removeMethod = data["removeMethod"] ? MethodInfo.fromJS(data["removeMethod"]) : undefined;
            this.raiseMethod = data["raiseMethod"] ? MethodInfo.fromJS(data["raiseMethod"]) : undefined;
            this.isMulticast = data["isMulticast"];
            this.eventHandlerType = data["eventHandlerType"] ? Type.fromJS(data["eventHandlerType"]) : undefined;
            this.name = data["name"];
            this.declaringType = data["declaringType"] ? Type.fromJS(data["declaringType"]) : undefined;
            this.reflectedType = data["reflectedType"] ? Type.fromJS(data["reflectedType"]) : undefined;
            this.module = data["module"] ? Module.fromJS(data["module"]) : undefined;
            if (Array.isArray(data["customAttributes"])) {
                this.customAttributes = [];
                for (var _i = 0, _a = data["customAttributes"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.customAttributes.push(CustomAttributeData.fromJS(item));
                }
            }
            this.isCollectible = data["isCollectible"];
            this.metadataToken = data["metadataToken"];
        }
    };
    EventInfo.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new EventInfo();
        result.init(data);
        return result;
    };
    EventInfo.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["memberType"] = this.memberType;
        data["attributes"] = this.attributes;
        data["isSpecialName"] = this.isSpecialName;
        data["addMethod"] = this.addMethod ? this.addMethod.toJSON() : undefined;
        data["removeMethod"] = this.removeMethod ? this.removeMethod.toJSON() : undefined;
        data["raiseMethod"] = this.raiseMethod ? this.raiseMethod.toJSON() : undefined;
        data["isMulticast"] = this.isMulticast;
        data["eventHandlerType"] = this.eventHandlerType ? this.eventHandlerType.toJSON() : undefined;
        data["name"] = this.name;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : undefined;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : undefined;
        data["module"] = this.module ? this.module.toJSON() : undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (var _i = 0, _a = this.customAttributes; _i < _a.length; _i++) {
                var item = _a[_i];
                data["customAttributes"].push(item.toJSON());
            }
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        return data;
    };
    return EventInfo;
}());
export { EventInfo };
export var FieldAttributes;
(function (FieldAttributes) {
    FieldAttributes[FieldAttributes["PrivateScope"] = 0] = "PrivateScope";
    FieldAttributes[FieldAttributes["Private"] = 1] = "Private";
    FieldAttributes[FieldAttributes["FamANDAssem"] = 2] = "FamANDAssem";
    FieldAttributes[FieldAttributes["Assembly"] = 3] = "Assembly";
    FieldAttributes[FieldAttributes["Family"] = 4] = "Family";
    FieldAttributes[FieldAttributes["FamORAssem"] = 5] = "FamORAssem";
    FieldAttributes[FieldAttributes["Public"] = 6] = "Public";
    FieldAttributes[FieldAttributes["FieldAccessMask"] = 7] = "FieldAccessMask";
    FieldAttributes[FieldAttributes["Static"] = 16] = "Static";
    FieldAttributes[FieldAttributes["InitOnly"] = 32] = "InitOnly";
    FieldAttributes[FieldAttributes["Literal"] = 64] = "Literal";
    FieldAttributes[FieldAttributes["NotSerialized"] = 128] = "NotSerialized";
    FieldAttributes[FieldAttributes["HasFieldRVA"] = 256] = "HasFieldRVA";
    FieldAttributes[FieldAttributes["SpecialName"] = 512] = "SpecialName";
    FieldAttributes[FieldAttributes["RTSpecialName"] = 1024] = "RTSpecialName";
    FieldAttributes[FieldAttributes["HasFieldMarshal"] = 4096] = "HasFieldMarshal";
    FieldAttributes[FieldAttributes["PinvokeImpl"] = 8192] = "PinvokeImpl";
    FieldAttributes[FieldAttributes["HasDefault"] = 32768] = "HasDefault";
    FieldAttributes[FieldAttributes["ReservedMask"] = 38144] = "ReservedMask";
})(FieldAttributes || (FieldAttributes = {}));
var RuntimeFieldHandle = /** @class */ (function () {
    function RuntimeFieldHandle(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RuntimeFieldHandle.prototype.init = function (data) {
        if (data) {
            this.value = data["value"] ? IntPtr.fromJS(data["value"]) : undefined;
        }
    };
    RuntimeFieldHandle.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RuntimeFieldHandle();
        result.init(data);
        return result;
    };
    RuntimeFieldHandle.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : undefined;
        return data;
    };
    return RuntimeFieldHandle;
}());
export { RuntimeFieldHandle };
var FieldInfo = /** @class */ (function () {
    function FieldInfo(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FieldInfo.prototype.init = function (data) {
        if (data) {
            this.memberType = data["memberType"];
            this.attributes = data["attributes"];
            this.fieldType = data["fieldType"] ? Type.fromJS(data["fieldType"]) : undefined;
            this.isInitOnly = data["isInitOnly"];
            this.isLiteral = data["isLiteral"];
            this.isNotSerialized = data["isNotSerialized"];
            this.isPinvokeImpl = data["isPinvokeImpl"];
            this.isSpecialName = data["isSpecialName"];
            this.isStatic = data["isStatic"];
            this.isAssembly = data["isAssembly"];
            this.isFamily = data["isFamily"];
            this.isFamilyAndAssembly = data["isFamilyAndAssembly"];
            this.isFamilyOrAssembly = data["isFamilyOrAssembly"];
            this.isPrivate = data["isPrivate"];
            this.isPublic = data["isPublic"];
            this.isSecurityCritical = data["isSecurityCritical"];
            this.isSecuritySafeCritical = data["isSecuritySafeCritical"];
            this.isSecurityTransparent = data["isSecurityTransparent"];
            this.fieldHandle = data["fieldHandle"] ? RuntimeFieldHandle.fromJS(data["fieldHandle"]) : undefined;
            this.name = data["name"];
            this.declaringType = data["declaringType"] ? Type.fromJS(data["declaringType"]) : undefined;
            this.reflectedType = data["reflectedType"] ? Type.fromJS(data["reflectedType"]) : undefined;
            this.module = data["module"] ? Module.fromJS(data["module"]) : undefined;
            if (Array.isArray(data["customAttributes"])) {
                this.customAttributes = [];
                for (var _i = 0, _a = data["customAttributes"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.customAttributes.push(CustomAttributeData.fromJS(item));
                }
            }
            this.isCollectible = data["isCollectible"];
            this.metadataToken = data["metadataToken"];
        }
    };
    FieldInfo.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FieldInfo();
        result.init(data);
        return result;
    };
    FieldInfo.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["memberType"] = this.memberType;
        data["attributes"] = this.attributes;
        data["fieldType"] = this.fieldType ? this.fieldType.toJSON() : undefined;
        data["isInitOnly"] = this.isInitOnly;
        data["isLiteral"] = this.isLiteral;
        data["isNotSerialized"] = this.isNotSerialized;
        data["isPinvokeImpl"] = this.isPinvokeImpl;
        data["isSpecialName"] = this.isSpecialName;
        data["isStatic"] = this.isStatic;
        data["isAssembly"] = this.isAssembly;
        data["isFamily"] = this.isFamily;
        data["isFamilyAndAssembly"] = this.isFamilyAndAssembly;
        data["isFamilyOrAssembly"] = this.isFamilyOrAssembly;
        data["isPrivate"] = this.isPrivate;
        data["isPublic"] = this.isPublic;
        data["isSecurityCritical"] = this.isSecurityCritical;
        data["isSecuritySafeCritical"] = this.isSecuritySafeCritical;
        data["isSecurityTransparent"] = this.isSecurityTransparent;
        data["fieldHandle"] = this.fieldHandle ? this.fieldHandle.toJSON() : undefined;
        data["name"] = this.name;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : undefined;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : undefined;
        data["module"] = this.module ? this.module.toJSON() : undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (var _i = 0, _a = this.customAttributes; _i < _a.length; _i++) {
                var item = _a[_i];
                data["customAttributes"].push(item.toJSON());
            }
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        return data;
    };
    return FieldInfo;
}());
export { FieldInfo };
export var PropertyAttributes;
(function (PropertyAttributes) {
    PropertyAttributes[PropertyAttributes["None"] = 0] = "None";
    PropertyAttributes[PropertyAttributes["SpecialName"] = 512] = "SpecialName";
    PropertyAttributes[PropertyAttributes["RTSpecialName"] = 1024] = "RTSpecialName";
    PropertyAttributes[PropertyAttributes["HasDefault"] = 4096] = "HasDefault";
    PropertyAttributes[PropertyAttributes["Reserved2"] = 8192] = "Reserved2";
    PropertyAttributes[PropertyAttributes["Reserved3"] = 16384] = "Reserved3";
    PropertyAttributes[PropertyAttributes["Reserved4"] = 32768] = "Reserved4";
    PropertyAttributes[PropertyAttributes["ReservedMask"] = 62464] = "ReservedMask";
})(PropertyAttributes || (PropertyAttributes = {}));
var PropertyInfo = /** @class */ (function () {
    function PropertyInfo(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PropertyInfo.prototype.init = function (data) {
        if (data) {
            this.memberType = data["memberType"];
            this.propertyType = data["propertyType"] ? Type.fromJS(data["propertyType"]) : undefined;
            this.attributes = data["attributes"];
            this.isSpecialName = data["isSpecialName"];
            this.canRead = data["canRead"];
            this.canWrite = data["canWrite"];
            this.getMethod = data["getMethod"] ? MethodInfo.fromJS(data["getMethod"]) : undefined;
            this.setMethod = data["setMethod"] ? MethodInfo.fromJS(data["setMethod"]) : undefined;
            this.name = data["name"];
            this.declaringType = data["declaringType"] ? Type.fromJS(data["declaringType"]) : undefined;
            this.reflectedType = data["reflectedType"] ? Type.fromJS(data["reflectedType"]) : undefined;
            this.module = data["module"] ? Module.fromJS(data["module"]) : undefined;
            if (Array.isArray(data["customAttributes"])) {
                this.customAttributes = [];
                for (var _i = 0, _a = data["customAttributes"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.customAttributes.push(CustomAttributeData.fromJS(item));
                }
            }
            this.isCollectible = data["isCollectible"];
            this.metadataToken = data["metadataToken"];
        }
    };
    PropertyInfo.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PropertyInfo();
        result.init(data);
        return result;
    };
    PropertyInfo.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["memberType"] = this.memberType;
        data["propertyType"] = this.propertyType ? this.propertyType.toJSON() : undefined;
        data["attributes"] = this.attributes;
        data["isSpecialName"] = this.isSpecialName;
        data["canRead"] = this.canRead;
        data["canWrite"] = this.canWrite;
        data["getMethod"] = this.getMethod ? this.getMethod.toJSON() : undefined;
        data["setMethod"] = this.setMethod ? this.setMethod.toJSON() : undefined;
        data["name"] = this.name;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : undefined;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : undefined;
        data["module"] = this.module ? this.module.toJSON() : undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (var _i = 0, _a = this.customAttributes; _i < _a.length; _i++) {
                var item = _a[_i];
                data["customAttributes"].push(item.toJSON());
            }
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        return data;
    };
    return PropertyInfo;
}());
export { PropertyInfo };
var MethodBase = /** @class */ (function () {
    function MethodBase(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MethodBase.prototype.init = function (data) {
        if (data) {
            this.attributes = data["attributes"];
            this.methodImplementationFlags = data["methodImplementationFlags"];
            this.callingConvention = data["callingConvention"];
            this.isAbstract = data["isAbstract"];
            this.isConstructor = data["isConstructor"];
            this.isFinal = data["isFinal"];
            this.isHideBySig = data["isHideBySig"];
            this.isSpecialName = data["isSpecialName"];
            this.isStatic = data["isStatic"];
            this.isVirtual = data["isVirtual"];
            this.isAssembly = data["isAssembly"];
            this.isFamily = data["isFamily"];
            this.isFamilyAndAssembly = data["isFamilyAndAssembly"];
            this.isFamilyOrAssembly = data["isFamilyOrAssembly"];
            this.isPrivate = data["isPrivate"];
            this.isPublic = data["isPublic"];
            this.isConstructedGenericMethod = data["isConstructedGenericMethod"];
            this.isGenericMethod = data["isGenericMethod"];
            this.isGenericMethodDefinition = data["isGenericMethodDefinition"];
            this.containsGenericParameters = data["containsGenericParameters"];
            this.methodHandle = data["methodHandle"] ? RuntimeMethodHandle.fromJS(data["methodHandle"]) : undefined;
            this.isSecurityCritical = data["isSecurityCritical"];
            this.isSecuritySafeCritical = data["isSecuritySafeCritical"];
            this.isSecurityTransparent = data["isSecurityTransparent"];
            this.memberType = data["memberType"];
            this.name = data["name"];
            this.declaringType = data["declaringType"] ? Type.fromJS(data["declaringType"]) : undefined;
            this.reflectedType = data["reflectedType"] ? Type.fromJS(data["reflectedType"]) : undefined;
            this.module = data["module"] ? Module.fromJS(data["module"]) : undefined;
            if (Array.isArray(data["customAttributes"])) {
                this.customAttributes = [];
                for (var _i = 0, _a = data["customAttributes"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.customAttributes.push(CustomAttributeData.fromJS(item));
                }
            }
            this.isCollectible = data["isCollectible"];
            this.metadataToken = data["metadataToken"];
        }
    };
    MethodBase.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new MethodBase();
        result.init(data);
        return result;
    };
    MethodBase.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["attributes"] = this.attributes;
        data["methodImplementationFlags"] = this.methodImplementationFlags;
        data["callingConvention"] = this.callingConvention;
        data["isAbstract"] = this.isAbstract;
        data["isConstructor"] = this.isConstructor;
        data["isFinal"] = this.isFinal;
        data["isHideBySig"] = this.isHideBySig;
        data["isSpecialName"] = this.isSpecialName;
        data["isStatic"] = this.isStatic;
        data["isVirtual"] = this.isVirtual;
        data["isAssembly"] = this.isAssembly;
        data["isFamily"] = this.isFamily;
        data["isFamilyAndAssembly"] = this.isFamilyAndAssembly;
        data["isFamilyOrAssembly"] = this.isFamilyOrAssembly;
        data["isPrivate"] = this.isPrivate;
        data["isPublic"] = this.isPublic;
        data["isConstructedGenericMethod"] = this.isConstructedGenericMethod;
        data["isGenericMethod"] = this.isGenericMethod;
        data["isGenericMethodDefinition"] = this.isGenericMethodDefinition;
        data["containsGenericParameters"] = this.containsGenericParameters;
        data["methodHandle"] = this.methodHandle ? this.methodHandle.toJSON() : undefined;
        data["isSecurityCritical"] = this.isSecurityCritical;
        data["isSecuritySafeCritical"] = this.isSecuritySafeCritical;
        data["isSecurityTransparent"] = this.isSecurityTransparent;
        data["memberType"] = this.memberType;
        data["name"] = this.name;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : undefined;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : undefined;
        data["module"] = this.module ? this.module.toJSON() : undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (var _i = 0, _a = this.customAttributes; _i < _a.length; _i++) {
                var item = _a[_i];
                data["customAttributes"].push(item.toJSON());
            }
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        return data;
    };
    return MethodBase;
}());
export { MethodBase };
export var GenericParameterAttributes;
(function (GenericParameterAttributes) {
    GenericParameterAttributes[GenericParameterAttributes["None"] = 0] = "None";
    GenericParameterAttributes[GenericParameterAttributes["Covariant"] = 1] = "Covariant";
    GenericParameterAttributes[GenericParameterAttributes["Contravariant"] = 2] = "Contravariant";
    GenericParameterAttributes[GenericParameterAttributes["VarianceMask"] = 3] = "VarianceMask";
    GenericParameterAttributes[GenericParameterAttributes["ReferenceTypeConstraint"] = 4] = "ReferenceTypeConstraint";
    GenericParameterAttributes[GenericParameterAttributes["NotNullableValueTypeConstraint"] = 8] = "NotNullableValueTypeConstraint";
    GenericParameterAttributes[GenericParameterAttributes["DefaultConstructorConstraint"] = 16] = "DefaultConstructorConstraint";
    GenericParameterAttributes[GenericParameterAttributes["SpecialConstraintMask"] = 28] = "SpecialConstraintMask";
})(GenericParameterAttributes || (GenericParameterAttributes = {}));
export var TypeAttributes;
(function (TypeAttributes) {
    TypeAttributes[TypeAttributes["NotPublic"] = 0] = "NotPublic";
    TypeAttributes[TypeAttributes["AutoLayout"] = 0] = "AutoLayout";
    TypeAttributes[TypeAttributes["AnsiClass"] = 0] = "AnsiClass";
    TypeAttributes[TypeAttributes["Class"] = 0] = "Class";
    TypeAttributes[TypeAttributes["Public"] = 1] = "Public";
    TypeAttributes[TypeAttributes["NestedPublic"] = 2] = "NestedPublic";
    TypeAttributes[TypeAttributes["NestedPrivate"] = 3] = "NestedPrivate";
    TypeAttributes[TypeAttributes["NestedFamily"] = 4] = "NestedFamily";
    TypeAttributes[TypeAttributes["NestedAssembly"] = 5] = "NestedAssembly";
    TypeAttributes[TypeAttributes["NestedFamANDAssem"] = 6] = "NestedFamANDAssem";
    TypeAttributes[TypeAttributes["NestedFamORAssem"] = 7] = "NestedFamORAssem";
    TypeAttributes[TypeAttributes["VisibilityMask"] = 7] = "VisibilityMask";
    TypeAttributes[TypeAttributes["SequentialLayout"] = 8] = "SequentialLayout";
    TypeAttributes[TypeAttributes["ExplicitLayout"] = 16] = "ExplicitLayout";
    TypeAttributes[TypeAttributes["LayoutMask"] = 24] = "LayoutMask";
    TypeAttributes[TypeAttributes["Interface"] = 32] = "Interface";
    TypeAttributes[TypeAttributes["ClassSemanticsMask"] = 32] = "ClassSemanticsMask";
    TypeAttributes[TypeAttributes["Abstract"] = 128] = "Abstract";
    TypeAttributes[TypeAttributes["Sealed"] = 256] = "Sealed";
    TypeAttributes[TypeAttributes["SpecialName"] = 1024] = "SpecialName";
    TypeAttributes[TypeAttributes["RTSpecialName"] = 2048] = "RTSpecialName";
    TypeAttributes[TypeAttributes["Import"] = 4096] = "Import";
    TypeAttributes[TypeAttributes["Serializable"] = 8192] = "Serializable";
    TypeAttributes[TypeAttributes["WindowsRuntime"] = 16384] = "WindowsRuntime";
    TypeAttributes[TypeAttributes["UnicodeClass"] = 65536] = "UnicodeClass";
    TypeAttributes[TypeAttributes["AutoClass"] = 131072] = "AutoClass";
    TypeAttributes[TypeAttributes["CustomFormatClass"] = 196608] = "CustomFormatClass";
    TypeAttributes[TypeAttributes["StringFormatMask"] = 196608] = "StringFormatMask";
    TypeAttributes[TypeAttributes["HasSecurity"] = 262144] = "HasSecurity";
    TypeAttributes[TypeAttributes["ReservedMask"] = 264192] = "ReservedMask";
    TypeAttributes[TypeAttributes["BeforeFieldInit"] = 1048576] = "BeforeFieldInit";
    TypeAttributes[TypeAttributes["CustomFormatMask"] = 12582912] = "CustomFormatMask";
})(TypeAttributes || (TypeAttributes = {}));
export var LayoutKind;
(function (LayoutKind) {
    LayoutKind[LayoutKind["Sequential"] = 0] = "Sequential";
    LayoutKind[LayoutKind["Explicit"] = 2] = "Explicit";
    LayoutKind[LayoutKind["Auto"] = 3] = "Auto";
})(LayoutKind || (LayoutKind = {}));
var StructLayoutAttribute = /** @class */ (function () {
    function StructLayoutAttribute(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    StructLayoutAttribute.prototype.init = function (data) {
        if (data) {
            this.value = data["value"];
            this.typeId = data["typeId"];
        }
    };
    StructLayoutAttribute.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new StructLayoutAttribute();
        result.init(data);
        return result;
    };
    StructLayoutAttribute.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["typeId"] = this.typeId;
        return data;
    };
    return StructLayoutAttribute;
}());
export { StructLayoutAttribute };
var RuntimeTypeHandle = /** @class */ (function () {
    function RuntimeTypeHandle(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RuntimeTypeHandle.prototype.init = function (data) {
        if (data) {
            this.value = data["value"] ? IntPtr.fromJS(data["value"]) : undefined;
        }
    };
    RuntimeTypeHandle.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RuntimeTypeHandle();
        result.init(data);
        return result;
    };
    RuntimeTypeHandle.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : undefined;
        return data;
    };
    return RuntimeTypeHandle;
}());
export { RuntimeTypeHandle };
var TypeInfo = /** @class */ (function () {
    function TypeInfo(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TypeInfo.prototype.init = function (data) {
        if (data) {
            if (Array.isArray(data["genericTypeParameters"])) {
                this.genericTypeParameters = [];
                for (var _i = 0, _a = data["genericTypeParameters"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.genericTypeParameters.push(Type.fromJS(item));
                }
            }
            if (Array.isArray(data["declaredConstructors"])) {
                this.declaredConstructors = [];
                for (var _b = 0, _c = data["declaredConstructors"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.declaredConstructors.push(ConstructorInfo.fromJS(item));
                }
            }
            if (Array.isArray(data["declaredEvents"])) {
                this.declaredEvents = [];
                for (var _d = 0, _e = data["declaredEvents"]; _d < _e.length; _d++) {
                    var item = _e[_d];
                    this.declaredEvents.push(EventInfo.fromJS(item));
                }
            }
            if (Array.isArray(data["declaredFields"])) {
                this.declaredFields = [];
                for (var _f = 0, _g = data["declaredFields"]; _f < _g.length; _f++) {
                    var item = _g[_f];
                    this.declaredFields.push(FieldInfo.fromJS(item));
                }
            }
            if (Array.isArray(data["declaredMembers"])) {
                this.declaredMembers = [];
                for (var _h = 0, _j = data["declaredMembers"]; _h < _j.length; _h++) {
                    var item = _j[_h];
                    this.declaredMembers.push(MemberInfo.fromJS(item));
                }
            }
            if (Array.isArray(data["declaredMethods"])) {
                this.declaredMethods = [];
                for (var _k = 0, _l = data["declaredMethods"]; _k < _l.length; _k++) {
                    var item = _l[_k];
                    this.declaredMethods.push(MethodInfo.fromJS(item));
                }
            }
            if (Array.isArray(data["declaredNestedTypes"])) {
                this.declaredNestedTypes = [];
                for (var _m = 0, _o = data["declaredNestedTypes"]; _m < _o.length; _m++) {
                    var item = _o[_m];
                    this.declaredNestedTypes.push(TypeInfo.fromJS(item));
                }
            }
            if (Array.isArray(data["declaredProperties"])) {
                this.declaredProperties = [];
                for (var _p = 0, _q = data["declaredProperties"]; _p < _q.length; _p++) {
                    var item = _q[_p];
                    this.declaredProperties.push(PropertyInfo.fromJS(item));
                }
            }
            if (Array.isArray(data["implementedInterfaces"])) {
                this.implementedInterfaces = [];
                for (var _r = 0, _s = data["implementedInterfaces"]; _r < _s.length; _r++) {
                    var item = _s[_r];
                    this.implementedInterfaces.push(Type.fromJS(item));
                }
            }
            this.isInterface = data["isInterface"];
            this.memberType = data["memberType"];
            this.namespace = data["namespace"];
            this.assemblyQualifiedName = data["assemblyQualifiedName"];
            this.fullName = data["fullName"];
            this.assembly = data["assembly"] ? Assembly.fromJS(data["assembly"]) : undefined;
            this.module = data["module"] ? Module.fromJS(data["module"]) : undefined;
            this.isNested = data["isNested"];
            this.declaringType = data["declaringType"] ? Type.fromJS(data["declaringType"]) : undefined;
            this.declaringMethod = data["declaringMethod"] ? MethodBase.fromJS(data["declaringMethod"]) : undefined;
            this.reflectedType = data["reflectedType"] ? Type.fromJS(data["reflectedType"]) : undefined;
            this.underlyingSystemType = data["underlyingSystemType"] ? Type.fromJS(data["underlyingSystemType"]) : undefined;
            this.isTypeDefinition = data["isTypeDefinition"];
            this.isArray = data["isArray"];
            this.isByRef = data["isByRef"];
            this.isPointer = data["isPointer"];
            this.isConstructedGenericType = data["isConstructedGenericType"];
            this.isGenericParameter = data["isGenericParameter"];
            this.isGenericTypeParameter = data["isGenericTypeParameter"];
            this.isGenericMethodParameter = data["isGenericMethodParameter"];
            this.isGenericType = data["isGenericType"];
            this.isGenericTypeDefinition = data["isGenericTypeDefinition"];
            this.isSZArray = data["isSZArray"];
            this.isVariableBoundArray = data["isVariableBoundArray"];
            this.isByRefLike = data["isByRefLike"];
            this.hasElementType = data["hasElementType"];
            if (Array.isArray(data["genericTypeArguments"])) {
                this.genericTypeArguments = [];
                for (var _t = 0, _u = data["genericTypeArguments"]; _t < _u.length; _t++) {
                    var item = _u[_t];
                    this.genericTypeArguments.push(Type.fromJS(item));
                }
            }
            this.genericParameterPosition = data["genericParameterPosition"];
            this.genericParameterAttributes = data["genericParameterAttributes"];
            this.attributes = data["attributes"];
            this.isAbstract = data["isAbstract"];
            this.isImport = data["isImport"];
            this.isSealed = data["isSealed"];
            this.isSpecialName = data["isSpecialName"];
            this.isClass = data["isClass"];
            this.isNestedAssembly = data["isNestedAssembly"];
            this.isNestedFamANDAssem = data["isNestedFamANDAssem"];
            this.isNestedFamily = data["isNestedFamily"];
            this.isNestedFamORAssem = data["isNestedFamORAssem"];
            this.isNestedPrivate = data["isNestedPrivate"];
            this.isNestedPublic = data["isNestedPublic"];
            this.isNotPublic = data["isNotPublic"];
            this.isPublic = data["isPublic"];
            this.isAutoLayout = data["isAutoLayout"];
            this.isExplicitLayout = data["isExplicitLayout"];
            this.isLayoutSequential = data["isLayoutSequential"];
            this.isAnsiClass = data["isAnsiClass"];
            this.isAutoClass = data["isAutoClass"];
            this.isUnicodeClass = data["isUnicodeClass"];
            this.isCOMObject = data["isCOMObject"];
            this.isContextful = data["isContextful"];
            this.isEnum = data["isEnum"];
            this.isMarshalByRef = data["isMarshalByRef"];
            this.isPrimitive = data["isPrimitive"];
            this.isValueType = data["isValueType"];
            this.isSignatureType = data["isSignatureType"];
            this.isSecurityCritical = data["isSecurityCritical"];
            this.isSecuritySafeCritical = data["isSecuritySafeCritical"];
            this.isSecurityTransparent = data["isSecurityTransparent"];
            this.structLayoutAttribute = data["structLayoutAttribute"] ? StructLayoutAttribute.fromJS(data["structLayoutAttribute"]) : undefined;
            this.typeInitializer = data["typeInitializer"] ? ConstructorInfo.fromJS(data["typeInitializer"]) : undefined;
            this.typeHandle = data["typeHandle"] ? RuntimeTypeHandle.fromJS(data["typeHandle"]) : undefined;
            this.guid = data["guid"];
            this.baseType = data["baseType"] ? Type.fromJS(data["baseType"]) : undefined;
            this.isSerializable = data["isSerializable"];
            this.containsGenericParameters = data["containsGenericParameters"];
            this.isVisible = data["isVisible"];
            this.name = data["name"];
            if (Array.isArray(data["customAttributes"])) {
                this.customAttributes = [];
                for (var _v = 0, _w = data["customAttributes"]; _v < _w.length; _v++) {
                    var item = _w[_v];
                    this.customAttributes.push(CustomAttributeData.fromJS(item));
                }
            }
            this.isCollectible = data["isCollectible"];
            this.metadataToken = data["metadataToken"];
        }
    };
    TypeInfo.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TypeInfo();
        result.init(data);
        return result;
    };
    TypeInfo.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.genericTypeParameters)) {
            data["genericTypeParameters"] = [];
            for (var _i = 0, _a = this.genericTypeParameters; _i < _a.length; _i++) {
                var item = _a[_i];
                data["genericTypeParameters"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.declaredConstructors)) {
            data["declaredConstructors"] = [];
            for (var _b = 0, _c = this.declaredConstructors; _b < _c.length; _b++) {
                var item = _c[_b];
                data["declaredConstructors"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.declaredEvents)) {
            data["declaredEvents"] = [];
            for (var _d = 0, _e = this.declaredEvents; _d < _e.length; _d++) {
                var item = _e[_d];
                data["declaredEvents"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.declaredFields)) {
            data["declaredFields"] = [];
            for (var _f = 0, _g = this.declaredFields; _f < _g.length; _f++) {
                var item = _g[_f];
                data["declaredFields"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.declaredMembers)) {
            data["declaredMembers"] = [];
            for (var _h = 0, _j = this.declaredMembers; _h < _j.length; _h++) {
                var item = _j[_h];
                data["declaredMembers"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.declaredMethods)) {
            data["declaredMethods"] = [];
            for (var _k = 0, _l = this.declaredMethods; _k < _l.length; _k++) {
                var item = _l[_k];
                data["declaredMethods"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.declaredNestedTypes)) {
            data["declaredNestedTypes"] = [];
            for (var _m = 0, _o = this.declaredNestedTypes; _m < _o.length; _m++) {
                var item = _o[_m];
                data["declaredNestedTypes"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.declaredProperties)) {
            data["declaredProperties"] = [];
            for (var _p = 0, _q = this.declaredProperties; _p < _q.length; _p++) {
                var item = _q[_p];
                data["declaredProperties"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.implementedInterfaces)) {
            data["implementedInterfaces"] = [];
            for (var _r = 0, _s = this.implementedInterfaces; _r < _s.length; _r++) {
                var item = _s[_r];
                data["implementedInterfaces"].push(item.toJSON());
            }
        }
        data["isInterface"] = this.isInterface;
        data["memberType"] = this.memberType;
        data["namespace"] = this.namespace;
        data["assemblyQualifiedName"] = this.assemblyQualifiedName;
        data["fullName"] = this.fullName;
        data["assembly"] = this.assembly ? this.assembly.toJSON() : undefined;
        data["module"] = this.module ? this.module.toJSON() : undefined;
        data["isNested"] = this.isNested;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : undefined;
        data["declaringMethod"] = this.declaringMethod ? this.declaringMethod.toJSON() : undefined;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : undefined;
        data["underlyingSystemType"] = this.underlyingSystemType ? this.underlyingSystemType.toJSON() : undefined;
        data["isTypeDefinition"] = this.isTypeDefinition;
        data["isArray"] = this.isArray;
        data["isByRef"] = this.isByRef;
        data["isPointer"] = this.isPointer;
        data["isConstructedGenericType"] = this.isConstructedGenericType;
        data["isGenericParameter"] = this.isGenericParameter;
        data["isGenericTypeParameter"] = this.isGenericTypeParameter;
        data["isGenericMethodParameter"] = this.isGenericMethodParameter;
        data["isGenericType"] = this.isGenericType;
        data["isGenericTypeDefinition"] = this.isGenericTypeDefinition;
        data["isSZArray"] = this.isSZArray;
        data["isVariableBoundArray"] = this.isVariableBoundArray;
        data["isByRefLike"] = this.isByRefLike;
        data["hasElementType"] = this.hasElementType;
        if (Array.isArray(this.genericTypeArguments)) {
            data["genericTypeArguments"] = [];
            for (var _t = 0, _u = this.genericTypeArguments; _t < _u.length; _t++) {
                var item = _u[_t];
                data["genericTypeArguments"].push(item.toJSON());
            }
        }
        data["genericParameterPosition"] = this.genericParameterPosition;
        data["genericParameterAttributes"] = this.genericParameterAttributes;
        data["attributes"] = this.attributes;
        data["isAbstract"] = this.isAbstract;
        data["isImport"] = this.isImport;
        data["isSealed"] = this.isSealed;
        data["isSpecialName"] = this.isSpecialName;
        data["isClass"] = this.isClass;
        data["isNestedAssembly"] = this.isNestedAssembly;
        data["isNestedFamANDAssem"] = this.isNestedFamANDAssem;
        data["isNestedFamily"] = this.isNestedFamily;
        data["isNestedFamORAssem"] = this.isNestedFamORAssem;
        data["isNestedPrivate"] = this.isNestedPrivate;
        data["isNestedPublic"] = this.isNestedPublic;
        data["isNotPublic"] = this.isNotPublic;
        data["isPublic"] = this.isPublic;
        data["isAutoLayout"] = this.isAutoLayout;
        data["isExplicitLayout"] = this.isExplicitLayout;
        data["isLayoutSequential"] = this.isLayoutSequential;
        data["isAnsiClass"] = this.isAnsiClass;
        data["isAutoClass"] = this.isAutoClass;
        data["isUnicodeClass"] = this.isUnicodeClass;
        data["isCOMObject"] = this.isCOMObject;
        data["isContextful"] = this.isContextful;
        data["isEnum"] = this.isEnum;
        data["isMarshalByRef"] = this.isMarshalByRef;
        data["isPrimitive"] = this.isPrimitive;
        data["isValueType"] = this.isValueType;
        data["isSignatureType"] = this.isSignatureType;
        data["isSecurityCritical"] = this.isSecurityCritical;
        data["isSecuritySafeCritical"] = this.isSecuritySafeCritical;
        data["isSecurityTransparent"] = this.isSecurityTransparent;
        data["structLayoutAttribute"] = this.structLayoutAttribute ? this.structLayoutAttribute.toJSON() : undefined;
        data["typeInitializer"] = this.typeInitializer ? this.typeInitializer.toJSON() : undefined;
        data["typeHandle"] = this.typeHandle ? this.typeHandle.toJSON() : undefined;
        data["guid"] = this.guid;
        data["baseType"] = this.baseType ? this.baseType.toJSON() : undefined;
        data["isSerializable"] = this.isSerializable;
        data["containsGenericParameters"] = this.containsGenericParameters;
        data["isVisible"] = this.isVisible;
        data["name"] = this.name;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (var _v = 0, _w = this.customAttributes; _v < _w.length; _v++) {
                var item = _w[_v];
                data["customAttributes"].push(item.toJSON());
            }
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        return data;
    };
    return TypeInfo;
}());
export { TypeInfo };
export var SecurityRuleSet;
(function (SecurityRuleSet) {
    SecurityRuleSet[SecurityRuleSet["None"] = 0] = "None";
    SecurityRuleSet[SecurityRuleSet["Level1"] = 1] = "Level1";
    SecurityRuleSet[SecurityRuleSet["Level2"] = 2] = "Level2";
})(SecurityRuleSet || (SecurityRuleSet = {}));
var Assembly = /** @class */ (function () {
    function Assembly(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Assembly.prototype.init = function (data) {
        if (data) {
            if (Array.isArray(data["definedTypes"])) {
                this.definedTypes = [];
                for (var _i = 0, _a = data["definedTypes"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.definedTypes.push(TypeInfo.fromJS(item));
                }
            }
            if (Array.isArray(data["exportedTypes"])) {
                this.exportedTypes = [];
                for (var _b = 0, _c = data["exportedTypes"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.exportedTypes.push(Type.fromJS(item));
                }
            }
            this.codeBase = data["codeBase"];
            this.entryPoint = data["entryPoint"] ? MethodInfo.fromJS(data["entryPoint"]) : undefined;
            this.fullName = data["fullName"];
            this.imageRuntimeVersion = data["imageRuntimeVersion"];
            this.isDynamic = data["isDynamic"];
            this.location = data["location"];
            this.reflectionOnly = data["reflectionOnly"];
            this.isCollectible = data["isCollectible"];
            this.isFullyTrusted = data["isFullyTrusted"];
            if (Array.isArray(data["customAttributes"])) {
                this.customAttributes = [];
                for (var _d = 0, _e = data["customAttributes"]; _d < _e.length; _d++) {
                    var item = _e[_d];
                    this.customAttributes.push(CustomAttributeData.fromJS(item));
                }
            }
            this.escapedCodeBase = data["escapedCodeBase"];
            this.manifestModule = data["manifestModule"] ? Module.fromJS(data["manifestModule"]) : undefined;
            if (Array.isArray(data["modules"])) {
                this.modules = [];
                for (var _f = 0, _g = data["modules"]; _f < _g.length; _f++) {
                    var item = _g[_f];
                    this.modules.push(Module.fromJS(item));
                }
            }
            this.globalAssemblyCache = data["globalAssemblyCache"];
            this.hostContext = data["hostContext"];
            this.securityRuleSet = data["securityRuleSet"];
        }
    };
    Assembly.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Assembly();
        result.init(data);
        return result;
    };
    Assembly.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.definedTypes)) {
            data["definedTypes"] = [];
            for (var _i = 0, _a = this.definedTypes; _i < _a.length; _i++) {
                var item = _a[_i];
                data["definedTypes"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.exportedTypes)) {
            data["exportedTypes"] = [];
            for (var _b = 0, _c = this.exportedTypes; _b < _c.length; _b++) {
                var item = _c[_b];
                data["exportedTypes"].push(item.toJSON());
            }
        }
        data["codeBase"] = this.codeBase;
        data["entryPoint"] = this.entryPoint ? this.entryPoint.toJSON() : undefined;
        data["fullName"] = this.fullName;
        data["imageRuntimeVersion"] = this.imageRuntimeVersion;
        data["isDynamic"] = this.isDynamic;
        data["location"] = this.location;
        data["reflectionOnly"] = this.reflectionOnly;
        data["isCollectible"] = this.isCollectible;
        data["isFullyTrusted"] = this.isFullyTrusted;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (var _d = 0, _e = this.customAttributes; _d < _e.length; _d++) {
                var item = _e[_d];
                data["customAttributes"].push(item.toJSON());
            }
        }
        data["escapedCodeBase"] = this.escapedCodeBase;
        data["manifestModule"] = this.manifestModule ? this.manifestModule.toJSON() : undefined;
        if (Array.isArray(this.modules)) {
            data["modules"] = [];
            for (var _f = 0, _g = this.modules; _f < _g.length; _f++) {
                var item = _g[_f];
                data["modules"].push(item.toJSON());
            }
        }
        data["globalAssemblyCache"] = this.globalAssemblyCache;
        data["hostContext"] = this.hostContext;
        data["securityRuleSet"] = this.securityRuleSet;
        return data;
    };
    return Assembly;
}());
export { Assembly };
var Type = /** @class */ (function () {
    function Type(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Type.prototype.init = function (data) {
        if (data) {
            this.isInterface = data["isInterface"];
            this.memberType = data["memberType"];
            this.namespace = data["namespace"];
            this.assemblyQualifiedName = data["assemblyQualifiedName"];
            this.fullName = data["fullName"];
            this.assembly = data["assembly"] ? Assembly.fromJS(data["assembly"]) : undefined;
            this.module = data["module"] ? Module.fromJS(data["module"]) : undefined;
            this.isNested = data["isNested"];
            this.declaringType = data["declaringType"] ? Type.fromJS(data["declaringType"]) : undefined;
            this.declaringMethod = data["declaringMethod"] ? MethodBase.fromJS(data["declaringMethod"]) : undefined;
            this.reflectedType = data["reflectedType"] ? Type.fromJS(data["reflectedType"]) : undefined;
            this.underlyingSystemType = data["underlyingSystemType"] ? Type.fromJS(data["underlyingSystemType"]) : undefined;
            this.isTypeDefinition = data["isTypeDefinition"];
            this.isArray = data["isArray"];
            this.isByRef = data["isByRef"];
            this.isPointer = data["isPointer"];
            this.isConstructedGenericType = data["isConstructedGenericType"];
            this.isGenericParameter = data["isGenericParameter"];
            this.isGenericTypeParameter = data["isGenericTypeParameter"];
            this.isGenericMethodParameter = data["isGenericMethodParameter"];
            this.isGenericType = data["isGenericType"];
            this.isGenericTypeDefinition = data["isGenericTypeDefinition"];
            this.isSZArray = data["isSZArray"];
            this.isVariableBoundArray = data["isVariableBoundArray"];
            this.isByRefLike = data["isByRefLike"];
            this.hasElementType = data["hasElementType"];
            if (Array.isArray(data["genericTypeArguments"])) {
                this.genericTypeArguments = [];
                for (var _i = 0, _a = data["genericTypeArguments"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.genericTypeArguments.push(Type.fromJS(item));
                }
            }
            this.genericParameterPosition = data["genericParameterPosition"];
            this.genericParameterAttributes = data["genericParameterAttributes"];
            this.attributes = data["attributes"];
            this.isAbstract = data["isAbstract"];
            this.isImport = data["isImport"];
            this.isSealed = data["isSealed"];
            this.isSpecialName = data["isSpecialName"];
            this.isClass = data["isClass"];
            this.isNestedAssembly = data["isNestedAssembly"];
            this.isNestedFamANDAssem = data["isNestedFamANDAssem"];
            this.isNestedFamily = data["isNestedFamily"];
            this.isNestedFamORAssem = data["isNestedFamORAssem"];
            this.isNestedPrivate = data["isNestedPrivate"];
            this.isNestedPublic = data["isNestedPublic"];
            this.isNotPublic = data["isNotPublic"];
            this.isPublic = data["isPublic"];
            this.isAutoLayout = data["isAutoLayout"];
            this.isExplicitLayout = data["isExplicitLayout"];
            this.isLayoutSequential = data["isLayoutSequential"];
            this.isAnsiClass = data["isAnsiClass"];
            this.isAutoClass = data["isAutoClass"];
            this.isUnicodeClass = data["isUnicodeClass"];
            this.isCOMObject = data["isCOMObject"];
            this.isContextful = data["isContextful"];
            this.isEnum = data["isEnum"];
            this.isMarshalByRef = data["isMarshalByRef"];
            this.isPrimitive = data["isPrimitive"];
            this.isValueType = data["isValueType"];
            this.isSignatureType = data["isSignatureType"];
            this.isSecurityCritical = data["isSecurityCritical"];
            this.isSecuritySafeCritical = data["isSecuritySafeCritical"];
            this.isSecurityTransparent = data["isSecurityTransparent"];
            this.structLayoutAttribute = data["structLayoutAttribute"] ? StructLayoutAttribute.fromJS(data["structLayoutAttribute"]) : undefined;
            this.typeInitializer = data["typeInitializer"] ? ConstructorInfo.fromJS(data["typeInitializer"]) : undefined;
            this.typeHandle = data["typeHandle"] ? RuntimeTypeHandle.fromJS(data["typeHandle"]) : undefined;
            this.guid = data["guid"];
            this.baseType = data["baseType"] ? Type.fromJS(data["baseType"]) : undefined;
            this.isSerializable = data["isSerializable"];
            this.containsGenericParameters = data["containsGenericParameters"];
            this.isVisible = data["isVisible"];
            this.name = data["name"];
            if (Array.isArray(data["customAttributes"])) {
                this.customAttributes = [];
                for (var _b = 0, _c = data["customAttributes"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.customAttributes.push(CustomAttributeData.fromJS(item));
                }
            }
            this.isCollectible = data["isCollectible"];
            this.metadataToken = data["metadataToken"];
        }
    };
    Type.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Type();
        result.init(data);
        return result;
    };
    Type.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["isInterface"] = this.isInterface;
        data["memberType"] = this.memberType;
        data["namespace"] = this.namespace;
        data["assemblyQualifiedName"] = this.assemblyQualifiedName;
        data["fullName"] = this.fullName;
        data["assembly"] = this.assembly ? this.assembly.toJSON() : undefined;
        data["module"] = this.module ? this.module.toJSON() : undefined;
        data["isNested"] = this.isNested;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : undefined;
        data["declaringMethod"] = this.declaringMethod ? this.declaringMethod.toJSON() : undefined;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : undefined;
        data["underlyingSystemType"] = this.underlyingSystemType ? this.underlyingSystemType.toJSON() : undefined;
        data["isTypeDefinition"] = this.isTypeDefinition;
        data["isArray"] = this.isArray;
        data["isByRef"] = this.isByRef;
        data["isPointer"] = this.isPointer;
        data["isConstructedGenericType"] = this.isConstructedGenericType;
        data["isGenericParameter"] = this.isGenericParameter;
        data["isGenericTypeParameter"] = this.isGenericTypeParameter;
        data["isGenericMethodParameter"] = this.isGenericMethodParameter;
        data["isGenericType"] = this.isGenericType;
        data["isGenericTypeDefinition"] = this.isGenericTypeDefinition;
        data["isSZArray"] = this.isSZArray;
        data["isVariableBoundArray"] = this.isVariableBoundArray;
        data["isByRefLike"] = this.isByRefLike;
        data["hasElementType"] = this.hasElementType;
        if (Array.isArray(this.genericTypeArguments)) {
            data["genericTypeArguments"] = [];
            for (var _i = 0, _a = this.genericTypeArguments; _i < _a.length; _i++) {
                var item = _a[_i];
                data["genericTypeArguments"].push(item.toJSON());
            }
        }
        data["genericParameterPosition"] = this.genericParameterPosition;
        data["genericParameterAttributes"] = this.genericParameterAttributes;
        data["attributes"] = this.attributes;
        data["isAbstract"] = this.isAbstract;
        data["isImport"] = this.isImport;
        data["isSealed"] = this.isSealed;
        data["isSpecialName"] = this.isSpecialName;
        data["isClass"] = this.isClass;
        data["isNestedAssembly"] = this.isNestedAssembly;
        data["isNestedFamANDAssem"] = this.isNestedFamANDAssem;
        data["isNestedFamily"] = this.isNestedFamily;
        data["isNestedFamORAssem"] = this.isNestedFamORAssem;
        data["isNestedPrivate"] = this.isNestedPrivate;
        data["isNestedPublic"] = this.isNestedPublic;
        data["isNotPublic"] = this.isNotPublic;
        data["isPublic"] = this.isPublic;
        data["isAutoLayout"] = this.isAutoLayout;
        data["isExplicitLayout"] = this.isExplicitLayout;
        data["isLayoutSequential"] = this.isLayoutSequential;
        data["isAnsiClass"] = this.isAnsiClass;
        data["isAutoClass"] = this.isAutoClass;
        data["isUnicodeClass"] = this.isUnicodeClass;
        data["isCOMObject"] = this.isCOMObject;
        data["isContextful"] = this.isContextful;
        data["isEnum"] = this.isEnum;
        data["isMarshalByRef"] = this.isMarshalByRef;
        data["isPrimitive"] = this.isPrimitive;
        data["isValueType"] = this.isValueType;
        data["isSignatureType"] = this.isSignatureType;
        data["isSecurityCritical"] = this.isSecurityCritical;
        data["isSecuritySafeCritical"] = this.isSecuritySafeCritical;
        data["isSecurityTransparent"] = this.isSecurityTransparent;
        data["structLayoutAttribute"] = this.structLayoutAttribute ? this.structLayoutAttribute.toJSON() : undefined;
        data["typeInitializer"] = this.typeInitializer ? this.typeInitializer.toJSON() : undefined;
        data["typeHandle"] = this.typeHandle ? this.typeHandle.toJSON() : undefined;
        data["guid"] = this.guid;
        data["baseType"] = this.baseType ? this.baseType.toJSON() : undefined;
        data["isSerializable"] = this.isSerializable;
        data["containsGenericParameters"] = this.containsGenericParameters;
        data["isVisible"] = this.isVisible;
        data["name"] = this.name;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (var _b = 0, _c = this.customAttributes; _b < _c.length; _b++) {
                var item = _c[_b];
                data["customAttributes"].push(item.toJSON());
            }
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        return data;
    };
    return Type;
}());
export { Type };
export var NotificationSeverity;
(function (NotificationSeverity) {
    NotificationSeverity[NotificationSeverity["Info"] = 0] = "Info";
    NotificationSeverity[NotificationSeverity["Success"] = 1] = "Success";
    NotificationSeverity[NotificationSeverity["Warn"] = 2] = "Warn";
    NotificationSeverity[NotificationSeverity["Error"] = 3] = "Error";
    NotificationSeverity[NotificationSeverity["Fatal"] = 4] = "Fatal";
})(NotificationSeverity || (NotificationSeverity = {}));
var TenantNotification = /** @class */ (function () {
    function TenantNotification(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TenantNotification.prototype.init = function (data) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.notificationName = data["notificationName"];
            this.data = data["data"] ? NotificationData.fromJS(data["data"]) : undefined;
            this.entityType = data["entityType"] ? Type.fromJS(data["entityType"]) : undefined;
            this.entityTypeName = data["entityTypeName"];
            this.entityId = data["entityId"];
            this.severity = data["severity"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.id = data["id"];
        }
    };
    TenantNotification.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TenantNotification();
        result.init(data);
        return result;
    };
    TenantNotification.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["notificationName"] = this.notificationName;
        data["data"] = this.data ? this.data.toJSON() : undefined;
        data["entityType"] = this.entityType ? this.entityType.toJSON() : undefined;
        data["entityTypeName"] = this.entityTypeName;
        data["entityId"] = this.entityId;
        data["severity"] = this.severity;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["id"] = this.id;
        return data;
    };
    return TenantNotification;
}());
export { TenantNotification };
var UserNotification = /** @class */ (function () {
    function UserNotification(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UserNotification.prototype.init = function (data) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
            this.state = data["state"];
            this.notification = data["notification"] ? TenantNotification.fromJS(data["notification"]) : undefined;
            this.id = data["id"];
        }
    };
    UserNotification.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UserNotification();
        result.init(data);
        return result;
    };
    UserNotification.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["state"] = this.state;
        data["notification"] = this.notification ? this.notification.toJSON() : undefined;
        data["id"] = this.id;
        return data;
    };
    return UserNotification;
}());
export { UserNotification };
var GetNotificationsOutput = /** @class */ (function () {
    function GetNotificationsOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetNotificationsOutput.prototype.init = function (data) {
        if (data) {
            this.unreadCount = data["unreadCount"];
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(UserNotification.fromJS(item));
                }
            }
        }
    };
    GetNotificationsOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetNotificationsOutput();
        result.init(data);
        return result;
    };
    GetNotificationsOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["unreadCount"] = this.unreadCount;
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return GetNotificationsOutput;
}());
export { GetNotificationsOutput };
var EntityDtoOfGuid = /** @class */ (function () {
    function EntityDtoOfGuid(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EntityDtoOfGuid.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
        }
    };
    EntityDtoOfGuid.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new EntityDtoOfGuid();
        result.init(data);
        return result;
    };
    EntityDtoOfGuid.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    };
    return EntityDtoOfGuid;
}());
export { EntityDtoOfGuid };
var NotificationSubscriptionWithDisplayNameDto = /** @class */ (function () {
    function NotificationSubscriptionWithDisplayNameDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    NotificationSubscriptionWithDisplayNameDto.prototype.init = function (data) {
        if (data) {
            this.displayName = data["displayName"];
            this.description = data["description"];
            this.name = data["name"];
            this.isSubscribed = data["isSubscribed"];
        }
    };
    NotificationSubscriptionWithDisplayNameDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new NotificationSubscriptionWithDisplayNameDto();
        result.init(data);
        return result;
    };
    NotificationSubscriptionWithDisplayNameDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["name"] = this.name;
        data["isSubscribed"] = this.isSubscribed;
        return data;
    };
    return NotificationSubscriptionWithDisplayNameDto;
}());
export { NotificationSubscriptionWithDisplayNameDto };
var GetNotificationSettingsOutput = /** @class */ (function () {
    function GetNotificationSettingsOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetNotificationSettingsOutput.prototype.init = function (data) {
        if (data) {
            this.receiveNotifications = data["receiveNotifications"];
            if (Array.isArray(data["notifications"])) {
                this.notifications = [];
                for (var _i = 0, _a = data["notifications"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.notifications.push(NotificationSubscriptionWithDisplayNameDto.fromJS(item));
                }
            }
        }
    };
    GetNotificationSettingsOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetNotificationSettingsOutput();
        result.init(data);
        return result;
    };
    GetNotificationSettingsOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["receiveNotifications"] = this.receiveNotifications;
        if (Array.isArray(this.notifications)) {
            data["notifications"] = [];
            for (var _i = 0, _a = this.notifications; _i < _a.length; _i++) {
                var item = _a[_i];
                data["notifications"].push(item.toJSON());
            }
        }
        return data;
    };
    return GetNotificationSettingsOutput;
}());
export { GetNotificationSettingsOutput };
var NotificationSubscriptionDto = /** @class */ (function () {
    function NotificationSubscriptionDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    NotificationSubscriptionDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.isSubscribed = data["isSubscribed"];
        }
    };
    NotificationSubscriptionDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new NotificationSubscriptionDto();
        result.init(data);
        return result;
    };
    NotificationSubscriptionDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isSubscribed"] = this.isSubscribed;
        return data;
    };
    return NotificationSubscriptionDto;
}());
export { NotificationSubscriptionDto };
var UpdateNotificationSettingsInput = /** @class */ (function () {
    function UpdateNotificationSettingsInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateNotificationSettingsInput.prototype.init = function (data) {
        if (data) {
            this.receiveNotifications = data["receiveNotifications"];
            if (Array.isArray(data["notifications"])) {
                this.notifications = [];
                for (var _i = 0, _a = data["notifications"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.notifications.push(NotificationSubscriptionDto.fromJS(item));
                }
            }
        }
    };
    UpdateNotificationSettingsInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateNotificationSettingsInput();
        result.init(data);
        return result;
    };
    UpdateNotificationSettingsInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["receiveNotifications"] = this.receiveNotifications;
        if (Array.isArray(this.notifications)) {
            data["notifications"] = [];
            for (var _i = 0, _a = this.notifications; _i < _a.length; _i++) {
                var item = _a[_i];
                data["notifications"].push(item.toJSON());
            }
        }
        return data;
    };
    return UpdateNotificationSettingsInput;
}());
export { UpdateNotificationSettingsInput };
var GetAllOrdersInput = /** @class */ (function () {
    function GetAllOrdersInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetAllOrdersInput.prototype.init = function (data) {
        if (data) {
            if (Array.isArray(data["orderNumberFilter"])) {
                this.orderNumberFilter = [];
                for (var _i = 0, _a = data["orderNumberFilter"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.orderNumberFilter.push(item);
                }
            }
            if (Array.isArray(data["externalVendorOrderNumbersFilter"])) {
                this.externalVendorOrderNumbersFilter = [];
                for (var _b = 0, _c = data["externalVendorOrderNumbersFilter"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.externalVendorOrderNumbersFilter.push(item);
                }
            }
            if (Array.isArray(data["priorityFilter"])) {
                this.priorityFilter = [];
                for (var _d = 0, _e = data["priorityFilter"]; _d < _e.length; _d++) {
                    var item = _e[_d];
                    this.priorityFilter.push(item);
                }
            }
            if (Array.isArray(data["heatStatusFilter"])) {
                this.heatStatusFilter = [];
                for (var _f = 0, _g = data["heatStatusFilter"]; _f < _g.length; _f++) {
                    var item = _g[_f];
                    this.heatStatusFilter.push(item);
                }
            }
            this.brandNameFilter = data["brandNameFilter"];
            this.customerIdFilter = data["customerIdFilter"];
            this.actionedOrderFilter = data["actionedOrderFilter"];
            this.removedFromDashboardFilter = data["removedFromDashboardFilter"];
            this.dashboardViewFilter = data["dashboardViewFilter"];
            this.xFilter = data["xFilter"];
            this.yFilter = data["yFilter"];
            this.zFilter = data["zFilter"];
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    };
    GetAllOrdersInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetAllOrdersInput();
        result.init(data);
        return result;
    };
    GetAllOrdersInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.orderNumberFilter)) {
            data["orderNumberFilter"] = [];
            for (var _i = 0, _a = this.orderNumberFilter; _i < _a.length; _i++) {
                var item = _a[_i];
                data["orderNumberFilter"].push(item);
            }
        }
        if (Array.isArray(this.externalVendorOrderNumbersFilter)) {
            data["externalVendorOrderNumbersFilter"] = [];
            for (var _b = 0, _c = this.externalVendorOrderNumbersFilter; _b < _c.length; _b++) {
                var item = _c[_b];
                data["externalVendorOrderNumbersFilter"].push(item);
            }
        }
        if (Array.isArray(this.priorityFilter)) {
            data["priorityFilter"] = [];
            for (var _d = 0, _e = this.priorityFilter; _d < _e.length; _d++) {
                var item = _e[_d];
                data["priorityFilter"].push(item);
            }
        }
        if (Array.isArray(this.heatStatusFilter)) {
            data["heatStatusFilter"] = [];
            for (var _f = 0, _g = this.heatStatusFilter; _f < _g.length; _f++) {
                var item = _g[_f];
                data["heatStatusFilter"].push(item);
            }
        }
        data["brandNameFilter"] = this.brandNameFilter;
        data["customerIdFilter"] = this.customerIdFilter;
        data["actionedOrderFilter"] = this.actionedOrderFilter;
        data["removedFromDashboardFilter"] = this.removedFromDashboardFilter;
        data["dashboardViewFilter"] = this.dashboardViewFilter;
        data["xFilter"] = this.xFilter;
        data["yFilter"] = this.yFilter;
        data["zFilter"] = this.zFilter;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    };
    return GetAllOrdersInput;
}());
export { GetAllOrdersInput };
var CustomerDto = /** @class */ (function () {
    function CustomerDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CustomerDto.prototype.init = function (data) {
        if (data) {
            this.shopperId = data["shopperId"];
            this.brandId = data["brandId"];
            this.title = data["title"];
            this.firstName = data["firstName"];
            this.lastName = data["lastName"];
            this.email = data["email"];
            this.contactMobileNumber = data["contactMobileNumber"];
            this.contactHomeNumber = data["contactHomeNumber"];
            this.contactWorkNumber = data["contactWorkNumber"];
            this.id = data["id"];
        }
    };
    CustomerDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CustomerDto();
        result.init(data);
        return result;
    };
    CustomerDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["shopperId"] = this.shopperId;
        data["brandId"] = this.brandId;
        data["title"] = this.title;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["contactMobileNumber"] = this.contactMobileNumber;
        data["contactHomeNumber"] = this.contactHomeNumber;
        data["contactWorkNumber"] = this.contactWorkNumber;
        data["id"] = this.id;
        return data;
    };
    return CustomerDto;
}());
export { CustomerDto };
export var SLAStatus;
(function (SLAStatus) {
    SLAStatus[SLAStatus["Unknown"] = 0] = "Unknown";
    SLAStatus[SLAStatus["WithinSLA"] = 1] = "WithinSLA";
    SLAStatus[SLAStatus["AtRisk"] = 2] = "AtRisk";
    SLAStatus[SLAStatus["Breached"] = 3] = "Breached";
})(SLAStatus || (SLAStatus = {}));
var OrderDto = /** @class */ (function () {
    function OrderDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrderDto.prototype.init = function (data) {
        if (data) {
            this.orderNumber = data["orderNumber"];
            this.brandId = data["brandId"];
            this.parentOrderNumber = data["parentOrderNumber"];
            this.orderDate = data["orderDate"] ? moment(data["orderDate"].toString()) : undefined;
            this.orderStatus = data["orderStatus"];
            this.orderDeliveryType = data["orderDeliveryType"];
            this.orderType = data["orderType"];
            this.atlEligible = data["atlEligible"];
            this.actionTakenAt = data["actionTakenAt"] ? moment(data["actionTakenAt"].toString()) : undefined;
            this.removedFromDashboardAt = data["removedFromDashboardAt"] ? moment(data["removedFromDashboardAt"].toString()) : undefined;
            this.customer = data["customer"] ? CustomerDto.fromJS(data["customer"]) : undefined;
            this.additionalData = data["additionalData"];
            this.slaStatus = data["slaStatus"];
            this.takeActionAllowed = data["takeActionAllowed"];
            this.deliveryLocation = data["deliveryLocation"];
            this.externalVendorName = data["externalVendorName"];
            this.externalVendorOrderNumber = data["externalVendorOrderNumber"];
            this.heatStatus = data["heatStatus"];
            this.id = data["id"];
        }
    };
    OrderDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrderDto();
        result.init(data);
        return result;
    };
    OrderDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["orderNumber"] = this.orderNumber;
        data["brandId"] = this.brandId;
        data["parentOrderNumber"] = this.parentOrderNumber;
        data["orderDate"] = this.orderDate ? this.orderDate.toISOString() : undefined;
        data["orderStatus"] = this.orderStatus;
        data["orderDeliveryType"] = this.orderDeliveryType;
        data["orderType"] = this.orderType;
        data["atlEligible"] = this.atlEligible;
        data["actionTakenAt"] = this.actionTakenAt ? this.actionTakenAt.toISOString() : undefined;
        data["removedFromDashboardAt"] = this.removedFromDashboardAt ? this.removedFromDashboardAt.toISOString() : undefined;
        data["customer"] = this.customer ? this.customer.toJSON() : undefined;
        data["additionalData"] = this.additionalData;
        data["slaStatus"] = this.slaStatus;
        data["takeActionAllowed"] = this.takeActionAllowed;
        data["deliveryLocation"] = this.deliveryLocation;
        data["externalVendorName"] = this.externalVendorName;
        data["externalVendorOrderNumber"] = this.externalVendorOrderNumber;
        data["heatStatus"] = this.heatStatus;
        data["id"] = this.id;
        return data;
    };
    return OrderDto;
}());
export { OrderDto };
var OrderLineDto = /** @class */ (function () {
    function OrderLineDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrderLineDto.prototype.init = function (data) {
        if (data) {
            this.stockCode = data["stockCode"];
            this.productName = data["productName"];
            this.quantity = data["quantity"];
            this.packType = data["packType"];
            this.packSize = data["packSize"];
            this.additionalData = data["additionalData"];
            this.storeNumber = data["storeNumber"];
            this.isCrossBorder = data["isCrossBorder"];
            this.regionType = data["regionType"];
            this.regionValue = data["regionValue"];
            this.id = data["id"];
        }
    };
    OrderLineDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrderLineDto();
        result.init(data);
        return result;
    };
    OrderLineDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["stockCode"] = this.stockCode;
        data["productName"] = this.productName;
        data["quantity"] = this.quantity;
        data["packType"] = this.packType;
        data["packSize"] = this.packSize;
        data["additionalData"] = this.additionalData;
        data["storeNumber"] = this.storeNumber;
        data["isCrossBorder"] = this.isCrossBorder;
        data["regionType"] = this.regionType;
        data["regionValue"] = this.regionValue;
        data["id"] = this.id;
        return data;
    };
    return OrderLineDto;
}());
export { OrderLineDto };
var GetOrderForViewDto = /** @class */ (function () {
    function GetOrderForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetOrderForViewDto.prototype.init = function (data) {
        if (data) {
            this.order = data["order"] ? OrderDto.fromJS(data["order"]) : undefined;
            this.brandName = data["brandName"];
            if (Array.isArray(data["orderLines"])) {
                this.orderLines = [];
                for (var _i = 0, _a = data["orderLines"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.orderLines.push(OrderLineDto.fromJS(item));
                }
            }
        }
    };
    GetOrderForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetOrderForViewDto();
        result.init(data);
        return result;
    };
    GetOrderForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order ? this.order.toJSON() : undefined;
        data["brandName"] = this.brandName;
        if (Array.isArray(this.orderLines)) {
            data["orderLines"] = [];
            for (var _i = 0, _a = this.orderLines; _i < _a.length; _i++) {
                var item = _a[_i];
                data["orderLines"].push(item.toJSON());
            }
        }
        return data;
    };
    return GetOrderForViewDto;
}());
export { GetOrderForViewDto };
var PagedResultDtoOfGetOrderForViewDto = /** @class */ (function () {
    function PagedResultDtoOfGetOrderForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfGetOrderForViewDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(GetOrderForViewDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfGetOrderForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfGetOrderForViewDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfGetOrderForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfGetOrderForViewDto;
}());
export { PagedResultDtoOfGetOrderForViewDto };
var PackageSummaryDto = /** @class */ (function () {
    function PackageSummaryDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PackageSummaryDto.prototype.init = function (data) {
        if (data) {
            this.barcode = data["barcode"];
            if (Array.isArray(data["packageItems"])) {
                this.packageItems = [];
                for (var _i = 0, _a = data["packageItems"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.packageItems.push(PackageItemsDto.fromJS(item));
                }
            }
            this.id = data["id"];
        }
    };
    PackageSummaryDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PackageSummaryDto();
        result.init(data);
        return result;
    };
    PackageSummaryDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["barcode"] = this.barcode;
        if (Array.isArray(this.packageItems)) {
            data["packageItems"] = [];
            for (var _i = 0, _a = this.packageItems; _i < _a.length; _i++) {
                var item = _a[_i];
                data["packageItems"].push(item.toJSON());
            }
        }
        data["id"] = this.id;
        return data;
    };
    return PackageSummaryDto;
}());
export { PackageSummaryDto };
var ConsignmentSummaryDto = /** @class */ (function () {
    function ConsignmentSummaryDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ConsignmentSummaryDto.prototype.init = function (data) {
        if (data) {
            this.consignmentNumber = data["consignmentNumber"];
            this.type = data["type"];
            this.status = data["status"];
            this.statusDescription = data["statusDescription"];
            if (Array.isArray(data["packageSummaries"])) {
                this.packageSummaries = [];
                for (var _i = 0, _a = data["packageSummaries"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.packageSummaries.push(PackageSummaryDto.fromJS(item));
                }
            }
            this.id = data["id"];
        }
    };
    ConsignmentSummaryDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ConsignmentSummaryDto();
        result.init(data);
        return result;
    };
    ConsignmentSummaryDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["consignmentNumber"] = this.consignmentNumber;
        data["type"] = this.type;
        data["status"] = this.status;
        data["statusDescription"] = this.statusDescription;
        if (Array.isArray(this.packageSummaries)) {
            data["packageSummaries"] = [];
            for (var _i = 0, _a = this.packageSummaries; _i < _a.length; _i++) {
                var item = _a[_i];
                data["packageSummaries"].push(item.toJSON());
            }
        }
        data["id"] = this.id;
        return data;
    };
    return ConsignmentSummaryDto;
}());
export { ConsignmentSummaryDto };
var OrdersSummaryData = /** @class */ (function () {
    function OrdersSummaryData(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrdersSummaryData.prototype.init = function (data) {
        if (data) {
            this.groupLabel = data["groupLabel"];
            this.groupId = data["groupId"];
            this.preManifested = data["preManifested"];
            this.fulfilled = data["fulfilled"];
        }
    };
    OrdersSummaryData.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrdersSummaryData();
        result.init(data);
        return result;
    };
    OrdersSummaryData.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["groupLabel"] = this.groupLabel;
        data["groupId"] = this.groupId;
        data["preManifested"] = this.preManifested;
        data["fulfilled"] = this.fulfilled;
        return data;
    };
    return OrdersSummaryData;
}());
export { OrdersSummaryData };
var OrdersSummaryDashboardOutput = /** @class */ (function () {
    function OrdersSummaryDashboardOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrdersSummaryDashboardOutput.prototype.init = function (data) {
        if (data) {
            this.mainTitle = data["mainTitle"];
            if (Array.isArray(data["ordersSummaryDatas"])) {
                this.ordersSummaryDatas = [];
                for (var _i = 0, _a = data["ordersSummaryDatas"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.ordersSummaryDatas.push(OrdersSummaryData.fromJS(item));
                }
            }
        }
    };
    OrdersSummaryDashboardOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrdersSummaryDashboardOutput();
        result.init(data);
        return result;
    };
    OrdersSummaryDashboardOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["mainTitle"] = this.mainTitle;
        if (Array.isArray(this.ordersSummaryDatas)) {
            data["ordersSummaryDatas"] = [];
            for (var _i = 0, _a = this.ordersSummaryDatas; _i < _a.length; _i++) {
                var item = _a[_i];
                data["ordersSummaryDatas"].push(item.toJSON());
            }
        }
        return data;
    };
    return OrdersSummaryDashboardOutput;
}());
export { OrdersSummaryDashboardOutput };
var OrganizationUnitDto = /** @class */ (function () {
    function OrganizationUnitDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrganizationUnitDto.prototype.init = function (data) {
        if (data) {
            this.parentId = data["parentId"];
            this.code = data["code"];
            this.displayName = data["displayName"];
            this.memberCount = data["memberCount"];
            this.roleCount = data["roleCount"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    };
    OrganizationUnitDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrganizationUnitDto();
        result.init(data);
        return result;
    };
    OrganizationUnitDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["code"] = this.code;
        data["displayName"] = this.displayName;
        data["memberCount"] = this.memberCount;
        data["roleCount"] = this.roleCount;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    return OrganizationUnitDto;
}());
export { OrganizationUnitDto };
var ListResultDtoOfOrganizationUnitDto = /** @class */ (function () {
    function ListResultDtoOfOrganizationUnitDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ListResultDtoOfOrganizationUnitDto.prototype.init = function (data) {
        if (data) {
            if (Array.isArray(data["items"])) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(OrganizationUnitDto.fromJS(item));
                }
            }
        }
    };
    ListResultDtoOfOrganizationUnitDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ListResultDtoOfOrganizationUnitDto();
        result.init(data);
        return result;
    };
    ListResultDtoOfOrganizationUnitDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return ListResultDtoOfOrganizationUnitDto;
}());
export { ListResultDtoOfOrganizationUnitDto };
var OrganizationUnitUserListDto = /** @class */ (function () {
    function OrganizationUnitUserListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrganizationUnitUserListDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.surname = data["surname"];
            this.userName = data["userName"];
            this.emailAddress = data["emailAddress"];
            this.profilePictureId = data["profilePictureId"];
            this.addedTime = data["addedTime"] ? moment(data["addedTime"].toString()) : undefined;
            this.id = data["id"];
        }
    };
    OrganizationUnitUserListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrganizationUnitUserListDto();
        result.init(data);
        return result;
    };
    OrganizationUnitUserListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["profilePictureId"] = this.profilePictureId;
        data["addedTime"] = this.addedTime ? this.addedTime.toISOString() : undefined;
        data["id"] = this.id;
        return data;
    };
    return OrganizationUnitUserListDto;
}());
export { OrganizationUnitUserListDto };
var PagedResultDtoOfOrganizationUnitUserListDto = /** @class */ (function () {
    function PagedResultDtoOfOrganizationUnitUserListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfOrganizationUnitUserListDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(OrganizationUnitUserListDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfOrganizationUnitUserListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfOrganizationUnitUserListDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfOrganizationUnitUserListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfOrganizationUnitUserListDto;
}());
export { PagedResultDtoOfOrganizationUnitUserListDto };
var OrganizationUnitRoleListDto = /** @class */ (function () {
    function OrganizationUnitRoleListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrganizationUnitRoleListDto.prototype.init = function (data) {
        if (data) {
            this.displayName = data["displayName"];
            this.name = data["name"];
            this.addedTime = data["addedTime"] ? moment(data["addedTime"].toString()) : undefined;
            this.id = data["id"];
        }
    };
    OrganizationUnitRoleListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrganizationUnitRoleListDto();
        result.init(data);
        return result;
    };
    OrganizationUnitRoleListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["name"] = this.name;
        data["addedTime"] = this.addedTime ? this.addedTime.toISOString() : undefined;
        data["id"] = this.id;
        return data;
    };
    return OrganizationUnitRoleListDto;
}());
export { OrganizationUnitRoleListDto };
var PagedResultDtoOfOrganizationUnitRoleListDto = /** @class */ (function () {
    function PagedResultDtoOfOrganizationUnitRoleListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfOrganizationUnitRoleListDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(OrganizationUnitRoleListDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfOrganizationUnitRoleListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfOrganizationUnitRoleListDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfOrganizationUnitRoleListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfOrganizationUnitRoleListDto;
}());
export { PagedResultDtoOfOrganizationUnitRoleListDto };
var CreateOrganizationUnitInput = /** @class */ (function () {
    function CreateOrganizationUnitInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateOrganizationUnitInput.prototype.init = function (data) {
        if (data) {
            this.parentId = data["parentId"];
            this.displayName = data["displayName"];
        }
    };
    CreateOrganizationUnitInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrganizationUnitInput();
        result.init(data);
        return result;
    };
    CreateOrganizationUnitInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["displayName"] = this.displayName;
        return data;
    };
    return CreateOrganizationUnitInput;
}());
export { CreateOrganizationUnitInput };
var UpdateOrganizationUnitInput = /** @class */ (function () {
    function UpdateOrganizationUnitInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateOrganizationUnitInput.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    };
    UpdateOrganizationUnitInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateOrganizationUnitInput();
        result.init(data);
        return result;
    };
    UpdateOrganizationUnitInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    };
    return UpdateOrganizationUnitInput;
}());
export { UpdateOrganizationUnitInput };
var MoveOrganizationUnitInput = /** @class */ (function () {
    function MoveOrganizationUnitInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MoveOrganizationUnitInput.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.newParentId = data["newParentId"];
        }
    };
    MoveOrganizationUnitInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new MoveOrganizationUnitInput();
        result.init(data);
        return result;
    };
    MoveOrganizationUnitInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["newParentId"] = this.newParentId;
        return data;
    };
    return MoveOrganizationUnitInput;
}());
export { MoveOrganizationUnitInput };
var UsersToOrganizationUnitInput = /** @class */ (function () {
    function UsersToOrganizationUnitInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UsersToOrganizationUnitInput.prototype.init = function (data) {
        if (data) {
            if (Array.isArray(data["userIds"])) {
                this.userIds = [];
                for (var _i = 0, _a = data["userIds"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.userIds.push(item);
                }
            }
            this.organizationUnitId = data["organizationUnitId"];
        }
    };
    UsersToOrganizationUnitInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UsersToOrganizationUnitInput();
        result.init(data);
        return result;
    };
    UsersToOrganizationUnitInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (var _i = 0, _a = this.userIds; _i < _a.length; _i++) {
                var item = _a[_i];
                data["userIds"].push(item);
            }
        }
        data["organizationUnitId"] = this.organizationUnitId;
        return data;
    };
    return UsersToOrganizationUnitInput;
}());
export { UsersToOrganizationUnitInput };
var RolesToOrganizationUnitInput = /** @class */ (function () {
    function RolesToOrganizationUnitInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RolesToOrganizationUnitInput.prototype.init = function (data) {
        if (data) {
            if (Array.isArray(data["roleIds"])) {
                this.roleIds = [];
                for (var _i = 0, _a = data["roleIds"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.roleIds.push(item);
                }
            }
            this.organizationUnitId = data["organizationUnitId"];
        }
    };
    RolesToOrganizationUnitInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RolesToOrganizationUnitInput();
        result.init(data);
        return result;
    };
    RolesToOrganizationUnitInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.roleIds)) {
            data["roleIds"] = [];
            for (var _i = 0, _a = this.roleIds; _i < _a.length; _i++) {
                var item = _a[_i];
                data["roleIds"].push(item);
            }
        }
        data["organizationUnitId"] = this.organizationUnitId;
        return data;
    };
    return RolesToOrganizationUnitInput;
}());
export { RolesToOrganizationUnitInput };
var FindOrganizationUnitUsersInput = /** @class */ (function () {
    function FindOrganizationUnitUsersInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FindOrganizationUnitUsersInput.prototype.init = function (data) {
        if (data) {
            this.organizationUnitId = data["organizationUnitId"];
            this.maxResultCount = data["maxResultCount"];
            this.skipCount = data["skipCount"];
            this.filter = data["filter"];
        }
    };
    FindOrganizationUnitUsersInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FindOrganizationUnitUsersInput();
        result.init(data);
        return result;
    };
    FindOrganizationUnitUsersInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["organizationUnitId"] = this.organizationUnitId;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["filter"] = this.filter;
        return data;
    };
    return FindOrganizationUnitUsersInput;
}());
export { FindOrganizationUnitUsersInput };
var FindOrganizationUnitRolesInput = /** @class */ (function () {
    function FindOrganizationUnitRolesInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FindOrganizationUnitRolesInput.prototype.init = function (data) {
        if (data) {
            this.organizationUnitId = data["organizationUnitId"];
            this.maxResultCount = data["maxResultCount"];
            this.skipCount = data["skipCount"];
            this.filter = data["filter"];
        }
    };
    FindOrganizationUnitRolesInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FindOrganizationUnitRolesInput();
        result.init(data);
        return result;
    };
    FindOrganizationUnitRolesInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["organizationUnitId"] = this.organizationUnitId;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["filter"] = this.filter;
        return data;
    };
    return FindOrganizationUnitRolesInput;
}());
export { FindOrganizationUnitRolesInput };
var PackageEventDto = /** @class */ (function () {
    function PackageEventDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PackageEventDto.prototype.init = function (data) {
        if (data) {
            this.signMessage = data["signMessage"];
            this.eventName = data["eventName"];
            this.eventStatus = data["eventStatus"];
            this.subStatus = data["subStatus"];
            this.routeId = data["routeId"];
            this.routeName = data["routeName"];
            this.plannedTime = data["plannedTime"] ? moment(data["plannedTime"].toString()) : undefined;
            this.driverCode = data["driverCode"];
            this.statusTime = data["statusTime"] ? moment(data["statusTime"].toString()) : undefined;
            this.exception = data["exception"];
            this.packageId = data["packageId"];
            this.comments = data["comments"];
            this.id = data["id"];
        }
    };
    PackageEventDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PackageEventDto();
        result.init(data);
        return result;
    };
    PackageEventDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["signMessage"] = this.signMessage;
        data["eventName"] = this.eventName;
        data["eventStatus"] = this.eventStatus;
        data["subStatus"] = this.subStatus;
        data["routeId"] = this.routeId;
        data["routeName"] = this.routeName;
        data["plannedTime"] = this.plannedTime ? this.plannedTime.toISOString() : undefined;
        data["driverCode"] = this.driverCode;
        data["statusTime"] = this.statusTime ? this.statusTime.toISOString() : undefined;
        data["exception"] = this.exception;
        data["packageId"] = this.packageId;
        data["comments"] = this.comments;
        data["id"] = this.id;
        return data;
    };
    return PackageEventDto;
}());
export { PackageEventDto };
var GetPackageHistoryForViewDto = /** @class */ (function () {
    function GetPackageHistoryForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetPackageHistoryForViewDto.prototype.init = function (data) {
        if (data) {
            this.isException = data["isException"];
            this.statusTime = data["statusTime"] ? moment(data["statusTime"].toString()) : undefined;
            this.eventGroupDescription = data["eventGroupDescription"];
            this.eventDetailStatus = data["eventDetailStatus"];
            this.eventDetailDescription = data["eventDetailDescription"];
            this.eventSource = data["eventSource"];
            this.userName = data["userName"];
            this.eventComment = data["eventComment"];
            this.barcode = data["barcode"];
            this.eventLocation = data["eventLocation"];
            this.eventLocationCode = data["eventLocationCode"];
            if (Array.isArray(data["packageHistoryTags"])) {
                this.packageHistoryTags = [];
                for (var _i = 0, _a = data["packageHistoryTags"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.packageHistoryTags.push(item);
                }
            }
            this.loadId = data["loadId"];
            this.palletConnoteNumber = data["palletConnoteNumber"];
            this.palletId = data["palletId"];
            this.subStatus = data["subStatus"];
        }
    };
    GetPackageHistoryForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetPackageHistoryForViewDto();
        result.init(data);
        return result;
    };
    GetPackageHistoryForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["isException"] = this.isException;
        data["statusTime"] = this.statusTime ? this.statusTime.toISOString() : undefined;
        data["eventGroupDescription"] = this.eventGroupDescription;
        data["eventDetailStatus"] = this.eventDetailStatus;
        data["eventDetailDescription"] = this.eventDetailDescription;
        data["eventSource"] = this.eventSource;
        data["userName"] = this.userName;
        data["eventComment"] = this.eventComment;
        data["barcode"] = this.barcode;
        data["eventLocation"] = this.eventLocation;
        data["eventLocationCode"] = this.eventLocationCode;
        if (Array.isArray(this.packageHistoryTags)) {
            data["packageHistoryTags"] = [];
            for (var _i = 0, _a = this.packageHistoryTags; _i < _a.length; _i++) {
                var item = _a[_i];
                data["packageHistoryTags"].push(item);
            }
        }
        data["loadId"] = this.loadId;
        data["palletConnoteNumber"] = this.palletConnoteNumber;
        data["palletId"] = this.palletId;
        data["subStatus"] = this.subStatus;
        return data;
    };
    return GetPackageHistoryForViewDto;
}());
export { GetPackageHistoryForViewDto };
var PagedResultDtoOfGetPackageHistoryForViewDto = /** @class */ (function () {
    function PagedResultDtoOfGetPackageHistoryForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfGetPackageHistoryForViewDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(GetPackageHistoryForViewDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfGetPackageHistoryForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfGetPackageHistoryForViewDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfGetPackageHistoryForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfGetPackageHistoryForViewDto;
}());
export { PagedResultDtoOfGetPackageHistoryForViewDto };
var GetPackageForViewDto = /** @class */ (function () {
    function GetPackageForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetPackageForViewDto.prototype.init = function (data) {
        if (data) {
            this.package = data["package"] ? PackageDto.fromJS(data["package"]) : undefined;
        }
    };
    GetPackageForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetPackageForViewDto();
        result.init(data);
        return result;
    };
    GetPackageForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["package"] = this.package ? this.package.toJSON() : undefined;
        return data;
    };
    return GetPackageForViewDto;
}());
export { GetPackageForViewDto };
var PagedResultDtoOfGetPackageForViewDto = /** @class */ (function () {
    function PagedResultDtoOfGetPackageForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfGetPackageForViewDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(GetPackageForViewDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfGetPackageForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfGetPackageForViewDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfGetPackageForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfGetPackageForViewDto;
}());
export { PagedResultDtoOfGetPackageForViewDto };
var GetPackageForEditOutput = /** @class */ (function () {
    function GetPackageForEditOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetPackageForEditOutput.prototype.init = function (data) {
        if (data) {
            this.package = data["package"] ? CreateOrEditPackageDto.fromJS(data["package"]) : undefined;
        }
    };
    GetPackageForEditOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetPackageForEditOutput();
        result.init(data);
        return result;
    };
    GetPackageForEditOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["package"] = this.package ? this.package.toJSON() : undefined;
        return data;
    };
    return GetPackageForEditOutput;
}());
export { GetPackageForEditOutput };
var PackageStatusDto = /** @class */ (function () {
    function PackageStatusDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PackageStatusDto.prototype.init = function (data) {
        if (data) {
            this.packageId = data["packageId"];
            this.barcode = data["barcode"];
            this.consignmentNumber = data["consignmentNumber"];
            this.deliveryType = data["deliveryType"];
            this.status = data["status"];
            this.isSuccess = data["isSuccess"];
        }
    };
    PackageStatusDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PackageStatusDto();
        result.init(data);
        return result;
    };
    PackageStatusDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["packageId"] = this.packageId;
        data["barcode"] = this.barcode;
        data["consignmentNumber"] = this.consignmentNumber;
        data["deliveryType"] = this.deliveryType;
        data["status"] = this.status;
        data["isSuccess"] = this.isSuccess;
        return data;
    };
    return PackageStatusDto;
}());
export { PackageStatusDto };
var PackageWeightDto = /** @class */ (function () {
    function PackageWeightDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PackageWeightDto.prototype.init = function (data) {
        if (data) {
            this.uom = data["uom"];
            this.weight = data["weight"];
            this.description = data["description"];
            this.id = data["id"];
        }
    };
    PackageWeightDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PackageWeightDto();
        result.init(data);
        return result;
    };
    PackageWeightDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["uom"] = this.uom;
        data["weight"] = this.weight;
        data["description"] = this.description;
        data["id"] = this.id;
        return data;
    };
    return PackageWeightDto;
}());
export { PackageWeightDto };
var GetPackageWeightForViewDto = /** @class */ (function () {
    function GetPackageWeightForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetPackageWeightForViewDto.prototype.init = function (data) {
        if (data) {
            this.packageWeight = data["packageWeight"] ? PackageWeightDto.fromJS(data["packageWeight"]) : undefined;
        }
    };
    GetPackageWeightForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetPackageWeightForViewDto();
        result.init(data);
        return result;
    };
    GetPackageWeightForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["packageWeight"] = this.packageWeight ? this.packageWeight.toJSON() : undefined;
        return data;
    };
    return GetPackageWeightForViewDto;
}());
export { GetPackageWeightForViewDto };
var PagedResultDtoOfGetPackageWeightForViewDto = /** @class */ (function () {
    function PagedResultDtoOfGetPackageWeightForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfGetPackageWeightForViewDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(GetPackageWeightForViewDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfGetPackageWeightForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfGetPackageWeightForViewDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfGetPackageWeightForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfGetPackageWeightForViewDto;
}());
export { PagedResultDtoOfGetPackageWeightForViewDto };
var CreateOrEditPackageWeightDto = /** @class */ (function () {
    function CreateOrEditPackageWeightDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateOrEditPackageWeightDto.prototype.init = function (data) {
        if (data) {
            this.uom = data["uom"];
            this.weight = data["weight"];
            this.description = data["description"];
            this.id = data["id"];
        }
    };
    CreateOrEditPackageWeightDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrEditPackageWeightDto();
        result.init(data);
        return result;
    };
    CreateOrEditPackageWeightDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["uom"] = this.uom;
        data["weight"] = this.weight;
        data["description"] = this.description;
        data["id"] = this.id;
        return data;
    };
    return CreateOrEditPackageWeightDto;
}());
export { CreateOrEditPackageWeightDto };
var GetPackageWeightForEditOutput = /** @class */ (function () {
    function GetPackageWeightForEditOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetPackageWeightForEditOutput.prototype.init = function (data) {
        if (data) {
            this.packageWeight = data["packageWeight"] ? CreateOrEditPackageWeightDto.fromJS(data["packageWeight"]) : undefined;
        }
    };
    GetPackageWeightForEditOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetPackageWeightForEditOutput();
        result.init(data);
        return result;
    };
    GetPackageWeightForEditOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["packageWeight"] = this.packageWeight ? this.packageWeight.toJSON() : undefined;
        return data;
    };
    return GetPackageWeightForEditOutput;
}());
export { GetPackageWeightForEditOutput };
var BulkRescheduleByPalletIdsInputDto = /** @class */ (function () {
    function BulkRescheduleByPalletIdsInputDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BulkRescheduleByPalletIdsInputDto.prototype.init = function (data) {
        if (data) {
            this.newShipDate = data["newShipDate"] ? moment(data["newShipDate"].toString()) : undefined;
            if (Array.isArray(data["palletIds"])) {
                this.palletIds = [];
                for (var _i = 0, _a = data["palletIds"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.palletIds.push(item);
                }
            }
            this.comment = data["comment"];
            this.deliveryType = data["deliveryType"];
            this.carrierId = data["carrierId"];
            this.resolveZendeskTicket = data["resolveZendeskTicket"];
        }
    };
    BulkRescheduleByPalletIdsInputDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BulkRescheduleByPalletIdsInputDto();
        result.init(data);
        return result;
    };
    BulkRescheduleByPalletIdsInputDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["newShipDate"] = this.newShipDate ? this.newShipDate.toISOString() : undefined;
        if (Array.isArray(this.palletIds)) {
            data["palletIds"] = [];
            for (var _i = 0, _a = this.palletIds; _i < _a.length; _i++) {
                var item = _a[_i];
                data["palletIds"].push(item);
            }
        }
        data["comment"] = this.comment;
        data["deliveryType"] = this.deliveryType;
        data["carrierId"] = this.carrierId;
        data["resolveZendeskTicket"] = this.resolveZendeskTicket;
        return data;
    };
    return BulkRescheduleByPalletIdsInputDto;
}());
export { BulkRescheduleByPalletIdsInputDto };
var BulkPalletValidationResult = /** @class */ (function () {
    function BulkPalletValidationResult(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BulkPalletValidationResult.prototype.init = function (data) {
        if (data) {
            if (Array.isArray(data["validPalletIds"])) {
                this.validPalletIds = [];
                for (var _i = 0, _a = data["validPalletIds"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.validPalletIds.push(item);
                }
            }
            if (Array.isArray(data["errors"])) {
                this.errors = [];
                for (var _b = 0, _c = data["errors"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.errors.push(item);
                }
            }
            if (Array.isArray(data["warnings"])) {
                this.warnings = [];
                for (var _d = 0, _e = data["warnings"]; _d < _e.length; _d++) {
                    var item = _e[_d];
                    this.warnings.push(item);
                }
            }
            if (Array.isArray(data["warningCodes"])) {
                this.warningCodes = [];
                for (var _f = 0, _g = data["warningCodes"]; _f < _g.length; _f++) {
                    var item = _g[_f];
                    this.warningCodes.push(item);
                }
            }
        }
    };
    BulkPalletValidationResult.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BulkPalletValidationResult();
        result.init(data);
        return result;
    };
    BulkPalletValidationResult.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.validPalletIds)) {
            data["validPalletIds"] = [];
            for (var _i = 0, _a = this.validPalletIds; _i < _a.length; _i++) {
                var item = _a[_i];
                data["validPalletIds"].push(item);
            }
        }
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (var _b = 0, _c = this.errors; _b < _c.length; _b++) {
                var item = _c[_b];
                data["errors"].push(item);
            }
        }
        if (Array.isArray(this.warnings)) {
            data["warnings"] = [];
            for (var _d = 0, _e = this.warnings; _d < _e.length; _d++) {
                var item = _e[_d];
                data["warnings"].push(item);
            }
        }
        if (Array.isArray(this.warningCodes)) {
            data["warningCodes"] = [];
            for (var _f = 0, _g = this.warningCodes; _f < _g.length; _f++) {
                var item = _g[_f];
                data["warningCodes"].push(item);
            }
        }
        return data;
    };
    return BulkPalletValidationResult;
}());
export { BulkPalletValidationResult };
var GetAllPalletsInput = /** @class */ (function () {
    function GetAllPalletsInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetAllPalletsInput.prototype.init = function (data) {
        if (data) {
            this.consignmentNumberFilter = data["consignmentNumberFilter"];
            this.barcodeFilter = data["barcodeFilter"];
            this.maxShipdateFilter = data["maxShipdateFilter"] ? moment(data["maxShipdateFilter"].toString()) : undefined;
            this.minShipdateFilter = data["minShipdateFilter"] ? moment(data["minShipdateFilter"].toString()) : undefined;
            this.fromFilter = data["fromFilter"];
            this.carrierFilter = data["carrierFilter"];
            this.docketFilter = data["docketFilter"];
            if (Array.isArray(data["palletStatusFilter"])) {
                this.palletStatusFilter = [];
                for (var _i = 0, _a = data["palletStatusFilter"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.palletStatusFilter.push(item);
                }
            }
            this.ownDepotFilter = data["ownDepotFilter"];
            this.isActiveFilter = data["isActiveFilter"];
            if (Array.isArray(data["mappedLocationsFilter"])) {
                this.mappedLocationsFilter = [];
                for (var _b = 0, _c = data["mappedLocationsFilter"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.mappedLocationsFilter.push(item);
                }
            }
            if (Array.isArray(data["idFilter"])) {
                this.idFilter = [];
                for (var _d = 0, _e = data["idFilter"]; _d < _e.length; _d++) {
                    var item = _e[_d];
                    this.idFilter.push(item);
                }
            }
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    };
    GetAllPalletsInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetAllPalletsInput();
        result.init(data);
        return result;
    };
    GetAllPalletsInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["consignmentNumberFilter"] = this.consignmentNumberFilter;
        data["barcodeFilter"] = this.barcodeFilter;
        data["maxShipdateFilter"] = this.maxShipdateFilter ? this.maxShipdateFilter.toISOString() : undefined;
        data["minShipdateFilter"] = this.minShipdateFilter ? this.minShipdateFilter.toISOString() : undefined;
        data["fromFilter"] = this.fromFilter;
        data["carrierFilter"] = this.carrierFilter;
        data["docketFilter"] = this.docketFilter;
        if (Array.isArray(this.palletStatusFilter)) {
            data["palletStatusFilter"] = [];
            for (var _i = 0, _a = this.palletStatusFilter; _i < _a.length; _i++) {
                var item = _a[_i];
                data["palletStatusFilter"].push(item);
            }
        }
        data["ownDepotFilter"] = this.ownDepotFilter;
        data["isActiveFilter"] = this.isActiveFilter;
        if (Array.isArray(this.mappedLocationsFilter)) {
            data["mappedLocationsFilter"] = [];
            for (var _b = 0, _c = this.mappedLocationsFilter; _b < _c.length; _b++) {
                var item = _c[_b];
                data["mappedLocationsFilter"].push(item);
            }
        }
        if (Array.isArray(this.idFilter)) {
            data["idFilter"] = [];
            for (var _d = 0, _e = this.idFilter; _d < _e.length; _d++) {
                var item = _e[_d];
                data["idFilter"].push(item);
            }
        }
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    };
    return GetAllPalletsInput;
}());
export { GetAllPalletsInput };
var PalletPackageDto = /** @class */ (function () {
    function PalletPackageDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PalletPackageDto.prototype.init = function (data) {
        if (data) {
            this.palletId = data["palletId"];
            this.packageId = data["packageId"];
            this.packageBarcode = data["packageBarcode"];
            this.palletConsignmentNumber = data["palletConsignmentNumber"];
            this.id = data["id"];
        }
    };
    PalletPackageDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PalletPackageDto();
        result.init(data);
        return result;
    };
    PalletPackageDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["palletId"] = this.palletId;
        data["packageId"] = this.packageId;
        data["packageBarcode"] = this.packageBarcode;
        data["palletConsignmentNumber"] = this.palletConsignmentNumber;
        data["id"] = this.id;
        return data;
    };
    return PalletPackageDto;
}());
export { PalletPackageDto };
var PalletDto = /** @class */ (function () {
    function PalletDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PalletDto.prototype.init = function (data) {
        if (data) {
            this.consignmentNumber = data["consignmentNumber"];
            this.barcode = data["barcode"];
            this.shipdate = data["shipdate"] ? moment(data["shipdate"].toString()) : undefined;
            this.from = data["from"];
            this.weight = data["weight"];
            this.carrier = data["carrier"];
            this.docket = data["docket"];
            this.deliveryInstruction = data["deliveryInstruction"];
            this.locationId = data["locationId"];
            this.destination = data["destination"];
            this.suburb = data["suburb"];
            this.businessName = data["businessName"];
            this.status = data["status"];
            this.mappedLocations = data["mappedLocations"];
            this.isActive = data["isActive"];
            this.podIdentifierInFred = data["podIdentifierInFred"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            if (Array.isArray(data["palletPackages"])) {
                this.palletPackages = [];
                for (var _i = 0, _a = data["palletPackages"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.palletPackages.push(PalletPackageDto.fromJS(item));
                }
            }
            this.zenDeskTicket = data["zenDeskTicket"] ? ZenDeskTicketDto.fromJS(data["zenDeskTicket"]) : undefined;
            this.id = data["id"];
        }
    };
    PalletDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PalletDto();
        result.init(data);
        return result;
    };
    PalletDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["consignmentNumber"] = this.consignmentNumber;
        data["barcode"] = this.barcode;
        data["shipdate"] = this.shipdate ? this.shipdate.toISOString() : undefined;
        data["from"] = this.from;
        data["weight"] = this.weight;
        data["carrier"] = this.carrier;
        data["docket"] = this.docket;
        data["deliveryInstruction"] = this.deliveryInstruction;
        data["locationId"] = this.locationId;
        data["destination"] = this.destination;
        data["suburb"] = this.suburb;
        data["businessName"] = this.businessName;
        data["status"] = this.status;
        data["mappedLocations"] = this.mappedLocations;
        data["isActive"] = this.isActive;
        data["podIdentifierInFred"] = this.podIdentifierInFred;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        if (Array.isArray(this.palletPackages)) {
            data["palletPackages"] = [];
            for (var _i = 0, _a = this.palletPackages; _i < _a.length; _i++) {
                var item = _a[_i];
                data["palletPackages"].push(item.toJSON());
            }
        }
        data["zenDeskTicket"] = this.zenDeskTicket ? this.zenDeskTicket.toJSON() : undefined;
        data["id"] = this.id;
        return data;
    };
    return PalletDto;
}());
export { PalletDto };
var GetPalletForViewDto = /** @class */ (function () {
    function GetPalletForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetPalletForViewDto.prototype.init = function (data) {
        if (data) {
            this.pallet = data["pallet"] ? PalletDto.fromJS(data["pallet"]) : undefined;
            this.packageCount = data["packageCount"];
            this.userName = data["userName"];
        }
    };
    GetPalletForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetPalletForViewDto();
        result.init(data);
        return result;
    };
    GetPalletForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["pallet"] = this.pallet ? this.pallet.toJSON() : undefined;
        data["packageCount"] = this.packageCount;
        data["userName"] = this.userName;
        return data;
    };
    return GetPalletForViewDto;
}());
export { GetPalletForViewDto };
var PagedResultDtoOfGetPalletForViewDto = /** @class */ (function () {
    function PagedResultDtoOfGetPalletForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfGetPalletForViewDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(GetPalletForViewDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfGetPalletForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfGetPalletForViewDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfGetPalletForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfGetPalletForViewDto;
}());
export { PagedResultDtoOfGetPalletForViewDto };
var PalletValidationResult = /** @class */ (function () {
    function PalletValidationResult(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PalletValidationResult.prototype.init = function (data) {
        if (data) {
            this.palletBarcode = data["palletBarcode"];
            this.isValid = data["isValid"];
        }
    };
    PalletValidationResult.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PalletValidationResult();
        result.init(data);
        return result;
    };
    PalletValidationResult.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["palletBarcode"] = this.palletBarcode;
        data["isValid"] = this.isValid;
        return data;
    };
    return PalletValidationResult;
}());
export { PalletValidationResult };
var CreateOrEditPalletDto = /** @class */ (function () {
    function CreateOrEditPalletDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateOrEditPalletDto.prototype.init = function (data) {
        if (data) {
            this.consignmentNumber = data["consignmentNumber"];
            this.barcode = data["barcode"];
            this.shipdate = data["shipdate"] ? moment(data["shipdate"].toString()) : undefined;
            this.from = data["from"];
            this.weight = data["weight"];
            this.carrier = data["carrier"];
            this.docket = data["docket"];
            this.deliveryInstruction = data["deliveryInstruction"];
            this.storeId = data["storeId"];
            this.locationId = data["locationId"];
            this.location = data["location"] ? CreateOrEditLocationDto.fromJS(data["location"]) : undefined;
            this.status = data["status"];
            this.mappedLocations = data["mappedLocations"];
            this.isActive = data["isActive"];
            this.id = data["id"];
        }
    };
    CreateOrEditPalletDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrEditPalletDto();
        result.init(data);
        return result;
    };
    CreateOrEditPalletDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["consignmentNumber"] = this.consignmentNumber;
        data["barcode"] = this.barcode;
        data["shipdate"] = this.shipdate ? this.shipdate.toISOString() : undefined;
        data["from"] = this.from;
        data["weight"] = this.weight;
        data["carrier"] = this.carrier;
        data["docket"] = this.docket;
        data["deliveryInstruction"] = this.deliveryInstruction;
        data["storeId"] = this.storeId;
        data["locationId"] = this.locationId;
        data["location"] = this.location ? this.location.toJSON() : undefined;
        data["status"] = this.status;
        data["mappedLocations"] = this.mappedLocations;
        data["isActive"] = this.isActive;
        data["id"] = this.id;
        return data;
    };
    return CreateOrEditPalletDto;
}());
export { CreateOrEditPalletDto };
var GetPalletForEditOutput = /** @class */ (function () {
    function GetPalletForEditOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetPalletForEditOutput.prototype.init = function (data) {
        if (data) {
            this.pallet = data["pallet"] ? CreateOrEditPalletDto.fromJS(data["pallet"]) : undefined;
        }
    };
    GetPalletForEditOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetPalletForEditOutput();
        result.init(data);
        return result;
    };
    GetPalletForEditOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["pallet"] = this.pallet ? this.pallet.toJSON() : undefined;
        return data;
    };
    return GetPalletForEditOutput;
}());
export { GetPalletForEditOutput };
var CreatePalletFromMidasDto = /** @class */ (function () {
    function CreatePalletFromMidasDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreatePalletFromMidasDto.prototype.init = function (data) {
        if (data) {
            this.from = data["from"];
            this.id = data["id"];
        }
    };
    CreatePalletFromMidasDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreatePalletFromMidasDto();
        result.init(data);
        return result;
    };
    CreatePalletFromMidasDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from;
        data["id"] = this.id;
        return data;
    };
    return CreatePalletFromMidasDto;
}());
export { CreatePalletFromMidasDto };
var GetAllPalletsForExcelInput = /** @class */ (function () {
    function GetAllPalletsForExcelInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetAllPalletsForExcelInput.prototype.init = function (data) {
        if (data) {
            this.consignmentNumberFilter = data["consignmentNumberFilter"];
            this.barcodeFilter = data["barcodeFilter"];
            this.maxShipdateFilter = data["maxShipdateFilter"] ? moment(data["maxShipdateFilter"].toString()) : undefined;
            this.minShipdateFilter = data["minShipdateFilter"] ? moment(data["minShipdateFilter"].toString()) : undefined;
            this.fromFilter = data["fromFilter"];
            this.carrierFilter = data["carrierFilter"];
            this.docketFilter = data["docketFilter"];
            if (Array.isArray(data["palletStatusFilter"])) {
                this.palletStatusFilter = [];
                for (var _i = 0, _a = data["palletStatusFilter"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.palletStatusFilter.push(item);
                }
            }
            this.ownDepotFilter = data["ownDepotFilter"];
            this.isActiveFilter = data["isActiveFilter"];
        }
    };
    GetAllPalletsForExcelInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetAllPalletsForExcelInput();
        result.init(data);
        return result;
    };
    GetAllPalletsForExcelInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["consignmentNumberFilter"] = this.consignmentNumberFilter;
        data["barcodeFilter"] = this.barcodeFilter;
        data["maxShipdateFilter"] = this.maxShipdateFilter ? this.maxShipdateFilter.toISOString() : undefined;
        data["minShipdateFilter"] = this.minShipdateFilter ? this.minShipdateFilter.toISOString() : undefined;
        data["fromFilter"] = this.fromFilter;
        data["carrierFilter"] = this.carrierFilter;
        data["docketFilter"] = this.docketFilter;
        if (Array.isArray(this.palletStatusFilter)) {
            data["palletStatusFilter"] = [];
            for (var _i = 0, _a = this.palletStatusFilter; _i < _a.length; _i++) {
                var item = _a[_i];
                data["palletStatusFilter"].push(item);
            }
        }
        data["ownDepotFilter"] = this.ownDepotFilter;
        data["isActiveFilter"] = this.isActiveFilter;
        return data;
    };
    return GetAllPalletsForExcelInput;
}());
export { GetAllPalletsForExcelInput };
var PrintLabelsByPalletIdsInput = /** @class */ (function () {
    function PrintLabelsByPalletIdsInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PrintLabelsByPalletIdsInput.prototype.init = function (data) {
        if (data) {
            if (Array.isArray(data["palletIds"])) {
                this.palletIds = [];
                for (var _i = 0, _a = data["palletIds"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.palletIds.push(item);
                }
            }
            this.labelType = data["labelType"];
        }
    };
    PrintLabelsByPalletIdsInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PrintLabelsByPalletIdsInput();
        result.init(data);
        return result;
    };
    PrintLabelsByPalletIdsInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.palletIds)) {
            data["palletIds"] = [];
            for (var _i = 0, _a = this.palletIds; _i < _a.length; _i++) {
                var item = _a[_i];
                data["palletIds"].push(item);
            }
        }
        data["labelType"] = this.labelType;
        return data;
    };
    return PrintLabelsByPalletIdsInput;
}());
export { PrintLabelsByPalletIdsInput };
var ResolveZendeskTicketByPalletIdInput = /** @class */ (function () {
    function ResolveZendeskTicketByPalletIdInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ResolveZendeskTicketByPalletIdInput.prototype.init = function (data) {
        if (data) {
            if (Array.isArray(data["palletIds"])) {
                this.palletIds = [];
                for (var _i = 0, _a = data["palletIds"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.palletIds.push(item);
                }
            }
            this.ticketComment = data["ticketComment"];
        }
    };
    ResolveZendeskTicketByPalletIdInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ResolveZendeskTicketByPalletIdInput();
        result.init(data);
        return result;
    };
    ResolveZendeskTicketByPalletIdInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.palletIds)) {
            data["palletIds"] = [];
            for (var _i = 0, _a = this.palletIds; _i < _a.length; _i++) {
                var item = _a[_i];
                data["palletIds"].push(item);
            }
        }
        data["ticketComment"] = this.ticketComment;
        return data;
    };
    return ResolveZendeskTicketByPalletIdInput;
}());
export { ResolveZendeskTicketByPalletIdInput };
var GetNonPalletisedBarcodesInput = /** @class */ (function () {
    function GetNonPalletisedBarcodesInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetNonPalletisedBarcodesInput.prototype.init = function (data) {
        if (data) {
            if (Array.isArray(data["palletIdsFilter"])) {
                this.palletIdsFilter = [];
                for (var _i = 0, _a = data["palletIdsFilter"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.palletIdsFilter.push(item);
                }
            }
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    };
    GetNonPalletisedBarcodesInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetNonPalletisedBarcodesInput();
        result.init(data);
        return result;
    };
    GetNonPalletisedBarcodesInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.palletIdsFilter)) {
            data["palletIdsFilter"] = [];
            for (var _i = 0, _a = this.palletIdsFilter; _i < _a.length; _i++) {
                var item = _a[_i];
                data["palletIdsFilter"].push(item);
            }
        }
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    };
    return GetNonPalletisedBarcodesInput;
}());
export { GetNonPalletisedBarcodesInput };
var GetNonPalletisedBarcodesForViewDto = /** @class */ (function () {
    function GetNonPalletisedBarcodesForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetNonPalletisedBarcodesForViewDto.prototype.init = function (data) {
        if (data) {
            this.barcode = data["barcode"];
            this.connoteNumber = data["connoteNumber"];
            this.territory = data["territory"];
            this.recipientName = data["recipientName"];
            this.suburb = data["suburb"];
            this.clientCode = data["clientCode"];
            this.palletConnoteNumber = data["palletConnoteNumber"];
            this.palletDestinationAddress = data["palletDestinationAddress"];
        }
    };
    GetNonPalletisedBarcodesForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetNonPalletisedBarcodesForViewDto();
        result.init(data);
        return result;
    };
    GetNonPalletisedBarcodesForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["barcode"] = this.barcode;
        data["connoteNumber"] = this.connoteNumber;
        data["territory"] = this.territory;
        data["recipientName"] = this.recipientName;
        data["suburb"] = this.suburb;
        data["clientCode"] = this.clientCode;
        data["palletConnoteNumber"] = this.palletConnoteNumber;
        data["palletDestinationAddress"] = this.palletDestinationAddress;
        return data;
    };
    return GetNonPalletisedBarcodesForViewDto;
}());
export { GetNonPalletisedBarcodesForViewDto };
var PagedResultDtoOfGetNonPalletisedBarcodesForViewDto = /** @class */ (function () {
    function PagedResultDtoOfGetNonPalletisedBarcodesForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfGetNonPalletisedBarcodesForViewDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(GetNonPalletisedBarcodesForViewDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfGetNonPalletisedBarcodesForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfGetNonPalletisedBarcodesForViewDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfGetNonPalletisedBarcodesForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfGetNonPalletisedBarcodesForViewDto;
}());
export { PagedResultDtoOfGetNonPalletisedBarcodesForViewDto };
var GetNonPalletisedBarcodesForExcelInput = /** @class */ (function () {
    function GetNonPalletisedBarcodesForExcelInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetNonPalletisedBarcodesForExcelInput.prototype.init = function (data) {
        if (data) {
            if (Array.isArray(data["palletIdsFilter"])) {
                this.palletIdsFilter = [];
                for (var _i = 0, _a = data["palletIdsFilter"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.palletIdsFilter.push(item);
                }
            }
        }
    };
    GetNonPalletisedBarcodesForExcelInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetNonPalletisedBarcodesForExcelInput();
        result.init(data);
        return result;
    };
    GetNonPalletisedBarcodesForExcelInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.palletIdsFilter)) {
            data["palletIdsFilter"] = [];
            for (var _i = 0, _a = this.palletIdsFilter; _i < _a.length; _i++) {
                var item = _a[_i];
                data["palletIdsFilter"].push(item);
            }
        }
        return data;
    };
    return GetNonPalletisedBarcodesForExcelInput;
}());
export { GetNonPalletisedBarcodesForExcelInput };
export var ChangePalletStatusType;
(function (ChangePalletStatusType) {
    ChangePalletStatusType[ChangePalletStatusType["None"] = 0] = "None";
    ChangePalletStatusType[ChangePalletStatusType["LAIComplete"] = 1] = "LAIComplete";
    ChangePalletStatusType[ChangePalletStatusType["SignComplete"] = 2] = "SignComplete";
    ChangePalletStatusType[ChangePalletStatusType["WithDriver"] = 3] = "WithDriver";
})(ChangePalletStatusType || (ChangePalletStatusType = {}));
var ChangePalletStatusByPalletIdsDto = /** @class */ (function () {
    function ChangePalletStatusByPalletIdsDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ChangePalletStatusByPalletIdsDto.prototype.init = function (data) {
        if (data) {
            if (Array.isArray(data["palletIds"])) {
                this.palletIds = [];
                for (var _i = 0, _a = data["palletIds"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.palletIds.push(item);
                }
            }
            this.changeStatusType = data["changeStatusType"];
            this.comment = data["comment"];
        }
    };
    ChangePalletStatusByPalletIdsDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ChangePalletStatusByPalletIdsDto();
        result.init(data);
        return result;
    };
    ChangePalletStatusByPalletIdsDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.palletIds)) {
            data["palletIds"] = [];
            for (var _i = 0, _a = this.palletIds; _i < _a.length; _i++) {
                var item = _a[_i];
                data["palletIds"].push(item);
            }
        }
        data["changeStatusType"] = this.changeStatusType;
        data["comment"] = this.comment;
        return data;
    };
    return ChangePalletStatusByPalletIdsDto;
}());
export { ChangePalletStatusByPalletIdsDto };
var EditionSelectDto = /** @class */ (function () {
    function EditionSelectDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EditionSelectDto.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.expiringEditionId = data["expiringEditionId"];
            this.dailyPrice = data["dailyPrice"];
            this.weeklyPrice = data["weeklyPrice"];
            this.monthlyPrice = data["monthlyPrice"];
            this.annualPrice = data["annualPrice"];
            this.trialDayCount = data["trialDayCount"];
            this.waitingDayAfterExpire = data["waitingDayAfterExpire"];
            this.isFree = data["isFree"];
            this.additionalData = data["additionalData"] ? AdditionalData.fromJS(data["additionalData"]) : undefined;
        }
    };
    EditionSelectDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new EditionSelectDto();
        result.init(data);
        return result;
    };
    EditionSelectDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["expiringEditionId"] = this.expiringEditionId;
        data["dailyPrice"] = this.dailyPrice;
        data["weeklyPrice"] = this.weeklyPrice;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["trialDayCount"] = this.trialDayCount;
        data["waitingDayAfterExpire"] = this.waitingDayAfterExpire;
        data["isFree"] = this.isFree;
        data["additionalData"] = this.additionalData ? this.additionalData.toJSON() : undefined;
        return data;
    };
    return EditionSelectDto;
}());
export { EditionSelectDto };
var PaymentInfoDto = /** @class */ (function () {
    function PaymentInfoDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PaymentInfoDto.prototype.init = function (data) {
        if (data) {
            this.edition = data["edition"] ? EditionSelectDto.fromJS(data["edition"]) : undefined;
            this.additionalPrice = data["additionalPrice"];
        }
    };
    PaymentInfoDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PaymentInfoDto();
        result.init(data);
        return result;
    };
    PaymentInfoDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : undefined;
        data["additionalPrice"] = this.additionalPrice;
        return data;
    };
    return PaymentInfoDto;
}());
export { PaymentInfoDto };
export var EditionPaymentType;
(function (EditionPaymentType) {
    EditionPaymentType[EditionPaymentType["NewRegistration"] = 0] = "NewRegistration";
    EditionPaymentType[EditionPaymentType["BuyNow"] = 1] = "BuyNow";
    EditionPaymentType[EditionPaymentType["Upgrade"] = 2] = "Upgrade";
    EditionPaymentType[EditionPaymentType["Extend"] = 3] = "Extend";
})(EditionPaymentType || (EditionPaymentType = {}));
export var PaymentPeriodType;
(function (PaymentPeriodType) {
    PaymentPeriodType[PaymentPeriodType["Daily"] = 1] = "Daily";
    PaymentPeriodType[PaymentPeriodType["Weekly"] = 7] = "Weekly";
    PaymentPeriodType[PaymentPeriodType["Monthly"] = 30] = "Monthly";
    PaymentPeriodType[PaymentPeriodType["Annual"] = 365] = "Annual";
})(PaymentPeriodType || (PaymentPeriodType = {}));
export var SubscriptionPaymentGatewayType;
(function (SubscriptionPaymentGatewayType) {
    SubscriptionPaymentGatewayType[SubscriptionPaymentGatewayType["Paypal"] = 1] = "Paypal";
    SubscriptionPaymentGatewayType[SubscriptionPaymentGatewayType["Stripe"] = 2] = "Stripe";
})(SubscriptionPaymentGatewayType || (SubscriptionPaymentGatewayType = {}));
var CreatePaymentDto = /** @class */ (function () {
    function CreatePaymentDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreatePaymentDto.prototype.init = function (data) {
        if (data) {
            this.editionId = data["editionId"];
            this.editionPaymentType = data["editionPaymentType"];
            this.paymentPeriodType = data["paymentPeriodType"];
            this.subscriptionPaymentGatewayType = data["subscriptionPaymentGatewayType"];
            this.recurringPaymentEnabled = data["recurringPaymentEnabled"];
            this.successUrl = data["successUrl"];
            this.errorUrl = data["errorUrl"];
        }
    };
    CreatePaymentDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreatePaymentDto();
        result.init(data);
        return result;
    };
    CreatePaymentDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["editionId"] = this.editionId;
        data["editionPaymentType"] = this.editionPaymentType;
        data["paymentPeriodType"] = this.paymentPeriodType;
        data["subscriptionPaymentGatewayType"] = this.subscriptionPaymentGatewayType;
        data["recurringPaymentEnabled"] = this.recurringPaymentEnabled;
        data["successUrl"] = this.successUrl;
        data["errorUrl"] = this.errorUrl;
        return data;
    };
    return CreatePaymentDto;
}());
export { CreatePaymentDto };
var CancelPaymentDto = /** @class */ (function () {
    function CancelPaymentDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CancelPaymentDto.prototype.init = function (data) {
        if (data) {
            this.paymentId = data["paymentId"];
            this.gateway = data["gateway"];
        }
    };
    CancelPaymentDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CancelPaymentDto();
        result.init(data);
        return result;
    };
    CancelPaymentDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["paymentId"] = this.paymentId;
        data["gateway"] = this.gateway;
        return data;
    };
    return CancelPaymentDto;
}());
export { CancelPaymentDto };
var SubscriptionPaymentListDto = /** @class */ (function () {
    function SubscriptionPaymentListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SubscriptionPaymentListDto.prototype.init = function (data) {
        if (data) {
            this.gateway = data["gateway"];
            this.amount = data["amount"];
            this.editionId = data["editionId"];
            this.dayCount = data["dayCount"];
            this.paymentPeriodType = data["paymentPeriodType"];
            this.externalPaymentId = data["externalPaymentId"];
            this.payerId = data["payerId"];
            this.status = data["status"];
            this.editionDisplayName = data["editionDisplayName"];
            this.tenantId = data["tenantId"];
            this.invoiceNo = data["invoiceNo"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    };
    SubscriptionPaymentListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SubscriptionPaymentListDto();
        result.init(data);
        return result;
    };
    SubscriptionPaymentListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["gateway"] = this.gateway;
        data["amount"] = this.amount;
        data["editionId"] = this.editionId;
        data["dayCount"] = this.dayCount;
        data["paymentPeriodType"] = this.paymentPeriodType;
        data["externalPaymentId"] = this.externalPaymentId;
        data["payerId"] = this.payerId;
        data["status"] = this.status;
        data["editionDisplayName"] = this.editionDisplayName;
        data["tenantId"] = this.tenantId;
        data["invoiceNo"] = this.invoiceNo;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    return SubscriptionPaymentListDto;
}());
export { SubscriptionPaymentListDto };
var PagedResultDtoOfSubscriptionPaymentListDto = /** @class */ (function () {
    function PagedResultDtoOfSubscriptionPaymentListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfSubscriptionPaymentListDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(SubscriptionPaymentListDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfSubscriptionPaymentListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfSubscriptionPaymentListDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfSubscriptionPaymentListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfSubscriptionPaymentListDto;
}());
export { PagedResultDtoOfSubscriptionPaymentListDto };
var PaymentGatewayModel = /** @class */ (function () {
    function PaymentGatewayModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PaymentGatewayModel.prototype.init = function (data) {
        if (data) {
            this.gatewayType = data["gatewayType"];
            this.supportsRecurringPayments = data["supportsRecurringPayments"];
        }
    };
    PaymentGatewayModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PaymentGatewayModel();
        result.init(data);
        return result;
    };
    PaymentGatewayModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["gatewayType"] = this.gatewayType;
        data["supportsRecurringPayments"] = this.supportsRecurringPayments;
        return data;
    };
    return PaymentGatewayModel;
}());
export { PaymentGatewayModel };
export var SubscriptionPaymentStatus;
(function (SubscriptionPaymentStatus) {
    SubscriptionPaymentStatus[SubscriptionPaymentStatus["NotPaid"] = 1] = "NotPaid";
    SubscriptionPaymentStatus[SubscriptionPaymentStatus["Paid"] = 2] = "Paid";
    SubscriptionPaymentStatus[SubscriptionPaymentStatus["Failed"] = 3] = "Failed";
    SubscriptionPaymentStatus[SubscriptionPaymentStatus["Cancelled"] = 4] = "Cancelled";
    SubscriptionPaymentStatus[SubscriptionPaymentStatus["Completed"] = 5] = "Completed";
})(SubscriptionPaymentStatus || (SubscriptionPaymentStatus = {}));
var SubscriptionPaymentDto = /** @class */ (function () {
    function SubscriptionPaymentDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SubscriptionPaymentDto.prototype.init = function (data) {
        if (data) {
            this.description = data["description"];
            this.gateway = data["gateway"];
            this.amount = data["amount"];
            this.editionId = data["editionId"];
            this.tenantId = data["tenantId"];
            this.dayCount = data["dayCount"];
            this.paymentPeriodType = data["paymentPeriodType"];
            this.paymentId = data["paymentId"];
            this.payerId = data["payerId"];
            this.editionDisplayName = data["editionDisplayName"];
            this.invoiceNo = data["invoiceNo"];
            this.status = data["status"];
            this.isRecurring = data["isRecurring"];
            this.externalPaymentId = data["externalPaymentId"];
            this.successUrl = data["successUrl"];
            this.errorUrl = data["errorUrl"];
            this.editionPaymentType = data["editionPaymentType"];
            this.id = data["id"];
        }
    };
    SubscriptionPaymentDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SubscriptionPaymentDto();
        result.init(data);
        return result;
    };
    SubscriptionPaymentDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["gateway"] = this.gateway;
        data["amount"] = this.amount;
        data["editionId"] = this.editionId;
        data["tenantId"] = this.tenantId;
        data["dayCount"] = this.dayCount;
        data["paymentPeriodType"] = this.paymentPeriodType;
        data["paymentId"] = this.paymentId;
        data["payerId"] = this.payerId;
        data["editionDisplayName"] = this.editionDisplayName;
        data["invoiceNo"] = this.invoiceNo;
        data["status"] = this.status;
        data["isRecurring"] = this.isRecurring;
        data["externalPaymentId"] = this.externalPaymentId;
        data["successUrl"] = this.successUrl;
        data["errorUrl"] = this.errorUrl;
        data["editionPaymentType"] = this.editionPaymentType;
        data["id"] = this.id;
        return data;
    };
    return SubscriptionPaymentDto;
}());
export { SubscriptionPaymentDto };
var PayPalConfigurationDto = /** @class */ (function () {
    function PayPalConfigurationDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PayPalConfigurationDto.prototype.init = function (data) {
        if (data) {
            this.clientId = data["clientId"];
            this.demoUsername = data["demoUsername"];
            this.demoPassword = data["demoPassword"];
        }
    };
    PayPalConfigurationDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PayPalConfigurationDto();
        result.init(data);
        return result;
    };
    PayPalConfigurationDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["demoUsername"] = this.demoUsername;
        data["demoPassword"] = this.demoPassword;
        return data;
    };
    return PayPalConfigurationDto;
}());
export { PayPalConfigurationDto };
var FlatPermissionWithLevelDto = /** @class */ (function () {
    function FlatPermissionWithLevelDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FlatPermissionWithLevelDto.prototype.init = function (data) {
        if (data) {
            this.level = data["level"];
            this.parentName = data["parentName"];
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.description = data["description"];
            this.isGrantedByDefault = data["isGrantedByDefault"];
        }
    };
    FlatPermissionWithLevelDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FlatPermissionWithLevelDto();
        result.init(data);
        return result;
    };
    FlatPermissionWithLevelDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["level"] = this.level;
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["isGrantedByDefault"] = this.isGrantedByDefault;
        return data;
    };
    return FlatPermissionWithLevelDto;
}());
export { FlatPermissionWithLevelDto };
var ListResultDtoOfFlatPermissionWithLevelDto = /** @class */ (function () {
    function ListResultDtoOfFlatPermissionWithLevelDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ListResultDtoOfFlatPermissionWithLevelDto.prototype.init = function (data) {
        if (data) {
            if (Array.isArray(data["items"])) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(FlatPermissionWithLevelDto.fromJS(item));
                }
            }
        }
    };
    ListResultDtoOfFlatPermissionWithLevelDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ListResultDtoOfFlatPermissionWithLevelDto();
        result.init(data);
        return result;
    };
    ListResultDtoOfFlatPermissionWithLevelDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return ListResultDtoOfFlatPermissionWithLevelDto;
}());
export { ListResultDtoOfFlatPermissionWithLevelDto };
var PagedResultDtoOfGetPrintersForViewDto = /** @class */ (function () {
    function PagedResultDtoOfGetPrintersForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfGetPrintersForViewDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(GetPrintersForViewDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfGetPrintersForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfGetPrintersForViewDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfGetPrintersForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfGetPrintersForViewDto;
}());
export { PagedResultDtoOfGetPrintersForViewDto };
var CreateOrEditPrintersDto = /** @class */ (function () {
    function CreateOrEditPrintersDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateOrEditPrintersDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.ip = data["ip"];
            this.printerType = data["printerType"];
            this.depotLocationId = data["depotLocationId"];
            this.id = data["id"];
        }
    };
    CreateOrEditPrintersDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrEditPrintersDto();
        result.init(data);
        return result;
    };
    CreateOrEditPrintersDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["ip"] = this.ip;
        data["printerType"] = this.printerType;
        data["depotLocationId"] = this.depotLocationId;
        data["id"] = this.id;
        return data;
    };
    return CreateOrEditPrintersDto;
}());
export { CreateOrEditPrintersDto };
var GetPrintersForEditOutput = /** @class */ (function () {
    function GetPrintersForEditOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetPrintersForEditOutput.prototype.init = function (data) {
        if (data) {
            this.printers = data["printers"] ? CreateOrEditPrintersDto.fromJS(data["printers"]) : undefined;
            this.depotLocationName = data["depotLocationName"];
        }
    };
    GetPrintersForEditOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetPrintersForEditOutput();
        result.init(data);
        return result;
    };
    GetPrintersForEditOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["printers"] = this.printers ? this.printers.toJSON() : undefined;
        data["depotLocationName"] = this.depotLocationName;
        return data;
    };
    return GetPrintersForEditOutput;
}());
export { GetPrintersForEditOutput };
var PrintersDepotLocationLookupTableDto = /** @class */ (function () {
    function PrintersDepotLocationLookupTableDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PrintersDepotLocationLookupTableDto.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    };
    PrintersDepotLocationLookupTableDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PrintersDepotLocationLookupTableDto();
        result.init(data);
        return result;
    };
    PrintersDepotLocationLookupTableDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    };
    return PrintersDepotLocationLookupTableDto;
}());
export { PrintersDepotLocationLookupTableDto };
var PagedResultDtoOfPrintersDepotLocationLookupTableDto = /** @class */ (function () {
    function PagedResultDtoOfPrintersDepotLocationLookupTableDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfPrintersDepotLocationLookupTableDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(PrintersDepotLocationLookupTableDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfPrintersDepotLocationLookupTableDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfPrintersDepotLocationLookupTableDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfPrintersDepotLocationLookupTableDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfPrintersDepotLocationLookupTableDto;
}());
export { PagedResultDtoOfPrintersDepotLocationLookupTableDto };
var CurrentUserProfileEditDto = /** @class */ (function () {
    function CurrentUserProfileEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CurrentUserProfileEditDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.surname = data["surname"];
            this.userName = data["userName"];
            this.emailAddress = data["emailAddress"];
            this.phoneNumber = data["phoneNumber"];
            this.isPhoneNumberConfirmed = data["isPhoneNumberConfirmed"];
            this.timezone = data["timezone"];
            this.qrCodeSetupImageUrl = data["qrCodeSetupImageUrl"];
            this.isGoogleAuthenticatorEnabled = data["isGoogleAuthenticatorEnabled"];
        }
    };
    CurrentUserProfileEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CurrentUserProfileEditDto();
        result.init(data);
        return result;
    };
    CurrentUserProfileEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["isPhoneNumberConfirmed"] = this.isPhoneNumberConfirmed;
        data["timezone"] = this.timezone;
        data["qrCodeSetupImageUrl"] = this.qrCodeSetupImageUrl;
        data["isGoogleAuthenticatorEnabled"] = this.isGoogleAuthenticatorEnabled;
        return data;
    };
    return CurrentUserProfileEditDto;
}());
export { CurrentUserProfileEditDto };
var UpdateGoogleAuthenticatorKeyOutput = /** @class */ (function () {
    function UpdateGoogleAuthenticatorKeyOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateGoogleAuthenticatorKeyOutput.prototype.init = function (data) {
        if (data) {
            this.qrCodeSetupImageUrl = data["qrCodeSetupImageUrl"];
        }
    };
    UpdateGoogleAuthenticatorKeyOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateGoogleAuthenticatorKeyOutput();
        result.init(data);
        return result;
    };
    UpdateGoogleAuthenticatorKeyOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["qrCodeSetupImageUrl"] = this.qrCodeSetupImageUrl;
        return data;
    };
    return UpdateGoogleAuthenticatorKeyOutput;
}());
export { UpdateGoogleAuthenticatorKeyOutput };
var SendVerificationSmsInputDto = /** @class */ (function () {
    function SendVerificationSmsInputDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SendVerificationSmsInputDto.prototype.init = function (data) {
        if (data) {
            this.phoneNumber = data["phoneNumber"];
        }
    };
    SendVerificationSmsInputDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SendVerificationSmsInputDto();
        result.init(data);
        return result;
    };
    SendVerificationSmsInputDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["phoneNumber"] = this.phoneNumber;
        return data;
    };
    return SendVerificationSmsInputDto;
}());
export { SendVerificationSmsInputDto };
var VerifySmsCodeInputDto = /** @class */ (function () {
    function VerifySmsCodeInputDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    VerifySmsCodeInputDto.prototype.init = function (data) {
        if (data) {
            this.code = data["code"];
            this.phoneNumber = data["phoneNumber"];
        }
    };
    VerifySmsCodeInputDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new VerifySmsCodeInputDto();
        result.init(data);
        return result;
    };
    VerifySmsCodeInputDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    };
    return VerifySmsCodeInputDto;
}());
export { VerifySmsCodeInputDto };
var ChangePasswordInput = /** @class */ (function () {
    function ChangePasswordInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ChangePasswordInput.prototype.init = function (data) {
        if (data) {
            this.currentPassword = data["currentPassword"];
            this.newPassword = data["newPassword"];
        }
    };
    ChangePasswordInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ChangePasswordInput();
        result.init(data);
        return result;
    };
    ChangePasswordInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        return data;
    };
    return ChangePasswordInput;
}());
export { ChangePasswordInput };
var UpdateProfilePictureInput = /** @class */ (function () {
    function UpdateProfilePictureInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateProfilePictureInput.prototype.init = function (data) {
        if (data) {
            this.fileToken = data["fileToken"];
            this.x = data["x"];
            this.y = data["y"];
            this.width = data["width"];
            this.height = data["height"];
        }
    };
    UpdateProfilePictureInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateProfilePictureInput();
        result.init(data);
        return result;
    };
    UpdateProfilePictureInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["fileToken"] = this.fileToken;
        data["x"] = this.x;
        data["y"] = this.y;
        data["width"] = this.width;
        data["height"] = this.height;
        return data;
    };
    return UpdateProfilePictureInput;
}());
export { UpdateProfilePictureInput };
var GetPasswordComplexitySettingOutput = /** @class */ (function () {
    function GetPasswordComplexitySettingOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetPasswordComplexitySettingOutput.prototype.init = function (data) {
        if (data) {
            this.setting = data["setting"] ? PasswordComplexitySetting.fromJS(data["setting"]) : undefined;
        }
    };
    GetPasswordComplexitySettingOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetPasswordComplexitySettingOutput();
        result.init(data);
        return result;
    };
    GetPasswordComplexitySettingOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["setting"] = this.setting ? this.setting.toJSON() : undefined;
        return data;
    };
    return GetPasswordComplexitySettingOutput;
}());
export { GetPasswordComplexitySettingOutput };
var GetProfilePictureOutput = /** @class */ (function () {
    function GetProfilePictureOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetProfilePictureOutput.prototype.init = function (data) {
        if (data) {
            this.profilePicture = data["profilePicture"];
        }
    };
    GetProfilePictureOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetProfilePictureOutput();
        result.init(data);
        return result;
    };
    GetProfilePictureOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["profilePicture"] = this.profilePicture;
        return data;
    };
    return GetProfilePictureOutput;
}());
export { GetProfilePictureOutput };
var ChangeUserLanguageDto = /** @class */ (function () {
    function ChangeUserLanguageDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ChangeUserLanguageDto.prototype.init = function (data) {
        if (data) {
            this.languageName = data["languageName"];
        }
    };
    ChangeUserLanguageDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ChangeUserLanguageDto();
        result.init(data);
        return result;
    };
    ChangeUserLanguageDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        return data;
    };
    return ChangeUserLanguageDto;
}());
export { ChangeUserLanguageDto };
var GetAllReturnToSuppliersInput = /** @class */ (function () {
    function GetAllReturnToSuppliersInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetAllReturnToSuppliersInput.prototype.init = function (data) {
        if (data) {
            this.receivingLocationFilter = data["receivingLocationFilter"];
            this.maxPalletisedDateFilter = data["maxPalletisedDateFilter"] ? moment(data["maxPalletisedDateFilter"].toString()) : undefined;
            this.minPalletisedDateFilter = data["minPalletisedDateFilter"] ? moment(data["minPalletisedDateFilter"].toString()) : undefined;
            if (Array.isArray(data["clientCodeFilter"])) {
                this.clientCodeFilter = [];
                for (var _i = 0, _a = data["clientCodeFilter"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.clientCodeFilter.push(item);
                }
            }
            if (Array.isArray(data["clientGroupFilter"])) {
                this.clientGroupFilter = [];
                for (var _b = 0, _c = data["clientGroupFilter"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.clientGroupFilter.push(item);
                }
            }
            this.ownDepotFilter = data["ownDepotFilter"];
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    };
    GetAllReturnToSuppliersInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetAllReturnToSuppliersInput();
        result.init(data);
        return result;
    };
    GetAllReturnToSuppliersInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["receivingLocationFilter"] = this.receivingLocationFilter;
        data["maxPalletisedDateFilter"] = this.maxPalletisedDateFilter ? this.maxPalletisedDateFilter.toISOString() : undefined;
        data["minPalletisedDateFilter"] = this.minPalletisedDateFilter ? this.minPalletisedDateFilter.toISOString() : undefined;
        if (Array.isArray(this.clientCodeFilter)) {
            data["clientCodeFilter"] = [];
            for (var _i = 0, _a = this.clientCodeFilter; _i < _a.length; _i++) {
                var item = _a[_i];
                data["clientCodeFilter"].push(item);
            }
        }
        if (Array.isArray(this.clientGroupFilter)) {
            data["clientGroupFilter"] = [];
            for (var _b = 0, _c = this.clientGroupFilter; _b < _c.length; _b++) {
                var item = _c[_b];
                data["clientGroupFilter"].push(item);
            }
        }
        data["ownDepotFilter"] = this.ownDepotFilter;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    };
    return GetAllReturnToSuppliersInput;
}());
export { GetAllReturnToSuppliersInput };
var ReturnToSupllierPackageProductDto = /** @class */ (function () {
    function ReturnToSupllierPackageProductDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ReturnToSupllierPackageProductDto.prototype.init = function (data) {
        if (data) {
            this.connote = data["connote"];
            this.boxBarcode = data["boxBarcode"];
            this.productBarcode = data["productBarcode"];
            this.quantity = data["quantity"];
        }
    };
    ReturnToSupllierPackageProductDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ReturnToSupllierPackageProductDto();
        result.init(data);
        return result;
    };
    ReturnToSupllierPackageProductDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["connote"] = this.connote;
        data["boxBarcode"] = this.boxBarcode;
        data["productBarcode"] = this.productBarcode;
        data["quantity"] = this.quantity;
        return data;
    };
    return ReturnToSupllierPackageProductDto;
}());
export { ReturnToSupllierPackageProductDto };
var ReturnToSupplierPackageDto = /** @class */ (function () {
    function ReturnToSupplierPackageDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ReturnToSupplierPackageDto.prototype.init = function (data) {
        if (data) {
            this.consignmentNumber = data["consignmentNumber"];
            this.returnToSupplierId = data["returnToSupplierId"];
            this.returnToSupplier = data["returnToSupplier"] ? ReturnToSupplierDto.fromJS(data["returnToSupplier"]) : undefined;
            this.packageId = data["packageId"];
            this.package = data["package"] ? PackageDto.fromJS(data["package"]) : undefined;
            this.barcode = data["barcode"];
            if (Array.isArray(data["returnToSupllierPackageProducts"])) {
                this.returnToSupllierPackageProducts = [];
                for (var _i = 0, _a = data["returnToSupllierPackageProducts"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.returnToSupllierPackageProducts.push(ReturnToSupllierPackageProductDto.fromJS(item));
                }
            }
            this.id = data["id"];
        }
    };
    ReturnToSupplierPackageDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ReturnToSupplierPackageDto();
        result.init(data);
        return result;
    };
    ReturnToSupplierPackageDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["consignmentNumber"] = this.consignmentNumber;
        data["returnToSupplierId"] = this.returnToSupplierId;
        data["returnToSupplier"] = this.returnToSupplier ? this.returnToSupplier.toJSON() : undefined;
        data["packageId"] = this.packageId;
        data["package"] = this.package ? this.package.toJSON() : undefined;
        data["barcode"] = this.barcode;
        if (Array.isArray(this.returnToSupllierPackageProducts)) {
            data["returnToSupllierPackageProducts"] = [];
            for (var _i = 0, _a = this.returnToSupllierPackageProducts; _i < _a.length; _i++) {
                var item = _a[_i];
                data["returnToSupllierPackageProducts"].push(item.toJSON());
            }
        }
        data["id"] = this.id;
        return data;
    };
    return ReturnToSupplierPackageDto;
}());
export { ReturnToSupplierPackageDto };
var ReturnToSupplierDto = /** @class */ (function () {
    function ReturnToSupplierDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ReturnToSupplierDto.prototype.init = function (data) {
        if (data) {
            this.receivingLocation = data["receivingLocation"];
            this.palletisedDate = data["palletisedDate"] ? moment(data["palletisedDate"].toString()) : undefined;
            this.clientCode = data["clientCode"];
            if (Array.isArray(data["returnToSupplierPackages"])) {
                this.returnToSupplierPackages = [];
                for (var _i = 0, _a = data["returnToSupplierPackages"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.returnToSupplierPackages.push(ReturnToSupplierPackageDto.fromJS(item));
                }
            }
            this.id = data["id"];
        }
    };
    ReturnToSupplierDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ReturnToSupplierDto();
        result.init(data);
        return result;
    };
    ReturnToSupplierDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["receivingLocation"] = this.receivingLocation;
        data["palletisedDate"] = this.palletisedDate ? this.palletisedDate.toISOString() : undefined;
        data["clientCode"] = this.clientCode;
        if (Array.isArray(this.returnToSupplierPackages)) {
            data["returnToSupplierPackages"] = [];
            for (var _i = 0, _a = this.returnToSupplierPackages; _i < _a.length; _i++) {
                var item = _a[_i];
                data["returnToSupplierPackages"].push(item.toJSON());
            }
        }
        data["id"] = this.id;
        return data;
    };
    return ReturnToSupplierDto;
}());
export { ReturnToSupplierDto };
var GetReturnToSupplierForViewDto = /** @class */ (function () {
    function GetReturnToSupplierForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetReturnToSupplierForViewDto.prototype.init = function (data) {
        if (data) {
            this.returnToSupplier = data["returnToSupplier"] ? ReturnToSupplierDto.fromJS(data["returnToSupplier"]) : undefined;
            this.packageCount = data["packageCount"];
            this.clientId = data["clientId"];
            this.clientName = data["clientName"];
            this.rtsProductCount = data["rtsProductCount"];
        }
    };
    GetReturnToSupplierForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetReturnToSupplierForViewDto();
        result.init(data);
        return result;
    };
    GetReturnToSupplierForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["returnToSupplier"] = this.returnToSupplier ? this.returnToSupplier.toJSON() : undefined;
        data["packageCount"] = this.packageCount;
        data["clientId"] = this.clientId;
        data["clientName"] = this.clientName;
        data["rtsProductCount"] = this.rtsProductCount;
        return data;
    };
    return GetReturnToSupplierForViewDto;
}());
export { GetReturnToSupplierForViewDto };
var PagedResultDtoOfGetReturnToSupplierForViewDto = /** @class */ (function () {
    function PagedResultDtoOfGetReturnToSupplierForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfGetReturnToSupplierForViewDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(GetReturnToSupplierForViewDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfGetReturnToSupplierForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfGetReturnToSupplierForViewDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfGetReturnToSupplierForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfGetReturnToSupplierForViewDto;
}());
export { PagedResultDtoOfGetReturnToSupplierForViewDto };
var ReturnToSupplierCreateLoadInput = /** @class */ (function () {
    function ReturnToSupplierCreateLoadInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.returnToSupplierIds = [];
        }
    }
    ReturnToSupplierCreateLoadInput.prototype.init = function (data) {
        if (data) {
            if (Array.isArray(data["returnToSupplierIds"])) {
                this.returnToSupplierIds = [];
                for (var _i = 0, _a = data["returnToSupplierIds"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.returnToSupplierIds.push(item);
                }
            }
            this.docket = data["docket"];
            this.carrier = data["carrier"];
            this.palletCount = data["palletCount"];
            this.storeId = data["storeId"];
            this.toDepot = data["toDepot"];
            this.toClient = data["toClient"];
            this.loadDestinationOption = data["loadDestinationOption"];
        }
    };
    ReturnToSupplierCreateLoadInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ReturnToSupplierCreateLoadInput();
        result.init(data);
        return result;
    };
    ReturnToSupplierCreateLoadInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.returnToSupplierIds)) {
            data["returnToSupplierIds"] = [];
            for (var _i = 0, _a = this.returnToSupplierIds; _i < _a.length; _i++) {
                var item = _a[_i];
                data["returnToSupplierIds"].push(item);
            }
        }
        data["docket"] = this.docket;
        data["carrier"] = this.carrier;
        data["palletCount"] = this.palletCount;
        data["storeId"] = this.storeId;
        data["toDepot"] = this.toDepot;
        data["toClient"] = this.toClient;
        data["loadDestinationOption"] = this.loadDestinationOption;
        return data;
    };
    return ReturnToSupplierCreateLoadInput;
}());
export { ReturnToSupplierCreateLoadInput };
var RoleListDto = /** @class */ (function () {
    function RoleListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RoleListDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.isStatic = data["isStatic"];
            this.isDefault = data["isDefault"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.id = data["id"];
        }
    };
    RoleListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RoleListDto();
        result.init(data);
        return result;
    };
    RoleListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isStatic"] = this.isStatic;
        data["isDefault"] = this.isDefault;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["id"] = this.id;
        return data;
    };
    return RoleListDto;
}());
export { RoleListDto };
var ListResultDtoOfRoleListDto = /** @class */ (function () {
    function ListResultDtoOfRoleListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ListResultDtoOfRoleListDto.prototype.init = function (data) {
        if (data) {
            if (Array.isArray(data["items"])) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(RoleListDto.fromJS(item));
                }
            }
        }
    };
    ListResultDtoOfRoleListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ListResultDtoOfRoleListDto();
        result.init(data);
        return result;
    };
    ListResultDtoOfRoleListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return ListResultDtoOfRoleListDto;
}());
export { ListResultDtoOfRoleListDto };
var RoleEditDto = /** @class */ (function () {
    function RoleEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RoleEditDto.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
            this.isDefault = data["isDefault"];
        }
    };
    RoleEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RoleEditDto();
        result.init(data);
        return result;
    };
    RoleEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["isDefault"] = this.isDefault;
        return data;
    };
    return RoleEditDto;
}());
export { RoleEditDto };
var FlatPermissionDto = /** @class */ (function () {
    function FlatPermissionDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FlatPermissionDto.prototype.init = function (data) {
        if (data) {
            this.parentName = data["parentName"];
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.description = data["description"];
            this.isGrantedByDefault = data["isGrantedByDefault"];
        }
    };
    FlatPermissionDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FlatPermissionDto();
        result.init(data);
        return result;
    };
    FlatPermissionDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["isGrantedByDefault"] = this.isGrantedByDefault;
        return data;
    };
    return FlatPermissionDto;
}());
export { FlatPermissionDto };
var GetRoleForEditOutput = /** @class */ (function () {
    function GetRoleForEditOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetRoleForEditOutput.prototype.init = function (data) {
        if (data) {
            this.role = data["role"] ? RoleEditDto.fromJS(data["role"]) : undefined;
            if (Array.isArray(data["permissions"])) {
                this.permissions = [];
                for (var _i = 0, _a = data["permissions"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.permissions.push(FlatPermissionDto.fromJS(item));
                }
            }
            if (Array.isArray(data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [];
                for (var _b = 0, _c = data["grantedPermissionNames"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.grantedPermissionNames.push(item);
                }
            }
        }
    };
    GetRoleForEditOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetRoleForEditOutput();
        result.init(data);
        return result;
    };
    GetRoleForEditOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : undefined;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (var _i = 0, _a = this.permissions; _i < _a.length; _i++) {
                var item = _a[_i];
                data["permissions"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (var _b = 0, _c = this.grantedPermissionNames; _b < _c.length; _b++) {
                var item = _c[_b];
                data["grantedPermissionNames"].push(item);
            }
        }
        return data;
    };
    return GetRoleForEditOutput;
}());
export { GetRoleForEditOutput };
var CreateOrUpdateRoleInput = /** @class */ (function () {
    function CreateOrUpdateRoleInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.role = new RoleEditDto();
            this.grantedPermissionNames = [];
        }
    }
    CreateOrUpdateRoleInput.prototype.init = function (data) {
        if (data) {
            this.role = data["role"] ? RoleEditDto.fromJS(data["role"]) : new RoleEditDto();
            if (Array.isArray(data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [];
                for (var _i = 0, _a = data["grantedPermissionNames"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.grantedPermissionNames.push(item);
                }
            }
        }
    };
    CreateOrUpdateRoleInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrUpdateRoleInput();
        result.init(data);
        return result;
    };
    CreateOrUpdateRoleInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : undefined;
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (var _i = 0, _a = this.grantedPermissionNames; _i < _a.length; _i++) {
                var item = _a[_i];
                data["grantedPermissionNames"].push(item);
            }
        }
        return data;
    };
    return CreateOrUpdateRoleInput;
}());
export { CreateOrUpdateRoleInput };
var UserLoginInfoDto = /** @class */ (function () {
    function UserLoginInfoDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UserLoginInfoDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.surname = data["surname"];
            this.userName = data["userName"];
            this.emailAddress = data["emailAddress"];
            this.profilePictureId = data["profilePictureId"];
            this.id = data["id"];
        }
    };
    UserLoginInfoDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UserLoginInfoDto();
        result.init(data);
        return result;
    };
    UserLoginInfoDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["profilePictureId"] = this.profilePictureId;
        data["id"] = this.id;
        return data;
    };
    return UserLoginInfoDto;
}());
export { UserLoginInfoDto };
export var SubscriptionPaymentType;
(function (SubscriptionPaymentType) {
    SubscriptionPaymentType[SubscriptionPaymentType["Manual"] = 0] = "Manual";
    SubscriptionPaymentType[SubscriptionPaymentType["RecurringAutomatic"] = 1] = "RecurringAutomatic";
    SubscriptionPaymentType[SubscriptionPaymentType["RecurringManual"] = 2] = "RecurringManual";
})(SubscriptionPaymentType || (SubscriptionPaymentType = {}));
var EditionInfoDto = /** @class */ (function () {
    function EditionInfoDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EditionInfoDto.prototype.init = function (data) {
        if (data) {
            this.displayName = data["displayName"];
            this.trialDayCount = data["trialDayCount"];
            this.monthlyPrice = data["monthlyPrice"];
            this.annualPrice = data["annualPrice"];
            this.isHighestEdition = data["isHighestEdition"];
            this.isFree = data["isFree"];
            this.id = data["id"];
        }
    };
    EditionInfoDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new EditionInfoDto();
        result.init(data);
        return result;
    };
    EditionInfoDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["trialDayCount"] = this.trialDayCount;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["isHighestEdition"] = this.isHighestEdition;
        data["isFree"] = this.isFree;
        data["id"] = this.id;
        return data;
    };
    return EditionInfoDto;
}());
export { EditionInfoDto };
var TenantLoginInfoDto = /** @class */ (function () {
    function TenantLoginInfoDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TenantLoginInfoDto.prototype.init = function (data) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.name = data["name"];
            this.logoId = data["logoId"];
            this.logoFileType = data["logoFileType"];
            this.customCssId = data["customCssId"];
            this.subscriptionEndDateUtc = data["subscriptionEndDateUtc"] ? moment(data["subscriptionEndDateUtc"].toString()) : undefined;
            this.isInTrialPeriod = data["isInTrialPeriod"];
            this.subscriptionPaymentType = data["subscriptionPaymentType"];
            this.edition = data["edition"] ? EditionInfoDto.fromJS(data["edition"]) : undefined;
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.paymentPeriodType = data["paymentPeriodType"];
            this.subscriptionDateString = data["subscriptionDateString"];
            this.creationTimeString = data["creationTimeString"];
            this.id = data["id"];
        }
    };
    TenantLoginInfoDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TenantLoginInfoDto();
        result.init(data);
        return result;
    };
    TenantLoginInfoDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["logoId"] = this.logoId;
        data["logoFileType"] = this.logoFileType;
        data["customCssId"] = this.customCssId;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toISOString() : undefined;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["subscriptionPaymentType"] = this.subscriptionPaymentType;
        data["edition"] = this.edition ? this.edition.toJSON() : undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["paymentPeriodType"] = this.paymentPeriodType;
        data["subscriptionDateString"] = this.subscriptionDateString;
        data["creationTimeString"] = this.creationTimeString;
        data["id"] = this.id;
        return data;
    };
    return TenantLoginInfoDto;
}());
export { TenantLoginInfoDto };
var ApplicationInfoDto = /** @class */ (function () {
    function ApplicationInfoDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ApplicationInfoDto.prototype.init = function (data) {
        if (data) {
            this.version = data["version"];
            this.releaseDate = data["releaseDate"] ? moment(data["releaseDate"].toString()) : undefined;
            this.currency = data["currency"];
            this.currencySign = data["currencySign"];
            this.allowTenantsToChangeEmailSettings = data["allowTenantsToChangeEmailSettings"];
            if (data["features"]) {
                this.features = {};
                for (var key in data["features"]) {
                    if (data["features"].hasOwnProperty(key))
                        this.features[key] = data["features"][key];
                }
            }
        }
    };
    ApplicationInfoDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ApplicationInfoDto();
        result.init(data);
        return result;
    };
    ApplicationInfoDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : undefined;
        data["currency"] = this.currency;
        data["currencySign"] = this.currencySign;
        data["allowTenantsToChangeEmailSettings"] = this.allowTenantsToChangeEmailSettings;
        if (this.features) {
            data["features"] = {};
            for (var key in this.features) {
                if (this.features.hasOwnProperty(key))
                    data["features"][key] = this.features[key];
            }
        }
        return data;
    };
    return ApplicationInfoDto;
}());
export { ApplicationInfoDto };
var ThemeLayoutSettingsDto = /** @class */ (function () {
    function ThemeLayoutSettingsDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ThemeLayoutSettingsDto.prototype.init = function (data) {
        if (data) {
            this.layoutType = data["layoutType"];
        }
    };
    ThemeLayoutSettingsDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ThemeLayoutSettingsDto();
        result.init(data);
        return result;
    };
    ThemeLayoutSettingsDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["layoutType"] = this.layoutType;
        return data;
    };
    return ThemeLayoutSettingsDto;
}());
export { ThemeLayoutSettingsDto };
var ThemeHeaderSettingsDto = /** @class */ (function () {
    function ThemeHeaderSettingsDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ThemeHeaderSettingsDto.prototype.init = function (data) {
        if (data) {
            this.desktopFixedHeader = data["desktopFixedHeader"];
            this.mobileFixedHeader = data["mobileFixedHeader"];
            this.headerSkin = data["headerSkin"];
            this.minimizeDesktopHeaderType = data["minimizeDesktopHeaderType"];
            this.headerMenuArrows = data["headerMenuArrows"];
        }
    };
    ThemeHeaderSettingsDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ThemeHeaderSettingsDto();
        result.init(data);
        return result;
    };
    ThemeHeaderSettingsDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["desktopFixedHeader"] = this.desktopFixedHeader;
        data["mobileFixedHeader"] = this.mobileFixedHeader;
        data["headerSkin"] = this.headerSkin;
        data["minimizeDesktopHeaderType"] = this.minimizeDesktopHeaderType;
        data["headerMenuArrows"] = this.headerMenuArrows;
        return data;
    };
    return ThemeHeaderSettingsDto;
}());
export { ThemeHeaderSettingsDto };
var ThemeSubHeaderSettingsDto = /** @class */ (function () {
    function ThemeSubHeaderSettingsDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ThemeSubHeaderSettingsDto.prototype.init = function (data) {
        if (data) {
            this.fixedSubHeader = data["fixedSubHeader"];
            this.subheaderStyle = data["subheaderStyle"];
        }
    };
    ThemeSubHeaderSettingsDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ThemeSubHeaderSettingsDto();
        result.init(data);
        return result;
    };
    ThemeSubHeaderSettingsDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["fixedSubHeader"] = this.fixedSubHeader;
        data["subheaderStyle"] = this.subheaderStyle;
        return data;
    };
    return ThemeSubHeaderSettingsDto;
}());
export { ThemeSubHeaderSettingsDto };
var ThemeMenuSettingsDto = /** @class */ (function () {
    function ThemeMenuSettingsDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ThemeMenuSettingsDto.prototype.init = function (data) {
        if (data) {
            this.position = data["position"];
            this.asideSkin = data["asideSkin"];
            this.fixedAside = data["fixedAside"];
            this.allowAsideMinimizing = data["allowAsideMinimizing"];
            this.defaultMinimizedAside = data["defaultMinimizedAside"];
            this.submenuToggle = data["submenuToggle"];
            this.searchActive = data["searchActive"];
        }
    };
    ThemeMenuSettingsDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ThemeMenuSettingsDto();
        result.init(data);
        return result;
    };
    ThemeMenuSettingsDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["position"] = this.position;
        data["asideSkin"] = this.asideSkin;
        data["fixedAside"] = this.fixedAside;
        data["allowAsideMinimizing"] = this.allowAsideMinimizing;
        data["defaultMinimizedAside"] = this.defaultMinimizedAside;
        data["submenuToggle"] = this.submenuToggle;
        data["searchActive"] = this.searchActive;
        return data;
    };
    return ThemeMenuSettingsDto;
}());
export { ThemeMenuSettingsDto };
var ThemeFooterSettingsDto = /** @class */ (function () {
    function ThemeFooterSettingsDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ThemeFooterSettingsDto.prototype.init = function (data) {
        if (data) {
            this.fixedFooter = data["fixedFooter"];
        }
    };
    ThemeFooterSettingsDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ThemeFooterSettingsDto();
        result.init(data);
        return result;
    };
    ThemeFooterSettingsDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["fixedFooter"] = this.fixedFooter;
        return data;
    };
    return ThemeFooterSettingsDto;
}());
export { ThemeFooterSettingsDto };
var ThemeSettingsDto = /** @class */ (function () {
    function ThemeSettingsDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ThemeSettingsDto.prototype.init = function (data) {
        if (data) {
            this.theme = data["theme"];
            this.layout = data["layout"] ? ThemeLayoutSettingsDto.fromJS(data["layout"]) : undefined;
            this.header = data["header"] ? ThemeHeaderSettingsDto.fromJS(data["header"]) : undefined;
            this.subHeader = data["subHeader"] ? ThemeSubHeaderSettingsDto.fromJS(data["subHeader"]) : undefined;
            this.menu = data["menu"] ? ThemeMenuSettingsDto.fromJS(data["menu"]) : undefined;
            this.footer = data["footer"] ? ThemeFooterSettingsDto.fromJS(data["footer"]) : undefined;
        }
    };
    ThemeSettingsDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ThemeSettingsDto();
        result.init(data);
        return result;
    };
    ThemeSettingsDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["theme"] = this.theme;
        data["layout"] = this.layout ? this.layout.toJSON() : undefined;
        data["header"] = this.header ? this.header.toJSON() : undefined;
        data["subHeader"] = this.subHeader ? this.subHeader.toJSON() : undefined;
        data["menu"] = this.menu ? this.menu.toJSON() : undefined;
        data["footer"] = this.footer ? this.footer.toJSON() : undefined;
        return data;
    };
    return ThemeSettingsDto;
}());
export { ThemeSettingsDto };
var UiCustomizationSettingsDto = /** @class */ (function () {
    function UiCustomizationSettingsDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UiCustomizationSettingsDto.prototype.init = function (data) {
        if (data) {
            this.baseSettings = data["baseSettings"] ? ThemeSettingsDto.fromJS(data["baseSettings"]) : undefined;
            this.isLeftMenuUsed = data["isLeftMenuUsed"];
            this.isTopMenuUsed = data["isTopMenuUsed"];
            this.isTabMenuUsed = data["isTabMenuUsed"];
            this.allowMenuScroll = data["allowMenuScroll"];
        }
    };
    UiCustomizationSettingsDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UiCustomizationSettingsDto();
        result.init(data);
        return result;
    };
    UiCustomizationSettingsDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["baseSettings"] = this.baseSettings ? this.baseSettings.toJSON() : undefined;
        data["isLeftMenuUsed"] = this.isLeftMenuUsed;
        data["isTopMenuUsed"] = this.isTopMenuUsed;
        data["isTabMenuUsed"] = this.isTabMenuUsed;
        data["allowMenuScroll"] = this.allowMenuScroll;
        return data;
    };
    return UiCustomizationSettingsDto;
}());
export { UiCustomizationSettingsDto };
var GetCurrentLoginInformationsOutput = /** @class */ (function () {
    function GetCurrentLoginInformationsOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetCurrentLoginInformationsOutput.prototype.init = function (data) {
        if (data) {
            this.user = data["user"] ? UserLoginInfoDto.fromJS(data["user"]) : undefined;
            this.tenant = data["tenant"] ? TenantLoginInfoDto.fromJS(data["tenant"]) : undefined;
            this.application = data["application"] ? ApplicationInfoDto.fromJS(data["application"]) : undefined;
            this.theme = data["theme"] ? UiCustomizationSettingsDto.fromJS(data["theme"]) : undefined;
        }
    };
    GetCurrentLoginInformationsOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetCurrentLoginInformationsOutput();
        result.init(data);
        return result;
    };
    GetCurrentLoginInformationsOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : undefined;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : undefined;
        data["application"] = this.application ? this.application.toJSON() : undefined;
        data["theme"] = this.theme ? this.theme.toJSON() : undefined;
        return data;
    };
    return GetCurrentLoginInformationsOutput;
}());
export { GetCurrentLoginInformationsOutput };
var UpdateUserSignInTokenOutput = /** @class */ (function () {
    function UpdateUserSignInTokenOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateUserSignInTokenOutput.prototype.init = function (data) {
        if (data) {
            this.signInToken = data["signInToken"];
            this.encodedUserId = data["encodedUserId"];
            this.encodedTenantId = data["encodedTenantId"];
        }
    };
    UpdateUserSignInTokenOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateUserSignInTokenOutput();
        result.init(data);
        return result;
    };
    UpdateUserSignInTokenOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["signInToken"] = this.signInToken;
        data["encodedUserId"] = this.encodedUserId;
        data["encodedTenantId"] = this.encodedTenantId;
        return data;
    };
    return UpdateUserSignInTokenOutput;
}());
export { UpdateUserSignInTokenOutput };
var StoreNumberDeliveryPostcodeDto = /** @class */ (function () {
    function StoreNumberDeliveryPostcodeDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    StoreNumberDeliveryPostcodeDto.prototype.init = function (data) {
        if (data) {
            this.storeNumberFrom = data["storeNumberFrom"];
            this.storeNumberTo = data["storeNumberTo"];
            this.deliveryPostCodeFrom = data["deliveryPostCodeFrom"];
            this.deliveryPostCodeTo = data["deliveryPostCodeTo"];
            this.id = data["id"];
        }
    };
    StoreNumberDeliveryPostcodeDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new StoreNumberDeliveryPostcodeDto();
        result.init(data);
        return result;
    };
    StoreNumberDeliveryPostcodeDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["storeNumberFrom"] = this.storeNumberFrom;
        data["storeNumberTo"] = this.storeNumberTo;
        data["deliveryPostCodeFrom"] = this.deliveryPostCodeFrom;
        data["deliveryPostCodeTo"] = this.deliveryPostCodeTo;
        data["id"] = this.id;
        return data;
    };
    return StoreNumberDeliveryPostcodeDto;
}());
export { StoreNumberDeliveryPostcodeDto };
var GetStoreNumberDeliveryPostcodeForViewDto = /** @class */ (function () {
    function GetStoreNumberDeliveryPostcodeForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetStoreNumberDeliveryPostcodeForViewDto.prototype.init = function (data) {
        if (data) {
            this.storeNumberDeliveryPostcode = data["storeNumberDeliveryPostcode"] ? StoreNumberDeliveryPostcodeDto.fromJS(data["storeNumberDeliveryPostcode"]) : undefined;
        }
    };
    GetStoreNumberDeliveryPostcodeForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetStoreNumberDeliveryPostcodeForViewDto();
        result.init(data);
        return result;
    };
    GetStoreNumberDeliveryPostcodeForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["storeNumberDeliveryPostcode"] = this.storeNumberDeliveryPostcode ? this.storeNumberDeliveryPostcode.toJSON() : undefined;
        return data;
    };
    return GetStoreNumberDeliveryPostcodeForViewDto;
}());
export { GetStoreNumberDeliveryPostcodeForViewDto };
var PagedResultDtoOfGetStoreNumberDeliveryPostcodeForViewDto = /** @class */ (function () {
    function PagedResultDtoOfGetStoreNumberDeliveryPostcodeForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfGetStoreNumberDeliveryPostcodeForViewDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(GetStoreNumberDeliveryPostcodeForViewDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfGetStoreNumberDeliveryPostcodeForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfGetStoreNumberDeliveryPostcodeForViewDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfGetStoreNumberDeliveryPostcodeForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfGetStoreNumberDeliveryPostcodeForViewDto;
}());
export { PagedResultDtoOfGetStoreNumberDeliveryPostcodeForViewDto };
var CreateOrEditStoreNumberDeliveryPostcodeDto = /** @class */ (function () {
    function CreateOrEditStoreNumberDeliveryPostcodeDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateOrEditStoreNumberDeliveryPostcodeDto.prototype.init = function (data) {
        if (data) {
            this.storeNumberFrom = data["storeNumberFrom"];
            this.storeNumberTo = data["storeNumberTo"];
            this.deliveryPostCodeFrom = data["deliveryPostCodeFrom"];
            this.deliveryPostCodeTo = data["deliveryPostCodeTo"];
            this.id = data["id"];
        }
    };
    CreateOrEditStoreNumberDeliveryPostcodeDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrEditStoreNumberDeliveryPostcodeDto();
        result.init(data);
        return result;
    };
    CreateOrEditStoreNumberDeliveryPostcodeDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["storeNumberFrom"] = this.storeNumberFrom;
        data["storeNumberTo"] = this.storeNumberTo;
        data["deliveryPostCodeFrom"] = this.deliveryPostCodeFrom;
        data["deliveryPostCodeTo"] = this.deliveryPostCodeTo;
        data["id"] = this.id;
        return data;
    };
    return CreateOrEditStoreNumberDeliveryPostcodeDto;
}());
export { CreateOrEditStoreNumberDeliveryPostcodeDto };
var GetStoreNumberDeliveryPostcodeForEditOutput = /** @class */ (function () {
    function GetStoreNumberDeliveryPostcodeForEditOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetStoreNumberDeliveryPostcodeForEditOutput.prototype.init = function (data) {
        if (data) {
            this.storeNumberDeliveryPostcode = data["storeNumberDeliveryPostcode"] ? CreateOrEditStoreNumberDeliveryPostcodeDto.fromJS(data["storeNumberDeliveryPostcode"]) : undefined;
        }
    };
    GetStoreNumberDeliveryPostcodeForEditOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetStoreNumberDeliveryPostcodeForEditOutput();
        result.init(data);
        return result;
    };
    GetStoreNumberDeliveryPostcodeForEditOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["storeNumberDeliveryPostcode"] = this.storeNumberDeliveryPostcode ? this.storeNumberDeliveryPostcode.toJSON() : undefined;
        return data;
    };
    return GetStoreNumberDeliveryPostcodeForEditOutput;
}());
export { GetStoreNumberDeliveryPostcodeForEditOutput };
var StoreDto = /** @class */ (function () {
    function StoreDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    StoreDto.prototype.init = function (data) {
        if (data) {
            this.storeId = data["storeId"];
            this.name = data["name"];
            if (Array.isArray(data["businessHours"])) {
                this.businessHours = [];
                for (var _i = 0, _a = data["businessHours"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.businessHours.push(BusinessHour.fromJS(item));
                }
            }
            this.palletEnabled = data["palletEnabled"];
            this.locationId = data["locationId"];
            this.location = data["location"] ? LocationDto.fromJS(data["location"]) : undefined;
            this.id = data["id"];
        }
    };
    StoreDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new StoreDto();
        result.init(data);
        return result;
    };
    StoreDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["storeId"] = this.storeId;
        data["name"] = this.name;
        if (Array.isArray(this.businessHours)) {
            data["businessHours"] = [];
            for (var _i = 0, _a = this.businessHours; _i < _a.length; _i++) {
                var item = _a[_i];
                data["businessHours"].push(item.toJSON());
            }
        }
        data["palletEnabled"] = this.palletEnabled;
        data["locationId"] = this.locationId;
        data["location"] = this.location ? this.location.toJSON() : undefined;
        data["id"] = this.id;
        return data;
    };
    return StoreDto;
}());
export { StoreDto };
var GetStoreForViewDto = /** @class */ (function () {
    function GetStoreForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetStoreForViewDto.prototype.init = function (data) {
        if (data) {
            this.store = data["store"] ? StoreDto.fromJS(data["store"]) : undefined;
            this.address = data["address"];
        }
    };
    GetStoreForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetStoreForViewDto();
        result.init(data);
        return result;
    };
    GetStoreForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["store"] = this.store ? this.store.toJSON() : undefined;
        data["address"] = this.address;
        return data;
    };
    return GetStoreForViewDto;
}());
export { GetStoreForViewDto };
var PagedResultDtoOfGetStoreForViewDto = /** @class */ (function () {
    function PagedResultDtoOfGetStoreForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfGetStoreForViewDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(GetStoreForViewDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfGetStoreForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfGetStoreForViewDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfGetStoreForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfGetStoreForViewDto;
}());
export { PagedResultDtoOfGetStoreForViewDto };
var CreateOrEditStoreDto = /** @class */ (function () {
    function CreateOrEditStoreDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateOrEditStoreDto.prototype.init = function (data) {
        if (data) {
            this.storeId = data["storeId"];
            this.name = data["name"];
            if (Array.isArray(data["businessHours"])) {
                this.businessHours = [];
                for (var _i = 0, _a = data["businessHours"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.businessHours.push(BusinessHour.fromJS(item));
                }
            }
            this.locationId = data["locationId"];
            this.location = data["location"] ? CreateOrEditLocationDto.fromJS(data["location"]) : undefined;
            this.palletEnabled = data["palletEnabled"];
            this.id = data["id"];
        }
    };
    CreateOrEditStoreDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrEditStoreDto();
        result.init(data);
        return result;
    };
    CreateOrEditStoreDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["storeId"] = this.storeId;
        data["name"] = this.name;
        if (Array.isArray(this.businessHours)) {
            data["businessHours"] = [];
            for (var _i = 0, _a = this.businessHours; _i < _a.length; _i++) {
                var item = _a[_i];
                data["businessHours"].push(item.toJSON());
            }
        }
        data["locationId"] = this.locationId;
        data["location"] = this.location ? this.location.toJSON() : undefined;
        data["palletEnabled"] = this.palletEnabled;
        data["id"] = this.id;
        return data;
    };
    return CreateOrEditStoreDto;
}());
export { CreateOrEditStoreDto };
var GetStoreForEditOutput = /** @class */ (function () {
    function GetStoreForEditOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetStoreForEditOutput.prototype.init = function (data) {
        if (data) {
            this.store = data["store"] ? CreateOrEditStoreDto.fromJS(data["store"]) : undefined;
        }
    };
    GetStoreForEditOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetStoreForEditOutput();
        result.init(data);
        return result;
    };
    GetStoreForEditOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["store"] = this.store ? this.store.toJSON() : undefined;
        return data;
    };
    return GetStoreForEditOutput;
}());
export { GetStoreForEditOutput };
var StripeConfigurationDto = /** @class */ (function () {
    function StripeConfigurationDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    StripeConfigurationDto.prototype.init = function (data) {
        if (data) {
            this.publishableKey = data["publishableKey"];
        }
    };
    StripeConfigurationDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new StripeConfigurationDto();
        result.init(data);
        return result;
    };
    StripeConfigurationDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["publishableKey"] = this.publishableKey;
        return data;
    };
    return StripeConfigurationDto;
}());
export { StripeConfigurationDto };
var StripeCreatePaymentSessionInput = /** @class */ (function () {
    function StripeCreatePaymentSessionInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    StripeCreatePaymentSessionInput.prototype.init = function (data) {
        if (data) {
            this.paymentId = data["paymentId"];
            this.successUrl = data["successUrl"];
            this.cancelUrl = data["cancelUrl"];
        }
    };
    StripeCreatePaymentSessionInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new StripeCreatePaymentSessionInput();
        result.init(data);
        return result;
    };
    StripeCreatePaymentSessionInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["paymentId"] = this.paymentId;
        data["successUrl"] = this.successUrl;
        data["cancelUrl"] = this.cancelUrl;
        return data;
    };
    return StripeCreatePaymentSessionInput;
}());
export { StripeCreatePaymentSessionInput };
var StripePaymentResultOutput = /** @class */ (function () {
    function StripePaymentResultOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    StripePaymentResultOutput.prototype.init = function (data) {
        if (data) {
            this.paymentDone = data["paymentDone"];
        }
    };
    StripePaymentResultOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new StripePaymentResultOutput();
        result.init(data);
        return result;
    };
    StripePaymentResultOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["paymentDone"] = this.paymentDone;
        return data;
    };
    return StripePaymentResultOutput;
}());
export { StripePaymentResultOutput };
var TenantListDto = /** @class */ (function () {
    function TenantListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TenantListDto.prototype.init = function (data) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.name = data["name"];
            this.editionDisplayName = data["editionDisplayName"];
            this.connectionString = data["connectionString"];
            this.isActive = data["isActive"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.subscriptionEndDateUtc = data["subscriptionEndDateUtc"] ? moment(data["subscriptionEndDateUtc"].toString()) : undefined;
            this.editionId = data["editionId"];
            this.isInTrialPeriod = data["isInTrialPeriod"];
            this.id = data["id"];
        }
    };
    TenantListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TenantListDto();
        result.init(data);
        return result;
    };
    TenantListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["editionDisplayName"] = this.editionDisplayName;
        data["connectionString"] = this.connectionString;
        data["isActive"] = this.isActive;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toISOString() : undefined;
        data["editionId"] = this.editionId;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["id"] = this.id;
        return data;
    };
    return TenantListDto;
}());
export { TenantListDto };
var PagedResultDtoOfTenantListDto = /** @class */ (function () {
    function PagedResultDtoOfTenantListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfTenantListDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(TenantListDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfTenantListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfTenantListDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfTenantListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfTenantListDto;
}());
export { PagedResultDtoOfTenantListDto };
var CreateTenantInput = /** @class */ (function () {
    function CreateTenantInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateTenantInput.prototype.init = function (data) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.name = data["name"];
            this.adminEmailAddress = data["adminEmailAddress"];
            this.adminPassword = data["adminPassword"];
            this.connectionString = data["connectionString"];
            this.shouldChangePasswordOnNextLogin = data["shouldChangePasswordOnNextLogin"];
            this.sendActivationEmail = data["sendActivationEmail"];
            this.editionId = data["editionId"];
            this.isActive = data["isActive"];
            this.subscriptionEndDateUtc = data["subscriptionEndDateUtc"] ? moment(data["subscriptionEndDateUtc"].toString()) : undefined;
            this.isInTrialPeriod = data["isInTrialPeriod"];
        }
    };
    CreateTenantInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateTenantInput();
        result.init(data);
        return result;
    };
    CreateTenantInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["adminEmailAddress"] = this.adminEmailAddress;
        data["adminPassword"] = this.adminPassword;
        data["connectionString"] = this.connectionString;
        data["shouldChangePasswordOnNextLogin"] = this.shouldChangePasswordOnNextLogin;
        data["sendActivationEmail"] = this.sendActivationEmail;
        data["editionId"] = this.editionId;
        data["isActive"] = this.isActive;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toISOString() : undefined;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        return data;
    };
    return CreateTenantInput;
}());
export { CreateTenantInput };
var TenantEditDto = /** @class */ (function () {
    function TenantEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TenantEditDto.prototype.init = function (data) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.name = data["name"];
            this.connectionString = data["connectionString"];
            this.editionId = data["editionId"];
            this.isActive = data["isActive"];
            this.subscriptionEndDateUtc = data["subscriptionEndDateUtc"] ? moment(data["subscriptionEndDateUtc"].toString()) : undefined;
            this.isInTrialPeriod = data["isInTrialPeriod"];
            this.id = data["id"];
        }
    };
    TenantEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TenantEditDto();
        result.init(data);
        return result;
    };
    TenantEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["connectionString"] = this.connectionString;
        data["editionId"] = this.editionId;
        data["isActive"] = this.isActive;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toISOString() : undefined;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["id"] = this.id;
        return data;
    };
    return TenantEditDto;
}());
export { TenantEditDto };
var GetTenantFeaturesEditOutput = /** @class */ (function () {
    function GetTenantFeaturesEditOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetTenantFeaturesEditOutput.prototype.init = function (data) {
        if (data) {
            if (Array.isArray(data["featureValues"])) {
                this.featureValues = [];
                for (var _i = 0, _a = data["featureValues"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.featureValues.push(NameValueDto.fromJS(item));
                }
            }
            if (Array.isArray(data["features"])) {
                this.features = [];
                for (var _b = 0, _c = data["features"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.features.push(FlatFeatureDto.fromJS(item));
                }
            }
        }
    };
    GetTenantFeaturesEditOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetTenantFeaturesEditOutput();
        result.init(data);
        return result;
    };
    GetTenantFeaturesEditOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (var _i = 0, _a = this.featureValues; _i < _a.length; _i++) {
                var item = _a[_i];
                data["featureValues"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.features)) {
            data["features"] = [];
            for (var _b = 0, _c = this.features; _b < _c.length; _b++) {
                var item = _c[_b];
                data["features"].push(item.toJSON());
            }
        }
        return data;
    };
    return GetTenantFeaturesEditOutput;
}());
export { GetTenantFeaturesEditOutput };
var UpdateTenantFeaturesInput = /** @class */ (function () {
    function UpdateTenantFeaturesInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.featureValues = [];
        }
    }
    UpdateTenantFeaturesInput.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            if (Array.isArray(data["featureValues"])) {
                this.featureValues = [];
                for (var _i = 0, _a = data["featureValues"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.featureValues.push(NameValueDto.fromJS(item));
                }
            }
        }
    };
    UpdateTenantFeaturesInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateTenantFeaturesInput();
        result.init(data);
        return result;
    };
    UpdateTenantFeaturesInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (var _i = 0, _a = this.featureValues; _i < _a.length; _i++) {
                var item = _a[_i];
                data["featureValues"].push(item.toJSON());
            }
        }
        return data;
    };
    return UpdateTenantFeaturesInput;
}());
export { UpdateTenantFeaturesInput };
var EntityDto = /** @class */ (function () {
    function EntityDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EntityDto.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
        }
    };
    EntityDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new EntityDto();
        result.init(data);
        return result;
    };
    EntityDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    };
    return EntityDto;
}());
export { EntityDto };
var MemberActivity = /** @class */ (function () {
    function MemberActivity(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MemberActivity.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.earnings = data["earnings"];
            this.cases = data["cases"];
            this.closed = data["closed"];
            this.rate = data["rate"];
        }
    };
    MemberActivity.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new MemberActivity();
        result.init(data);
        return result;
    };
    MemberActivity.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["earnings"] = this.earnings;
        data["cases"] = this.cases;
        data["closed"] = this.closed;
        data["rate"] = this.rate;
        return data;
    };
    return MemberActivity;
}());
export { MemberActivity };
var GetMemberActivityOutput = /** @class */ (function () {
    function GetMemberActivityOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetMemberActivityOutput.prototype.init = function (data) {
        if (data) {
            if (Array.isArray(data["memberActivities"])) {
                this.memberActivities = [];
                for (var _i = 0, _a = data["memberActivities"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.memberActivities.push(MemberActivity.fromJS(item));
                }
            }
        }
    };
    GetMemberActivityOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetMemberActivityOutput();
        result.init(data);
        return result;
    };
    GetMemberActivityOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.memberActivities)) {
            data["memberActivities"] = [];
            for (var _i = 0, _a = this.memberActivities; _i < _a.length; _i++) {
                var item = _a[_i];
                data["memberActivities"].push(item.toJSON());
            }
        }
        return data;
    };
    return GetMemberActivityOutput;
}());
export { GetMemberActivityOutput };
export var SalesSummaryDatePeriod;
(function (SalesSummaryDatePeriod) {
    SalesSummaryDatePeriod[SalesSummaryDatePeriod["Daily"] = 1] = "Daily";
    SalesSummaryDatePeriod[SalesSummaryDatePeriod["Weekly"] = 2] = "Weekly";
    SalesSummaryDatePeriod[SalesSummaryDatePeriod["Monthly"] = 3] = "Monthly";
})(SalesSummaryDatePeriod || (SalesSummaryDatePeriod = {}));
var SalesSummaryData = /** @class */ (function () {
    function SalesSummaryData(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SalesSummaryData.prototype.init = function (data) {
        if (data) {
            this.period = data["period"];
            this.sales = data["sales"];
            this.profit = data["profit"];
        }
    };
    SalesSummaryData.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SalesSummaryData();
        result.init(data);
        return result;
    };
    SalesSummaryData.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["period"] = this.period;
        data["sales"] = this.sales;
        data["profit"] = this.profit;
        return data;
    };
    return SalesSummaryData;
}());
export { SalesSummaryData };
var GetDashboardDataOutput = /** @class */ (function () {
    function GetDashboardDataOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetDashboardDataOutput.prototype.init = function (data) {
        if (data) {
            this.totalProfit = data["totalProfit"];
            this.newFeedbacks = data["newFeedbacks"];
            this.newOrders = data["newOrders"];
            this.newUsers = data["newUsers"];
            if (Array.isArray(data["salesSummary"])) {
                this.salesSummary = [];
                for (var _i = 0, _a = data["salesSummary"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.salesSummary.push(SalesSummaryData.fromJS(item));
                }
            }
            this.totalSales = data["totalSales"];
            this.revenue = data["revenue"];
            this.expenses = data["expenses"];
            this.growth = data["growth"];
            this.transactionPercent = data["transactionPercent"];
            this.newVisitPercent = data["newVisitPercent"];
            this.bouncePercent = data["bouncePercent"];
            if (Array.isArray(data["dailySales"])) {
                this.dailySales = [];
                for (var _b = 0, _c = data["dailySales"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.dailySales.push(item);
                }
            }
            if (Array.isArray(data["profitShares"])) {
                this.profitShares = [];
                for (var _d = 0, _e = data["profitShares"]; _d < _e.length; _d++) {
                    var item = _e[_d];
                    this.profitShares.push(item);
                }
            }
        }
    };
    GetDashboardDataOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetDashboardDataOutput();
        result.init(data);
        return result;
    };
    GetDashboardDataOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalProfit"] = this.totalProfit;
        data["newFeedbacks"] = this.newFeedbacks;
        data["newOrders"] = this.newOrders;
        data["newUsers"] = this.newUsers;
        if (Array.isArray(this.salesSummary)) {
            data["salesSummary"] = [];
            for (var _i = 0, _a = this.salesSummary; _i < _a.length; _i++) {
                var item = _a[_i];
                data["salesSummary"].push(item.toJSON());
            }
        }
        data["totalSales"] = this.totalSales;
        data["revenue"] = this.revenue;
        data["expenses"] = this.expenses;
        data["growth"] = this.growth;
        data["transactionPercent"] = this.transactionPercent;
        data["newVisitPercent"] = this.newVisitPercent;
        data["bouncePercent"] = this.bouncePercent;
        if (Array.isArray(this.dailySales)) {
            data["dailySales"] = [];
            for (var _b = 0, _c = this.dailySales; _b < _c.length; _b++) {
                var item = _c[_b];
                data["dailySales"].push(item);
            }
        }
        if (Array.isArray(this.profitShares)) {
            data["profitShares"] = [];
            for (var _d = 0, _e = this.profitShares; _d < _e.length; _d++) {
                var item = _e[_d];
                data["profitShares"].push(item);
            }
        }
        return data;
    };
    return GetDashboardDataOutput;
}());
export { GetDashboardDataOutput };
var GetTopStatsOutput = /** @class */ (function () {
    function GetTopStatsOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetTopStatsOutput.prototype.init = function (data) {
        if (data) {
            this.totalProfit = data["totalProfit"];
            this.newFeedbacks = data["newFeedbacks"];
            this.newOrders = data["newOrders"];
            this.newUsers = data["newUsers"];
        }
    };
    GetTopStatsOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetTopStatsOutput();
        result.init(data);
        return result;
    };
    GetTopStatsOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalProfit"] = this.totalProfit;
        data["newFeedbacks"] = this.newFeedbacks;
        data["newOrders"] = this.newOrders;
        data["newUsers"] = this.newUsers;
        return data;
    };
    return GetTopStatsOutput;
}());
export { GetTopStatsOutput };
var GetProfitShareOutput = /** @class */ (function () {
    function GetProfitShareOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetProfitShareOutput.prototype.init = function (data) {
        if (data) {
            if (Array.isArray(data["profitShares"])) {
                this.profitShares = [];
                for (var _i = 0, _a = data["profitShares"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.profitShares.push(item);
                }
            }
        }
    };
    GetProfitShareOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetProfitShareOutput();
        result.init(data);
        return result;
    };
    GetProfitShareOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.profitShares)) {
            data["profitShares"] = [];
            for (var _i = 0, _a = this.profitShares; _i < _a.length; _i++) {
                var item = _a[_i];
                data["profitShares"].push(item);
            }
        }
        return data;
    };
    return GetProfitShareOutput;
}());
export { GetProfitShareOutput };
var GetDailySalesOutput = /** @class */ (function () {
    function GetDailySalesOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetDailySalesOutput.prototype.init = function (data) {
        if (data) {
            if (Array.isArray(data["dailySales"])) {
                this.dailySales = [];
                for (var _i = 0, _a = data["dailySales"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.dailySales.push(item);
                }
            }
        }
    };
    GetDailySalesOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetDailySalesOutput();
        result.init(data);
        return result;
    };
    GetDailySalesOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.dailySales)) {
            data["dailySales"] = [];
            for (var _i = 0, _a = this.dailySales; _i < _a.length; _i++) {
                var item = _a[_i];
                data["dailySales"].push(item);
            }
        }
        return data;
    };
    return GetDailySalesOutput;
}());
export { GetDailySalesOutput };
var GetSalesSummaryOutput = /** @class */ (function () {
    function GetSalesSummaryOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetSalesSummaryOutput.prototype.init = function (data) {
        if (data) {
            this.totalSales = data["totalSales"];
            this.revenue = data["revenue"];
            this.expenses = data["expenses"];
            this.growth = data["growth"];
            if (Array.isArray(data["salesSummary"])) {
                this.salesSummary = [];
                for (var _i = 0, _a = data["salesSummary"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.salesSummary.push(SalesSummaryData.fromJS(item));
                }
            }
        }
    };
    GetSalesSummaryOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetSalesSummaryOutput();
        result.init(data);
        return result;
    };
    GetSalesSummaryOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalSales"] = this.totalSales;
        data["revenue"] = this.revenue;
        data["expenses"] = this.expenses;
        data["growth"] = this.growth;
        if (Array.isArray(this.salesSummary)) {
            data["salesSummary"] = [];
            for (var _i = 0, _a = this.salesSummary; _i < _a.length; _i++) {
                var item = _a[_i];
                data["salesSummary"].push(item.toJSON());
            }
        }
        return data;
    };
    return GetSalesSummaryOutput;
}());
export { GetSalesSummaryOutput };
var RegionalStatCountry = /** @class */ (function () {
    function RegionalStatCountry(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RegionalStatCountry.prototype.init = function (data) {
        if (data) {
            this.countryName = data["countryName"];
            this.sales = data["sales"];
            if (Array.isArray(data["change"])) {
                this.change = [];
                for (var _i = 0, _a = data["change"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.change.push(item);
                }
            }
            this.averagePrice = data["averagePrice"];
            this.totalPrice = data["totalPrice"];
        }
    };
    RegionalStatCountry.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RegionalStatCountry();
        result.init(data);
        return result;
    };
    RegionalStatCountry.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["countryName"] = this.countryName;
        data["sales"] = this.sales;
        if (Array.isArray(this.change)) {
            data["change"] = [];
            for (var _i = 0, _a = this.change; _i < _a.length; _i++) {
                var item = _a[_i];
                data["change"].push(item);
            }
        }
        data["averagePrice"] = this.averagePrice;
        data["totalPrice"] = this.totalPrice;
        return data;
    };
    return RegionalStatCountry;
}());
export { RegionalStatCountry };
var GetRegionalStatsOutput = /** @class */ (function () {
    function GetRegionalStatsOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetRegionalStatsOutput.prototype.init = function (data) {
        if (data) {
            if (Array.isArray(data["stats"])) {
                this.stats = [];
                for (var _i = 0, _a = data["stats"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.stats.push(RegionalStatCountry.fromJS(item));
                }
            }
        }
    };
    GetRegionalStatsOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetRegionalStatsOutput();
        result.init(data);
        return result;
    };
    GetRegionalStatsOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.stats)) {
            data["stats"] = [];
            for (var _i = 0, _a = this.stats; _i < _a.length; _i++) {
                var item = _a[_i];
                data["stats"].push(item.toJSON());
            }
        }
        return data;
    };
    return GetRegionalStatsOutput;
}());
export { GetRegionalStatsOutput };
var GetGeneralStatsOutput = /** @class */ (function () {
    function GetGeneralStatsOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetGeneralStatsOutput.prototype.init = function (data) {
        if (data) {
            this.transactionPercent = data["transactionPercent"];
            this.newVisitPercent = data["newVisitPercent"];
            this.bouncePercent = data["bouncePercent"];
        }
    };
    GetGeneralStatsOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetGeneralStatsOutput();
        result.init(data);
        return result;
    };
    GetGeneralStatsOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["transactionPercent"] = this.transactionPercent;
        data["newVisitPercent"] = this.newVisitPercent;
        data["bouncePercent"] = this.bouncePercent;
        return data;
    };
    return GetGeneralStatsOutput;
}());
export { GetGeneralStatsOutput };
export var SubscriptionStartType;
(function (SubscriptionStartType) {
    SubscriptionStartType[SubscriptionStartType["Free"] = 1] = "Free";
    SubscriptionStartType[SubscriptionStartType["Trial"] = 2] = "Trial";
    SubscriptionStartType[SubscriptionStartType["Paid"] = 3] = "Paid";
})(SubscriptionStartType || (SubscriptionStartType = {}));
var RegisterTenantInput = /** @class */ (function () {
    function RegisterTenantInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RegisterTenantInput.prototype.init = function (data) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.name = data["name"];
            this.adminEmailAddress = data["adminEmailAddress"];
            this.adminPassword = data["adminPassword"];
            this.captchaResponse = data["captchaResponse"];
            this.subscriptionStartType = data["subscriptionStartType"];
            this.editionId = data["editionId"];
        }
    };
    RegisterTenantInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RegisterTenantInput();
        result.init(data);
        return result;
    };
    RegisterTenantInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["adminEmailAddress"] = this.adminEmailAddress;
        data["adminPassword"] = this.adminPassword;
        data["captchaResponse"] = this.captchaResponse;
        data["subscriptionStartType"] = this.subscriptionStartType;
        data["editionId"] = this.editionId;
        return data;
    };
    return RegisterTenantInput;
}());
export { RegisterTenantInput };
var RegisterTenantOutput = /** @class */ (function () {
    function RegisterTenantOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RegisterTenantOutput.prototype.init = function (data) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.tenancyName = data["tenancyName"];
            this.name = data["name"];
            this.userName = data["userName"];
            this.emailAddress = data["emailAddress"];
            this.isTenantActive = data["isTenantActive"];
            this.isActive = data["isActive"];
            this.isEmailConfirmationRequired = data["isEmailConfirmationRequired"];
        }
    };
    RegisterTenantOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RegisterTenantOutput();
        result.init(data);
        return result;
    };
    RegisterTenantOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["isTenantActive"] = this.isTenantActive;
        data["isActive"] = this.isActive;
        data["isEmailConfirmationRequired"] = this.isEmailConfirmationRequired;
        return data;
    };
    return RegisterTenantOutput;
}());
export { RegisterTenantOutput };
var IInputType = /** @class */ (function () {
    function IInputType(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    IInputType.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            if (data["attributes"]) {
                this.attributes = {};
                for (var key in data["attributes"]) {
                    if (data["attributes"].hasOwnProperty(key))
                        this.attributes[key] = data["attributes"][key];
                }
            }
            this.validator = data["validator"] ? IValueValidator.fromJS(data["validator"]) : undefined;
        }
    };
    IInputType.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new IInputType();
        result.init(data);
        return result;
    };
    IInputType.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.attributes) {
            data["attributes"] = {};
            for (var key in this.attributes) {
                if (this.attributes.hasOwnProperty(key))
                    data["attributes"][key] = this.attributes[key];
            }
        }
        data["validator"] = this.validator ? this.validator.toJSON() : undefined;
        return data;
    };
    return IInputType;
}());
export { IInputType };
var FlatFeatureSelectDto = /** @class */ (function () {
    function FlatFeatureSelectDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FlatFeatureSelectDto.prototype.init = function (data) {
        if (data) {
            this.parentName = data["parentName"];
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.description = data["description"];
            this.defaultValue = data["defaultValue"];
            this.inputType = data["inputType"] ? IInputType.fromJS(data["inputType"]) : undefined;
            this.textHtmlColor = data["textHtmlColor"];
        }
    };
    FlatFeatureSelectDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FlatFeatureSelectDto();
        result.init(data);
        return result;
    };
    FlatFeatureSelectDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["defaultValue"] = this.defaultValue;
        data["inputType"] = this.inputType ? this.inputType.toJSON() : undefined;
        data["textHtmlColor"] = this.textHtmlColor;
        return data;
    };
    return FlatFeatureSelectDto;
}());
export { FlatFeatureSelectDto };
var EditionWithFeaturesDto = /** @class */ (function () {
    function EditionWithFeaturesDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EditionWithFeaturesDto.prototype.init = function (data) {
        if (data) {
            this.edition = data["edition"] ? EditionSelectDto.fromJS(data["edition"]) : undefined;
            if (Array.isArray(data["featureValues"])) {
                this.featureValues = [];
                for (var _i = 0, _a = data["featureValues"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.featureValues.push(NameValueDto.fromJS(item));
                }
            }
        }
    };
    EditionWithFeaturesDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new EditionWithFeaturesDto();
        result.init(data);
        return result;
    };
    EditionWithFeaturesDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : undefined;
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (var _i = 0, _a = this.featureValues; _i < _a.length; _i++) {
                var item = _a[_i];
                data["featureValues"].push(item.toJSON());
            }
        }
        return data;
    };
    return EditionWithFeaturesDto;
}());
export { EditionWithFeaturesDto };
var EditionsSelectOutput = /** @class */ (function () {
    function EditionsSelectOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EditionsSelectOutput.prototype.init = function (data) {
        if (data) {
            if (Array.isArray(data["allFeatures"])) {
                this.allFeatures = [];
                for (var _i = 0, _a = data["allFeatures"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.allFeatures.push(FlatFeatureSelectDto.fromJS(item));
                }
            }
            if (Array.isArray(data["editionsWithFeatures"])) {
                this.editionsWithFeatures = [];
                for (var _b = 0, _c = data["editionsWithFeatures"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.editionsWithFeatures.push(EditionWithFeaturesDto.fromJS(item));
                }
            }
        }
    };
    EditionsSelectOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new EditionsSelectOutput();
        result.init(data);
        return result;
    };
    EditionsSelectOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.allFeatures)) {
            data["allFeatures"] = [];
            for (var _i = 0, _a = this.allFeatures; _i < _a.length; _i++) {
                var item = _a[_i];
                data["allFeatures"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.editionsWithFeatures)) {
            data["editionsWithFeatures"] = [];
            for (var _b = 0, _c = this.editionsWithFeatures; _b < _c.length; _b++) {
                var item = _c[_b];
                data["editionsWithFeatures"].push(item.toJSON());
            }
        }
        return data;
    };
    return EditionsSelectOutput;
}());
export { EditionsSelectOutput };
var TenantUserManagementSettingsEditDto = /** @class */ (function () {
    function TenantUserManagementSettingsEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TenantUserManagementSettingsEditDto.prototype.init = function (data) {
        if (data) {
            this.allowSelfRegistration = data["allowSelfRegistration"];
            this.isNewRegisteredUserActiveByDefault = data["isNewRegisteredUserActiveByDefault"];
            this.isEmailConfirmationRequiredForLogin = data["isEmailConfirmationRequiredForLogin"];
            this.useCaptchaOnRegistration = data["useCaptchaOnRegistration"];
            this.useCaptchaOnLogin = data["useCaptchaOnLogin"];
            this.isCookieConsentEnabled = data["isCookieConsentEnabled"];
            this.isQuickThemeSelectEnabled = data["isQuickThemeSelectEnabled"];
            this.sessionTimeOutSettings = data["sessionTimeOutSettings"] ? SessionTimeOutSettingsEditDto.fromJS(data["sessionTimeOutSettings"]) : undefined;
        }
    };
    TenantUserManagementSettingsEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TenantUserManagementSettingsEditDto();
        result.init(data);
        return result;
    };
    TenantUserManagementSettingsEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["allowSelfRegistration"] = this.allowSelfRegistration;
        data["isNewRegisteredUserActiveByDefault"] = this.isNewRegisteredUserActiveByDefault;
        data["isEmailConfirmationRequiredForLogin"] = this.isEmailConfirmationRequiredForLogin;
        data["useCaptchaOnRegistration"] = this.useCaptchaOnRegistration;
        data["useCaptchaOnLogin"] = this.useCaptchaOnLogin;
        data["isCookieConsentEnabled"] = this.isCookieConsentEnabled;
        data["isQuickThemeSelectEnabled"] = this.isQuickThemeSelectEnabled;
        data["sessionTimeOutSettings"] = this.sessionTimeOutSettings ? this.sessionTimeOutSettings.toJSON() : undefined;
        return data;
    };
    return TenantUserManagementSettingsEditDto;
}());
export { TenantUserManagementSettingsEditDto };
var TenantEmailSettingsEditDto = /** @class */ (function () {
    function TenantEmailSettingsEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TenantEmailSettingsEditDto.prototype.init = function (data) {
        if (data) {
            this.useHostDefaultEmailSettings = data["useHostDefaultEmailSettings"];
            this.defaultFromAddress = data["defaultFromAddress"];
            this.defaultFromDisplayName = data["defaultFromDisplayName"];
            this.smtpHost = data["smtpHost"];
            this.smtpPort = data["smtpPort"];
            this.smtpUserName = data["smtpUserName"];
            this.smtpPassword = data["smtpPassword"];
            this.smtpDomain = data["smtpDomain"];
            this.smtpEnableSsl = data["smtpEnableSsl"];
            this.smtpUseDefaultCredentials = data["smtpUseDefaultCredentials"];
        }
    };
    TenantEmailSettingsEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TenantEmailSettingsEditDto();
        result.init(data);
        return result;
    };
    TenantEmailSettingsEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["useHostDefaultEmailSettings"] = this.useHostDefaultEmailSettings;
        data["defaultFromAddress"] = this.defaultFromAddress;
        data["defaultFromDisplayName"] = this.defaultFromDisplayName;
        data["smtpHost"] = this.smtpHost;
        data["smtpPort"] = this.smtpPort;
        data["smtpUserName"] = this.smtpUserName;
        data["smtpPassword"] = this.smtpPassword;
        data["smtpDomain"] = this.smtpDomain;
        data["smtpEnableSsl"] = this.smtpEnableSsl;
        data["smtpUseDefaultCredentials"] = this.smtpUseDefaultCredentials;
        return data;
    };
    return TenantEmailSettingsEditDto;
}());
export { TenantEmailSettingsEditDto };
var LdapSettingsEditDto = /** @class */ (function () {
    function LdapSettingsEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    LdapSettingsEditDto.prototype.init = function (data) {
        if (data) {
            this.isModuleEnabled = data["isModuleEnabled"];
            this.isEnabled = data["isEnabled"];
            this.domain = data["domain"];
            this.userName = data["userName"];
            this.password = data["password"];
        }
    };
    LdapSettingsEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new LdapSettingsEditDto();
        result.init(data);
        return result;
    };
    LdapSettingsEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["isModuleEnabled"] = this.isModuleEnabled;
        data["isEnabled"] = this.isEnabled;
        data["domain"] = this.domain;
        data["userName"] = this.userName;
        data["password"] = this.password;
        return data;
    };
    return LdapSettingsEditDto;
}());
export { LdapSettingsEditDto };
var TenantBillingSettingsEditDto = /** @class */ (function () {
    function TenantBillingSettingsEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TenantBillingSettingsEditDto.prototype.init = function (data) {
        if (data) {
            this.legalName = data["legalName"];
            this.address = data["address"];
            this.taxVatNo = data["taxVatNo"];
        }
    };
    TenantBillingSettingsEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TenantBillingSettingsEditDto();
        result.init(data);
        return result;
    };
    TenantBillingSettingsEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["legalName"] = this.legalName;
        data["address"] = this.address;
        data["taxVatNo"] = this.taxVatNo;
        return data;
    };
    return TenantBillingSettingsEditDto;
}());
export { TenantBillingSettingsEditDto };
var TenantOtherSettingsEditDto = /** @class */ (function () {
    function TenantOtherSettingsEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TenantOtherSettingsEditDto.prototype.init = function (data) {
        if (data) {
            this.isQuickThemeSelectEnabled = data["isQuickThemeSelectEnabled"];
        }
    };
    TenantOtherSettingsEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TenantOtherSettingsEditDto();
        result.init(data);
        return result;
    };
    TenantOtherSettingsEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["isQuickThemeSelectEnabled"] = this.isQuickThemeSelectEnabled;
        return data;
    };
    return TenantOtherSettingsEditDto;
}());
export { TenantOtherSettingsEditDto };
var DeliveryWindowSettingEditDto = /** @class */ (function () {
    function DeliveryWindowSettingEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DeliveryWindowSettingEditDto.prototype.init = function (data) {
        if (data) {
            this.nsw = data["nsw"];
            this.act = data["act"];
            this.qld = data["qld"];
            this.vic = data["vic"];
            this.nt = data["nt"];
            this.wa = data["wa"];
            this.tas = data["tas"];
            this.sa = data["sa"];
            this.default = data["default"];
            this.businessDefault = data["businessDefault"];
        }
    };
    DeliveryWindowSettingEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DeliveryWindowSettingEditDto();
        result.init(data);
        return result;
    };
    DeliveryWindowSettingEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["nsw"] = this.nsw;
        data["act"] = this.act;
        data["qld"] = this.qld;
        data["vic"] = this.vic;
        data["nt"] = this.nt;
        data["wa"] = this.wa;
        data["tas"] = this.tas;
        data["sa"] = this.sa;
        data["default"] = this.default;
        data["businessDefault"] = this.businessDefault;
        return data;
    };
    return DeliveryWindowSettingEditDto;
}());
export { DeliveryWindowSettingEditDto };
var TenantSettingsEditDto = /** @class */ (function () {
    function TenantSettingsEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.userManagement = new TenantUserManagementSettingsEditDto();
            this.security = new SecuritySettingsEditDto();
        }
    }
    TenantSettingsEditDto.prototype.init = function (data) {
        if (data) {
            this.general = data["general"] ? GeneralSettingsEditDto.fromJS(data["general"]) : undefined;
            this.userManagement = data["userManagement"] ? TenantUserManagementSettingsEditDto.fromJS(data["userManagement"]) : new TenantUserManagementSettingsEditDto();
            this.email = data["email"] ? TenantEmailSettingsEditDto.fromJS(data["email"]) : undefined;
            this.ldap = data["ldap"] ? LdapSettingsEditDto.fromJS(data["ldap"]) : undefined;
            this.security = data["security"] ? SecuritySettingsEditDto.fromJS(data["security"]) : new SecuritySettingsEditDto();
            this.billing = data["billing"] ? TenantBillingSettingsEditDto.fromJS(data["billing"]) : undefined;
            this.otherSettings = data["otherSettings"] ? TenantOtherSettingsEditDto.fromJS(data["otherSettings"]) : undefined;
            this.connoteNumberSettings = data["connoteNumberSettings"] ? ConnoteNumberSettingsEditDto.fromJS(data["connoteNumberSettings"]) : undefined;
            this.deliveryWindowSettings = data["deliveryWindowSettings"] ? DeliveryWindowSettingEditDto.fromJS(data["deliveryWindowSettings"]) : undefined;
        }
    };
    TenantSettingsEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TenantSettingsEditDto();
        result.init(data);
        return result;
    };
    TenantSettingsEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["general"] = this.general ? this.general.toJSON() : undefined;
        data["userManagement"] = this.userManagement ? this.userManagement.toJSON() : undefined;
        data["email"] = this.email ? this.email.toJSON() : undefined;
        data["ldap"] = this.ldap ? this.ldap.toJSON() : undefined;
        data["security"] = this.security ? this.security.toJSON() : undefined;
        data["billing"] = this.billing ? this.billing.toJSON() : undefined;
        data["otherSettings"] = this.otherSettings ? this.otherSettings.toJSON() : undefined;
        data["connoteNumberSettings"] = this.connoteNumberSettings ? this.connoteNumberSettings.toJSON() : undefined;
        data["deliveryWindowSettings"] = this.deliveryWindowSettings ? this.deliveryWindowSettings.toJSON() : undefined;
        return data;
    };
    return TenantSettingsEditDto;
}());
export { TenantSettingsEditDto };
var GetTerritoryConfigurationForViewDto = /** @class */ (function () {
    function GetTerritoryConfigurationForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetTerritoryConfigurationForViewDto.prototype.init = function (data) {
        if (data) {
            this.territoryConfiguration = data["territoryConfiguration"] ? TerritoryConfigurationDto.fromJS(data["territoryConfiguration"]) : undefined;
        }
    };
    GetTerritoryConfigurationForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetTerritoryConfigurationForViewDto();
        result.init(data);
        return result;
    };
    GetTerritoryConfigurationForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["territoryConfiguration"] = this.territoryConfiguration ? this.territoryConfiguration.toJSON() : undefined;
        return data;
    };
    return GetTerritoryConfigurationForViewDto;
}());
export { GetTerritoryConfigurationForViewDto };
var PagedResultDtoOfGetTerritoryConfigurationForViewDto = /** @class */ (function () {
    function PagedResultDtoOfGetTerritoryConfigurationForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfGetTerritoryConfigurationForViewDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(GetTerritoryConfigurationForViewDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfGetTerritoryConfigurationForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfGetTerritoryConfigurationForViewDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfGetTerritoryConfigurationForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfGetTerritoryConfigurationForViewDto;
}());
export { PagedResultDtoOfGetTerritoryConfigurationForViewDto };
var CreateOrEditTerritoryConfigurationDto = /** @class */ (function () {
    function CreateOrEditTerritoryConfigurationDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateOrEditTerritoryConfigurationDto.prototype.init = function (data) {
        if (data) {
            this.territory = data["territory"];
            this.routedBy = data["routedBy"];
            this.servicedByED = data["servicedByED"];
            this.state = data["state"];
            this.showETA = data["showETA"];
            this.id = data["id"];
        }
    };
    CreateOrEditTerritoryConfigurationDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrEditTerritoryConfigurationDto();
        result.init(data);
        return result;
    };
    CreateOrEditTerritoryConfigurationDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["territory"] = this.territory;
        data["routedBy"] = this.routedBy;
        data["servicedByED"] = this.servicedByED;
        data["state"] = this.state;
        data["showETA"] = this.showETA;
        data["id"] = this.id;
        return data;
    };
    return CreateOrEditTerritoryConfigurationDto;
}());
export { CreateOrEditTerritoryConfigurationDto };
var GetTerritoryConfigurationForEditOutput = /** @class */ (function () {
    function GetTerritoryConfigurationForEditOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetTerritoryConfigurationForEditOutput.prototype.init = function (data) {
        if (data) {
            this.territoryConfiguration = data["territoryConfiguration"] ? CreateOrEditTerritoryConfigurationDto.fromJS(data["territoryConfiguration"]) : undefined;
        }
    };
    GetTerritoryConfigurationForEditOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetTerritoryConfigurationForEditOutput();
        result.init(data);
        return result;
    };
    GetTerritoryConfigurationForEditOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["territoryConfiguration"] = this.territoryConfiguration ? this.territoryConfiguration.toJSON() : undefined;
        return data;
    };
    return GetTerritoryConfigurationForEditOutput;
}());
export { GetTerritoryConfigurationForEditOutput };
export var SettingScopes;
(function (SettingScopes) {
    SettingScopes[SettingScopes["Application"] = 1] = "Application";
    SettingScopes[SettingScopes["Tenant"] = 2] = "Tenant";
    SettingScopes[SettingScopes["User"] = 4] = "User";
    SettingScopes[SettingScopes["All"] = 7] = "All";
})(SettingScopes || (SettingScopes = {}));
var ListResultDtoOfNameValueDto = /** @class */ (function () {
    function ListResultDtoOfNameValueDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ListResultDtoOfNameValueDto.prototype.init = function (data) {
        if (data) {
            if (Array.isArray(data["items"])) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(NameValueDto.fromJS(item));
                }
            }
        }
    };
    ListResultDtoOfNameValueDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ListResultDtoOfNameValueDto();
        result.init(data);
        return result;
    };
    ListResultDtoOfNameValueDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return ListResultDtoOfNameValueDto;
}());
export { ListResultDtoOfNameValueDto };
var AuthenticateModel = /** @class */ (function () {
    function AuthenticateModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AuthenticateModel.prototype.init = function (data) {
        if (data) {
            this.userNameOrEmailAddress = data["userNameOrEmailAddress"];
            this.password = data["password"];
            this.twoFactorVerificationCode = data["twoFactorVerificationCode"];
            this.rememberClient = data["rememberClient"];
            this.twoFactorRememberClientToken = data["twoFactorRememberClientToken"];
            this.singleSignIn = data["singleSignIn"];
            this.returnUrl = data["returnUrl"];
            this.captchaResponse = data["captchaResponse"];
        }
    };
    AuthenticateModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AuthenticateModel();
        result.init(data);
        return result;
    };
    AuthenticateModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["userNameOrEmailAddress"] = this.userNameOrEmailAddress;
        data["password"] = this.password;
        data["twoFactorVerificationCode"] = this.twoFactorVerificationCode;
        data["rememberClient"] = this.rememberClient;
        data["twoFactorRememberClientToken"] = this.twoFactorRememberClientToken;
        data["singleSignIn"] = this.singleSignIn;
        data["returnUrl"] = this.returnUrl;
        data["captchaResponse"] = this.captchaResponse;
        return data;
    };
    return AuthenticateModel;
}());
export { AuthenticateModel };
var AuthenticateResultModel = /** @class */ (function () {
    function AuthenticateResultModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AuthenticateResultModel.prototype.init = function (data) {
        if (data) {
            this.accessToken = data["accessToken"];
            this.encryptedAccessToken = data["encryptedAccessToken"];
            this.expireInSeconds = data["expireInSeconds"];
            this.shouldResetPassword = data["shouldResetPassword"];
            this.passwordResetCode = data["passwordResetCode"];
            this.userId = data["userId"];
            this.requiresTwoFactorVerification = data["requiresTwoFactorVerification"];
            if (Array.isArray(data["twoFactorAuthProviders"])) {
                this.twoFactorAuthProviders = [];
                for (var _i = 0, _a = data["twoFactorAuthProviders"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.twoFactorAuthProviders.push(item);
                }
            }
            this.twoFactorRememberClientToken = data["twoFactorRememberClientToken"];
            this.returnUrl = data["returnUrl"];
            this.refreshToken = data["refreshToken"];
            this.refreshTokenExpireInSeconds = data["refreshTokenExpireInSeconds"];
        }
    };
    AuthenticateResultModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AuthenticateResultModel();
        result.init(data);
        return result;
    };
    AuthenticateResultModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["shouldResetPassword"] = this.shouldResetPassword;
        data["passwordResetCode"] = this.passwordResetCode;
        data["userId"] = this.userId;
        data["requiresTwoFactorVerification"] = this.requiresTwoFactorVerification;
        if (Array.isArray(this.twoFactorAuthProviders)) {
            data["twoFactorAuthProviders"] = [];
            for (var _i = 0, _a = this.twoFactorAuthProviders; _i < _a.length; _i++) {
                var item = _a[_i];
                data["twoFactorAuthProviders"].push(item);
            }
        }
        data["twoFactorRememberClientToken"] = this.twoFactorRememberClientToken;
        data["returnUrl"] = this.returnUrl;
        data["refreshToken"] = this.refreshToken;
        data["refreshTokenExpireInSeconds"] = this.refreshTokenExpireInSeconds;
        return data;
    };
    return AuthenticateResultModel;
}());
export { AuthenticateResultModel };
var RefreshTokenResult = /** @class */ (function () {
    function RefreshTokenResult(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RefreshTokenResult.prototype.init = function (data) {
        if (data) {
            this.accessToken = data["accessToken"];
            this.encryptedAccessToken = data["encryptedAccessToken"];
            this.expireInSeconds = data["expireInSeconds"];
        }
    };
    RefreshTokenResult.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RefreshTokenResult();
        result.init(data);
        return result;
    };
    RefreshTokenResult.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        return data;
    };
    return RefreshTokenResult;
}());
export { RefreshTokenResult };
var SendTwoFactorAuthCodeModel = /** @class */ (function () {
    function SendTwoFactorAuthCodeModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SendTwoFactorAuthCodeModel.prototype.init = function (data) {
        if (data) {
            this.userId = data["userId"];
            this.provider = data["provider"];
        }
    };
    SendTwoFactorAuthCodeModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SendTwoFactorAuthCodeModel();
        result.init(data);
        return result;
    };
    SendTwoFactorAuthCodeModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["provider"] = this.provider;
        return data;
    };
    return SendTwoFactorAuthCodeModel;
}());
export { SendTwoFactorAuthCodeModel };
var ImpersonatedAuthenticateResultModel = /** @class */ (function () {
    function ImpersonatedAuthenticateResultModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ImpersonatedAuthenticateResultModel.prototype.init = function (data) {
        if (data) {
            this.accessToken = data["accessToken"];
            this.encryptedAccessToken = data["encryptedAccessToken"];
            this.expireInSeconds = data["expireInSeconds"];
        }
    };
    ImpersonatedAuthenticateResultModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ImpersonatedAuthenticateResultModel();
        result.init(data);
        return result;
    };
    ImpersonatedAuthenticateResultModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        return data;
    };
    return ImpersonatedAuthenticateResultModel;
}());
export { ImpersonatedAuthenticateResultModel };
var SwitchedAccountAuthenticateResultModel = /** @class */ (function () {
    function SwitchedAccountAuthenticateResultModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SwitchedAccountAuthenticateResultModel.prototype.init = function (data) {
        if (data) {
            this.accessToken = data["accessToken"];
            this.encryptedAccessToken = data["encryptedAccessToken"];
            this.expireInSeconds = data["expireInSeconds"];
        }
    };
    SwitchedAccountAuthenticateResultModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SwitchedAccountAuthenticateResultModel();
        result.init(data);
        return result;
    };
    SwitchedAccountAuthenticateResultModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        return data;
    };
    return SwitchedAccountAuthenticateResultModel;
}());
export { SwitchedAccountAuthenticateResultModel };
var ExternalLoginProviderInfoModel = /** @class */ (function () {
    function ExternalLoginProviderInfoModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ExternalLoginProviderInfoModel.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.clientId = data["clientId"];
            if (data["additionalParams"]) {
                this.additionalParams = {};
                for (var key in data["additionalParams"]) {
                    if (data["additionalParams"].hasOwnProperty(key))
                        this.additionalParams[key] = data["additionalParams"][key];
                }
            }
        }
    };
    ExternalLoginProviderInfoModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ExternalLoginProviderInfoModel();
        result.init(data);
        return result;
    };
    ExternalLoginProviderInfoModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["clientId"] = this.clientId;
        if (this.additionalParams) {
            data["additionalParams"] = {};
            for (var key in this.additionalParams) {
                if (this.additionalParams.hasOwnProperty(key))
                    data["additionalParams"][key] = this.additionalParams[key];
            }
        }
        return data;
    };
    return ExternalLoginProviderInfoModel;
}());
export { ExternalLoginProviderInfoModel };
var ExternalAuthenticateModel = /** @class */ (function () {
    function ExternalAuthenticateModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ExternalAuthenticateModel.prototype.init = function (data) {
        if (data) {
            this.authProvider = data["authProvider"];
            this.providerKey = data["providerKey"];
            this.providerAccessCode = data["providerAccessCode"];
            this.returnUrl = data["returnUrl"];
            this.singleSignIn = data["singleSignIn"];
        }
    };
    ExternalAuthenticateModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ExternalAuthenticateModel();
        result.init(data);
        return result;
    };
    ExternalAuthenticateModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["authProvider"] = this.authProvider;
        data["providerKey"] = this.providerKey;
        data["providerAccessCode"] = this.providerAccessCode;
        data["returnUrl"] = this.returnUrl;
        data["singleSignIn"] = this.singleSignIn;
        return data;
    };
    return ExternalAuthenticateModel;
}());
export { ExternalAuthenticateModel };
var ExternalAuthenticateResultModel = /** @class */ (function () {
    function ExternalAuthenticateResultModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ExternalAuthenticateResultModel.prototype.init = function (data) {
        if (data) {
            this.accessToken = data["accessToken"];
            this.encryptedAccessToken = data["encryptedAccessToken"];
            this.expireInSeconds = data["expireInSeconds"];
            this.waitingForActivation = data["waitingForActivation"];
            this.returnUrl = data["returnUrl"];
            this.refreshToken = data["refreshToken"];
            this.refreshTokenExpireInSeconds = data["refreshTokenExpireInSeconds"];
        }
    };
    ExternalAuthenticateResultModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ExternalAuthenticateResultModel();
        result.init(data);
        return result;
    };
    ExternalAuthenticateResultModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["waitingForActivation"] = this.waitingForActivation;
        data["returnUrl"] = this.returnUrl;
        data["refreshToken"] = this.refreshToken;
        data["refreshTokenExpireInSeconds"] = this.refreshTokenExpireInSeconds;
        return data;
    };
    return ExternalAuthenticateResultModel;
}());
export { ExternalAuthenticateResultModel };
var UserListRoleDto = /** @class */ (function () {
    function UserListRoleDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UserListRoleDto.prototype.init = function (data) {
        if (data) {
            this.roleId = data["roleId"];
            this.roleName = data["roleName"];
        }
    };
    UserListRoleDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UserListRoleDto();
        result.init(data);
        return result;
    };
    UserListRoleDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        return data;
    };
    return UserListRoleDto;
}());
export { UserListRoleDto };
var UserListDto = /** @class */ (function () {
    function UserListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UserListDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.surname = data["surname"];
            this.userName = data["userName"];
            this.emailAddress = data["emailAddress"];
            this.phoneNumber = data["phoneNumber"];
            this.profilePictureId = data["profilePictureId"];
            this.isEmailConfirmed = data["isEmailConfirmed"];
            if (Array.isArray(data["roles"])) {
                this.roles = [];
                for (var _i = 0, _a = data["roles"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.roles.push(UserListRoleDto.fromJS(item));
                }
            }
            this.isActive = data["isActive"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.id = data["id"];
        }
    };
    UserListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UserListDto();
        result.init(data);
        return result;
    };
    UserListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["profilePictureId"] = this.profilePictureId;
        data["isEmailConfirmed"] = this.isEmailConfirmed;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (var _i = 0, _a = this.roles; _i < _a.length; _i++) {
                var item = _a[_i];
                data["roles"].push(item.toJSON());
            }
        }
        data["isActive"] = this.isActive;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["id"] = this.id;
        return data;
    };
    return UserListDto;
}());
export { UserListDto };
var PagedResultDtoOfUserListDto = /** @class */ (function () {
    function PagedResultDtoOfUserListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfUserListDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(UserListDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfUserListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfUserListDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfUserListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfUserListDto;
}());
export { PagedResultDtoOfUserListDto };
var UserEditDto = /** @class */ (function () {
    function UserEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UserEditDto.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.surname = data["surname"];
            this.userName = data["userName"];
            this.emailAddress = data["emailAddress"];
            this.phoneNumber = data["phoneNumber"];
            this.password = data["password"];
            this.isActive = data["isActive"];
            this.shouldChangePasswordOnNextLogin = data["shouldChangePasswordOnNextLogin"];
            this.isTwoFactorEnabled = data["isTwoFactorEnabled"];
            this.isLockoutEnabled = data["isLockoutEnabled"];
        }
    };
    UserEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UserEditDto();
        result.init(data);
        return result;
    };
    UserEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["password"] = this.password;
        data["isActive"] = this.isActive;
        data["shouldChangePasswordOnNextLogin"] = this.shouldChangePasswordOnNextLogin;
        data["isTwoFactorEnabled"] = this.isTwoFactorEnabled;
        data["isLockoutEnabled"] = this.isLockoutEnabled;
        return data;
    };
    return UserEditDto;
}());
export { UserEditDto };
var UserRoleDto = /** @class */ (function () {
    function UserRoleDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UserRoleDto.prototype.init = function (data) {
        if (data) {
            this.roleId = data["roleId"];
            this.roleName = data["roleName"];
            this.roleDisplayName = data["roleDisplayName"];
            this.isAssigned = data["isAssigned"];
            this.inheritedFromOrganizationUnit = data["inheritedFromOrganizationUnit"];
        }
    };
    UserRoleDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UserRoleDto();
        result.init(data);
        return result;
    };
    UserRoleDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        data["roleDisplayName"] = this.roleDisplayName;
        data["isAssigned"] = this.isAssigned;
        data["inheritedFromOrganizationUnit"] = this.inheritedFromOrganizationUnit;
        return data;
    };
    return UserRoleDto;
}());
export { UserRoleDto };
var GetUserForEditOutput = /** @class */ (function () {
    function GetUserForEditOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetUserForEditOutput.prototype.init = function (data) {
        if (data) {
            this.profilePictureId = data["profilePictureId"];
            this.user = data["user"] ? UserEditDto.fromJS(data["user"]) : undefined;
            if (Array.isArray(data["roles"])) {
                this.roles = [];
                for (var _i = 0, _a = data["roles"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.roles.push(UserRoleDto.fromJS(item));
                }
            }
            if (Array.isArray(data["allOrganizationUnits"])) {
                this.allOrganizationUnits = [];
                for (var _b = 0, _c = data["allOrganizationUnits"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.allOrganizationUnits.push(OrganizationUnitDto.fromJS(item));
                }
            }
            if (Array.isArray(data["memberedOrganizationUnits"])) {
                this.memberedOrganizationUnits = [];
                for (var _d = 0, _e = data["memberedOrganizationUnits"]; _d < _e.length; _d++) {
                    var item = _e[_d];
                    this.memberedOrganizationUnits.push(item);
                }
            }
        }
    };
    GetUserForEditOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetUserForEditOutput();
        result.init(data);
        return result;
    };
    GetUserForEditOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["profilePictureId"] = this.profilePictureId;
        data["user"] = this.user ? this.user.toJSON() : undefined;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (var _i = 0, _a = this.roles; _i < _a.length; _i++) {
                var item = _a[_i];
                data["roles"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.allOrganizationUnits)) {
            data["allOrganizationUnits"] = [];
            for (var _b = 0, _c = this.allOrganizationUnits; _b < _c.length; _b++) {
                var item = _c[_b];
                data["allOrganizationUnits"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.memberedOrganizationUnits)) {
            data["memberedOrganizationUnits"] = [];
            for (var _d = 0, _e = this.memberedOrganizationUnits; _d < _e.length; _d++) {
                var item = _e[_d];
                data["memberedOrganizationUnits"].push(item);
            }
        }
        return data;
    };
    return GetUserForEditOutput;
}());
export { GetUserForEditOutput };
var GetUserPermissionsForEditOutput = /** @class */ (function () {
    function GetUserPermissionsForEditOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetUserPermissionsForEditOutput.prototype.init = function (data) {
        if (data) {
            if (Array.isArray(data["permissions"])) {
                this.permissions = [];
                for (var _i = 0, _a = data["permissions"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.permissions.push(FlatPermissionDto.fromJS(item));
                }
            }
            if (Array.isArray(data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [];
                for (var _b = 0, _c = data["grantedPermissionNames"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.grantedPermissionNames.push(item);
                }
            }
        }
    };
    GetUserPermissionsForEditOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetUserPermissionsForEditOutput();
        result.init(data);
        return result;
    };
    GetUserPermissionsForEditOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (var _i = 0, _a = this.permissions; _i < _a.length; _i++) {
                var item = _a[_i];
                data["permissions"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (var _b = 0, _c = this.grantedPermissionNames; _b < _c.length; _b++) {
                var item = _c[_b];
                data["grantedPermissionNames"].push(item);
            }
        }
        return data;
    };
    return GetUserPermissionsForEditOutput;
}());
export { GetUserPermissionsForEditOutput };
var EntityDtoOfInt64 = /** @class */ (function () {
    function EntityDtoOfInt64(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EntityDtoOfInt64.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
        }
    };
    EntityDtoOfInt64.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new EntityDtoOfInt64();
        result.init(data);
        return result;
    };
    EntityDtoOfInt64.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    };
    return EntityDtoOfInt64;
}());
export { EntityDtoOfInt64 };
var UpdateUserPermissionsInput = /** @class */ (function () {
    function UpdateUserPermissionsInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.grantedPermissionNames = [];
        }
    }
    UpdateUserPermissionsInput.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            if (Array.isArray(data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [];
                for (var _i = 0, _a = data["grantedPermissionNames"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.grantedPermissionNames.push(item);
                }
            }
        }
    };
    UpdateUserPermissionsInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateUserPermissionsInput();
        result.init(data);
        return result;
    };
    UpdateUserPermissionsInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (var _i = 0, _a = this.grantedPermissionNames; _i < _a.length; _i++) {
                var item = _a[_i];
                data["grantedPermissionNames"].push(item);
            }
        }
        return data;
    };
    return UpdateUserPermissionsInput;
}());
export { UpdateUserPermissionsInput };
var CreateOrUpdateUserInput = /** @class */ (function () {
    function CreateOrUpdateUserInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.user = new UserEditDto();
            this.assignedRoleNames = [];
        }
    }
    CreateOrUpdateUserInput.prototype.init = function (data) {
        if (data) {
            this.user = data["user"] ? UserEditDto.fromJS(data["user"]) : new UserEditDto();
            if (Array.isArray(data["assignedRoleNames"])) {
                this.assignedRoleNames = [];
                for (var _i = 0, _a = data["assignedRoleNames"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.assignedRoleNames.push(item);
                }
            }
            this.sendActivationEmail = data["sendActivationEmail"];
            this.setRandomPassword = data["setRandomPassword"];
            if (Array.isArray(data["organizationUnits"])) {
                this.organizationUnits = [];
                for (var _b = 0, _c = data["organizationUnits"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.organizationUnits.push(item);
                }
            }
        }
    };
    CreateOrUpdateUserInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrUpdateUserInput();
        result.init(data);
        return result;
    };
    CreateOrUpdateUserInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : undefined;
        if (Array.isArray(this.assignedRoleNames)) {
            data["assignedRoleNames"] = [];
            for (var _i = 0, _a = this.assignedRoleNames; _i < _a.length; _i++) {
                var item = _a[_i];
                data["assignedRoleNames"].push(item);
            }
        }
        data["sendActivationEmail"] = this.sendActivationEmail;
        data["setRandomPassword"] = this.setRandomPassword;
        if (Array.isArray(this.organizationUnits)) {
            data["organizationUnits"] = [];
            for (var _b = 0, _c = this.organizationUnits; _b < _c.length; _b++) {
                var item = _c[_b];
                data["organizationUnits"].push(item);
            }
        }
        return data;
    };
    return CreateOrUpdateUserInput;
}());
export { CreateOrUpdateUserInput };
var LinkToUserInput = /** @class */ (function () {
    function LinkToUserInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    LinkToUserInput.prototype.init = function (data) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.usernameOrEmailAddress = data["usernameOrEmailAddress"];
            this.password = data["password"];
        }
    };
    LinkToUserInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new LinkToUserInput();
        result.init(data);
        return result;
    };
    LinkToUserInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["usernameOrEmailAddress"] = this.usernameOrEmailAddress;
        data["password"] = this.password;
        return data;
    };
    return LinkToUserInput;
}());
export { LinkToUserInput };
var LinkedUserDto = /** @class */ (function () {
    function LinkedUserDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    LinkedUserDto.prototype.init = function (data) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.tenancyName = data["tenancyName"];
            this.username = data["username"];
            this.id = data["id"];
        }
    };
    LinkedUserDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new LinkedUserDto();
        result.init(data);
        return result;
    };
    LinkedUserDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["tenancyName"] = this.tenancyName;
        data["username"] = this.username;
        data["id"] = this.id;
        return data;
    };
    return LinkedUserDto;
}());
export { LinkedUserDto };
var PagedResultDtoOfLinkedUserDto = /** @class */ (function () {
    function PagedResultDtoOfLinkedUserDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfLinkedUserDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(LinkedUserDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfLinkedUserDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfLinkedUserDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfLinkedUserDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfLinkedUserDto;
}());
export { PagedResultDtoOfLinkedUserDto };
var ListResultDtoOfLinkedUserDto = /** @class */ (function () {
    function ListResultDtoOfLinkedUserDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ListResultDtoOfLinkedUserDto.prototype.init = function (data) {
        if (data) {
            if (Array.isArray(data["items"])) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(LinkedUserDto.fromJS(item));
                }
            }
        }
    };
    ListResultDtoOfLinkedUserDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ListResultDtoOfLinkedUserDto();
        result.init(data);
        return result;
    };
    ListResultDtoOfLinkedUserDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return ListResultDtoOfLinkedUserDto;
}());
export { ListResultDtoOfLinkedUserDto };
var UnlinkUserInput = /** @class */ (function () {
    function UnlinkUserInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UnlinkUserInput.prototype.init = function (data) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
        }
    };
    UnlinkUserInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UnlinkUserInput();
        result.init(data);
        return result;
    };
    UnlinkUserInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        return data;
    };
    return UnlinkUserInput;
}());
export { UnlinkUserInput };
var UserLoginAttemptDto = /** @class */ (function () {
    function UserLoginAttemptDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UserLoginAttemptDto.prototype.init = function (data) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.userNameOrEmail = data["userNameOrEmail"];
            this.clientIpAddress = data["clientIpAddress"];
            this.clientName = data["clientName"];
            this.browserInfo = data["browserInfo"];
            this.result = data["result"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
        }
    };
    UserLoginAttemptDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UserLoginAttemptDto();
        result.init(data);
        return result;
    };
    UserLoginAttemptDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["userNameOrEmail"] = this.userNameOrEmail;
        data["clientIpAddress"] = this.clientIpAddress;
        data["clientName"] = this.clientName;
        data["browserInfo"] = this.browserInfo;
        data["result"] = this.result;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        return data;
    };
    return UserLoginAttemptDto;
}());
export { UserLoginAttemptDto };
var ListResultDtoOfUserLoginAttemptDto = /** @class */ (function () {
    function ListResultDtoOfUserLoginAttemptDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ListResultDtoOfUserLoginAttemptDto.prototype.init = function (data) {
        if (data) {
            if (Array.isArray(data["items"])) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(UserLoginAttemptDto.fromJS(item));
                }
            }
        }
    };
    ListResultDtoOfUserLoginAttemptDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ListResultDtoOfUserLoginAttemptDto();
        result.init(data);
        return result;
    };
    ListResultDtoOfUserLoginAttemptDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return ListResultDtoOfUserLoginAttemptDto;
}());
export { ListResultDtoOfUserLoginAttemptDto };
var WebhookEvent = /** @class */ (function () {
    function WebhookEvent(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    WebhookEvent.prototype.init = function (data) {
        if (data) {
            this.webhookName = data["webhookName"];
            this.data = data["data"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : undefined;
            this.id = data["id"];
        }
    };
    WebhookEvent.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new WebhookEvent();
        result.init(data);
        return result;
    };
    WebhookEvent.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["webhookName"] = this.webhookName;
        data["data"] = this.data;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["id"] = this.id;
        return data;
    };
    return WebhookEvent;
}());
export { WebhookEvent };
export var HttpStatusCode;
(function (HttpStatusCode) {
    HttpStatusCode[HttpStatusCode["Continue"] = 100] = "Continue";
    HttpStatusCode[HttpStatusCode["SwitchingProtocols"] = 101] = "SwitchingProtocols";
    HttpStatusCode[HttpStatusCode["Processing"] = 102] = "Processing";
    HttpStatusCode[HttpStatusCode["EarlyHints"] = 103] = "EarlyHints";
    HttpStatusCode[HttpStatusCode["OK"] = 200] = "OK";
    HttpStatusCode[HttpStatusCode["Created"] = 201] = "Created";
    HttpStatusCode[HttpStatusCode["Accepted"] = 202] = "Accepted";
    HttpStatusCode[HttpStatusCode["NonAuthoritativeInformation"] = 203] = "NonAuthoritativeInformation";
    HttpStatusCode[HttpStatusCode["NoContent"] = 204] = "NoContent";
    HttpStatusCode[HttpStatusCode["ResetContent"] = 205] = "ResetContent";
    HttpStatusCode[HttpStatusCode["PartialContent"] = 206] = "PartialContent";
    HttpStatusCode[HttpStatusCode["MultiStatus"] = 207] = "MultiStatus";
    HttpStatusCode[HttpStatusCode["AlreadyReported"] = 208] = "AlreadyReported";
    HttpStatusCode[HttpStatusCode["IMUsed"] = 226] = "IMUsed";
    HttpStatusCode[HttpStatusCode["MultipleChoices"] = 300] = "MultipleChoices";
    HttpStatusCode[HttpStatusCode["Ambiguous"] = 300] = "Ambiguous";
    HttpStatusCode[HttpStatusCode["MovedPermanently"] = 301] = "MovedPermanently";
    HttpStatusCode[HttpStatusCode["Moved"] = 301] = "Moved";
    HttpStatusCode[HttpStatusCode["Found"] = 302] = "Found";
    HttpStatusCode[HttpStatusCode["Redirect"] = 302] = "Redirect";
    HttpStatusCode[HttpStatusCode["SeeOther"] = 303] = "SeeOther";
    HttpStatusCode[HttpStatusCode["RedirectMethod"] = 303] = "RedirectMethod";
    HttpStatusCode[HttpStatusCode["NotModified"] = 304] = "NotModified";
    HttpStatusCode[HttpStatusCode["UseProxy"] = 305] = "UseProxy";
    HttpStatusCode[HttpStatusCode["Unused"] = 306] = "Unused";
    HttpStatusCode[HttpStatusCode["TemporaryRedirect"] = 307] = "TemporaryRedirect";
    HttpStatusCode[HttpStatusCode["RedirectKeepVerb"] = 307] = "RedirectKeepVerb";
    HttpStatusCode[HttpStatusCode["PermanentRedirect"] = 308] = "PermanentRedirect";
    HttpStatusCode[HttpStatusCode["BadRequest"] = 400] = "BadRequest";
    HttpStatusCode[HttpStatusCode["Unauthorized"] = 401] = "Unauthorized";
    HttpStatusCode[HttpStatusCode["PaymentRequired"] = 402] = "PaymentRequired";
    HttpStatusCode[HttpStatusCode["Forbidden"] = 403] = "Forbidden";
    HttpStatusCode[HttpStatusCode["NotFound"] = 404] = "NotFound";
    HttpStatusCode[HttpStatusCode["MethodNotAllowed"] = 405] = "MethodNotAllowed";
    HttpStatusCode[HttpStatusCode["NotAcceptable"] = 406] = "NotAcceptable";
    HttpStatusCode[HttpStatusCode["ProxyAuthenticationRequired"] = 407] = "ProxyAuthenticationRequired";
    HttpStatusCode[HttpStatusCode["RequestTimeout"] = 408] = "RequestTimeout";
    HttpStatusCode[HttpStatusCode["Conflict"] = 409] = "Conflict";
    HttpStatusCode[HttpStatusCode["Gone"] = 410] = "Gone";
    HttpStatusCode[HttpStatusCode["LengthRequired"] = 411] = "LengthRequired";
    HttpStatusCode[HttpStatusCode["PreconditionFailed"] = 412] = "PreconditionFailed";
    HttpStatusCode[HttpStatusCode["RequestEntityTooLarge"] = 413] = "RequestEntityTooLarge";
    HttpStatusCode[HttpStatusCode["RequestUriTooLong"] = 414] = "RequestUriTooLong";
    HttpStatusCode[HttpStatusCode["UnsupportedMediaType"] = 415] = "UnsupportedMediaType";
    HttpStatusCode[HttpStatusCode["RequestedRangeNotSatisfiable"] = 416] = "RequestedRangeNotSatisfiable";
    HttpStatusCode[HttpStatusCode["ExpectationFailed"] = 417] = "ExpectationFailed";
    HttpStatusCode[HttpStatusCode["MisdirectedRequest"] = 421] = "MisdirectedRequest";
    HttpStatusCode[HttpStatusCode["UnprocessableEntity"] = 422] = "UnprocessableEntity";
    HttpStatusCode[HttpStatusCode["Locked"] = 423] = "Locked";
    HttpStatusCode[HttpStatusCode["FailedDependency"] = 424] = "FailedDependency";
    HttpStatusCode[HttpStatusCode["UpgradeRequired"] = 426] = "UpgradeRequired";
    HttpStatusCode[HttpStatusCode["PreconditionRequired"] = 428] = "PreconditionRequired";
    HttpStatusCode[HttpStatusCode["TooManyRequests"] = 429] = "TooManyRequests";
    HttpStatusCode[HttpStatusCode["RequestHeaderFieldsTooLarge"] = 431] = "RequestHeaderFieldsTooLarge";
    HttpStatusCode[HttpStatusCode["UnavailableForLegalReasons"] = 451] = "UnavailableForLegalReasons";
    HttpStatusCode[HttpStatusCode["InternalServerError"] = 500] = "InternalServerError";
    HttpStatusCode[HttpStatusCode["NotImplemented"] = 501] = "NotImplemented";
    HttpStatusCode[HttpStatusCode["BadGateway"] = 502] = "BadGateway";
    HttpStatusCode[HttpStatusCode["ServiceUnavailable"] = 503] = "ServiceUnavailable";
    HttpStatusCode[HttpStatusCode["GatewayTimeout"] = 504] = "GatewayTimeout";
    HttpStatusCode[HttpStatusCode["HttpVersionNotSupported"] = 505] = "HttpVersionNotSupported";
    HttpStatusCode[HttpStatusCode["VariantAlsoNegotiates"] = 506] = "VariantAlsoNegotiates";
    HttpStatusCode[HttpStatusCode["InsufficientStorage"] = 507] = "InsufficientStorage";
    HttpStatusCode[HttpStatusCode["LoopDetected"] = 508] = "LoopDetected";
    HttpStatusCode[HttpStatusCode["NotExtended"] = 510] = "NotExtended";
    HttpStatusCode[HttpStatusCode["NetworkAuthenticationRequired"] = 511] = "NetworkAuthenticationRequired";
})(HttpStatusCode || (HttpStatusCode = {}));
var GetAllSendAttemptsOutput = /** @class */ (function () {
    function GetAllSendAttemptsOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetAllSendAttemptsOutput.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.webhookEventId = data["webhookEventId"];
            this.webhookName = data["webhookName"];
            this.data = data["data"];
            this.response = data["response"];
            this.responseStatusCode = data["responseStatusCode"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
        }
    };
    GetAllSendAttemptsOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetAllSendAttemptsOutput();
        result.init(data);
        return result;
    };
    GetAllSendAttemptsOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["webhookEventId"] = this.webhookEventId;
        data["webhookName"] = this.webhookName;
        data["data"] = this.data;
        data["response"] = this.response;
        data["responseStatusCode"] = this.responseStatusCode;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        return data;
    };
    return GetAllSendAttemptsOutput;
}());
export { GetAllSendAttemptsOutput };
var PagedResultDtoOfGetAllSendAttemptsOutput = /** @class */ (function () {
    function PagedResultDtoOfGetAllSendAttemptsOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfGetAllSendAttemptsOutput.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(GetAllSendAttemptsOutput.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfGetAllSendAttemptsOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfGetAllSendAttemptsOutput();
        result.init(data);
        return result;
    };
    PagedResultDtoOfGetAllSendAttemptsOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfGetAllSendAttemptsOutput;
}());
export { PagedResultDtoOfGetAllSendAttemptsOutput };
var GetAllSendAttemptsOfWebhookEventOutput = /** @class */ (function () {
    function GetAllSendAttemptsOfWebhookEventOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetAllSendAttemptsOfWebhookEventOutput.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.webhookSubscriptionId = data["webhookSubscriptionId"];
            this.response = data["response"];
            this.responseStatusCode = data["responseStatusCode"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : undefined;
        }
    };
    GetAllSendAttemptsOfWebhookEventOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetAllSendAttemptsOfWebhookEventOutput();
        result.init(data);
        return result;
    };
    GetAllSendAttemptsOfWebhookEventOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["webhookSubscriptionId"] = this.webhookSubscriptionId;
        data["response"] = this.response;
        data["responseStatusCode"] = this.responseStatusCode;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        return data;
    };
    return GetAllSendAttemptsOfWebhookEventOutput;
}());
export { GetAllSendAttemptsOfWebhookEventOutput };
var ListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput = /** @class */ (function () {
    function ListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput.prototype.init = function (data) {
        if (data) {
            if (Array.isArray(data["items"])) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(GetAllSendAttemptsOfWebhookEventOutput.fromJS(item));
                }
            }
        }
    };
    ListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput();
        result.init(data);
        return result;
    };
    ListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return ListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput;
}());
export { ListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput };
var GetAllSubscriptionsOutput = /** @class */ (function () {
    function GetAllSubscriptionsOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetAllSubscriptionsOutput.prototype.init = function (data) {
        if (data) {
            this.webhookUri = data["webhookUri"];
            this.isActive = data["isActive"];
            if (Array.isArray(data["webhooks"])) {
                this.webhooks = [];
                for (var _i = 0, _a = data["webhooks"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.webhooks.push(item);
                }
            }
            this.id = data["id"];
        }
    };
    GetAllSubscriptionsOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetAllSubscriptionsOutput();
        result.init(data);
        return result;
    };
    GetAllSubscriptionsOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["webhookUri"] = this.webhookUri;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.webhooks)) {
            data["webhooks"] = [];
            for (var _i = 0, _a = this.webhooks; _i < _a.length; _i++) {
                var item = _a[_i];
                data["webhooks"].push(item);
            }
        }
        data["id"] = this.id;
        return data;
    };
    return GetAllSubscriptionsOutput;
}());
export { GetAllSubscriptionsOutput };
var ListResultDtoOfGetAllSubscriptionsOutput = /** @class */ (function () {
    function ListResultDtoOfGetAllSubscriptionsOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ListResultDtoOfGetAllSubscriptionsOutput.prototype.init = function (data) {
        if (data) {
            if (Array.isArray(data["items"])) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(GetAllSubscriptionsOutput.fromJS(item));
                }
            }
        }
    };
    ListResultDtoOfGetAllSubscriptionsOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ListResultDtoOfGetAllSubscriptionsOutput();
        result.init(data);
        return result;
    };
    ListResultDtoOfGetAllSubscriptionsOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return ListResultDtoOfGetAllSubscriptionsOutput;
}());
export { ListResultDtoOfGetAllSubscriptionsOutput };
var WebhookSubscription = /** @class */ (function () {
    function WebhookSubscription(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    WebhookSubscription.prototype.init = function (data) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.webhookUri = data["webhookUri"];
            this.secret = data["secret"];
            this.isActive = data["isActive"];
            if (Array.isArray(data["webhooks"])) {
                this.webhooks = [];
                for (var _i = 0, _a = data["webhooks"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.webhooks.push(item);
                }
            }
            if (data["headers"]) {
                this.headers = {};
                for (var key in data["headers"]) {
                    if (data["headers"].hasOwnProperty(key))
                        this.headers[key] = data["headers"][key];
                }
            }
            this.id = data["id"];
        }
    };
    WebhookSubscription.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new WebhookSubscription();
        result.init(data);
        return result;
    };
    WebhookSubscription.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["webhookUri"] = this.webhookUri;
        data["secret"] = this.secret;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.webhooks)) {
            data["webhooks"] = [];
            for (var _i = 0, _a = this.webhooks; _i < _a.length; _i++) {
                var item = _a[_i];
                data["webhooks"].push(item);
            }
        }
        if (this.headers) {
            data["headers"] = {};
            for (var key in this.headers) {
                if (this.headers.hasOwnProperty(key))
                    data["headers"][key] = this.headers[key];
            }
        }
        data["id"] = this.id;
        return data;
    };
    return WebhookSubscription;
}());
export { WebhookSubscription };
var ActivateWebhookSubscriptionInput = /** @class */ (function () {
    function ActivateWebhookSubscriptionInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ActivateWebhookSubscriptionInput.prototype.init = function (data) {
        if (data) {
            this.subscriptionId = data["subscriptionId"];
            this.isActive = data["isActive"];
        }
    };
    ActivateWebhookSubscriptionInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ActivateWebhookSubscriptionInput();
        result.init(data);
        return result;
    };
    ActivateWebhookSubscriptionInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionId"] = this.subscriptionId;
        data["isActive"] = this.isActive;
        return data;
    };
    return ActivateWebhookSubscriptionInput;
}());
export { ActivateWebhookSubscriptionInput };
var GetAllAvailableWebhooksOutput = /** @class */ (function () {
    function GetAllAvailableWebhooksOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetAllAvailableWebhooksOutput.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.description = data["description"];
        }
    };
    GetAllAvailableWebhooksOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetAllAvailableWebhooksOutput();
        result.init(data);
        return result;
    };
    GetAllAvailableWebhooksOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        return data;
    };
    return GetAllAvailableWebhooksOutput;
}());
export { GetAllAvailableWebhooksOutput };
var ListResultDtoOfGetAllAvailableWebhooksOutput = /** @class */ (function () {
    function ListResultDtoOfGetAllAvailableWebhooksOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ListResultDtoOfGetAllAvailableWebhooksOutput.prototype.init = function (data) {
        if (data) {
            if (Array.isArray(data["items"])) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(GetAllAvailableWebhooksOutput.fromJS(item));
                }
            }
        }
    };
    ListResultDtoOfGetAllAvailableWebhooksOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ListResultDtoOfGetAllAvailableWebhooksOutput();
        result.init(data);
        return result;
    };
    ListResultDtoOfGetAllAvailableWebhooksOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return ListResultDtoOfGetAllAvailableWebhooksOutput;
}());
export { ListResultDtoOfGetAllAvailableWebhooksOutput };
var GetLatestWebLogsOutput = /** @class */ (function () {
    function GetLatestWebLogsOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetLatestWebLogsOutput.prototype.init = function (data) {
        if (data) {
            if (Array.isArray(data["latestWebLogLines"])) {
                this.latestWebLogLines = [];
                for (var _i = 0, _a = data["latestWebLogLines"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.latestWebLogLines.push(item);
                }
            }
        }
    };
    GetLatestWebLogsOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetLatestWebLogsOutput();
        result.init(data);
        return result;
    };
    GetLatestWebLogsOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.latestWebLogLines)) {
            data["latestWebLogLines"] = [];
            for (var _i = 0, _a = this.latestWebLogLines; _i < _a.length; _i++) {
                var item = _a[_i];
                data["latestWebLogLines"].push(item);
            }
        }
        return data;
    };
    return GetLatestWebLogsOutput;
}());
export { GetLatestWebLogsOutput };
var ZenDeskFieldDto = /** @class */ (function () {
    function ZenDeskFieldDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ZenDeskFieldDto.prototype.init = function (data) {
        if (data) {
            this.description = data["description"];
            this.name = data["name"];
            this.zenDeskId = data["zenDeskId"];
            this.id = data["id"];
        }
    };
    ZenDeskFieldDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ZenDeskFieldDto();
        result.init(data);
        return result;
    };
    ZenDeskFieldDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["name"] = this.name;
        data["zenDeskId"] = this.zenDeskId;
        data["id"] = this.id;
        return data;
    };
    return ZenDeskFieldDto;
}());
export { ZenDeskFieldDto };
var GetZenDeskFieldForViewDto = /** @class */ (function () {
    function GetZenDeskFieldForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetZenDeskFieldForViewDto.prototype.init = function (data) {
        if (data) {
            this.zenDeskField = data["zenDeskField"] ? ZenDeskFieldDto.fromJS(data["zenDeskField"]) : undefined;
        }
    };
    GetZenDeskFieldForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetZenDeskFieldForViewDto();
        result.init(data);
        return result;
    };
    GetZenDeskFieldForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["zenDeskField"] = this.zenDeskField ? this.zenDeskField.toJSON() : undefined;
        return data;
    };
    return GetZenDeskFieldForViewDto;
}());
export { GetZenDeskFieldForViewDto };
var PagedResultDtoOfGetZenDeskFieldForViewDto = /** @class */ (function () {
    function PagedResultDtoOfGetZenDeskFieldForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfGetZenDeskFieldForViewDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(GetZenDeskFieldForViewDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfGetZenDeskFieldForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfGetZenDeskFieldForViewDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfGetZenDeskFieldForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfGetZenDeskFieldForViewDto;
}());
export { PagedResultDtoOfGetZenDeskFieldForViewDto };
var CreateOrEditZenDeskFieldDto = /** @class */ (function () {
    function CreateOrEditZenDeskFieldDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateOrEditZenDeskFieldDto.prototype.init = function (data) {
        if (data) {
            this.description = data["description"];
            this.name = data["name"];
            this.zenDeskId = data["zenDeskId"];
            this.id = data["id"];
        }
    };
    CreateOrEditZenDeskFieldDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrEditZenDeskFieldDto();
        result.init(data);
        return result;
    };
    CreateOrEditZenDeskFieldDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["name"] = this.name;
        data["zenDeskId"] = this.zenDeskId;
        data["id"] = this.id;
        return data;
    };
    return CreateOrEditZenDeskFieldDto;
}());
export { CreateOrEditZenDeskFieldDto };
var GetZenDeskFieldForEditOutput = /** @class */ (function () {
    function GetZenDeskFieldForEditOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetZenDeskFieldForEditOutput.prototype.init = function (data) {
        if (data) {
            this.zenDeskField = data["zenDeskField"] ? CreateOrEditZenDeskFieldDto.fromJS(data["zenDeskField"]) : undefined;
        }
    };
    GetZenDeskFieldForEditOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetZenDeskFieldForEditOutput();
        result.init(data);
        return result;
    };
    GetZenDeskFieldForEditOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["zenDeskField"] = this.zenDeskField ? this.zenDeskField.toJSON() : undefined;
        return data;
    };
    return GetZenDeskFieldForEditOutput;
}());
export { GetZenDeskFieldForEditOutput };
var AdditionalData = /** @class */ (function () {
    function AdditionalData(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AdditionalData.prototype.init = function (data) {
        if (data) {
            if (data["Paypal"]) {
                this.paypal = {};
                for (var key in data["Paypal"]) {
                    if (data["Paypal"].hasOwnProperty(key))
                        this.paypal[key] = data["Paypal"][key];
                }
            }
            if (data["Stripe"]) {
                this.stripe = {};
                for (var key in data["Stripe"]) {
                    if (data["Stripe"].hasOwnProperty(key))
                        this.stripe[key] = data["Stripe"][key];
                }
            }
        }
    };
    AdditionalData.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AdditionalData();
        result.init(data);
        return result;
    };
    AdditionalData.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.paypal) {
            data["Paypal"] = {};
            for (var key in this.paypal) {
                if (this.paypal.hasOwnProperty(key))
                    data["Paypal"][key] = this.paypal[key];
            }
        }
        if (this.stripe) {
            data["Stripe"] = {};
            for (var key in this.stripe) {
                if (this.stripe.hasOwnProperty(key))
                    data["Stripe"][key] = this.stripe[key];
            }
        }
        return data;
    };
    return AdditionalData;
}());
export { AdditionalData };
var ApiException = /** @class */ (function (_super) {
    __extends(ApiException, _super);
    function ApiException(message, status, response, headers, result) {
        var _this = _super.call(this) || this;
        _this.isApiException = true;
        _this.message = message;
        _this.status = status;
        _this.response = response;
        _this.headers = headers;
        _this.result = result;
        return _this;
    }
    ApiException.isApiException = function (obj) {
        return obj.isApiException === true;
    };
    return ApiException;
}(Error));
export { ApiException };
function throwException(message, status, response, headers, result) {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}
function blobToText(blob) {
    return new Observable(function (observer) {
        if (!blob) {
            observer.next("");
            observer.complete();
        }
        else {
            var reader = new FileReader();
            reader.onload = function (event) {
                observer.next(event.target.result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}
